//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param email (optional) 
     * @param userId (optional) 
     * @return Success
     */
    userNameOrEmailExist(email: string | undefined, userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/UserNameOrEmailExist?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserNameOrEmailExist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserNameOrEmailExist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUserNameOrEmailExist(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    sendConfirmationEmail(userId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendConfirmationEmail?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendConfirmationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendConfirmationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSendConfirmationEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param token (optional) 
     * @return Success
     */
    confirmEmail(userId: number | undefined, token: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/ConfirmEmail?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processConfirmEmail(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forgotPassword(body: ForgotPasswordDto | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/Account/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processForgotPassword(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param token (optional) 
     * @return Success
     */
    sendNewPasswordAfterReset(userId: number | undefined, token: string | undefined): Observable<ResetPasswordResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendNewPasswordAfterReset?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendNewPasswordAfterReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendNewPasswordAfterReset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResetPasswordResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResetPasswordResultDto>;
        }));
    }

    protected processSendNewPasswordAfterReset(response: HttpResponseBase): Observable<ResetPasswordResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteUserData(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/DeleteUserData?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUserData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUserData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDeleteUserData(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param password (optional) 
     * @param token (optional) 
     * @return Success
     */
    activateAccount(userId: number | undefined, password: string | undefined, token: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateAccount?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (password === null)
            throw new globalThis.Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processActivateAccount(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateMyProfile(body: UpdateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/Account/UpdateMyProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMyProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMyProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdateMyProfile(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ActivityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkOverlaps(body: ActivityOverlapCheckInput | undefined): Observable<ActivityOverlapDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Activity/CheckOverlaps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckOverlaps(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckOverlaps(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityOverlapDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityOverlapDto[]>;
        }));
    }

    protected processCheckOverlaps(response: HttpResponseBase): Observable<ActivityOverlapDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityOverlapDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param from (optional) 
     * @param to (optional) 
     * @param serviceIds (optional) 
     * @return Success
     */
    getMyActivities(from: moment.Moment | undefined, to: moment.Moment | undefined, serviceIds: number[] | undefined): Observable<ActivityDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetMyActivities?";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        if (serviceIds === null)
            throw new globalThis.Error("The parameter 'serviceIds' cannot be null.");
        else if (serviceIds !== undefined)
            serviceIds && serviceIds.forEach(item => { url_ += "ServiceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyActivities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyActivities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityDtoListResultDto>;
        }));
    }

    protected processGetMyActivities(response: HttpResponseBase): Observable<ActivityDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param serviceIds (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getMyBadgingNotes(keyword: string | undefined, serviceIds: number[] | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ActivityDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetMyBadgingNotes?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (serviceIds === null)
            throw new globalThis.Error("The parameter 'serviceIds' cannot be null.");
        else if (serviceIds !== undefined)
            serviceIds && serviceIds.forEach(item => { url_ += "ServiceIds=" + encodeURIComponent("" + item) + "&"; });
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyBadgingNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyBadgingNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityDtoPagedResultDto>;
        }));
    }

    protected processGetMyBadgingNotes(response: HttpResponseBase): Observable<ActivityDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelMyActivity(body: CancelMyActivityInput | undefined): Observable<ActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/CancelMyActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelMyActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelMyActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityDto>;
        }));
    }

    protected processCancelMyActivity(response: HttpResponseBase): Observable<ActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelMyOccurrence(body: CancelMyOccurrenceInput | undefined): Observable<ActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/CancelMyOccurrence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelMyOccurrence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelMyOccurrence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityDto>;
        }));
    }

    protected processCancelMyOccurrence(response: HttpResponseBase): Observable<ActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    rescheduleMyActivity(body: RescheduleMyActivityInput | undefined): Observable<ActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/RescheduleMyActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRescheduleMyActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRescheduleMyActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityDto>;
        }));
    }

    protected processRescheduleMyActivity(response: HttpResponseBase): Observable<ActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    badge(body: BadgeInput | undefined): Observable<ActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/Badge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBadge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBadge(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityDto>;
        }));
    }

    protected processBadge(response: HttpResponseBase): Observable<ActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadExcel(body: ActivityGetAllInput | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/DownloadExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadExcel(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    rebuildOccurrences(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/RebuildOccurrences";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRebuildOccurrences(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRebuildOccurrences(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRebuildOccurrences(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateActivityDto | undefined): Observable<ActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateActivityDto | undefined): Observable<ActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Activity/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ActivityDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ActivityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param serviceIds (optional) 
     * @param beneficiaryIds (optional) 
     * @param operatorIds (optional) 
     * @param placeIds (optional) 
     * @param hasNote (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, serviceIds: number[] | undefined, beneficiaryIds: number[] | undefined, operatorIds: number[] | undefined, placeIds: number[] | undefined, hasNote: boolean | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ActivityDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Activity/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (serviceIds === null)
            throw new globalThis.Error("The parameter 'serviceIds' cannot be null.");
        else if (serviceIds !== undefined)
            serviceIds && serviceIds.forEach(item => { url_ += "ServiceIds=" + encodeURIComponent("" + item) + "&"; });
        if (beneficiaryIds === null)
            throw new globalThis.Error("The parameter 'beneficiaryIds' cannot be null.");
        else if (beneficiaryIds !== undefined)
            beneficiaryIds && beneficiaryIds.forEach(item => { url_ += "BeneficiaryIds=" + encodeURIComponent("" + item) + "&"; });
        if (operatorIds === null)
            throw new globalThis.Error("The parameter 'operatorIds' cannot be null.");
        else if (operatorIds !== undefined)
            operatorIds && operatorIds.forEach(item => { url_ += "OperatorIds=" + encodeURIComponent("" + item) + "&"; });
        if (placeIds === null)
            throw new globalThis.Error("The parameter 'placeIds' cannot be null.");
        else if (placeIds !== undefined)
            placeIds && placeIds.forEach(item => { url_ += "PlaceIds=" + encodeURIComponent("" + item) + "&"; });
        if (hasNote === null)
            throw new globalThis.Error("The parameter 'hasNote' cannot be null.");
        else if (hasNote !== undefined)
            url_ += "HasNote=" + encodeURIComponent("" + hasNote) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ActivityDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ActivityStatusServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ActivityStatus/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ActivityUserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateActivityUserDto | undefined): Observable<ActivityUserDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityUser/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityUserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ActivityUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateActivityUserDto | undefined): Observable<ActivityUserDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityUser/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityUserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ActivityUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityUser/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ActivityUserDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityUser/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityUserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ActivityUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param activityId (optional) 
     * @param isOperator (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, activityId: number | undefined, isOperator: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ActivityUserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityUser/GetAll?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (activityId === null)
            throw new globalThis.Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "ActivityId=" + encodeURIComponent("" + activityId) + "&";
        if (isOperator === null)
            throw new globalThis.Error("The parameter 'isOperator' cannot be null.");
        else if (isOperator !== undefined)
            url_ += "IsOperator=" + encodeURIComponent("" + isOperator) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityUserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityUserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ActivityUserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityUserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AdditionalInvestigationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdditionalInvestigation/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AddressServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    insertMunicipality(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Address/InsertMunicipality";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertMunicipality(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertMunicipality(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processInsertMunicipality(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllRegion(): Observable<RegionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Address/GetAllRegion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRegion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRegion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegionDto[]>;
        }));
    }

    protected processGetAllRegion(response: HttpResponseBase): Observable<RegionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllProvinces(): Observable<ProvinceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Address/GetAllProvinces";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProvinces(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProvinces(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProvinceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProvinceDto[]>;
        }));
    }

    protected processGetAllProvinces(response: HttpResponseBase): Observable<ProvinceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProvinceDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllMunicipality(): Observable<MunicipalityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Address/GetAllMunicipality";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMunicipality(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMunicipality(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MunicipalityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MunicipalityDto[]>;
        }));
    }

    protected processGetAllMunicipality(response: HttpResponseBase): Observable<MunicipalityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MunicipalityDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AdministrativeLegalAreaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAdministrativeLegalAreaDto | undefined): Observable<AdministrativeLegalAreaDto> {
        let url_ = this.baseUrl + "/api/services/app/AdministrativeLegalArea/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrativeLegalAreaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrativeLegalAreaDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AdministrativeLegalAreaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdministrativeLegalAreaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAdministrativeLegalAreaDto | undefined): Observable<AdministrativeLegalAreaDto> {
        let url_ = this.baseUrl + "/api/services/app/AdministrativeLegalArea/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrativeLegalAreaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrativeLegalAreaDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AdministrativeLegalAreaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdministrativeLegalAreaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdministrativeLegalArea/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<AdministrativeLegalAreaDto> {
        let url_ = this.baseUrl + "/api/services/app/AdministrativeLegalArea/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrativeLegalAreaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrativeLegalAreaDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AdministrativeLegalAreaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdministrativeLegalAreaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param inputCardRecordId (optional) 
     * @param isPaged (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(inputCardRecordId: number | undefined, isPaged: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AdministrativeLegalAreaDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdministrativeLegalArea/GetAll?";
        if (inputCardRecordId === null)
            throw new globalThis.Error("The parameter 'inputCardRecordId' cannot be null.");
        else if (inputCardRecordId !== undefined)
            url_ += "InputCardRecordId=" + encodeURIComponent("" + inputCardRecordId) + "&";
        if (isPaged === null)
            throw new globalThis.Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdministrativeLegalAreaDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdministrativeLegalAreaDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AdministrativeLegalAreaDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdministrativeLegalAreaDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AdmissionRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAdmissionRecordDto | undefined): Observable<AdmissionRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/AdmissionRecord/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdmissionRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdmissionRecordDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AdmissionRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdmissionRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAdmissionRecordDto | undefined): Observable<AdmissionRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/AdmissionRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdmissionRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdmissionRecordDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AdmissionRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdmissionRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdmissionRecord/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<AdmissionRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/AdmissionRecord/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdmissionRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdmissionRecordDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AdmissionRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdmissionRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialHealthRecordId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(socialHealthRecordId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AdmissionRecordDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdmissionRecord/GetAll?";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "SocialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdmissionRecordDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdmissionRecordDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AdmissionRecordDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdmissionRecordDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AdmissionResidentialAuthorizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAdmissionResidentialAuthorizationDto | undefined): Observable<AdmissionResidentialAuthorizationDto> {
        let url_ = this.baseUrl + "/api/services/app/AdmissionResidentialAuthorization/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdmissionResidentialAuthorizationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdmissionResidentialAuthorizationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AdmissionResidentialAuthorizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdmissionResidentialAuthorizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAdmissionResidentialAuthorizationDto | undefined): Observable<AdmissionResidentialAuthorizationDto> {
        let url_ = this.baseUrl + "/api/services/app/AdmissionResidentialAuthorization/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdmissionResidentialAuthorizationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdmissionResidentialAuthorizationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AdmissionResidentialAuthorizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdmissionResidentialAuthorizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AdmissionResidentialAuthorization/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<AdmissionResidentialAuthorizationDto> {
        let url_ = this.baseUrl + "/api/services/app/AdmissionResidentialAuthorization/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdmissionResidentialAuthorizationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdmissionResidentialAuthorizationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AdmissionResidentialAuthorizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdmissionResidentialAuthorizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param admissionRecordIds (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(admissionRecordIds: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AdmissionResidentialAuthorizationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AdmissionResidentialAuthorization/GetAll?";
        if (admissionRecordIds === null)
            throw new globalThis.Error("The parameter 'admissionRecordIds' cannot be null.");
        else if (admissionRecordIds !== undefined)
            url_ += "AdmissionRecordIds=" + encodeURIComponent("" + admissionRecordIds) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdmissionResidentialAuthorizationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdmissionResidentialAuthorizationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AdmissionResidentialAuthorizationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdmissionResidentialAuthorizationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AdmissionTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AdmissionType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AirTreatmentPlantTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AirTreatmentPlantType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AirTreatmentSystemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param structureId (optional) 
     * @param serviceId (optional) 
     * @return Success
     */
    getAllBase(structureId: number | undefined, serviceId: number | undefined): Observable<AirTreatmentSystemBaseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AirTreatmentSystem/GetAllBase?";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AirTreatmentSystemBaseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AirTreatmentSystemBaseDto[]>;
        }));
    }

    protected processGetAllBase(response: HttpResponseBase): Observable<AirTreatmentSystemBaseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AirTreatmentSystemBaseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAirTreatmentSystemDto | undefined): Observable<AirTreatmentSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/AirTreatmentSystem/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AirTreatmentSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AirTreatmentSystemDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AirTreatmentSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AirTreatmentSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAirTreatmentSystemDto | undefined): Observable<AirTreatmentSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/AirTreatmentSystem/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AirTreatmentSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AirTreatmentSystemDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AirTreatmentSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AirTreatmentSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AirTreatmentSystem/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<AirTreatmentSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/AirTreatmentSystem/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AirTreatmentSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AirTreatmentSystemDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AirTreatmentSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AirTreatmentSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param structureId (optional) 
     * @param serviceId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, structureId: number | undefined, serviceId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AirTreatmentSystemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AirTreatmentSystem/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AirTreatmentSystemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AirTreatmentSystemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AirTreatmentSystemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AirTreatmentSystemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AlertServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    switchIsRead(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Alert/SwitchIsRead?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchIsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchIsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSwitchIsRead(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getUnreadCount(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Alert/GetUnreadCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnreadCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnreadCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetUnreadCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAlertDto | undefined): Observable<AlertDto> {
        let url_ = this.baseUrl + "/api/services/app/Alert/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlertDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlertDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AlertDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAlertDto | undefined): Observable<AlertDto> {
        let url_ = this.baseUrl + "/api/services/app/Alert/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlertDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlertDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AlertDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Alert/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<AlertDto> {
        let url_ = this.baseUrl + "/api/services/app/Alert/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlertDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlertDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AlertDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isExpired (optional) 
     * @param isRead (optional) 
     * @param userId (optional) 
     * @param isCreator (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(isExpired: boolean | undefined, isRead: boolean | undefined, userId: number | undefined, isCreator: boolean | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AlertItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Alert/GetAll?";
        if (isExpired === null)
            throw new globalThis.Error("The parameter 'isExpired' cannot be null.");
        else if (isExpired !== undefined)
            url_ += "IsExpired=" + encodeURIComponent("" + isExpired) + "&";
        if (isRead === null)
            throw new globalThis.Error("The parameter 'isRead' cannot be null.");
        else if (isRead !== undefined)
            url_ += "IsRead=" + encodeURIComponent("" + isRead) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (isCreator === null)
            throw new globalThis.Error("The parameter 'isCreator' cannot be null.");
        else if (isCreator !== undefined)
            url_ += "IsCreator=" + encodeURIComponent("" + isCreator) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AlertItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AlertItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AlertItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AlertItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AntiTheftSystemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param structureId (optional) 
     * @param serviceId (optional) 
     * @return Success
     */
    getAllBase(structureId: number | undefined, serviceId: number | undefined): Observable<AntiTheftSystemBaseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AntiTheftSystem/GetAllBase?";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AntiTheftSystemBaseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AntiTheftSystemBaseDto[]>;
        }));
    }

    protected processGetAllBase(response: HttpResponseBase): Observable<AntiTheftSystemBaseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AntiTheftSystemBaseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAntiTheftSystemDto | undefined): Observable<AntiTheftSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/AntiTheftSystem/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AntiTheftSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AntiTheftSystemDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AntiTheftSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AntiTheftSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAntiTheftSystemDto | undefined): Observable<AntiTheftSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/AntiTheftSystem/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AntiTheftSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AntiTheftSystemDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AntiTheftSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AntiTheftSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AntiTheftSystem/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<AntiTheftSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/AntiTheftSystem/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AntiTheftSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AntiTheftSystemDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AntiTheftSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AntiTheftSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param structureId (optional) 
     * @param serviceId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, structureId: number | undefined, serviceId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AntiTheftSystemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AntiTheftSystem/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AntiTheftSystemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AntiTheftSystemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AntiTheftSystemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AntiTheftSystemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssetServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAssetDto | undefined): Observable<AssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAssetDto | undefined): Observable<AssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Asset/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<AssetDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AssetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param typeId (optional) 
     * @param serviceId (optional) 
     * @param userId (optional) 
     * @param iCCID (optional) 
     * @param phoneNumber (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, typeId: number | undefined, serviceId: number | undefined, userId: number | undefined, iCCID: string | undefined, phoneNumber: string | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AssetItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Asset/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (typeId === null)
            throw new globalThis.Error("The parameter 'typeId' cannot be null.");
        else if (typeId !== undefined)
            url_ += "TypeId=" + encodeURIComponent("" + typeId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (iCCID === null)
            throw new globalThis.Error("The parameter 'iCCID' cannot be null.");
        else if (iCCID !== undefined)
            url_ += "ICCID=" + encodeURIComponent("" + iCCID) + "&";
        if (phoneNumber === null)
            throw new globalThis.Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined)
            url_ += "PhoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AssetItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssetServiceUserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAssetServiceUserDto | undefined): Observable<AssetServiceUserDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetServiceUser/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetServiceUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetServiceUserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AssetServiceUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetServiceUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAssetServiceUserDto | undefined): Observable<AssetServiceUserDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetServiceUser/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetServiceUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetServiceUserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AssetServiceUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetServiceUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/AssetServiceUser/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<AssetServiceUserDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetServiceUser/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetServiceUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetServiceUserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AssetServiceUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetServiceUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param assetId (optional) 
     * @param serviceId (optional) 
     * @param userId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, assetId: number | undefined, serviceId: number | undefined, userId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AssetServiceUserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/AssetServiceUser/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (assetId === null)
            throw new globalThis.Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "AssetId=" + encodeURIComponent("" + assetId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetServiceUserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetServiceUserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AssetServiceUserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetServiceUserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssetTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AssetType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AutonomyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateAutonomyDto | undefined): Observable<AutonomyDto> {
        let url_ = this.baseUrl + "/api/services/app/Autonomy/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AutonomyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AutonomyDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<AutonomyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AutonomyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAutonomyDto | undefined): Observable<AutonomyDto> {
        let url_ = this.baseUrl + "/api/services/app/Autonomy/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AutonomyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AutonomyDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<AutonomyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AutonomyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Autonomy/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<AutonomyDto> {
        let url_ = this.baseUrl + "/api/services/app/Autonomy/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AutonomyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AutonomyDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AutonomyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AutonomyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param inputCardRecordId (optional) 
     * @param isPaged (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(inputCardRecordId: number | undefined, isPaged: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<AutonomyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Autonomy/GetAll?";
        if (inputCardRecordId === null)
            throw new globalThis.Error("The parameter 'inputCardRecordId' cannot be null.");
        else if (inputCardRecordId !== undefined)
            url_ += "InputCardRecordId=" + encodeURIComponent("" + inputCardRecordId) + "&";
        if (isPaged === null)
            throw new globalThis.Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AutonomyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AutonomyDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AutonomyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AutonomyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BarthelAnswerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param barthelQuestionId (optional) 
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(barthelQuestionId: number | undefined, keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<BarthelAnswerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BarthelAnswer/GetAll?";
        if (barthelQuestionId === null)
            throw new globalThis.Error("The parameter 'barthelQuestionId' cannot be null.");
        else if (barthelQuestionId !== undefined)
            url_ += "BarthelQuestionId=" + encodeURIComponent("" + barthelQuestionId) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BarthelAnswerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BarthelAnswerDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BarthelAnswerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BarthelAnswerDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BarthelIndexRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param currentId (optional) 
     * @param getPrevious (optional) 
     * @return Success
     */
    getForComparison(currentId: number | undefined, getPrevious: boolean | undefined): Observable<BarthelIndexDto> {
        let url_ = this.baseUrl + "/api/services/app/BarthelIndexRecord/GetForComparison?";
        if (currentId === null)
            throw new globalThis.Error("The parameter 'currentId' cannot be null.");
        else if (currentId !== undefined)
            url_ += "currentId=" + encodeURIComponent("" + currentId) + "&";
        if (getPrevious === null)
            throw new globalThis.Error("The parameter 'getPrevious' cannot be null.");
        else if (getPrevious !== undefined)
            url_ += "getPrevious=" + encodeURIComponent("" + getPrevious) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForComparison(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForComparison(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BarthelIndexDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BarthelIndexDto>;
        }));
    }

    protected processGetForComparison(response: HttpResponseBase): Observable<BarthelIndexDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BarthelIndexDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateBarthelIndexDto | undefined): Observable<BarthelIndexDto> {
        let url_ = this.baseUrl + "/api/services/app/BarthelIndexRecord/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BarthelIndexDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BarthelIndexDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<BarthelIndexDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BarthelIndexDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateBarthelIndexDto | undefined): Observable<BarthelIndexDto> {
        let url_ = this.baseUrl + "/api/services/app/BarthelIndexRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BarthelIndexDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BarthelIndexDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BarthelIndexDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BarthelIndexDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BarthelIndexRecord/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<BarthelIndexDto> {
        let url_ = this.baseUrl + "/api/services/app/BarthelIndexRecord/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BarthelIndexDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BarthelIndexDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BarthelIndexDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BarthelIndexDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param date (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(date: moment.Moment | undefined, socialHealtRecordId: number, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<BarthelIndexItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/BarthelIndexRecord/GetAll?";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (socialHealtRecordId === undefined || socialHealtRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealtRecordId' must be defined and cannot be null.");
        else
            url_ += "SocialHealtRecordId=" + encodeURIComponent("" + socialHealtRecordId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BarthelIndexItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BarthelIndexItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BarthelIndexItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BarthelIndexItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BarthelIndexRecordAnswerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateBarthelIndexAnswerDto | undefined): Observable<BarthelIndexAnswerDto> {
        let url_ = this.baseUrl + "/api/services/app/BarthelIndexRecordAnswer/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BarthelIndexAnswerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BarthelIndexAnswerDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BarthelIndexAnswerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BarthelIndexAnswerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BarthelIndexRecordAnswer/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<BarthelIndexAnswerDto> {
        let url_ = this.baseUrl + "/api/services/app/BarthelIndexRecordAnswer/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BarthelIndexAnswerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BarthelIndexAnswerDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BarthelIndexAnswerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BarthelIndexAnswerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: BarthelIndexAnswerGetAllInput | undefined): Observable<BarthelIndexAnswerDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/BarthelIndexRecordAnswer/GetAll?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BarthelIndexAnswerDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BarthelIndexAnswerDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BarthelIndexAnswerDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BarthelIndexAnswerDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BarthelQuestionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BarthelQuestion/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BodySegmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BodySegment/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BodyTemperatureServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/BodyTemperature/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BodyTemperatureHourVitalSignServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateBodyTemperatureHourVitalSignDto | undefined): Observable<BodyTemperatureHourVitalSignDto> {
        let url_ = this.baseUrl + "/api/services/app/BodyTemperatureHourVitalSign/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BodyTemperatureHourVitalSignDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BodyTemperatureHourVitalSignDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<BodyTemperatureHourVitalSignDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BodyTemperatureHourVitalSignDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/BodyTemperatureHourVitalSign/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<BodyTemperatureHourVitalSignDto> {
        let url_ = this.baseUrl + "/api/services/app/BodyTemperatureHourVitalSign/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BodyTemperatureHourVitalSignDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BodyTemperatureHourVitalSignDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<BodyTemperatureHourVitalSignDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BodyTemperatureHourVitalSignDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param vitalSignRecordId (optional) 
     * @return Success
     */
    getAll(vitalSignRecordId: number | undefined): Observable<BodyTemperatureHourVitalSignDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/BodyTemperatureHourVitalSign/GetAll?";
        if (vitalSignRecordId === null)
            throw new globalThis.Error("The parameter 'vitalSignRecordId' cannot be null.");
        else if (vitalSignRecordId !== undefined)
            url_ += "VitalSignRecordId=" + encodeURIComponent("" + vitalSignRecordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BodyTemperatureHourVitalSignDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BodyTemperatureHourVitalSignDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BodyTemperatureHourVitalSignDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BodyTemperatureHourVitalSignDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CadenceOfChangeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CadenceOfChange/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CaregiverRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCaregiverRecordDto | undefined): Observable<CaregiverRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/CaregiverRecord/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverRecordDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CaregiverRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCaregiverRecordDto | undefined): Observable<CaregiverRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/CaregiverRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverRecordDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CaregiverRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CaregiverRecord/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CaregiverRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/CaregiverRecord/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverRecordDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CaregiverRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialHealtRecordId (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(socialHealtRecordId: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CaregiverRecordDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CaregiverRecord/GetAll?";
        if (socialHealtRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealtRecordId' cannot be null.");
        else if (socialHealtRecordId !== undefined)
            url_ += "SocialHealtRecordId=" + encodeURIComponent("" + socialHealtRecordId) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CaregiverRecordDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CaregiverRecordDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CaregiverRecordDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CaregiverRecordDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CaregiverTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CaregiverType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CategoryObservationGridServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCategoryObservationGridDto | undefined): Observable<CategoryObservationGridDto> {
        let url_ = this.baseUrl + "/api/services/app/CategoryObservationGrid/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryObservationGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryObservationGridDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CategoryObservationGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryObservationGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCategoryObservationGridDto | undefined): Observable<CategoryObservationGridDto> {
        let url_ = this.baseUrl + "/api/services/app/CategoryObservationGrid/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryObservationGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryObservationGridDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CategoryObservationGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryObservationGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CategoryObservationGrid/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CategoryObservationGridDto> {
        let url_ = this.baseUrl + "/api/services/app/CategoryObservationGrid/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryObservationGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryObservationGridDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CategoryObservationGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryObservationGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sectionObservationGridId (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, sectionObservationGridId: number | undefined, sorting: string | undefined): Observable<CategoryObservationGridDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CategoryObservationGrid/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sectionObservationGridId === null)
            throw new globalThis.Error("The parameter 'sectionObservationGridId' cannot be null.");
        else if (sectionObservationGridId !== undefined)
            url_ += "SectionObservationGridId=" + encodeURIComponent("" + sectionObservationGridId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CategoryObservationGridDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CategoryObservationGridDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CategoryObservationGridDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CategoryObservationGridDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CheckDrugExpirationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    confirm(id: number | undefined): Observable<CheckDrugExpirationDto> {
        let url_ = this.baseUrl + "/api/services/app/CheckDrugExpiration/Confirm?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckDrugExpirationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckDrugExpirationDto>;
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<CheckDrugExpirationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckDrugExpirationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCheckDrugExpirationDto | undefined): Observable<CheckDrugExpirationDto> {
        let url_ = this.baseUrl + "/api/services/app/CheckDrugExpiration/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckDrugExpirationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckDrugExpirationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CheckDrugExpirationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckDrugExpirationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCheckDrugExpirationDto | undefined): Observable<CheckDrugExpirationDto> {
        let url_ = this.baseUrl + "/api/services/app/CheckDrugExpiration/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckDrugExpirationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckDrugExpirationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CheckDrugExpirationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckDrugExpirationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CheckDrugExpiration/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CheckDrugExpirationDto> {
        let url_ = this.baseUrl + "/api/services/app/CheckDrugExpiration/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckDrugExpirationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckDrugExpirationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CheckDrugExpirationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckDrugExpirationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param keyword (optional) 
     * @param isConfirmed (optional) 
     * @param month (optional) 
     * @param year (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceId: number | undefined, keyword: string | undefined, isConfirmed: boolean | undefined, month: number | undefined, year: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CheckDrugExpirationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CheckDrugExpiration/GetAll?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isConfirmed === null)
            throw new globalThis.Error("The parameter 'isConfirmed' cannot be null.");
        else if (isConfirmed !== undefined)
            url_ += "IsConfirmed=" + encodeURIComponent("" + isConfirmed) + "&";
        if (month === null)
            throw new globalThis.Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "Month=" + encodeURIComponent("" + month) + "&";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckDrugExpirationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckDrugExpirationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CheckDrugExpirationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckDrugExpirationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CollaborationDegreeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CollaborationDegree/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CompetentBodyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CompetentBody/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeUiTheme(body: ChangeUiThemeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeUiTheme(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeUiTheme(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeUiTheme(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ConleyQuestionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<ConleyQuestionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ConleyQuestion/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConleyQuestionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConleyQuestionDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ConleyQuestionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ConleyQuestionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ConleyScaleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    confirm(id: number | undefined): Observable<ConleyScaleDto> {
        let url_ = this.baseUrl + "/api/services/app/ConleyScale/Confirm?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConleyScaleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConleyScaleDto>;
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<ConleyScaleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConleyScaleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateConleyScaleDto | undefined): Observable<ConleyScaleDto> {
        let url_ = this.baseUrl + "/api/services/app/ConleyScale/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConleyScaleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConleyScaleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ConleyScaleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConleyScaleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateConleyScaleDto | undefined): Observable<ConleyScaleDto> {
        let url_ = this.baseUrl + "/api/services/app/ConleyScale/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConleyScaleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConleyScaleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ConleyScaleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConleyScaleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ConleyScale/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ConleyScaleDto> {
        let url_ = this.baseUrl + "/api/services/app/ConleyScale/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConleyScaleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConleyScaleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ConleyScaleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConleyScaleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialHealthRecordId (optional) 
     * @param isConfirmed (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isAdmission (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(socialHealthRecordId: number | undefined, isConfirmed: boolean | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, isAdmission: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ConleyScaleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ConleyScale/GetAll?";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "SocialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        if (isConfirmed === null)
            throw new globalThis.Error("The parameter 'isConfirmed' cannot be null.");
        else if (isConfirmed !== undefined)
            url_ += "IsConfirmed=" + encodeURIComponent("" + isConfirmed) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (isAdmission === null)
            throw new globalThis.Error("The parameter 'isAdmission' cannot be null.");
        else if (isAdmission !== undefined)
            url_ += "IsAdmission=" + encodeURIComponent("" + isAdmission) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConleyScaleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConleyScaleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ConleyScaleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConleyScaleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ConsciousnessStateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ConsciousnessState/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CPIMonthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CPIMonth/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CPITypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/CPIType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CustomDataTemplateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateCustomDataTemplateDto | undefined): Observable<CustomDataTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomDataTemplate/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomDataTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomDataTemplateDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<CustomDataTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomDataTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateCustomDataTemplateDto | undefined): Observable<CustomDataTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomDataTemplate/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomDataTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomDataTemplateDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CustomDataTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomDataTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/CustomDataTemplate/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<CustomDataTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomDataTemplate/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomDataTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomDataTemplateDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<CustomDataTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomDataTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<CustomDataTemplateDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/CustomDataTemplate/GetAll?";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomDataTemplateDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomDataTemplateDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomDataTemplateDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomDataTemplateDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DaysOfWeekServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DaysOfWeek/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DiaryRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateDiaryRecordDto | undefined): Observable<DiaryRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/DiaryRecord/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiaryRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiaryRecordDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DiaryRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiaryRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateDiaryRecordDto | undefined): Observable<DiaryRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/DiaryRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiaryRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiaryRecordDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DiaryRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiaryRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DiaryRecord/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DiaryRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/DiaryRecord/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiaryRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiaryRecordDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DiaryRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiaryRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialHealthRecordId (optional) 
     * @param userId (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(socialHealthRecordId: number | undefined, userId: number | undefined, sorting: string | undefined): Observable<DiaryRecordDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DiaryRecord/GetAll?";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "SocialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiaryRecordDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiaryRecordDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DiaryRecordDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiaryRecordDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DiaryTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DiaryType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DisabilityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateDisabilityDto | undefined): Observable<DisabilityDto> {
        let url_ = this.baseUrl + "/api/services/app/Disability/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DisabilityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DisabilityDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DisabilityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisabilityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateDisabilityDto | undefined): Observable<DisabilityDto> {
        let url_ = this.baseUrl + "/api/services/app/Disability/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DisabilityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DisabilityDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DisabilityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisabilityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Disability/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DisabilityDto> {
        let url_ = this.baseUrl + "/api/services/app/Disability/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DisabilityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DisabilityDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DisabilityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisabilityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param inputCardRecordId (optional) 
     * @param isPaged (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(inputCardRecordId: number | undefined, isPaged: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<DisabilityDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Disability/GetAll?";
        if (inputCardRecordId === null)
            throw new globalThis.Error("The parameter 'inputCardRecordId' cannot be null.");
        else if (inputCardRecordId !== undefined)
            url_ += "InputCardRecordId=" + encodeURIComponent("" + inputCardRecordId) + "&";
        if (isPaged === null)
            throw new globalThis.Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DisabilityDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DisabilityDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DisabilityDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisabilityDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DisabilityTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DisabilityType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DisorderNonCognitiveServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DisorderNonCognitive/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DoctorRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateDoctorRecordDto | undefined): Observable<DoctorRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/DoctorRecord/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorRecordDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DoctorRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateDoctorRecordDto | undefined): Observable<DoctorRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/DoctorRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorRecordDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DoctorRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DoctorRecord/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DoctorRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/DoctorRecord/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorRecordDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DoctorRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param socialHealtRecordId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, socialHealtRecordId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<DoctorRecordDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DoctorRecord/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (socialHealtRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealtRecordId' cannot be null.");
        else if (socialHealtRecordId !== undefined)
            url_ += "SocialHealtRecordId=" + encodeURIComponent("" + socialHealtRecordId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DoctorRecordDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DoctorRecordDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DoctorRecordDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DoctorRecordDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DoctorTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DoctorType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DrugServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateDrugDto | undefined): Observable<DrugDto> {
        let url_ = this.baseUrl + "/api/services/app/Drug/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DrugDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DrugDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DrugDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrugDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateDrugDto | undefined): Observable<DrugDto> {
        let url_ = this.baseUrl + "/api/services/app/Drug/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DrugDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DrugDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DrugDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrugDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Drug/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DrugDto> {
        let url_ = this.baseUrl + "/api/services/app/Drug/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DrugDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DrugDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DrugDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrugDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param admissionRecordId (optional) 
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(admissionRecordId: number | undefined, keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<DrugDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Drug/GetAll?";
        if (admissionRecordId === null)
            throw new globalThis.Error("The parameter 'admissionRecordId' cannot be null.");
        else if (admissionRecordId !== undefined)
            url_ += "AdmissionRecordId=" + encodeURIComponent("" + admissionRecordId) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DrugDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DrugDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DrugDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrugDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DrugAdministrationRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateDrugAdministrationRecordDto | undefined): Observable<DrugAdministrationRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/DrugAdministrationRecord/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DrugAdministrationRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DrugAdministrationRecordDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DrugAdministrationRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrugAdministrationRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateDrugAdministrationRecordDto | undefined): Observable<DrugAdministrationRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/DrugAdministrationRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DrugAdministrationRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DrugAdministrationRecordDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DrugAdministrationRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrugAdministrationRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DrugAdministrationRecord/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DrugAdministrationRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/DrugAdministrationRecord/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DrugAdministrationRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DrugAdministrationRecordDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DrugAdministrationRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrugAdministrationRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialHealthRecordId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(socialHealthRecordId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<DrugAdministrationRecordDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DrugAdministrationRecord/GetAll?";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "SocialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DrugAdministrationRecordDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DrugAdministrationRecordDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DrugAdministrationRecordDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrugAdministrationRecordDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DrugStockManagementRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @param isSecondSignature (optional) 
     * @return Success
     */
    confirm(id: number | undefined, isSecondSignature: boolean | undefined): Observable<DrugStockManagementRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/DrugStockManagementRecord/Confirm?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isSecondSignature === null)
            throw new globalThis.Error("The parameter 'isSecondSignature' cannot be null.");
        else if (isSecondSignature !== undefined)
            url_ += "isSecondSignature=" + encodeURIComponent("" + isSecondSignature) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DrugStockManagementRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DrugStockManagementRecordDto>;
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<DrugStockManagementRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrugStockManagementRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isSecondSignature (optional) 
     * @param body (optional) 
     * @return Success
     */
    confirmMany(isSecondSignature: boolean | undefined, body: number[] | undefined): Observable<DrugStockManagementRecordDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DrugStockManagementRecord/ConfirmMany?";
        if (isSecondSignature === null)
            throw new globalThis.Error("The parameter 'isSecondSignature' cannot be null.");
        else if (isSecondSignature !== undefined)
            url_ += "isSecondSignature=" + encodeURIComponent("" + isSecondSignature) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DrugStockManagementRecordDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DrugStockManagementRecordDto[]>;
        }));
    }

    protected processConfirmMany(response: HttpResponseBase): Observable<DrugStockManagementRecordDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DrugStockManagementRecordDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateDrugStockManagementRecord | undefined): Observable<DrugStockManagementRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/DrugStockManagementRecord/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DrugStockManagementRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DrugStockManagementRecordDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<DrugStockManagementRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrugStockManagementRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateDrugStockManagementRecordDto | undefined): Observable<DrugStockManagementRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/DrugStockManagementRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DrugStockManagementRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DrugStockManagementRecordDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DrugStockManagementRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrugStockManagementRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DrugStockManagementRecord/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<DrugStockManagementRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/DrugStockManagementRecord/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DrugStockManagementRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DrugStockManagementRecordDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DrugStockManagementRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrugStockManagementRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialHealthRecordId (optional) 
     * @param startExpiryDate (optional) 
     * @param endExpiryDate (optional) 
     * @param startLoadingDate (optional) 
     * @param endLoadingDate (optional) 
     * @param startDischargeDate (optional) 
     * @param endDischargeDate (optional) 
     * @param hasDischarge (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(socialHealthRecordId: number | undefined, startExpiryDate: moment.Moment | undefined, endExpiryDate: moment.Moment | undefined, startLoadingDate: moment.Moment | undefined, endLoadingDate: moment.Moment | undefined, startDischargeDate: moment.Moment | undefined, endDischargeDate: moment.Moment | undefined, hasDischarge: boolean | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<DrugStockManagementRecordDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/DrugStockManagementRecord/GetAll?";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "SocialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        if (startExpiryDate === null)
            throw new globalThis.Error("The parameter 'startExpiryDate' cannot be null.");
        else if (startExpiryDate !== undefined)
            url_ += "StartExpiryDate=" + encodeURIComponent(startExpiryDate ? "" + startExpiryDate.toISOString() : "") + "&";
        if (endExpiryDate === null)
            throw new globalThis.Error("The parameter 'endExpiryDate' cannot be null.");
        else if (endExpiryDate !== undefined)
            url_ += "EndExpiryDate=" + encodeURIComponent(endExpiryDate ? "" + endExpiryDate.toISOString() : "") + "&";
        if (startLoadingDate === null)
            throw new globalThis.Error("The parameter 'startLoadingDate' cannot be null.");
        else if (startLoadingDate !== undefined)
            url_ += "StartLoadingDate=" + encodeURIComponent(startLoadingDate ? "" + startLoadingDate.toISOString() : "") + "&";
        if (endLoadingDate === null)
            throw new globalThis.Error("The parameter 'endLoadingDate' cannot be null.");
        else if (endLoadingDate !== undefined)
            url_ += "EndLoadingDate=" + encodeURIComponent(endLoadingDate ? "" + endLoadingDate.toISOString() : "") + "&";
        if (startDischargeDate === null)
            throw new globalThis.Error("The parameter 'startDischargeDate' cannot be null.");
        else if (startDischargeDate !== undefined)
            url_ += "StartDischargeDate=" + encodeURIComponent(startDischargeDate ? "" + startDischargeDate.toISOString() : "") + "&";
        if (endDischargeDate === null)
            throw new globalThis.Error("The parameter 'endDischargeDate' cannot be null.");
        else if (endDischargeDate !== undefined)
            url_ += "EndDischargeDate=" + encodeURIComponent(endDischargeDate ? "" + endDischargeDate.toISOString() : "") + "&";
        if (hasDischarge === null)
            throw new globalThis.Error("The parameter 'hasDischarge' cannot be null.");
        else if (hasDischarge !== undefined)
            url_ += "HasDischarge=" + encodeURIComponent("" + hasDischarge) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DrugStockManagementRecordDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DrugStockManagementRecordDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DrugStockManagementRecordDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DrugStockManagementRecordDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EatingModeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EatingMode/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EducationalDegreeLevelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EducationalDegreeLevel/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EducationalTrainingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateEducationalTrainingDto | undefined): Observable<EducationalTrainingDto> {
        let url_ = this.baseUrl + "/api/services/app/EducationalTraining/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducationalTrainingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducationalTrainingDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<EducationalTrainingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EducationalTrainingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateEducationalTrainingDto | undefined): Observable<EducationalTrainingDto> {
        let url_ = this.baseUrl + "/api/services/app/EducationalTraining/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducationalTrainingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducationalTrainingDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<EducationalTrainingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EducationalTrainingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/EducationalTraining/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<EducationalTrainingDto> {
        let url_ = this.baseUrl + "/api/services/app/EducationalTraining/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducationalTrainingDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducationalTrainingDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EducationalTrainingDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EducationalTrainingDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<EducationalTrainingDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/EducationalTraining/GetAll?";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EducationalTrainingDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EducationalTrainingDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<EducationalTrainingDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EducationalTrainingDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ElectricalSystemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param structureId (optional) 
     * @param serviceId (optional) 
     * @return Success
     */
    getAllBase(structureId: number | undefined, serviceId: number | undefined): Observable<ElectricalSystemBaseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ElectricalSystem/GetAllBase?";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElectricalSystemBaseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElectricalSystemBaseDto[]>;
        }));
    }

    protected processGetAllBase(response: HttpResponseBase): Observable<ElectricalSystemBaseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ElectricalSystemBaseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateElectricalSystemDto | undefined): Observable<ElectricalSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectricalSystem/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElectricalSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElectricalSystemDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ElectricalSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectricalSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateElectricalSystemDto | undefined): Observable<ElectricalSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectricalSystem/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElectricalSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElectricalSystemDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ElectricalSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectricalSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ElectricalSystem/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ElectricalSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectricalSystem/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElectricalSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElectricalSystemDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ElectricalSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectricalSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param structureId (optional) 
     * @param serviceId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, structureId: number | undefined, serviceId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ElectricalSystemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ElectricalSystem/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElectricalSystemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElectricalSystemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ElectricalSystemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectricalSystemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ElevatorSystemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param structureId (optional) 
     * @param serviceId (optional) 
     * @return Success
     */
    getAllBase(structureId: number | undefined, serviceId: number | undefined): Observable<ElevatorSystemBaseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ElevatorSystem/GetAllBase?";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElevatorSystemBaseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElevatorSystemBaseDto[]>;
        }));
    }

    protected processGetAllBase(response: HttpResponseBase): Observable<ElevatorSystemBaseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ElevatorSystemBaseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateElevatorSystemDto | undefined): Observable<ElevatorSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/ElevatorSystem/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElevatorSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElevatorSystemDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ElevatorSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElevatorSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateElevatorSystemDto | undefined): Observable<ElevatorSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/ElevatorSystem/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElevatorSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElevatorSystemDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ElevatorSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElevatorSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ElevatorSystem/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ElevatorSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/ElevatorSystem/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElevatorSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElevatorSystemDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ElevatorSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElevatorSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param structureId (optional) 
     * @param serviceId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, structureId: number | undefined, serviceId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ElevatorSystemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ElevatorSystem/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElevatorSystemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElevatorSystemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ElevatorSystemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElevatorSystemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ElevatorTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ElevatorType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EnergySourceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EnergySource/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class EventSeverityLevelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/EventSeverityLevel/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FallEventOutcomeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FallEventOutcome/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FallLocationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FallLocation/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FallModeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FallMode/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FallReasonServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FallReason/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FallReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    confirm(id: number | undefined): Observable<FallReportDto> {
        let url_ = this.baseUrl + "/api/services/app/FallReport/Confirm?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FallReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FallReportDto>;
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<FallReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FallReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    confirmMany(body: number[] | undefined): Observable<FallReportDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FallReport/ConfirmMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FallReportDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FallReportDto[]>;
        }));
    }

    protected processConfirmMany(response: HttpResponseBase): Observable<FallReportDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FallReportDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateForOperator(body: UpdateFallReportForOperatorDto | undefined): Observable<FallReportDto> {
        let url_ = this.baseUrl + "/api/services/app/FallReport/UpdateForOperator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateForOperator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateForOperator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FallReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FallReportDto>;
        }));
    }

    protected processUpdateForOperator(response: HttpResponseBase): Observable<FallReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FallReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateForDoctor(body: UpdateFallReportForDoctorDto | undefined): Observable<FallReportDto> {
        let url_ = this.baseUrl + "/api/services/app/FallReport/UpdateForDoctor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateForDoctor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateForDoctor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FallReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FallReportDto>;
        }));
    }

    protected processUpdateForDoctor(response: HttpResponseBase): Observable<FallReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FallReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateFallReportDto | undefined): Observable<FallReportDto> {
        let url_ = this.baseUrl + "/api/services/app/FallReport/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FallReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FallReportDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FallReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FallReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateFallReportDto | undefined): Observable<FallReportDto> {
        let url_ = this.baseUrl + "/api/services/app/FallReport/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FallReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FallReportDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FallReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FallReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FallReport/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<FallReportDto> {
        let url_ = this.baseUrl + "/api/services/app/FallReport/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FallReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FallReportDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FallReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FallReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialHealthRecordId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param keyword (optional) 
     * @param isConfirmed (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(socialHealthRecordId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, keyword: string | undefined, isConfirmed: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FallReportDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/FallReport/GetAll?";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "SocialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isConfirmed === null)
            throw new globalThis.Error("The parameter 'isConfirmed' cannot be null.");
        else if (isConfirmed !== undefined)
            url_ += "IsConfirmed=" + encodeURIComponent("" + isConfirmed) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FallReportDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FallReportDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FallReportDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FallReportDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FamilyComponentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateFamilyComponentDto | undefined): Observable<FamilyComponentDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyComponent/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FamilyComponentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FamilyComponentDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FamilyComponentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FamilyComponentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateFamilyComponentDto | undefined): Observable<FamilyComponentDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyComponent/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FamilyComponentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FamilyComponentDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FamilyComponentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FamilyComponentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FamilyComponent/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<FamilyComponentDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyComponent/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FamilyComponentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FamilyComponentDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FamilyComponentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FamilyComponentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialInvestigationRecordId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(socialInvestigationRecordId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FamilyComponentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyComponent/GetAll?";
        if (socialInvestigationRecordId === null)
            throw new globalThis.Error("The parameter 'socialInvestigationRecordId' cannot be null.");
        else if (socialInvestigationRecordId !== undefined)
            url_ += "SocialInvestigationRecordId=" + encodeURIComponent("" + socialInvestigationRecordId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FamilyComponentDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FamilyComponentDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FamilyComponentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FamilyComponentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FamilyReferenceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateFamilyReferenceDto | undefined): Observable<FamilyReferenceDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyReference/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FamilyReferenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FamilyReferenceDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FamilyReferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FamilyReferenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateFamilyReferenceDto | undefined): Observable<FamilyReferenceDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyReference/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FamilyReferenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FamilyReferenceDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FamilyReferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FamilyReferenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FamilyReference/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<FamilyReferenceDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyReference/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FamilyReferenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FamilyReferenceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FamilyReferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FamilyReferenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param inputCardRecordId (optional) 
     * @param isPaged (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(inputCardRecordId: number | undefined, isPaged: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FamilyReferenceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/FamilyReference/GetAll?";
        if (inputCardRecordId === null)
            throw new globalThis.Error("The parameter 'inputCardRecordId' cannot be null.");
        else if (inputCardRecordId !== undefined)
            url_ += "InputCardRecordId=" + encodeURIComponent("" + inputCardRecordId) + "&";
        if (isPaged === null)
            throw new globalThis.Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FamilyReferenceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FamilyReferenceDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FamilyReferenceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FamilyReferenceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FamilySituationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FamilySituation/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    downloadFile(fileId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/File/DownloadFile?";
        if (fileId === null)
            throw new globalThis.Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fileId (optional) 
     * @return Success
     */
    getFile(fileId: number | undefined): Observable<FileExtendedDto> {
        let url_ = this.baseUrl + "/api/services/app/File/GetFile?";
        if (fileId === null)
            throw new globalThis.Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileExtendedDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileExtendedDto>;
        }));
    }

    protected processGetFile(response: HttpResponseBase): Observable<FileExtendedDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileExtendedDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    associateFileToEntities(body: CreateFileAssociationDto | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/File/AssociateFileToEntities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssociateFileToEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssociateFileToEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processAssociateFileToEntities(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadZipFiles(body: FileZipDowloadDto | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/File/DownloadZipFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadZipFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadZipFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadZipFiles(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param file (optional) 
     * @return Success
     */
    create(file: FileParameter | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/File/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/File/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/File/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @param serviceId (optional) 
     * @param userId (optional) 
     * @param activityId (optional) 
     * @param socialHealthRecordId (optional) 
     * @param fileTypeId (optional) 
     * @param assetId (optional) 
     * @param vehicleId (optional) 
     * @param serviceVerbalId (optional) 
     * @param serviceReportId (optional) 
     * @param structureId (optional) 
     * @param fileTagIds (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(name: string | undefined, serviceId: number | undefined, userId: number | undefined, activityId: number | undefined, socialHealthRecordId: number | undefined, fileTypeId: number | undefined, assetId: number | undefined, vehicleId: number | undefined, serviceVerbalId: number | undefined, serviceReportId: number | undefined, structureId: number | undefined, fileTagIds: number[] | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FileDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/File/GetAll?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (activityId === null)
            throw new globalThis.Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "ActivityId=" + encodeURIComponent("" + activityId) + "&";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "SocialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        if (fileTypeId === null)
            throw new globalThis.Error("The parameter 'fileTypeId' cannot be null.");
        else if (fileTypeId !== undefined)
            url_ += "FileTypeId=" + encodeURIComponent("" + fileTypeId) + "&";
        if (assetId === null)
            throw new globalThis.Error("The parameter 'assetId' cannot be null.");
        else if (assetId !== undefined)
            url_ += "AssetId=" + encodeURIComponent("" + assetId) + "&";
        if (vehicleId === null)
            throw new globalThis.Error("The parameter 'vehicleId' cannot be null.");
        else if (vehicleId !== undefined)
            url_ += "VehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        if (serviceVerbalId === null)
            throw new globalThis.Error("The parameter 'serviceVerbalId' cannot be null.");
        else if (serviceVerbalId !== undefined)
            url_ += "ServiceVerbalId=" + encodeURIComponent("" + serviceVerbalId) + "&";
        if (serviceReportId === null)
            throw new globalThis.Error("The parameter 'serviceReportId' cannot be null.");
        else if (serviceReportId !== undefined)
            url_ += "ServiceReportId=" + encodeURIComponent("" + serviceReportId) + "&";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (fileTagIds === null)
            throw new globalThis.Error("The parameter 'fileTagIds' cannot be null.");
        else if (fileTagIds !== undefined)
            fileTagIds && fileTagIds.forEach(item => { url_ += "FileTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FileDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FileTagServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateFileTagDto | undefined): Observable<DictionaryDto> {
        let url_ = this.baseUrl + "/api/services/app/FileTag/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DictionaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DictionaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceId: number | undefined, keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FileTag/GetAll?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FirePreventionDeviceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FirePreventionDevice/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FirePreventionExtinguisherServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FirePreventionExtinguisher/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FirePreventionSystemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param structureId (optional) 
     * @param serviceId (optional) 
     * @return Success
     */
    getAllBase(structureId: number | undefined, serviceId: number | undefined): Observable<FirePreventionSystemBaseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FirePreventionSystem/GetAllBase?";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FirePreventionSystemBaseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FirePreventionSystemBaseDto[]>;
        }));
    }

    protected processGetAllBase(response: HttpResponseBase): Observable<FirePreventionSystemBaseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FirePreventionSystemBaseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateFirePreventionSystemDto | undefined): Observable<FirePreventionSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/FirePreventionSystem/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FirePreventionSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FirePreventionSystemDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FirePreventionSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FirePreventionSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateFirePreventionSystemDto | undefined): Observable<FirePreventionSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/FirePreventionSystem/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FirePreventionSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FirePreventionSystemDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FirePreventionSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FirePreventionSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FirePreventionSystem/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<FirePreventionSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/FirePreventionSystem/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FirePreventionSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FirePreventionSystemDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FirePreventionSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FirePreventionSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param structureId (optional) 
     * @param serviceId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, structureId: number | undefined, serviceId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<FirePreventionSystemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/FirePreventionSystem/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FirePreventionSystemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FirePreventionSystemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FirePreventionSystemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FirePreventionSystemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FootwearTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FootwearType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FuelServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param fuelTypeId (optional) 
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(fuelTypeId: number | undefined, keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Fuel/GetAll?";
        if (fuelTypeId === null)
            throw new globalThis.Error("The parameter 'fuelTypeId' cannot be null.");
        else if (fuelTypeId !== undefined)
            url_ += "FuelTypeId=" + encodeURIComponent("" + fuelTypeId) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FuelTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FuelType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GeneralConditionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/GeneralCondition/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HealthAspectServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateHealthAspectDto | undefined): Observable<HealthAspectDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthAspect/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthAspectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthAspectDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<HealthAspectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthAspectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateHealthAspectDto | undefined): Observable<HealthAspectDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthAspect/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthAspectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthAspectDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<HealthAspectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthAspectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthAspect/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<HealthAspectDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthAspect/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthAspectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthAspectDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HealthAspectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthAspectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param inputCardRecordId (optional) 
     * @param isPaged (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(inputCardRecordId: number | undefined, isPaged: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<HealthAspectDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthAspect/GetAll?";
        if (inputCardRecordId === null)
            throw new globalThis.Error("The parameter 'inputCardRecordId' cannot be null.");
        else if (inputCardRecordId !== undefined)
            url_ += "InputCardRecordId=" + encodeURIComponent("" + inputCardRecordId) + "&";
        if (isPaged === null)
            throw new globalThis.Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthAspectDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthAspectDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<HealthAspectDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthAspectDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HealthCoordinatorRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateHealthCoordinatorRecordDto | undefined): Observable<HealthCoordinatorRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthCoordinatorRecord/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthCoordinatorRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthCoordinatorRecordDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<HealthCoordinatorRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCoordinatorRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateHealthCoordinatorRecordDto | undefined): Observable<HealthCoordinatorRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthCoordinatorRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthCoordinatorRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthCoordinatorRecordDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<HealthCoordinatorRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCoordinatorRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthCoordinatorRecord/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<HealthCoordinatorRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthCoordinatorRecord/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthCoordinatorRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthCoordinatorRecordDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HealthCoordinatorRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCoordinatorRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param socialHealtRecordId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, socialHealtRecordId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<HealthCoordinatorRecordDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthCoordinatorRecord/GetAll?";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (socialHealtRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealtRecordId' cannot be null.");
        else if (socialHealtRecordId !== undefined)
            url_ += "SocialHealtRecordId=" + encodeURIComponent("" + socialHealtRecordId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthCoordinatorRecordDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthCoordinatorRecordDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<HealthCoordinatorRecordDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCoordinatorRecordDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HealthSocialWelfareServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateHealthSocialWelfareServiceDto | undefined): Observable<HealthSocialWelfareServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthSocialWelfareService/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthSocialWelfareServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthSocialWelfareServiceDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<HealthSocialWelfareServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthSocialWelfareServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateHealthSocialWelfareServiceDto | undefined): Observable<HealthSocialWelfareServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthSocialWelfareService/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthSocialWelfareServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthSocialWelfareServiceDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<HealthSocialWelfareServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthSocialWelfareServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HealthSocialWelfareService/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<HealthSocialWelfareServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthSocialWelfareService/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthSocialWelfareServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthSocialWelfareServiceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HealthSocialWelfareServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthSocialWelfareServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param inputCardRecordId (optional) 
     * @param isPaged (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(inputCardRecordId: number | undefined, isPaged: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<HealthSocialWelfareServiceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HealthSocialWelfareService/GetAll?";
        if (inputCardRecordId === null)
            throw new globalThis.Error("The parameter 'inputCardRecordId' cannot be null.");
        else if (inputCardRecordId !== undefined)
            url_ += "InputCardRecordId=" + encodeURIComponent("" + inputCardRecordId) + "&";
        if (isPaged === null)
            throw new globalThis.Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthSocialWelfareServiceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthSocialWelfareServiceDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<HealthSocialWelfareServiceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthSocialWelfareServiceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HeatingSystemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param structureId (optional) 
     * @param serviceId (optional) 
     * @return Success
     */
    getAllBase(structureId: number | undefined, serviceId: number | undefined): Observable<HeatingSystemBaseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HeatingSystem/GetAllBase?";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HeatingSystemBaseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HeatingSystemBaseDto[]>;
        }));
    }

    protected processGetAllBase(response: HttpResponseBase): Observable<HeatingSystemBaseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HeatingSystemBaseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateHeatingSystemDto | undefined): Observable<HeatingSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/HeatingSystem/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HeatingSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HeatingSystemDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<HeatingSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HeatingSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateHeatingSystemDto | undefined): Observable<HeatingSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/HeatingSystem/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HeatingSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HeatingSystemDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<HeatingSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HeatingSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HeatingSystem/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<HeatingSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/HeatingSystem/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HeatingSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HeatingSystemDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HeatingSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HeatingSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param structureId (optional) 
     * @param keyword (optional) 
     * @param serviceId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(structureId: number | undefined, keyword: string | undefined, serviceId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<HeatingSystemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HeatingSystem/GetAll?";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HeatingSystemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HeatingSystemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<HeatingSystemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HeatingSystemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HistoricalCaseServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateHistoricalCaseDto | undefined): Observable<HistoricalCaseDto> {
        let url_ = this.baseUrl + "/api/services/app/HistoricalCase/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HistoricalCaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HistoricalCaseDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<HistoricalCaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HistoricalCaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateHistoricalCaseDto | undefined): Observable<HistoricalCaseDto> {
        let url_ = this.baseUrl + "/api/services/app/HistoricalCase/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HistoricalCaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HistoricalCaseDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<HistoricalCaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HistoricalCaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HistoricalCase/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<HistoricalCaseDto> {
        let url_ = this.baseUrl + "/api/services/app/HistoricalCase/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HistoricalCaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HistoricalCaseDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HistoricalCaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HistoricalCaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param admissionRecordId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(admissionRecordId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<HistoricalCaseDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HistoricalCase/GetAll?";
        if (admissionRecordId === null)
            throw new globalThis.Error("The parameter 'admissionRecordId' cannot be null.");
        else if (admissionRecordId !== undefined)
            url_ += "AdmissionRecordId=" + encodeURIComponent("" + admissionRecordId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HistoricalCaseDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HistoricalCaseDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<HistoricalCaseDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HistoricalCaseDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HistoricalCaseScopeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HistoricalCaseScope/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HourVitalSignServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HourVitalSign/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HousingSituationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateHousingSituationDto | undefined): Observable<HousingSituationDto> {
        let url_ = this.baseUrl + "/api/services/app/HousingSituation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HousingSituationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HousingSituationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<HousingSituationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HousingSituationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateHousingSituationDto | undefined): Observable<HousingSituationDto> {
        let url_ = this.baseUrl + "/api/services/app/HousingSituation/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HousingSituationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HousingSituationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<HousingSituationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HousingSituationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HousingSituation/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<HousingSituationDto> {
        let url_ = this.baseUrl + "/api/services/app/HousingSituation/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HousingSituationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HousingSituationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HousingSituationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HousingSituationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<HousingSituationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HousingSituation/GetAll?";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HousingSituationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HousingSituationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<HousingSituationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HousingSituationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class HydraulicSystemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param structureId (optional) 
     * @param serviceId (optional) 
     * @return Success
     */
    getAllBase(structureId: number | undefined, serviceId: number | undefined): Observable<HydraulicSystemBaseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/HydraulicSystem/GetAllBase?";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HydraulicSystemBaseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HydraulicSystemBaseDto[]>;
        }));
    }

    protected processGetAllBase(response: HttpResponseBase): Observable<HydraulicSystemBaseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HydraulicSystemBaseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateHydraulicSystemDto | undefined): Observable<HydraulicSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/HydraulicSystem/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HydraulicSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HydraulicSystemDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<HydraulicSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HydraulicSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateHydraulicSystemDto | undefined): Observable<HydraulicSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/HydraulicSystem/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HydraulicSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HydraulicSystemDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<HydraulicSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HydraulicSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HydraulicSystem/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<HydraulicSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/HydraulicSystem/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HydraulicSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HydraulicSystemDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HydraulicSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HydraulicSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param structureId (optional) 
     * @param serviceId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, structureId: number | undefined, serviceId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<HydraulicSystemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/HydraulicSystem/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HydraulicSystemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HydraulicSystemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<HydraulicSystemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HydraulicSystemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class InappropriateTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InappropriateType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class IncomeAllowanceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateIncomeAllowanceDto | undefined): Observable<IncomeAllowanceDto> {
        let url_ = this.baseUrl + "/api/services/app/IncomeAllowance/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncomeAllowanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncomeAllowanceDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<IncomeAllowanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncomeAllowanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateIncomeAllowanceDto | undefined): Observable<IncomeAllowanceDto> {
        let url_ = this.baseUrl + "/api/services/app/IncomeAllowance/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncomeAllowanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncomeAllowanceDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<IncomeAllowanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncomeAllowanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IncomeAllowance/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<IncomeAllowanceDto> {
        let url_ = this.baseUrl + "/api/services/app/IncomeAllowance/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncomeAllowanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncomeAllowanceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<IncomeAllowanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncomeAllowanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<IncomeAllowanceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/IncomeAllowance/GetAll?";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IncomeAllowanceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IncomeAllowanceDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<IncomeAllowanceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IncomeAllowanceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class InformationAccreditationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateInformationAccreditationDto | undefined): Observable<InformationAccreditationDto> {
        let url_ = this.baseUrl + "/api/services/app/InformationAccreditation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InformationAccreditationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InformationAccreditationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<InformationAccreditationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InformationAccreditationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateInformationAccreditationDto | undefined): Observable<InformationAccreditationDto> {
        let url_ = this.baseUrl + "/api/services/app/InformationAccreditation/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InformationAccreditationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InformationAccreditationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<InformationAccreditationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InformationAccreditationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InformationAccreditation/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<InformationAccreditationDto> {
        let url_ = this.baseUrl + "/api/services/app/InformationAccreditation/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InformationAccreditationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InformationAccreditationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InformationAccreditationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InformationAccreditationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialHealthRecordId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(socialHealthRecordId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<InformationAccreditationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InformationAccreditation/GetAll?";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "SocialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InformationAccreditationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InformationAccreditationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InformationAccreditationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InformationAccreditationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class InputCardRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @param serviceUserId (optional) 
     * @return Success
     */
    downloadInputCardRecordPdf(id: number | undefined, serviceUserId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/InputCardRecord/DownloadInputCardRecordPdf?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (serviceUserId === null)
            throw new globalThis.Error("The parameter 'serviceUserId' cannot be null.");
        else if (serviceUserId !== undefined)
            url_ += "serviceUserId=" + encodeURIComponent("" + serviceUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadInputCardRecordPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadInputCardRecordPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadInputCardRecordPdf(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateInputCardRecordDto | undefined): Observable<InputCardRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/InputCardRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InputCardRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InputCardRecordDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<InputCardRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InputCardRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InputCardRecord/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<InputCardRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/InputCardRecord/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InputCardRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InputCardRecordDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InputCardRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InputCardRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialHealthRecordId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(socialHealthRecordId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<InputCardRecordDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InputCardRecord/GetAll?";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "SocialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InputCardRecordDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InputCardRecordDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InputCardRecordDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InputCardRecordDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class IntegratedRehabilitationPlanRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateIntegratedRehabilitationPlanRecordDto | undefined): Observable<IntegratedRehabilitationPlanRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/IntegratedRehabilitationPlanRecord/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegratedRehabilitationPlanRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegratedRehabilitationPlanRecordDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<IntegratedRehabilitationPlanRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegratedRehabilitationPlanRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateIntegratedRehabilitationPlanRecordDto | undefined): Observable<IntegratedRehabilitationPlanRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/IntegratedRehabilitationPlanRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegratedRehabilitationPlanRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegratedRehabilitationPlanRecordDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<IntegratedRehabilitationPlanRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegratedRehabilitationPlanRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IntegratedRehabilitationPlanRecord/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<IntegratedRehabilitationPlanRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/IntegratedRehabilitationPlanRecord/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegratedRehabilitationPlanRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegratedRehabilitationPlanRecordDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<IntegratedRehabilitationPlanRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegratedRehabilitationPlanRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param obsevationGridId (optional) 
     * @param socialHealthRecordId (optional) 
     * @param scopeObservationGridId (optional) 
     * @param createdAfter (optional) 
     * @param createdBefore (optional) 
     * @param isFinalReport (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(obsevationGridId: number | undefined, socialHealthRecordId: number | undefined, scopeObservationGridId: number | undefined, createdAfter: moment.Moment | undefined, createdBefore: moment.Moment | undefined, isFinalReport: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<IntegratedRehabilitationPlanRecordDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/IntegratedRehabilitationPlanRecord/GetAll?";
        if (obsevationGridId === null)
            throw new globalThis.Error("The parameter 'obsevationGridId' cannot be null.");
        else if (obsevationGridId !== undefined)
            url_ += "ObsevationGridId=" + encodeURIComponent("" + obsevationGridId) + "&";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "SocialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        if (scopeObservationGridId === null)
            throw new globalThis.Error("The parameter 'scopeObservationGridId' cannot be null.");
        else if (scopeObservationGridId !== undefined)
            url_ += "ScopeObservationGridId=" + encodeURIComponent("" + scopeObservationGridId) + "&";
        if (createdAfter === null)
            throw new globalThis.Error("The parameter 'createdAfter' cannot be null.");
        else if (createdAfter !== undefined)
            url_ += "CreatedAfter=" + encodeURIComponent(createdAfter ? "" + createdAfter.toISOString() : "") + "&";
        if (createdBefore === null)
            throw new globalThis.Error("The parameter 'createdBefore' cannot be null.");
        else if (createdBefore !== undefined)
            url_ += "CreatedBefore=" + encodeURIComponent(createdBefore ? "" + createdBefore.toISOString() : "") + "&";
        if (isFinalReport === null)
            throw new globalThis.Error("The parameter 'isFinalReport' cannot be null.");
        else if (isFinalReport !== undefined)
            url_ += "IsFinalReport=" + encodeURIComponent("" + isFinalReport) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegratedRehabilitationPlanRecordDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegratedRehabilitationPlanRecordDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<IntegratedRehabilitationPlanRecordDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegratedRehabilitationPlanRecordDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class InterviewParticipantsRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateInterviewParticipantsRecordDto | undefined): Observable<InterviewParticipantsRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/InterviewParticipantsRecord/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InterviewParticipantsRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InterviewParticipantsRecordDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<InterviewParticipantsRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InterviewParticipantsRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateInterviewParticipantsRecordDto | undefined): Observable<InterviewParticipantsRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/InterviewParticipantsRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InterviewParticipantsRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InterviewParticipantsRecordDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<InterviewParticipantsRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InterviewParticipantsRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InterviewParticipantsRecord/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<InterviewParticipantsRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/InterviewParticipantsRecord/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InterviewParticipantsRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InterviewParticipantsRecordDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<InterviewParticipantsRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InterviewParticipantsRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialHealthRecordId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(socialHealthRecordId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<InterviewParticipantsRecordDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/InterviewParticipantsRecord/GetAll?";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "SocialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InterviewParticipantsRecordDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InterviewParticipantsRecordDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<InterviewParticipantsRecordDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InterviewParticipantsRecordDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class KinshipDegreeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/KinshipDegree/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LaboratoryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateDictionaryDto | undefined): Observable<DictionaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Laboratory/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DictionaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DictionaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Laboratory/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LeaksControlServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LeaksControl/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LifelineSystemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param structureId (optional) 
     * @param serviceId (optional) 
     * @return Success
     */
    getAllBase(structureId: number | undefined, serviceId: number | undefined): Observable<LifelineSystemBaseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LifelineSystem/GetAllBase?";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LifelineSystemBaseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LifelineSystemBaseDto[]>;
        }));
    }

    protected processGetAllBase(response: HttpResponseBase): Observable<LifelineSystemBaseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LifelineSystemBaseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateLifelineSystemDto | undefined): Observable<LifelineSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/LifelineSystem/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LifelineSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LifelineSystemDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<LifelineSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LifelineSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateLifelineSystemDto | undefined): Observable<LifelineSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/LifelineSystem/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LifelineSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LifelineSystemDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<LifelineSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LifelineSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LifelineSystem/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<LifelineSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/LifelineSystem/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LifelineSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LifelineSystemDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<LifelineSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LifelineSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param structureId (optional) 
     * @param serviceId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, structureId: number | undefined, serviceId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<LifelineSystemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/LifelineSystem/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LifelineSystemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LifelineSystemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LifelineSystemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LifelineSystemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LinkedServiceDiaryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setForUser(body: SetLinkedServiceDiariesDto | undefined): Observable<LinkedServiceDiaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LinkedServiceDiary/SetForUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetForUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LinkedServiceDiaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LinkedServiceDiaryDto[]>;
        }));
    }

    protected processSetForUser(response: HttpResponseBase): Observable<LinkedServiceDiaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LinkedServiceDiaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param viewingServiceId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(userId: number | undefined, viewingServiceId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<LinkedServiceDiaryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/LinkedServiceDiary/GetAll?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (viewingServiceId === null)
            throw new globalThis.Error("The parameter 'viewingServiceId' cannot be null.");
        else if (viewingServiceId !== undefined)
            url_ += "ViewingServiceId=" + encodeURIComponent("" + viewingServiceId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LinkedServiceDiaryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LinkedServiceDiaryDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<LinkedServiceDiaryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LinkedServiceDiaryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LocationTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LocationType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class LongTermObjectiveServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/LongTermObjective/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MaintenanceEventServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMaintenanceEventDto | undefined): Observable<MaintenanceEventDto> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceEvent/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceEventDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MaintenanceEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaintenanceEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMaintenanceEventDto | undefined): Observable<MaintenanceEventDto> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceEvent/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceEventDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MaintenanceEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaintenanceEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceEvent/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MaintenanceEventDto> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceEvent/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceEventDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MaintenanceEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaintenanceEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param vehicleId (optional) 
     * @param eventTypeId (optional) 
     * @param provider (optional) 
     * @param date (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(vehicleId: number | undefined, eventTypeId: number | undefined, provider: string | undefined, date: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MaintenanceEventDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceEvent/GetAll?";
        if (vehicleId === null)
            throw new globalThis.Error("The parameter 'vehicleId' cannot be null.");
        else if (vehicleId !== undefined)
            url_ += "VehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        if (eventTypeId === null)
            throw new globalThis.Error("The parameter 'eventTypeId' cannot be null.");
        else if (eventTypeId !== undefined)
            url_ += "EventTypeId=" + encodeURIComponent("" + eventTypeId) + "&";
        if (provider === null)
            throw new globalThis.Error("The parameter 'provider' cannot be null.");
        else if (provider !== undefined)
            url_ += "Provider=" + encodeURIComponent("" + provider) + "&";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaintenanceEventDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaintenanceEventDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MaintenanceEventDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaintenanceEventDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MaintenanceTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MaintenanceType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MeasurementScaleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MeasurementScale/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MentalStateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MentalState/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MissedProcedureTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MissedProcedureType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MonitoringRestraintRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @param signatureTypeId (optional) 
     * @return Success
     */
    sign(id: number | undefined, signatureTypeId: number | undefined): Observable<MonitoringRestraintConfirmationSignatureDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MonitoringRestraintRecord/Sign?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (signatureTypeId === null)
            throw new globalThis.Error("The parameter 'signatureTypeId' cannot be null.");
        else if (signatureTypeId !== undefined)
            url_ += "signatureTypeId=" + encodeURIComponent("" + signatureTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonitoringRestraintConfirmationSignatureDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonitoringRestraintConfirmationSignatureDto[]>;
        }));
    }

    protected processSign(response: HttpResponseBase): Observable<MonitoringRestraintConfirmationSignatureDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MonitoringRestraintConfirmationSignatureDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMonitoringRestraintRecordDto | undefined): Observable<MonitoringRestraintRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/MonitoringRestraintRecord/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonitoringRestraintRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonitoringRestraintRecordDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MonitoringRestraintRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonitoringRestraintRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMonitoringRestraintRecordDto | undefined): Observable<MonitoringRestraintRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/MonitoringRestraintRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonitoringRestraintRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonitoringRestraintRecordDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MonitoringRestraintRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonitoringRestraintRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MonitoringRestraintRecord/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MonitoringRestraintRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/MonitoringRestraintRecord/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonitoringRestraintRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonitoringRestraintRecordDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MonitoringRestraintRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonitoringRestraintRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialHealthRecordId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(socialHealthRecordId: number | undefined, fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MonitoringRestraintRecordItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MonitoringRestraintRecord/GetAll?";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "SocialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonitoringRestraintRecordItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonitoringRestraintRecordItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MonitoringRestraintRecordItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonitoringRestraintRecordItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MonthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Month/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MonthlyRehabilitationProgramNoteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    confirm(id: number | undefined): Observable<MonthlyRehabilitationProgramNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyRehabilitationProgramNote/Confirm?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyRehabilitationProgramNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyRehabilitationProgramNoteDto>;
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<MonthlyRehabilitationProgramNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyRehabilitationProgramNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    confirmMany(body: number[] | undefined): Observable<MonthlyRehabilitationProgramNoteDto[]> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyRehabilitationProgramNote/ConfirmMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyRehabilitationProgramNoteDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyRehabilitationProgramNoteDto[]>;
        }));
    }

    protected processConfirmMany(response: HttpResponseBase): Observable<MonthlyRehabilitationProgramNoteDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MonthlyRehabilitationProgramNoteDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMonthlyRehabilitationProgramNoteDto | undefined): Observable<MonthlyRehabilitationProgramNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyRehabilitationProgramNote/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyRehabilitationProgramNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyRehabilitationProgramNoteDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MonthlyRehabilitationProgramNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyRehabilitationProgramNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMonthlyRehabilitationProgramNoteDto | undefined): Observable<MonthlyRehabilitationProgramNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyRehabilitationProgramNote/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyRehabilitationProgramNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyRehabilitationProgramNoteDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MonthlyRehabilitationProgramNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyRehabilitationProgramNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyRehabilitationProgramNote/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MonthlyRehabilitationProgramNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyRehabilitationProgramNote/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyRehabilitationProgramNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyRehabilitationProgramNoteDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MonthlyRehabilitationProgramNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyRehabilitationProgramNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param monthlyRehabilitationProgramRecordId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(monthlyRehabilitationProgramRecordId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MonthlyRehabilitationProgramNoteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyRehabilitationProgramNote/GetAll?";
        if (monthlyRehabilitationProgramRecordId === null)
            throw new globalThis.Error("The parameter 'monthlyRehabilitationProgramRecordId' cannot be null.");
        else if (monthlyRehabilitationProgramRecordId !== undefined)
            url_ += "MonthlyRehabilitationProgramRecordId=" + encodeURIComponent("" + monthlyRehabilitationProgramRecordId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyRehabilitationProgramNoteDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyRehabilitationProgramNoteDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MonthlyRehabilitationProgramNoteDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyRehabilitationProgramNoteDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MonthlyRehabilitationProgramRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMonthlyRehabilitationProgramRecordDto | undefined): Observable<MonthlyRehabilitationProgramRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyRehabilitationProgramRecord/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyRehabilitationProgramRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyRehabilitationProgramRecordDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MonthlyRehabilitationProgramRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyRehabilitationProgramRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMonthlyRehabilitationProgramRecordDto | undefined): Observable<MonthlyRehabilitationProgramRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyRehabilitationProgramRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyRehabilitationProgramRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyRehabilitationProgramRecordDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MonthlyRehabilitationProgramRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyRehabilitationProgramRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyRehabilitationProgramRecord/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MonthlyRehabilitationProgramRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyRehabilitationProgramRecord/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyRehabilitationProgramRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyRehabilitationProgramRecordDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MonthlyRehabilitationProgramRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyRehabilitationProgramRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialHealthRecordId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(socialHealthRecordId: number | undefined, fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MonthlyRehabilitationProgramRecordItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyRehabilitationProgramRecord/GetAll?";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "SocialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyRehabilitationProgramRecordItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyRehabilitationProgramRecordItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MonthlyRehabilitationProgramRecordItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyRehabilitationProgramRecordItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class MonthlyRehabilitationProgramTreatmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateMonthlyRehabilitationProgramTreatmentDto | undefined): Observable<MonthlyRehabilitationProgramTreatmentDto> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyRehabilitationProgramTreatment/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyRehabilitationProgramTreatmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyRehabilitationProgramTreatmentDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<MonthlyRehabilitationProgramTreatmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyRehabilitationProgramTreatmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateMonthlyRehabilitationProgramTreatmentDto | undefined): Observable<MonthlyRehabilitationProgramTreatmentDto> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyRehabilitationProgramTreatment/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyRehabilitationProgramTreatmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyRehabilitationProgramTreatmentDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<MonthlyRehabilitationProgramTreatmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyRehabilitationProgramTreatmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyRehabilitationProgramTreatment/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<MonthlyRehabilitationProgramTreatmentDto> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyRehabilitationProgramTreatment/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyRehabilitationProgramTreatmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyRehabilitationProgramTreatmentDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MonthlyRehabilitationProgramTreatmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyRehabilitationProgramTreatmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param monthlyRehabilitationProgramRecordId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(monthlyRehabilitationProgramRecordId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<MonthlyRehabilitationProgramTreatmentDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/MonthlyRehabilitationProgramTreatment/GetAll?";
        if (monthlyRehabilitationProgramRecordId === null)
            throw new globalThis.Error("The parameter 'monthlyRehabilitationProgramRecordId' cannot be null.");
        else if (monthlyRehabilitationProgramRecordId !== undefined)
            url_ += "MonthlyRehabilitationProgramRecordId=" + encodeURIComponent("" + monthlyRehabilitationProgramRecordId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MonthlyRehabilitationProgramTreatmentDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MonthlyRehabilitationProgramTreatmentDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<MonthlyRehabilitationProgramTreatmentDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MonthlyRehabilitationProgramTreatmentDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class NursingSphereSyndromeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/NursingSphereSyndrome/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ObjectiveServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateObjectiveDto | undefined): Observable<ObjectiveDto> {
        let url_ = this.baseUrl + "/api/services/app/Objective/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObjectiveDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObjectiveDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ObjectiveDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjectiveDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateObjectiveDto | undefined): Observable<ObjectiveDto> {
        let url_ = this.baseUrl + "/api/services/app/Objective/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObjectiveDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObjectiveDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ObjectiveDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjectiveDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Objective/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ObjectiveDto> {
        let url_ = this.baseUrl + "/api/services/app/Objective/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObjectiveDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObjectiveDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ObjectiveDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjectiveDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param integratedRehabilitationPlanRecordId (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(integratedRehabilitationPlanRecordId: number | undefined, sorting: string | undefined): Observable<ObjectiveDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Objective/GetAll?";
        if (integratedRehabilitationPlanRecordId === null)
            throw new globalThis.Error("The parameter 'integratedRehabilitationPlanRecordId' cannot be null.");
        else if (integratedRehabilitationPlanRecordId !== undefined)
            url_ += "IntegratedRehabilitationPlanRecordId=" + encodeURIComponent("" + integratedRehabilitationPlanRecordId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObjectiveDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObjectiveDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ObjectiveDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjectiveDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ObjectiveCollectionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateDictionaryDto | undefined): Observable<DictionaryDto> {
        let url_ = this.baseUrl + "/api/services/app/ObjectiveCollection/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DictionaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DictionaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceDataCollectionId (optional) 
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceDataCollectionId: number | undefined, keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ObjectiveCollection/GetAll?";
        if (serviceDataCollectionId === null)
            throw new globalThis.Error("The parameter 'serviceDataCollectionId' cannot be null.");
        else if (serviceDataCollectionId !== undefined)
            url_ += "ServiceDataCollectionId=" + encodeURIComponent("" + serviceDataCollectionId) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ObjectiveResultServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateObjectiveResultDto | undefined): Observable<ObjectiveResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ObjectiveResult/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObjectiveResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObjectiveResultDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ObjectiveResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjectiveResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateObjectiveResultDto | undefined): Observable<ObjectiveResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ObjectiveResult/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObjectiveResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObjectiveResultDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ObjectiveResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjectiveResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ObjectiveResult/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ObjectiveResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ObjectiveResult/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObjectiveResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObjectiveResultDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ObjectiveResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjectiveResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: ObjectiveResultGetAllInput | undefined): Observable<ObjectiveResultDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ObjectiveResult/GetAll?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObjectiveResultDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObjectiveResultDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ObjectiveResultDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjectiveResultDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ObjectivesRehabilitationRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @param isSecondSignature (optional) 
     * @return Success
     */
    confirm(id: number | undefined, isSecondSignature: boolean | undefined): Observable<ObjectivesRehabilitationRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/ObjectivesRehabilitationRecord/Confirm?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isSecondSignature === null)
            throw new globalThis.Error("The parameter 'isSecondSignature' cannot be null.");
        else if (isSecondSignature !== undefined)
            url_ += "isSecondSignature=" + encodeURIComponent("" + isSecondSignature) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObjectivesRehabilitationRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObjectivesRehabilitationRecordDto>;
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<ObjectivesRehabilitationRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjectivesRehabilitationRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isSecondSignature (optional) 
     * @param body (optional) 
     * @return Success
     */
    confirmMany(isSecondSignature: boolean | undefined, body: number[] | undefined): Observable<ObjectivesRehabilitationRecordDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ObjectivesRehabilitationRecord/ConfirmMany?";
        if (isSecondSignature === null)
            throw new globalThis.Error("The parameter 'isSecondSignature' cannot be null.");
        else if (isSecondSignature !== undefined)
            url_ += "isSecondSignature=" + encodeURIComponent("" + isSecondSignature) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObjectivesRehabilitationRecordDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObjectivesRehabilitationRecordDto[]>;
        }));
    }

    protected processConfirmMany(response: HttpResponseBase): Observable<ObjectivesRehabilitationRecordDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObjectivesRehabilitationRecordDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateObjectivesRehabilitationRecordDto | undefined): Observable<ObjectivesRehabilitationRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/ObjectivesRehabilitationRecord/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObjectivesRehabilitationRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObjectivesRehabilitationRecordDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ObjectivesRehabilitationRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjectivesRehabilitationRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateObjectivesRehabilitationRecordDto | undefined): Observable<ObjectivesRehabilitationRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/ObjectivesRehabilitationRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObjectivesRehabilitationRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObjectivesRehabilitationRecordDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ObjectivesRehabilitationRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjectivesRehabilitationRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ObjectivesRehabilitationRecord/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ObjectivesRehabilitationRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/ObjectivesRehabilitationRecord/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObjectivesRehabilitationRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObjectivesRehabilitationRecordDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ObjectivesRehabilitationRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjectivesRehabilitationRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialHealthRecordId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(socialHealthRecordId: number | undefined, fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ObjectivesRehabilitationRecordItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ObjectivesRehabilitationRecord/GetAll?";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "SocialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObjectivesRehabilitationRecordItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObjectivesRehabilitationRecordItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ObjectivesRehabilitationRecordItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObjectivesRehabilitationRecordItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ObjectiveTimeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ObjectiveTime/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ObservationGridServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param socialHealthRecordId (optional) 
     * @param categoryObservationGridId (optional) 
     * @return Success
     */
    getCategoryResponsesHistory(socialHealthRecordId: number | undefined, categoryObservationGridId: number | undefined): Observable<ObservationGridCategoryHistoryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ObservationGrid/GetCategoryResponsesHistory?";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "SocialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        if (categoryObservationGridId === null)
            throw new globalThis.Error("The parameter 'categoryObservationGridId' cannot be null.");
        else if (categoryObservationGridId !== undefined)
            url_ += "CategoryObservationGridId=" + encodeURIComponent("" + categoryObservationGridId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategoryResponsesHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoryResponsesHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationGridCategoryHistoryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationGridCategoryHistoryDto[]>;
        }));
    }

    protected processGetCategoryResponsesHistory(response: HttpResponseBase): Observable<ObservationGridCategoryHistoryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationGridCategoryHistoryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    confirm(id: number | undefined): Observable<ObservationGridDto> {
        let url_ = this.baseUrl + "/api/services/app/ObservationGrid/Confirm?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationGridDto>;
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<ObservationGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateObservationGrid | undefined): Observable<ObservationGridDto> {
        let url_ = this.baseUrl + "/api/services/app/ObservationGrid/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationGridDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ObservationGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateObservationGrid | undefined): Observable<ObservationGridDto> {
        let url_ = this.baseUrl + "/api/services/app/ObservationGrid/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationGridDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ObservationGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ObservationGrid/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ObservationGridDto> {
        let url_ = this.baseUrl + "/api/services/app/ObservationGrid/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationGridDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ObservationGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialHealthRecordId (optional) 
     * @param date (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(socialHealthRecordId: number | undefined, date: moment.Moment | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ObservationGridItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ObservationGrid/GetAll?";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "SocialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationGridItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationGridItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ObservationGridItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationGridItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ObservationGridSectionOperationPermissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAll(body: CreateObservationGridSectionOperatorPermissionDto | undefined): Observable<ObservationGridSectionOperatorPermissionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ObservationGridSectionOperationPermission/CreateAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationGridSectionOperatorPermissionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationGridSectionOperatorPermissionDto[]>;
        }));
    }

    protected processCreateAll(response: HttpResponseBase): Observable<ObservationGridSectionOperatorPermissionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ObservationGridSectionOperatorPermissionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param observationGridId (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(observationGridId: number | undefined, sorting: string | undefined): Observable<ObservationGridSectionOperatorPermissionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ObservationGridSectionOperationPermission/GetAll?";
        if (observationGridId === null)
            throw new globalThis.Error("The parameter 'observationGridId' cannot be null.");
        else if (observationGridId !== undefined)
            url_ += "ObservationGridId=" + encodeURIComponent("" + observationGridId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ObservationGridSectionOperatorPermissionDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ObservationGridSectionOperatorPermissionDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ObservationGridSectionOperatorPermissionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ObservationGridSectionOperatorPermissionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OccupationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateOccupationDto | undefined): Observable<OccupationDto> {
        let url_ = this.baseUrl + "/api/services/app/Occupation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OccupationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OccupationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OccupationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OccupationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOccupationDto | undefined): Observable<OccupationDto> {
        let url_ = this.baseUrl + "/api/services/app/Occupation/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OccupationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OccupationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OccupationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OccupationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Occupation/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<OccupationDto> {
        let url_ = this.baseUrl + "/api/services/app/Occupation/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OccupationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OccupationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OccupationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OccupationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param inputCardRecordId (optional) 
     * @param isPaged (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(inputCardRecordId: number | undefined, isPaged: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OccupationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Occupation/GetAll?";
        if (inputCardRecordId === null)
            throw new globalThis.Error("The parameter 'inputCardRecordId' cannot be null.");
        else if (inputCardRecordId !== undefined)
            url_ += "InputCardRecordId=" + encodeURIComponent("" + inputCardRecordId) + "&";
        if (isPaged === null)
            throw new globalThis.Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OccupationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OccupationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OccupationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OccupationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OperationalAuthorizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OperationalAuthorization/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OrganizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadExcel(body: OrganizationGetAllInput | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/Organization/DownloadExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadExcel(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateOrganizationDto | undefined): Observable<OrganizationDto> {
        let url_ = this.baseUrl + "/api/services/app/Organization/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OrganizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOrganizationDto | undefined): Observable<OrganizationDto> {
        let url_ = this.baseUrl + "/api/services/app/Organization/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OrganizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Organization/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<OrganizationDto> {
        let url_ = this.baseUrl + "/api/services/app/Organization/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OrganizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OrganizationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Organization/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OrganizationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OtherEventTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OtherEventType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OtherReferenceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateOtherReferenceDto | undefined): Observable<OtherReferenceDto> {
        let url_ = this.baseUrl + "/api/services/app/OtherReference/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OtherReferenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OtherReferenceDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<OtherReferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OtherReferenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateOtherReferenceDto | undefined): Observable<OtherReferenceDto> {
        let url_ = this.baseUrl + "/api/services/app/OtherReference/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OtherReferenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OtherReferenceDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<OtherReferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OtherReferenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OtherReference/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<OtherReferenceDto> {
        let url_ = this.baseUrl + "/api/services/app/OtherReference/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OtherReferenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OtherReferenceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<OtherReferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OtherReferenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param inputCardRecordId (optional) 
     * @param isPaged (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(inputCardRecordId: number | undefined, isPaged: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<OtherReferenceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/OtherReference/GetAll?";
        if (inputCardRecordId === null)
            throw new globalThis.Error("The parameter 'inputCardRecordId' cannot be null.");
        else if (inputCardRecordId !== undefined)
            url_ += "InputCardRecordId=" + encodeURIComponent("" + inputCardRecordId) + "&";
        if (isPaged === null)
            throw new globalThis.Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OtherReferenceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OtherReferenceDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<OtherReferenceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OtherReferenceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OutcomeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Outcome/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OutcomeReductionFactorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OutcomeReductionFactor/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OwnerShipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/OwnerShip/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class Patient118RecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    confirm(id: number | undefined): Observable<Patient118RecordDto> {
        let url_ = this.baseUrl + "/api/services/app/Patient118Record/Confirm?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Patient118RecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Patient118RecordDto>;
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<Patient118RecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Patient118RecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    confirmMany(body: number[] | undefined): Observable<Patient118RecordDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Patient118Record/ConfirmMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Patient118RecordDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Patient118RecordDto[]>;
        }));
    }

    protected processConfirmMany(response: HttpResponseBase): Observable<Patient118RecordDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Patient118RecordDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePatient118RecordDto | undefined): Observable<Patient118RecordDto> {
        let url_ = this.baseUrl + "/api/services/app/Patient118Record/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Patient118RecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Patient118RecordDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<Patient118RecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Patient118RecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePatient118RecordDto | undefined): Observable<Patient118RecordDto> {
        let url_ = this.baseUrl + "/api/services/app/Patient118Record/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Patient118RecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Patient118RecordDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<Patient118RecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Patient118RecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Patient118Record/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<Patient118RecordDto> {
        let url_ = this.baseUrl + "/api/services/app/Patient118Record/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Patient118RecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Patient118RecordDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Patient118RecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Patient118RecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param socialHealtRecordId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, socialHealtRecordId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<Patient118RecordDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Patient118Record/GetAll?";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (socialHealtRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealtRecordId' cannot be null.");
        else if (socialHealtRecordId !== undefined)
            url_ += "SocialHealtRecordId=" + encodeURIComponent("" + socialHealtRecordId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Patient118RecordDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Patient118RecordDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Patient118RecordDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Patient118RecordDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PatientFactorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PatientFactor/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PerformanceTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PerformanceType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PersonalAutonomyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePersonalAutonomyDto | undefined): Observable<PersonalAutonomyDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonalAutonomy/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonalAutonomyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonalAutonomyDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PersonalAutonomyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonalAutonomyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePersonalAutonomyDto | undefined): Observable<PersonalAutonomyDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonalAutonomy/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonalAutonomyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonalAutonomyDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PersonalAutonomyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonalAutonomyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonalAutonomy/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PersonalAutonomyDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonalAutonomy/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonalAutonomyDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonalAutonomyDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PersonalAutonomyDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonalAutonomyDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PersonalAutonomyDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonalAutonomy/GetAll?";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonalAutonomyDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonalAutonomyDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PersonalAutonomyDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonalAutonomyDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PersonalDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePersonalDataDto | undefined): Observable<PersonalDataDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonalData/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonalDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonalDataDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PersonalDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonalDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePersonalDataDto | undefined): Observable<PersonalDataDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonalData/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonalDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonalDataDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PersonalDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonalDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonalData/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PersonalDataDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonalData/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonalDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonalDataDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PersonalDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonalDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param inputCardRecordId (optional) 
     * @param isPaged (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(inputCardRecordId: number | undefined, isPaged: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PersonalDataDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonalData/GetAll?";
        if (inputCardRecordId === null)
            throw new globalThis.Error("The parameter 'inputCardRecordId' cannot be null.");
        else if (inputCardRecordId !== undefined)
            url_ += "InputCardRecordId=" + encodeURIComponent("" + inputCardRecordId) + "&";
        if (isPaged === null)
            throw new globalThis.Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonalDataDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonalDataDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PersonalDataDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonalDataDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PersonalDataFamilyMemberServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePersonalDataFamilyMemberDto | undefined): Observable<PersonalDataFamilyMemberDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonalDataFamilyMember/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonalDataFamilyMemberDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonalDataFamilyMemberDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PersonalDataFamilyMemberDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonalDataFamilyMemberDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePersonalDataFamilyMemberDto | undefined): Observable<PersonalDataFamilyMemberDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonalDataFamilyMember/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonalDataFamilyMemberDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonalDataFamilyMemberDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PersonalDataFamilyMemberDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonalDataFamilyMemberDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PersonalDataFamilyMember/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PersonalDataFamilyMemberDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonalDataFamilyMember/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonalDataFamilyMemberDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonalDataFamilyMemberDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PersonalDataFamilyMemberDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonalDataFamilyMemberDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param inputCardRecordId (optional) 
     * @param isPaged (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(inputCardRecordId: number | undefined, isPaged: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PersonalDataFamilyMemberDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PersonalDataFamilyMember/GetAll?";
        if (inputCardRecordId === null)
            throw new globalThis.Error("The parameter 'inputCardRecordId' cannot be null.");
        else if (inputCardRecordId !== undefined)
            url_ += "InputCardRecordId=" + encodeURIComponent("" + inputCardRecordId) + "&";
        if (isPaged === null)
            throw new globalThis.Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PersonalDataFamilyMemberDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PersonalDataFamilyMemberDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PersonalDataFamilyMemberDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonalDataFamilyMemberDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PersonalHygieneModeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PersonalHygieneMode/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PersonPresentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PersonPresent/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PhotovoltaicSystemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param structureId (optional) 
     * @param serviceId (optional) 
     * @return Success
     */
    getAllBase(structureId: number | undefined, serviceId: number | undefined): Observable<PhotovoltaicSystemBaseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PhotovoltaicSystem/GetAllBase?";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhotovoltaicSystemBaseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhotovoltaicSystemBaseDto[]>;
        }));
    }

    protected processGetAllBase(response: HttpResponseBase): Observable<PhotovoltaicSystemBaseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PhotovoltaicSystemBaseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdatePhotovoltaicSystemDto | undefined): Observable<PhotovoltaicSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/PhotovoltaicSystem/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhotovoltaicSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhotovoltaicSystemDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<PhotovoltaicSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhotovoltaicSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePhotovoltaicSystemDto | undefined): Observable<PhotovoltaicSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/PhotovoltaicSystem/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhotovoltaicSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhotovoltaicSystemDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<PhotovoltaicSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhotovoltaicSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PhotovoltaicSystem/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<PhotovoltaicSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/PhotovoltaicSystem/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhotovoltaicSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhotovoltaicSystemDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PhotovoltaicSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhotovoltaicSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param structureId (optional) 
     * @param serviceId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, structureId: number | undefined, serviceId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PhotovoltaicSystemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/PhotovoltaicSystem/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PhotovoltaicSystemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PhotovoltaicSystemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PhotovoltaicSystemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PhotovoltaicSystemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PhysiotherapySphereSyndromeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PhysiotherapySphereSyndrome/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PlaceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreatePlaceDto | undefined): Observable<DictionaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Place/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DictionaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DictionaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceId: number | undefined, keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Place/GetAll?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PlantTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlantType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PresenceSoresServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PresenceSores/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProcedureDelayServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProcedureDelay/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProtectionMeasureServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateProtectionMeasureDto | undefined): Observable<ProtectionMeasureDto> {
        let url_ = this.baseUrl + "/api/services/app/ProtectionMeasure/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProtectionMeasureDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProtectionMeasureDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProtectionMeasureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProtectionMeasureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateProtectionMeasureDto | undefined): Observable<ProtectionMeasureDto> {
        let url_ = this.baseUrl + "/api/services/app/ProtectionMeasure/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProtectionMeasureDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProtectionMeasureDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ProtectionMeasureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProtectionMeasureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ProtectionMeasure/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ProtectionMeasureDto> {
        let url_ = this.baseUrl + "/api/services/app/ProtectionMeasure/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProtectionMeasureDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProtectionMeasureDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProtectionMeasureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProtectionMeasureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ProtectionMeasureDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ProtectionMeasure/GetAll?";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProtectionMeasureDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProtectionMeasureDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ProtectionMeasureDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProtectionMeasureDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProvisionTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ProvisionType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PsychosocialSphereSyndromeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PsychosocialSphereSyndrome/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class QualificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateQualificationDto | undefined): Observable<DictionaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Qualification/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DictionaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DictionaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Qualification/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ReconciliationInformationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationInformation/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ReconciliationPharmacologicalRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param existingRecordId (optional) 
     * @return Success
     */
    createNewReconciliationFromExisting(existingRecordId: number | undefined): Observable<ReconciliationPharmacologicalRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalRecord/CreateNewReconciliationFromExisting?";
        if (existingRecordId === null)
            throw new globalThis.Error("The parameter 'existingRecordId' cannot be null.");
        else if (existingRecordId !== undefined)
            url_ += "existingRecordId=" + encodeURIComponent("" + existingRecordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNewReconciliationFromExisting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNewReconciliationFromExisting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReconciliationPharmacologicalRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReconciliationPharmacologicalRecordDto>;
        }));
    }

    protected processCreateNewReconciliationFromExisting(response: HttpResponseBase): Observable<ReconciliationPharmacologicalRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReconciliationPharmacologicalRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reconciliationPharmacologicalRecordId (optional) 
     * @param reconciliationPharmacologicalTypeId (optional) 
     * @return Success
     */
    sign(reconciliationPharmacologicalRecordId: number | undefined, reconciliationPharmacologicalTypeId: number | undefined): Observable<ConfirmationSignatureDto> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalRecord/Sign?";
        if (reconciliationPharmacologicalRecordId === null)
            throw new globalThis.Error("The parameter 'reconciliationPharmacologicalRecordId' cannot be null.");
        else if (reconciliationPharmacologicalRecordId !== undefined)
            url_ += "reconciliationPharmacologicalRecordId=" + encodeURIComponent("" + reconciliationPharmacologicalRecordId) + "&";
        if (reconciliationPharmacologicalTypeId === null)
            throw new globalThis.Error("The parameter 'reconciliationPharmacologicalTypeId' cannot be null.");
        else if (reconciliationPharmacologicalTypeId !== undefined)
            url_ += "reconciliationPharmacologicalTypeId=" + encodeURIComponent("" + reconciliationPharmacologicalTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ConfirmationSignatureDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ConfirmationSignatureDto>;
        }));
    }

    protected processSign(response: HttpResponseBase): Observable<ConfirmationSignatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfirmationSignatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateReconciliationPharmacologicalRecordDto | undefined): Observable<ReconciliationPharmacologicalRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalRecord/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReconciliationPharmacologicalRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReconciliationPharmacologicalRecordDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ReconciliationPharmacologicalRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReconciliationPharmacologicalRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateReconciliationPharmacologicalRecordDto | undefined): Observable<ReconciliationPharmacologicalRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReconciliationPharmacologicalRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReconciliationPharmacologicalRecordDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ReconciliationPharmacologicalRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReconciliationPharmacologicalRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalRecord/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ReconciliationPharmacologicalRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalRecord/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReconciliationPharmacologicalRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReconciliationPharmacologicalRecordDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ReconciliationPharmacologicalRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReconciliationPharmacologicalRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialHealtRecordId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(socialHealtRecordId: number | undefined, fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ReconciliationPharmacologicalRecordItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalRecord/GetAll?";
        if (socialHealtRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealtRecordId' cannot be null.");
        else if (socialHealtRecordId !== undefined)
            url_ += "SocialHealtRecordId=" + encodeURIComponent("" + socialHealtRecordId) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReconciliationPharmacologicalRecordItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReconciliationPharmacologicalRecordItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ReconciliationPharmacologicalRecordItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReconciliationPharmacologicalRecordItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ReconciliationPharmacologicalSomministrationRecognitionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    confirm(id: number | undefined): Observable<ReconciliationPharmacologicalSomministrationRecognitionDto> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalSomministrationRecognition/Confirm?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReconciliationPharmacologicalSomministrationRecognitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReconciliationPharmacologicalSomministrationRecognitionDto>;
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<ReconciliationPharmacologicalSomministrationRecognitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReconciliationPharmacologicalSomministrationRecognitionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    confirmMany(body: number[] | undefined): Observable<ReconciliationPharmacologicalSomministrationRecognitionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalSomministrationRecognition/ConfirmMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReconciliationPharmacologicalSomministrationRecognitionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReconciliationPharmacologicalSomministrationRecognitionDto[]>;
        }));
    }

    protected processConfirmMany(response: HttpResponseBase): Observable<ReconciliationPharmacologicalSomministrationRecognitionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReconciliationPharmacologicalSomministrationRecognitionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateReconciliationPharmacologicalSomministrationRecognitionDto | undefined): Observable<ReconciliationPharmacologicalSomministrationRecognitionDto> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalSomministrationRecognition/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReconciliationPharmacologicalSomministrationRecognitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReconciliationPharmacologicalSomministrationRecognitionDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ReconciliationPharmacologicalSomministrationRecognitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReconciliationPharmacologicalSomministrationRecognitionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateReconciliationPharmacologicalSomministrationRecognitionDto | undefined): Observable<ReconciliationPharmacologicalSomministrationRecognitionDto> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalSomministrationRecognition/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReconciliationPharmacologicalSomministrationRecognitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReconciliationPharmacologicalSomministrationRecognitionDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ReconciliationPharmacologicalSomministrationRecognitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReconciliationPharmacologicalSomministrationRecognitionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalSomministrationRecognition/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ReconciliationPharmacologicalSomministrationRecognitionDto> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalSomministrationRecognition/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReconciliationPharmacologicalSomministrationRecognitionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReconciliationPharmacologicalSomministrationRecognitionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ReconciliationPharmacologicalSomministrationRecognitionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReconciliationPharmacologicalSomministrationRecognitionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reconciliationPharmacologicalRecordId (optional) 
     * @return Success
     */
    getAll(reconciliationPharmacologicalRecordId: number | undefined): Observable<ReconciliationPharmacologicalSomministrationRecognitionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalSomministrationRecognition/GetAll?";
        if (reconciliationPharmacologicalRecordId === null)
            throw new globalThis.Error("The parameter 'reconciliationPharmacologicalRecordId' cannot be null.");
        else if (reconciliationPharmacologicalRecordId !== undefined)
            url_ += "ReconciliationPharmacologicalRecordId=" + encodeURIComponent("" + reconciliationPharmacologicalRecordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReconciliationPharmacologicalSomministrationRecognitionDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReconciliationPharmacologicalSomministrationRecognitionDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ReconciliationPharmacologicalSomministrationRecognitionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReconciliationPharmacologicalSomministrationRecognitionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ReconciliationPharmacologicalSomministrationReconciliationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    confirm(id: number | undefined): Observable<ReconciliationPharmacologicalSomministrationReconciliationDto> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalSomministrationReconciliation/Confirm?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReconciliationPharmacologicalSomministrationReconciliationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReconciliationPharmacologicalSomministrationReconciliationDto>;
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<ReconciliationPharmacologicalSomministrationReconciliationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReconciliationPharmacologicalSomministrationReconciliationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    confirmMany(body: number[] | undefined): Observable<ReconciliationPharmacologicalSomministrationReconciliationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalSomministrationReconciliation/ConfirmMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReconciliationPharmacologicalSomministrationReconciliationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReconciliationPharmacologicalSomministrationReconciliationDto[]>;
        }));
    }

    protected processConfirmMany(response: HttpResponseBase): Observable<ReconciliationPharmacologicalSomministrationReconciliationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReconciliationPharmacologicalSomministrationReconciliationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param recognitionId (optional) 
     * @return Success
     */
    getRecognitionCase(recognitionId: number | undefined): Observable<ReconciliationCaseDto> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalSomministrationReconciliation/GetRecognitionCase?";
        if (recognitionId === null)
            throw new globalThis.Error("The parameter 'recognitionId' cannot be null.");
        else if (recognitionId !== undefined)
            url_ += "recognitionId=" + encodeURIComponent("" + recognitionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecognitionCase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecognitionCase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReconciliationCaseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReconciliationCaseDto>;
        }));
    }

    protected processGetRecognitionCase(response: HttpResponseBase): Observable<ReconciliationCaseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReconciliationCaseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateReconciliationPharmacologicalSomministrationReconciliationDto | undefined): Observable<ReconciliationPharmacologicalSomministrationReconciliationDto> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalSomministrationReconciliation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReconciliationPharmacologicalSomministrationReconciliationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReconciliationPharmacologicalSomministrationReconciliationDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ReconciliationPharmacologicalSomministrationReconciliationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReconciliationPharmacologicalSomministrationReconciliationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateReconciliationPharmacologicalSomministrationReconciliationDto | undefined): Observable<ReconciliationPharmacologicalSomministrationReconciliationDto> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalSomministrationReconciliation/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReconciliationPharmacologicalSomministrationReconciliationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReconciliationPharmacologicalSomministrationReconciliationDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ReconciliationPharmacologicalSomministrationReconciliationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReconciliationPharmacologicalSomministrationReconciliationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalSomministrationReconciliation/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ReconciliationPharmacologicalSomministrationReconciliationDto> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalSomministrationReconciliation/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReconciliationPharmacologicalSomministrationReconciliationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReconciliationPharmacologicalSomministrationReconciliationDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ReconciliationPharmacologicalSomministrationReconciliationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReconciliationPharmacologicalSomministrationReconciliationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reconciliationPharmacologicalSomministrationRecognitionIds (optional) 
     * @return Success
     */
    getAll(reconciliationPharmacologicalSomministrationRecognitionIds: number[] | undefined): Observable<ReconciliationPharmacologicalSomministrationReconciliationDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalSomministrationReconciliation/GetAll?";
        if (reconciliationPharmacologicalSomministrationRecognitionIds === null)
            throw new globalThis.Error("The parameter 'reconciliationPharmacologicalSomministrationRecognitionIds' cannot be null.");
        else if (reconciliationPharmacologicalSomministrationRecognitionIds !== undefined)
            reconciliationPharmacologicalSomministrationRecognitionIds && reconciliationPharmacologicalSomministrationRecognitionIds.forEach(item => { url_ += "ReconciliationPharmacologicalSomministrationRecognitionIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReconciliationPharmacologicalSomministrationReconciliationDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReconciliationPharmacologicalSomministrationReconciliationDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ReconciliationPharmacologicalSomministrationReconciliationDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReconciliationPharmacologicalSomministrationReconciliationDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ReconciliationPharmacologicalTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ReconciliationPharmacologicalType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateRecordDto | undefined): Observable<RecordDto> {
        let url_ = this.baseUrl + "/api/services/app/Record/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecordDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRecordDto | undefined): Observable<RecordDto> {
        let url_ = this.baseUrl + "/api/services/app/Record/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecordDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Record/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RecordDto> {
        let url_ = this.baseUrl + "/api/services/app/Record/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecordDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, sorting: string | undefined): Observable<RecordDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Record/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RecordDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RecordDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RecordDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RecordDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RehabilitationActivityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RehabilitationActivity/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RehabilitationMobilityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RehabilitationMobility/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RehabilitationRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @param isSecondSignature (optional) 
     * @return Success
     */
    confirm(id: number | undefined, isSecondSignature: boolean | undefined): Observable<RehabilitationRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/RehabilitationRecord/Confirm?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (isSecondSignature === null)
            throw new globalThis.Error("The parameter 'isSecondSignature' cannot be null.");
        else if (isSecondSignature !== undefined)
            url_ += "isSecondSignature=" + encodeURIComponent("" + isSecondSignature) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RehabilitationRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RehabilitationRecordDto>;
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<RehabilitationRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RehabilitationRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isSecondSignature (optional) 
     * @param body (optional) 
     * @return Success
     */
    confirmMany(isSecondSignature: boolean | undefined, body: number[] | undefined): Observable<RehabilitationRecordDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RehabilitationRecord/ConfirmMany?";
        if (isSecondSignature === null)
            throw new globalThis.Error("The parameter 'isSecondSignature' cannot be null.");
        else if (isSecondSignature !== undefined)
            url_ += "isSecondSignature=" + encodeURIComponent("" + isSecondSignature) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RehabilitationRecordDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RehabilitationRecordDto[]>;
        }));
    }

    protected processConfirmMany(response: HttpResponseBase): Observable<RehabilitationRecordDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RehabilitationRecordDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateRehabilitationRecordDto | undefined): Observable<RehabilitationRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/RehabilitationRecord/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RehabilitationRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RehabilitationRecordDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RehabilitationRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RehabilitationRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRehabilitationRecordDto | undefined): Observable<RehabilitationRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/RehabilitationRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RehabilitationRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RehabilitationRecordDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RehabilitationRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RehabilitationRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RehabilitationRecord/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RehabilitationRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/RehabilitationRecord/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RehabilitationRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RehabilitationRecordDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RehabilitationRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RehabilitationRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param socialHealtRecordId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, socialHealtRecordId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RehabilitationRecordDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/RehabilitationRecord/GetAll?";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (socialHealtRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealtRecordId' cannot be null.");
        else if (socialHealtRecordId !== undefined)
            url_ += "SocialHealtRecordId=" + encodeURIComponent("" + socialHealtRecordId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RehabilitationRecordDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RehabilitationRecordDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RehabilitationRecordDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RehabilitationRecordDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RehabilitationTreatmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RehabilitationTreatment/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RelativeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateRelativeDto | undefined): Observable<RelativeDto> {
        let url_ = this.baseUrl + "/api/services/app/Relative/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RelativeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RelativeDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RelativeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RelativeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRelativeDto | undefined): Observable<RelativeDto> {
        let url_ = this.baseUrl + "/api/services/app/Relative/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RelativeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RelativeDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RelativeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RelativeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Relative/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RelativeDto> {
        let url_ = this.baseUrl + "/api/services/app/Relative/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RelativeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RelativeDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RelativeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RelativeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param interviewParticipantsRecordId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(interviewParticipantsRecordId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RelativeDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Relative/GetAll?";
        if (interviewParticipantsRecordId === null)
            throw new globalThis.Error("The parameter 'interviewParticipantsRecordId' cannot be null.");
        else if (interviewParticipantsRecordId !== undefined)
            url_ += "InterviewParticipantsRecordId=" + encodeURIComponent("" + interviewParticipantsRecordId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RelativeDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RelativeDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RelativeDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RelativeDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RentalCompanyServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RentalCompany/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ResponseObservationGridServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateResponseObservationGridDto | undefined): Observable<ResponseObservationGridDto> {
        let url_ = this.baseUrl + "/api/services/app/ResponseObservationGrid/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseObservationGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseObservationGridDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ResponseObservationGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseObservationGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateResponseObservationGridDto | undefined): Observable<ResponseObservationGridDto> {
        let url_ = this.baseUrl + "/api/services/app/ResponseObservationGrid/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseObservationGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseObservationGridDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ResponseObservationGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseObservationGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ResponseObservationGrid/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ResponseObservationGridDto> {
        let url_ = this.baseUrl + "/api/services/app/ResponseObservationGrid/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseObservationGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseObservationGridDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ResponseObservationGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseObservationGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceUserId (optional) 
     * @param scopeObservationGridId (optional) 
     * @param observationGridId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceUserId: number | undefined, scopeObservationGridId: number | undefined, observationGridId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ResponseObservationGridItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ResponseObservationGrid/GetAll?";
        if (serviceUserId === null)
            throw new globalThis.Error("The parameter 'serviceUserId' cannot be null.");
        else if (serviceUserId !== undefined)
            url_ += "ServiceUserId=" + encodeURIComponent("" + serviceUserId) + "&";
        if (scopeObservationGridId === null)
            throw new globalThis.Error("The parameter 'scopeObservationGridId' cannot be null.");
        else if (scopeObservationGridId !== undefined)
            url_ += "ScopeObservationGridId=" + encodeURIComponent("" + scopeObservationGridId) + "&";
        if (observationGridId === null)
            throw new globalThis.Error("The parameter 'observationGridId' cannot be null.");
        else if (observationGridId !== undefined)
            url_ += "ObservationGridId=" + encodeURIComponent("" + observationGridId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResponseObservationGridItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResponseObservationGridItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ResponseObservationGridItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResponseObservationGridItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ResponseTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ResponseType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RestraintPrescribedTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RestraintPrescribedType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isForEditUser (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isForEditUser: boolean | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isForEditUser === null)
            throw new globalThis.Error("The parameter 'isForEditUser' cannot be null.");
        else if (isForEditUser !== undefined)
            url_ += "IsForEditUser=" + encodeURIComponent("" + isForEditUser) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param permission (optional) 
     * @return Success
     */
    getRoles(permission: string | undefined): Observable<RoleListDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission === null)
            throw new globalThis.Error("The parameter 'permission' cannot be null.");
        else if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleListDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleListDtoListResultDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleListDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleListDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: RoleDto | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAllPermissions(): Observable<PermissionDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermissionDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermissionDtoListResultDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<PermissionDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PermissionDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RoleDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RoomServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateRoomDto | undefined): Observable<RoomDto> {
        let url_ = this.baseUrl + "/api/services/app/Room/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoomDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoomDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<RoomDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoomDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateRoomDto | undefined): Observable<RoomDto> {
        let url_ = this.baseUrl + "/api/services/app/Room/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoomDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoomDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<RoomDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoomDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Room/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<RoomDto> {
        let url_ = this.baseUrl + "/api/services/app/Room/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoomDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoomDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoomDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoomDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param structureId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, structureId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<RoomDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Room/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoomDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoomDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<RoomDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoomDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SchoolWorkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateSchoolWorkDto | undefined): Observable<SchoolWorkDto> {
        let url_ = this.baseUrl + "/api/services/app/SchoolWork/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SchoolWorkDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SchoolWorkDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SchoolWorkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SchoolWorkDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateSchoolWorkDto | undefined): Observable<SchoolWorkDto> {
        let url_ = this.baseUrl + "/api/services/app/SchoolWork/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SchoolWorkDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SchoolWorkDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SchoolWorkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SchoolWorkDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SchoolWork/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SchoolWorkDto> {
        let url_ = this.baseUrl + "/api/services/app/SchoolWork/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SchoolWorkDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SchoolWorkDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SchoolWorkDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SchoolWorkDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param inputCardRecordId (optional) 
     * @param isPaged (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(inputCardRecordId: number | undefined, isPaged: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SchoolWorkDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SchoolWork/GetAll?";
        if (inputCardRecordId === null)
            throw new globalThis.Error("The parameter 'inputCardRecordId' cannot be null.");
        else if (inputCardRecordId !== undefined)
            url_ += "InputCardRecordId=" + encodeURIComponent("" + inputCardRecordId) + "&";
        if (isPaged === null)
            throw new globalThis.Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SchoolWorkDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SchoolWorkDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SchoolWorkDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SchoolWorkDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ScopeObservationGridServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateScopeObservationGridDto | undefined): Observable<ScopeObservationGridDto> {
        let url_ = this.baseUrl + "/api/services/app/ScopeObservationGrid/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScopeObservationGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScopeObservationGridDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ScopeObservationGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScopeObservationGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateScopeObservationGridDto | undefined): Observable<ScopeObservationGridDto> {
        let url_ = this.baseUrl + "/api/services/app/ScopeObservationGrid/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScopeObservationGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScopeObservationGridDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ScopeObservationGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScopeObservationGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ScopeObservationGrid/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ScopeObservationGridDto> {
        let url_ = this.baseUrl + "/api/services/app/ScopeObservationGrid/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScopeObservationGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScopeObservationGridDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ScopeObservationGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScopeObservationGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param observationGridId (optional) 
     * @param categoryObservationGridId (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, observationGridId: number | undefined, categoryObservationGridId: number | undefined, sorting: string | undefined): Observable<ScopeObservationGridDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ScopeObservationGrid/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (observationGridId === null)
            throw new globalThis.Error("The parameter 'observationGridId' cannot be null.");
        else if (observationGridId !== undefined)
            url_ += "ObservationGridId=" + encodeURIComponent("" + observationGridId) + "&";
        if (categoryObservationGridId === null)
            throw new globalThis.Error("The parameter 'categoryObservationGridId' cannot be null.");
        else if (categoryObservationGridId !== undefined)
            url_ += "CategoryObservationGridId=" + encodeURIComponent("" + categoryObservationGridId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScopeObservationGridDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScopeObservationGridDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ScopeObservationGridDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScopeObservationGridDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SectionObservationGridServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateSectionObservationGridDto | undefined): Observable<SectionObservationGridDto> {
        let url_ = this.baseUrl + "/api/services/app/SectionObservationGrid/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SectionObservationGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SectionObservationGridDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SectionObservationGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SectionObservationGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateSectionObservationGridDto | undefined): Observable<SectionObservationGridDto> {
        let url_ = this.baseUrl + "/api/services/app/SectionObservationGrid/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SectionObservationGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SectionObservationGridDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SectionObservationGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SectionObservationGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SectionObservationGrid/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SectionObservationGridDto> {
        let url_ = this.baseUrl + "/api/services/app/SectionObservationGrid/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SectionObservationGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SectionObservationGridDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SectionObservationGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SectionObservationGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, sorting: string | undefined): Observable<SectionObservationGridDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SectionObservationGrid/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SectionObservationGridDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SectionObservationGridDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SectionObservationGridDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SectionObservationGridDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getMyServices(keyword: string | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Service/GetMyServices?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyServices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyServices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceItemDtoPagedResultDto>;
        }));
    }

    protected processGetMyServices(response: HttpResponseBase): Observable<ServiceItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadExcel(body: ServiceGetAllInput | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/Service/DownloadExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadExcel(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param templateId (optional) 
     * @return Success
     */
    associateTemplateToService(serviceId: number | undefined, templateId: number | undefined): Observable<ServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Service/AssociateTemplateToService?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        if (templateId === null)
            throw new globalThis.Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssociateTemplateToService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssociateTemplateToService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDto>;
        }));
    }

    protected processAssociateTemplateToService(response: HttpResponseBase): Observable<ServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setCloudFolderUrl(body: SetCloudFolderUrlInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Service/SetCloudFolderUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCloudFolderUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCloudFolderUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetCloudFolderUrl(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteByName(name: string, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Service/DeleteByName?";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined and cannot be null.");
        else
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteByName(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceDto | undefined): Observable<ServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Service/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceDto | undefined): Observable<ServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Service/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Service/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Service/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param operatorIds (optional) 
     * @param beneficiaryIds (optional) 
     * @param organizationIds (optional) 
     * @param qualificationIds (optional) 
     * @param structureIds (optional) 
     * @param userIds (optional) 
     * @param serviceSectorIds (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, operatorIds: number[] | undefined, beneficiaryIds: number[] | undefined, organizationIds: number[] | undefined, qualificationIds: number[] | undefined, structureIds: number[] | undefined, userIds: number[] | undefined, serviceSectorIds: number[] | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Service/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (operatorIds === null)
            throw new globalThis.Error("The parameter 'operatorIds' cannot be null.");
        else if (operatorIds !== undefined)
            operatorIds && operatorIds.forEach(item => { url_ += "OperatorIds=" + encodeURIComponent("" + item) + "&"; });
        if (beneficiaryIds === null)
            throw new globalThis.Error("The parameter 'beneficiaryIds' cannot be null.");
        else if (beneficiaryIds !== undefined)
            beneficiaryIds && beneficiaryIds.forEach(item => { url_ += "BeneficiaryIds=" + encodeURIComponent("" + item) + "&"; });
        if (organizationIds === null)
            throw new globalThis.Error("The parameter 'organizationIds' cannot be null.");
        else if (organizationIds !== undefined)
            organizationIds && organizationIds.forEach(item => { url_ += "OrganizationIds=" + encodeURIComponent("" + item) + "&"; });
        if (qualificationIds === null)
            throw new globalThis.Error("The parameter 'qualificationIds' cannot be null.");
        else if (qualificationIds !== undefined)
            qualificationIds && qualificationIds.forEach(item => { url_ += "QualificationIds=" + encodeURIComponent("" + item) + "&"; });
        if (structureIds === null)
            throw new globalThis.Error("The parameter 'structureIds' cannot be null.");
        else if (structureIds !== undefined)
            structureIds && structureIds.forEach(item => { url_ += "StructureIds=" + encodeURIComponent("" + item) + "&"; });
        if (userIds === null)
            throw new globalThis.Error("The parameter 'userIds' cannot be null.");
        else if (userIds !== undefined)
            userIds && userIds.forEach(item => { url_ += "UserIds=" + encodeURIComponent("" + item) + "&"; });
        if (serviceSectorIds === null)
            throw new globalThis.Error("The parameter 'serviceSectorIds' cannot be null.");
        else if (serviceSectorIds !== undefined)
            serviceSectorIds && serviceSectorIds.forEach(item => { url_ += "ServiceSectorIds=" + encodeURIComponent("" + item) + "&"; });
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceAttendanceRegisterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param serviceUserIds (optional) 
     * @param date (optional) 
     * @param startRangeDate (optional) 
     * @param endRangeDate (optional) 
     * @param serviceId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllAttendance(serviceUserIds: number[] | undefined, date: moment.Moment | undefined, startRangeDate: moment.Moment | undefined, endRangeDate: moment.Moment | undefined, serviceId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceAttendanceRegisterDtoServiceAttendanceRegisterPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceAttendanceRegister/GetAllAttendance?";
        if (serviceUserIds === null)
            throw new globalThis.Error("The parameter 'serviceUserIds' cannot be null.");
        else if (serviceUserIds !== undefined)
            serviceUserIds && serviceUserIds.forEach(item => { url_ += "ServiceUserIds=" + encodeURIComponent("" + item) + "&"; });
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (startRangeDate === null)
            throw new globalThis.Error("The parameter 'startRangeDate' cannot be null.");
        else if (startRangeDate !== undefined)
            url_ += "StartRangeDate=" + encodeURIComponent(startRangeDate ? "" + startRangeDate.toISOString() : "") + "&";
        if (endRangeDate === null)
            throw new globalThis.Error("The parameter 'endRangeDate' cannot be null.");
        else if (endRangeDate !== undefined)
            url_ += "EndRangeDate=" + encodeURIComponent(endRangeDate ? "" + endRangeDate.toISOString() : "") + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAttendance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAttendance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceAttendanceRegisterDtoServiceAttendanceRegisterPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceAttendanceRegisterDtoServiceAttendanceRegisterPagedResultDto>;
        }));
    }

    protected processGetAllAttendance(response: HttpResponseBase): Observable<ServiceAttendanceRegisterDtoServiceAttendanceRegisterPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceAttendanceRegisterDtoServiceAttendanceRegisterPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceUserIds (optional) 
     * @param date (optional) 
     * @param startRangeDate (optional) 
     * @param endRangeDate (optional) 
     * @param serviceId (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAllWithoutPaged(serviceUserIds: number[] | undefined, date: moment.Moment | undefined, startRangeDate: moment.Moment | undefined, endRangeDate: moment.Moment | undefined, serviceId: number | undefined, sorting: string | undefined): Observable<ServiceAttendanceRegisterDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceAttendanceRegister/GetAllWithoutPaged?";
        if (serviceUserIds === null)
            throw new globalThis.Error("The parameter 'serviceUserIds' cannot be null.");
        else if (serviceUserIds !== undefined)
            serviceUserIds && serviceUserIds.forEach(item => { url_ += "ServiceUserIds=" + encodeURIComponent("" + item) + "&"; });
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (startRangeDate === null)
            throw new globalThis.Error("The parameter 'startRangeDate' cannot be null.");
        else if (startRangeDate !== undefined)
            url_ += "StartRangeDate=" + encodeURIComponent(startRangeDate ? "" + startRangeDate.toISOString() : "") + "&";
        if (endRangeDate === null)
            throw new globalThis.Error("The parameter 'endRangeDate' cannot be null.");
        else if (endRangeDate !== undefined)
            url_ += "EndRangeDate=" + encodeURIComponent(endRangeDate ? "" + endRangeDate.toISOString() : "") + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWithoutPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWithoutPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceAttendanceRegisterDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceAttendanceRegisterDtoPagedResultDto>;
        }));
    }

    protected processGetAllWithoutPaged(response: HttpResponseBase): Observable<ServiceAttendanceRegisterDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceAttendanceRegisterDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportServiceAttendanceRegister(body: ServiceAttendanceRegisterGetAllInput | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceAttendanceRegister/ExportServiceAttendanceRegister";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportServiceAttendanceRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportServiceAttendanceRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processExportServiceAttendanceRegister(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportServiceAttendancePivot(body: ServiceAttendanceRegisterGetAllInput | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceAttendanceRegister/ExportServiceAttendancePivot";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportServiceAttendancePivot(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportServiceAttendancePivot(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processExportServiceAttendancePivot(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceAttendanceRegisterDto | undefined): Observable<ServiceAttendanceRegisterDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceAttendanceRegister/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceAttendanceRegisterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceAttendanceRegisterDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceAttendanceRegisterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceAttendanceRegisterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceAttendanceRegisterDto | undefined): Observable<ServiceAttendanceRegisterDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceAttendanceRegister/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceAttendanceRegisterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceAttendanceRegisterDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceAttendanceRegisterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceAttendanceRegisterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceAttendanceRegister/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceAttendanceRegisterDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceAttendanceRegister/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceAttendanceRegisterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceAttendanceRegisterDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceAttendanceRegisterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceAttendanceRegisterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceUserIds (optional) 
     * @param date (optional) 
     * @param startRangeDate (optional) 
     * @param endRangeDate (optional) 
     * @param serviceId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceUserIds: number[] | undefined, date: moment.Moment | undefined, startRangeDate: moment.Moment | undefined, endRangeDate: moment.Moment | undefined, serviceId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceAttendanceRegisterDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceAttendanceRegister/GetAll?";
        if (serviceUserIds === null)
            throw new globalThis.Error("The parameter 'serviceUserIds' cannot be null.");
        else if (serviceUserIds !== undefined)
            serviceUserIds && serviceUserIds.forEach(item => { url_ += "ServiceUserIds=" + encodeURIComponent("" + item) + "&"; });
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (startRangeDate === null)
            throw new globalThis.Error("The parameter 'startRangeDate' cannot be null.");
        else if (startRangeDate !== undefined)
            url_ += "StartRangeDate=" + encodeURIComponent(startRangeDate ? "" + startRangeDate.toISOString() : "") + "&";
        if (endRangeDate === null)
            throw new globalThis.Error("The parameter 'endRangeDate' cannot be null.");
        else if (endRangeDate !== undefined)
            url_ += "EndRangeDate=" + encodeURIComponent(endRangeDate ? "" + endRangeDate.toISOString() : "") + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceAttendanceRegisterDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceAttendanceRegisterDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceAttendanceRegisterDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceAttendanceRegisterDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceCheckRefrigeratorTemperatureServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceCheckRefrigeratorTemperatureDto | undefined): Observable<ServiceCheckRefrigeratorTemperatureDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCheckRefrigeratorTemperature/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCheckRefrigeratorTemperatureDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCheckRefrigeratorTemperatureDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceCheckRefrigeratorTemperatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCheckRefrigeratorTemperatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceCheckRefrigeratorTemperatureDto | undefined): Observable<ServiceCheckRefrigeratorTemperatureDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCheckRefrigeratorTemperature/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCheckRefrigeratorTemperatureDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCheckRefrigeratorTemperatureDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceCheckRefrigeratorTemperatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCheckRefrigeratorTemperatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCheckRefrigeratorTemperature/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceCheckRefrigeratorTemperatureDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCheckRefrigeratorTemperature/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCheckRefrigeratorTemperatureDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCheckRefrigeratorTemperatureDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceCheckRefrigeratorTemperatureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCheckRefrigeratorTemperatureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param serviceId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, serviceId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceCheckRefrigeratorTemperatureItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCheckRefrigeratorTemperature/GetAll?";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCheckRefrigeratorTemperatureItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCheckRefrigeratorTemperatureItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceCheckRefrigeratorTemperatureItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCheckRefrigeratorTemperatureItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceCheckRefrigeratorTemperatureDetailServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    confirm(id: number | undefined): Observable<ServiceCheckRefrigeratorTemperatureDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCheckRefrigeratorTemperatureDetail/Confirm?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCheckRefrigeratorTemperatureDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCheckRefrigeratorTemperatureDetailDto>;
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<ServiceCheckRefrigeratorTemperatureDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCheckRefrigeratorTemperatureDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    confirmMany(body: number[] | undefined): Observable<ServiceCheckRefrigeratorTemperatureDetailDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCheckRefrigeratorTemperatureDetail/ConfirmMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCheckRefrigeratorTemperatureDetailDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCheckRefrigeratorTemperatureDetailDto[]>;
        }));
    }

    protected processConfirmMany(response: HttpResponseBase): Observable<ServiceCheckRefrigeratorTemperatureDetailDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceCheckRefrigeratorTemperatureDetailDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceCheckRefrigeratorTemperatureDetailDto | undefined): Observable<ServiceCheckRefrigeratorTemperatureDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCheckRefrigeratorTemperatureDetail/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCheckRefrigeratorTemperatureDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCheckRefrigeratorTemperatureDetailDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceCheckRefrigeratorTemperatureDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCheckRefrigeratorTemperatureDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceCheckRefrigeratorTemperatureDetailDto | undefined): Observable<ServiceCheckRefrigeratorTemperatureDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCheckRefrigeratorTemperatureDetail/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCheckRefrigeratorTemperatureDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCheckRefrigeratorTemperatureDetailDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceCheckRefrigeratorTemperatureDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCheckRefrigeratorTemperatureDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCheckRefrigeratorTemperatureDetail/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceCheckRefrigeratorTemperatureDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCheckRefrigeratorTemperatureDetail/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCheckRefrigeratorTemperatureDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCheckRefrigeratorTemperatureDetailDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceCheckRefrigeratorTemperatureDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCheckRefrigeratorTemperatureDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceCheckRefrigeratorTemperatureId (optional) 
     * @return Success
     */
    getAll(serviceCheckRefrigeratorTemperatureId: number | undefined): Observable<ServiceCheckRefrigeratorTemperatureDetailDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceCheckRefrigeratorTemperatureDetail/GetAll?";
        if (serviceCheckRefrigeratorTemperatureId === null)
            throw new globalThis.Error("The parameter 'serviceCheckRefrigeratorTemperatureId' cannot be null.");
        else if (serviceCheckRefrigeratorTemperatureId !== undefined)
            url_ += "ServiceCheckRefrigeratorTemperatureId=" + encodeURIComponent("" + serviceCheckRefrigeratorTemperatureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceCheckRefrigeratorTemperatureDetailDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceCheckRefrigeratorTemperatureDetailDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceCheckRefrigeratorTemperatureDetailDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceCheckRefrigeratorTemperatureDetailDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceDataCollectionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceDataCollectionDto | undefined): Observable<ServiceDataCollectionDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceDataCollection/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDataCollectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDataCollectionDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceDataCollectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDataCollectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceDataCollectionDto | undefined): Observable<ServiceDataCollectionDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceDataCollection/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDataCollectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDataCollectionDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceDataCollectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDataCollectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceDataCollection/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceDataCollectionDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceDataCollection/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDataCollectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDataCollectionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceDataCollectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDataCollectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param laboratoryId (optional) 
     * @param serviceUserId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceId: number | undefined, laboratoryId: number | undefined, serviceUserId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceDataCollectionItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceDataCollection/GetAll?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (laboratoryId === null)
            throw new globalThis.Error("The parameter 'laboratoryId' cannot be null.");
        else if (laboratoryId !== undefined)
            url_ += "LaboratoryId=" + encodeURIComponent("" + laboratoryId) + "&";
        if (serviceUserId === null)
            throw new globalThis.Error("The parameter 'serviceUserId' cannot be null.");
        else if (serviceUserId !== undefined)
            url_ += "ServiceUserId=" + encodeURIComponent("" + serviceUserId) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDataCollectionItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDataCollectionItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceDataCollectionItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDataCollectionItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceDataCollectionObjectiveServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceDataCollectionObjectiveDto | undefined): Observable<ServiceDataCollectionObjectiveDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceDataCollectionObjective/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDataCollectionObjectiveDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDataCollectionObjectiveDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceDataCollectionObjectiveDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDataCollectionObjectiveDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceDataCollectionObjectiveDto | undefined): Observable<ServiceDataCollectionObjectiveDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceDataCollectionObjective/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDataCollectionObjectiveDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDataCollectionObjectiveDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceDataCollectionObjectiveDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDataCollectionObjectiveDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceDataCollectionObjective/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceDataCollectionObjectiveDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceDataCollectionObjective/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDataCollectionObjectiveDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDataCollectionObjectiveDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceDataCollectionObjectiveDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDataCollectionObjectiveDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceDataCollectionId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceDataCollectionId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceDataCollectionObjectiveDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceDataCollectionObjective/GetAll?";
        if (serviceDataCollectionId === null)
            throw new globalThis.Error("The parameter 'serviceDataCollectionId' cannot be null.");
        else if (serviceDataCollectionId !== undefined)
            url_ += "ServiceDataCollectionId=" + encodeURIComponent("" + serviceDataCollectionId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceDataCollectionObjectiveDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceDataCollectionObjectiveDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceDataCollectionObjectiveDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceDataCollectionObjectiveDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceDataCollectionResultServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceDataCollectionResult/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceFileTagServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceFileTagDto | undefined): Observable<ServiceFileTagDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceFileTag/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceFileTagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceFileTagDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceFileTagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceFileTagDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceFileTag/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceFileTagDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceFileTag/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceFileTagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceFileTagDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceFileTagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceFileTagDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceFileTagDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceFileTag/GetAll?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceFileTagDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceFileTagDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceFileTagDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceFileTagDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadServiceLogsPdf(body: ServiceLogGetAllInput | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceLog/DownloadServiceLogsPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadServiceLogsPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadServiceLogsPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadServiceLogsPdf(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setReadState(body: SetServiceLogReadStateDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceLog/SetReadState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetReadState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetReadState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetReadState(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param serviceId (optional) 
     * @param tagIds (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isRead (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getMyNotes(keyword: string | undefined, serviceId: number | undefined, tagIds: number[] | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, isRead: boolean | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceLogDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceLog/GetMyNotes?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (tagIds === null)
            throw new globalThis.Error("The parameter 'tagIds' cannot be null.");
        else if (tagIds !== undefined)
            tagIds && tagIds.forEach(item => { url_ += "TagIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (isRead === null)
            throw new globalThis.Error("The parameter 'isRead' cannot be null.");
        else if (isRead !== undefined)
            url_ += "IsRead=" + encodeURIComponent("" + isRead) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyNotes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyNotes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceLogDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceLogDtoPagedResultDto>;
        }));
    }

    protected processGetMyNotes(response: HttpResponseBase): Observable<ServiceLogDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceLogDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceLogDto | undefined): Observable<ServiceLogDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceLog/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceLogDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceLogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceLogDto | undefined): Observable<ServiceLogDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceLog/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceLogDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceLogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceLog/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceLogDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceLog/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceLogDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceLogDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceLogDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceLogDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param serviceId (optional) 
     * @param userId (optional) 
     * @param tagIds (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isRead (optional) 
     * @param includeLinkedDiaries (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, serviceId: number | undefined, userId: number | undefined, tagIds: number[] | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, isRead: boolean | undefined, includeLinkedDiaries: boolean | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceLogDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceLog/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tagIds === null)
            throw new globalThis.Error("The parameter 'tagIds' cannot be null.");
        else if (tagIds !== undefined)
            tagIds && tagIds.forEach(item => { url_ += "TagIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (isRead === null)
            throw new globalThis.Error("The parameter 'isRead' cannot be null.");
        else if (isRead !== undefined)
            url_ += "IsRead=" + encodeURIComponent("" + isRead) + "&";
        if (includeLinkedDiaries === null)
            throw new globalThis.Error("The parameter 'includeLinkedDiaries' cannot be null.");
        else if (includeLinkedDiaries !== undefined)
            url_ += "IncludeLinkedDiaries=" + encodeURIComponent("" + includeLinkedDiaries) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceLogDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceLogDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceLogDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceLogDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceLogServiceTaskServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceLogServiceTaskDto | undefined): Observable<ServiceLogServiceTaskDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceLogServiceTask/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceLogServiceTaskDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceLogServiceTaskDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceLogServiceTaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceLogServiceTaskDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceLogServiceTaskDto | undefined): Observable<ServiceLogServiceTaskDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceLogServiceTask/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceLogServiceTaskDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceLogServiceTaskDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceLogServiceTaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceLogServiceTaskDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceLogServiceTask/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceLogServiceTaskDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceLogServiceTask/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceLogServiceTaskDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceLogServiceTaskDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceLogServiceTaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceLogServiceTaskDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceLogId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceLogId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceLogServiceTaskDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceLogServiceTask/GetAll?";
        if (serviceLogId === null)
            throw new globalThis.Error("The parameter 'serviceLogId' cannot be null.");
        else if (serviceLogId !== undefined)
            url_ += "ServiceLogId=" + encodeURIComponent("" + serviceLogId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceLogServiceTaskDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceLogServiceTaskDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceLogServiceTaskDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceLogServiceTaskDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceModRUDServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceModRUDDto | undefined): Observable<ServiceModRUDDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceModRUD/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceModRUDDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceModRUDDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceModRUDDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceModRUDDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceModRUDDto | undefined): Observable<ServiceModRUDDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceModRUD/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceModRUDDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceModRUDDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceModRUDDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceModRUDDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceModRUD/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceModRUDDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceModRUD/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceModRUDDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceModRUDDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceModRUDDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceModRUDDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceModRUDItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceModRUD/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceModRUDItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceModRUDItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceModRUDItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceModRUDItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServicePlaceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServicePlaceDto | undefined): Observable<ServicePlaceDto> {
        let url_ = this.baseUrl + "/api/services/app/ServicePlace/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServicePlaceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServicePlaceDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServicePlaceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServicePlaceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServicePlace/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServicePlaceDto> {
        let url_ = this.baseUrl + "/api/services/app/ServicePlace/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServicePlaceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServicePlaceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServicePlaceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServicePlaceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param placeId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceId: number | undefined, placeId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServicePlaceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServicePlace/GetAll?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (placeId === null)
            throw new globalThis.Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "PlaceId=" + encodeURIComponent("" + placeId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServicePlaceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServicePlaceDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServicePlaceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServicePlaceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    confirm(id: number | undefined): Observable<ServiceReportDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceReport/Confirm?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceReportDto>;
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<ServiceReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    downloadServiceReportPdf(id: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceReport/DownloadServiceReportPdf?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadServiceReportPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadServiceReportPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadServiceReportPdf(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceReportDto | undefined): Observable<ServiceReportDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceReport/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceReportDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceReportDto | undefined): Observable<ServiceReportDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceReport/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceReportDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceReport/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceReportDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceReport/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceReportDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param beneficiaryId (optional) 
     * @param operatorId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isConfirmed (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceId: number | undefined, beneficiaryId: number | undefined, operatorId: number | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, isConfirmed: boolean | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceReportDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceReport/GetAll?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (beneficiaryId === null)
            throw new globalThis.Error("The parameter 'beneficiaryId' cannot be null.");
        else if (beneficiaryId !== undefined)
            url_ += "BeneficiaryId=" + encodeURIComponent("" + beneficiaryId) + "&";
        if (operatorId === null)
            throw new globalThis.Error("The parameter 'operatorId' cannot be null.");
        else if (operatorId !== undefined)
            url_ += "OperatorId=" + encodeURIComponent("" + operatorId) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (isConfirmed === null)
            throw new globalThis.Error("The parameter 'isConfirmed' cannot be null.");
        else if (isConfirmed !== undefined)
            url_ += "IsConfirmed=" + encodeURIComponent("" + isConfirmed) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceReportDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceReportDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceReportDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceReportDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceSectorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceSector/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceSemiAnnualHealthDocumentationReviewServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    confirm(id: number | undefined): Observable<ServiceSemiAnnualHealthDocumentationReviewDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceSemiAnnualHealthDocumentationReview/Confirm?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceSemiAnnualHealthDocumentationReviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceSemiAnnualHealthDocumentationReviewDto>;
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<ServiceSemiAnnualHealthDocumentationReviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceSemiAnnualHealthDocumentationReviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceSemiAnnualHealthDocumentationReviewDto | undefined): Observable<ServiceSemiAnnualHealthDocumentationReviewDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceSemiAnnualHealthDocumentationReview/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceSemiAnnualHealthDocumentationReviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceSemiAnnualHealthDocumentationReviewDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceSemiAnnualHealthDocumentationReviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceSemiAnnualHealthDocumentationReviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceSemiAnnualHealthDocumentationReviewDto | undefined): Observable<ServiceSemiAnnualHealthDocumentationReviewDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceSemiAnnualHealthDocumentationReview/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceSemiAnnualHealthDocumentationReviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceSemiAnnualHealthDocumentationReviewDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceSemiAnnualHealthDocumentationReviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceSemiAnnualHealthDocumentationReviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceSemiAnnualHealthDocumentationReview/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceSemiAnnualHealthDocumentationReviewDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceSemiAnnualHealthDocumentationReview/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceSemiAnnualHealthDocumentationReviewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceSemiAnnualHealthDocumentationReviewDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceSemiAnnualHealthDocumentationReviewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceSemiAnnualHealthDocumentationReviewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param keyword (optional) 
     * @param isConfirmed (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceId: number | undefined, keyword: string | undefined, isConfirmed: boolean | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceSemiAnnualHealthDocumentationReviewDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceSemiAnnualHealthDocumentationReview/GetAll?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isConfirmed === null)
            throw new globalThis.Error("The parameter 'isConfirmed' cannot be null.");
        else if (isConfirmed !== undefined)
            url_ += "IsConfirmed=" + encodeURIComponent("" + isConfirmed) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceSemiAnnualHealthDocumentationReviewDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceSemiAnnualHealthDocumentationReviewDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceSemiAnnualHealthDocumentationReviewDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceSemiAnnualHealthDocumentationReviewDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceStructureServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceStructureDto | undefined): Observable<ServiceStructureDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceStructure/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceStructureDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceStructureDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceStructureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceStructureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceStructure/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceStructureDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceStructure/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceStructureDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceStructureDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceStructureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceStructureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param serviceId (optional) 
     * @param structureId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, serviceId: number | undefined, structureId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceStructureDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceStructure/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceStructureDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceStructureDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceStructureDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceStructureDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceSubTagServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceSubTagDto | undefined): Observable<ServiceSubTagDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceSubTag/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceSubTagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceSubTagDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceSubTagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceSubTagDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceSubTag/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceSubTagDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceSubTag/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceSubTagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceSubTagDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceSubTagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceSubTagDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param isInService (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceId: number | undefined, isInService: boolean | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceSubTagDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceSubTag/GetAll?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (isInService === null)
            throw new globalThis.Error("The parameter 'isInService' cannot be null.");
        else if (isInService !== undefined)
            url_ += "IsInService=" + encodeURIComponent("" + isInService) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceSubTagDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceSubTagDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceSubTagDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceSubTagDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceTagServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceTagDto | undefined): Observable<ServiceTagDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceTag/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTagDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceTagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceTagDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceTag/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceTagDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceTag/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTagDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceTagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceTagDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param isInService (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceId: number | undefined, isInService: boolean | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceTagDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceTag/GetAll?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (isInService === null)
            throw new globalThis.Error("The parameter 'isInService' cannot be null.");
        else if (isInService !== undefined)
            url_ += "IsInService=" + encodeURIComponent("" + isInService) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTagDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTagDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceTagDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceTagDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceTaskServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceTaskDto | undefined): Observable<ServiceTaskDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceTask/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTaskDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTaskDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceTaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceTaskDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceTask/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceTaskDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceTask/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTaskDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTaskDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceTaskDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceTaskDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param isInService (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceId: number | undefined, isInService: boolean | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceTaskDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceTask/GetAll?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (isInService === null)
            throw new globalThis.Error("The parameter 'isInService' cannot be null.");
        else if (isInService !== undefined)
            url_ += "IsInService=" + encodeURIComponent("" + isInService) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTaskDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTaskDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceTaskDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceTaskDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceTemplateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    switchIsHidden(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ServiceTemplate/SwitchIsHidden?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchIsHidden(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchIsHidden(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSwitchIsHidden(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceTemplateDto | undefined): Observable<ServiceTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceTemplate/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTemplateDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceTemplateDto | undefined): Observable<ServiceTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceTemplate/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTemplateDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceTemplate/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceTemplate/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTemplateDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param widgetId (optional) 
     * @param isHidden (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, widgetId: number | undefined, isHidden: boolean | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceTemplateDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceTemplate/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (widgetId === null)
            throw new globalThis.Error("The parameter 'widgetId' cannot be null.");
        else if (widgetId !== undefined)
            url_ += "WidgetId=" + encodeURIComponent("" + widgetId) + "&";
        if (isHidden === null)
            throw new globalThis.Error("The parameter 'isHidden' cannot be null.");
        else if (isHidden !== undefined)
            url_ += "IsHidden=" + encodeURIComponent("" + isHidden) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceTemplateDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceTemplateDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceTemplateDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceTemplateDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceUserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param serviceId (optional) 
     * @return Success
     */
    serviceUserInsideServiceCheck(serviceId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ServiceUser/ServiceUserInsideServiceCheck?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServiceUserInsideServiceCheck(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServiceUserInsideServiceCheck(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processServiceUserInsideServiceCheck(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialHealthRecordId (optional) 
     * @return Success
     */
    getBySocialHealthRecordId(socialHealthRecordId: number | undefined): Observable<ServiceUserDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceUser/GetBySocialHealthRecordId?";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "socialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBySocialHealthRecordId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBySocialHealthRecordId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceUserDto>;
        }));
    }

    protected processGetBySocialHealthRecordId(response: HttpResponseBase): Observable<ServiceUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setCloudFolderUrl(body: SetCloudFolderUrlInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceUser/SetCloudFolderUrl";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCloudFolderUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCloudFolderUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetCloudFolderUrl(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fullName (optional) 
     * @param id (optional) 
     * @return Success
     */
    deleteByName(fullName: string | undefined, id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceUser/DeleteByName?";
        if (fullName === null)
            throw new globalThis.Error("The parameter 'fullName' cannot be null.");
        else if (fullName !== undefined)
            url_ += "FullName=" + encodeURIComponent("" + fullName) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteByName(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    archiveServiceUser(body: ArchiveServiceUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceUser/ArchiveServiceUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveServiceUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveServiceUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArchiveServiceUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceUserId (optional) 
     * @return Success
     */
    unarchiveServiceUser(serviceUserId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceUser/UnarchiveServiceUser?";
        if (serviceUserId === null)
            throw new globalThis.Error("The parameter 'serviceUserId' cannot be null.");
        else if (serviceUserId !== undefined)
            url_ += "serviceUserId=" + encodeURIComponent("" + serviceUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnarchiveServiceUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnarchiveServiceUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnarchiveServiceUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceUserDto | undefined): Observable<ServiceUserDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceUser/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceUserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceUserDto | undefined): Observable<ServiceUserDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceUser/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceUserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceUser/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceUserDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceUser/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceUserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param serviceId (optional) 
     * @param userId (optional) 
     * @param qualificationId (optional) 
     * @param isOperator (optional) 
     * @param includeArchived (optional) 
     * @param isArchived (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, serviceId: number | undefined, userId: number | undefined, qualificationId: number | undefined, isOperator: boolean | undefined, includeArchived: boolean | undefined, isArchived: boolean | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceUserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceUser/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (qualificationId === null)
            throw new globalThis.Error("The parameter 'qualificationId' cannot be null.");
        else if (qualificationId !== undefined)
            url_ += "QualificationId=" + encodeURIComponent("" + qualificationId) + "&";
        if (isOperator === null)
            throw new globalThis.Error("The parameter 'isOperator' cannot be null.");
        else if (isOperator !== undefined)
            url_ += "IsOperator=" + encodeURIComponent("" + isOperator) + "&";
        if (includeArchived === null)
            throw new globalThis.Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "IncludeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        if (isArchived === null)
            throw new globalThis.Error("The parameter 'isArchived' cannot be null.");
        else if (isArchived !== undefined)
            url_ += "IsArchived=" + encodeURIComponent("" + isArchived) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceUserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceUserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceUserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceUserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceUserAvailabilityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceUserAvailabilityDto | undefined): Observable<ServiceUserAvailabilityDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceUserAvailability/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceUserAvailabilityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceUserAvailabilityDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceUserAvailabilityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceUserAvailabilityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceUserAvailabilityDto | undefined): Observable<ServiceUserAvailabilityDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceUserAvailability/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceUserAvailabilityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceUserAvailabilityDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceUserAvailabilityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceUserAvailabilityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceUserAvailability/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceUserAvailabilityDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceUserAvailability/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceUserAvailabilityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceUserAvailabilityDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceUserAvailabilityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceUserAvailabilityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param serviceUserIds (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceId: number | undefined, serviceUserIds: number[] | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceUserAvailabilityDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceUserAvailability/GetAll?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (serviceUserIds === null)
            throw new globalThis.Error("The parameter 'serviceUserIds' cannot be null.");
        else if (serviceUserIds !== undefined)
            serviceUserIds && serviceUserIds.forEach(item => { url_ += "ServiceUserIds=" + encodeURIComponent("" + item) + "&"; });
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceUserAvailabilityDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceUserAvailabilityDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceUserAvailabilityDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceUserAvailabilityDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceUserStructureServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param structureId (optional) 
     * @param serviceId (optional) 
     * @param serviceUserId (optional) 
     * @param userId (optional) 
     * @param includeHistory (optional) 
     * @return Success
     */
    getAll(structureId: number | undefined, serviceId: number | undefined, serviceUserId: number | undefined, userId: number | undefined, includeHistory: boolean | undefined): Observable<ServiceUserStructureDtoListResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceUserStructure/GetAll?";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (serviceUserId === null)
            throw new globalThis.Error("The parameter 'serviceUserId' cannot be null.");
        else if (serviceUserId !== undefined)
            url_ += "ServiceUserId=" + encodeURIComponent("" + serviceUserId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (includeHistory === null)
            throw new globalThis.Error("The parameter 'includeHistory' cannot be null.");
        else if (includeHistory !== undefined)
            url_ += "IncludeHistory=" + encodeURIComponent("" + includeHistory) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceUserStructureDtoListResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceUserStructureDtoListResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceUserStructureDtoListResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceUserStructureDtoListResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getServicesWithStructures(userId: number | undefined): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceUserStructure/GetServicesWithStructures?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServicesWithStructures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServicesWithStructures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetServicesWithStructures(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param structureId (optional) 
     * @return Success
     */
    getRoomOccupancy(structureId: number | undefined): Observable<RoomOccupancyDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceUserStructure/GetRoomOccupancy?";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "structureId=" + encodeURIComponent("" + structureId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoomOccupancy(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoomOccupancy(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoomOccupancyDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoomOccupancyDto[]>;
        }));
    }

    protected processGetRoomOccupancy(response: HttpResponseBase): Observable<RoomOccupancyDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoomOccupancyDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    assign(body: AssignServiceUserStructureInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceUserStructure/Assign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssign(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unassign(body: UnassignServiceUserStructureInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceUserStructure/Unassign";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnassign(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnassign(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnassign(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceVerbalServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    confirm(id: number | undefined): Observable<ServiceVerbalDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVerbal/Confirm?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceVerbalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceVerbalDto>;
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<ServiceVerbalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceVerbalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @return Success
     */
    downloadServiceVerbalsByServiceIdCSV(serviceId: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVerbal/DownloadServiceVerbalsByServiceIdCSV?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadServiceVerbalsByServiceIdCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadServiceVerbalsByServiceIdCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadServiceVerbalsByServiceIdCSV(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    downloadServiceVerbalPdf(id: number | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVerbal/DownloadServiceVerbalPdf?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadServiceVerbalPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadServiceVerbalPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processDownloadServiceVerbalPdf(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceVerbalDto | undefined): Observable<ServiceVerbalDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVerbal/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceVerbalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceVerbalDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceVerbalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceVerbalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceVerbalDto | undefined): Observable<ServiceVerbalDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVerbal/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceVerbalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceVerbalDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceVerbalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceVerbalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVerbal/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceVerbalDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVerbal/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceVerbalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceVerbalDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceVerbalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceVerbalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param serviceId (optional) 
     * @param operatorId (optional) 
     * @param beneficiaryId (optional) 
     * @param verbalTagIds (optional) 
     * @param dayOrder (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isConfirmed (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, serviceId: number | undefined, operatorId: number | undefined, beneficiaryId: number | undefined, verbalTagIds: number[] | undefined, dayOrder: string | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, isConfirmed: boolean | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceVerbalDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVerbal/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (operatorId === null)
            throw new globalThis.Error("The parameter 'operatorId' cannot be null.");
        else if (operatorId !== undefined)
            url_ += "OperatorId=" + encodeURIComponent("" + operatorId) + "&";
        if (beneficiaryId === null)
            throw new globalThis.Error("The parameter 'beneficiaryId' cannot be null.");
        else if (beneficiaryId !== undefined)
            url_ += "BeneficiaryId=" + encodeURIComponent("" + beneficiaryId) + "&";
        if (verbalTagIds === null)
            throw new globalThis.Error("The parameter 'verbalTagIds' cannot be null.");
        else if (verbalTagIds !== undefined)
            verbalTagIds && verbalTagIds.forEach(item => { url_ += "VerbalTagIds=" + encodeURIComponent("" + item) + "&"; });
        if (dayOrder === null)
            throw new globalThis.Error("The parameter 'dayOrder' cannot be null.");
        else if (dayOrder !== undefined)
            url_ += "DayOrder=" + encodeURIComponent("" + dayOrder) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (isConfirmed === null)
            throw new globalThis.Error("The parameter 'isConfirmed' cannot be null.");
        else if (isConfirmed !== undefined)
            url_ += "IsConfirmed=" + encodeURIComponent("" + isConfirmed) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceVerbalDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceVerbalDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceVerbalDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceVerbalDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceVerbalTagServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceVerbalTagDto | undefined): Observable<ServiceVerbalTagDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVerbalTag/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceVerbalTagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceVerbalTagDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceVerbalTagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceVerbalTagDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVerbalTag/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceVerbalTagDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVerbalTag/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceVerbalTagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceVerbalTagDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceVerbalTagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceVerbalTagDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceVerbalTagDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceVerbalTag/GetAll?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceVerbalTagDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceVerbalTagDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceVerbalTagDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceVerbalTagDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceWeeklyScheduleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMany(body: CreateServiceWeeklyScheduleDto | undefined): Observable<ServiceWeeklyScheduleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceWeeklySchedule/CreateMany";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateMany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceWeeklyScheduleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceWeeklyScheduleDto[]>;
        }));
    }

    protected processCreateMany(response: HttpResponseBase): Observable<ServiceWeeklyScheduleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceWeeklyScheduleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceUserId (optional) 
     * @return Success
     */
    getByServiceUserId(serviceUserId: number | undefined): Observable<ServiceWeeklyScheduleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceWeeklySchedule/GetByServiceUserId?";
        if (serviceUserId === null)
            throw new globalThis.Error("The parameter 'serviceUserId' cannot be null.");
        else if (serviceUserId !== undefined)
            url_ += "serviceUserId=" + encodeURIComponent("" + serviceUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByServiceUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByServiceUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceWeeklyScheduleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceWeeklyScheduleDto[]>;
        }));
    }

    protected processGetByServiceUserId(response: HttpResponseBase): Observable<ServiceWeeklyScheduleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceWeeklyScheduleDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceWeeklyScheduleDto | undefined): Observable<ServiceWeeklyScheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceWeeklySchedule/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceWeeklyScheduleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceWeeklyScheduleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceWeeklyScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceWeeklyScheduleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceWeeklyScheduleDto | undefined): Observable<ServiceWeeklyScheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceWeeklySchedule/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceWeeklyScheduleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceWeeklyScheduleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceWeeklyScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceWeeklyScheduleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceWeeklySchedule/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceWeeklyScheduleDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceWeeklySchedule/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceWeeklyScheduleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceWeeklyScheduleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceWeeklyScheduleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceWeeklyScheduleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceWeeklyScheduleDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceWeeklySchedule/GetAll?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceWeeklyScheduleDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceWeeklyScheduleDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceWeeklyScheduleDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceWeeklyScheduleDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceWeightDetectionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceWeightDetectionDto | undefined): Observable<ServiceWeightDetectionDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceWeightDetection/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceWeightDetectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceWeightDetectionDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceWeightDetectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceWeightDetectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceWeightDetectionDto | undefined): Observable<ServiceWeightDetectionDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceWeightDetection/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceWeightDetectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceWeightDetectionDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceWeightDetectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceWeightDetectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceWeightDetection/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceWeightDetectionDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceWeightDetection/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceWeightDetectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceWeightDetectionDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceWeightDetectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceWeightDetectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param year (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceId: number | undefined, year: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceWeightDetectionItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceWeightDetection/GetAll?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (year === null)
            throw new globalThis.Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceWeightDetectionItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceWeightDetectionItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceWeightDetectionItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceWeightDetectionItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ServiceWidgetServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateServiceWidgetDto | undefined): Observable<ServiceWidgetDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceWidget/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceWidgetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceWidgetDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ServiceWidgetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceWidgetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateServiceWidgetDto | undefined): Observable<ServiceWidgetDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceWidget/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceWidgetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceWidgetDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<ServiceWidgetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceWidgetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceWidget/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<ServiceWidgetDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceWidget/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceWidgetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceWidgetDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ServiceWidgetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceWidgetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param templateId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, templateId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<ServiceWidgetDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceWidget/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (templateId === null)
            throw new globalThis.Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "TemplateId=" + encodeURIComponent("" + templateId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceWidgetDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceWidgetDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<ServiceWidgetDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceWidgetDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ShortTermObjectiveServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ShortTermObjective/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ShortTermResultServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ShortTermResult/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SignatureTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SignatureType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SocialAssistanceReferenceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateSocialAssistanceReferenceDto | undefined): Observable<SocialAssistanceReferenceDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialAssistanceReference/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialAssistanceReferenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialAssistanceReferenceDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SocialAssistanceReferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialAssistanceReferenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateSocialAssistanceReferenceDto | undefined): Observable<SocialAssistanceReferenceDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialAssistanceReference/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialAssistanceReferenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialAssistanceReferenceDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SocialAssistanceReferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialAssistanceReferenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialAssistanceReference/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SocialAssistanceReferenceDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialAssistanceReference/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialAssistanceReferenceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialAssistanceReferenceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SocialAssistanceReferenceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialAssistanceReferenceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param inputCardRecordId (optional) 
     * @param isPaged (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(inputCardRecordId: number | undefined, isPaged: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SocialAssistanceReferenceDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialAssistanceReference/GetAll?";
        if (inputCardRecordId === null)
            throw new globalThis.Error("The parameter 'inputCardRecordId' cannot be null.");
        else if (inputCardRecordId !== undefined)
            url_ += "InputCardRecordId=" + encodeURIComponent("" + inputCardRecordId) + "&";
        if (isPaged === null)
            throw new globalThis.Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialAssistanceReferenceDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialAssistanceReferenceDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SocialAssistanceReferenceDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialAssistanceReferenceDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SocialHealthRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getAllByUserId(userId: number | undefined): Observable<SocialHealthRecordDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealthRecord/GetAllByUserId?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialHealthRecordDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialHealthRecordDto[]>;
        }));
    }

    protected processGetAllByUserId(response: HttpResponseBase): Observable<SocialHealthRecordDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SocialHealthRecordDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceUserId (optional) 
     * @return Success
     */
    getByServiceUserId(serviceUserId: number | undefined): Observable<SocialHealthRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealthRecord/GetByServiceUserId?";
        if (serviceUserId === null)
            throw new globalThis.Error("The parameter 'serviceUserId' cannot be null.");
        else if (serviceUserId !== undefined)
            url_ += "serviceUserId=" + encodeURIComponent("" + serviceUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByServiceUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByServiceUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialHealthRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialHealthRecordDto>;
        }));
    }

    protected processGetByServiceUserId(response: HttpResponseBase): Observable<SocialHealthRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialHealthRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialHealthRecordId (optional) 
     * @param templateId (optional) 
     * @return Success
     */
    associateTemplateToSocialHalthRecord(socialHealthRecordId: number | undefined, templateId: number | undefined): Observable<SocialHealthRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealthRecord/AssociateTemplateToSocialHalthRecord?";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "socialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        if (templateId === null)
            throw new globalThis.Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssociateTemplateToSocialHalthRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssociateTemplateToSocialHalthRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialHealthRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialHealthRecordDto>;
        }));
    }

    protected processAssociateTemplateToSocialHalthRecord(response: HttpResponseBase): Observable<SocialHealthRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialHealthRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    associateTemplateToManySocialHealthRecords(body: AssociateTemplateToManyInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealthRecord/AssociateTemplateToManySocialHealthRecords";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssociateTemplateToManySocialHealthRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssociateTemplateToManySocialHealthRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssociateTemplateToManySocialHealthRecords(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @return Success
     */
    getTemplatesByServiceId(serviceId: number | undefined): Observable<ServiceUserSocialHealthRecordTemplateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealthRecord/GetTemplatesByServiceId?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "serviceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplatesByServiceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplatesByServiceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceUserSocialHealthRecordTemplateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceUserSocialHealthRecordTemplateDto[]>;
        }));
    }

    protected processGetTemplatesByServiceId(response: HttpResponseBase): Observable<ServiceUserSocialHealthRecordTemplateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceUserSocialHealthRecordTemplateDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceUserId (optional) 
     * @param socialHealthRecordId (optional) 
     * @return Success
     */
    deleteByServiceUserAndSocialHealthRecord(serviceUserId: number | undefined, socialHealthRecordId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealthRecord/DeleteByServiceUserAndSocialHealthRecord?";
        if (serviceUserId === null)
            throw new globalThis.Error("The parameter 'serviceUserId' cannot be null.");
        else if (serviceUserId !== undefined)
            url_ += "serviceUserId=" + encodeURIComponent("" + serviceUserId) + "&";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "socialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByServiceUserAndSocialHealthRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByServiceUserAndSocialHealthRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteByServiceUserAndSocialHealthRecord(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateSocialHealthRecordDto | undefined): Observable<SocialHealthRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealthRecord/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialHealthRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialHealthRecordDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SocialHealthRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialHealthRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateSocialHealthRecordDto | undefined): Observable<SocialHealthRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealthRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialHealthRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialHealthRecordDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SocialHealthRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialHealthRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealthRecord/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SocialHealthRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealthRecord/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialHealthRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialHealthRecordDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SocialHealthRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialHealthRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SocialHealthRecordDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealthRecord/GetAll?";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialHealthRecordDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialHealthRecordDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SocialHealthRecordDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialHealthRecordDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SocialHealthRecordExtensionDateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAll(body: CreateAllSocialHealthRecordExtensionDateDto | undefined): Observable<SocialHealthRecordExtensionDateDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealthRecordExtensionDate/CreateAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialHealthRecordExtensionDateDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialHealthRecordExtensionDateDto[]>;
        }));
    }

    protected processCreateAll(response: HttpResponseBase): Observable<SocialHealthRecordExtensionDateDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SocialHealthRecordExtensionDateDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateSocialHealthRecordExtensionDateDto | undefined): Observable<SocialHealthRecordExtensionDateDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealthRecordExtensionDate/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialHealthRecordExtensionDateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialHealthRecordExtensionDateDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SocialHealthRecordExtensionDateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialHealthRecordExtensionDateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateAllSocialHealthRecordExtensionDateDto | undefined): Observable<SocialHealthRecordExtensionDateDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealthRecordExtensionDate/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialHealthRecordExtensionDateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialHealthRecordExtensionDateDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SocialHealthRecordExtensionDateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialHealthRecordExtensionDateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealthRecordExtensionDate/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SocialHealthRecordExtensionDateDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealthRecordExtensionDate/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialHealthRecordExtensionDateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialHealthRecordExtensionDateDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SocialHealthRecordExtensionDateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialHealthRecordExtensionDateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialHealthRecordId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(socialHealthRecordId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SocialHealthRecordExtensionDateDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealthRecordExtensionDate/GetAll?";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "SocialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialHealthRecordExtensionDateDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialHealthRecordExtensionDateDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SocialHealthRecordExtensionDateDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialHealthRecordExtensionDateDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SocialHealthRecordOperatorPermissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAll(body: CreateSocialHealthRecordOperatorPermissionDto | undefined): Observable<SocialHealthRecordOperatorPermissionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealthRecordOperatorPermission/CreateAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialHealthRecordOperatorPermissionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialHealthRecordOperatorPermissionDto[]>;
        }));
    }

    protected processCreateAll(response: HttpResponseBase): Observable<SocialHealthRecordOperatorPermissionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SocialHealthRecordOperatorPermissionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialHealthRecordId (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getAll(socialHealthRecordId: number | undefined, sorting: string | undefined): Observable<SocialHealthRecordOperatorPermissionDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealthRecordOperatorPermission/GetAll?";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "SocialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialHealthRecordOperatorPermissionDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialHealthRecordOperatorPermissionDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SocialHealthRecordOperatorPermissionDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialHealthRecordOperatorPermissionDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SocialHealtRecordTemplateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    switchIsHidden(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealtRecordTemplate/SwitchIsHidden?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchIsHidden(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchIsHidden(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSwitchIsHidden(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateSocialHealtRecordTemplateDto | undefined): Observable<SocialHealtRecordTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealtRecordTemplate/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialHealtRecordTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialHealtRecordTemplateDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SocialHealtRecordTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialHealtRecordTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateSocialHealtRecordTemplateDto | undefined): Observable<SocialHealtRecordTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealtRecordTemplate/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialHealtRecordTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialHealtRecordTemplateDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SocialHealtRecordTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialHealtRecordTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealtRecordTemplate/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SocialHealtRecordTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealtRecordTemplate/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialHealtRecordTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialHealtRecordTemplateDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SocialHealtRecordTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialHealtRecordTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param widgetId (optional) 
     * @param isHidden (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, widgetId: number | undefined, isHidden: boolean | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SocialHealtRecordTemplateDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialHealtRecordTemplate/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (widgetId === null)
            throw new globalThis.Error("The parameter 'widgetId' cannot be null.");
        else if (widgetId !== undefined)
            url_ += "WidgetId=" + encodeURIComponent("" + widgetId) + "&";
        if (isHidden === null)
            throw new globalThis.Error("The parameter 'isHidden' cannot be null.");
        else if (isHidden !== undefined)
            url_ += "IsHidden=" + encodeURIComponent("" + isHidden) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialHealtRecordTemplateDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialHealtRecordTemplateDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SocialHealtRecordTemplateDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialHealtRecordTemplateDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SocialInvestigationRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateSocialInvestigationRecordDto | undefined): Observable<SocialInvestigationRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialInvestigationRecord/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialInvestigationRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialInvestigationRecordDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SocialInvestigationRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialInvestigationRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateSocialInvestigationRecordDto | undefined): Observable<SocialInvestigationRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialInvestigationRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialInvestigationRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialInvestigationRecordDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SocialInvestigationRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialInvestigationRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SocialInvestigationRecord/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SocialInvestigationRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialInvestigationRecord/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialInvestigationRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialInvestigationRecordDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SocialInvestigationRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialInvestigationRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialHealthRecordId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(socialHealthRecordId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SocialInvestigationRecordDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SocialInvestigationRecord/GetAll?";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "SocialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SocialInvestigationRecordDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SocialInvestigationRecordDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SocialInvestigationRecordDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SocialInvestigationRecordDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SomministrationMethodServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SomministrationMethod/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SpecialistAssessmentRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateSpecialistAssessmentRecordDto | undefined): Observable<SpecialistAssessmentRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/SpecialistAssessmentRecord/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpecialistAssessmentRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpecialistAssessmentRecordDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SpecialistAssessmentRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpecialistAssessmentRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateSpecialistAssessmentRecordDto | undefined): Observable<SpecialistAssessmentRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/SpecialistAssessmentRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpecialistAssessmentRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpecialistAssessmentRecordDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SpecialistAssessmentRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpecialistAssessmentRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SpecialistAssessmentRecord/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SpecialistAssessmentRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/SpecialistAssessmentRecord/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpecialistAssessmentRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpecialistAssessmentRecordDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SpecialistAssessmentRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpecialistAssessmentRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param socialHealtRecordId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, socialHealtRecordId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SpecialistAssessmentRecordDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SpecialistAssessmentRecord/GetAll?";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (socialHealtRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealtRecordId' cannot be null.");
        else if (socialHealtRecordId !== undefined)
            url_ += "SocialHealtRecordId=" + encodeURIComponent("" + socialHealtRecordId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpecialistAssessmentRecordDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpecialistAssessmentRecordDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SpecialistAssessmentRecordDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpecialistAssessmentRecordDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SpontaneousReportingEventServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    confirm(id: number | undefined): Observable<SpontaneousReportingEventDto> {
        let url_ = this.baseUrl + "/api/services/app/SpontaneousReportingEvent/Confirm?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpontaneousReportingEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpontaneousReportingEventDto>;
        }));
    }

    protected processConfirm(response: HttpResponseBase): Observable<SpontaneousReportingEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpontaneousReportingEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateSpontaneousReportingEventDto | undefined): Observable<SpontaneousReportingEventDto> {
        let url_ = this.baseUrl + "/api/services/app/SpontaneousReportingEvent/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpontaneousReportingEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpontaneousReportingEventDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<SpontaneousReportingEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpontaneousReportingEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateSpontaneousReportingEventDto | undefined): Observable<SpontaneousReportingEventDto> {
        let url_ = this.baseUrl + "/api/services/app/SpontaneousReportingEvent/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpontaneousReportingEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpontaneousReportingEventDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<SpontaneousReportingEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpontaneousReportingEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/SpontaneousReportingEvent/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<SpontaneousReportingEventDto> {
        let url_ = this.baseUrl + "/api/services/app/SpontaneousReportingEvent/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpontaneousReportingEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpontaneousReportingEventDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SpontaneousReportingEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpontaneousReportingEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialHealthRecordId (optional) 
     * @param keyword (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param isConfirmed (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(socialHealthRecordId: number | undefined, keyword: string | undefined, startDate: moment.Moment | undefined, endDate: moment.Moment | undefined, isConfirmed: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<SpontaneousReportingEventItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/SpontaneousReportingEvent/GetAll?";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "SocialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (isConfirmed === null)
            throw new globalThis.Error("The parameter 'isConfirmed' cannot be null.");
        else if (isConfirmed !== undefined)
            url_ += "IsConfirmed=" + encodeURIComponent("" + isConfirmed) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SpontaneousReportingEventItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SpontaneousReportingEventItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<SpontaneousReportingEventItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpontaneousReportingEventItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class StaffFactorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StaffFactor/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class StructureServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param structureId (optional) 
     * @param templateId (optional) 
     * @return Success
     */
    associateTemplateToStructure(structureId: number | undefined, templateId: number | undefined): Observable<StructureDto> {
        let url_ = this.baseUrl + "/api/services/app/Structure/AssociateTemplateToStructure?";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "structureId=" + encodeURIComponent("" + structureId) + "&";
        if (templateId === null)
            throw new globalThis.Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssociateTemplateToStructure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssociateTemplateToStructure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StructureDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StructureDto>;
        }));
    }

    protected processAssociateTemplateToStructure(response: HttpResponseBase): Observable<StructureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateStructureDto | undefined): Observable<StructureDto> {
        let url_ = this.baseUrl + "/api/services/app/Structure/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StructureDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StructureDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<StructureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateStructureDto | undefined): Observable<StructureDto> {
        let url_ = this.baseUrl + "/api/services/app/Structure/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StructureDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StructureDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<StructureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Structure/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<StructureDto> {
        let url_ = this.baseUrl + "/api/services/app/Structure/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StructureDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StructureDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StructureDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructureDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @param status (optional) 
     * @param ownershipTypeId (optional) 
     * @param serviceId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(name: string | undefined, status: boolean | undefined, ownershipTypeId: number | undefined, serviceId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StructureDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Structure/GetAll?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "Name=" + encodeURIComponent("" + name) + "&";
        if (status === null)
            throw new globalThis.Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (ownershipTypeId === null)
            throw new globalThis.Error("The parameter 'ownershipTypeId' cannot be null.");
        else if (ownershipTypeId !== undefined)
            url_ += "OwnershipTypeId=" + encodeURIComponent("" + ownershipTypeId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StructureDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StructureDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StructureDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructureDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class StructureDetailServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateStructureDetailDto | undefined): Observable<StructureDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/StructureDetail/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StructureDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StructureDetailDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<StructureDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructureDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateStructureDetailDto | undefined): Observable<StructureDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/StructureDetail/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StructureDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StructureDetailDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<StructureDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructureDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StructureDetail/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<StructureDetailDto> {
        let url_ = this.baseUrl + "/api/services/app/StructureDetail/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StructureDetailDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StructureDetailDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StructureDetailDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructureDetailDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param structureId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(structureId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StructureDetailDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StructureDetail/GetAll?";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StructureDetailDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StructureDetailDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StructureDetailDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructureDetailDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class StructureOwnershipTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/StructureOwnershipType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class StructureRegistryDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateStructureRegistryDataDto | undefined): Observable<StructureRegistryDataDto> {
        let url_ = this.baseUrl + "/api/services/app/StructureRegistryData/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StructureRegistryDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StructureRegistryDataDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<StructureRegistryDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructureRegistryDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateStructureRegistryDataDto | undefined): Observable<StructureRegistryDataDto> {
        let url_ = this.baseUrl + "/api/services/app/StructureRegistryData/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StructureRegistryDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StructureRegistryDataDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<StructureRegistryDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructureRegistryDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StructureRegistryData/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<StructureRegistryDataDto> {
        let url_ = this.baseUrl + "/api/services/app/StructureRegistryData/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StructureRegistryDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StructureRegistryDataDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StructureRegistryDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructureRegistryDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param structureId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(structureId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StructureRegistryDataDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StructureRegistryData/GetAll?";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StructureRegistryDataDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StructureRegistryDataDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StructureRegistryDataDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructureRegistryDataDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class StructureTemplateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    switchIsHidden(id: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/StructureTemplate/SwitchIsHidden?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchIsHidden(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchIsHidden(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSwitchIsHidden(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateStructureTemplateDto | undefined): Observable<StructureTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/StructureTemplate/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StructureTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StructureTemplateDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<StructureTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructureTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateStructureTemplateDto | undefined): Observable<StructureTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/StructureTemplate/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StructureTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StructureTemplateDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<StructureTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructureTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/StructureTemplate/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<StructureTemplateDto> {
        let url_ = this.baseUrl + "/api/services/app/StructureTemplate/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StructureTemplateDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StructureTemplateDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StructureTemplateDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructureTemplateDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param widgetId (optional) 
     * @param isHidden (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, widgetId: number | undefined, isHidden: boolean | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StructureTemplateDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StructureTemplate/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (widgetId === null)
            throw new globalThis.Error("The parameter 'widgetId' cannot be null.");
        else if (widgetId !== undefined)
            url_ += "WidgetId=" + encodeURIComponent("" + widgetId) + "&";
        if (isHidden === null)
            throw new globalThis.Error("The parameter 'isHidden' cannot be null.");
        else if (isHidden !== undefined)
            url_ += "IsHidden=" + encodeURIComponent("" + isHidden) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StructureTemplateDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StructureTemplateDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StructureTemplateDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructureTemplateDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class StructureWidgetServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<StructureWidgetDto> {
        let url_ = this.baseUrl + "/api/services/app/StructureWidget/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StructureWidgetDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StructureWidgetDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<StructureWidgetDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructureWidgetDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param templateId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, templateId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<StructureWidgetDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/StructureWidget/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (templateId === null)
            throw new globalThis.Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "TemplateId=" + encodeURIComponent("" + templateId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StructureWidgetDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StructureWidgetDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<StructureWidgetDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StructureWidgetDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SubTagServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param serviceId (optional) 
     * @param tagId (optional) 
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceId: number | undefined, tagId: number | undefined, keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SubTag/GetAll?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (tagId === null)
            throw new globalThis.Error("The parameter 'tagId' cannot be null.");
        else if (tagId !== undefined)
            url_ += "TagId=" + encodeURIComponent("" + tagId) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SystemFactorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/SystemFactor/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TagServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTagDto | undefined): Observable<TagDto> {
        let url_ = this.baseUrl + "/api/services/app/Tag/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TagDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TagDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceId: number | undefined, keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<TagDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Tag/GetAll?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TagDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TagDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TagDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TagDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TaskServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTaskDto | undefined): Observable<DictionaryDto> {
        let url_ = this.baseUrl + "/api/services/app/Task/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DictionaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DictionaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceId: number | undefined, keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Task/GetAll?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TenantDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new globalThis.Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TenantDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: TenantDto | undefined): Observable<TenantDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TenantDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TinettiAnswerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param tinettiQuestionId (optional) 
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(tinettiQuestionId: number | undefined, keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<TinettiAnswerDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TinettiAnswer/GetAll?";
        if (tinettiQuestionId === null)
            throw new globalThis.Error("The parameter 'tinettiQuestionId' cannot be null.");
        else if (tinettiQuestionId !== undefined)
            url_ += "TinettiQuestionId=" + encodeURIComponent("" + tinettiQuestionId) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TinettiAnswerDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TinettiAnswerDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TinettiAnswerDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TinettiAnswerDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TinettiPerformanceRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param currentId (optional) 
     * @param getPrevious (optional) 
     * @return Success
     */
    getForComparison(currentId: number | undefined, getPrevious: boolean | undefined): Observable<TinettiPerformanceRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/TinettiPerformanceRecord/GetForComparison?";
        if (currentId === null)
            throw new globalThis.Error("The parameter 'currentId' cannot be null.");
        else if (currentId !== undefined)
            url_ += "currentId=" + encodeURIComponent("" + currentId) + "&";
        if (getPrevious === null)
            throw new globalThis.Error("The parameter 'getPrevious' cannot be null.");
        else if (getPrevious !== undefined)
            url_ += "getPrevious=" + encodeURIComponent("" + getPrevious) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForComparison(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForComparison(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TinettiPerformanceRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TinettiPerformanceRecordDto>;
        }));
    }

    protected processGetForComparison(response: HttpResponseBase): Observable<TinettiPerformanceRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TinettiPerformanceRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateTinettiPerformanceRecordDto | undefined): Observable<TinettiPerformanceRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/TinettiPerformanceRecord/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TinettiPerformanceRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TinettiPerformanceRecordDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<TinettiPerformanceRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TinettiPerformanceRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTinettiPerformanceRecordDto | undefined): Observable<TinettiPerformanceRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/TinettiPerformanceRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TinettiPerformanceRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TinettiPerformanceRecordDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TinettiPerformanceRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TinettiPerformanceRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TinettiPerformanceRecord/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TinettiPerformanceRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/TinettiPerformanceRecord/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TinettiPerformanceRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TinettiPerformanceRecordDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TinettiPerformanceRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TinettiPerformanceRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param date (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(date: moment.Moment | undefined, socialHealtRecordId: number, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<TinettiPerformanceRecordItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TinettiPerformanceRecord/GetAll?";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        if (socialHealtRecordId === undefined || socialHealtRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealtRecordId' must be defined and cannot be null.");
        else
            url_ += "SocialHealtRecordId=" + encodeURIComponent("" + socialHealtRecordId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TinettiPerformanceRecordItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TinettiPerformanceRecordItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TinettiPerformanceRecordItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TinettiPerformanceRecordItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TinettiPerformanceRecordAnswerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTinettiPerformanceRecordAnswerDto | undefined): Observable<TinettiPerformanceRecordAnswerDto> {
        let url_ = this.baseUrl + "/api/services/app/TinettiPerformanceRecordAnswer/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TinettiPerformanceRecordAnswerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TinettiPerformanceRecordAnswerDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<TinettiPerformanceRecordAnswerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TinettiPerformanceRecordAnswerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TinettiPerformanceRecordAnswer/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TinettiPerformanceRecordAnswerDto> {
        let url_ = this.baseUrl + "/api/services/app/TinettiPerformanceRecordAnswer/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TinettiPerformanceRecordAnswerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TinettiPerformanceRecordAnswerDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TinettiPerformanceRecordAnswerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TinettiPerformanceRecordAnswerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: TinettiPerformanceRecordAnswerGetAllInput | undefined): Observable<TinettiPerformanceRecordAnswerDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/TinettiPerformanceRecordAnswer/GetAll?";
        if (input === null)
            throw new globalThis.Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TinettiPerformanceRecordAnswerDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TinettiPerformanceRecordAnswerDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TinettiPerformanceRecordAnswerDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TinettiPerformanceRecordAnswerDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TinettiQuestionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param tinettiTypeId (optional) 
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(tinettiTypeId: number | undefined, keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<TinettiQuestionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TinettiQuestion/GetAll?";
        if (tinettiTypeId === null)
            throw new globalThis.Error("The parameter 'tinettiTypeId' cannot be null.");
        else if (tinettiTypeId !== undefined)
            url_ += "TinettiTypeId=" + encodeURIComponent("" + tinettiTypeId) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TinettiQuestionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TinettiQuestionDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TinettiQuestionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TinettiQuestionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TinettiTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TinettiType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TitleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Title/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TreatmentProgramServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentProgram/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class TreatmentTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/TreatmentType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UMVDServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUMVDDto | undefined): Observable<UMVDDto> {
        let url_ = this.baseUrl + "/api/services/app/UMVD/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UMVDDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UMVDDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UMVDDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UMVDDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUMVDDto | undefined): Observable<UMVDDto> {
        let url_ = this.baseUrl + "/api/services/app/UMVD/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UMVDDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UMVDDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UMVDDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UMVDDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UMVD/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UMVDDto> {
        let url_ = this.baseUrl + "/api/services/app/UMVD/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UMVDDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UMVDDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UMVDDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UMVDDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param inputCardRecordId (optional) 
     * @param isPaged (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(inputCardRecordId: number | undefined, isPaged: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UMVDDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/UMVD/GetAll?";
        if (inputCardRecordId === null)
            throw new globalThis.Error("The parameter 'inputCardRecordId' cannot be null.");
        else if (inputCardRecordId !== undefined)
            url_ += "InputCardRecordId=" + encodeURIComponent("" + inputCardRecordId) + "&";
        if (isPaged === null)
            throw new globalThis.Error("The parameter 'isPaged' cannot be null.");
        else if (isPaged !== undefined)
            url_ += "IsPaged=" + encodeURIComponent("" + isPaged) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UMVDDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UMVDDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UMVDDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UMVDDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param isActive (optional) 
     * @param roleId (optional) 
     * @param permissionName (optional) 
     * @param customDataField (optional) 
     * @param serviceId (optional) 
     * @param includeArchived (optional) 
     * @param isArchived (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, isActive: boolean | undefined, roleId: number | undefined, permissionName: string | undefined, customDataField: string | undefined, serviceId: number | undefined, includeArchived: boolean | undefined, isArchived: boolean | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<UserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (isActive === null)
            throw new globalThis.Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (roleId === null)
            throw new globalThis.Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (permissionName === null)
            throw new globalThis.Error("The parameter 'permissionName' cannot be null.");
        else if (permissionName !== undefined)
            url_ += "PermissionName=" + encodeURIComponent("" + permissionName) + "&";
        if (customDataField === null)
            throw new globalThis.Error("The parameter 'customDataField' cannot be null.");
        else if (customDataField !== undefined)
            url_ += "customDataField=" + encodeURIComponent("" + customDataField) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (includeArchived === null)
            throw new globalThis.Error("The parameter 'includeArchived' cannot be null.");
        else if (includeArchived !== undefined)
            url_ += "IncludeArchived=" + encodeURIComponent("" + includeArchived) + "&";
        if (isArchived === null)
            throw new globalThis.Error("The parameter 'isArchived' cannot be null.");
        else if (isArchived !== undefined)
            url_ += "IsArchived=" + encodeURIComponent("" + isArchived) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<UserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateUserDto | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyProfile(): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetMyProfile";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGetMyProfile(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getMyGuid(): Observable<UserGuidDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetMyGuid";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMyGuid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMyGuid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserGuidDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserGuidDto>;
        }));
    }

    protected processGetMyGuid(response: HttpResponseBase): Observable<UserGuidDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserGuidDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    toggleActivationUser(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ToggleActivationUser?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToggleActivationUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToggleActivationUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processToggleActivationUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    archiveUser(body: ArchiveUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ArchiveUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchiveUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchiveUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArchiveUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param unblockAccount (optional) 
     * @return Success
     */
    unarchiveUser(userId: number | undefined, unblockAccount: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnarchiveUser?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (unblockAccount === null)
            throw new globalThis.Error("The parameter 'unblockAccount' cannot be null.");
        else if (unblockAccount !== undefined)
            url_ += "unblockAccount=" + encodeURIComponent("" + unblockAccount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnarchiveUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnarchiveUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnarchiveUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    unlockLogin(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockLogin?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockLogin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forceResetPassword(body: ForceResetPasswordDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/User/ForceResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForceResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForceResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processForceResetPassword(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VehicleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateVehicleDto | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/api/services/app/Vehicle/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateVehicleDto | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/api/services/app/Vehicle/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Vehicle/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<VehicleDto> {
        let url_ = this.baseUrl + "/api/services/app/Vehicle/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VehicleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param vehicleTypeId (optional) 
     * @param rentalCompanyId (optional) 
     * @param engineCategory (optional) 
     * @param equipped (optional) 
     * @param ownershipId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, vehicleTypeId: number | undefined, rentalCompanyId: number | undefined, engineCategory: string | undefined, equipped: boolean | undefined, ownershipId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<VehicleItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/Vehicle/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (vehicleTypeId === null)
            throw new globalThis.Error("The parameter 'vehicleTypeId' cannot be null.");
        else if (vehicleTypeId !== undefined)
            url_ += "VehicleTypeId=" + encodeURIComponent("" + vehicleTypeId) + "&";
        if (rentalCompanyId === null)
            throw new globalThis.Error("The parameter 'rentalCompanyId' cannot be null.");
        else if (rentalCompanyId !== undefined)
            url_ += "RentalCompanyId=" + encodeURIComponent("" + rentalCompanyId) + "&";
        if (engineCategory === null)
            throw new globalThis.Error("The parameter 'engineCategory' cannot be null.");
        else if (engineCategory !== undefined)
            url_ += "EngineCategory=" + encodeURIComponent("" + engineCategory) + "&";
        if (equipped === null)
            throw new globalThis.Error("The parameter 'equipped' cannot be null.");
        else if (equipped !== undefined)
            url_ += "Equipped=" + encodeURIComponent("" + equipped) + "&";
        if (ownershipId === null)
            throw new globalThis.Error("The parameter 'ownershipId' cannot be null.");
        else if (ownershipId !== undefined)
            url_ += "OwnershipId=" + encodeURIComponent("" + ownershipId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<VehicleItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VehicleAdditionalDataServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param vehicleId (optional) 
     * @return Success
     */
    getByVehicleId(vehicleId: number | undefined): Observable<VehicleAdditionalDataDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleAdditionalData/GetByVehicleId?";
        if (vehicleId === null)
            throw new globalThis.Error("The parameter 'vehicleId' cannot be null.");
        else if (vehicleId !== undefined)
            url_ += "vehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByVehicleId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByVehicleId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleAdditionalDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleAdditionalDataDto>;
        }));
    }

    protected processGetByVehicleId(response: HttpResponseBase): Observable<VehicleAdditionalDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleAdditionalDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateVehicleAdditionalDataDto | undefined): Observable<VehicleAdditionalDataDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleAdditionalData/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleAdditionalDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleAdditionalDataDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<VehicleAdditionalDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleAdditionalDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateVehicleAdditionalDataDto | undefined): Observable<VehicleAdditionalDataDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleAdditionalData/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleAdditionalDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleAdditionalDataDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<VehicleAdditionalDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleAdditionalDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VehicleAdditionalData/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<VehicleAdditionalDataDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleAdditionalData/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleAdditionalDataDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleAdditionalDataDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VehicleAdditionalDataDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleAdditionalDataDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<VehicleAdditionalDataDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleAdditionalData/GetAll?";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleAdditionalDataDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleAdditionalDataDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<VehicleAdditionalDataDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleAdditionalDataDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VehicleServiceUserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateVehicleServiceUserDto | undefined): Observable<VehicleServiceUserDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleServiceUser/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleServiceUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleServiceUserDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<VehicleServiceUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleServiceUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateVehicleServiceUserDto | undefined): Observable<VehicleServiceUserDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleServiceUser/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleServiceUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleServiceUserDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<VehicleServiceUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleServiceUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VehicleServiceUser/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<VehicleServiceUserDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleServiceUser/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleServiceUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleServiceUserDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VehicleServiceUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleServiceUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param serviceId (optional) 
     * @param userId (optional) 
     * @param vehicleId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, serviceId: number | undefined, userId: number | undefined, vehicleId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<VehicleServiceUserDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/VehicleServiceUser/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (vehicleId === null)
            throw new globalThis.Error("The parameter 'vehicleId' cannot be null.");
        else if (vehicleId !== undefined)
            url_ += "VehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VehicleServiceUserDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VehicleServiceUserDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<VehicleServiceUserDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VehicleServiceUserDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VehicleTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VehicleType/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VerbalNoteServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateVerbalNoteDto | undefined): Observable<VerbalNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/VerbalNote/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VerbalNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VerbalNoteDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<VerbalNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerbalNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateVerbalNoteDto | undefined): Observable<VerbalNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/VerbalNote/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VerbalNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VerbalNoteDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<VerbalNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerbalNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VerbalNote/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<VerbalNoteDto> {
        let url_ = this.baseUrl + "/api/services/app/VerbalNote/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VerbalNoteDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VerbalNoteDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VerbalNoteDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerbalNoteDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param verbalId (optional) 
     * @param beneficiaryId (optional) 
     * @param keyword (optional) 
     * @param verbalTagId (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(verbalId: number | undefined, beneficiaryId: number | undefined, keyword: string | undefined, verbalTagId: number | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<VerbalNoteDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/VerbalNote/GetAll?";
        if (verbalId === null)
            throw new globalThis.Error("The parameter 'verbalId' cannot be null.");
        else if (verbalId !== undefined)
            url_ += "VerbalId=" + encodeURIComponent("" + verbalId) + "&";
        if (beneficiaryId === null)
            throw new globalThis.Error("The parameter 'beneficiaryId' cannot be null.");
        else if (beneficiaryId !== undefined)
            url_ += "BeneficiaryId=" + encodeURIComponent("" + beneficiaryId) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (verbalTagId === null)
            throw new globalThis.Error("The parameter 'verbalTagId' cannot be null.");
        else if (verbalTagId !== undefined)
            url_ += "VerbalTagId=" + encodeURIComponent("" + verbalTagId) + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VerbalNoteDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VerbalNoteDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<VerbalNoteDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VerbalNoteDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VerbalTagServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateVerbalTagDto | undefined): Observable<DictionaryDto> {
        let url_ = this.baseUrl + "/api/services/app/VerbalTag/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<DictionaryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DictionaryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceId (optional) 
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(serviceId: number | undefined, keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VerbalTag/GetAll?";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VerificationCadenceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VerificationCadence/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VideoSurveillanceSystemServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param structureId (optional) 
     * @param serviceId (optional) 
     * @return Success
     */
    getAllBase(structureId: number | undefined, serviceId: number | undefined): Observable<VideoSurveillanceSystemBaseDto[]> {
        let url_ = this.baseUrl + "/api/services/app/VideoSurveillanceSystem/GetAllBase?";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VideoSurveillanceSystemBaseDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VideoSurveillanceSystemBaseDto[]>;
        }));
    }

    protected processGetAllBase(response: HttpResponseBase): Observable<VideoSurveillanceSystemBaseDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(VideoSurveillanceSystemBaseDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateVideoSurveillanceSystemDto | undefined): Observable<VideoSurveillanceSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/VideoSurveillanceSystem/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VideoSurveillanceSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VideoSurveillanceSystemDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<VideoSurveillanceSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideoSurveillanceSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateVideoSurveillanceSystemDto | undefined): Observable<VideoSurveillanceSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/VideoSurveillanceSystem/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VideoSurveillanceSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VideoSurveillanceSystemDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<VideoSurveillanceSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideoSurveillanceSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VideoSurveillanceSystem/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<VideoSurveillanceSystemDto> {
        let url_ = this.baseUrl + "/api/services/app/VideoSurveillanceSystem/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VideoSurveillanceSystemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VideoSurveillanceSystemDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VideoSurveillanceSystemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideoSurveillanceSystemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param keyword (optional) 
     * @param structureId (optional) 
     * @param serviceId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, structureId: number | undefined, serviceId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<VideoSurveillanceSystemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/VideoSurveillanceSystem/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (structureId === null)
            throw new globalThis.Error("The parameter 'structureId' cannot be null.");
        else if (structureId !== undefined)
            url_ += "StructureId=" + encodeURIComponent("" + structureId) + "&";
        if (serviceId === null)
            throw new globalThis.Error("The parameter 'serviceId' cannot be null.");
        else if (serviceId !== undefined)
            url_ += "ServiceId=" + encodeURIComponent("" + serviceId) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VideoSurveillanceSystemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VideoSurveillanceSystemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<VideoSurveillanceSystemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VideoSurveillanceSystemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class VitalSignRecordServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateVitalSignRecordDto | undefined): Observable<VitalSignRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/VitalSignRecord/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VitalSignRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VitalSignRecordDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<VitalSignRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VitalSignRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateVitalSignRecordDto | undefined): Observable<VitalSignRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/VitalSignRecord/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VitalSignRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VitalSignRecordDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<VitalSignRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VitalSignRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/VitalSignRecord/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<VitalSignRecordDto> {
        let url_ = this.baseUrl + "/api/services/app/VitalSignRecord/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VitalSignRecordDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VitalSignRecordDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VitalSignRecordDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VitalSignRecordDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param socialHealthRecordId (optional) 
     * @param fromDate (optional) 
     * @param toDate (optional) 
     * @param isPaginated (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(socialHealthRecordId: number | undefined, fromDate: moment.Moment | undefined, toDate: moment.Moment | undefined, isPaginated: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<VitalSignRecordItemDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/VitalSignRecord/GetAll?";
        if (socialHealthRecordId === null)
            throw new globalThis.Error("The parameter 'socialHealthRecordId' cannot be null.");
        else if (socialHealthRecordId !== undefined)
            url_ += "SocialHealthRecordId=" + encodeURIComponent("" + socialHealthRecordId) + "&";
        if (fromDate === null)
            throw new globalThis.Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toISOString() : "") + "&";
        if (toDate === null)
            throw new globalThis.Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toISOString() : "") + "&";
        if (isPaginated === null)
            throw new globalThis.Error("The parameter 'isPaginated' cannot be null.");
        else if (isPaginated !== undefined)
            url_ += "IsPaginated=" + encodeURIComponent("" + isPaginated) + "&";
        if (sorting === null)
            throw new globalThis.Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new globalThis.Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VitalSignRecordItemDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VitalSignRecordItemDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<VitalSignRecordItemDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VitalSignRecordItemDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WalkingModeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/WalkingMode/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WeeklyFrequenceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/WeeklyFrequence/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WeightDetectionEntryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateWeightDetectionEntryDto | undefined): Observable<WeightDetectionEntryDto> {
        let url_ = this.baseUrl + "/api/services/app/WeightDetectionEntry/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeightDetectionEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeightDetectionEntryDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WeightDetectionEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeightDetectionEntryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateWeightDetectionEntryDto | undefined): Observable<WeightDetectionEntryDto> {
        let url_ = this.baseUrl + "/api/services/app/WeightDetectionEntry/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeightDetectionEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeightDetectionEntryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<WeightDetectionEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeightDetectionEntryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WeightDetectionEntry/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<WeightDetectionEntryDto> {
        let url_ = this.baseUrl + "/api/services/app/WeightDetectionEntry/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeightDetectionEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeightDetectionEntryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WeightDetectionEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeightDetectionEntryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serviceWeightDetectionId (optional) 
     * @return Success
     */
    getAll(serviceWeightDetectionId: number | undefined): Observable<WeightDetectionEntryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/WeightDetectionEntry/GetAll?";
        if (serviceWeightDetectionId === null)
            throw new globalThis.Error("The parameter 'serviceWeightDetectionId' cannot be null.");
        else if (serviceWeightDetectionId !== undefined)
            url_ += "ServiceWeightDetectionId=" + encodeURIComponent("" + serviceWeightDetectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeightDetectionEntryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeightDetectionEntryDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WeightDetectionEntryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeightDetectionEntryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WeightDetectionMonthEntryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateWeightDetectionMonthEntryDto | undefined): Observable<WeightDetectionMonthEntryDto> {
        let url_ = this.baseUrl + "/api/services/app/WeightDetectionMonthEntry/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeightDetectionMonthEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeightDetectionMonthEntryDto>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<WeightDetectionMonthEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeightDetectionMonthEntryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateWeightDetectionMonthEntryDto | undefined): Observable<WeightDetectionMonthEntryDto> {
        let url_ = this.baseUrl + "/api/services/app/WeightDetectionMonthEntry/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeightDetectionMonthEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeightDetectionMonthEntryDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<WeightDetectionMonthEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeightDetectionMonthEntryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WeightDetectionMonthEntry/Delete?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<WeightDetectionMonthEntryDto> {
        let url_ = this.baseUrl + "/api/services/app/WeightDetectionMonthEntry/Get?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeightDetectionMonthEntryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeightDetectionMonthEntryDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<WeightDetectionMonthEntryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeightDetectionMonthEntryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param weightDetectionEntryId (optional) 
     * @return Success
     */
    getAll(weightDetectionEntryId: number | undefined): Observable<WeightDetectionMonthEntryDtoPagedResultDto> {
        let url_ = this.baseUrl + "/api/services/app/WeightDetectionMonthEntry/GetAll?";
        if (weightDetectionEntryId === null)
            throw new globalThis.Error("The parameter 'weightDetectionEntryId' cannot be null.");
        else if (weightDetectionEntryId !== undefined)
            url_ += "WeightDetectionEntryId=" + encodeURIComponent("" + weightDetectionEntryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WeightDetectionMonthEntryDtoPagedResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WeightDetectionMonthEntryDtoPagedResultDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<WeightDetectionMonthEntryDtoPagedResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WeightDetectionMonthEntryDtoPagedResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WheelChairUserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param keyword (optional) 
     * @param localizeValues (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(keyword: string | undefined, localizeValues: boolean | undefined, maxResultCount: number | undefined): Observable<DictionaryDto[]> {
        let url_ = this.baseUrl + "/api/services/app/WheelChairUser/GetAll?";
        if (keyword === null)
            throw new globalThis.Error("The parameter 'keyword' cannot be null.");
        else if (keyword !== undefined)
            url_ += "Keyword=" + encodeURIComponent("" + keyword) + "&";
        if (localizeValues === null)
            throw new globalThis.Error("The parameter 'localizeValues' cannot be null.");
        else if (localizeValues !== undefined)
            url_ += "LocalizeValues=" + encodeURIComponent("" + localizeValues) + "&";
        if (maxResultCount === null)
            throw new globalThis.Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DictionaryDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DictionaryDto[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<DictionaryDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DictionaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class ActivityDto implements IActivityDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;
    startDateTime!: moment.Moment;
    endDateTime!: moment.Moment;
    badgeInDateTime!: moment.Moment | undefined;
    badgeOutDateTime!: moment.Moment | undefined;
    note!: string | undefined;
    actualActivityMinutes!: number;
    isAbsent!: boolean | undefined;
    reasonAbsence!: string | undefined;
    service!: ServiceDto;
    status!: DictionaryDto;
    activityPlaces!: ActivityPlaceDto[] | undefined;
    files!: FileDto[] | undefined;
    recurrenceRule!: string | undefined;
    recurrenceException!: string | undefined;
    plannedActivityMinutes!: number;
    cancellationReason!: string | undefined;
    qualification!: DictionaryDto;
    activityUsers!: ActivityUserDto[] | undefined;

    constructor(data?: IActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : undefined as any;
            this.badgeInDateTime = _data["badgeInDateTime"] ? moment(_data["badgeInDateTime"].toString()) : undefined as any;
            this.badgeOutDateTime = _data["badgeOutDateTime"] ? moment(_data["badgeOutDateTime"].toString()) : undefined as any;
            this.note = _data["note"];
            this.actualActivityMinutes = _data["actualActivityMinutes"];
            this.isAbsent = _data["isAbsent"];
            this.reasonAbsence = _data["reasonAbsence"];
            this.service = _data["service"] ? ServiceDto.fromJS(_data["service"]) : undefined as any;
            this.status = _data["status"] ? DictionaryDto.fromJS(_data["status"]) : undefined as any;
            if (Array.isArray(_data["activityPlaces"])) {
                this.activityPlaces = [] as any;
                for (let item of _data["activityPlaces"])
                    this.activityPlaces!.push(ActivityPlaceDto.fromJS(item));
            }
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileDto.fromJS(item));
            }
            this.recurrenceRule = _data["recurrenceRule"];
            this.recurrenceException = _data["recurrenceException"];
            this.plannedActivityMinutes = _data["plannedActivityMinutes"];
            this.cancellationReason = _data["cancellationReason"];
            this.qualification = _data["qualification"] ? DictionaryDto.fromJS(_data["qualification"]) : undefined as any;
            if (Array.isArray(_data["activityUsers"])) {
                this.activityUsers = [] as any;
                for (let item of _data["activityUsers"])
                    this.activityUsers!.push(ActivityUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined as any;
        data["badgeInDateTime"] = this.badgeInDateTime ? this.badgeInDateTime.toISOString() : undefined as any;
        data["badgeOutDateTime"] = this.badgeOutDateTime ? this.badgeOutDateTime.toISOString() : undefined as any;
        data["note"] = this.note;
        data["actualActivityMinutes"] = this.actualActivityMinutes;
        data["isAbsent"] = this.isAbsent;
        data["reasonAbsence"] = this.reasonAbsence;
        data["service"] = this.service ? this.service.toJSON() : undefined as any;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        if (Array.isArray(this.activityPlaces)) {
            data["activityPlaces"] = [];
            for (let item of this.activityPlaces)
                data["activityPlaces"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item ? item.toJSON() : undefined as any);
        }
        data["recurrenceRule"] = this.recurrenceRule;
        data["recurrenceException"] = this.recurrenceException;
        data["plannedActivityMinutes"] = this.plannedActivityMinutes;
        data["cancellationReason"] = this.cancellationReason;
        data["qualification"] = this.qualification ? this.qualification.toJSON() : undefined as any;
        if (Array.isArray(this.activityUsers)) {
            data["activityUsers"] = [];
            for (let item of this.activityUsers)
                data["activityUsers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ActivityDto {
        const json = this.toJSON();
        let result = new ActivityDto();
        result.init(json);
        return result;
    }
}

export interface IActivityDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    startDateTime: moment.Moment;
    endDateTime: moment.Moment;
    badgeInDateTime: moment.Moment | undefined;
    badgeOutDateTime: moment.Moment | undefined;
    note: string | undefined;
    actualActivityMinutes: number;
    isAbsent: boolean | undefined;
    reasonAbsence: string | undefined;
    service: ServiceDto;
    status: DictionaryDto;
    activityPlaces: ActivityPlaceDto[] | undefined;
    files: FileDto[] | undefined;
    recurrenceRule: string | undefined;
    recurrenceException: string | undefined;
    plannedActivityMinutes: number;
    cancellationReason: string | undefined;
    qualification: DictionaryDto;
    activityUsers: ActivityUserDto[] | undefined;
}

export class ActivityDtoListResultDto implements IActivityDtoListResultDto {
    items!: ActivityDto[] | undefined;

    constructor(data?: IActivityDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ActivityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ActivityDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ActivityDtoListResultDto {
        const json = this.toJSON();
        let result = new ActivityDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IActivityDtoListResultDto {
    items: ActivityDto[] | undefined;
}

export class ActivityDtoPagedResultDto implements IActivityDtoPagedResultDto {
    items!: ActivityDto[] | undefined;
    totalCount!: number;

    constructor(data?: IActivityDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ActivityDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ActivityDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ActivityDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ActivityDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IActivityDtoPagedResultDto {
    items: ActivityDto[] | undefined;
    totalCount: number;
}

export class ActivityGetAllInput implements IActivityGetAllInput {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    isPaginated!: boolean;
    keyword!: string | undefined;
    serviceIds!: number[] | undefined;
    beneficiaryIds!: number[] | undefined;
    operatorIds!: number[] | undefined;
    placeIds!: number[] | undefined;
    hasNote!: boolean;

    constructor(data?: IActivityGetAllInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.isPaginated = _data["isPaginated"];
            this.keyword = _data["keyword"];
            if (Array.isArray(_data["serviceIds"])) {
                this.serviceIds = [] as any;
                for (let item of _data["serviceIds"])
                    this.serviceIds!.push(item);
            }
            if (Array.isArray(_data["beneficiaryIds"])) {
                this.beneficiaryIds = [] as any;
                for (let item of _data["beneficiaryIds"])
                    this.beneficiaryIds!.push(item);
            }
            if (Array.isArray(_data["operatorIds"])) {
                this.operatorIds = [] as any;
                for (let item of _data["operatorIds"])
                    this.operatorIds!.push(item);
            }
            if (Array.isArray(_data["placeIds"])) {
                this.placeIds = [] as any;
                for (let item of _data["placeIds"])
                    this.placeIds!.push(item);
            }
            this.hasNote = _data["hasNote"];
        }
    }

    static fromJS(data: any): ActivityGetAllInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityGetAllInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["isPaginated"] = this.isPaginated;
        data["keyword"] = this.keyword;
        if (Array.isArray(this.serviceIds)) {
            data["serviceIds"] = [];
            for (let item of this.serviceIds)
                data["serviceIds"].push(item);
        }
        if (Array.isArray(this.beneficiaryIds)) {
            data["beneficiaryIds"] = [];
            for (let item of this.beneficiaryIds)
                data["beneficiaryIds"].push(item);
        }
        if (Array.isArray(this.operatorIds)) {
            data["operatorIds"] = [];
            for (let item of this.operatorIds)
                data["operatorIds"].push(item);
        }
        if (Array.isArray(this.placeIds)) {
            data["placeIds"] = [];
            for (let item of this.placeIds)
                data["placeIds"].push(item);
        }
        data["hasNote"] = this.hasNote;
        return data;
    }

    clone(): ActivityGetAllInput {
        const json = this.toJSON();
        let result = new ActivityGetAllInput();
        result.init(json);
        return result;
    }
}

export interface IActivityGetAllInput {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    isPaginated: boolean;
    keyword: string | undefined;
    serviceIds: number[] | undefined;
    beneficiaryIds: number[] | undefined;
    operatorIds: number[] | undefined;
    placeIds: number[] | undefined;
    hasNote: boolean;
}

export class ActivityItemDto implements IActivityItemDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IActivityItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ActivityItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): ActivityItemDto {
        const json = this.toJSON();
        let result = new ActivityItemDto();
        result.init(json);
        return result;
    }
}

export interface IActivityItemDto {
    id: number;
    name: string | undefined;
}

export class ActivityOverlapCheckInput implements IActivityOverlapCheckInput {
    activityId!: number | undefined;
    startDateTime!: moment.Moment;
    endDateTime!: moment.Moment;
    recurrenceRule!: string | undefined;
    recurrenceException!: string | undefined;
    serviceOperatorIds!: number[] | undefined;
    serviceBeneficiaryIds!: number[] | undefined;

    constructor(data?: IActivityOverlapCheckInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityId = _data["activityId"];
            this.startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : undefined as any;
            this.recurrenceRule = _data["recurrenceRule"];
            this.recurrenceException = _data["recurrenceException"];
            if (Array.isArray(_data["serviceOperatorIds"])) {
                this.serviceOperatorIds = [] as any;
                for (let item of _data["serviceOperatorIds"])
                    this.serviceOperatorIds!.push(item);
            }
            if (Array.isArray(_data["serviceBeneficiaryIds"])) {
                this.serviceBeneficiaryIds = [] as any;
                for (let item of _data["serviceBeneficiaryIds"])
                    this.serviceBeneficiaryIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ActivityOverlapCheckInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityOverlapCheckInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityId"] = this.activityId;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined as any;
        data["recurrenceRule"] = this.recurrenceRule;
        data["recurrenceException"] = this.recurrenceException;
        if (Array.isArray(this.serviceOperatorIds)) {
            data["serviceOperatorIds"] = [];
            for (let item of this.serviceOperatorIds)
                data["serviceOperatorIds"].push(item);
        }
        if (Array.isArray(this.serviceBeneficiaryIds)) {
            data["serviceBeneficiaryIds"] = [];
            for (let item of this.serviceBeneficiaryIds)
                data["serviceBeneficiaryIds"].push(item);
        }
        return data;
    }

    clone(): ActivityOverlapCheckInput {
        const json = this.toJSON();
        let result = new ActivityOverlapCheckInput();
        result.init(json);
        return result;
    }
}

export interface IActivityOverlapCheckInput {
    activityId: number | undefined;
    startDateTime: moment.Moment;
    endDateTime: moment.Moment;
    recurrenceRule: string | undefined;
    recurrenceException: string | undefined;
    serviceOperatorIds: number[] | undefined;
    serviceBeneficiaryIds: number[] | undefined;
}

export class ActivityOverlapDto implements IActivityOverlapDto {
    userFullName!: string | undefined;
    isOperator!: boolean;
    firstStartDateTime!: moment.Moment;
    firstEndDateTime!: moment.Moment;
    occurrenceCount!: number;
    serviceName!: string | undefined;
    activityName!: string | undefined;

    constructor(data?: IActivityOverlapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userFullName = _data["userFullName"];
            this.isOperator = _data["isOperator"];
            this.firstStartDateTime = _data["firstStartDateTime"] ? moment(_data["firstStartDateTime"].toString()) : undefined as any;
            this.firstEndDateTime = _data["firstEndDateTime"] ? moment(_data["firstEndDateTime"].toString()) : undefined as any;
            this.occurrenceCount = _data["occurrenceCount"];
            this.serviceName = _data["serviceName"];
            this.activityName = _data["activityName"];
        }
    }

    static fromJS(data: any): ActivityOverlapDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityOverlapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userFullName"] = this.userFullName;
        data["isOperator"] = this.isOperator;
        data["firstStartDateTime"] = this.firstStartDateTime ? this.firstStartDateTime.toISOString() : undefined as any;
        data["firstEndDateTime"] = this.firstEndDateTime ? this.firstEndDateTime.toISOString() : undefined as any;
        data["occurrenceCount"] = this.occurrenceCount;
        data["serviceName"] = this.serviceName;
        data["activityName"] = this.activityName;
        return data;
    }

    clone(): ActivityOverlapDto {
        const json = this.toJSON();
        let result = new ActivityOverlapDto();
        result.init(json);
        return result;
    }
}

export interface IActivityOverlapDto {
    userFullName: string | undefined;
    isOperator: boolean;
    firstStartDateTime: moment.Moment;
    firstEndDateTime: moment.Moment;
    occurrenceCount: number;
    serviceName: string | undefined;
    activityName: string | undefined;
}

export class ActivityPlaceDto implements IActivityPlaceDto {
    id!: number;
    activity!: ActivityItemDto;
    place!: DictionaryDto;

    constructor(data?: IActivityPlaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activity = _data["activity"] ? ActivityItemDto.fromJS(_data["activity"]) : undefined as any;
            this.place = _data["place"] ? DictionaryDto.fromJS(_data["place"]) : undefined as any;
        }
    }

    static fromJS(data: any): ActivityPlaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityPlaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activity"] = this.activity ? this.activity.toJSON() : undefined as any;
        data["place"] = this.place ? this.place.toJSON() : undefined as any;
        return data;
    }

    clone(): ActivityPlaceDto {
        const json = this.toJSON();
        let result = new ActivityPlaceDto();
        result.init(json);
        return result;
    }
}

export interface IActivityPlaceDto {
    id: number;
    activity: ActivityItemDto;
    place: DictionaryDto;
}

export class ActivityUserDto implements IActivityUserDto {
    id!: number;
    serviceUser!: ServiceUserDto;
    activity!: ActivityItemDto;

    constructor(data?: IActivityUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceUser = _data["serviceUser"] ? ServiceUserDto.fromJS(_data["serviceUser"]) : undefined as any;
            this.activity = _data["activity"] ? ActivityItemDto.fromJS(_data["activity"]) : undefined as any;
        }
    }

    static fromJS(data: any): ActivityUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceUser"] = this.serviceUser ? this.serviceUser.toJSON() : undefined as any;
        data["activity"] = this.activity ? this.activity.toJSON() : undefined as any;
        return data;
    }

    clone(): ActivityUserDto {
        const json = this.toJSON();
        let result = new ActivityUserDto();
        result.init(json);
        return result;
    }
}

export interface IActivityUserDto {
    id: number;
    serviceUser: ServiceUserDto;
    activity: ActivityItemDto;
}

export class ActivityUserDtoPagedResultDto implements IActivityUserDtoPagedResultDto {
    items!: ActivityUserDto[] | undefined;
    totalCount!: number;

    constructor(data?: IActivityUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ActivityUserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ActivityUserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityUserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ActivityUserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ActivityUserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IActivityUserDtoPagedResultDto {
    items: ActivityUserDto[] | undefined;
    totalCount: number;
}

export class AddressDto implements IAddressDto {
    id!: number;
    streetName!: string | undefined;
    streetNumber!: string | undefined;
    postalCode!: string | undefined;
    isMain!: boolean;
    municipality!: MunicipalityDto;

    constructor(data?: IAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.streetName = _data["streetName"];
            this.streetNumber = _data["streetNumber"];
            this.postalCode = _data["postalCode"];
            this.isMain = _data["isMain"];
            this.municipality = _data["municipality"] ? MunicipalityDto.fromJS(_data["municipality"]) : undefined as any;
        }
    }

    static fromJS(data: any): AddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["streetName"] = this.streetName;
        data["streetNumber"] = this.streetNumber;
        data["postalCode"] = this.postalCode;
        data["isMain"] = this.isMain;
        data["municipality"] = this.municipality ? this.municipality.toJSON() : undefined as any;
        return data;
    }

    clone(): AddressDto {
        const json = this.toJSON();
        let result = new AddressDto();
        result.init(json);
        return result;
    }
}

export interface IAddressDto {
    id: number;
    streetName: string | undefined;
    streetNumber: string | undefined;
    postalCode: string | undefined;
    isMain: boolean;
    municipality: MunicipalityDto;
}

export class AdministrativeLegalAreaDto implements IAdministrativeLegalAreaDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    supportAdministrator!: boolean;
    supportAdministratorName!: string | undefined;
    supportAdministratorDate!: moment.Moment | undefined;
    guardian!: boolean;
    guardianName!: string | undefined;
    guardianDate!: moment.Moment | undefined;
    pension!: boolean;
    accompaniment!: boolean;
    freeTransport!: boolean;
    freeTransportWithAccompaniment!: boolean;
    registrationForTargetedPlacement!: boolean;
    presenceOfFunctionalDiagnosis!: boolean;
    note!: string | undefined;

    constructor(data?: IAdministrativeLegalAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.supportAdministrator = _data["supportAdministrator"];
            this.supportAdministratorName = _data["supportAdministratorName"];
            this.supportAdministratorDate = _data["supportAdministratorDate"] ? moment(_data["supportAdministratorDate"].toString()) : undefined as any;
            this.guardian = _data["guardian"];
            this.guardianName = _data["guardianName"];
            this.guardianDate = _data["guardianDate"] ? moment(_data["guardianDate"].toString()) : undefined as any;
            this.pension = _data["pension"];
            this.accompaniment = _data["accompaniment"];
            this.freeTransport = _data["freeTransport"];
            this.freeTransportWithAccompaniment = _data["freeTransportWithAccompaniment"];
            this.registrationForTargetedPlacement = _data["registrationForTargetedPlacement"];
            this.presenceOfFunctionalDiagnosis = _data["presenceOfFunctionalDiagnosis"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): AdministrativeLegalAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdministrativeLegalAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["supportAdministrator"] = this.supportAdministrator;
        data["supportAdministratorName"] = this.supportAdministratorName;
        data["supportAdministratorDate"] = this.supportAdministratorDate ? this.supportAdministratorDate.toISOString() : undefined as any;
        data["guardian"] = this.guardian;
        data["guardianName"] = this.guardianName;
        data["guardianDate"] = this.guardianDate ? this.guardianDate.toISOString() : undefined as any;
        data["pension"] = this.pension;
        data["accompaniment"] = this.accompaniment;
        data["freeTransport"] = this.freeTransport;
        data["freeTransportWithAccompaniment"] = this.freeTransportWithAccompaniment;
        data["registrationForTargetedPlacement"] = this.registrationForTargetedPlacement;
        data["presenceOfFunctionalDiagnosis"] = this.presenceOfFunctionalDiagnosis;
        data["note"] = this.note;
        return data;
    }

    clone(): AdministrativeLegalAreaDto {
        const json = this.toJSON();
        let result = new AdministrativeLegalAreaDto();
        result.init(json);
        return result;
    }
}

export interface IAdministrativeLegalAreaDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    supportAdministrator: boolean;
    supportAdministratorName: string | undefined;
    supportAdministratorDate: moment.Moment | undefined;
    guardian: boolean;
    guardianName: string | undefined;
    guardianDate: moment.Moment | undefined;
    pension: boolean;
    accompaniment: boolean;
    freeTransport: boolean;
    freeTransportWithAccompaniment: boolean;
    registrationForTargetedPlacement: boolean;
    presenceOfFunctionalDiagnosis: boolean;
    note: string | undefined;
}

export class AdministrativeLegalAreaDtoPagedResultDto implements IAdministrativeLegalAreaDtoPagedResultDto {
    items!: AdministrativeLegalAreaDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAdministrativeLegalAreaDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AdministrativeLegalAreaDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AdministrativeLegalAreaDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdministrativeLegalAreaDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AdministrativeLegalAreaDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AdministrativeLegalAreaDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAdministrativeLegalAreaDtoPagedResultDto {
    items: AdministrativeLegalAreaDto[] | undefined;
    totalCount: number;
}

export class AdmissionRecordDto implements IAdmissionRecordDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    socialHealthRecord!: SocialHealthRecordDto;
    admissionDate!: moment.Moment;
    admissionType!: DictionaryDto;
    admissionDiagnosis!: string | undefined;
    travel!: boolean | undefined;
    diningFacility!: boolean | undefined;
    reconciliationVoucherRequest!: boolean;
    startDateVoucher!: moment.Moment | undefined;
    endDateVoucher!: moment.Moment | undefined;
    disability!: string | undefined;
    accompanimentAllowance!: boolean;
    admissionDiagnosisUVMReport!: string | undefined;
    dailyAttendanceResidentialFacility!: boolean | undefined;
    dayOfWeeks!: DictionaryDto[] | undefined;
    admissionResidentialAuthorization!: AdmissionResidentialAuthorizationDto;
    pharmacologicalTherapy!: DrugDto[] | undefined;
    historicalCases!: HistoricalCaseDto[] | undefined;
    foodAllergies!: string | undefined;
    otherDietaryHabits!: string | undefined;
    personalAutonomy!: PersonalAutonomyDto;
    remotePathologicalAnamnesis!: string | undefined;
    proximalPathologicalAnamnesis!: string | undefined;
    orthosesProsthesesAndAids!: string | undefined;

    constructor(data?: IAdmissionRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.socialHealthRecord = _data["socialHealthRecord"] ? SocialHealthRecordDto.fromJS(_data["socialHealthRecord"]) : undefined as any;
            this.admissionDate = _data["admissionDate"] ? moment(_data["admissionDate"].toString()) : undefined as any;
            this.admissionType = _data["admissionType"] ? DictionaryDto.fromJS(_data["admissionType"]) : undefined as any;
            this.admissionDiagnosis = _data["admissionDiagnosis"];
            this.travel = _data["travel"];
            this.diningFacility = _data["diningFacility"];
            this.reconciliationVoucherRequest = _data["reconciliationVoucherRequest"];
            this.startDateVoucher = _data["startDateVoucher"] ? moment(_data["startDateVoucher"].toString()) : undefined as any;
            this.endDateVoucher = _data["endDateVoucher"] ? moment(_data["endDateVoucher"].toString()) : undefined as any;
            this.disability = _data["disability"];
            this.accompanimentAllowance = _data["accompanimentAllowance"];
            this.admissionDiagnosisUVMReport = _data["admissionDiagnosisUVMReport"];
            this.dailyAttendanceResidentialFacility = _data["dailyAttendanceResidentialFacility"];
            if (Array.isArray(_data["dayOfWeeks"])) {
                this.dayOfWeeks = [] as any;
                for (let item of _data["dayOfWeeks"])
                    this.dayOfWeeks!.push(DictionaryDto.fromJS(item));
            }
            this.admissionResidentialAuthorization = _data["admissionResidentialAuthorization"] ? AdmissionResidentialAuthorizationDto.fromJS(_data["admissionResidentialAuthorization"]) : undefined as any;
            if (Array.isArray(_data["pharmacologicalTherapy"])) {
                this.pharmacologicalTherapy = [] as any;
                for (let item of _data["pharmacologicalTherapy"])
                    this.pharmacologicalTherapy!.push(DrugDto.fromJS(item));
            }
            if (Array.isArray(_data["historicalCases"])) {
                this.historicalCases = [] as any;
                for (let item of _data["historicalCases"])
                    this.historicalCases!.push(HistoricalCaseDto.fromJS(item));
            }
            this.foodAllergies = _data["foodAllergies"];
            this.otherDietaryHabits = _data["otherDietaryHabits"];
            this.personalAutonomy = _data["personalAutonomy"] ? PersonalAutonomyDto.fromJS(_data["personalAutonomy"]) : undefined as any;
            this.remotePathologicalAnamnesis = _data["remotePathologicalAnamnesis"];
            this.proximalPathologicalAnamnesis = _data["proximalPathologicalAnamnesis"];
            this.orthosesProsthesesAndAids = _data["orthosesProsthesesAndAids"];
        }
    }

    static fromJS(data: any): AdmissionRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdmissionRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["socialHealthRecord"] = this.socialHealthRecord ? this.socialHealthRecord.toJSON() : undefined as any;
        data["admissionDate"] = this.admissionDate ? this.admissionDate.format('YYYY-MM-DD') : undefined as any;
        data["admissionType"] = this.admissionType ? this.admissionType.toJSON() : undefined as any;
        data["admissionDiagnosis"] = this.admissionDiagnosis;
        data["travel"] = this.travel;
        data["diningFacility"] = this.diningFacility;
        data["reconciliationVoucherRequest"] = this.reconciliationVoucherRequest;
        data["startDateVoucher"] = this.startDateVoucher ? this.startDateVoucher.format('YYYY-MM-DD') : undefined as any;
        data["endDateVoucher"] = this.endDateVoucher ? this.endDateVoucher.format('YYYY-MM-DD') : undefined as any;
        data["disability"] = this.disability;
        data["accompanimentAllowance"] = this.accompanimentAllowance;
        data["admissionDiagnosisUVMReport"] = this.admissionDiagnosisUVMReport;
        data["dailyAttendanceResidentialFacility"] = this.dailyAttendanceResidentialFacility;
        if (Array.isArray(this.dayOfWeeks)) {
            data["dayOfWeeks"] = [];
            for (let item of this.dayOfWeeks)
                data["dayOfWeeks"].push(item ? item.toJSON() : undefined as any);
        }
        data["admissionResidentialAuthorization"] = this.admissionResidentialAuthorization ? this.admissionResidentialAuthorization.toJSON() : undefined as any;
        if (Array.isArray(this.pharmacologicalTherapy)) {
            data["pharmacologicalTherapy"] = [];
            for (let item of this.pharmacologicalTherapy)
                data["pharmacologicalTherapy"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.historicalCases)) {
            data["historicalCases"] = [];
            for (let item of this.historicalCases)
                data["historicalCases"].push(item ? item.toJSON() : undefined as any);
        }
        data["foodAllergies"] = this.foodAllergies;
        data["otherDietaryHabits"] = this.otherDietaryHabits;
        data["personalAutonomy"] = this.personalAutonomy ? this.personalAutonomy.toJSON() : undefined as any;
        data["remotePathologicalAnamnesis"] = this.remotePathologicalAnamnesis;
        data["proximalPathologicalAnamnesis"] = this.proximalPathologicalAnamnesis;
        data["orthosesProsthesesAndAids"] = this.orthosesProsthesesAndAids;
        return data;
    }

    clone(): AdmissionRecordDto {
        const json = this.toJSON();
        let result = new AdmissionRecordDto();
        result.init(json);
        return result;
    }
}

export interface IAdmissionRecordDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    socialHealthRecord: SocialHealthRecordDto;
    admissionDate: moment.Moment;
    admissionType: DictionaryDto;
    admissionDiagnosis: string | undefined;
    travel: boolean | undefined;
    diningFacility: boolean | undefined;
    reconciliationVoucherRequest: boolean;
    startDateVoucher: moment.Moment | undefined;
    endDateVoucher: moment.Moment | undefined;
    disability: string | undefined;
    accompanimentAllowance: boolean;
    admissionDiagnosisUVMReport: string | undefined;
    dailyAttendanceResidentialFacility: boolean | undefined;
    dayOfWeeks: DictionaryDto[] | undefined;
    admissionResidentialAuthorization: AdmissionResidentialAuthorizationDto;
    pharmacologicalTherapy: DrugDto[] | undefined;
    historicalCases: HistoricalCaseDto[] | undefined;
    foodAllergies: string | undefined;
    otherDietaryHabits: string | undefined;
    personalAutonomy: PersonalAutonomyDto;
    remotePathologicalAnamnesis: string | undefined;
    proximalPathologicalAnamnesis: string | undefined;
    orthosesProsthesesAndAids: string | undefined;
}

export class AdmissionRecordDtoPagedResultDto implements IAdmissionRecordDtoPagedResultDto {
    items!: AdmissionRecordDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAdmissionRecordDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AdmissionRecordDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AdmissionRecordDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdmissionRecordDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AdmissionRecordDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AdmissionRecordDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAdmissionRecordDtoPagedResultDto {
    items: AdmissionRecordDto[] | undefined;
    totalCount: number;
}

export class AdmissionResidentialAuthorizationDto implements IAdmissionResidentialAuthorizationDto {
    id!: number;
    date!: moment.Moment | undefined;
    protocol!: string | undefined;
    expirationDate!: moment.Moment | undefined;
    attendanceStartDate!: moment.Moment | undefined;

    constructor(data?: IAdmissionResidentialAuthorizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.protocol = _data["protocol"];
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : undefined as any;
            this.attendanceStartDate = _data["attendanceStartDate"] ? moment(_data["attendanceStartDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AdmissionResidentialAuthorizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdmissionResidentialAuthorizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined as any;
        data["protocol"] = this.protocol;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.format('YYYY-MM-DD') : undefined as any;
        data["attendanceStartDate"] = this.attendanceStartDate ? this.attendanceStartDate.format('YYYY-MM-DD') : undefined as any;
        return data;
    }

    clone(): AdmissionResidentialAuthorizationDto {
        const json = this.toJSON();
        let result = new AdmissionResidentialAuthorizationDto();
        result.init(json);
        return result;
    }
}

export interface IAdmissionResidentialAuthorizationDto {
    id: number;
    date: moment.Moment | undefined;
    protocol: string | undefined;
    expirationDate: moment.Moment | undefined;
    attendanceStartDate: moment.Moment | undefined;
}

export class AdmissionResidentialAuthorizationDtoPagedResultDto implements IAdmissionResidentialAuthorizationDtoPagedResultDto {
    items!: AdmissionResidentialAuthorizationDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAdmissionResidentialAuthorizationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AdmissionResidentialAuthorizationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AdmissionResidentialAuthorizationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdmissionResidentialAuthorizationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AdmissionResidentialAuthorizationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AdmissionResidentialAuthorizationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAdmissionResidentialAuthorizationDtoPagedResultDto {
    items: AdmissionResidentialAuthorizationDto[] | undefined;
    totalCount: number;
}

export class AirTreatmentSystemBaseDto implements IAirTreatmentSystemBaseDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IAirTreatmentSystemBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AirTreatmentSystemBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AirTreatmentSystemBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): AirTreatmentSystemBaseDto {
        const json = this.toJSON();
        let result = new AirTreatmentSystemBaseDto();
        result.init(json);
        return result;
    }
}

export interface IAirTreatmentSystemBaseDto {
    id: number;
    name: string | undefined;
}

export class AirTreatmentSystemDto implements IAirTreatmentSystemDto {
    id!: number;
    name!: string | undefined;
    airTreatmentPlantType!: DictionaryDto;
    ton!: string | undefined;
    equivalentCarbonDioxide!: string | undefined;
    leaksControl!: DictionaryDto;
    numberOfUnits!: number | undefined;
    project!: boolean;
    plantBookletPresent!: boolean;
    plantBookletPresentFile!: FileDto;
    plantConformityDeclaration!: boolean;
    plantConformityDeclarationFile!: FileDto;
    maintenanceContract!: boolean;
    maintenanceContractFile!: FileDto;
    maintenanceCompany!: string | undefined;
    lastMaintenanceDate!: moment.Moment | undefined;
    notes!: string | undefined;

    constructor(data?: IAirTreatmentSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.airTreatmentPlantType = _data["airTreatmentPlantType"] ? DictionaryDto.fromJS(_data["airTreatmentPlantType"]) : undefined as any;
            this.ton = _data["ton"];
            this.equivalentCarbonDioxide = _data["equivalentCarbonDioxide"];
            this.leaksControl = _data["leaksControl"] ? DictionaryDto.fromJS(_data["leaksControl"]) : undefined as any;
            this.numberOfUnits = _data["numberOfUnits"];
            this.project = _data["project"];
            this.plantBookletPresent = _data["plantBookletPresent"];
            this.plantBookletPresentFile = _data["plantBookletPresentFile"] ? FileDto.fromJS(_data["plantBookletPresentFile"]) : undefined as any;
            this.plantConformityDeclaration = _data["plantConformityDeclaration"];
            this.plantConformityDeclarationFile = _data["plantConformityDeclarationFile"] ? FileDto.fromJS(_data["plantConformityDeclarationFile"]) : undefined as any;
            this.maintenanceContract = _data["maintenanceContract"];
            this.maintenanceContractFile = _data["maintenanceContractFile"] ? FileDto.fromJS(_data["maintenanceContractFile"]) : undefined as any;
            this.maintenanceCompany = _data["maintenanceCompany"];
            this.lastMaintenanceDate = _data["lastMaintenanceDate"] ? moment(_data["lastMaintenanceDate"].toString()) : undefined as any;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): AirTreatmentSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AirTreatmentSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["airTreatmentPlantType"] = this.airTreatmentPlantType ? this.airTreatmentPlantType.toJSON() : undefined as any;
        data["ton"] = this.ton;
        data["equivalentCarbonDioxide"] = this.equivalentCarbonDioxide;
        data["leaksControl"] = this.leaksControl ? this.leaksControl.toJSON() : undefined as any;
        data["numberOfUnits"] = this.numberOfUnits;
        data["project"] = this.project;
        data["plantBookletPresent"] = this.plantBookletPresent;
        data["plantBookletPresentFile"] = this.plantBookletPresentFile ? this.plantBookletPresentFile.toJSON() : undefined as any;
        data["plantConformityDeclaration"] = this.plantConformityDeclaration;
        data["plantConformityDeclarationFile"] = this.plantConformityDeclarationFile ? this.plantConformityDeclarationFile.toJSON() : undefined as any;
        data["maintenanceContract"] = this.maintenanceContract;
        data["maintenanceContractFile"] = this.maintenanceContractFile ? this.maintenanceContractFile.toJSON() : undefined as any;
        data["maintenanceCompany"] = this.maintenanceCompany;
        data["lastMaintenanceDate"] = this.lastMaintenanceDate ? this.lastMaintenanceDate.toISOString() : undefined as any;
        data["notes"] = this.notes;
        return data;
    }

    clone(): AirTreatmentSystemDto {
        const json = this.toJSON();
        let result = new AirTreatmentSystemDto();
        result.init(json);
        return result;
    }
}

export interface IAirTreatmentSystemDto {
    id: number;
    name: string | undefined;
    airTreatmentPlantType: DictionaryDto;
    ton: string | undefined;
    equivalentCarbonDioxide: string | undefined;
    leaksControl: DictionaryDto;
    numberOfUnits: number | undefined;
    project: boolean;
    plantBookletPresent: boolean;
    plantBookletPresentFile: FileDto;
    plantConformityDeclaration: boolean;
    plantConformityDeclarationFile: FileDto;
    maintenanceContract: boolean;
    maintenanceContractFile: FileDto;
    maintenanceCompany: string | undefined;
    lastMaintenanceDate: moment.Moment | undefined;
    notes: string | undefined;
}

export class AirTreatmentSystemDtoPagedResultDto implements IAirTreatmentSystemDtoPagedResultDto {
    items!: AirTreatmentSystemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAirTreatmentSystemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AirTreatmentSystemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AirTreatmentSystemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AirTreatmentSystemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AirTreatmentSystemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AirTreatmentSystemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAirTreatmentSystemDtoPagedResultDto {
    items: AirTreatmentSystemDto[] | undefined;
    totalCount: number;
}

export class AlertDto implements IAlertDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    date!: moment.Moment;
    title!: string | undefined;
    description!: string | undefined;
    contextLink!: string | undefined;
    emailNotification!: boolean;
    users!: BaseUserDto[] | undefined;

    constructor(data?: IAlertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.title = _data["title"];
            this.description = _data["description"];
            this.contextLink = _data["contextLink"];
            this.emailNotification = _data["emailNotification"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(BaseUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AlertDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["title"] = this.title;
        data["description"] = this.description;
        data["contextLink"] = this.contextLink;
        data["emailNotification"] = this.emailNotification;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): AlertDto {
        const json = this.toJSON();
        let result = new AlertDto();
        result.init(json);
        return result;
    }
}

export interface IAlertDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    date: moment.Moment;
    title: string | undefined;
    description: string | undefined;
    contextLink: string | undefined;
    emailNotification: boolean;
    users: BaseUserDto[] | undefined;
}

export class AlertItemDto implements IAlertItemDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    date!: moment.Moment;
    title!: string | undefined;
    description!: string | undefined;
    contextLink!: string | undefined;
    isRead!: boolean;

    constructor(data?: IAlertItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.title = _data["title"];
            this.description = _data["description"];
            this.contextLink = _data["contextLink"];
            this.isRead = _data["isRead"];
        }
    }

    static fromJS(data: any): AlertItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlertItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["title"] = this.title;
        data["description"] = this.description;
        data["contextLink"] = this.contextLink;
        data["isRead"] = this.isRead;
        return data;
    }

    clone(): AlertItemDto {
        const json = this.toJSON();
        let result = new AlertItemDto();
        result.init(json);
        return result;
    }
}

export interface IAlertItemDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    date: moment.Moment;
    title: string | undefined;
    description: string | undefined;
    contextLink: string | undefined;
    isRead: boolean;
}

export class AlertItemDtoPagedResultDto implements IAlertItemDtoPagedResultDto {
    items!: AlertItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAlertItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AlertItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AlertItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlertItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AlertItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AlertItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAlertItemDtoPagedResultDto {
    items: AlertItemDto[] | undefined;
    totalCount: number;
}

export class AntiTheftSystemBaseDto implements IAntiTheftSystemBaseDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IAntiTheftSystemBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AntiTheftSystemBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AntiTheftSystemBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): AntiTheftSystemBaseDto {
        const json = this.toJSON();
        let result = new AntiTheftSystemBaseDto();
        result.init(json);
        return result;
    }
}

export interface IAntiTheftSystemBaseDto {
    id: number;
    name: string | undefined;
}

export class AntiTheftSystemDto implements IAntiTheftSystemDto {
    id!: number;
    name!: string | undefined;
    brand!: string | undefined;
    model!: string | undefined;
    telephoneDialer!: boolean;
    telephoneNumber!: string | undefined;
    project!: boolean;
    projectFile!: FileDto;
    maintenanceContract!: boolean;
    maintenanceContractFile!: FileDto;
    maintenanceCompany!: string | undefined;
    lastMaintenanceDate!: moment.Moment | undefined;
    outsiderResponsible!: boolean;
    externalVigilance!: boolean;
    vigilanceContractFile!: FileDto;
    vigilanceCompany!: string | undefined;
    notes!: string | undefined;

    constructor(data?: IAntiTheftSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.brand = _data["brand"];
            this.model = _data["model"];
            this.telephoneDialer = _data["telephoneDialer"];
            this.telephoneNumber = _data["telephoneNumber"];
            this.project = _data["project"];
            this.projectFile = _data["projectFile"] ? FileDto.fromJS(_data["projectFile"]) : undefined as any;
            this.maintenanceContract = _data["maintenanceContract"];
            this.maintenanceContractFile = _data["maintenanceContractFile"] ? FileDto.fromJS(_data["maintenanceContractFile"]) : undefined as any;
            this.maintenanceCompany = _data["maintenanceCompany"];
            this.lastMaintenanceDate = _data["lastMaintenanceDate"] ? moment(_data["lastMaintenanceDate"].toString()) : undefined as any;
            this.outsiderResponsible = _data["outsiderResponsible"];
            this.externalVigilance = _data["externalVigilance"];
            this.vigilanceContractFile = _data["vigilanceContractFile"] ? FileDto.fromJS(_data["vigilanceContractFile"]) : undefined as any;
            this.vigilanceCompany = _data["vigilanceCompany"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): AntiTheftSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AntiTheftSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["brand"] = this.brand;
        data["model"] = this.model;
        data["telephoneDialer"] = this.telephoneDialer;
        data["telephoneNumber"] = this.telephoneNumber;
        data["project"] = this.project;
        data["projectFile"] = this.projectFile ? this.projectFile.toJSON() : undefined as any;
        data["maintenanceContract"] = this.maintenanceContract;
        data["maintenanceContractFile"] = this.maintenanceContractFile ? this.maintenanceContractFile.toJSON() : undefined as any;
        data["maintenanceCompany"] = this.maintenanceCompany;
        data["lastMaintenanceDate"] = this.lastMaintenanceDate ? this.lastMaintenanceDate.toISOString() : undefined as any;
        data["outsiderResponsible"] = this.outsiderResponsible;
        data["externalVigilance"] = this.externalVigilance;
        data["vigilanceContractFile"] = this.vigilanceContractFile ? this.vigilanceContractFile.toJSON() : undefined as any;
        data["vigilanceCompany"] = this.vigilanceCompany;
        data["notes"] = this.notes;
        return data;
    }

    clone(): AntiTheftSystemDto {
        const json = this.toJSON();
        let result = new AntiTheftSystemDto();
        result.init(json);
        return result;
    }
}

export interface IAntiTheftSystemDto {
    id: number;
    name: string | undefined;
    brand: string | undefined;
    model: string | undefined;
    telephoneDialer: boolean;
    telephoneNumber: string | undefined;
    project: boolean;
    projectFile: FileDto;
    maintenanceContract: boolean;
    maintenanceContractFile: FileDto;
    maintenanceCompany: string | undefined;
    lastMaintenanceDate: moment.Moment | undefined;
    outsiderResponsible: boolean;
    externalVigilance: boolean;
    vigilanceContractFile: FileDto;
    vigilanceCompany: string | undefined;
    notes: string | undefined;
}

export class AntiTheftSystemDtoPagedResultDto implements IAntiTheftSystemDtoPagedResultDto {
    items!: AntiTheftSystemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAntiTheftSystemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AntiTheftSystemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AntiTheftSystemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AntiTheftSystemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AntiTheftSystemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AntiTheftSystemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAntiTheftSystemDtoPagedResultDto {
    items: AntiTheftSystemDto[] | undefined;
    totalCount: number;
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: moment.Moment;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : undefined as any;
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (this.features as any)![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined as any;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (data["features"] as any)[key] = (this.features as any)[key];
            }
        }
        return data;
    }

    clone(): ApplicationInfoDto {
        const json = this.toJSON();
        let result = new ApplicationInfoDto();
        result.init(json);
        return result;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: moment.Moment;
    features: { [key: string]: boolean; } | undefined;
}

export class ArchiveServiceUserInput implements IArchiveServiceUserInput {
    serviceUserId!: number;
    dischargeDate!: moment.Moment | undefined;

    constructor(data?: IArchiveServiceUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceUserId = _data["serviceUserId"];
            this.dischargeDate = _data["dischargeDate"] ? moment(_data["dischargeDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ArchiveServiceUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new ArchiveServiceUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceUserId"] = this.serviceUserId;
        data["dischargeDate"] = this.dischargeDate ? this.dischargeDate.format('YYYY-MM-DD') : undefined as any;
        return data;
    }

    clone(): ArchiveServiceUserInput {
        const json = this.toJSON();
        let result = new ArchiveServiceUserInput();
        result.init(json);
        return result;
    }
}

export interface IArchiveServiceUserInput {
    serviceUserId: number;
    dischargeDate: moment.Moment | undefined;
}

export class ArchiveUserInput implements IArchiveUserInput {
    userId!: number;
    blockAccount!: boolean;
    recipientUserIds!: number[] | undefined;
    recipientRoleId!: number | undefined;

    constructor(data?: IArchiveUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.blockAccount = _data["blockAccount"];
            if (Array.isArray(_data["recipientUserIds"])) {
                this.recipientUserIds = [] as any;
                for (let item of _data["recipientUserIds"])
                    this.recipientUserIds!.push(item);
            }
            this.recipientRoleId = _data["recipientRoleId"];
        }
    }

    static fromJS(data: any): ArchiveUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new ArchiveUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["blockAccount"] = this.blockAccount;
        if (Array.isArray(this.recipientUserIds)) {
            data["recipientUserIds"] = [];
            for (let item of this.recipientUserIds)
                data["recipientUserIds"].push(item);
        }
        data["recipientRoleId"] = this.recipientRoleId;
        return data;
    }

    clone(): ArchiveUserInput {
        const json = this.toJSON();
        let result = new ArchiveUserInput();
        result.init(json);
        return result;
    }
}

export interface IArchiveUserInput {
    userId: number;
    blockAccount: boolean;
    recipientUserIds: number[] | undefined;
    recipientRoleId: number | undefined;
}

export class AssetDto implements IAssetDto {
    id!: number;
    name!: string | undefined;
    assetType!: DictionaryDto;
    description!: string | undefined;
    iccid!: string | undefined;
    phoneNumber!: string | undefined;
    pin!: string | undefined;
    puk!: string | undefined;
    note!: string | undefined;

    constructor(data?: IAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.assetType = _data["assetType"] ? DictionaryDto.fromJS(_data["assetType"]) : undefined as any;
            this.description = _data["description"];
            this.iccid = _data["iccid"];
            this.phoneNumber = _data["phoneNumber"];
            this.pin = _data["pin"];
            this.puk = _data["puk"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): AssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["assetType"] = this.assetType ? this.assetType.toJSON() : undefined as any;
        data["description"] = this.description;
        data["iccid"] = this.iccid;
        data["phoneNumber"] = this.phoneNumber;
        data["pin"] = this.pin;
        data["puk"] = this.puk;
        data["note"] = this.note;
        return data;
    }

    clone(): AssetDto {
        const json = this.toJSON();
        let result = new AssetDto();
        result.init(json);
        return result;
    }
}

export interface IAssetDto {
    id: number;
    name: string | undefined;
    assetType: DictionaryDto;
    description: string | undefined;
    iccid: string | undefined;
    phoneNumber: string | undefined;
    pin: string | undefined;
    puk: string | undefined;
    note: string | undefined;
}

export class AssetItemDto implements IAssetItemDto {
    id!: number;
    name!: string | undefined;
    assetType!: DictionaryDto;

    constructor(data?: IAssetItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.assetType = _data["assetType"] ? DictionaryDto.fromJS(_data["assetType"]) : undefined as any;
        }
    }

    static fromJS(data: any): AssetItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["assetType"] = this.assetType ? this.assetType.toJSON() : undefined as any;
        return data;
    }

    clone(): AssetItemDto {
        const json = this.toJSON();
        let result = new AssetItemDto();
        result.init(json);
        return result;
    }
}

export interface IAssetItemDto {
    id: number;
    name: string | undefined;
    assetType: DictionaryDto;
}

export class AssetItemDtoPagedResultDto implements IAssetItemDtoPagedResultDto {
    items!: AssetItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAssetItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AssetItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AssetItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AssetItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AssetItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAssetItemDtoPagedResultDto {
    items: AssetItemDto[] | undefined;
    totalCount: number;
}

export class AssetServiceUserDto implements IAssetServiceUserDto {
    id!: number;
    asset!: AssetDto;
    service!: ServiceItemDto;
    user!: UserDto;
    assignmentDate!: moment.Moment;
    withdrawalDate!: moment.Moment | undefined;

    constructor(data?: IAssetServiceUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.asset = _data["asset"] ? AssetDto.fromJS(_data["asset"]) : undefined as any;
            this.service = _data["service"] ? ServiceItemDto.fromJS(_data["service"]) : undefined as any;
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            this.assignmentDate = _data["assignmentDate"] ? moment(_data["assignmentDate"].toString()) : undefined as any;
            this.withdrawalDate = _data["withdrawalDate"] ? moment(_data["withdrawalDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AssetServiceUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetServiceUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["asset"] = this.asset ? this.asset.toJSON() : undefined as any;
        data["service"] = this.service ? this.service.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["assignmentDate"] = this.assignmentDate ? this.assignmentDate.toISOString() : undefined as any;
        data["withdrawalDate"] = this.withdrawalDate ? this.withdrawalDate.toISOString() : undefined as any;
        return data;
    }

    clone(): AssetServiceUserDto {
        const json = this.toJSON();
        let result = new AssetServiceUserDto();
        result.init(json);
        return result;
    }
}

export interface IAssetServiceUserDto {
    id: number;
    asset: AssetDto;
    service: ServiceItemDto;
    user: UserDto;
    assignmentDate: moment.Moment;
    withdrawalDate: moment.Moment | undefined;
}

export class AssetServiceUserDtoPagedResultDto implements IAssetServiceUserDtoPagedResultDto {
    items!: AssetServiceUserDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAssetServiceUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AssetServiceUserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AssetServiceUserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetServiceUserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AssetServiceUserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AssetServiceUserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAssetServiceUserDtoPagedResultDto {
    items: AssetServiceUserDto[] | undefined;
    totalCount: number;
}

export class AssignServiceUserStructureInput implements IAssignServiceUserStructureInput {
    serviceUserIds!: number[] | undefined;
    structureId!: number;
    roomId!: number | undefined;
    startDate!: moment.Moment;

    constructor(data?: IAssignServiceUserStructureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["serviceUserIds"])) {
                this.serviceUserIds = [] as any;
                for (let item of _data["serviceUserIds"])
                    this.serviceUserIds!.push(item);
            }
            this.structureId = _data["structureId"];
            this.roomId = _data["roomId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AssignServiceUserStructureInput {
        data = typeof data === 'object' ? data : {};
        let result = new AssignServiceUserStructureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceUserIds)) {
            data["serviceUserIds"] = [];
            for (let item of this.serviceUserIds)
                data["serviceUserIds"].push(item);
        }
        data["structureId"] = this.structureId;
        data["roomId"] = this.roomId;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : undefined as any;
        return data;
    }

    clone(): AssignServiceUserStructureInput {
        const json = this.toJSON();
        let result = new AssignServiceUserStructureInput();
        result.init(json);
        return result;
    }
}

export interface IAssignServiceUserStructureInput {
    serviceUserIds: number[] | undefined;
    structureId: number;
    roomId: number | undefined;
    startDate: moment.Moment;
}

export class AssociateTemplateToManyInput implements IAssociateTemplateToManyInput {
    templateId!: number;
    socialHealthRecordIds!: number[] | undefined;
    selectAll!: boolean;
    serviceId!: number | undefined;
    keyword!: string | undefined;
    includeArchived!: boolean;
    isArchived!: boolean | undefined;

    constructor(data?: IAssociateTemplateToManyInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"];
            if (Array.isArray(_data["socialHealthRecordIds"])) {
                this.socialHealthRecordIds = [] as any;
                for (let item of _data["socialHealthRecordIds"])
                    this.socialHealthRecordIds!.push(item);
            }
            this.selectAll = _data["selectAll"];
            this.serviceId = _data["serviceId"];
            this.keyword = _data["keyword"];
            this.includeArchived = _data["includeArchived"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): AssociateTemplateToManyInput {
        data = typeof data === 'object' ? data : {};
        let result = new AssociateTemplateToManyInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId;
        if (Array.isArray(this.socialHealthRecordIds)) {
            data["socialHealthRecordIds"] = [];
            for (let item of this.socialHealthRecordIds)
                data["socialHealthRecordIds"].push(item);
        }
        data["selectAll"] = this.selectAll;
        data["serviceId"] = this.serviceId;
        data["keyword"] = this.keyword;
        data["includeArchived"] = this.includeArchived;
        data["isArchived"] = this.isArchived;
        return data;
    }

    clone(): AssociateTemplateToManyInput {
        const json = this.toJSON();
        let result = new AssociateTemplateToManyInput();
        result.init(json);
        return result;
    }
}

export interface IAssociateTemplateToManyInput {
    templateId: number;
    socialHealthRecordIds: number[] | undefined;
    selectAll: boolean;
    serviceId: number | undefined;
    keyword: string | undefined;
    includeArchived: boolean;
    isArchived: boolean | undefined;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    rememberClient!: boolean;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.rememberClient = _data["rememberClient"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data;
    }

    clone(): AuthenticateModel {
        const json = this.toJSON();
        let result = new AuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    rememberClient: boolean;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    userId!: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        return data;
    }

    clone(): AuthenticateResultModel {
        const json = this.toJSON();
        let result = new AuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    userId: number;
}

export class AutonomyDto implements IAutonomyDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    eatAlone!: string | undefined;
    sleepAloneInRoom!: string | undefined;
    canCalculate!: string | undefined;
    canReadTime!: string | undefined;
    orientedInTime!: string | undefined;
    orientedInSpace!: string | undefined;
    usesPublicTransport!: string | undefined;
    dailyRoutine!: string | undefined;
    goesOutAlone!: string | undefined;
    staysHomeAlone!: string | undefined;
    weekendActivities!: string | undefined;
    hasFriends!: string | undefined;
    sleptAwayWithoutCloseRelatives!: string | undefined;
    hobbiesAndInterests!: string | undefined;
    difficultBehaviors!: string | undefined;
    sexualActivity!: string | undefined;
    personalHygiene!: string | undefined;
    takeCareYourSelf!: string | undefined;
    thingsInOrder!: string | undefined;
    assignmentsAtHome!: string | undefined;
    canWrite!: string | undefined;
    canRead!: string | undefined;
    knowPersonalDetail!: string | undefined;
    hasMoneyRegularly!: string | undefined;
    purchasesYourselfHome!: string | undefined;
    hasHouseKeys!: string | undefined;
    hasPhone!: string | undefined;
    crossRoadAlone!: string | undefined;
    other!: string | undefined;

    constructor(data?: IAutonomyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.eatAlone = _data["eatAlone"];
            this.sleepAloneInRoom = _data["sleepAloneInRoom"];
            this.canCalculate = _data["canCalculate"];
            this.canReadTime = _data["canReadTime"];
            this.orientedInTime = _data["orientedInTime"];
            this.orientedInSpace = _data["orientedInSpace"];
            this.usesPublicTransport = _data["usesPublicTransport"];
            this.dailyRoutine = _data["dailyRoutine"];
            this.goesOutAlone = _data["goesOutAlone"];
            this.staysHomeAlone = _data["staysHomeAlone"];
            this.weekendActivities = _data["weekendActivities"];
            this.hasFriends = _data["hasFriends"];
            this.sleptAwayWithoutCloseRelatives = _data["sleptAwayWithoutCloseRelatives"];
            this.hobbiesAndInterests = _data["hobbiesAndInterests"];
            this.difficultBehaviors = _data["difficultBehaviors"];
            this.sexualActivity = _data["sexualActivity"];
            this.personalHygiene = _data["personalHygiene"];
            this.takeCareYourSelf = _data["takeCareYourSelf"];
            this.thingsInOrder = _data["thingsInOrder"];
            this.assignmentsAtHome = _data["assignmentsAtHome"];
            this.canWrite = _data["canWrite"];
            this.canRead = _data["canRead"];
            this.knowPersonalDetail = _data["knowPersonalDetail"];
            this.hasMoneyRegularly = _data["hasMoneyRegularly"];
            this.purchasesYourselfHome = _data["purchasesYourselfHome"];
            this.hasHouseKeys = _data["hasHouseKeys"];
            this.hasPhone = _data["hasPhone"];
            this.crossRoadAlone = _data["crossRoadAlone"];
            this.other = _data["other"];
        }
    }

    static fromJS(data: any): AutonomyDto {
        data = typeof data === 'object' ? data : {};
        let result = new AutonomyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["eatAlone"] = this.eatAlone;
        data["sleepAloneInRoom"] = this.sleepAloneInRoom;
        data["canCalculate"] = this.canCalculate;
        data["canReadTime"] = this.canReadTime;
        data["orientedInTime"] = this.orientedInTime;
        data["orientedInSpace"] = this.orientedInSpace;
        data["usesPublicTransport"] = this.usesPublicTransport;
        data["dailyRoutine"] = this.dailyRoutine;
        data["goesOutAlone"] = this.goesOutAlone;
        data["staysHomeAlone"] = this.staysHomeAlone;
        data["weekendActivities"] = this.weekendActivities;
        data["hasFriends"] = this.hasFriends;
        data["sleptAwayWithoutCloseRelatives"] = this.sleptAwayWithoutCloseRelatives;
        data["hobbiesAndInterests"] = this.hobbiesAndInterests;
        data["difficultBehaviors"] = this.difficultBehaviors;
        data["sexualActivity"] = this.sexualActivity;
        data["personalHygiene"] = this.personalHygiene;
        data["takeCareYourSelf"] = this.takeCareYourSelf;
        data["thingsInOrder"] = this.thingsInOrder;
        data["assignmentsAtHome"] = this.assignmentsAtHome;
        data["canWrite"] = this.canWrite;
        data["canRead"] = this.canRead;
        data["knowPersonalDetail"] = this.knowPersonalDetail;
        data["hasMoneyRegularly"] = this.hasMoneyRegularly;
        data["purchasesYourselfHome"] = this.purchasesYourselfHome;
        data["hasHouseKeys"] = this.hasHouseKeys;
        data["hasPhone"] = this.hasPhone;
        data["crossRoadAlone"] = this.crossRoadAlone;
        data["other"] = this.other;
        return data;
    }

    clone(): AutonomyDto {
        const json = this.toJSON();
        let result = new AutonomyDto();
        result.init(json);
        return result;
    }
}

export interface IAutonomyDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    eatAlone: string | undefined;
    sleepAloneInRoom: string | undefined;
    canCalculate: string | undefined;
    canReadTime: string | undefined;
    orientedInTime: string | undefined;
    orientedInSpace: string | undefined;
    usesPublicTransport: string | undefined;
    dailyRoutine: string | undefined;
    goesOutAlone: string | undefined;
    staysHomeAlone: string | undefined;
    weekendActivities: string | undefined;
    hasFriends: string | undefined;
    sleptAwayWithoutCloseRelatives: string | undefined;
    hobbiesAndInterests: string | undefined;
    difficultBehaviors: string | undefined;
    sexualActivity: string | undefined;
    personalHygiene: string | undefined;
    takeCareYourSelf: string | undefined;
    thingsInOrder: string | undefined;
    assignmentsAtHome: string | undefined;
    canWrite: string | undefined;
    canRead: string | undefined;
    knowPersonalDetail: string | undefined;
    hasMoneyRegularly: string | undefined;
    purchasesYourselfHome: string | undefined;
    hasHouseKeys: string | undefined;
    hasPhone: string | undefined;
    crossRoadAlone: string | undefined;
    other: string | undefined;
}

export class AutonomyDtoPagedResultDto implements IAutonomyDtoPagedResultDto {
    items!: AutonomyDto[] | undefined;
    totalCount!: number;

    constructor(data?: IAutonomyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AutonomyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): AutonomyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AutonomyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): AutonomyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new AutonomyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IAutonomyDtoPagedResultDto {
    items: AutonomyDto[] | undefined;
    totalCount: number;
}

export enum BadgeDirection {
    _0 = 0,
    _1 = 1,
}

export class BadgeInput implements IBadgeInput {
    id!: number;
    direction!: BadgeDirection;
    at!: moment.Moment | undefined;
    note!: string | undefined;
    actualMinutes!: number | undefined;
    occurrenceStart!: moment.Moment | undefined;

    constructor(data?: IBadgeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.direction = _data["direction"];
            this.at = _data["at"] ? moment(_data["at"].toString()) : undefined as any;
            this.note = _data["note"];
            this.actualMinutes = _data["actualMinutes"];
            this.occurrenceStart = _data["occurrenceStart"] ? moment(_data["occurrenceStart"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): BadgeInput {
        data = typeof data === 'object' ? data : {};
        let result = new BadgeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["direction"] = this.direction;
        data["at"] = this.at ? this.at.toISOString() : undefined as any;
        data["note"] = this.note;
        data["actualMinutes"] = this.actualMinutes;
        data["occurrenceStart"] = this.occurrenceStart ? this.occurrenceStart.toISOString() : undefined as any;
        return data;
    }

    clone(): BadgeInput {
        const json = this.toJSON();
        let result = new BadgeInput();
        result.init(json);
        return result;
    }
}

export interface IBadgeInput {
    id: number;
    direction: BadgeDirection;
    at: moment.Moment | undefined;
    note: string | undefined;
    actualMinutes: number | undefined;
    occurrenceStart: moment.Moment | undefined;
}

export class BarthelAnswerDto implements IBarthelAnswerDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;
    barthelQuestion!: DictionaryDto;
    value!: number;

    constructor(data?: IBarthelAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
            this.barthelQuestion = _data["barthelQuestion"] ? DictionaryDto.fromJS(_data["barthelQuestion"]) : undefined as any;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): BarthelAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new BarthelAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        data["barthelQuestion"] = this.barthelQuestion ? this.barthelQuestion.toJSON() : undefined as any;
        data["value"] = this.value;
        return data;
    }

    clone(): BarthelAnswerDto {
        const json = this.toJSON();
        let result = new BarthelAnswerDto();
        result.init(json);
        return result;
    }
}

export interface IBarthelAnswerDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
    barthelQuestion: DictionaryDto;
    value: number;
}

export class BarthelIndexAnswerDto implements IBarthelIndexAnswerDto {
    id!: number;
    barthelIndexRecordId!: number;
    allAnswers!: BarthelAnswerDto[] | undefined;

    constructor(data?: IBarthelIndexAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.barthelIndexRecordId = _data["barthelIndexRecordId"];
            if (Array.isArray(_data["allAnswers"])) {
                this.allAnswers = [] as any;
                for (let item of _data["allAnswers"])
                    this.allAnswers!.push(BarthelAnswerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BarthelIndexAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new BarthelIndexAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["barthelIndexRecordId"] = this.barthelIndexRecordId;
        if (Array.isArray(this.allAnswers)) {
            data["allAnswers"] = [];
            for (let item of this.allAnswers)
                data["allAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): BarthelIndexAnswerDto {
        const json = this.toJSON();
        let result = new BarthelIndexAnswerDto();
        result.init(json);
        return result;
    }
}

export interface IBarthelIndexAnswerDto {
    id: number;
    barthelIndexRecordId: number;
    allAnswers: BarthelAnswerDto[] | undefined;
}

export class BarthelIndexAnswerDtoPagedResultDto implements IBarthelIndexAnswerDtoPagedResultDto {
    items!: BarthelIndexAnswerDto[] | undefined;
    totalCount!: number;

    constructor(data?: IBarthelIndexAnswerDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BarthelIndexAnswerDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): BarthelIndexAnswerDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BarthelIndexAnswerDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): BarthelIndexAnswerDtoPagedResultDto {
        const json = this.toJSON();
        let result = new BarthelIndexAnswerDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IBarthelIndexAnswerDtoPagedResultDto {
    items: BarthelIndexAnswerDto[] | undefined;
    totalCount: number;
}

export class BarthelIndexAnswerGetAllInput implements IBarthelIndexAnswerGetAllInput {

    constructor(data?: IBarthelIndexAnswerGetAllInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BarthelIndexAnswerGetAllInput {
        data = typeof data === 'object' ? data : {};
        let result = new BarthelIndexAnswerGetAllInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): BarthelIndexAnswerGetAllInput {
        const json = this.toJSON();
        let result = new BarthelIndexAnswerGetAllInput();
        result.init(json);
        return result;
    }
}

export interface IBarthelIndexAnswerGetAllInput {
}

export class BarthelIndexDto implements IBarthelIndexDto {
    id!: number;
    date!: moment.Moment;
    barthelAnswers!: BarthelAnswerDto[] | undefined;
    isCompiled!: boolean;
    totalScore!: number | undefined;
    hasPreviously!: boolean;
    hasFollowing!: boolean;

    constructor(data?: IBarthelIndexDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            if (Array.isArray(_data["barthelAnswers"])) {
                this.barthelAnswers = [] as any;
                for (let item of _data["barthelAnswers"])
                    this.barthelAnswers!.push(BarthelAnswerDto.fromJS(item));
            }
            this.isCompiled = _data["isCompiled"];
            this.totalScore = _data["totalScore"];
            this.hasPreviously = _data["hasPreviously"];
            this.hasFollowing = _data["hasFollowing"];
        }
    }

    static fromJS(data: any): BarthelIndexDto {
        data = typeof data === 'object' ? data : {};
        let result = new BarthelIndexDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        if (Array.isArray(this.barthelAnswers)) {
            data["barthelAnswers"] = [];
            for (let item of this.barthelAnswers)
                data["barthelAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        data["isCompiled"] = this.isCompiled;
        data["totalScore"] = this.totalScore;
        data["hasPreviously"] = this.hasPreviously;
        data["hasFollowing"] = this.hasFollowing;
        return data;
    }

    clone(): BarthelIndexDto {
        const json = this.toJSON();
        let result = new BarthelIndexDto();
        result.init(json);
        return result;
    }
}

export interface IBarthelIndexDto {
    id: number;
    date: moment.Moment;
    barthelAnswers: BarthelAnswerDto[] | undefined;
    isCompiled: boolean;
    totalScore: number | undefined;
    hasPreviously: boolean;
    hasFollowing: boolean;
}

export class BarthelIndexItemDto implements IBarthelIndexItemDto {
    id!: number;
    date!: moment.Moment | undefined;
    isCompiled!: boolean;
    totalScore!: number | undefined;

    constructor(data?: IBarthelIndexItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.isCompiled = _data["isCompiled"];
            this.totalScore = _data["totalScore"];
        }
    }

    static fromJS(data: any): BarthelIndexItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new BarthelIndexItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["isCompiled"] = this.isCompiled;
        data["totalScore"] = this.totalScore;
        return data;
    }

    clone(): BarthelIndexItemDto {
        const json = this.toJSON();
        let result = new BarthelIndexItemDto();
        result.init(json);
        return result;
    }
}

export interface IBarthelIndexItemDto {
    id: number;
    date: moment.Moment | undefined;
    isCompiled: boolean;
    totalScore: number | undefined;
}

export class BarthelIndexItemDtoPagedResultDto implements IBarthelIndexItemDtoPagedResultDto {
    items!: BarthelIndexItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IBarthelIndexItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BarthelIndexItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): BarthelIndexItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BarthelIndexItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): BarthelIndexItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new BarthelIndexItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IBarthelIndexItemDtoPagedResultDto {
    items: BarthelIndexItemDto[] | undefined;
    totalCount: number;
}

export class BaseUserDto implements IBaseUserDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    fullName!: string | undefined;
    userName!: string | undefined;
    fiscalCode!: string | undefined;
    birthday!: moment.Moment;
    birthPlace!: MunicipalityDto;
    isMale!: boolean | undefined;
    emailAddress!: string | undefined;

    constructor(data?: IBaseUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.fiscalCode = _data["fiscalCode"];
            this.birthday = _data["birthday"] ? moment(_data["birthday"].toString()) : undefined as any;
            this.birthPlace = _data["birthPlace"] ? MunicipalityDto.fromJS(_data["birthPlace"]) : undefined as any;
            this.isMale = _data["isMale"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): BaseUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new BaseUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["fiscalCode"] = this.fiscalCode;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : undefined as any;
        data["birthPlace"] = this.birthPlace ? this.birthPlace.toJSON() : undefined as any;
        data["isMale"] = this.isMale;
        data["emailAddress"] = this.emailAddress;
        return data;
    }

    clone(): BaseUserDto {
        const json = this.toJSON();
        let result = new BaseUserDto();
        result.init(json);
        return result;
    }
}

export interface IBaseUserDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    userName: string | undefined;
    fiscalCode: string | undefined;
    birthday: moment.Moment;
    birthPlace: MunicipalityDto;
    isMale: boolean | undefined;
    emailAddress: string | undefined;
}

export class BodyTemperatureHourVitalSignDto implements IBodyTemperatureHourVitalSignDto {
    id!: number;
    bodyTemperature!: DictionaryDto;
    hourVitalSign!: DictionaryDto;

    constructor(data?: IBodyTemperatureHourVitalSignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bodyTemperature = _data["bodyTemperature"] ? DictionaryDto.fromJS(_data["bodyTemperature"]) : undefined as any;
            this.hourVitalSign = _data["hourVitalSign"] ? DictionaryDto.fromJS(_data["hourVitalSign"]) : undefined as any;
        }
    }

    static fromJS(data: any): BodyTemperatureHourVitalSignDto {
        data = typeof data === 'object' ? data : {};
        let result = new BodyTemperatureHourVitalSignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bodyTemperature"] = this.bodyTemperature ? this.bodyTemperature.toJSON() : undefined as any;
        data["hourVitalSign"] = this.hourVitalSign ? this.hourVitalSign.toJSON() : undefined as any;
        return data;
    }

    clone(): BodyTemperatureHourVitalSignDto {
        const json = this.toJSON();
        let result = new BodyTemperatureHourVitalSignDto();
        result.init(json);
        return result;
    }
}

export interface IBodyTemperatureHourVitalSignDto {
    id: number;
    bodyTemperature: DictionaryDto;
    hourVitalSign: DictionaryDto;
}

export class BodyTemperatureHourVitalSignDtoPagedResultDto implements IBodyTemperatureHourVitalSignDtoPagedResultDto {
    items!: BodyTemperatureHourVitalSignDto[] | undefined;
    totalCount!: number;

    constructor(data?: IBodyTemperatureHourVitalSignDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BodyTemperatureHourVitalSignDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): BodyTemperatureHourVitalSignDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BodyTemperatureHourVitalSignDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): BodyTemperatureHourVitalSignDtoPagedResultDto {
        const json = this.toJSON();
        let result = new BodyTemperatureHourVitalSignDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IBodyTemperatureHourVitalSignDtoPagedResultDto {
    items: BodyTemperatureHourVitalSignDto[] | undefined;
    totalCount: number;
}

export class CancelMyActivityInput implements ICancelMyActivityInput {
    id!: number;
    reason!: string;
    isAbsent!: boolean;

    constructor(data?: ICancelMyActivityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reason = _data["reason"];
            this.isAbsent = _data["isAbsent"];
        }
    }

    static fromJS(data: any): CancelMyActivityInput {
        data = typeof data === 'object' ? data : {};
        let result = new CancelMyActivityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reason"] = this.reason;
        data["isAbsent"] = this.isAbsent;
        return data;
    }

    clone(): CancelMyActivityInput {
        const json = this.toJSON();
        let result = new CancelMyActivityInput();
        result.init(json);
        return result;
    }
}

export interface ICancelMyActivityInput {
    id: number;
    reason: string;
    isAbsent: boolean;
}

export class CancelMyOccurrenceInput implements ICancelMyOccurrenceInput {
    id!: number;
    reason!: string;
    isAbsent!: boolean;
    occurrenceStart!: moment.Moment;

    constructor(data?: ICancelMyOccurrenceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reason = _data["reason"];
            this.isAbsent = _data["isAbsent"];
            this.occurrenceStart = _data["occurrenceStart"] ? moment(_data["occurrenceStart"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CancelMyOccurrenceInput {
        data = typeof data === 'object' ? data : {};
        let result = new CancelMyOccurrenceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reason"] = this.reason;
        data["isAbsent"] = this.isAbsent;
        data["occurrenceStart"] = this.occurrenceStart ? this.occurrenceStart.toISOString() : undefined as any;
        return data;
    }

    clone(): CancelMyOccurrenceInput {
        const json = this.toJSON();
        let result = new CancelMyOccurrenceInput();
        result.init(json);
        return result;
    }
}

export interface ICancelMyOccurrenceInput {
    id: number;
    reason: string;
    isAbsent: boolean;
    occurrenceStart: moment.Moment;
}

export class CaregiverRecordDto implements ICaregiverRecordDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    caregiverType!: DictionaryDto;

    constructor(data?: ICaregiverRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.caregiverType = _data["caregiverType"] ? DictionaryDto.fromJS(_data["caregiverType"]) : undefined as any;
        }
    }

    static fromJS(data: any): CaregiverRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["caregiverType"] = this.caregiverType ? this.caregiverType.toJSON() : undefined as any;
        return data;
    }

    clone(): CaregiverRecordDto {
        const json = this.toJSON();
        let result = new CaregiverRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICaregiverRecordDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    name: string | undefined;
    surname: string | undefined;
    caregiverType: DictionaryDto;
}

export class CaregiverRecordDtoPagedResultDto implements ICaregiverRecordDtoPagedResultDto {
    items!: CaregiverRecordDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICaregiverRecordDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CaregiverRecordDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CaregiverRecordDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CaregiverRecordDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CaregiverRecordDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CaregiverRecordDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICaregiverRecordDtoPagedResultDto {
    items: CaregiverRecordDto[] | undefined;
    totalCount: number;
}

export class CategoryObservationGridDto implements ICategoryObservationGridDto {
    id!: number;
    name!: string | undefined;
    sectionObservationGrid!: SectionObservationGridDto;

    constructor(data?: ICategoryObservationGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sectionObservationGrid = _data["sectionObservationGrid"] ? SectionObservationGridDto.fromJS(_data["sectionObservationGrid"]) : undefined as any;
        }
    }

    static fromJS(data: any): CategoryObservationGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryObservationGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sectionObservationGrid"] = this.sectionObservationGrid ? this.sectionObservationGrid.toJSON() : undefined as any;
        return data;
    }

    clone(): CategoryObservationGridDto {
        const json = this.toJSON();
        let result = new CategoryObservationGridDto();
        result.init(json);
        return result;
    }
}

export interface ICategoryObservationGridDto {
    id: number;
    name: string | undefined;
    sectionObservationGrid: SectionObservationGridDto;
}

export class CategoryObservationGridDtoPagedResultDto implements ICategoryObservationGridDtoPagedResultDto {
    items!: CategoryObservationGridDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICategoryObservationGridDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CategoryObservationGridDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CategoryObservationGridDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CategoryObservationGridDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CategoryObservationGridDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CategoryObservationGridDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICategoryObservationGridDtoPagedResultDto {
    items: CategoryObservationGridDto[] | undefined;
    totalCount: number;
}

export class ChangePasswordDto implements IChangePasswordDto {
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ChangePasswordDto {
        const json = this.toJSON();
        let result = new ChangePasswordDto();
        result.init(json);
        return result;
    }
}

export interface IChangePasswordDto {
    currentPassword: string;
    newPassword: string;
}

export class ChangeUiThemeInput implements IChangeUiThemeInput {
    theme!: string;

    constructor(data?: IChangeUiThemeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
        }
    }

    static fromJS(data: any): ChangeUiThemeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data;
    }

    clone(): ChangeUiThemeInput {
        const json = this.toJSON();
        let result = new ChangeUiThemeInput();
        result.init(json);
        return result;
    }
}

export interface IChangeUiThemeInput {
    theme: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }

    clone(): ChangeUserLanguageDto {
        const json = this.toJSON();
        let result = new ChangeUserLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export class CheckDrugExpirationDto implements ICheckDrugExpirationDto {
    id!: number;
    isConfirmed!: boolean;
    confirmingUserId!: number | undefined;
    confirmationDate!: moment.Moment | undefined;
    confirmingUserFullName!: string | undefined;
    month!: number;
    note!: string | undefined;
    creationTime!: moment.Moment;

    constructor(data?: ICheckDrugExpirationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isConfirmed = _data["isConfirmed"];
            this.confirmingUserId = _data["confirmingUserId"];
            this.confirmationDate = _data["confirmationDate"] ? moment(_data["confirmationDate"].toString()) : undefined as any;
            this.confirmingUserFullName = _data["confirmingUserFullName"];
            this.month = _data["month"];
            this.note = _data["note"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CheckDrugExpirationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckDrugExpirationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isConfirmed"] = this.isConfirmed;
        data["confirmingUserId"] = this.confirmingUserId;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : undefined as any;
        data["confirmingUserFullName"] = this.confirmingUserFullName;
        data["month"] = this.month;
        data["note"] = this.note;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        return data;
    }

    clone(): CheckDrugExpirationDto {
        const json = this.toJSON();
        let result = new CheckDrugExpirationDto();
        result.init(json);
        return result;
    }
}

export interface ICheckDrugExpirationDto {
    id: number;
    isConfirmed: boolean;
    confirmingUserId: number | undefined;
    confirmationDate: moment.Moment | undefined;
    confirmingUserFullName: string | undefined;
    month: number;
    note: string | undefined;
    creationTime: moment.Moment;
}

export class CheckDrugExpirationDtoPagedResultDto implements ICheckDrugExpirationDtoPagedResultDto {
    items!: CheckDrugExpirationDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICheckDrugExpirationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CheckDrugExpirationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CheckDrugExpirationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckDrugExpirationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CheckDrugExpirationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CheckDrugExpirationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICheckDrugExpirationDtoPagedResultDto {
    items: CheckDrugExpirationDto[] | undefined;
    totalCount: number;
}

export class ConfirmationSignatureDto implements IConfirmationSignatureDto {
    id!: number;
    reconciliationPharmacologicalType!: DictionaryDto;
    isConfirmed!: boolean;
    confirmingUserId!: number | undefined;
    confirmationDate!: moment.Moment | undefined;
    confirmingUserFullName!: string | undefined;

    constructor(data?: IConfirmationSignatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reconciliationPharmacologicalType = _data["reconciliationPharmacologicalType"] ? DictionaryDto.fromJS(_data["reconciliationPharmacologicalType"]) : undefined as any;
            this.isConfirmed = _data["isConfirmed"];
            this.confirmingUserId = _data["confirmingUserId"];
            this.confirmationDate = _data["confirmationDate"] ? moment(_data["confirmationDate"].toString()) : undefined as any;
            this.confirmingUserFullName = _data["confirmingUserFullName"];
        }
    }

    static fromJS(data: any): ConfirmationSignatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmationSignatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reconciliationPharmacologicalType"] = this.reconciliationPharmacologicalType ? this.reconciliationPharmacologicalType.toJSON() : undefined as any;
        data["isConfirmed"] = this.isConfirmed;
        data["confirmingUserId"] = this.confirmingUserId;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : undefined as any;
        data["confirmingUserFullName"] = this.confirmingUserFullName;
        return data;
    }

    clone(): ConfirmationSignatureDto {
        const json = this.toJSON();
        let result = new ConfirmationSignatureDto();
        result.init(json);
        return result;
    }
}

export interface IConfirmationSignatureDto {
    id: number;
    reconciliationPharmacologicalType: DictionaryDto;
    isConfirmed: boolean;
    confirmingUserId: number | undefined;
    confirmationDate: moment.Moment | undefined;
    confirmingUserFullName: string | undefined;
}

export class ConleyQuestionDto implements IConleyQuestionDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;
    score!: number;

    constructor(data?: IConleyQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
            this.score = _data["score"];
        }
    }

    static fromJS(data: any): ConleyQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConleyQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        data["score"] = this.score;
        return data;
    }

    clone(): ConleyQuestionDto {
        const json = this.toJSON();
        let result = new ConleyQuestionDto();
        result.init(json);
        return result;
    }
}

export interface IConleyQuestionDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
    score: number;
}

export class ConleyScaleDto implements IConleyScaleDto {
    id!: number;
    isConfirmed!: boolean;
    confirmingUserId!: number | undefined;
    confirmationDate!: moment.Moment | undefined;
    isMale!: boolean | undefined;
    confirmingUserFullName!: string | undefined;
    admissionDate!: moment.Moment;
    detectionDate!: moment.Moment;
    conleyQuestion1!: number;
    conleyQuestion2!: number;
    conleyQuestion3!: number;
    conleyQuestion4!: number;
    conleyQuestion5!: number;
    conleyQuestion6!: number;

    constructor(data?: IConleyScaleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isConfirmed = _data["isConfirmed"];
            this.confirmingUserId = _data["confirmingUserId"];
            this.confirmationDate = _data["confirmationDate"] ? moment(_data["confirmationDate"].toString()) : undefined as any;
            this.isMale = _data["isMale"];
            this.confirmingUserFullName = _data["confirmingUserFullName"];
            this.admissionDate = _data["admissionDate"] ? moment(_data["admissionDate"].toString()) : undefined as any;
            this.detectionDate = _data["detectionDate"] ? moment(_data["detectionDate"].toString()) : undefined as any;
            this.conleyQuestion1 = _data["conleyQuestion1"];
            this.conleyQuestion2 = _data["conleyQuestion2"];
            this.conleyQuestion3 = _data["conleyQuestion3"];
            this.conleyQuestion4 = _data["conleyQuestion4"];
            this.conleyQuestion5 = _data["conleyQuestion5"];
            this.conleyQuestion6 = _data["conleyQuestion6"];
        }
    }

    static fromJS(data: any): ConleyScaleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConleyScaleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isConfirmed"] = this.isConfirmed;
        data["confirmingUserId"] = this.confirmingUserId;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : undefined as any;
        data["isMale"] = this.isMale;
        data["confirmingUserFullName"] = this.confirmingUserFullName;
        data["admissionDate"] = this.admissionDate ? this.admissionDate.toISOString() : undefined as any;
        data["detectionDate"] = this.detectionDate ? this.detectionDate.toISOString() : undefined as any;
        data["conleyQuestion1"] = this.conleyQuestion1;
        data["conleyQuestion2"] = this.conleyQuestion2;
        data["conleyQuestion3"] = this.conleyQuestion3;
        data["conleyQuestion4"] = this.conleyQuestion4;
        data["conleyQuestion5"] = this.conleyQuestion5;
        data["conleyQuestion6"] = this.conleyQuestion6;
        return data;
    }

    clone(): ConleyScaleDto {
        const json = this.toJSON();
        let result = new ConleyScaleDto();
        result.init(json);
        return result;
    }
}

export interface IConleyScaleDto {
    id: number;
    isConfirmed: boolean;
    confirmingUserId: number | undefined;
    confirmationDate: moment.Moment | undefined;
    isMale: boolean | undefined;
    confirmingUserFullName: string | undefined;
    admissionDate: moment.Moment;
    detectionDate: moment.Moment;
    conleyQuestion1: number;
    conleyQuestion2: number;
    conleyQuestion3: number;
    conleyQuestion4: number;
    conleyQuestion5: number;
    conleyQuestion6: number;
}

export class ConleyScaleDtoPagedResultDto implements IConleyScaleDtoPagedResultDto {
    items!: ConleyScaleDto[] | undefined;
    totalCount!: number;

    constructor(data?: IConleyScaleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ConleyScaleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ConleyScaleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConleyScaleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ConleyScaleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ConleyScaleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IConleyScaleDtoPagedResultDto {
    items: ConleyScaleDto[] | undefined;
    totalCount: number;
}

export class CreateActivityDto implements ICreateActivityDto {
    name!: string;
    description!: string | undefined;
    startDateTime!: moment.Moment;
    endDateTime!: moment.Moment;
    badgeInDateTime!: moment.Moment | undefined;
    badgeOutDateTime!: moment.Moment | undefined;
    note!: string | undefined;
    actualActivityMinutes!: number;
    isAbsent!: boolean | undefined;
    reasonAbsence!: string | undefined;
    serviceId!: number;
    plannedActivityMinutes!: number;
    recurrenceRule!: string | undefined;
    recurrenceException!: string | undefined;
    fileIds!: number[] | undefined;
    placeIds!: number[] | undefined;
    serviceOperatorIds!: number[] | undefined;
    serviceBeneficiaryIds!: number[] | undefined;
    qualificationId!: number | undefined;
    statusId!: number | undefined;
    cancellationReason!: string | undefined;

    constructor(data?: ICreateActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : undefined as any;
            this.badgeInDateTime = _data["badgeInDateTime"] ? moment(_data["badgeInDateTime"].toString()) : undefined as any;
            this.badgeOutDateTime = _data["badgeOutDateTime"] ? moment(_data["badgeOutDateTime"].toString()) : undefined as any;
            this.note = _data["note"];
            this.actualActivityMinutes = _data["actualActivityMinutes"];
            this.isAbsent = _data["isAbsent"];
            this.reasonAbsence = _data["reasonAbsence"];
            this.serviceId = _data["serviceId"];
            this.plannedActivityMinutes = _data["plannedActivityMinutes"];
            this.recurrenceRule = _data["recurrenceRule"];
            this.recurrenceException = _data["recurrenceException"];
            if (Array.isArray(_data["fileIds"])) {
                this.fileIds = [] as any;
                for (let item of _data["fileIds"])
                    this.fileIds!.push(item);
            }
            if (Array.isArray(_data["placeIds"])) {
                this.placeIds = [] as any;
                for (let item of _data["placeIds"])
                    this.placeIds!.push(item);
            }
            if (Array.isArray(_data["serviceOperatorIds"])) {
                this.serviceOperatorIds = [] as any;
                for (let item of _data["serviceOperatorIds"])
                    this.serviceOperatorIds!.push(item);
            }
            if (Array.isArray(_data["serviceBeneficiaryIds"])) {
                this.serviceBeneficiaryIds = [] as any;
                for (let item of _data["serviceBeneficiaryIds"])
                    this.serviceBeneficiaryIds!.push(item);
            }
            this.qualificationId = _data["qualificationId"];
            this.statusId = _data["statusId"];
            this.cancellationReason = _data["cancellationReason"];
        }
    }

    static fromJS(data: any): CreateActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined as any;
        data["badgeInDateTime"] = this.badgeInDateTime ? this.badgeInDateTime.toISOString() : undefined as any;
        data["badgeOutDateTime"] = this.badgeOutDateTime ? this.badgeOutDateTime.toISOString() : undefined as any;
        data["note"] = this.note;
        data["actualActivityMinutes"] = this.actualActivityMinutes;
        data["isAbsent"] = this.isAbsent;
        data["reasonAbsence"] = this.reasonAbsence;
        data["serviceId"] = this.serviceId;
        data["plannedActivityMinutes"] = this.plannedActivityMinutes;
        data["recurrenceRule"] = this.recurrenceRule;
        data["recurrenceException"] = this.recurrenceException;
        if (Array.isArray(this.fileIds)) {
            data["fileIds"] = [];
            for (let item of this.fileIds)
                data["fileIds"].push(item);
        }
        if (Array.isArray(this.placeIds)) {
            data["placeIds"] = [];
            for (let item of this.placeIds)
                data["placeIds"].push(item);
        }
        if (Array.isArray(this.serviceOperatorIds)) {
            data["serviceOperatorIds"] = [];
            for (let item of this.serviceOperatorIds)
                data["serviceOperatorIds"].push(item);
        }
        if (Array.isArray(this.serviceBeneficiaryIds)) {
            data["serviceBeneficiaryIds"] = [];
            for (let item of this.serviceBeneficiaryIds)
                data["serviceBeneficiaryIds"].push(item);
        }
        data["qualificationId"] = this.qualificationId;
        data["statusId"] = this.statusId;
        data["cancellationReason"] = this.cancellationReason;
        return data;
    }

    clone(): CreateActivityDto {
        const json = this.toJSON();
        let result = new CreateActivityDto();
        result.init(json);
        return result;
    }
}

export interface ICreateActivityDto {
    name: string;
    description: string | undefined;
    startDateTime: moment.Moment;
    endDateTime: moment.Moment;
    badgeInDateTime: moment.Moment | undefined;
    badgeOutDateTime: moment.Moment | undefined;
    note: string | undefined;
    actualActivityMinutes: number;
    isAbsent: boolean | undefined;
    reasonAbsence: string | undefined;
    serviceId: number;
    plannedActivityMinutes: number;
    recurrenceRule: string | undefined;
    recurrenceException: string | undefined;
    fileIds: number[] | undefined;
    placeIds: number[] | undefined;
    serviceOperatorIds: number[] | undefined;
    serviceBeneficiaryIds: number[] | undefined;
    qualificationId: number | undefined;
    statusId: number | undefined;
    cancellationReason: string | undefined;
}

export class CreateActivityUserDto implements ICreateActivityUserDto {
    serviceUserId!: number;
    activityId!: number;

    constructor(data?: ICreateActivityUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceUserId = _data["serviceUserId"];
            this.activityId = _data["activityId"];
        }
    }

    static fromJS(data: any): CreateActivityUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceUserId"] = this.serviceUserId;
        data["activityId"] = this.activityId;
        return data;
    }

    clone(): CreateActivityUserDto {
        const json = this.toJSON();
        let result = new CreateActivityUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateActivityUserDto {
    serviceUserId: number;
    activityId: number;
}

export class CreateAddressDto implements ICreateAddressDto {
    streetName!: string | undefined;
    streetNumber!: string | undefined;
    postalCode!: string | undefined;
    isMain!: boolean;
    municipalityId!: number;

    constructor(data?: ICreateAddressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.streetName = _data["streetName"];
            this.streetNumber = _data["streetNumber"];
            this.postalCode = _data["postalCode"];
            this.isMain = _data["isMain"];
            this.municipalityId = _data["municipalityId"];
        }
    }

    static fromJS(data: any): CreateAddressDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAddressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["streetName"] = this.streetName;
        data["streetNumber"] = this.streetNumber;
        data["postalCode"] = this.postalCode;
        data["isMain"] = this.isMain;
        data["municipalityId"] = this.municipalityId;
        return data;
    }

    clone(): CreateAddressDto {
        const json = this.toJSON();
        let result = new CreateAddressDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAddressDto {
    streetName: string | undefined;
    streetNumber: string | undefined;
    postalCode: string | undefined;
    isMain: boolean;
    municipalityId: number;
}

export class CreateAdministrativeLegalAreaDto implements ICreateAdministrativeLegalAreaDto {
    inputCardRecordId!: number;
    supportAdministrator!: boolean;
    supportAdministratorName!: string | undefined;
    supportAdministratorDate!: moment.Moment | undefined;
    guardian!: boolean;
    guardianName!: string | undefined;
    guardianDate!: moment.Moment | undefined;
    pension!: boolean;
    accompaniment!: boolean;
    freeTransport!: boolean;
    freeTransportWithAccompaniment!: boolean;
    registrationForTargetedPlacement!: boolean;
    presenceOfFunctionalDiagnosis!: boolean;
    note!: string | undefined;

    constructor(data?: ICreateAdministrativeLegalAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputCardRecordId = _data["inputCardRecordId"];
            this.supportAdministrator = _data["supportAdministrator"];
            this.supportAdministratorName = _data["supportAdministratorName"];
            this.supportAdministratorDate = _data["supportAdministratorDate"] ? moment(_data["supportAdministratorDate"].toString()) : undefined as any;
            this.guardian = _data["guardian"];
            this.guardianName = _data["guardianName"];
            this.guardianDate = _data["guardianDate"] ? moment(_data["guardianDate"].toString()) : undefined as any;
            this.pension = _data["pension"];
            this.accompaniment = _data["accompaniment"];
            this.freeTransport = _data["freeTransport"];
            this.freeTransportWithAccompaniment = _data["freeTransportWithAccompaniment"];
            this.registrationForTargetedPlacement = _data["registrationForTargetedPlacement"];
            this.presenceOfFunctionalDiagnosis = _data["presenceOfFunctionalDiagnosis"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateAdministrativeLegalAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAdministrativeLegalAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputCardRecordId"] = this.inputCardRecordId;
        data["supportAdministrator"] = this.supportAdministrator;
        data["supportAdministratorName"] = this.supportAdministratorName;
        data["supportAdministratorDate"] = this.supportAdministratorDate ? this.supportAdministratorDate.toISOString() : undefined as any;
        data["guardian"] = this.guardian;
        data["guardianName"] = this.guardianName;
        data["guardianDate"] = this.guardianDate ? this.guardianDate.toISOString() : undefined as any;
        data["pension"] = this.pension;
        data["accompaniment"] = this.accompaniment;
        data["freeTransport"] = this.freeTransport;
        data["freeTransportWithAccompaniment"] = this.freeTransportWithAccompaniment;
        data["registrationForTargetedPlacement"] = this.registrationForTargetedPlacement;
        data["presenceOfFunctionalDiagnosis"] = this.presenceOfFunctionalDiagnosis;
        data["note"] = this.note;
        return data;
    }

    clone(): CreateAdministrativeLegalAreaDto {
        const json = this.toJSON();
        let result = new CreateAdministrativeLegalAreaDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAdministrativeLegalAreaDto {
    inputCardRecordId: number;
    supportAdministrator: boolean;
    supportAdministratorName: string | undefined;
    supportAdministratorDate: moment.Moment | undefined;
    guardian: boolean;
    guardianName: string | undefined;
    guardianDate: moment.Moment | undefined;
    pension: boolean;
    accompaniment: boolean;
    freeTransport: boolean;
    freeTransportWithAccompaniment: boolean;
    registrationForTargetedPlacement: boolean;
    presenceOfFunctionalDiagnosis: boolean;
    note: string | undefined;
}

export class CreateAdmissionRecordDto implements ICreateAdmissionRecordDto {
    socialHealthRecordId!: number;
    admissionDate!: moment.Moment;
    admissionTypeId!: number | undefined;
    admissionDiagnosis!: string | undefined;
    travel!: boolean | undefined;
    diningFacility!: boolean | undefined;
    reconciliationVoucherRequest!: boolean;
    startDateVoucher!: moment.Moment | undefined;
    endDateVoucher!: moment.Moment | undefined;
    disability!: string | undefined;
    accompanimentAllowance!: boolean;
    admissionDiagnosisUVMReport!: string | undefined;
    dailyAttendanceResidentialFacility!: boolean | undefined;
    dayOfWeekIds!: number[] | undefined;
    admissionResidentialAuthorization!: CreateAdmissionResidentialAuthorizationDto;
    pharmacologicalTherapy!: CreateDrugDto[] | undefined;
    historicalCases!: CreateHistoricalCaseDto[] | undefined;
    foodAllergies!: string | undefined;
    otherDietaryHabits!: string | undefined;
    personalAutonomy!: CreatePersonalAutonomyDto;
    remotePathologicalAnamnesis!: string | undefined;
    proximalPathologicalAnamnesis!: string | undefined;
    orthosesProsthesesAndAids!: string | undefined;

    constructor(data?: ICreateAdmissionRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.admissionDate = _data["admissionDate"] ? moment(_data["admissionDate"].toString()) : undefined as any;
            this.admissionTypeId = _data["admissionTypeId"];
            this.admissionDiagnosis = _data["admissionDiagnosis"];
            this.travel = _data["travel"];
            this.diningFacility = _data["diningFacility"];
            this.reconciliationVoucherRequest = _data["reconciliationVoucherRequest"];
            this.startDateVoucher = _data["startDateVoucher"] ? moment(_data["startDateVoucher"].toString()) : undefined as any;
            this.endDateVoucher = _data["endDateVoucher"] ? moment(_data["endDateVoucher"].toString()) : undefined as any;
            this.disability = _data["disability"];
            this.accompanimentAllowance = _data["accompanimentAllowance"];
            this.admissionDiagnosisUVMReport = _data["admissionDiagnosisUVMReport"];
            this.dailyAttendanceResidentialFacility = _data["dailyAttendanceResidentialFacility"];
            if (Array.isArray(_data["dayOfWeekIds"])) {
                this.dayOfWeekIds = [] as any;
                for (let item of _data["dayOfWeekIds"])
                    this.dayOfWeekIds!.push(item);
            }
            this.admissionResidentialAuthorization = _data["admissionResidentialAuthorization"] ? CreateAdmissionResidentialAuthorizationDto.fromJS(_data["admissionResidentialAuthorization"]) : undefined as any;
            if (Array.isArray(_data["pharmacologicalTherapy"])) {
                this.pharmacologicalTherapy = [] as any;
                for (let item of _data["pharmacologicalTherapy"])
                    this.pharmacologicalTherapy!.push(CreateDrugDto.fromJS(item));
            }
            if (Array.isArray(_data["historicalCases"])) {
                this.historicalCases = [] as any;
                for (let item of _data["historicalCases"])
                    this.historicalCases!.push(CreateHistoricalCaseDto.fromJS(item));
            }
            this.foodAllergies = _data["foodAllergies"];
            this.otherDietaryHabits = _data["otherDietaryHabits"];
            this.personalAutonomy = _data["personalAutonomy"] ? CreatePersonalAutonomyDto.fromJS(_data["personalAutonomy"]) : undefined as any;
            this.remotePathologicalAnamnesis = _data["remotePathologicalAnamnesis"];
            this.proximalPathologicalAnamnesis = _data["proximalPathologicalAnamnesis"];
            this.orthosesProsthesesAndAids = _data["orthosesProsthesesAndAids"];
        }
    }

    static fromJS(data: any): CreateAdmissionRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAdmissionRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["admissionDate"] = this.admissionDate ? this.admissionDate.format('YYYY-MM-DD') : undefined as any;
        data["admissionTypeId"] = this.admissionTypeId;
        data["admissionDiagnosis"] = this.admissionDiagnosis;
        data["travel"] = this.travel;
        data["diningFacility"] = this.diningFacility;
        data["reconciliationVoucherRequest"] = this.reconciliationVoucherRequest;
        data["startDateVoucher"] = this.startDateVoucher ? this.startDateVoucher.format('YYYY-MM-DD') : undefined as any;
        data["endDateVoucher"] = this.endDateVoucher ? this.endDateVoucher.format('YYYY-MM-DD') : undefined as any;
        data["disability"] = this.disability;
        data["accompanimentAllowance"] = this.accompanimentAllowance;
        data["admissionDiagnosisUVMReport"] = this.admissionDiagnosisUVMReport;
        data["dailyAttendanceResidentialFacility"] = this.dailyAttendanceResidentialFacility;
        if (Array.isArray(this.dayOfWeekIds)) {
            data["dayOfWeekIds"] = [];
            for (let item of this.dayOfWeekIds)
                data["dayOfWeekIds"].push(item);
        }
        data["admissionResidentialAuthorization"] = this.admissionResidentialAuthorization ? this.admissionResidentialAuthorization.toJSON() : undefined as any;
        if (Array.isArray(this.pharmacologicalTherapy)) {
            data["pharmacologicalTherapy"] = [];
            for (let item of this.pharmacologicalTherapy)
                data["pharmacologicalTherapy"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.historicalCases)) {
            data["historicalCases"] = [];
            for (let item of this.historicalCases)
                data["historicalCases"].push(item ? item.toJSON() : undefined as any);
        }
        data["foodAllergies"] = this.foodAllergies;
        data["otherDietaryHabits"] = this.otherDietaryHabits;
        data["personalAutonomy"] = this.personalAutonomy ? this.personalAutonomy.toJSON() : undefined as any;
        data["remotePathologicalAnamnesis"] = this.remotePathologicalAnamnesis;
        data["proximalPathologicalAnamnesis"] = this.proximalPathologicalAnamnesis;
        data["orthosesProsthesesAndAids"] = this.orthosesProsthesesAndAids;
        return data;
    }

    clone(): CreateAdmissionRecordDto {
        const json = this.toJSON();
        let result = new CreateAdmissionRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAdmissionRecordDto {
    socialHealthRecordId: number;
    admissionDate: moment.Moment;
    admissionTypeId: number | undefined;
    admissionDiagnosis: string | undefined;
    travel: boolean | undefined;
    diningFacility: boolean | undefined;
    reconciliationVoucherRequest: boolean;
    startDateVoucher: moment.Moment | undefined;
    endDateVoucher: moment.Moment | undefined;
    disability: string | undefined;
    accompanimentAllowance: boolean;
    admissionDiagnosisUVMReport: string | undefined;
    dailyAttendanceResidentialFacility: boolean | undefined;
    dayOfWeekIds: number[] | undefined;
    admissionResidentialAuthorization: CreateAdmissionResidentialAuthorizationDto;
    pharmacologicalTherapy: CreateDrugDto[] | undefined;
    historicalCases: CreateHistoricalCaseDto[] | undefined;
    foodAllergies: string | undefined;
    otherDietaryHabits: string | undefined;
    personalAutonomy: CreatePersonalAutonomyDto;
    remotePathologicalAnamnesis: string | undefined;
    proximalPathologicalAnamnesis: string | undefined;
    orthosesProsthesesAndAids: string | undefined;
}

export class CreateAdmissionResidentialAuthorizationDto implements ICreateAdmissionResidentialAuthorizationDto {
    date!: moment.Moment | undefined;
    protocol!: string | undefined;
    expirationDate!: moment.Moment | undefined;
    attendanceStartDate!: moment.Moment | undefined;

    constructor(data?: ICreateAdmissionResidentialAuthorizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.protocol = _data["protocol"];
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : undefined as any;
            this.attendanceStartDate = _data["attendanceStartDate"] ? moment(_data["attendanceStartDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateAdmissionResidentialAuthorizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAdmissionResidentialAuthorizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined as any;
        data["protocol"] = this.protocol;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.format('YYYY-MM-DD') : undefined as any;
        data["attendanceStartDate"] = this.attendanceStartDate ? this.attendanceStartDate.format('YYYY-MM-DD') : undefined as any;
        return data;
    }

    clone(): CreateAdmissionResidentialAuthorizationDto {
        const json = this.toJSON();
        let result = new CreateAdmissionResidentialAuthorizationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAdmissionResidentialAuthorizationDto {
    date: moment.Moment | undefined;
    protocol: string | undefined;
    expirationDate: moment.Moment | undefined;
    attendanceStartDate: moment.Moment | undefined;
}

export class CreateAirTreatmentSystemDto implements ICreateAirTreatmentSystemDto {
    structureId!: number;
    name!: string;

    constructor(data?: ICreateAirTreatmentSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.structureId = _data["structureId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateAirTreatmentSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAirTreatmentSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["structureId"] = this.structureId;
        data["name"] = this.name;
        return data;
    }

    clone(): CreateAirTreatmentSystemDto {
        const json = this.toJSON();
        let result = new CreateAirTreatmentSystemDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAirTreatmentSystemDto {
    structureId: number;
    name: string;
}

export class CreateAlertDto implements ICreateAlertDto {
    date!: moment.Moment;
    title!: string | undefined;
    description!: string | undefined;
    contextLink!: string | undefined;
    emailNotification!: boolean;
    userIds!: number[] | undefined;

    constructor(data?: ICreateAlertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.title = _data["title"];
            this.description = _data["description"];
            this.contextLink = _data["contextLink"];
            this.emailNotification = _data["emailNotification"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateAlertDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAlertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["title"] = this.title;
        data["description"] = this.description;
        data["contextLink"] = this.contextLink;
        data["emailNotification"] = this.emailNotification;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        return data;
    }

    clone(): CreateAlertDto {
        const json = this.toJSON();
        let result = new CreateAlertDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAlertDto {
    date: moment.Moment;
    title: string | undefined;
    description: string | undefined;
    contextLink: string | undefined;
    emailNotification: boolean;
    userIds: number[] | undefined;
}

export class CreateAllSocialHealthRecordExtensionDateDto implements ICreateAllSocialHealthRecordExtensionDateDto {
    socialHealthRecordId!: number;
    extensions!: CreateSocialHealthRecordExtensionDateDto[] | undefined;

    constructor(data?: ICreateAllSocialHealthRecordExtensionDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            if (Array.isArray(_data["extensions"])) {
                this.extensions = [] as any;
                for (let item of _data["extensions"])
                    this.extensions!.push(CreateSocialHealthRecordExtensionDateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateAllSocialHealthRecordExtensionDateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAllSocialHealthRecordExtensionDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        if (Array.isArray(this.extensions)) {
            data["extensions"] = [];
            for (let item of this.extensions)
                data["extensions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreateAllSocialHealthRecordExtensionDateDto {
        const json = this.toJSON();
        let result = new CreateAllSocialHealthRecordExtensionDateDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAllSocialHealthRecordExtensionDateDto {
    socialHealthRecordId: number;
    extensions: CreateSocialHealthRecordExtensionDateDto[] | undefined;
}

export class CreateAntiTheftSystemDto implements ICreateAntiTheftSystemDto {
    structureId!: number;
    name!: string;

    constructor(data?: ICreateAntiTheftSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.structureId = _data["structureId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateAntiTheftSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAntiTheftSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["structureId"] = this.structureId;
        data["name"] = this.name;
        return data;
    }

    clone(): CreateAntiTheftSystemDto {
        const json = this.toJSON();
        let result = new CreateAntiTheftSystemDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAntiTheftSystemDto {
    structureId: number;
    name: string;
}

export class CreateAssetDto implements ICreateAssetDto {
    name!: string | undefined;
    assetTypeId!: number | undefined;
    description!: string | undefined;
    iccid!: string | undefined;
    phoneNumber!: string | undefined;
    pin!: string | undefined;
    puk!: string | undefined;
    note!: string | undefined;

    constructor(data?: ICreateAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.assetTypeId = _data["assetTypeId"];
            this.description = _data["description"];
            this.iccid = _data["iccid"];
            this.phoneNumber = _data["phoneNumber"];
            this.pin = _data["pin"];
            this.puk = _data["puk"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["assetTypeId"] = this.assetTypeId;
        data["description"] = this.description;
        data["iccid"] = this.iccid;
        data["phoneNumber"] = this.phoneNumber;
        data["pin"] = this.pin;
        data["puk"] = this.puk;
        data["note"] = this.note;
        return data;
    }

    clone(): CreateAssetDto {
        const json = this.toJSON();
        let result = new CreateAssetDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAssetDto {
    name: string | undefined;
    assetTypeId: number | undefined;
    description: string | undefined;
    iccid: string | undefined;
    phoneNumber: string | undefined;
    pin: string | undefined;
    puk: string | undefined;
    note: string | undefined;
}

export class CreateAssetServiceUserDto implements ICreateAssetServiceUserDto {
    assetId!: number;
    serviceId!: number;
    userId!: number | undefined;
    assignmentDate!: moment.Moment;
    withdrawalDate!: moment.Moment | undefined;

    constructor(data?: ICreateAssetServiceUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.serviceId = _data["serviceId"];
            this.userId = _data["userId"];
            this.assignmentDate = _data["assignmentDate"] ? moment(_data["assignmentDate"].toString()) : undefined as any;
            this.withdrawalDate = _data["withdrawalDate"] ? moment(_data["withdrawalDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateAssetServiceUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssetServiceUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["serviceId"] = this.serviceId;
        data["userId"] = this.userId;
        data["assignmentDate"] = this.assignmentDate ? this.assignmentDate.toISOString() : undefined as any;
        data["withdrawalDate"] = this.withdrawalDate ? this.withdrawalDate.toISOString() : undefined as any;
        return data;
    }

    clone(): CreateAssetServiceUserDto {
        const json = this.toJSON();
        let result = new CreateAssetServiceUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAssetServiceUserDto {
    assetId: number;
    serviceId: number;
    userId: number | undefined;
    assignmentDate: moment.Moment;
    withdrawalDate: moment.Moment | undefined;
}

export class CreateAutonomyDto implements ICreateAutonomyDto {
    inputCardRecordId!: number;
    eatAlone!: string | undefined;
    sleepAloneInRoom!: string | undefined;
    canCalculate!: string | undefined;
    canReadTime!: string | undefined;
    orientedInTime!: string | undefined;
    orientedInSpace!: string | undefined;
    usesPublicTransport!: string | undefined;
    dailyRoutine!: string | undefined;
    goesOutAlone!: string | undefined;
    staysHomeAlone!: string | undefined;
    weekendActivities!: string | undefined;
    hasFriends!: string | undefined;
    sleptAwayWithoutCloseRelatives!: string | undefined;
    hobbiesAndInterests!: string | undefined;
    difficultBehaviors!: string | undefined;
    sexualActivity!: string | undefined;
    personalHygiene!: string | undefined;
    takeCareYourSelf!: string | undefined;
    thingsInOrder!: string | undefined;
    assignmentsAtHome!: string | undefined;
    canWrite!: string | undefined;
    canRead!: string | undefined;
    knowPersonalDetail!: string | undefined;
    hasMoneyRegularly!: string | undefined;
    purchasesYourselfHome!: string | undefined;
    hasHouseKeys!: string | undefined;
    hasPhone!: string | undefined;
    crossRoadAlone!: string | undefined;
    other!: string | undefined;

    constructor(data?: ICreateAutonomyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputCardRecordId = _data["inputCardRecordId"];
            this.eatAlone = _data["eatAlone"];
            this.sleepAloneInRoom = _data["sleepAloneInRoom"];
            this.canCalculate = _data["canCalculate"];
            this.canReadTime = _data["canReadTime"];
            this.orientedInTime = _data["orientedInTime"];
            this.orientedInSpace = _data["orientedInSpace"];
            this.usesPublicTransport = _data["usesPublicTransport"];
            this.dailyRoutine = _data["dailyRoutine"];
            this.goesOutAlone = _data["goesOutAlone"];
            this.staysHomeAlone = _data["staysHomeAlone"];
            this.weekendActivities = _data["weekendActivities"];
            this.hasFriends = _data["hasFriends"];
            this.sleptAwayWithoutCloseRelatives = _data["sleptAwayWithoutCloseRelatives"];
            this.hobbiesAndInterests = _data["hobbiesAndInterests"];
            this.difficultBehaviors = _data["difficultBehaviors"];
            this.sexualActivity = _data["sexualActivity"];
            this.personalHygiene = _data["personalHygiene"];
            this.takeCareYourSelf = _data["takeCareYourSelf"];
            this.thingsInOrder = _data["thingsInOrder"];
            this.assignmentsAtHome = _data["assignmentsAtHome"];
            this.canWrite = _data["canWrite"];
            this.canRead = _data["canRead"];
            this.knowPersonalDetail = _data["knowPersonalDetail"];
            this.hasMoneyRegularly = _data["hasMoneyRegularly"];
            this.purchasesYourselfHome = _data["purchasesYourselfHome"];
            this.hasHouseKeys = _data["hasHouseKeys"];
            this.hasPhone = _data["hasPhone"];
            this.crossRoadAlone = _data["crossRoadAlone"];
            this.other = _data["other"];
        }
    }

    static fromJS(data: any): CreateAutonomyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAutonomyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputCardRecordId"] = this.inputCardRecordId;
        data["eatAlone"] = this.eatAlone;
        data["sleepAloneInRoom"] = this.sleepAloneInRoom;
        data["canCalculate"] = this.canCalculate;
        data["canReadTime"] = this.canReadTime;
        data["orientedInTime"] = this.orientedInTime;
        data["orientedInSpace"] = this.orientedInSpace;
        data["usesPublicTransport"] = this.usesPublicTransport;
        data["dailyRoutine"] = this.dailyRoutine;
        data["goesOutAlone"] = this.goesOutAlone;
        data["staysHomeAlone"] = this.staysHomeAlone;
        data["weekendActivities"] = this.weekendActivities;
        data["hasFriends"] = this.hasFriends;
        data["sleptAwayWithoutCloseRelatives"] = this.sleptAwayWithoutCloseRelatives;
        data["hobbiesAndInterests"] = this.hobbiesAndInterests;
        data["difficultBehaviors"] = this.difficultBehaviors;
        data["sexualActivity"] = this.sexualActivity;
        data["personalHygiene"] = this.personalHygiene;
        data["takeCareYourSelf"] = this.takeCareYourSelf;
        data["thingsInOrder"] = this.thingsInOrder;
        data["assignmentsAtHome"] = this.assignmentsAtHome;
        data["canWrite"] = this.canWrite;
        data["canRead"] = this.canRead;
        data["knowPersonalDetail"] = this.knowPersonalDetail;
        data["hasMoneyRegularly"] = this.hasMoneyRegularly;
        data["purchasesYourselfHome"] = this.purchasesYourselfHome;
        data["hasHouseKeys"] = this.hasHouseKeys;
        data["hasPhone"] = this.hasPhone;
        data["crossRoadAlone"] = this.crossRoadAlone;
        data["other"] = this.other;
        return data;
    }

    clone(): CreateAutonomyDto {
        const json = this.toJSON();
        let result = new CreateAutonomyDto();
        result.init(json);
        return result;
    }
}

export interface ICreateAutonomyDto {
    inputCardRecordId: number;
    eatAlone: string | undefined;
    sleepAloneInRoom: string | undefined;
    canCalculate: string | undefined;
    canReadTime: string | undefined;
    orientedInTime: string | undefined;
    orientedInSpace: string | undefined;
    usesPublicTransport: string | undefined;
    dailyRoutine: string | undefined;
    goesOutAlone: string | undefined;
    staysHomeAlone: string | undefined;
    weekendActivities: string | undefined;
    hasFriends: string | undefined;
    sleptAwayWithoutCloseRelatives: string | undefined;
    hobbiesAndInterests: string | undefined;
    difficultBehaviors: string | undefined;
    sexualActivity: string | undefined;
    personalHygiene: string | undefined;
    takeCareYourSelf: string | undefined;
    thingsInOrder: string | undefined;
    assignmentsAtHome: string | undefined;
    canWrite: string | undefined;
    canRead: string | undefined;
    knowPersonalDetail: string | undefined;
    hasMoneyRegularly: string | undefined;
    purchasesYourselfHome: string | undefined;
    hasHouseKeys: string | undefined;
    hasPhone: string | undefined;
    crossRoadAlone: string | undefined;
    other: string | undefined;
}

export class CreateBarthelIndexAnswerDto implements ICreateBarthelIndexAnswerDto {
    barthelIndexRecordId!: number;
    barthelAnswerIds!: number[] | undefined;

    constructor(data?: ICreateBarthelIndexAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barthelIndexRecordId = _data["barthelIndexRecordId"];
            if (Array.isArray(_data["barthelAnswerIds"])) {
                this.barthelAnswerIds = [] as any;
                for (let item of _data["barthelAnswerIds"])
                    this.barthelAnswerIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateBarthelIndexAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBarthelIndexAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barthelIndexRecordId"] = this.barthelIndexRecordId;
        if (Array.isArray(this.barthelAnswerIds)) {
            data["barthelAnswerIds"] = [];
            for (let item of this.barthelAnswerIds)
                data["barthelAnswerIds"].push(item);
        }
        return data;
    }

    clone(): CreateBarthelIndexAnswerDto {
        const json = this.toJSON();
        let result = new CreateBarthelIndexAnswerDto();
        result.init(json);
        return result;
    }
}

export interface ICreateBarthelIndexAnswerDto {
    barthelIndexRecordId: number;
    barthelAnswerIds: number[] | undefined;
}

export class CreateBarthelIndexDto implements ICreateBarthelIndexDto {
    date!: moment.Moment;
    socialHealthRecordId!: number;

    constructor(data?: ICreateBarthelIndexDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.socialHealthRecordId = _data["socialHealthRecordId"];
        }
    }

    static fromJS(data: any): CreateBarthelIndexDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBarthelIndexDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        return data;
    }

    clone(): CreateBarthelIndexDto {
        const json = this.toJSON();
        let result = new CreateBarthelIndexDto();
        result.init(json);
        return result;
    }
}

export interface ICreateBarthelIndexDto {
    date: moment.Moment;
    socialHealthRecordId: number;
}

export class CreateBodyTemperatureHourVitalSignDto implements ICreateBodyTemperatureHourVitalSignDto {
    vitalSignRecordId!: number;
    bodyTemperatureId!: number;
    hourVitalSignId!: number;

    constructor(data?: ICreateBodyTemperatureHourVitalSignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vitalSignRecordId = _data["vitalSignRecordId"];
            this.bodyTemperatureId = _data["bodyTemperatureId"];
            this.hourVitalSignId = _data["hourVitalSignId"];
        }
    }

    static fromJS(data: any): CreateBodyTemperatureHourVitalSignDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBodyTemperatureHourVitalSignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vitalSignRecordId"] = this.vitalSignRecordId;
        data["bodyTemperatureId"] = this.bodyTemperatureId;
        data["hourVitalSignId"] = this.hourVitalSignId;
        return data;
    }

    clone(): CreateBodyTemperatureHourVitalSignDto {
        const json = this.toJSON();
        let result = new CreateBodyTemperatureHourVitalSignDto();
        result.init(json);
        return result;
    }
}

export interface ICreateBodyTemperatureHourVitalSignDto {
    vitalSignRecordId: number;
    bodyTemperatureId: number;
    hourVitalSignId: number;
}

export class CreateCaregiverRecordDto implements ICreateCaregiverRecordDto {
    socialHealthRecordId!: number;
    name!: string | undefined;
    surname!: string | undefined;
    caregiverTypeId!: number | undefined;

    constructor(data?: ICreateCaregiverRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.caregiverTypeId = _data["caregiverTypeId"];
        }
    }

    static fromJS(data: any): CreateCaregiverRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCaregiverRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["caregiverTypeId"] = this.caregiverTypeId;
        return data;
    }

    clone(): CreateCaregiverRecordDto {
        const json = this.toJSON();
        let result = new CreateCaregiverRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCaregiverRecordDto {
    socialHealthRecordId: number;
    name: string | undefined;
    surname: string | undefined;
    caregiverTypeId: number | undefined;
}

export class CreateCategoryObservationGridDto implements ICreateCategoryObservationGridDto {
    name!: string | undefined;
    sectionObservationGridId!: number | undefined;

    constructor(data?: ICreateCategoryObservationGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.sectionObservationGridId = _data["sectionObservationGridId"];
        }
    }

    static fromJS(data: any): CreateCategoryObservationGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCategoryObservationGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sectionObservationGridId"] = this.sectionObservationGridId;
        return data;
    }

    clone(): CreateCategoryObservationGridDto {
        const json = this.toJSON();
        let result = new CreateCategoryObservationGridDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCategoryObservationGridDto {
    name: string | undefined;
    sectionObservationGridId: number | undefined;
}

export class CreateCheckDrugExpirationDto implements ICreateCheckDrugExpirationDto {
    serviceId!: number;
    month!: number;
    note!: string | undefined;

    constructor(data?: ICreateCheckDrugExpirationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.month = _data["month"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateCheckDrugExpirationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCheckDrugExpirationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["month"] = this.month;
        data["note"] = this.note;
        return data;
    }

    clone(): CreateCheckDrugExpirationDto {
        const json = this.toJSON();
        let result = new CreateCheckDrugExpirationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCheckDrugExpirationDto {
    serviceId: number;
    month: number;
    note: string | undefined;
}

export class CreateConleyScaleDto implements ICreateConleyScaleDto {
    socialHealthRecordId!: number;
    admissionDate!: moment.Moment;
    detectionDate!: moment.Moment;
    isMale!: boolean | undefined;
    conleyQuestion1!: number;
    conleyQuestion2!: number;
    conleyQuestion3!: number;
    conleyQuestion4!: number;
    conleyQuestion5!: number;
    conleyQuestion6!: number;

    constructor(data?: ICreateConleyScaleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.admissionDate = _data["admissionDate"] ? moment(_data["admissionDate"].toString()) : undefined as any;
            this.detectionDate = _data["detectionDate"] ? moment(_data["detectionDate"].toString()) : undefined as any;
            this.isMale = _data["isMale"];
            this.conleyQuestion1 = _data["conleyQuestion1"];
            this.conleyQuestion2 = _data["conleyQuestion2"];
            this.conleyQuestion3 = _data["conleyQuestion3"];
            this.conleyQuestion4 = _data["conleyQuestion4"];
            this.conleyQuestion5 = _data["conleyQuestion5"];
            this.conleyQuestion6 = _data["conleyQuestion6"];
        }
    }

    static fromJS(data: any): CreateConleyScaleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConleyScaleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["admissionDate"] = this.admissionDate ? this.admissionDate.toISOString() : undefined as any;
        data["detectionDate"] = this.detectionDate ? this.detectionDate.toISOString() : undefined as any;
        data["isMale"] = this.isMale;
        data["conleyQuestion1"] = this.conleyQuestion1;
        data["conleyQuestion2"] = this.conleyQuestion2;
        data["conleyQuestion3"] = this.conleyQuestion3;
        data["conleyQuestion4"] = this.conleyQuestion4;
        data["conleyQuestion5"] = this.conleyQuestion5;
        data["conleyQuestion6"] = this.conleyQuestion6;
        return data;
    }

    clone(): CreateConleyScaleDto {
        const json = this.toJSON();
        let result = new CreateConleyScaleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateConleyScaleDto {
    socialHealthRecordId: number;
    admissionDate: moment.Moment;
    detectionDate: moment.Moment;
    isMale: boolean | undefined;
    conleyQuestion1: number;
    conleyQuestion2: number;
    conleyQuestion3: number;
    conleyQuestion4: number;
    conleyQuestion5: number;
    conleyQuestion6: number;
}

export class CreateCustomDataTemplateDto implements ICreateCustomDataTemplateDto {
    name!: string | undefined;
    content!: string | undefined;

    constructor(data?: ICreateCustomDataTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): CreateCustomDataTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomDataTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["content"] = this.content;
        return data;
    }

    clone(): CreateCustomDataTemplateDto {
        const json = this.toJSON();
        let result = new CreateCustomDataTemplateDto();
        result.init(json);
        return result;
    }
}

export interface ICreateCustomDataTemplateDto {
    name: string | undefined;
    content: string | undefined;
}

export class CreateDiaryRecordDto implements ICreateDiaryRecordDto {
    socialHealthRecordId!: number;
    diaryTypeId!: number | undefined;
    description!: string | undefined;

    constructor(data?: ICreateDiaryRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.diaryTypeId = _data["diaryTypeId"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateDiaryRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDiaryRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["diaryTypeId"] = this.diaryTypeId;
        data["description"] = this.description;
        return data;
    }

    clone(): CreateDiaryRecordDto {
        const json = this.toJSON();
        let result = new CreateDiaryRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDiaryRecordDto {
    socialHealthRecordId: number;
    diaryTypeId: number | undefined;
    description: string | undefined;
}

export class CreateDictionaryDto implements ICreateDictionaryDto {
    description!: string;

    constructor(data?: ICreateDictionaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateDictionaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDictionaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        return data;
    }

    clone(): CreateDictionaryDto {
        const json = this.toJSON();
        let result = new CreateDictionaryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDictionaryDto {
    description: string;
}

export class CreateDisabilityDto implements ICreateDisabilityDto {
    inputCardRecordId!: number;
    percentage!: number;
    releaseDate!: moment.Moment | undefined;
    diagnosis!: string | undefined;
    note!: string | undefined;

    constructor(data?: ICreateDisabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputCardRecordId = _data["inputCardRecordId"];
            this.percentage = _data["percentage"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : undefined as any;
            this.diagnosis = _data["diagnosis"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateDisabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDisabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputCardRecordId"] = this.inputCardRecordId;
        data["percentage"] = this.percentage;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined as any;
        data["diagnosis"] = this.diagnosis;
        data["note"] = this.note;
        return data;
    }

    clone(): CreateDisabilityDto {
        const json = this.toJSON();
        let result = new CreateDisabilityDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDisabilityDto {
    inputCardRecordId: number;
    percentage: number;
    releaseDate: moment.Moment | undefined;
    diagnosis: string | undefined;
    note: string | undefined;
}

export class CreateDoctorRecordDto implements ICreateDoctorRecordDto {
    name!: string | undefined;
    surname!: string | undefined;
    doctorTypeId!: number | undefined;
    specialization!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    socialHealthRecordId!: number;

    constructor(data?: ICreateDoctorRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.doctorTypeId = _data["doctorTypeId"];
            this.specialization = _data["specialization"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.socialHealthRecordId = _data["socialHealthRecordId"];
        }
    }

    static fromJS(data: any): CreateDoctorRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDoctorRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["doctorTypeId"] = this.doctorTypeId;
        data["specialization"] = this.specialization;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        return data;
    }

    clone(): CreateDoctorRecordDto {
        const json = this.toJSON();
        let result = new CreateDoctorRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDoctorRecordDto {
    name: string | undefined;
    surname: string | undefined;
    doctorTypeId: number | undefined;
    specialization: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    socialHealthRecordId: number;
}

export class CreateDrugAdministrationRecordDto implements ICreateDrugAdministrationRecordDto {
    socialHealthRecordId!: number;
    administrationDateTime!: moment.Moment;
    drug!: string | undefined;
    administrator!: string | undefined;

    constructor(data?: ICreateDrugAdministrationRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.administrationDateTime = _data["administrationDateTime"] ? moment(_data["administrationDateTime"].toString()) : undefined as any;
            this.drug = _data["drug"];
            this.administrator = _data["administrator"];
        }
    }

    static fromJS(data: any): CreateDrugAdministrationRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDrugAdministrationRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["administrationDateTime"] = this.administrationDateTime ? this.administrationDateTime.toISOString() : undefined as any;
        data["drug"] = this.drug;
        data["administrator"] = this.administrator;
        return data;
    }

    clone(): CreateDrugAdministrationRecordDto {
        const json = this.toJSON();
        let result = new CreateDrugAdministrationRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDrugAdministrationRecordDto {
    socialHealthRecordId: number;
    administrationDateTime: moment.Moment;
    drug: string | undefined;
    administrator: string | undefined;
}

export class CreateDrugDto implements ICreateDrugDto {
    name!: string | undefined;
    administrationMethod!: string | undefined;
    admissionRecordId!: number;

    constructor(data?: ICreateDrugDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.administrationMethod = _data["administrationMethod"];
            this.admissionRecordId = _data["admissionRecordId"];
        }
    }

    static fromJS(data: any): CreateDrugDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDrugDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["administrationMethod"] = this.administrationMethod;
        data["admissionRecordId"] = this.admissionRecordId;
        return data;
    }

    clone(): CreateDrugDto {
        const json = this.toJSON();
        let result = new CreateDrugDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDrugDto {
    name: string | undefined;
    administrationMethod: string | undefined;
    admissionRecordId: number;
}

export class CreateDrugStockManagementRecordDto implements ICreateDrugStockManagementRecordDto {
    socialHealthRecordId!: number;
    drugName!: string | undefined;
    expiryDate!: moment.Moment | undefined;
    loadingDate!: moment.Moment | undefined;
    loadingQuantity!: string | undefined;
    dischargeDate!: moment.Moment | undefined;
    dischargeQuantity!: string | undefined;

    constructor(data?: ICreateDrugStockManagementRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.drugName = _data["drugName"];
            this.expiryDate = _data["expiryDate"] ? moment(_data["expiryDate"].toString()) : undefined as any;
            this.loadingDate = _data["loadingDate"] ? moment(_data["loadingDate"].toString()) : undefined as any;
            this.loadingQuantity = _data["loadingQuantity"];
            this.dischargeDate = _data["dischargeDate"] ? moment(_data["dischargeDate"].toString()) : undefined as any;
            this.dischargeQuantity = _data["dischargeQuantity"];
        }
    }

    static fromJS(data: any): CreateDrugStockManagementRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDrugStockManagementRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["drugName"] = this.drugName;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : undefined as any;
        data["loadingDate"] = this.loadingDate ? this.loadingDate.toISOString() : undefined as any;
        data["loadingQuantity"] = this.loadingQuantity;
        data["dischargeDate"] = this.dischargeDate ? this.dischargeDate.toISOString() : undefined as any;
        data["dischargeQuantity"] = this.dischargeQuantity;
        return data;
    }

    clone(): CreateDrugStockManagementRecordDto {
        const json = this.toJSON();
        let result = new CreateDrugStockManagementRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreateDrugStockManagementRecordDto {
    socialHealthRecordId: number;
    drugName: string | undefined;
    expiryDate: moment.Moment | undefined;
    loadingDate: moment.Moment | undefined;
    loadingQuantity: string | undefined;
    dischargeDate: moment.Moment | undefined;
    dischargeQuantity: string | undefined;
}

export class CreateEducationalTrainingDto implements ICreateEducationalTrainingDto {
    educationalDegreeLevelId!: number | undefined;
    support!: boolean | undefined;
    titleArchievement!: string | undefined;

    constructor(data?: ICreateEducationalTrainingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.educationalDegreeLevelId = _data["educationalDegreeLevelId"];
            this.support = _data["support"];
            this.titleArchievement = _data["titleArchievement"];
        }
    }

    static fromJS(data: any): CreateEducationalTrainingDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEducationalTrainingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["educationalDegreeLevelId"] = this.educationalDegreeLevelId;
        data["support"] = this.support;
        data["titleArchievement"] = this.titleArchievement;
        return data;
    }

    clone(): CreateEducationalTrainingDto {
        const json = this.toJSON();
        let result = new CreateEducationalTrainingDto();
        result.init(json);
        return result;
    }
}

export interface ICreateEducationalTrainingDto {
    educationalDegreeLevelId: number | undefined;
    support: boolean | undefined;
    titleArchievement: string | undefined;
}

export class CreateElectricalSystemDto implements ICreateElectricalSystemDto {
    structureId!: number;
    name!: string;

    constructor(data?: ICreateElectricalSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.structureId = _data["structureId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateElectricalSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateElectricalSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["structureId"] = this.structureId;
        data["name"] = this.name;
        return data;
    }

    clone(): CreateElectricalSystemDto {
        const json = this.toJSON();
        let result = new CreateElectricalSystemDto();
        result.init(json);
        return result;
    }
}

export interface ICreateElectricalSystemDto {
    structureId: number;
    name: string;
}

export class CreateElevatorSystemDto implements ICreateElevatorSystemDto {
    structureId!: number;
    name!: string;

    constructor(data?: ICreateElevatorSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.structureId = _data["structureId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateElevatorSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateElevatorSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["structureId"] = this.structureId;
        data["name"] = this.name;
        return data;
    }

    clone(): CreateElevatorSystemDto {
        const json = this.toJSON();
        let result = new CreateElevatorSystemDto();
        result.init(json);
        return result;
    }
}

export interface ICreateElevatorSystemDto {
    structureId: number;
    name: string;
}

export class CreateEmploymentPeriodDto implements ICreateEmploymentPeriodDto {
    startDateTime!: moment.Moment | undefined;
    endDateTime!: moment.Moment | undefined;

    constructor(data?: ICreateEmploymentPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateEmploymentPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEmploymentPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined as any;
        return data;
    }

    clone(): CreateEmploymentPeriodDto {
        const json = this.toJSON();
        let result = new CreateEmploymentPeriodDto();
        result.init(json);
        return result;
    }
}

export interface ICreateEmploymentPeriodDto {
    startDateTime: moment.Moment | undefined;
    endDateTime: moment.Moment | undefined;
}

export class CreateFallReportDto implements ICreateFallReportDto {
    socialHealthRecordId!: number;
    isMale!: boolean | undefined;
    admissionDate!: moment.Moment | undefined;
    floor!: number | undefined;
    roomNumber!: number | undefined;

    constructor(data?: ICreateFallReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.isMale = _data["isMale"];
            this.admissionDate = _data["admissionDate"] ? moment(_data["admissionDate"].toString()) : undefined as any;
            this.floor = _data["floor"];
            this.roomNumber = _data["roomNumber"];
        }
    }

    static fromJS(data: any): CreateFallReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFallReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["isMale"] = this.isMale;
        data["admissionDate"] = this.admissionDate ? this.admissionDate.toISOString() : undefined as any;
        data["floor"] = this.floor;
        data["roomNumber"] = this.roomNumber;
        return data;
    }

    clone(): CreateFallReportDto {
        const json = this.toJSON();
        let result = new CreateFallReportDto();
        result.init(json);
        return result;
    }
}

export interface ICreateFallReportDto {
    socialHealthRecordId: number;
    isMale: boolean | undefined;
    admissionDate: moment.Moment | undefined;
    floor: number | undefined;
    roomNumber: number | undefined;
}

export class CreateFamilyComponentDto implements ICreateFamilyComponentDto {
    socialInvestigationRecordId!: number | undefined;
    kinshipDegree!: string | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    birthDate!: moment.Moment | undefined;
    deathDate!: moment.Moment | undefined;
    workActivities!: string | undefined;
    educationDegree!: string | undefined;

    constructor(data?: ICreateFamilyComponentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialInvestigationRecordId = _data["socialInvestigationRecordId"];
            this.kinshipDegree = _data["kinshipDegree"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : undefined as any;
            this.deathDate = _data["deathDate"] ? moment(_data["deathDate"].toString()) : undefined as any;
            this.workActivities = _data["workActivities"];
            this.educationDegree = _data["educationDegree"];
        }
    }

    static fromJS(data: any): CreateFamilyComponentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFamilyComponentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialInvestigationRecordId"] = this.socialInvestigationRecordId;
        data["kinshipDegree"] = this.kinshipDegree;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["birthDate"] = this.birthDate ? this.birthDate.format('YYYY-MM-DD') : undefined as any;
        data["deathDate"] = this.deathDate ? this.deathDate.format('YYYY-MM-DD') : undefined as any;
        data["workActivities"] = this.workActivities;
        data["educationDegree"] = this.educationDegree;
        return data;
    }

    clone(): CreateFamilyComponentDto {
        const json = this.toJSON();
        let result = new CreateFamilyComponentDto();
        result.init(json);
        return result;
    }
}

export interface ICreateFamilyComponentDto {
    socialInvestigationRecordId: number | undefined;
    kinshipDegree: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    birthDate: moment.Moment | undefined;
    deathDate: moment.Moment | undefined;
    workActivities: string | undefined;
    educationDegree: string | undefined;
}

export class CreateFamilyReferenceDto implements ICreateFamilyReferenceDto {
    inputCardRecordId!: number;
    name!: string | undefined;
    surname!: string | undefined;
    phoneNumber!: string | undefined;
    emailAddress!: string | undefined;
    role!: string | undefined;

    constructor(data?: ICreateFamilyReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputCardRecordId = _data["inputCardRecordId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phoneNumber = _data["phoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): CreateFamilyReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFamilyReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputCardRecordId"] = this.inputCardRecordId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phoneNumber"] = this.phoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["role"] = this.role;
        return data;
    }

    clone(): CreateFamilyReferenceDto {
        const json = this.toJSON();
        let result = new CreateFamilyReferenceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateFamilyReferenceDto {
    inputCardRecordId: number;
    name: string | undefined;
    surname: string | undefined;
    phoneNumber: string | undefined;
    emailAddress: string | undefined;
    role: string | undefined;
}

export class CreateFileAssociationDto implements ICreateFileAssociationDto {
    fileId!: number;
    serviceId!: number | undefined;
    userId!: number | undefined;
    activityId!: number | undefined;
    socialHealthRecordId!: number | undefined;
    assetId!: number | undefined;
    vehicleId!: number | undefined;
    serviceVerbalId!: number | undefined;
    serviceReportId!: number | undefined;
    structureId!: number | undefined;
    fileTagIds!: number[] | undefined;
    expirationDate!: moment.Moment | undefined;

    constructor(data?: ICreateFileAssociationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"];
            this.serviceId = _data["serviceId"];
            this.userId = _data["userId"];
            this.activityId = _data["activityId"];
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.assetId = _data["assetId"];
            this.vehicleId = _data["vehicleId"];
            this.serviceVerbalId = _data["serviceVerbalId"];
            this.serviceReportId = _data["serviceReportId"];
            this.structureId = _data["structureId"];
            if (Array.isArray(_data["fileTagIds"])) {
                this.fileTagIds = [] as any;
                for (let item of _data["fileTagIds"])
                    this.fileTagIds!.push(item);
            }
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateFileAssociationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFileAssociationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId;
        data["serviceId"] = this.serviceId;
        data["userId"] = this.userId;
        data["activityId"] = this.activityId;
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["assetId"] = this.assetId;
        data["vehicleId"] = this.vehicleId;
        data["serviceVerbalId"] = this.serviceVerbalId;
        data["serviceReportId"] = this.serviceReportId;
        data["structureId"] = this.structureId;
        if (Array.isArray(this.fileTagIds)) {
            data["fileTagIds"] = [];
            for (let item of this.fileTagIds)
                data["fileTagIds"].push(item);
        }
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        return data;
    }

    clone(): CreateFileAssociationDto {
        const json = this.toJSON();
        let result = new CreateFileAssociationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateFileAssociationDto {
    fileId: number;
    serviceId: number | undefined;
    userId: number | undefined;
    activityId: number | undefined;
    socialHealthRecordId: number | undefined;
    assetId: number | undefined;
    vehicleId: number | undefined;
    serviceVerbalId: number | undefined;
    serviceReportId: number | undefined;
    structureId: number | undefined;
    fileTagIds: number[] | undefined;
    expirationDate: moment.Moment | undefined;
}

export class CreateFileTagDto implements ICreateFileTagDto {
    description!: string;

    constructor(data?: ICreateFileTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateFileTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFileTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        return data;
    }

    clone(): CreateFileTagDto {
        const json = this.toJSON();
        let result = new CreateFileTagDto();
        result.init(json);
        return result;
    }
}

export interface ICreateFileTagDto {
    description: string;
}

export class CreateFirePreventionSystemDto implements ICreateFirePreventionSystemDto {
    structureId!: number;
    name!: string;

    constructor(data?: ICreateFirePreventionSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.structureId = _data["structureId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateFirePreventionSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFirePreventionSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["structureId"] = this.structureId;
        data["name"] = this.name;
        return data;
    }

    clone(): CreateFirePreventionSystemDto {
        const json = this.toJSON();
        let result = new CreateFirePreventionSystemDto();
        result.init(json);
        return result;
    }
}

export interface ICreateFirePreventionSystemDto {
    structureId: number;
    name: string;
}

export class CreateHealthAspectDto implements ICreateHealthAspectDto {
    inputCardRecordId!: number;
    motorSkills!: boolean;
    sight!: boolean;
    hearing!: boolean;
    language!: boolean;
    walking!: boolean;
    other!: string | undefined;
    aids!: string | undefined;
    rehabilitationTherapies!: string | undefined;
    drugTherapies!: string | undefined;
    note!: string | undefined;

    constructor(data?: ICreateHealthAspectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputCardRecordId = _data["inputCardRecordId"];
            this.motorSkills = _data["motorSkills"];
            this.sight = _data["sight"];
            this.hearing = _data["hearing"];
            this.language = _data["language"];
            this.walking = _data["walking"];
            this.other = _data["other"];
            this.aids = _data["aids"];
            this.rehabilitationTherapies = _data["rehabilitationTherapies"];
            this.drugTherapies = _data["drugTherapies"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateHealthAspectDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHealthAspectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputCardRecordId"] = this.inputCardRecordId;
        data["motorSkills"] = this.motorSkills;
        data["sight"] = this.sight;
        data["hearing"] = this.hearing;
        data["language"] = this.language;
        data["walking"] = this.walking;
        data["other"] = this.other;
        data["aids"] = this.aids;
        data["rehabilitationTherapies"] = this.rehabilitationTherapies;
        data["drugTherapies"] = this.drugTherapies;
        data["note"] = this.note;
        return data;
    }

    clone(): CreateHealthAspectDto {
        const json = this.toJSON();
        let result = new CreateHealthAspectDto();
        result.init(json);
        return result;
    }
}

export interface ICreateHealthAspectDto {
    inputCardRecordId: number;
    motorSkills: boolean;
    sight: boolean;
    hearing: boolean;
    language: boolean;
    walking: boolean;
    other: string | undefined;
    aids: string | undefined;
    rehabilitationTherapies: string | undefined;
    drugTherapies: string | undefined;
    note: string | undefined;
}

export class CreateHealthCoordinatorRecordDto implements ICreateHealthCoordinatorRecordDto {
    date!: moment.Moment;
    diagnosis!: string | undefined;
    advice!: string | undefined;
    socialHealthRecordId!: number;

    constructor(data?: ICreateHealthCoordinatorRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.diagnosis = _data["diagnosis"];
            this.advice = _data["advice"];
            this.socialHealthRecordId = _data["socialHealthRecordId"];
        }
    }

    static fromJS(data: any): CreateHealthCoordinatorRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHealthCoordinatorRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["diagnosis"] = this.diagnosis;
        data["advice"] = this.advice;
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        return data;
    }

    clone(): CreateHealthCoordinatorRecordDto {
        const json = this.toJSON();
        let result = new CreateHealthCoordinatorRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreateHealthCoordinatorRecordDto {
    date: moment.Moment;
    diagnosis: string | undefined;
    advice: string | undefined;
    socialHealthRecordId: number;
}

export class CreateHealthSocialWelfareServiceDto implements ICreateHealthSocialWelfareServiceDto {
    inputCardRecordId!: number;
    dateOfAcceptance!: moment.Moment | undefined;
    socialWorker!: string | undefined;
    homeAssistant!: string | undefined;
    dayFosterCare!: string | undefined;
    inChargeAt!: string | undefined;
    serviceNPI!: string | undefined;

    constructor(data?: ICreateHealthSocialWelfareServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputCardRecordId = _data["inputCardRecordId"];
            this.dateOfAcceptance = _data["dateOfAcceptance"] ? moment(_data["dateOfAcceptance"].toString()) : undefined as any;
            this.socialWorker = _data["socialWorker"];
            this.homeAssistant = _data["homeAssistant"];
            this.dayFosterCare = _data["dayFosterCare"];
            this.inChargeAt = _data["inChargeAt"];
            this.serviceNPI = _data["serviceNPI"];
        }
    }

    static fromJS(data: any): CreateHealthSocialWelfareServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHealthSocialWelfareServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputCardRecordId"] = this.inputCardRecordId;
        data["dateOfAcceptance"] = this.dateOfAcceptance ? this.dateOfAcceptance.toISOString() : undefined as any;
        data["socialWorker"] = this.socialWorker;
        data["homeAssistant"] = this.homeAssistant;
        data["dayFosterCare"] = this.dayFosterCare;
        data["inChargeAt"] = this.inChargeAt;
        data["serviceNPI"] = this.serviceNPI;
        return data;
    }

    clone(): CreateHealthSocialWelfareServiceDto {
        const json = this.toJSON();
        let result = new CreateHealthSocialWelfareServiceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateHealthSocialWelfareServiceDto {
    inputCardRecordId: number;
    dateOfAcceptance: moment.Moment | undefined;
    socialWorker: string | undefined;
    homeAssistant: string | undefined;
    dayFosterCare: string | undefined;
    inChargeAt: string | undefined;
    serviceNPI: string | undefined;
}

export class CreateHeatingSystemDto implements ICreateHeatingSystemDto {
    structureId!: number;
    name!: string;

    constructor(data?: ICreateHeatingSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.structureId = _data["structureId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateHeatingSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHeatingSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["structureId"] = this.structureId;
        data["name"] = this.name;
        return data;
    }

    clone(): CreateHeatingSystemDto {
        const json = this.toJSON();
        let result = new CreateHeatingSystemDto();
        result.init(json);
        return result;
    }
}

export interface ICreateHeatingSystemDto {
    structureId: number;
    name: string;
}

export class CreateHistoricalCaseDto implements ICreateHistoricalCaseDto {
    admissionRecordId!: number;
    historicalCaseScopeId!: number | undefined;
    description!: string | undefined;

    constructor(data?: ICreateHistoricalCaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.admissionRecordId = _data["admissionRecordId"];
            this.historicalCaseScopeId = _data["historicalCaseScopeId"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateHistoricalCaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHistoricalCaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["admissionRecordId"] = this.admissionRecordId;
        data["historicalCaseScopeId"] = this.historicalCaseScopeId;
        data["description"] = this.description;
        return data;
    }

    clone(): CreateHistoricalCaseDto {
        const json = this.toJSON();
        let result = new CreateHistoricalCaseDto();
        result.init(json);
        return result;
    }
}

export interface ICreateHistoricalCaseDto {
    admissionRecordId: number;
    historicalCaseScopeId: number | undefined;
    description: string | undefined;
}

export class CreateHousingSituationDto implements ICreateHousingSituationDto {
    possession!: boolean | undefined;
    environmentalHygienicCondition!: boolean | undefined;
    locationTypeId!: number | undefined;
    relationship!: string | undefined;

    constructor(data?: ICreateHousingSituationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.possession = _data["possession"];
            this.environmentalHygienicCondition = _data["environmentalHygienicCondition"];
            this.locationTypeId = _data["locationTypeId"];
            this.relationship = _data["relationship"];
        }
    }

    static fromJS(data: any): CreateHousingSituationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHousingSituationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["possession"] = this.possession;
        data["environmentalHygienicCondition"] = this.environmentalHygienicCondition;
        data["locationTypeId"] = this.locationTypeId;
        data["relationship"] = this.relationship;
        return data;
    }

    clone(): CreateHousingSituationDto {
        const json = this.toJSON();
        let result = new CreateHousingSituationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateHousingSituationDto {
    possession: boolean | undefined;
    environmentalHygienicCondition: boolean | undefined;
    locationTypeId: number | undefined;
    relationship: string | undefined;
}

export class CreateHydraulicSystemDto implements ICreateHydraulicSystemDto {
    structureId!: number;
    name!: string;

    constructor(data?: ICreateHydraulicSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.structureId = _data["structureId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateHydraulicSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHydraulicSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["structureId"] = this.structureId;
        data["name"] = this.name;
        return data;
    }

    clone(): CreateHydraulicSystemDto {
        const json = this.toJSON();
        let result = new CreateHydraulicSystemDto();
        result.init(json);
        return result;
    }
}

export interface ICreateHydraulicSystemDto {
    structureId: number;
    name: string;
}

export class CreateIncomeAllowanceDto implements ICreateIncomeAllowanceDto {
    disabilityRate!: number;
    placeableWork!: boolean | undefined;
    protectedCategories!: boolean | undefined;
    inailDisability!: boolean | undefined;
    disabilityTypeId!: number | undefined;
    practicesInProgress!: boolean | undefined;
    allowanceAccompanying!: boolean | undefined;
    note!: string | undefined;

    constructor(data?: ICreateIncomeAllowanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disabilityRate = _data["disabilityRate"];
            this.placeableWork = _data["placeableWork"];
            this.protectedCategories = _data["protectedCategories"];
            this.inailDisability = _data["inailDisability"];
            this.disabilityTypeId = _data["disabilityTypeId"];
            this.practicesInProgress = _data["practicesInProgress"];
            this.allowanceAccompanying = _data["allowanceAccompanying"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateIncomeAllowanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIncomeAllowanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disabilityRate"] = this.disabilityRate;
        data["placeableWork"] = this.placeableWork;
        data["protectedCategories"] = this.protectedCategories;
        data["inailDisability"] = this.inailDisability;
        data["disabilityTypeId"] = this.disabilityTypeId;
        data["practicesInProgress"] = this.practicesInProgress;
        data["allowanceAccompanying"] = this.allowanceAccompanying;
        data["note"] = this.note;
        return data;
    }

    clone(): CreateIncomeAllowanceDto {
        const json = this.toJSON();
        let result = new CreateIncomeAllowanceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateIncomeAllowanceDto {
    disabilityRate: number;
    placeableWork: boolean | undefined;
    protectedCategories: boolean | undefined;
    inailDisability: boolean | undefined;
    disabilityTypeId: number | undefined;
    practicesInProgress: boolean | undefined;
    allowanceAccompanying: boolean | undefined;
    note: string | undefined;
}

export class CreateInformationAccreditationDto implements ICreateInformationAccreditationDto {
    socialHealthRecordId!: number;
    insertionDate!: moment.Moment | undefined;
    mmg!: string | undefined;
    dss!: string | undefined;
    municipalSocialServiceId!: number | undefined;
    neurologicalDisorders!: string | undefined;
    psychiatricDisorders!: string | undefined;
    arterialHypertension!: boolean | undefined;
    diabetesMellitus!: boolean | undefined;
    osteoporosis!: boolean | undefined;
    sphincterIncontinence!: string | undefined;
    allergies!: string | undefined;
    foodIntolerances!: string | undefined;
    sensoryMotorDisorders!: string | undefined;

    constructor(data?: ICreateInformationAccreditationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.insertionDate = _data["insertionDate"] ? moment(_data["insertionDate"].toString()) : undefined as any;
            this.mmg = _data["mmg"];
            this.dss = _data["dss"];
            this.municipalSocialServiceId = _data["municipalSocialServiceId"];
            this.neurologicalDisorders = _data["neurologicalDisorders"];
            this.psychiatricDisorders = _data["psychiatricDisorders"];
            this.arterialHypertension = _data["arterialHypertension"];
            this.diabetesMellitus = _data["diabetesMellitus"];
            this.osteoporosis = _data["osteoporosis"];
            this.sphincterIncontinence = _data["sphincterIncontinence"];
            this.allergies = _data["allergies"];
            this.foodIntolerances = _data["foodIntolerances"];
            this.sensoryMotorDisorders = _data["sensoryMotorDisorders"];
        }
    }

    static fromJS(data: any): CreateInformationAccreditationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInformationAccreditationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["insertionDate"] = this.insertionDate ? this.insertionDate.toISOString() : undefined as any;
        data["mmg"] = this.mmg;
        data["dss"] = this.dss;
        data["municipalSocialServiceId"] = this.municipalSocialServiceId;
        data["neurologicalDisorders"] = this.neurologicalDisorders;
        data["psychiatricDisorders"] = this.psychiatricDisorders;
        data["arterialHypertension"] = this.arterialHypertension;
        data["diabetesMellitus"] = this.diabetesMellitus;
        data["osteoporosis"] = this.osteoporosis;
        data["sphincterIncontinence"] = this.sphincterIncontinence;
        data["allergies"] = this.allergies;
        data["foodIntolerances"] = this.foodIntolerances;
        data["sensoryMotorDisorders"] = this.sensoryMotorDisorders;
        return data;
    }

    clone(): CreateInformationAccreditationDto {
        const json = this.toJSON();
        let result = new CreateInformationAccreditationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateInformationAccreditationDto {
    socialHealthRecordId: number;
    insertionDate: moment.Moment | undefined;
    mmg: string | undefined;
    dss: string | undefined;
    municipalSocialServiceId: number | undefined;
    neurologicalDisorders: string | undefined;
    psychiatricDisorders: string | undefined;
    arterialHypertension: boolean | undefined;
    diabetesMellitus: boolean | undefined;
    osteoporosis: boolean | undefined;
    sphincterIncontinence: string | undefined;
    allergies: string | undefined;
    foodIntolerances: string | undefined;
    sensoryMotorDisorders: string | undefined;
}

export class CreateInputCardRecordDto implements ICreateInputCardRecordDto {
    socialHealhRecordId!: number;

    constructor(data?: ICreateInputCardRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialHealhRecordId = _data["socialHealhRecordId"];
        }
    }

    static fromJS(data: any): CreateInputCardRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInputCardRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialHealhRecordId"] = this.socialHealhRecordId;
        return data;
    }

    clone(): CreateInputCardRecordDto {
        const json = this.toJSON();
        let result = new CreateInputCardRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreateInputCardRecordDto {
    socialHealhRecordId: number;
}

export class CreateIntegratedRehabilitationPlanRecordDto implements ICreateIntegratedRehabilitationPlanRecordDto {
    observationGridId!: number;
    startingSituation!: string | undefined;
    isFinalReport!: boolean;
    description!: string | undefined;

    constructor(data?: ICreateIntegratedRehabilitationPlanRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.observationGridId = _data["observationGridId"];
            this.startingSituation = _data["startingSituation"];
            this.isFinalReport = _data["isFinalReport"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateIntegratedRehabilitationPlanRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateIntegratedRehabilitationPlanRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["observationGridId"] = this.observationGridId;
        data["startingSituation"] = this.startingSituation;
        data["isFinalReport"] = this.isFinalReport;
        data["description"] = this.description;
        return data;
    }

    clone(): CreateIntegratedRehabilitationPlanRecordDto {
        const json = this.toJSON();
        let result = new CreateIntegratedRehabilitationPlanRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreateIntegratedRehabilitationPlanRecordDto {
    observationGridId: number;
    startingSituation: string | undefined;
    isFinalReport: boolean;
    description: string | undefined;
}

export class CreateInterviewParticipantsRecordDto implements ICreateInterviewParticipantsRecordDto {
    socialHealthRecordId!: number;
    serviceUserIds!: number[] | undefined;
    relatives!: CreateRelativeDto[] | undefined;

    constructor(data?: ICreateInterviewParticipantsRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            if (Array.isArray(_data["serviceUserIds"])) {
                this.serviceUserIds = [] as any;
                for (let item of _data["serviceUserIds"])
                    this.serviceUserIds!.push(item);
            }
            if (Array.isArray(_data["relatives"])) {
                this.relatives = [] as any;
                for (let item of _data["relatives"])
                    this.relatives!.push(CreateRelativeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateInterviewParticipantsRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInterviewParticipantsRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        if (Array.isArray(this.serviceUserIds)) {
            data["serviceUserIds"] = [];
            for (let item of this.serviceUserIds)
                data["serviceUserIds"].push(item);
        }
        if (Array.isArray(this.relatives)) {
            data["relatives"] = [];
            for (let item of this.relatives)
                data["relatives"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreateInterviewParticipantsRecordDto {
        const json = this.toJSON();
        let result = new CreateInterviewParticipantsRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreateInterviewParticipantsRecordDto {
    socialHealthRecordId: number;
    serviceUserIds: number[] | undefined;
    relatives: CreateRelativeDto[] | undefined;
}

export class CreateLifelineSystemDto implements ICreateLifelineSystemDto {
    structureId!: number;
    name!: string;

    constructor(data?: ICreateLifelineSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.structureId = _data["structureId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateLifelineSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLifelineSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["structureId"] = this.structureId;
        data["name"] = this.name;
        return data;
    }

    clone(): CreateLifelineSystemDto {
        const json = this.toJSON();
        let result = new CreateLifelineSystemDto();
        result.init(json);
        return result;
    }
}

export interface ICreateLifelineSystemDto {
    structureId: number;
    name: string;
}

export class CreateMaintenanceEventDto implements ICreateMaintenanceEventDto {
    vehicleId!: number;
    eventTypeId!: number | undefined;
    date!: moment.Moment;
    provider!: string | undefined;
    amount!: number | undefined;
    note!: string | undefined;

    constructor(data?: ICreateMaintenanceEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleId = _data["vehicleId"];
            this.eventTypeId = _data["eventTypeId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.provider = _data["provider"];
            this.amount = _data["amount"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateMaintenanceEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMaintenanceEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleId"] = this.vehicleId;
        data["eventTypeId"] = this.eventTypeId;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["provider"] = this.provider;
        data["amount"] = this.amount;
        data["note"] = this.note;
        return data;
    }

    clone(): CreateMaintenanceEventDto {
        const json = this.toJSON();
        let result = new CreateMaintenanceEventDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMaintenanceEventDto {
    vehicleId: number;
    eventTypeId: number | undefined;
    date: moment.Moment;
    provider: string | undefined;
    amount: number | undefined;
    note: string | undefined;
}

export class CreateMonitoringRestraintRecordDto implements ICreateMonitoringRestraintRecordDto {
    socialHealthRecordId!: number;
    date!: moment.Moment;
    startRestraint!: moment.Moment | undefined;
    mmse!: string | undefined;
    disorderNonCognitiveIds!: number[] | undefined;
    conleyScale!: string | undefined;
    prescribedTypeIds!: number[] | undefined;
    bedriddenGuest!: string | undefined;
    sideRails!: string | undefined;
    prescribedTypeOther!: string | undefined;
    wheelchairUserIds!: number[] | undefined;
    wheelchairUserOther!: string | undefined;
    bodySegmentIds!: number[] | undefined;
    bodySegmentOther!: string | undefined;
    psychosocialSphereSyndromeIds!: number[] | undefined;
    nursingSphereSyndromeIds!: number[] | undefined;
    physiotherapySphereSyndromeIds!: number[] | undefined;
    notes!: string | undefined;

    constructor(data?: ICreateMonitoringRestraintRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.startRestraint = _data["startRestraint"] ? moment(_data["startRestraint"].toString()) : undefined as any;
            this.mmse = _data["mmse"];
            if (Array.isArray(_data["disorderNonCognitiveIds"])) {
                this.disorderNonCognitiveIds = [] as any;
                for (let item of _data["disorderNonCognitiveIds"])
                    this.disorderNonCognitiveIds!.push(item);
            }
            this.conleyScale = _data["conleyScale"];
            if (Array.isArray(_data["prescribedTypeIds"])) {
                this.prescribedTypeIds = [] as any;
                for (let item of _data["prescribedTypeIds"])
                    this.prescribedTypeIds!.push(item);
            }
            this.bedriddenGuest = _data["bedriddenGuest"];
            this.sideRails = _data["sideRails"];
            this.prescribedTypeOther = _data["prescribedTypeOther"];
            if (Array.isArray(_data["wheelchairUserIds"])) {
                this.wheelchairUserIds = [] as any;
                for (let item of _data["wheelchairUserIds"])
                    this.wheelchairUserIds!.push(item);
            }
            this.wheelchairUserOther = _data["wheelchairUserOther"];
            if (Array.isArray(_data["bodySegmentIds"])) {
                this.bodySegmentIds = [] as any;
                for (let item of _data["bodySegmentIds"])
                    this.bodySegmentIds!.push(item);
            }
            this.bodySegmentOther = _data["bodySegmentOther"];
            if (Array.isArray(_data["psychosocialSphereSyndromeIds"])) {
                this.psychosocialSphereSyndromeIds = [] as any;
                for (let item of _data["psychosocialSphereSyndromeIds"])
                    this.psychosocialSphereSyndromeIds!.push(item);
            }
            if (Array.isArray(_data["nursingSphereSyndromeIds"])) {
                this.nursingSphereSyndromeIds = [] as any;
                for (let item of _data["nursingSphereSyndromeIds"])
                    this.nursingSphereSyndromeIds!.push(item);
            }
            if (Array.isArray(_data["physiotherapySphereSyndromeIds"])) {
                this.physiotherapySphereSyndromeIds = [] as any;
                for (let item of _data["physiotherapySphereSyndromeIds"])
                    this.physiotherapySphereSyndromeIds!.push(item);
            }
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateMonitoringRestraintRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMonitoringRestraintRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["startRestraint"] = this.startRestraint ? this.startRestraint.toISOString() : undefined as any;
        data["mmse"] = this.mmse;
        if (Array.isArray(this.disorderNonCognitiveIds)) {
            data["disorderNonCognitiveIds"] = [];
            for (let item of this.disorderNonCognitiveIds)
                data["disorderNonCognitiveIds"].push(item);
        }
        data["conleyScale"] = this.conleyScale;
        if (Array.isArray(this.prescribedTypeIds)) {
            data["prescribedTypeIds"] = [];
            for (let item of this.prescribedTypeIds)
                data["prescribedTypeIds"].push(item);
        }
        data["bedriddenGuest"] = this.bedriddenGuest;
        data["sideRails"] = this.sideRails;
        data["prescribedTypeOther"] = this.prescribedTypeOther;
        if (Array.isArray(this.wheelchairUserIds)) {
            data["wheelchairUserIds"] = [];
            for (let item of this.wheelchairUserIds)
                data["wheelchairUserIds"].push(item);
        }
        data["wheelchairUserOther"] = this.wheelchairUserOther;
        if (Array.isArray(this.bodySegmentIds)) {
            data["bodySegmentIds"] = [];
            for (let item of this.bodySegmentIds)
                data["bodySegmentIds"].push(item);
        }
        data["bodySegmentOther"] = this.bodySegmentOther;
        if (Array.isArray(this.psychosocialSphereSyndromeIds)) {
            data["psychosocialSphereSyndromeIds"] = [];
            for (let item of this.psychosocialSphereSyndromeIds)
                data["psychosocialSphereSyndromeIds"].push(item);
        }
        if (Array.isArray(this.nursingSphereSyndromeIds)) {
            data["nursingSphereSyndromeIds"] = [];
            for (let item of this.nursingSphereSyndromeIds)
                data["nursingSphereSyndromeIds"].push(item);
        }
        if (Array.isArray(this.physiotherapySphereSyndromeIds)) {
            data["physiotherapySphereSyndromeIds"] = [];
            for (let item of this.physiotherapySphereSyndromeIds)
                data["physiotherapySphereSyndromeIds"].push(item);
        }
        data["notes"] = this.notes;
        return data;
    }

    clone(): CreateMonitoringRestraintRecordDto {
        const json = this.toJSON();
        let result = new CreateMonitoringRestraintRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMonitoringRestraintRecordDto {
    socialHealthRecordId: number;
    date: moment.Moment;
    startRestraint: moment.Moment | undefined;
    mmse: string | undefined;
    disorderNonCognitiveIds: number[] | undefined;
    conleyScale: string | undefined;
    prescribedTypeIds: number[] | undefined;
    bedriddenGuest: string | undefined;
    sideRails: string | undefined;
    prescribedTypeOther: string | undefined;
    wheelchairUserIds: number[] | undefined;
    wheelchairUserOther: string | undefined;
    bodySegmentIds: number[] | undefined;
    bodySegmentOther: string | undefined;
    psychosocialSphereSyndromeIds: number[] | undefined;
    nursingSphereSyndromeIds: number[] | undefined;
    physiotherapySphereSyndromeIds: number[] | undefined;
    notes: string | undefined;
}

export class CreateMonthlyRehabilitationProgramNoteDto implements ICreateMonthlyRehabilitationProgramNoteDto {
    monthlyRehabilitationProgramRecordId!: number;
    motivation!: string | undefined;

    constructor(data?: ICreateMonthlyRehabilitationProgramNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthlyRehabilitationProgramRecordId = _data["monthlyRehabilitationProgramRecordId"];
            this.motivation = _data["motivation"];
        }
    }

    static fromJS(data: any): CreateMonthlyRehabilitationProgramNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMonthlyRehabilitationProgramNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthlyRehabilitationProgramRecordId"] = this.monthlyRehabilitationProgramRecordId;
        data["motivation"] = this.motivation;
        return data;
    }

    clone(): CreateMonthlyRehabilitationProgramNoteDto {
        const json = this.toJSON();
        let result = new CreateMonthlyRehabilitationProgramNoteDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMonthlyRehabilitationProgramNoteDto {
    monthlyRehabilitationProgramRecordId: number;
    motivation: string | undefined;
}

export class CreateMonthlyRehabilitationProgramRecordDto implements ICreateMonthlyRehabilitationProgramRecordDto {
    socialHealthRecordId!: number;
    month!: number;
    year!: number;

    constructor(data?: ICreateMonthlyRehabilitationProgramRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.month = _data["month"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): CreateMonthlyRehabilitationProgramRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMonthlyRehabilitationProgramRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["month"] = this.month;
        data["year"] = this.year;
        return data;
    }

    clone(): CreateMonthlyRehabilitationProgramRecordDto {
        const json = this.toJSON();
        let result = new CreateMonthlyRehabilitationProgramRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMonthlyRehabilitationProgramRecordDto {
    socialHealthRecordId: number;
    month: number;
    year: number;
}

export class CreateMonthlyRehabilitationProgramTreatmentDto implements ICreateMonthlyRehabilitationProgramTreatmentDto {
    monthlyRehabilitationProgramRecordId!: number;
    dayTreatments!: DayTreatmentsDto[] | undefined;

    constructor(data?: ICreateMonthlyRehabilitationProgramTreatmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.monthlyRehabilitationProgramRecordId = _data["monthlyRehabilitationProgramRecordId"];
            if (Array.isArray(_data["dayTreatments"])) {
                this.dayTreatments = [] as any;
                for (let item of _data["dayTreatments"])
                    this.dayTreatments!.push(DayTreatmentsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateMonthlyRehabilitationProgramTreatmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateMonthlyRehabilitationProgramTreatmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["monthlyRehabilitationProgramRecordId"] = this.monthlyRehabilitationProgramRecordId;
        if (Array.isArray(this.dayTreatments)) {
            data["dayTreatments"] = [];
            for (let item of this.dayTreatments)
                data["dayTreatments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreateMonthlyRehabilitationProgramTreatmentDto {
        const json = this.toJSON();
        let result = new CreateMonthlyRehabilitationProgramTreatmentDto();
        result.init(json);
        return result;
    }
}

export interface ICreateMonthlyRehabilitationProgramTreatmentDto {
    monthlyRehabilitationProgramRecordId: number;
    dayTreatments: DayTreatmentsDto[] | undefined;
}

export class CreateObjectiveDto implements ICreateObjectiveDto {
    integratedRehabilitationPlanRecordId!: number;
    scopeObservationGridId!: number;
    description!: string | undefined;
    objectiveTimeId!: number | undefined;
    strategy!: string | undefined;
    result!: CreateObjectiveResultDto;

    constructor(data?: ICreateObjectiveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.integratedRehabilitationPlanRecordId = _data["integratedRehabilitationPlanRecordId"];
            this.scopeObservationGridId = _data["scopeObservationGridId"];
            this.description = _data["description"];
            this.objectiveTimeId = _data["objectiveTimeId"];
            this.strategy = _data["strategy"];
            this.result = _data["result"] ? CreateObjectiveResultDto.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateObjectiveDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateObjectiveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["integratedRehabilitationPlanRecordId"] = this.integratedRehabilitationPlanRecordId;
        data["scopeObservationGridId"] = this.scopeObservationGridId;
        data["description"] = this.description;
        data["objectiveTimeId"] = this.objectiveTimeId;
        data["strategy"] = this.strategy;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): CreateObjectiveDto {
        const json = this.toJSON();
        let result = new CreateObjectiveDto();
        result.init(json);
        return result;
    }
}

export interface ICreateObjectiveDto {
    integratedRehabilitationPlanRecordId: number;
    scopeObservationGridId: number;
    description: string | undefined;
    objectiveTimeId: number | undefined;
    strategy: string | undefined;
    result: CreateObjectiveResultDto;
}

export class CreateObjectiveResultDto implements ICreateObjectiveResultDto {
    outcomeId!: number | undefined;
    dateTime!: moment.Moment | undefined;
    description!: string | undefined;

    constructor(data?: ICreateObjectiveResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.outcomeId = _data["outcomeId"];
            this.dateTime = _data["dateTime"] ? moment(_data["dateTime"].toString()) : undefined as any;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateObjectiveResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateObjectiveResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["outcomeId"] = this.outcomeId;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : undefined as any;
        data["description"] = this.description;
        return data;
    }

    clone(): CreateObjectiveResultDto {
        const json = this.toJSON();
        let result = new CreateObjectiveResultDto();
        result.init(json);
        return result;
    }
}

export interface ICreateObjectiveResultDto {
    outcomeId: number | undefined;
    dateTime: moment.Moment | undefined;
    description: string | undefined;
}

export class CreateObjectivesRehabilitationRecordDto implements ICreateObjectivesRehabilitationRecordDto {
    socialHealthRecordId!: number;
    date!: moment.Moment;
    shortTermObjectiveIds!: number[] | undefined;
    shortTermOther!: string | undefined;
    shortTermResultId!: number | undefined;
    longTermObjectiveIds!: number[] | undefined;
    longTermOther!: string | undefined;
    treatmentProgramIds!: number[] | undefined;
    treatmentProgramOther!: string | undefined;
    weeklyFrequencyId!: number | undefined;
    weeklyFrequencyOther!: string | undefined;
    tinetti!: CreateOrUpdateObjectivesRehabilitationTinettiDto;
    barthel!: CreateOrUpdateObjectivesRehabilitationBarthelDto;

    constructor(data?: ICreateObjectivesRehabilitationRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            if (Array.isArray(_data["shortTermObjectiveIds"])) {
                this.shortTermObjectiveIds = [] as any;
                for (let item of _data["shortTermObjectiveIds"])
                    this.shortTermObjectiveIds!.push(item);
            }
            this.shortTermOther = _data["shortTermOther"];
            this.shortTermResultId = _data["shortTermResultId"];
            if (Array.isArray(_data["longTermObjectiveIds"])) {
                this.longTermObjectiveIds = [] as any;
                for (let item of _data["longTermObjectiveIds"])
                    this.longTermObjectiveIds!.push(item);
            }
            this.longTermOther = _data["longTermOther"];
            if (Array.isArray(_data["treatmentProgramIds"])) {
                this.treatmentProgramIds = [] as any;
                for (let item of _data["treatmentProgramIds"])
                    this.treatmentProgramIds!.push(item);
            }
            this.treatmentProgramOther = _data["treatmentProgramOther"];
            this.weeklyFrequencyId = _data["weeklyFrequencyId"];
            this.weeklyFrequencyOther = _data["weeklyFrequencyOther"];
            this.tinetti = _data["tinetti"] ? CreateOrUpdateObjectivesRehabilitationTinettiDto.fromJS(_data["tinetti"]) : undefined as any;
            this.barthel = _data["barthel"] ? CreateOrUpdateObjectivesRehabilitationBarthelDto.fromJS(_data["barthel"]) : undefined as any;
        }
    }

    static fromJS(data: any): CreateObjectivesRehabilitationRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateObjectivesRehabilitationRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        if (Array.isArray(this.shortTermObjectiveIds)) {
            data["shortTermObjectiveIds"] = [];
            for (let item of this.shortTermObjectiveIds)
                data["shortTermObjectiveIds"].push(item);
        }
        data["shortTermOther"] = this.shortTermOther;
        data["shortTermResultId"] = this.shortTermResultId;
        if (Array.isArray(this.longTermObjectiveIds)) {
            data["longTermObjectiveIds"] = [];
            for (let item of this.longTermObjectiveIds)
                data["longTermObjectiveIds"].push(item);
        }
        data["longTermOther"] = this.longTermOther;
        if (Array.isArray(this.treatmentProgramIds)) {
            data["treatmentProgramIds"] = [];
            for (let item of this.treatmentProgramIds)
                data["treatmentProgramIds"].push(item);
        }
        data["treatmentProgramOther"] = this.treatmentProgramOther;
        data["weeklyFrequencyId"] = this.weeklyFrequencyId;
        data["weeklyFrequencyOther"] = this.weeklyFrequencyOther;
        data["tinetti"] = this.tinetti ? this.tinetti.toJSON() : undefined as any;
        data["barthel"] = this.barthel ? this.barthel.toJSON() : undefined as any;
        return data;
    }

    clone(): CreateObjectivesRehabilitationRecordDto {
        const json = this.toJSON();
        let result = new CreateObjectivesRehabilitationRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreateObjectivesRehabilitationRecordDto {
    socialHealthRecordId: number;
    date: moment.Moment;
    shortTermObjectiveIds: number[] | undefined;
    shortTermOther: string | undefined;
    shortTermResultId: number | undefined;
    longTermObjectiveIds: number[] | undefined;
    longTermOther: string | undefined;
    treatmentProgramIds: number[] | undefined;
    treatmentProgramOther: string | undefined;
    weeklyFrequencyId: number | undefined;
    weeklyFrequencyOther: string | undefined;
    tinetti: CreateOrUpdateObjectivesRehabilitationTinettiDto;
    barthel: CreateOrUpdateObjectivesRehabilitationBarthelDto;
}

export class CreateObservationGrid implements ICreateObservationGrid {
    socialHealthRecordId!: number;
    scopeObservationGridIds!: number[] | undefined;
    date!: moment.Moment | undefined;

    constructor(data?: ICreateObservationGrid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            if (Array.isArray(_data["scopeObservationGridIds"])) {
                this.scopeObservationGridIds = [] as any;
                for (let item of _data["scopeObservationGridIds"])
                    this.scopeObservationGridIds!.push(item);
            }
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateObservationGrid {
        data = typeof data === 'object' ? data : {};
        let result = new CreateObservationGrid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        if (Array.isArray(this.scopeObservationGridIds)) {
            data["scopeObservationGridIds"] = [];
            for (let item of this.scopeObservationGridIds)
                data["scopeObservationGridIds"].push(item);
        }
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        return data;
    }

    clone(): CreateObservationGrid {
        const json = this.toJSON();
        let result = new CreateObservationGrid();
        result.init(json);
        return result;
    }
}

export interface ICreateObservationGrid {
    socialHealthRecordId: number;
    scopeObservationGridIds: number[] | undefined;
    date: moment.Moment | undefined;
}

export class CreateObservationGridSectionOperatorPermissionDto implements ICreateObservationGridSectionOperatorPermissionDto {
    observationGridId!: number;
    sectionOperators!: SectionOperatorPermissionDto[] | undefined;

    constructor(data?: ICreateObservationGridSectionOperatorPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.observationGridId = _data["observationGridId"];
            if (Array.isArray(_data["sectionOperators"])) {
                this.sectionOperators = [] as any;
                for (let item of _data["sectionOperators"])
                    this.sectionOperators!.push(SectionOperatorPermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateObservationGridSectionOperatorPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateObservationGridSectionOperatorPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["observationGridId"] = this.observationGridId;
        if (Array.isArray(this.sectionOperators)) {
            data["sectionOperators"] = [];
            for (let item of this.sectionOperators)
                data["sectionOperators"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreateObservationGridSectionOperatorPermissionDto {
        const json = this.toJSON();
        let result = new CreateObservationGridSectionOperatorPermissionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateObservationGridSectionOperatorPermissionDto {
    observationGridId: number;
    sectionOperators: SectionOperatorPermissionDto[] | undefined;
}

export class CreateOccupationDto implements ICreateOccupationDto {
    inputCardRecordId!: number;
    activityType!: string | undefined;
    location!: string | undefined;
    activityPeriod!: string | undefined;
    time!: string | undefined;
    note!: string | undefined;

    constructor(data?: ICreateOccupationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputCardRecordId = _data["inputCardRecordId"];
            this.activityType = _data["activityType"];
            this.location = _data["location"];
            this.activityPeriod = _data["activityPeriod"];
            this.time = _data["time"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateOccupationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOccupationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputCardRecordId"] = this.inputCardRecordId;
        data["activityType"] = this.activityType;
        data["location"] = this.location;
        data["activityPeriod"] = this.activityPeriod;
        data["time"] = this.time;
        data["note"] = this.note;
        return data;
    }

    clone(): CreateOccupationDto {
        const json = this.toJSON();
        let result = new CreateOccupationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOccupationDto {
    inputCardRecordId: number;
    activityType: string | undefined;
    location: string | undefined;
    activityPeriod: string | undefined;
    time: string | undefined;
    note: string | undefined;
}

export class CreateOrganizationDto implements ICreateOrganizationDto {
    name!: string | undefined;

    constructor(data?: ICreateOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateOrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }

    clone(): CreateOrganizationDto {
        const json = this.toJSON();
        let result = new CreateOrganizationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrganizationDto {
    name: string | undefined;
}

export class CreateOrUpdateObjectivesRehabilitationBarthelDto implements ICreateOrUpdateObjectivesRehabilitationBarthelDto {
    dateEntry!: moment.Moment | undefined;
    totalEntry!: number | undefined;
    dateCurrent!: moment.Moment | undefined;
    totalCurrent!: number | undefined;
    dateNext!: moment.Moment | undefined;
    totalNext!: number | undefined;

    constructor(data?: ICreateOrUpdateObjectivesRehabilitationBarthelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateEntry = _data["dateEntry"] ? moment(_data["dateEntry"].toString()) : undefined as any;
            this.totalEntry = _data["totalEntry"];
            this.dateCurrent = _data["dateCurrent"] ? moment(_data["dateCurrent"].toString()) : undefined as any;
            this.totalCurrent = _data["totalCurrent"];
            this.dateNext = _data["dateNext"] ? moment(_data["dateNext"].toString()) : undefined as any;
            this.totalNext = _data["totalNext"];
        }
    }

    static fromJS(data: any): CreateOrUpdateObjectivesRehabilitationBarthelDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateObjectivesRehabilitationBarthelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateEntry"] = this.dateEntry ? this.dateEntry.toISOString() : undefined as any;
        data["totalEntry"] = this.totalEntry;
        data["dateCurrent"] = this.dateCurrent ? this.dateCurrent.toISOString() : undefined as any;
        data["totalCurrent"] = this.totalCurrent;
        data["dateNext"] = this.dateNext ? this.dateNext.toISOString() : undefined as any;
        data["totalNext"] = this.totalNext;
        return data;
    }

    clone(): CreateOrUpdateObjectivesRehabilitationBarthelDto {
        const json = this.toJSON();
        let result = new CreateOrUpdateObjectivesRehabilitationBarthelDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateObjectivesRehabilitationBarthelDto {
    dateEntry: moment.Moment | undefined;
    totalEntry: number | undefined;
    dateCurrent: moment.Moment | undefined;
    totalCurrent: number | undefined;
    dateNext: moment.Moment | undefined;
    totalNext: number | undefined;
}

export class CreateOrUpdateObjectivesRehabilitationTinettiDto implements ICreateOrUpdateObjectivesRehabilitationTinettiDto {
    dateEntry!: moment.Moment | undefined;
    balanceEntry!: number | undefined;
    gaitEntry!: number | undefined;
    totalEntry!: number | undefined;
    dateCurrent!: moment.Moment | undefined;
    balanceCurrent!: number | undefined;
    gaitCurrent!: number | undefined;
    totalCurrent!: number | undefined;
    dateNext!: moment.Moment | undefined;
    balanceNext!: number | undefined;
    gaitNext!: number | undefined;
    totalNext!: number | undefined;

    constructor(data?: ICreateOrUpdateObjectivesRehabilitationTinettiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateEntry = _data["dateEntry"] ? moment(_data["dateEntry"].toString()) : undefined as any;
            this.balanceEntry = _data["balanceEntry"];
            this.gaitEntry = _data["gaitEntry"];
            this.totalEntry = _data["totalEntry"];
            this.dateCurrent = _data["dateCurrent"] ? moment(_data["dateCurrent"].toString()) : undefined as any;
            this.balanceCurrent = _data["balanceCurrent"];
            this.gaitCurrent = _data["gaitCurrent"];
            this.totalCurrent = _data["totalCurrent"];
            this.dateNext = _data["dateNext"] ? moment(_data["dateNext"].toString()) : undefined as any;
            this.balanceNext = _data["balanceNext"];
            this.gaitNext = _data["gaitNext"];
            this.totalNext = _data["totalNext"];
        }
    }

    static fromJS(data: any): CreateOrUpdateObjectivesRehabilitationTinettiDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateObjectivesRehabilitationTinettiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateEntry"] = this.dateEntry ? this.dateEntry.toISOString() : undefined as any;
        data["balanceEntry"] = this.balanceEntry;
        data["gaitEntry"] = this.gaitEntry;
        data["totalEntry"] = this.totalEntry;
        data["dateCurrent"] = this.dateCurrent ? this.dateCurrent.toISOString() : undefined as any;
        data["balanceCurrent"] = this.balanceCurrent;
        data["gaitCurrent"] = this.gaitCurrent;
        data["totalCurrent"] = this.totalCurrent;
        data["dateNext"] = this.dateNext ? this.dateNext.toISOString() : undefined as any;
        data["balanceNext"] = this.balanceNext;
        data["gaitNext"] = this.gaitNext;
        data["totalNext"] = this.totalNext;
        return data;
    }

    clone(): CreateOrUpdateObjectivesRehabilitationTinettiDto {
        const json = this.toJSON();
        let result = new CreateOrUpdateObjectivesRehabilitationTinettiDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOrUpdateObjectivesRehabilitationTinettiDto {
    dateEntry: moment.Moment | undefined;
    balanceEntry: number | undefined;
    gaitEntry: number | undefined;
    totalEntry: number | undefined;
    dateCurrent: moment.Moment | undefined;
    balanceCurrent: number | undefined;
    gaitCurrent: number | undefined;
    totalCurrent: number | undefined;
    dateNext: moment.Moment | undefined;
    balanceNext: number | undefined;
    gaitNext: number | undefined;
    totalNext: number | undefined;
}

export class CreateOtherReferenceDto implements ICreateOtherReferenceDto {
    inputCardRecordId!: number;
    name!: string | undefined;
    surname!: string | undefined;
    phoneNumber!: string | undefined;
    otherPhoneNumber!: string | undefined;
    emailAddress!: string | undefined;
    role!: string | undefined;
    address!: CreateAddressDto;
    note!: string | undefined;
    isActive!: boolean;

    constructor(data?: ICreateOtherReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputCardRecordId = _data["inputCardRecordId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phoneNumber = _data["phoneNumber"];
            this.otherPhoneNumber = _data["otherPhoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.role = _data["role"];
            this.address = _data["address"] ? CreateAddressDto.fromJS(_data["address"]) : undefined as any;
            this.note = _data["note"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateOtherReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOtherReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputCardRecordId"] = this.inputCardRecordId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phoneNumber"] = this.phoneNumber;
        data["otherPhoneNumber"] = this.otherPhoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["role"] = this.role;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["note"] = this.note;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateOtherReferenceDto {
        const json = this.toJSON();
        let result = new CreateOtherReferenceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateOtherReferenceDto {
    inputCardRecordId: number;
    name: string | undefined;
    surname: string | undefined;
    phoneNumber: string | undefined;
    otherPhoneNumber: string | undefined;
    emailAddress: string | undefined;
    role: string | undefined;
    address: CreateAddressDto;
    note: string | undefined;
    isActive: boolean;
}

export class CreatePatient118RecordDto implements ICreatePatient118RecordDto {
    date!: moment.Moment;
    residence!: string | undefined;
    healthCardNumber!: string | undefined;
    caregiverName!: string | undefined;
    caregiverSurname!: string | undefined;
    caregiverNumber!: string | undefined;
    diagnosis!: string | undefined;
    therapy!: string | undefined;
    note!: string | undefined;
    socialHealthRecordId!: number;

    constructor(data?: ICreatePatient118RecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.residence = _data["residence"];
            this.healthCardNumber = _data["healthCardNumber"];
            this.caregiverName = _data["caregiverName"];
            this.caregiverSurname = _data["caregiverSurname"];
            this.caregiverNumber = _data["caregiverNumber"];
            this.diagnosis = _data["diagnosis"];
            this.therapy = _data["therapy"];
            this.note = _data["note"];
            this.socialHealthRecordId = _data["socialHealthRecordId"];
        }
    }

    static fromJS(data: any): CreatePatient118RecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePatient118RecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["residence"] = this.residence;
        data["healthCardNumber"] = this.healthCardNumber;
        data["caregiverName"] = this.caregiverName;
        data["caregiverSurname"] = this.caregiverSurname;
        data["caregiverNumber"] = this.caregiverNumber;
        data["diagnosis"] = this.diagnosis;
        data["therapy"] = this.therapy;
        data["note"] = this.note;
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        return data;
    }

    clone(): CreatePatient118RecordDto {
        const json = this.toJSON();
        let result = new CreatePatient118RecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePatient118RecordDto {
    date: moment.Moment;
    residence: string | undefined;
    healthCardNumber: string | undefined;
    caregiverName: string | undefined;
    caregiverSurname: string | undefined;
    caregiverNumber: string | undefined;
    diagnosis: string | undefined;
    therapy: string | undefined;
    note: string | undefined;
    socialHealthRecordId: number;
}

export class CreatePersonalAutonomyDto implements ICreatePersonalAutonomyDto {
    walkingModeId!: number | undefined;
    walkingDescription!: string | undefined;
    eatingModeId!: number | undefined;
    eatingDescription!: string | undefined;
    personalHygieneModeId!: number | undefined;
    personalHygieneDescription!: string | undefined;
    note!: string | undefined;

    constructor(data?: ICreatePersonalAutonomyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.walkingModeId = _data["walkingModeId"];
            this.walkingDescription = _data["walkingDescription"];
            this.eatingModeId = _data["eatingModeId"];
            this.eatingDescription = _data["eatingDescription"];
            this.personalHygieneModeId = _data["personalHygieneModeId"];
            this.personalHygieneDescription = _data["personalHygieneDescription"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreatePersonalAutonomyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonalAutonomyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["walkingModeId"] = this.walkingModeId;
        data["walkingDescription"] = this.walkingDescription;
        data["eatingModeId"] = this.eatingModeId;
        data["eatingDescription"] = this.eatingDescription;
        data["personalHygieneModeId"] = this.personalHygieneModeId;
        data["personalHygieneDescription"] = this.personalHygieneDescription;
        data["note"] = this.note;
        return data;
    }

    clone(): CreatePersonalAutonomyDto {
        const json = this.toJSON();
        let result = new CreatePersonalAutonomyDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePersonalAutonomyDto {
    walkingModeId: number | undefined;
    walkingDescription: string | undefined;
    eatingModeId: number | undefined;
    eatingDescription: string | undefined;
    personalHygieneModeId: number | undefined;
    personalHygieneDescription: string | undefined;
    note: string | undefined;
}

export class CreatePersonalDataDto implements ICreatePersonalDataDto {
    inputCardRecordId!: number;
    residenceAddresses!: CreateAddressDto[] | undefined;
    domicileAddresses!: CreateAddressDto[] | undefined;
    constituency!: string | undefined;
    district!: string | undefined;
    phoneNumbers!: string[] | undefined;

    constructor(data?: ICreatePersonalDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputCardRecordId = _data["inputCardRecordId"];
            if (Array.isArray(_data["residenceAddresses"])) {
                this.residenceAddresses = [] as any;
                for (let item of _data["residenceAddresses"])
                    this.residenceAddresses!.push(CreateAddressDto.fromJS(item));
            }
            if (Array.isArray(_data["domicileAddresses"])) {
                this.domicileAddresses = [] as any;
                for (let item of _data["domicileAddresses"])
                    this.domicileAddresses!.push(CreateAddressDto.fromJS(item));
            }
            this.constituency = _data["constituency"];
            this.district = _data["district"];
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(item);
            }
        }
    }

    static fromJS(data: any): CreatePersonalDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonalDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputCardRecordId"] = this.inputCardRecordId;
        if (Array.isArray(this.residenceAddresses)) {
            data["residenceAddresses"] = [];
            for (let item of this.residenceAddresses)
                data["residenceAddresses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.domicileAddresses)) {
            data["domicileAddresses"] = [];
            for (let item of this.domicileAddresses)
                data["domicileAddresses"].push(item ? item.toJSON() : undefined as any);
        }
        data["constituency"] = this.constituency;
        data["district"] = this.district;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item);
        }
        return data;
    }

    clone(): CreatePersonalDataDto {
        const json = this.toJSON();
        let result = new CreatePersonalDataDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePersonalDataDto {
    inputCardRecordId: number;
    residenceAddresses: CreateAddressDto[] | undefined;
    domicileAddresses: CreateAddressDto[] | undefined;
    constituency: string | undefined;
    district: string | undefined;
    phoneNumbers: string[] | undefined;
}

export class CreatePersonalDataFamilyMemberDto implements ICreatePersonalDataFamilyMemberDto {
    inputCardRecordId!: number;
    kinshipDegreeId!: number | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    birthDate!: moment.Moment | undefined;
    cohabitation!: boolean | undefined;
    note!: string | undefined;
    profession!: string | undefined;

    constructor(data?: ICreatePersonalDataFamilyMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputCardRecordId = _data["inputCardRecordId"];
            this.kinshipDegreeId = _data["kinshipDegreeId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : undefined as any;
            this.cohabitation = _data["cohabitation"];
            this.note = _data["note"];
            this.profession = _data["profession"];
        }
    }

    static fromJS(data: any): CreatePersonalDataFamilyMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePersonalDataFamilyMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputCardRecordId"] = this.inputCardRecordId;
        data["kinshipDegreeId"] = this.kinshipDegreeId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined as any;
        data["cohabitation"] = this.cohabitation;
        data["note"] = this.note;
        data["profession"] = this.profession;
        return data;
    }

    clone(): CreatePersonalDataFamilyMemberDto {
        const json = this.toJSON();
        let result = new CreatePersonalDataFamilyMemberDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePersonalDataFamilyMemberDto {
    inputCardRecordId: number;
    kinshipDegreeId: number | undefined;
    name: string | undefined;
    surname: string | undefined;
    birthDate: moment.Moment | undefined;
    cohabitation: boolean | undefined;
    note: string | undefined;
    profession: string | undefined;
}

export class CreatePhotovoltaicSystemDto implements ICreatePhotovoltaicSystemDto {
    structureId!: number;
    name!: string;

    constructor(data?: ICreatePhotovoltaicSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.structureId = _data["structureId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreatePhotovoltaicSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePhotovoltaicSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["structureId"] = this.structureId;
        data["name"] = this.name;
        return data;
    }

    clone(): CreatePhotovoltaicSystemDto {
        const json = this.toJSON();
        let result = new CreatePhotovoltaicSystemDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePhotovoltaicSystemDto {
    structureId: number;
    name: string;
}

export class CreatePlaceDto implements ICreatePlaceDto {
    description!: string;

    constructor(data?: ICreatePlaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreatePlaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        return data;
    }

    clone(): CreatePlaceDto {
        const json = this.toJSON();
        let result = new CreatePlaceDto();
        result.init(json);
        return result;
    }
}

export interface ICreatePlaceDto {
    description: string;
}

export class CreateProtectionMeasureDto implements ICreateProtectionMeasureDto {
    provisionTypeId!: number | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    note!: string | undefined;

    constructor(data?: ICreateProtectionMeasureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.provisionTypeId = _data["provisionTypeId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateProtectionMeasureDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProtectionMeasureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["provisionTypeId"] = this.provisionTypeId;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.format('YYYY-MM-DD') : undefined as any;
        data["note"] = this.note;
        return data;
    }

    clone(): CreateProtectionMeasureDto {
        const json = this.toJSON();
        let result = new CreateProtectionMeasureDto();
        result.init(json);
        return result;
    }
}

export interface ICreateProtectionMeasureDto {
    provisionTypeId: number | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    note: string | undefined;
}

export class CreateQualificationDto implements ICreateQualificationDto {
    description!: string;

    constructor(data?: ICreateQualificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateQualificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQualificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        return data;
    }

    clone(): CreateQualificationDto {
        const json = this.toJSON();
        let result = new CreateQualificationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateQualificationDto {
    description: string;
}

export class CreateReconciliationPharmacologicalRecordDto implements ICreateReconciliationPharmacologicalRecordDto {
    date!: moment.Moment;
    socialHealthRecordId!: number;
    room!: string | undefined;
    bed!: string | undefined;
    observation!: string | undefined;
    allergyOrIntolerance!: string | undefined;
    reconciliationInformationIds!: number[] | undefined;
    reconciliationInformationOther!: string | undefined;

    constructor(data?: ICreateReconciliationPharmacologicalRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.room = _data["room"];
            this.bed = _data["bed"];
            this.observation = _data["observation"];
            this.allergyOrIntolerance = _data["allergyOrIntolerance"];
            if (Array.isArray(_data["reconciliationInformationIds"])) {
                this.reconciliationInformationIds = [] as any;
                for (let item of _data["reconciliationInformationIds"])
                    this.reconciliationInformationIds!.push(item);
            }
            this.reconciliationInformationOther = _data["reconciliationInformationOther"];
        }
    }

    static fromJS(data: any): CreateReconciliationPharmacologicalRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReconciliationPharmacologicalRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["room"] = this.room;
        data["bed"] = this.bed;
        data["observation"] = this.observation;
        data["allergyOrIntolerance"] = this.allergyOrIntolerance;
        if (Array.isArray(this.reconciliationInformationIds)) {
            data["reconciliationInformationIds"] = [];
            for (let item of this.reconciliationInformationIds)
                data["reconciliationInformationIds"].push(item);
        }
        data["reconciliationInformationOther"] = this.reconciliationInformationOther;
        return data;
    }

    clone(): CreateReconciliationPharmacologicalRecordDto {
        const json = this.toJSON();
        let result = new CreateReconciliationPharmacologicalRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreateReconciliationPharmacologicalRecordDto {
    date: moment.Moment;
    socialHealthRecordId: number;
    room: string | undefined;
    bed: string | undefined;
    observation: string | undefined;
    allergyOrIntolerance: string | undefined;
    reconciliationInformationIds: number[] | undefined;
    reconciliationInformationOther: string | undefined;
}

export class CreateReconciliationPharmacologicalSomministrationRecognitionDto implements ICreateReconciliationPharmacologicalSomministrationRecognitionDto {
    reconciliationPharmacologicalRecordId!: number;
    parentReconciliationPharmacologicalSomministrationRecognitionId!: number | undefined;
    drugName!: string | undefined;
    formAndDosage!: string | undefined;
    somministrationMethodId!: number | undefined;
    somministrationMethodOther!: string | undefined;
    dosageDaily!: string | undefined;
    startDate!: moment.Moment | undefined;
    duration!: string | undefined;
    dateTimeLastDose!: moment.Moment | undefined;
    isNewPrescription!: boolean | undefined;

    constructor(data?: ICreateReconciliationPharmacologicalSomministrationRecognitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reconciliationPharmacologicalRecordId = _data["reconciliationPharmacologicalRecordId"];
            this.parentReconciliationPharmacologicalSomministrationRecognitionId = _data["parentReconciliationPharmacologicalSomministrationRecognitionId"];
            this.drugName = _data["drugName"];
            this.formAndDosage = _data["formAndDosage"];
            this.somministrationMethodId = _data["somministrationMethodId"];
            this.somministrationMethodOther = _data["somministrationMethodOther"];
            this.dosageDaily = _data["dosageDaily"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.duration = _data["duration"];
            this.dateTimeLastDose = _data["dateTimeLastDose"] ? moment(_data["dateTimeLastDose"].toString()) : undefined as any;
            this.isNewPrescription = _data["isNewPrescription"];
        }
    }

    static fromJS(data: any): CreateReconciliationPharmacologicalSomministrationRecognitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReconciliationPharmacologicalSomministrationRecognitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reconciliationPharmacologicalRecordId"] = this.reconciliationPharmacologicalRecordId;
        data["parentReconciliationPharmacologicalSomministrationRecognitionId"] = this.parentReconciliationPharmacologicalSomministrationRecognitionId;
        data["drugName"] = this.drugName;
        data["formAndDosage"] = this.formAndDosage;
        data["somministrationMethodId"] = this.somministrationMethodId;
        data["somministrationMethodOther"] = this.somministrationMethodOther;
        data["dosageDaily"] = this.dosageDaily;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["duration"] = this.duration;
        data["dateTimeLastDose"] = this.dateTimeLastDose ? this.dateTimeLastDose.toISOString() : undefined as any;
        data["isNewPrescription"] = this.isNewPrescription;
        return data;
    }

    clone(): CreateReconciliationPharmacologicalSomministrationRecognitionDto {
        const json = this.toJSON();
        let result = new CreateReconciliationPharmacologicalSomministrationRecognitionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateReconciliationPharmacologicalSomministrationRecognitionDto {
    reconciliationPharmacologicalRecordId: number;
    parentReconciliationPharmacologicalSomministrationRecognitionId: number | undefined;
    drugName: string | undefined;
    formAndDosage: string | undefined;
    somministrationMethodId: number | undefined;
    somministrationMethodOther: string | undefined;
    dosageDaily: string | undefined;
    startDate: moment.Moment | undefined;
    duration: string | undefined;
    dateTimeLastDose: moment.Moment | undefined;
    isNewPrescription: boolean | undefined;
}

export class CreateReconciliationPharmacologicalSomministrationReconciliationDto implements ICreateReconciliationPharmacologicalSomministrationReconciliationDto {
    reconciliationPharmacologicalSomministrationRecognitionId!: number;
    continue!: boolean | undefined;
    interrupt!: boolean | undefined;
    modify!: boolean | undefined;
    getStarted!: boolean | undefined;
    motivation!: string | undefined;

    constructor(data?: ICreateReconciliationPharmacologicalSomministrationReconciliationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reconciliationPharmacologicalSomministrationRecognitionId = _data["reconciliationPharmacologicalSomministrationRecognitionId"];
            this.continue = _data["continue"];
            this.interrupt = _data["interrupt"];
            this.modify = _data["modify"];
            this.getStarted = _data["getStarted"];
            this.motivation = _data["motivation"];
        }
    }

    static fromJS(data: any): CreateReconciliationPharmacologicalSomministrationReconciliationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateReconciliationPharmacologicalSomministrationReconciliationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reconciliationPharmacologicalSomministrationRecognitionId"] = this.reconciliationPharmacologicalSomministrationRecognitionId;
        data["continue"] = this.continue;
        data["interrupt"] = this.interrupt;
        data["modify"] = this.modify;
        data["getStarted"] = this.getStarted;
        data["motivation"] = this.motivation;
        return data;
    }

    clone(): CreateReconciliationPharmacologicalSomministrationReconciliationDto {
        const json = this.toJSON();
        let result = new CreateReconciliationPharmacologicalSomministrationReconciliationDto();
        result.init(json);
        return result;
    }
}

export interface ICreateReconciliationPharmacologicalSomministrationReconciliationDto {
    reconciliationPharmacologicalSomministrationRecognitionId: number;
    continue: boolean | undefined;
    interrupt: boolean | undefined;
    modify: boolean | undefined;
    getStarted: boolean | undefined;
    motivation: string | undefined;
}

export class CreateRecordDto implements ICreateRecordDto {
    name!: string | undefined;
    description!: string | undefined;

    constructor(data?: ICreateRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }

    clone(): CreateRecordDto {
        const json = this.toJSON();
        let result = new CreateRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRecordDto {
    name: string | undefined;
    description: string | undefined;
}

export class CreateRehabilitationRecordDto implements ICreateRehabilitationRecordDto {
    date!: moment.Moment;
    diagnosis!: string | undefined;
    generalConditionId!: number | undefined;
    mentalStateId!: number | undefined;
    activityId!: number | undefined;
    mobilityId!: number | undefined;
    presenceSoresId!: number | undefined;
    note!: string | undefined;
    treatmentIds!: number[] | undefined;
    socialHealthRecordId!: number;

    constructor(data?: ICreateRehabilitationRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.diagnosis = _data["diagnosis"];
            this.generalConditionId = _data["generalConditionId"];
            this.mentalStateId = _data["mentalStateId"];
            this.activityId = _data["activityId"];
            this.mobilityId = _data["mobilityId"];
            this.presenceSoresId = _data["presenceSoresId"];
            this.note = _data["note"];
            if (Array.isArray(_data["treatmentIds"])) {
                this.treatmentIds = [] as any;
                for (let item of _data["treatmentIds"])
                    this.treatmentIds!.push(item);
            }
            this.socialHealthRecordId = _data["socialHealthRecordId"];
        }
    }

    static fromJS(data: any): CreateRehabilitationRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRehabilitationRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["diagnosis"] = this.diagnosis;
        data["generalConditionId"] = this.generalConditionId;
        data["mentalStateId"] = this.mentalStateId;
        data["activityId"] = this.activityId;
        data["mobilityId"] = this.mobilityId;
        data["presenceSoresId"] = this.presenceSoresId;
        data["note"] = this.note;
        if (Array.isArray(this.treatmentIds)) {
            data["treatmentIds"] = [];
            for (let item of this.treatmentIds)
                data["treatmentIds"].push(item);
        }
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        return data;
    }

    clone(): CreateRehabilitationRecordDto {
        const json = this.toJSON();
        let result = new CreateRehabilitationRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRehabilitationRecordDto {
    date: moment.Moment;
    diagnosis: string | undefined;
    generalConditionId: number | undefined;
    mentalStateId: number | undefined;
    activityId: number | undefined;
    mobilityId: number | undefined;
    presenceSoresId: number | undefined;
    note: string | undefined;
    treatmentIds: number[] | undefined;
    socialHealthRecordId: number;
}

export class CreateRelativeDto implements ICreateRelativeDto {
    interviewParticipantsRecordId!: number;
    kinshipDegreeId!: number | undefined;
    nominative!: string | undefined;

    constructor(data?: ICreateRelativeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.interviewParticipantsRecordId = _data["interviewParticipantsRecordId"];
            this.kinshipDegreeId = _data["kinshipDegreeId"];
            this.nominative = _data["nominative"];
        }
    }

    static fromJS(data: any): CreateRelativeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRelativeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["interviewParticipantsRecordId"] = this.interviewParticipantsRecordId;
        data["kinshipDegreeId"] = this.kinshipDegreeId;
        data["nominative"] = this.nominative;
        return data;
    }

    clone(): CreateRelativeDto {
        const json = this.toJSON();
        let result = new CreateRelativeDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRelativeDto {
    interviewParticipantsRecordId: number;
    kinshipDegreeId: number | undefined;
    nominative: string | undefined;
}

export class CreateResponseObservationGridDto implements ICreateResponseObservationGridDto {
    responseTypeId!: number | undefined;
    description!: string | undefined;
    scopeObservationGridId!: number;
    observationGridId!: number;
    measurementScaleId!: number | undefined;

    constructor(data?: ICreateResponseObservationGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseTypeId = _data["responseTypeId"];
            this.description = _data["description"];
            this.scopeObservationGridId = _data["scopeObservationGridId"];
            this.observationGridId = _data["observationGridId"];
            this.measurementScaleId = _data["measurementScaleId"];
        }
    }

    static fromJS(data: any): CreateResponseObservationGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateResponseObservationGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseTypeId"] = this.responseTypeId;
        data["description"] = this.description;
        data["scopeObservationGridId"] = this.scopeObservationGridId;
        data["observationGridId"] = this.observationGridId;
        data["measurementScaleId"] = this.measurementScaleId;
        return data;
    }

    clone(): CreateResponseObservationGridDto {
        const json = this.toJSON();
        let result = new CreateResponseObservationGridDto();
        result.init(json);
        return result;
    }
}

export interface ICreateResponseObservationGridDto {
    responseTypeId: number | undefined;
    description: string | undefined;
    scopeObservationGridId: number;
    observationGridId: number;
    measurementScaleId: number | undefined;
}

export class CreateRoleDto implements ICreateRoleDto {
    name!: string;
    displayName!: string;
    normalizedName!: string | undefined;
    description!: string | undefined;
    grantedPermissions!: string[] | undefined;

    constructor(data?: ICreateRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        return data;
    }

    clone(): CreateRoleDto {
        const json = this.toJSON();
        let result = new CreateRoleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoleDto {
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
}

export class CreateRoomDto implements ICreateRoomDto {
    structureId!: number;
    name!: string;
    availableBeds!: number;

    constructor(data?: ICreateRoomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.structureId = _data["structureId"];
            this.name = _data["name"];
            this.availableBeds = _data["availableBeds"];
        }
    }

    static fromJS(data: any): CreateRoomDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRoomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["structureId"] = this.structureId;
        data["name"] = this.name;
        data["availableBeds"] = this.availableBeds;
        return data;
    }

    clone(): CreateRoomDto {
        const json = this.toJSON();
        let result = new CreateRoomDto();
        result.init(json);
        return result;
    }
}

export interface ICreateRoomDto {
    structureId: number;
    name: string;
    availableBeds: number;
}

export class CreateSchoolWorkDto implements ICreateSchoolWorkDto {
    inputCardRecordId!: number;
    levelFieldOfStudy!: string | undefined;
    institution!: string | undefined;
    completionYear!: string | undefined;

    constructor(data?: ICreateSchoolWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputCardRecordId = _data["inputCardRecordId"];
            this.levelFieldOfStudy = _data["levelFieldOfStudy"];
            this.institution = _data["institution"];
            this.completionYear = _data["completionYear"];
        }
    }

    static fromJS(data: any): CreateSchoolWorkDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSchoolWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputCardRecordId"] = this.inputCardRecordId;
        data["levelFieldOfStudy"] = this.levelFieldOfStudy;
        data["institution"] = this.institution;
        data["completionYear"] = this.completionYear;
        return data;
    }

    clone(): CreateSchoolWorkDto {
        const json = this.toJSON();
        let result = new CreateSchoolWorkDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSchoolWorkDto {
    inputCardRecordId: number;
    levelFieldOfStudy: string | undefined;
    institution: string | undefined;
    completionYear: string | undefined;
}

export class CreateScopeObservationGridDto implements ICreateScopeObservationGridDto {
    description!: string | undefined;
    categoryObservationGridId!: number | undefined;

    constructor(data?: ICreateScopeObservationGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.categoryObservationGridId = _data["categoryObservationGridId"];
        }
    }

    static fromJS(data: any): CreateScopeObservationGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateScopeObservationGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["categoryObservationGridId"] = this.categoryObservationGridId;
        return data;
    }

    clone(): CreateScopeObservationGridDto {
        const json = this.toJSON();
        let result = new CreateScopeObservationGridDto();
        result.init(json);
        return result;
    }
}

export interface ICreateScopeObservationGridDto {
    description: string | undefined;
    categoryObservationGridId: number | undefined;
}

export class CreateSectionObservationGridDto implements ICreateSectionObservationGridDto {
    name!: string | undefined;
    dataSetObservationGridId!: number | undefined;

    constructor(data?: ICreateSectionObservationGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.dataSetObservationGridId = _data["dataSetObservationGridId"];
        }
    }

    static fromJS(data: any): CreateSectionObservationGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSectionObservationGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["dataSetObservationGridId"] = this.dataSetObservationGridId;
        return data;
    }

    clone(): CreateSectionObservationGridDto {
        const json = this.toJSON();
        let result = new CreateSectionObservationGridDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSectionObservationGridDto {
    name: string | undefined;
    dataSetObservationGridId: number | undefined;
}

export class CreateServiceAttendanceRegisterDto implements ICreateServiceAttendanceRegisterDto {
    serviceUserId!: number;
    date!: moment.Moment;
    isPresent!: boolean | undefined;
    employmentPeriods!: CreateEmploymentPeriodDto[] | undefined;

    constructor(data?: ICreateServiceAttendanceRegisterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceUserId = _data["serviceUserId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.isPresent = _data["isPresent"];
            if (Array.isArray(_data["employmentPeriods"])) {
                this.employmentPeriods = [] as any;
                for (let item of _data["employmentPeriods"])
                    this.employmentPeriods!.push(CreateEmploymentPeriodDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateServiceAttendanceRegisterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceAttendanceRegisterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceUserId"] = this.serviceUserId;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined as any;
        data["isPresent"] = this.isPresent;
        if (Array.isArray(this.employmentPeriods)) {
            data["employmentPeriods"] = [];
            for (let item of this.employmentPeriods)
                data["employmentPeriods"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreateServiceAttendanceRegisterDto {
        const json = this.toJSON();
        let result = new CreateServiceAttendanceRegisterDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceAttendanceRegisterDto {
    serviceUserId: number;
    date: moment.Moment;
    isPresent: boolean | undefined;
    employmentPeriods: CreateEmploymentPeriodDto[] | undefined;
}

export class CreateServiceCheckRefrigeratorTemperatureDetailDto implements ICreateServiceCheckRefrigeratorTemperatureDetailDto {
    serviceCheckRefrigeratorTemperatureId!: number;
    day!: number;
    temperature!: number;

    constructor(data?: ICreateServiceCheckRefrigeratorTemperatureDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceCheckRefrigeratorTemperatureId = _data["serviceCheckRefrigeratorTemperatureId"];
            this.day = _data["day"];
            this.temperature = _data["temperature"];
        }
    }

    static fromJS(data: any): CreateServiceCheckRefrigeratorTemperatureDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceCheckRefrigeratorTemperatureDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceCheckRefrigeratorTemperatureId"] = this.serviceCheckRefrigeratorTemperatureId;
        data["day"] = this.day;
        data["temperature"] = this.temperature;
        return data;
    }

    clone(): CreateServiceCheckRefrigeratorTemperatureDetailDto {
        const json = this.toJSON();
        let result = new CreateServiceCheckRefrigeratorTemperatureDetailDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceCheckRefrigeratorTemperatureDetailDto {
    serviceCheckRefrigeratorTemperatureId: number;
    day: number;
    temperature: number;
}

export class CreateServiceCheckRefrigeratorTemperatureDto implements ICreateServiceCheckRefrigeratorTemperatureDto {
    serviceId!: number;
    month!: number;
    year!: number;

    constructor(data?: ICreateServiceCheckRefrigeratorTemperatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.month = _data["month"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): CreateServiceCheckRefrigeratorTemperatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceCheckRefrigeratorTemperatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["month"] = this.month;
        data["year"] = this.year;
        return data;
    }

    clone(): CreateServiceCheckRefrigeratorTemperatureDto {
        const json = this.toJSON();
        let result = new CreateServiceCheckRefrigeratorTemperatureDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceCheckRefrigeratorTemperatureDto {
    serviceId: number;
    month: number;
    year: number;
}

export class CreateServiceDataCollectionDto implements ICreateServiceDataCollectionDto {
    date!: moment.Moment;
    laboratoryId!: number;
    serviceUserId!: number;
    objectiveIds!: number[] | undefined;
    tenantId!: number | undefined;

    constructor(data?: ICreateServiceDataCollectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.laboratoryId = _data["laboratoryId"];
            this.serviceUserId = _data["serviceUserId"];
            if (Array.isArray(_data["objectiveIds"])) {
                this.objectiveIds = [] as any;
                for (let item of _data["objectiveIds"])
                    this.objectiveIds!.push(item);
            }
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateServiceDataCollectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceDataCollectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["laboratoryId"] = this.laboratoryId;
        data["serviceUserId"] = this.serviceUserId;
        if (Array.isArray(this.objectiveIds)) {
            data["objectiveIds"] = [];
            for (let item of this.objectiveIds)
                data["objectiveIds"].push(item);
        }
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): CreateServiceDataCollectionDto {
        const json = this.toJSON();
        let result = new CreateServiceDataCollectionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceDataCollectionDto {
    date: moment.Moment;
    laboratoryId: number;
    serviceUserId: number;
    objectiveIds: number[] | undefined;
    tenantId: number | undefined;
}

export class CreateServiceDataCollectionObjectiveDto implements ICreateServiceDataCollectionObjectiveDto {
    serviceDataCollectionId!: number;
    objectiveId!: number;
    serviceDataCollectionResultId!: number | undefined;

    constructor(data?: ICreateServiceDataCollectionObjectiveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceDataCollectionId = _data["serviceDataCollectionId"];
            this.objectiveId = _data["objectiveId"];
            this.serviceDataCollectionResultId = _data["serviceDataCollectionResultId"];
        }
    }

    static fromJS(data: any): CreateServiceDataCollectionObjectiveDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceDataCollectionObjectiveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceDataCollectionId"] = this.serviceDataCollectionId;
        data["objectiveId"] = this.objectiveId;
        data["serviceDataCollectionResultId"] = this.serviceDataCollectionResultId;
        return data;
    }

    clone(): CreateServiceDataCollectionObjectiveDto {
        const json = this.toJSON();
        let result = new CreateServiceDataCollectionObjectiveDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceDataCollectionObjectiveDto {
    serviceDataCollectionId: number;
    objectiveId: number;
    serviceDataCollectionResultId: number | undefined;
}

export class CreateServiceDto implements ICreateServiceDto {
    name!: string;
    description!: string | undefined;
    managerName!: string | undefined;
    managerPhoneNumber!: string | undefined;
    sectorIds!: number[] | undefined;
    totalSeats!: number | undefined;
    address!: CreateAddressDto;
    landline!: string | undefined;

    constructor(data?: ICreateServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.managerName = _data["managerName"];
            this.managerPhoneNumber = _data["managerPhoneNumber"];
            if (Array.isArray(_data["sectorIds"])) {
                this.sectorIds = [] as any;
                for (let item of _data["sectorIds"])
                    this.sectorIds!.push(item);
            }
            this.totalSeats = _data["totalSeats"];
            this.address = _data["address"] ? CreateAddressDto.fromJS(_data["address"]) : undefined as any;
            this.landline = _data["landline"];
        }
    }

    static fromJS(data: any): CreateServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["managerName"] = this.managerName;
        data["managerPhoneNumber"] = this.managerPhoneNumber;
        if (Array.isArray(this.sectorIds)) {
            data["sectorIds"] = [];
            for (let item of this.sectorIds)
                data["sectorIds"].push(item);
        }
        data["totalSeats"] = this.totalSeats;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["landline"] = this.landline;
        return data;
    }

    clone(): CreateServiceDto {
        const json = this.toJSON();
        let result = new CreateServiceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceDto {
    name: string;
    description: string | undefined;
    managerName: string | undefined;
    managerPhoneNumber: string | undefined;
    sectorIds: number[] | undefined;
    totalSeats: number | undefined;
    address: CreateAddressDto;
    landline: string | undefined;
}

export class CreateServiceFileTagDto implements ICreateServiceFileTagDto {
    fileTagId!: number;
    serviceId!: number;

    constructor(data?: ICreateServiceFileTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileTagId = _data["fileTagId"];
            this.serviceId = _data["serviceId"];
        }
    }

    static fromJS(data: any): CreateServiceFileTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceFileTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileTagId"] = this.fileTagId;
        data["serviceId"] = this.serviceId;
        return data;
    }

    clone(): CreateServiceFileTagDto {
        const json = this.toJSON();
        let result = new CreateServiceFileTagDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceFileTagDto {
    fileTagId: number;
    serviceId: number;
}

export class CreateServiceLogDto implements ICreateServiceLogDto {
    serviceUserIds!: number[] | undefined;
    serviceId!: number;
    title!: string | undefined;
    description!: string | undefined;
    hasDifferentReferenceDate!: boolean;
    referenceDate!: moment.Moment | undefined;
    tagIds!: number[] | undefined;
    subTagIds!: number[] | undefined;
    serviceTaskIds!: number[] | undefined;

    constructor(data?: ICreateServiceLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["serviceUserIds"])) {
                this.serviceUserIds = [] as any;
                for (let item of _data["serviceUserIds"])
                    this.serviceUserIds!.push(item);
            }
            this.serviceId = _data["serviceId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.hasDifferentReferenceDate = _data["hasDifferentReferenceDate"];
            this.referenceDate = _data["referenceDate"] ? moment(_data["referenceDate"].toString()) : undefined as any;
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            if (Array.isArray(_data["subTagIds"])) {
                this.subTagIds = [] as any;
                for (let item of _data["subTagIds"])
                    this.subTagIds!.push(item);
            }
            if (Array.isArray(_data["serviceTaskIds"])) {
                this.serviceTaskIds = [] as any;
                for (let item of _data["serviceTaskIds"])
                    this.serviceTaskIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateServiceLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceUserIds)) {
            data["serviceUserIds"] = [];
            for (let item of this.serviceUserIds)
                data["serviceUserIds"].push(item);
        }
        data["serviceId"] = this.serviceId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["hasDifferentReferenceDate"] = this.hasDifferentReferenceDate;
        data["referenceDate"] = this.referenceDate ? this.referenceDate.toISOString() : undefined as any;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        if (Array.isArray(this.subTagIds)) {
            data["subTagIds"] = [];
            for (let item of this.subTagIds)
                data["subTagIds"].push(item);
        }
        if (Array.isArray(this.serviceTaskIds)) {
            data["serviceTaskIds"] = [];
            for (let item of this.serviceTaskIds)
                data["serviceTaskIds"].push(item);
        }
        return data;
    }

    clone(): CreateServiceLogDto {
        const json = this.toJSON();
        let result = new CreateServiceLogDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceLogDto {
    serviceUserIds: number[] | undefined;
    serviceId: number;
    title: string | undefined;
    description: string | undefined;
    hasDifferentReferenceDate: boolean;
    referenceDate: moment.Moment | undefined;
    tagIds: number[] | undefined;
    subTagIds: number[] | undefined;
    serviceTaskIds: number[] | undefined;
}

export class CreateServiceLogServiceTaskDto implements ICreateServiceLogServiceTaskDto {
    serviceLogId!: number;
    serviceTaskId!: number;

    constructor(data?: ICreateServiceLogServiceTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceLogId = _data["serviceLogId"];
            this.serviceTaskId = _data["serviceTaskId"];
        }
    }

    static fromJS(data: any): CreateServiceLogServiceTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceLogServiceTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceLogId"] = this.serviceLogId;
        data["serviceTaskId"] = this.serviceTaskId;
        return data;
    }

    clone(): CreateServiceLogServiceTaskDto {
        const json = this.toJSON();
        let result = new CreateServiceLogServiceTaskDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceLogServiceTaskDto {
    serviceLogId: number;
    serviceTaskId: number;
}

export class CreateServiceModRUDDto implements ICreateServiceModRUDDto {
    serviceUserId!: number;
    municipalityResidence!: string | undefined;
    frequency!: string | undefined;
    hour!: string | undefined;
    weeklyAccess!: string | undefined;
    authorization!: string | undefined;
    voucher!: boolean | undefined;
    expiryVoucher!: moment.Moment | undefined;
    transport!: boolean | undefined;
    canteen!: boolean | undefined;
    entryDate!: moment.Moment | undefined;
    expiryPAI!: moment.Moment | undefined;
    familyContact!: string | undefined;

    constructor(data?: ICreateServiceModRUDDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceUserId = _data["serviceUserId"];
            this.municipalityResidence = _data["municipalityResidence"];
            this.frequency = _data["frequency"];
            this.hour = _data["hour"];
            this.weeklyAccess = _data["weeklyAccess"];
            this.authorization = _data["authorization"];
            this.voucher = _data["voucher"];
            this.expiryVoucher = _data["expiryVoucher"] ? moment(_data["expiryVoucher"].toString()) : undefined as any;
            this.transport = _data["transport"];
            this.canteen = _data["canteen"];
            this.entryDate = _data["entryDate"] ? moment(_data["entryDate"].toString()) : undefined as any;
            this.expiryPAI = _data["expiryPAI"] ? moment(_data["expiryPAI"].toString()) : undefined as any;
            this.familyContact = _data["familyContact"];
        }
    }

    static fromJS(data: any): CreateServiceModRUDDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceModRUDDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceUserId"] = this.serviceUserId;
        data["municipalityResidence"] = this.municipalityResidence;
        data["frequency"] = this.frequency;
        data["hour"] = this.hour;
        data["weeklyAccess"] = this.weeklyAccess;
        data["authorization"] = this.authorization;
        data["voucher"] = this.voucher;
        data["expiryVoucher"] = this.expiryVoucher ? this.expiryVoucher.toISOString() : undefined as any;
        data["transport"] = this.transport;
        data["canteen"] = this.canteen;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : undefined as any;
        data["expiryPAI"] = this.expiryPAI ? this.expiryPAI.toISOString() : undefined as any;
        data["familyContact"] = this.familyContact;
        return data;
    }

    clone(): CreateServiceModRUDDto {
        const json = this.toJSON();
        let result = new CreateServiceModRUDDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceModRUDDto {
    serviceUserId: number;
    municipalityResidence: string | undefined;
    frequency: string | undefined;
    hour: string | undefined;
    weeklyAccess: string | undefined;
    authorization: string | undefined;
    voucher: boolean | undefined;
    expiryVoucher: moment.Moment | undefined;
    transport: boolean | undefined;
    canteen: boolean | undefined;
    entryDate: moment.Moment | undefined;
    expiryPAI: moment.Moment | undefined;
    familyContact: string | undefined;
}

export class CreateServicePlaceDto implements ICreateServicePlaceDto {
    serviceId!: number;
    placeId!: number;

    constructor(data?: ICreateServicePlaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): CreateServicePlaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServicePlaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["placeId"] = this.placeId;
        return data;
    }

    clone(): CreateServicePlaceDto {
        const json = this.toJSON();
        let result = new CreateServicePlaceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServicePlaceDto {
    serviceId: number;
    placeId: number;
}

export class CreateServiceReportDto implements ICreateServiceReportDto {
    serviceId!: number;
    beneficiaryId!: number;
    operatorId!: number;
    objectives!: ServiceReportObjectiveInputDto[] | undefined;
    school!: string | undefined;
    schoolAddress!: CreateAddressDto;
    protocolNumber!: string | undefined;
    place!: string | undefined;
    date!: moment.Moment | undefined;
    subject!: string | undefined;
    projectReferent!: string | undefined;
    serviceManager!: string | undefined;
    schoolYear!: string | undefined;
    projectStartDate!: moment.Moment | undefined;
    weeklyHours!: string | undefined;
    projectLocation!: string | undefined;
    supportTeachers!: string | undefined;
    interventionsDescription!: string | undefined;
    issues!: string | undefined;
    nextYearObjectives!: string | undefined;

    constructor(data?: ICreateServiceReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.beneficiaryId = _data["beneficiaryId"];
            this.operatorId = _data["operatorId"];
            if (Array.isArray(_data["objectives"])) {
                this.objectives = [] as any;
                for (let item of _data["objectives"])
                    this.objectives!.push(ServiceReportObjectiveInputDto.fromJS(item));
            }
            this.school = _data["school"];
            this.schoolAddress = _data["schoolAddress"] ? CreateAddressDto.fromJS(_data["schoolAddress"]) : undefined as any;
            this.protocolNumber = _data["protocolNumber"];
            this.place = _data["place"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.subject = _data["subject"];
            this.projectReferent = _data["projectReferent"];
            this.serviceManager = _data["serviceManager"];
            this.schoolYear = _data["schoolYear"];
            this.projectStartDate = _data["projectStartDate"] ? moment(_data["projectStartDate"].toString()) : undefined as any;
            this.weeklyHours = _data["weeklyHours"];
            this.projectLocation = _data["projectLocation"];
            this.supportTeachers = _data["supportTeachers"];
            this.interventionsDescription = _data["interventionsDescription"];
            this.issues = _data["issues"];
            this.nextYearObjectives = _data["nextYearObjectives"];
        }
    }

    static fromJS(data: any): CreateServiceReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["beneficiaryId"] = this.beneficiaryId;
        data["operatorId"] = this.operatorId;
        if (Array.isArray(this.objectives)) {
            data["objectives"] = [];
            for (let item of this.objectives)
                data["objectives"].push(item ? item.toJSON() : undefined as any);
        }
        data["school"] = this.school;
        data["schoolAddress"] = this.schoolAddress ? this.schoolAddress.toJSON() : undefined as any;
        data["protocolNumber"] = this.protocolNumber;
        data["place"] = this.place;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["subject"] = this.subject;
        data["projectReferent"] = this.projectReferent;
        data["serviceManager"] = this.serviceManager;
        data["schoolYear"] = this.schoolYear;
        data["projectStartDate"] = this.projectStartDate ? this.projectStartDate.toISOString() : undefined as any;
        data["weeklyHours"] = this.weeklyHours;
        data["projectLocation"] = this.projectLocation;
        data["supportTeachers"] = this.supportTeachers;
        data["interventionsDescription"] = this.interventionsDescription;
        data["issues"] = this.issues;
        data["nextYearObjectives"] = this.nextYearObjectives;
        return data;
    }

    clone(): CreateServiceReportDto {
        const json = this.toJSON();
        let result = new CreateServiceReportDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceReportDto {
    serviceId: number;
    beneficiaryId: number;
    operatorId: number;
    objectives: ServiceReportObjectiveInputDto[] | undefined;
    school: string | undefined;
    schoolAddress: CreateAddressDto;
    protocolNumber: string | undefined;
    place: string | undefined;
    date: moment.Moment | undefined;
    subject: string | undefined;
    projectReferent: string | undefined;
    serviceManager: string | undefined;
    schoolYear: string | undefined;
    projectStartDate: moment.Moment | undefined;
    weeklyHours: string | undefined;
    projectLocation: string | undefined;
    supportTeachers: string | undefined;
    interventionsDescription: string | undefined;
    issues: string | undefined;
    nextYearObjectives: string | undefined;
}

export class CreateServiceSemiAnnualHealthDocumentationReviewDto implements ICreateServiceSemiAnnualHealthDocumentationReviewDto {
    serviceId!: number;
    date!: moment.Moment | undefined;
    annotation!: string | undefined;

    constructor(data?: ICreateServiceSemiAnnualHealthDocumentationReviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.annotation = _data["annotation"];
        }
    }

    static fromJS(data: any): CreateServiceSemiAnnualHealthDocumentationReviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceSemiAnnualHealthDocumentationReviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["annotation"] = this.annotation;
        return data;
    }

    clone(): CreateServiceSemiAnnualHealthDocumentationReviewDto {
        const json = this.toJSON();
        let result = new CreateServiceSemiAnnualHealthDocumentationReviewDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceSemiAnnualHealthDocumentationReviewDto {
    serviceId: number;
    date: moment.Moment | undefined;
    annotation: string | undefined;
}

export class CreateServiceStructureDto implements ICreateServiceStructureDto {
    serviceId!: number;
    structureId!: number | undefined;
    airTreatmentSystemId!: number | undefined;
    electricalSystemId!: number | undefined;
    elevatorSystemId!: number | undefined;
    heatingSystemId!: number | undefined;
    hydraulicSystemId!: number | undefined;
    firePreventionSystemId!: number | undefined;
    photovoltaicSystemId!: number | undefined;
    lifelineSystemId!: number | undefined;
    antiTheftSystemId!: number | undefined;
    videoSurveillanceSystemId!: number | undefined;

    constructor(data?: ICreateServiceStructureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.structureId = _data["structureId"];
            this.airTreatmentSystemId = _data["airTreatmentSystemId"];
            this.electricalSystemId = _data["electricalSystemId"];
            this.elevatorSystemId = _data["elevatorSystemId"];
            this.heatingSystemId = _data["heatingSystemId"];
            this.hydraulicSystemId = _data["hydraulicSystemId"];
            this.firePreventionSystemId = _data["firePreventionSystemId"];
            this.photovoltaicSystemId = _data["photovoltaicSystemId"];
            this.lifelineSystemId = _data["lifelineSystemId"];
            this.antiTheftSystemId = _data["antiTheftSystemId"];
            this.videoSurveillanceSystemId = _data["videoSurveillanceSystemId"];
        }
    }

    static fromJS(data: any): CreateServiceStructureDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceStructureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["structureId"] = this.structureId;
        data["airTreatmentSystemId"] = this.airTreatmentSystemId;
        data["electricalSystemId"] = this.electricalSystemId;
        data["elevatorSystemId"] = this.elevatorSystemId;
        data["heatingSystemId"] = this.heatingSystemId;
        data["hydraulicSystemId"] = this.hydraulicSystemId;
        data["firePreventionSystemId"] = this.firePreventionSystemId;
        data["photovoltaicSystemId"] = this.photovoltaicSystemId;
        data["lifelineSystemId"] = this.lifelineSystemId;
        data["antiTheftSystemId"] = this.antiTheftSystemId;
        data["videoSurveillanceSystemId"] = this.videoSurveillanceSystemId;
        return data;
    }

    clone(): CreateServiceStructureDto {
        const json = this.toJSON();
        let result = new CreateServiceStructureDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceStructureDto {
    serviceId: number;
    structureId: number | undefined;
    airTreatmentSystemId: number | undefined;
    electricalSystemId: number | undefined;
    elevatorSystemId: number | undefined;
    heatingSystemId: number | undefined;
    hydraulicSystemId: number | undefined;
    firePreventionSystemId: number | undefined;
    photovoltaicSystemId: number | undefined;
    lifelineSystemId: number | undefined;
    antiTheftSystemId: number | undefined;
    videoSurveillanceSystemId: number | undefined;
}

export class CreateServiceSubTagDto implements ICreateServiceSubTagDto {
    serviceId!: number;
    subTagId!: number;

    constructor(data?: ICreateServiceSubTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.subTagId = _data["subTagId"];
        }
    }

    static fromJS(data: any): CreateServiceSubTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceSubTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["subTagId"] = this.subTagId;
        return data;
    }

    clone(): CreateServiceSubTagDto {
        const json = this.toJSON();
        let result = new CreateServiceSubTagDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceSubTagDto {
    serviceId: number;
    subTagId: number;
}

export class CreateServiceTagDto implements ICreateServiceTagDto {
    serviceId!: number;
    tagId!: number;
    subTagIds!: number[] | undefined;

    constructor(data?: ICreateServiceTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.tagId = _data["tagId"];
            if (Array.isArray(_data["subTagIds"])) {
                this.subTagIds = [] as any;
                for (let item of _data["subTagIds"])
                    this.subTagIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateServiceTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["tagId"] = this.tagId;
        if (Array.isArray(this.subTagIds)) {
            data["subTagIds"] = [];
            for (let item of this.subTagIds)
                data["subTagIds"].push(item);
        }
        return data;
    }

    clone(): CreateServiceTagDto {
        const json = this.toJSON();
        let result = new CreateServiceTagDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceTagDto {
    serviceId: number;
    tagId: number;
    subTagIds: number[] | undefined;
}

export class CreateServiceTaskDto implements ICreateServiceTaskDto {
    serviceId!: number;
    taskId!: number;

    constructor(data?: ICreateServiceTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.taskId = _data["taskId"];
        }
    }

    static fromJS(data: any): CreateServiceTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["taskId"] = this.taskId;
        return data;
    }

    clone(): CreateServiceTaskDto {
        const json = this.toJSON();
        let result = new CreateServiceTaskDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceTaskDto {
    serviceId: number;
    taskId: number;
}

export class CreateServiceTemplateDto implements ICreateServiceTemplateDto {
    name!: string | undefined;
    description!: string | undefined;
    widgetIds!: number[] | undefined;

    constructor(data?: ICreateServiceTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["widgetIds"])) {
                this.widgetIds = [] as any;
                for (let item of _data["widgetIds"])
                    this.widgetIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateServiceTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.widgetIds)) {
            data["widgetIds"] = [];
            for (let item of this.widgetIds)
                data["widgetIds"].push(item);
        }
        return data;
    }

    clone(): CreateServiceTemplateDto {
        const json = this.toJSON();
        let result = new CreateServiceTemplateDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceTemplateDto {
    name: string | undefined;
    description: string | undefined;
    widgetIds: number[] | undefined;
}

export class CreateServiceUserAvailabilityDto implements ICreateServiceUserAvailabilityDto {
    serviceUserId!: number;
    startDate!: moment.Moment;
    endDate!: moment.Moment | undefined;

    constructor(data?: ICreateServiceUserAvailabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceUserId = _data["serviceUserId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateServiceUserAvailabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceUserAvailabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceUserId"] = this.serviceUserId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        return data;
    }

    clone(): CreateServiceUserAvailabilityDto {
        const json = this.toJSON();
        let result = new CreateServiceUserAvailabilityDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceUserAvailabilityDto {
    serviceUserId: number;
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
}

export class CreateServiceUserDto implements ICreateServiceUserDto {
    userId!: number;
    serviceId!: number;
    isOperator!: boolean;
    qualificationId!: number | undefined;

    constructor(data?: ICreateServiceUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.serviceId = _data["serviceId"];
            this.isOperator = _data["isOperator"];
            this.qualificationId = _data["qualificationId"];
        }
    }

    static fromJS(data: any): CreateServiceUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["serviceId"] = this.serviceId;
        data["isOperator"] = this.isOperator;
        data["qualificationId"] = this.qualificationId;
        return data;
    }

    clone(): CreateServiceUserDto {
        const json = this.toJSON();
        let result = new CreateServiceUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceUserDto {
    userId: number;
    serviceId: number;
    isOperator: boolean;
    qualificationId: number | undefined;
}

export class CreateServiceVerbalDto implements ICreateServiceVerbalDto {
    serviceUserIds!: number[] | undefined;
    serviceId!: number;
    externalPeople!: string | undefined;
    dayOrder!: string | undefined;
    date!: moment.Moment | undefined;
    isConfirmed!: boolean;

    constructor(data?: ICreateServiceVerbalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["serviceUserIds"])) {
                this.serviceUserIds = [] as any;
                for (let item of _data["serviceUserIds"])
                    this.serviceUserIds!.push(item);
            }
            this.serviceId = _data["serviceId"];
            this.externalPeople = _data["externalPeople"];
            this.dayOrder = _data["dayOrder"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.isConfirmed = _data["isConfirmed"];
        }
    }

    static fromJS(data: any): CreateServiceVerbalDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceVerbalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceUserIds)) {
            data["serviceUserIds"] = [];
            for (let item of this.serviceUserIds)
                data["serviceUserIds"].push(item);
        }
        data["serviceId"] = this.serviceId;
        data["externalPeople"] = this.externalPeople;
        data["dayOrder"] = this.dayOrder;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["isConfirmed"] = this.isConfirmed;
        return data;
    }

    clone(): CreateServiceVerbalDto {
        const json = this.toJSON();
        let result = new CreateServiceVerbalDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceVerbalDto {
    serviceUserIds: number[] | undefined;
    serviceId: number;
    externalPeople: string | undefined;
    dayOrder: string | undefined;
    date: moment.Moment | undefined;
    isConfirmed: boolean;
}

export class CreateServiceVerbalTagDto implements ICreateServiceVerbalTagDto {
    serviceId!: number;
    verbalTagId!: number;

    constructor(data?: ICreateServiceVerbalTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.verbalTagId = _data["verbalTagId"];
        }
    }

    static fromJS(data: any): CreateServiceVerbalTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceVerbalTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["verbalTagId"] = this.verbalTagId;
        return data;
    }

    clone(): CreateServiceVerbalTagDto {
        const json = this.toJSON();
        let result = new CreateServiceVerbalTagDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceVerbalTagDto {
    serviceId: number;
    verbalTagId: number;
}

export class CreateServiceWeeklyScheduleDto implements ICreateServiceWeeklyScheduleDto {
    serviceUserId!: number;
    dayOfWeekIds!: number[] | undefined;
    employmentPeriods!: CreateEmploymentPeriodDto[] | undefined;

    constructor(data?: ICreateServiceWeeklyScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceUserId = _data["serviceUserId"];
            if (Array.isArray(_data["dayOfWeekIds"])) {
                this.dayOfWeekIds = [] as any;
                for (let item of _data["dayOfWeekIds"])
                    this.dayOfWeekIds!.push(item);
            }
            if (Array.isArray(_data["employmentPeriods"])) {
                this.employmentPeriods = [] as any;
                for (let item of _data["employmentPeriods"])
                    this.employmentPeriods!.push(CreateEmploymentPeriodDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateServiceWeeklyScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceWeeklyScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceUserId"] = this.serviceUserId;
        if (Array.isArray(this.dayOfWeekIds)) {
            data["dayOfWeekIds"] = [];
            for (let item of this.dayOfWeekIds)
                data["dayOfWeekIds"].push(item);
        }
        if (Array.isArray(this.employmentPeriods)) {
            data["employmentPeriods"] = [];
            for (let item of this.employmentPeriods)
                data["employmentPeriods"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreateServiceWeeklyScheduleDto {
        const json = this.toJSON();
        let result = new CreateServiceWeeklyScheduleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceWeeklyScheduleDto {
    serviceUserId: number;
    dayOfWeekIds: number[] | undefined;
    employmentPeriods: CreateEmploymentPeriodDto[] | undefined;
}

export class CreateServiceWeightDetectionDto implements ICreateServiceWeightDetectionDto {
    serviceId!: number;
    structure!: string | undefined;
    year!: number;

    constructor(data?: ICreateServiceWeightDetectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.structure = _data["structure"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): CreateServiceWeightDetectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceWeightDetectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["structure"] = this.structure;
        data["year"] = this.year;
        return data;
    }

    clone(): CreateServiceWeightDetectionDto {
        const json = this.toJSON();
        let result = new CreateServiceWeightDetectionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceWeightDetectionDto {
    serviceId: number;
    structure: string | undefined;
    year: number;
}

export class CreateServiceWidgetDto implements ICreateServiceWidgetDto {
    name!: string | undefined;
    description!: string | undefined;

    constructor(data?: ICreateServiceWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateServiceWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }

    clone(): CreateServiceWidgetDto {
        const json = this.toJSON();
        let result = new CreateServiceWidgetDto();
        result.init(json);
        return result;
    }
}

export interface ICreateServiceWidgetDto {
    name: string | undefined;
    description: string | undefined;
}

export class CreateSocialAssistanceReferenceDto implements ICreateSocialAssistanceReferenceDto {
    inputCardRecordId!: number;
    name!: string | undefined;
    surname!: string | undefined;
    phoneNumber!: string | undefined;
    otherPhoneNumber!: string | undefined;
    emailAddress!: string | undefined;
    role!: string | undefined;
    address!: CreateAddressDto;
    note!: string | undefined;

    constructor(data?: ICreateSocialAssistanceReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputCardRecordId = _data["inputCardRecordId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phoneNumber = _data["phoneNumber"];
            this.otherPhoneNumber = _data["otherPhoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.role = _data["role"];
            this.address = _data["address"] ? CreateAddressDto.fromJS(_data["address"]) : undefined as any;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): CreateSocialAssistanceReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSocialAssistanceReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputCardRecordId"] = this.inputCardRecordId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phoneNumber"] = this.phoneNumber;
        data["otherPhoneNumber"] = this.otherPhoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["role"] = this.role;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["note"] = this.note;
        return data;
    }

    clone(): CreateSocialAssistanceReferenceDto {
        const json = this.toJSON();
        let result = new CreateSocialAssistanceReferenceDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSocialAssistanceReferenceDto {
    inputCardRecordId: number;
    name: string | undefined;
    surname: string | undefined;
    phoneNumber: string | undefined;
    otherPhoneNumber: string | undefined;
    emailAddress: string | undefined;
    role: string | undefined;
    address: CreateAddressDto;
    note: string | undefined;
}

export class CreateSocialHealthRecordDto implements ICreateSocialHealthRecordDto {
    date!: moment.Moment;
    code!: string | undefined;
    dischargeDate!: moment.Moment | undefined;
    dischargeDiagnosis!: string | undefined;
    serviceUserId!: number;

    constructor(data?: ICreateSocialHealthRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.code = _data["code"];
            this.dischargeDate = _data["dischargeDate"] ? moment(_data["dischargeDate"].toString()) : undefined as any;
            this.dischargeDiagnosis = _data["dischargeDiagnosis"];
            this.serviceUserId = _data["serviceUserId"];
        }
    }

    static fromJS(data: any): CreateSocialHealthRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSocialHealthRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["code"] = this.code;
        data["dischargeDate"] = this.dischargeDate ? this.dischargeDate.format('YYYY-MM-DD') : undefined as any;
        data["dischargeDiagnosis"] = this.dischargeDiagnosis;
        data["serviceUserId"] = this.serviceUserId;
        return data;
    }

    clone(): CreateSocialHealthRecordDto {
        const json = this.toJSON();
        let result = new CreateSocialHealthRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSocialHealthRecordDto {
    date: moment.Moment;
    code: string | undefined;
    dischargeDate: moment.Moment | undefined;
    dischargeDiagnosis: string | undefined;
    serviceUserId: number;
}

export class CreateSocialHealthRecordExtensionDateDto implements ICreateSocialHealthRecordExtensionDateDto {
    date!: moment.Moment;
    reason!: string | undefined;

    constructor(data?: ICreateSocialHealthRecordExtensionDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): CreateSocialHealthRecordExtensionDateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSocialHealthRecordExtensionDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined as any;
        data["reason"] = this.reason;
        return data;
    }

    clone(): CreateSocialHealthRecordExtensionDateDto {
        const json = this.toJSON();
        let result = new CreateSocialHealthRecordExtensionDateDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSocialHealthRecordExtensionDateDto {
    date: moment.Moment;
    reason: string | undefined;
}

export class CreateSocialHealthRecordOperatorPermissionDto implements ICreateSocialHealthRecordOperatorPermissionDto {
    socialHealthRecordId!: number;
    operatorPermissions!: OperatorPermissionDto[] | undefined;

    constructor(data?: ICreateSocialHealthRecordOperatorPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            if (Array.isArray(_data["operatorPermissions"])) {
                this.operatorPermissions = [] as any;
                for (let item of _data["operatorPermissions"])
                    this.operatorPermissions!.push(OperatorPermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateSocialHealthRecordOperatorPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSocialHealthRecordOperatorPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        if (Array.isArray(this.operatorPermissions)) {
            data["operatorPermissions"] = [];
            for (let item of this.operatorPermissions)
                data["operatorPermissions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): CreateSocialHealthRecordOperatorPermissionDto {
        const json = this.toJSON();
        let result = new CreateSocialHealthRecordOperatorPermissionDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSocialHealthRecordOperatorPermissionDto {
    socialHealthRecordId: number;
    operatorPermissions: OperatorPermissionDto[] | undefined;
}

export class CreateSocialHealtRecordTemplateDto implements ICreateSocialHealtRecordTemplateDto {
    name!: string | undefined;
    description!: string | undefined;
    widgetIds!: number[] | undefined;

    constructor(data?: ICreateSocialHealtRecordTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["widgetIds"])) {
                this.widgetIds = [] as any;
                for (let item of _data["widgetIds"])
                    this.widgetIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateSocialHealtRecordTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSocialHealtRecordTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.widgetIds)) {
            data["widgetIds"] = [];
            for (let item of this.widgetIds)
                data["widgetIds"].push(item);
        }
        return data;
    }

    clone(): CreateSocialHealtRecordTemplateDto {
        const json = this.toJSON();
        let result = new CreateSocialHealtRecordTemplateDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSocialHealtRecordTemplateDto {
    name: string | undefined;
    description: string | undefined;
    widgetIds: number[] | undefined;
}

export class CreateSocialInvestigationRecordDto implements ICreateSocialInvestigationRecordDto {
    socialHealthRecordId!: number;
    briefUserHistory!: string | undefined;
    familyComponents!: CreateFamilyComponentDto[] | undefined;
    familySituationId!: number | undefined;
    familyNote!: string | undefined;
    familyMedicalHistory!: string | undefined;
    familyDynamics!: string | undefined;
    incomeAllowances!: CreateIncomeAllowanceDto[] | undefined;
    protectionMeasure!: CreateProtectionMeasureDto;
    housingSituation!: CreateHousingSituationDto;
    eductionalTraining!: CreateEducationalTrainingDto;
    freeTimeAutonomies!: string | undefined;
    characteristicsOrProblems!: string | undefined;

    constructor(data?: ICreateSocialInvestigationRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.briefUserHistory = _data["briefUserHistory"];
            if (Array.isArray(_data["familyComponents"])) {
                this.familyComponents = [] as any;
                for (let item of _data["familyComponents"])
                    this.familyComponents!.push(CreateFamilyComponentDto.fromJS(item));
            }
            this.familySituationId = _data["familySituationId"];
            this.familyNote = _data["familyNote"];
            this.familyMedicalHistory = _data["familyMedicalHistory"];
            this.familyDynamics = _data["familyDynamics"];
            if (Array.isArray(_data["incomeAllowances"])) {
                this.incomeAllowances = [] as any;
                for (let item of _data["incomeAllowances"])
                    this.incomeAllowances!.push(CreateIncomeAllowanceDto.fromJS(item));
            }
            this.protectionMeasure = _data["protectionMeasure"] ? CreateProtectionMeasureDto.fromJS(_data["protectionMeasure"]) : undefined as any;
            this.housingSituation = _data["housingSituation"] ? CreateHousingSituationDto.fromJS(_data["housingSituation"]) : undefined as any;
            this.eductionalTraining = _data["eductionalTraining"] ? CreateEducationalTrainingDto.fromJS(_data["eductionalTraining"]) : undefined as any;
            this.freeTimeAutonomies = _data["freeTimeAutonomies"];
            this.characteristicsOrProblems = _data["characteristicsOrProblems"];
        }
    }

    static fromJS(data: any): CreateSocialInvestigationRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSocialInvestigationRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["briefUserHistory"] = this.briefUserHistory;
        if (Array.isArray(this.familyComponents)) {
            data["familyComponents"] = [];
            for (let item of this.familyComponents)
                data["familyComponents"].push(item ? item.toJSON() : undefined as any);
        }
        data["familySituationId"] = this.familySituationId;
        data["familyNote"] = this.familyNote;
        data["familyMedicalHistory"] = this.familyMedicalHistory;
        data["familyDynamics"] = this.familyDynamics;
        if (Array.isArray(this.incomeAllowances)) {
            data["incomeAllowances"] = [];
            for (let item of this.incomeAllowances)
                data["incomeAllowances"].push(item ? item.toJSON() : undefined as any);
        }
        data["protectionMeasure"] = this.protectionMeasure ? this.protectionMeasure.toJSON() : undefined as any;
        data["housingSituation"] = this.housingSituation ? this.housingSituation.toJSON() : undefined as any;
        data["eductionalTraining"] = this.eductionalTraining ? this.eductionalTraining.toJSON() : undefined as any;
        data["freeTimeAutonomies"] = this.freeTimeAutonomies;
        data["characteristicsOrProblems"] = this.characteristicsOrProblems;
        return data;
    }

    clone(): CreateSocialInvestigationRecordDto {
        const json = this.toJSON();
        let result = new CreateSocialInvestigationRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSocialInvestigationRecordDto {
    socialHealthRecordId: number;
    briefUserHistory: string | undefined;
    familyComponents: CreateFamilyComponentDto[] | undefined;
    familySituationId: number | undefined;
    familyNote: string | undefined;
    familyMedicalHistory: string | undefined;
    familyDynamics: string | undefined;
    incomeAllowances: CreateIncomeAllowanceDto[] | undefined;
    protectionMeasure: CreateProtectionMeasureDto;
    housingSituation: CreateHousingSituationDto;
    eductionalTraining: CreateEducationalTrainingDto;
    freeTimeAutonomies: string | undefined;
    characteristicsOrProblems: string | undefined;
}

export class CreateSpecialistAssessmentRecordDto implements ICreateSpecialistAssessmentRecordDto {
    date!: moment.Moment;
    diagnosis!: string | undefined;
    advice!: string | undefined;
    socialHealthRecordId!: number;

    constructor(data?: ICreateSpecialistAssessmentRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.diagnosis = _data["diagnosis"];
            this.advice = _data["advice"];
            this.socialHealthRecordId = _data["socialHealthRecordId"];
        }
    }

    static fromJS(data: any): CreateSpecialistAssessmentRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSpecialistAssessmentRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["diagnosis"] = this.diagnosis;
        data["advice"] = this.advice;
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        return data;
    }

    clone(): CreateSpecialistAssessmentRecordDto {
        const json = this.toJSON();
        let result = new CreateSpecialistAssessmentRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSpecialistAssessmentRecordDto {
    date: moment.Moment;
    diagnosis: string | undefined;
    advice: string | undefined;
    socialHealthRecordId: number;
}

export class CreateSpontaneousReportingEventDto implements ICreateSpontaneousReportingEventDto {
    socialHealthRecordId!: number;
    structure!: string | undefined;
    operationalUnit!: string | undefined;
    equipeId!: number | undefined;
    titleId!: number | undefined;
    otherTitle!: string | undefined;
    hospitalizationNumber!: string | undefined;
    performanceTypeId!: number | undefined;
    otherPerformanceType!: string | undefined;
    procedureDelayId!: number | undefined;
    inappropriateTypeId!: number | undefined;
    missedProcedureTypeId!: number | undefined;
    otherEventTypeId!: number | undefined;
    otherOtherEventType!: string | undefined;
    dateTime!: moment.Moment;
    place!: string;
    isWeekday!: boolean | undefined;
    description!: string | undefined;
    patientFactorIds!: number[] | undefined;
    staffFactorsìIds!: number[] | undefined;
    systemFactorIds!: number[] | undefined;
    otherSystemFactor!: string | undefined;
    outcomeReductionFactorIds!: number[] | undefined;
    otherOutcomeReductionFactor!: string | undefined;
    additionalInvestigationIds!: number[] | undefined;
    otherAdditionalInvestigation!: string | undefined;
    isDocumented!: boolean | undefined;
    isPatientInformed!: boolean | undefined;
    preventedOrAvoidedEvent!: string | undefined;
    eventSeverityLevelId!: number | undefined;

    constructor(data?: ICreateSpontaneousReportingEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.structure = _data["structure"];
            this.operationalUnit = _data["operationalUnit"];
            this.equipeId = _data["equipeId"];
            this.titleId = _data["titleId"];
            this.otherTitle = _data["otherTitle"];
            this.hospitalizationNumber = _data["hospitalizationNumber"];
            this.performanceTypeId = _data["performanceTypeId"];
            this.otherPerformanceType = _data["otherPerformanceType"];
            this.procedureDelayId = _data["procedureDelayId"];
            this.inappropriateTypeId = _data["inappropriateTypeId"];
            this.missedProcedureTypeId = _data["missedProcedureTypeId"];
            this.otherEventTypeId = _data["otherEventTypeId"];
            this.otherOtherEventType = _data["otherOtherEventType"];
            this.dateTime = _data["dateTime"] ? moment(_data["dateTime"].toString()) : undefined as any;
            this.place = _data["place"];
            this.isWeekday = _data["isWeekday"];
            this.description = _data["description"];
            if (Array.isArray(_data["patientFactorIds"])) {
                this.patientFactorIds = [] as any;
                for (let item of _data["patientFactorIds"])
                    this.patientFactorIds!.push(item);
            }
            if (Array.isArray(_data["staffFactorsìIds"])) {
                this.staffFactorsìIds = [] as any;
                for (let item of _data["staffFactorsìIds"])
                    this.staffFactorsìIds!.push(item);
            }
            if (Array.isArray(_data["systemFactorIds"])) {
                this.systemFactorIds = [] as any;
                for (let item of _data["systemFactorIds"])
                    this.systemFactorIds!.push(item);
            }
            this.otherSystemFactor = _data["otherSystemFactor"];
            if (Array.isArray(_data["outcomeReductionFactorIds"])) {
                this.outcomeReductionFactorIds = [] as any;
                for (let item of _data["outcomeReductionFactorIds"])
                    this.outcomeReductionFactorIds!.push(item);
            }
            this.otherOutcomeReductionFactor = _data["otherOutcomeReductionFactor"];
            if (Array.isArray(_data["additionalInvestigationIds"])) {
                this.additionalInvestigationIds = [] as any;
                for (let item of _data["additionalInvestigationIds"])
                    this.additionalInvestigationIds!.push(item);
            }
            this.otherAdditionalInvestigation = _data["otherAdditionalInvestigation"];
            this.isDocumented = _data["isDocumented"];
            this.isPatientInformed = _data["isPatientInformed"];
            this.preventedOrAvoidedEvent = _data["preventedOrAvoidedEvent"];
            this.eventSeverityLevelId = _data["eventSeverityLevelId"];
        }
    }

    static fromJS(data: any): CreateSpontaneousReportingEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSpontaneousReportingEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["structure"] = this.structure;
        data["operationalUnit"] = this.operationalUnit;
        data["equipeId"] = this.equipeId;
        data["titleId"] = this.titleId;
        data["otherTitle"] = this.otherTitle;
        data["hospitalizationNumber"] = this.hospitalizationNumber;
        data["performanceTypeId"] = this.performanceTypeId;
        data["otherPerformanceType"] = this.otherPerformanceType;
        data["procedureDelayId"] = this.procedureDelayId;
        data["inappropriateTypeId"] = this.inappropriateTypeId;
        data["missedProcedureTypeId"] = this.missedProcedureTypeId;
        data["otherEventTypeId"] = this.otherEventTypeId;
        data["otherOtherEventType"] = this.otherOtherEventType;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : undefined as any;
        data["place"] = this.place;
        data["isWeekday"] = this.isWeekday;
        data["description"] = this.description;
        if (Array.isArray(this.patientFactorIds)) {
            data["patientFactorIds"] = [];
            for (let item of this.patientFactorIds)
                data["patientFactorIds"].push(item);
        }
        if (Array.isArray(this.staffFactorsìIds)) {
            data["staffFactorsìIds"] = [];
            for (let item of this.staffFactorsìIds)
                data["staffFactorsìIds"].push(item);
        }
        if (Array.isArray(this.systemFactorIds)) {
            data["systemFactorIds"] = [];
            for (let item of this.systemFactorIds)
                data["systemFactorIds"].push(item);
        }
        data["otherSystemFactor"] = this.otherSystemFactor;
        if (Array.isArray(this.outcomeReductionFactorIds)) {
            data["outcomeReductionFactorIds"] = [];
            for (let item of this.outcomeReductionFactorIds)
                data["outcomeReductionFactorIds"].push(item);
        }
        data["otherOutcomeReductionFactor"] = this.otherOutcomeReductionFactor;
        if (Array.isArray(this.additionalInvestigationIds)) {
            data["additionalInvestigationIds"] = [];
            for (let item of this.additionalInvestigationIds)
                data["additionalInvestigationIds"].push(item);
        }
        data["otherAdditionalInvestigation"] = this.otherAdditionalInvestigation;
        data["isDocumented"] = this.isDocumented;
        data["isPatientInformed"] = this.isPatientInformed;
        data["preventedOrAvoidedEvent"] = this.preventedOrAvoidedEvent;
        data["eventSeverityLevelId"] = this.eventSeverityLevelId;
        return data;
    }

    clone(): CreateSpontaneousReportingEventDto {
        const json = this.toJSON();
        let result = new CreateSpontaneousReportingEventDto();
        result.init(json);
        return result;
    }
}

export interface ICreateSpontaneousReportingEventDto {
    socialHealthRecordId: number;
    structure: string | undefined;
    operationalUnit: string | undefined;
    equipeId: number | undefined;
    titleId: number | undefined;
    otherTitle: string | undefined;
    hospitalizationNumber: string | undefined;
    performanceTypeId: number | undefined;
    otherPerformanceType: string | undefined;
    procedureDelayId: number | undefined;
    inappropriateTypeId: number | undefined;
    missedProcedureTypeId: number | undefined;
    otherEventTypeId: number | undefined;
    otherOtherEventType: string | undefined;
    dateTime: moment.Moment;
    place: string;
    isWeekday: boolean | undefined;
    description: string | undefined;
    patientFactorIds: number[] | undefined;
    staffFactorsìIds: number[] | undefined;
    systemFactorIds: number[] | undefined;
    otherSystemFactor: string | undefined;
    outcomeReductionFactorIds: number[] | undefined;
    otherOutcomeReductionFactor: string | undefined;
    additionalInvestigationIds: number[] | undefined;
    otherAdditionalInvestigation: string | undefined;
    isDocumented: boolean | undefined;
    isPatientInformed: boolean | undefined;
    preventedOrAvoidedEvent: string | undefined;
    eventSeverityLevelId: number | undefined;
}

export class CreateStructureDetailDto implements ICreateStructureDetailDto {
    structureId!: number;
    cadastralData!: string | undefined;
    structureOwnershipTypeId!: number | undefined;
    releaseDate!: moment.Moment | undefined;
    leaseExpirationDate!: moment.Moment | undefined;
    contractRent!: boolean;
    contractRentFileId!: number | undefined;
    deed!: boolean;
    deedFileId!: number | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    extensionDate!: moment.Moment | undefined;
    contractConcession!: boolean;
    contractConcessionFileId!: number | undefined;
    lastBuildingPermitDate!: moment.Moment | undefined;
    lastOccupancyCertificateDate!: moment.Moment | undefined;
    undergroundLocalAuthorizations!: boolean;
    undergroundLocalAuthorizationsFileId!: number | undefined;
    floorPlan!: boolean;
    floorPlanFileId!: number | undefined;
    surfaceArea!: number | undefined;
    cpi!: boolean;
    cpiFileId!: number | undefined;
    cpiTypeId!: number | undefined;

    constructor(data?: ICreateStructureDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.structureId = _data["structureId"];
            this.cadastralData = _data["cadastralData"];
            this.structureOwnershipTypeId = _data["structureOwnershipTypeId"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : undefined as any;
            this.leaseExpirationDate = _data["leaseExpirationDate"] ? moment(_data["leaseExpirationDate"].toString()) : undefined as any;
            this.contractRent = _data["contractRent"];
            this.contractRentFileId = _data["contractRentFileId"];
            this.deed = _data["deed"];
            this.deedFileId = _data["deedFileId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
            this.extensionDate = _data["extensionDate"] ? moment(_data["extensionDate"].toString()) : undefined as any;
            this.contractConcession = _data["contractConcession"];
            this.contractConcessionFileId = _data["contractConcessionFileId"];
            this.lastBuildingPermitDate = _data["lastBuildingPermitDate"] ? moment(_data["lastBuildingPermitDate"].toString()) : undefined as any;
            this.lastOccupancyCertificateDate = _data["lastOccupancyCertificateDate"] ? moment(_data["lastOccupancyCertificateDate"].toString()) : undefined as any;
            this.undergroundLocalAuthorizations = _data["undergroundLocalAuthorizations"];
            this.undergroundLocalAuthorizationsFileId = _data["undergroundLocalAuthorizationsFileId"];
            this.floorPlan = _data["floorPlan"];
            this.floorPlanFileId = _data["floorPlanFileId"];
            this.surfaceArea = _data["surfaceArea"];
            this.cpi = _data["cpi"];
            this.cpiFileId = _data["cpiFileId"];
            this.cpiTypeId = _data["cpiTypeId"];
        }
    }

    static fromJS(data: any): CreateStructureDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStructureDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["structureId"] = this.structureId;
        data["cadastralData"] = this.cadastralData;
        data["structureOwnershipTypeId"] = this.structureOwnershipTypeId;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined as any;
        data["leaseExpirationDate"] = this.leaseExpirationDate ? this.leaseExpirationDate.toISOString() : undefined as any;
        data["contractRent"] = this.contractRent;
        data["contractRentFileId"] = this.contractRentFileId;
        data["deed"] = this.deed;
        data["deedFileId"] = this.deedFileId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["extensionDate"] = this.extensionDate ? this.extensionDate.toISOString() : undefined as any;
        data["contractConcession"] = this.contractConcession;
        data["contractConcessionFileId"] = this.contractConcessionFileId;
        data["lastBuildingPermitDate"] = this.lastBuildingPermitDate ? this.lastBuildingPermitDate.toISOString() : undefined as any;
        data["lastOccupancyCertificateDate"] = this.lastOccupancyCertificateDate ? this.lastOccupancyCertificateDate.toISOString() : undefined as any;
        data["undergroundLocalAuthorizations"] = this.undergroundLocalAuthorizations;
        data["undergroundLocalAuthorizationsFileId"] = this.undergroundLocalAuthorizationsFileId;
        data["floorPlan"] = this.floorPlan;
        data["floorPlanFileId"] = this.floorPlanFileId;
        data["surfaceArea"] = this.surfaceArea;
        data["cpi"] = this.cpi;
        data["cpiFileId"] = this.cpiFileId;
        data["cpiTypeId"] = this.cpiTypeId;
        return data;
    }

    clone(): CreateStructureDetailDto {
        const json = this.toJSON();
        let result = new CreateStructureDetailDto();
        result.init(json);
        return result;
    }
}

export interface ICreateStructureDetailDto {
    structureId: number;
    cadastralData: string | undefined;
    structureOwnershipTypeId: number | undefined;
    releaseDate: moment.Moment | undefined;
    leaseExpirationDate: moment.Moment | undefined;
    contractRent: boolean;
    contractRentFileId: number | undefined;
    deed: boolean;
    deedFileId: number | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    extensionDate: moment.Moment | undefined;
    contractConcession: boolean;
    contractConcessionFileId: number | undefined;
    lastBuildingPermitDate: moment.Moment | undefined;
    lastOccupancyCertificateDate: moment.Moment | undefined;
    undergroundLocalAuthorizations: boolean;
    undergroundLocalAuthorizationsFileId: number | undefined;
    floorPlan: boolean;
    floorPlanFileId: number | undefined;
    surfaceArea: number | undefined;
    cpi: boolean;
    cpiFileId: number | undefined;
    cpiTypeId: number | undefined;
}

export class CreateStructureDto implements ICreateStructureDto {
    name!: string;
    address!: CreateAddressDto;

    constructor(data?: ICreateStructureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.address = new CreateAddressDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.address = _data["address"] ? CreateAddressDto.fromJS(_data["address"]) : new CreateAddressDto();
        }
    }

    static fromJS(data: any): CreateStructureDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStructureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        return data;
    }

    clone(): CreateStructureDto {
        const json = this.toJSON();
        let result = new CreateStructureDto();
        result.init(json);
        return result;
    }
}

export interface ICreateStructureDto {
    name: string;
    address: CreateAddressDto;
}

export class CreateStructureRegistryDataDto implements ICreateStructureRegistryDataDto {
    structureId!: number;
    nui!: string | undefined;
    floor!: string | undefined;
    hasElevator!: boolean | undefined;
    householdHead!: string | undefined;
    contractStartDate!: moment.Moment | undefined;
    contractEndDate!: moment.Moment | undefined;
    projectType!: string | undefined;
    projectTotalPlaces!: number | undefined;
    projectExpirationDate!: moment.Moment | undefined;
    ownerName!: string | undefined;
    ownerPhoneNumber!: string | undefined;
    ownerEmailAddress!: string | undefined;
    utilitiesPayment!: string | undefined;
    heatingType!: string | undefined;
    heatingOrdinaryCleaning!: string | undefined;
    heatingCost!: number | undefined;
    heatingBrand!: string | undefined;
    notes!: string | undefined;

    constructor(data?: ICreateStructureRegistryDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.structureId = _data["structureId"];
            this.nui = _data["nui"];
            this.floor = _data["floor"];
            this.hasElevator = _data["hasElevator"];
            this.householdHead = _data["householdHead"];
            this.contractStartDate = _data["contractStartDate"] ? moment(_data["contractStartDate"].toString()) : undefined as any;
            this.contractEndDate = _data["contractEndDate"] ? moment(_data["contractEndDate"].toString()) : undefined as any;
            this.projectType = _data["projectType"];
            this.projectTotalPlaces = _data["projectTotalPlaces"];
            this.projectExpirationDate = _data["projectExpirationDate"] ? moment(_data["projectExpirationDate"].toString()) : undefined as any;
            this.ownerName = _data["ownerName"];
            this.ownerPhoneNumber = _data["ownerPhoneNumber"];
            this.ownerEmailAddress = _data["ownerEmailAddress"];
            this.utilitiesPayment = _data["utilitiesPayment"];
            this.heatingType = _data["heatingType"];
            this.heatingOrdinaryCleaning = _data["heatingOrdinaryCleaning"];
            this.heatingCost = _data["heatingCost"];
            this.heatingBrand = _data["heatingBrand"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): CreateStructureRegistryDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStructureRegistryDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["structureId"] = this.structureId;
        data["nui"] = this.nui;
        data["floor"] = this.floor;
        data["hasElevator"] = this.hasElevator;
        data["householdHead"] = this.householdHead;
        data["contractStartDate"] = this.contractStartDate ? this.contractStartDate.toISOString() : undefined as any;
        data["contractEndDate"] = this.contractEndDate ? this.contractEndDate.toISOString() : undefined as any;
        data["projectType"] = this.projectType;
        data["projectTotalPlaces"] = this.projectTotalPlaces;
        data["projectExpirationDate"] = this.projectExpirationDate ? this.projectExpirationDate.toISOString() : undefined as any;
        data["ownerName"] = this.ownerName;
        data["ownerPhoneNumber"] = this.ownerPhoneNumber;
        data["ownerEmailAddress"] = this.ownerEmailAddress;
        data["utilitiesPayment"] = this.utilitiesPayment;
        data["heatingType"] = this.heatingType;
        data["heatingOrdinaryCleaning"] = this.heatingOrdinaryCleaning;
        data["heatingCost"] = this.heatingCost;
        data["heatingBrand"] = this.heatingBrand;
        data["notes"] = this.notes;
        return data;
    }

    clone(): CreateStructureRegistryDataDto {
        const json = this.toJSON();
        let result = new CreateStructureRegistryDataDto();
        result.init(json);
        return result;
    }
}

export interface ICreateStructureRegistryDataDto {
    structureId: number;
    nui: string | undefined;
    floor: string | undefined;
    hasElevator: boolean | undefined;
    householdHead: string | undefined;
    contractStartDate: moment.Moment | undefined;
    contractEndDate: moment.Moment | undefined;
    projectType: string | undefined;
    projectTotalPlaces: number | undefined;
    projectExpirationDate: moment.Moment | undefined;
    ownerName: string | undefined;
    ownerPhoneNumber: string | undefined;
    ownerEmailAddress: string | undefined;
    utilitiesPayment: string | undefined;
    heatingType: string | undefined;
    heatingOrdinaryCleaning: string | undefined;
    heatingCost: number | undefined;
    heatingBrand: string | undefined;
    notes: string | undefined;
}

export class CreateStructureTemplateDto implements ICreateStructureTemplateDto {
    name!: string | undefined;
    description!: string | undefined;
    widgetIds!: number[] | undefined;

    constructor(data?: ICreateStructureTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["widgetIds"])) {
                this.widgetIds = [] as any;
                for (let item of _data["widgetIds"])
                    this.widgetIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateStructureTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStructureTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.widgetIds)) {
            data["widgetIds"] = [];
            for (let item of this.widgetIds)
                data["widgetIds"].push(item);
        }
        return data;
    }

    clone(): CreateStructureTemplateDto {
        const json = this.toJSON();
        let result = new CreateStructureTemplateDto();
        result.init(json);
        return result;
    }
}

export interface ICreateStructureTemplateDto {
    name: string | undefined;
    description: string | undefined;
    widgetIds: number[] | undefined;
}

export class CreateTagDto implements ICreateTagDto {
    description!: string;
    subTagDescriptions!: string[] | undefined;

    constructor(data?: ICreateTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            if (Array.isArray(_data["subTagDescriptions"])) {
                this.subTagDescriptions = [] as any;
                for (let item of _data["subTagDescriptions"])
                    this.subTagDescriptions!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        if (Array.isArray(this.subTagDescriptions)) {
            data["subTagDescriptions"] = [];
            for (let item of this.subTagDescriptions)
                data["subTagDescriptions"].push(item);
        }
        return data;
    }

    clone(): CreateTagDto {
        const json = this.toJSON();
        let result = new CreateTagDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTagDto {
    description: string;
    subTagDescriptions: string[] | undefined;
}

export class CreateTaskDto implements ICreateTaskDto {
    description!: string;

    constructor(data?: ICreateTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        return data;
    }

    clone(): CreateTaskDto {
        const json = this.toJSON();
        let result = new CreateTaskDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTaskDto {
    description: string;
}

export class CreateTenantDto implements ICreateTenantDto {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    connectionString!: string | undefined;
    isActive!: boolean;

    constructor(data?: ICreateTenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): CreateTenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): CreateTenantDto {
        const json = this.toJSON();
        let result = new CreateTenantDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTenantDto {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    connectionString: string | undefined;
    isActive: boolean;
}

export class CreateTinettiPerformanceRecordAnswerDto implements ICreateTinettiPerformanceRecordAnswerDto {
    tinettiStaircaseRecordId!: number;
    tinettiAnswerIds!: number[] | undefined;

    constructor(data?: ICreateTinettiPerformanceRecordAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tinettiStaircaseRecordId = _data["tinettiStaircaseRecordId"];
            if (Array.isArray(_data["tinettiAnswerIds"])) {
                this.tinettiAnswerIds = [] as any;
                for (let item of _data["tinettiAnswerIds"])
                    this.tinettiAnswerIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateTinettiPerformanceRecordAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTinettiPerformanceRecordAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tinettiStaircaseRecordId"] = this.tinettiStaircaseRecordId;
        if (Array.isArray(this.tinettiAnswerIds)) {
            data["tinettiAnswerIds"] = [];
            for (let item of this.tinettiAnswerIds)
                data["tinettiAnswerIds"].push(item);
        }
        return data;
    }

    clone(): CreateTinettiPerformanceRecordAnswerDto {
        const json = this.toJSON();
        let result = new CreateTinettiPerformanceRecordAnswerDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTinettiPerformanceRecordAnswerDto {
    tinettiStaircaseRecordId: number;
    tinettiAnswerIds: number[] | undefined;
}

export class CreateTinettiPerformanceRecordDto implements ICreateTinettiPerformanceRecordDto {
    date!: moment.Moment;
    socialHealthRecordId!: number;

    constructor(data?: ICreateTinettiPerformanceRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.socialHealthRecordId = _data["socialHealthRecordId"];
        }
    }

    static fromJS(data: any): CreateTinettiPerformanceRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTinettiPerformanceRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        return data;
    }

    clone(): CreateTinettiPerformanceRecordDto {
        const json = this.toJSON();
        let result = new CreateTinettiPerformanceRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreateTinettiPerformanceRecordDto {
    date: moment.Moment;
    socialHealthRecordId: number;
}

export class CreateUMVDDto implements ICreateUMVDDto {
    inputCardRecordId!: number;
    releaseDate!: moment.Moment | undefined;
    intensity!: string | undefined;
    possibleExpirationDate!: moment.Moment | undefined;
    frequency!: string | undefined;

    constructor(data?: ICreateUMVDDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.inputCardRecordId = _data["inputCardRecordId"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : undefined as any;
            this.intensity = _data["intensity"];
            this.possibleExpirationDate = _data["possibleExpirationDate"] ? moment(_data["possibleExpirationDate"].toString()) : undefined as any;
            this.frequency = _data["frequency"];
        }
    }

    static fromJS(data: any): CreateUMVDDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUMVDDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["inputCardRecordId"] = this.inputCardRecordId;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined as any;
        data["intensity"] = this.intensity;
        data["possibleExpirationDate"] = this.possibleExpirationDate ? this.possibleExpirationDate.toISOString() : undefined as any;
        data["frequency"] = this.frequency;
        return data;
    }

    clone(): CreateUMVDDto {
        const json = this.toJSON();
        let result = new CreateUMVDDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUMVDDto {
    inputCardRecordId: number;
    releaseDate: moment.Moment | undefined;
    intensity: string | undefined;
    possibleExpirationDate: moment.Moment | undefined;
    frequency: string | undefined;
}

export class CreateUserDto implements ICreateUserDto {
    name!: string;
    surname!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    fiscalCode!: string | undefined;
    birthDate!: moment.Moment;
    birthPlaceId!: number | undefined;
    isMale!: boolean | undefined;
    isActive!: boolean;
    roleNames!: string[] | undefined;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.fiscalCode = _data["fiscalCode"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : undefined as any;
            this.birthPlaceId = _data["birthPlaceId"];
            this.isMale = _data["isMale"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["fiscalCode"] = this.fiscalCode;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined as any;
        data["birthPlaceId"] = this.birthPlaceId;
        data["isMale"] = this.isMale;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        return data;
    }

    clone(): CreateUserDto {
        const json = this.toJSON();
        let result = new CreateUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateUserDto {
    name: string;
    surname: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    fiscalCode: string | undefined;
    birthDate: moment.Moment;
    birthPlaceId: number | undefined;
    isMale: boolean | undefined;
    isActive: boolean;
    roleNames: string[] | undefined;
}

export class CreateVehicleAdditionalDataDto implements ICreateVehicleAdditionalDataDto {
    vehicleId!: number;
    keys!: string | undefined;
    multiCard!: boolean | undefined;
    pin!: string | undefined;
    cardNumber!: string | undefined;
    insurance!: string | undefined;
    insuranceExpirationDate!: moment.Moment | undefined;
    vehicleKm!: number | undefined;
    lastRevisionDate!: moment.Moment | undefined;
    revisionExpiration!: number | undefined;

    constructor(data?: ICreateVehicleAdditionalDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleId = _data["vehicleId"];
            this.keys = _data["keys"];
            this.multiCard = _data["multiCard"];
            this.pin = _data["pin"];
            this.cardNumber = _data["cardNumber"];
            this.insurance = _data["insurance"];
            this.insuranceExpirationDate = _data["insuranceExpirationDate"] ? moment(_data["insuranceExpirationDate"].toString()) : undefined as any;
            this.vehicleKm = _data["vehicleKm"];
            this.lastRevisionDate = _data["lastRevisionDate"] ? moment(_data["lastRevisionDate"].toString()) : undefined as any;
            this.revisionExpiration = _data["revisionExpiration"];
        }
    }

    static fromJS(data: any): CreateVehicleAdditionalDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVehicleAdditionalDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleId"] = this.vehicleId;
        data["keys"] = this.keys;
        data["multiCard"] = this.multiCard;
        data["pin"] = this.pin;
        data["cardNumber"] = this.cardNumber;
        data["insurance"] = this.insurance;
        data["insuranceExpirationDate"] = this.insuranceExpirationDate ? this.insuranceExpirationDate.toISOString() : undefined as any;
        data["vehicleKm"] = this.vehicleKm;
        data["lastRevisionDate"] = this.lastRevisionDate ? this.lastRevisionDate.toISOString() : undefined as any;
        data["revisionExpiration"] = this.revisionExpiration;
        return data;
    }

    clone(): CreateVehicleAdditionalDataDto {
        const json = this.toJSON();
        let result = new CreateVehicleAdditionalDataDto();
        result.init(json);
        return result;
    }
}

export interface ICreateVehicleAdditionalDataDto {
    vehicleId: number;
    keys: string | undefined;
    multiCard: boolean | undefined;
    pin: string | undefined;
    cardNumber: string | undefined;
    insurance: string | undefined;
    insuranceExpirationDate: moment.Moment | undefined;
    vehicleKm: number | undefined;
    lastRevisionDate: moment.Moment | undefined;
    revisionExpiration: number | undefined;
}

export class CreateVehicleDto implements ICreateVehicleDto {
    plate!: string;
    vehicleTypeId!: number;
    make!: string;
    model!: string;

    constructor(data?: ICreateVehicleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plate = _data["plate"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.make = _data["make"];
            this.model = _data["model"];
        }
    }

    static fromJS(data: any): CreateVehicleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVehicleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plate"] = this.plate;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["make"] = this.make;
        data["model"] = this.model;
        return data;
    }

    clone(): CreateVehicleDto {
        const json = this.toJSON();
        let result = new CreateVehicleDto();
        result.init(json);
        return result;
    }
}

export interface ICreateVehicleDto {
    plate: string;
    vehicleTypeId: number;
    make: string;
    model: string;
}

export class CreateVehicleServiceUserDto implements ICreateVehicleServiceUserDto {
    vehicleId!: number;
    serviceId!: number;
    userId!: number | undefined;
    assignmentDate!: moment.Moment;
    withdrawalDate!: moment.Moment | undefined;

    constructor(data?: ICreateVehicleServiceUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleId = _data["vehicleId"];
            this.serviceId = _data["serviceId"];
            this.userId = _data["userId"];
            this.assignmentDate = _data["assignmentDate"] ? moment(_data["assignmentDate"].toString()) : undefined as any;
            this.withdrawalDate = _data["withdrawalDate"] ? moment(_data["withdrawalDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateVehicleServiceUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVehicleServiceUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleId"] = this.vehicleId;
        data["serviceId"] = this.serviceId;
        data["userId"] = this.userId;
        data["assignmentDate"] = this.assignmentDate ? this.assignmentDate.toISOString() : undefined as any;
        data["withdrawalDate"] = this.withdrawalDate ? this.withdrawalDate.toISOString() : undefined as any;
        return data;
    }

    clone(): CreateVehicleServiceUserDto {
        const json = this.toJSON();
        let result = new CreateVehicleServiceUserDto();
        result.init(json);
        return result;
    }
}

export interface ICreateVehicleServiceUserDto {
    vehicleId: number;
    serviceId: number;
    userId: number | undefined;
    assignmentDate: moment.Moment;
    withdrawalDate: moment.Moment | undefined;
}

export class CreateVerbalNoteDto implements ICreateVerbalNoteDto {
    serviceVerbalId!: number;
    title!: string | undefined;
    verbalTagIds!: number[] | undefined;
    beneficiaryIds!: number[] | undefined;
    contentsToRecord!: string | undefined;
    detarminationAndNotes!: string | undefined;

    constructor(data?: ICreateVerbalNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceVerbalId = _data["serviceVerbalId"];
            this.title = _data["title"];
            if (Array.isArray(_data["verbalTagIds"])) {
                this.verbalTagIds = [] as any;
                for (let item of _data["verbalTagIds"])
                    this.verbalTagIds!.push(item);
            }
            if (Array.isArray(_data["beneficiaryIds"])) {
                this.beneficiaryIds = [] as any;
                for (let item of _data["beneficiaryIds"])
                    this.beneficiaryIds!.push(item);
            }
            this.contentsToRecord = _data["contentsToRecord"];
            this.detarminationAndNotes = _data["detarminationAndNotes"];
        }
    }

    static fromJS(data: any): CreateVerbalNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVerbalNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceVerbalId"] = this.serviceVerbalId;
        data["title"] = this.title;
        if (Array.isArray(this.verbalTagIds)) {
            data["verbalTagIds"] = [];
            for (let item of this.verbalTagIds)
                data["verbalTagIds"].push(item);
        }
        if (Array.isArray(this.beneficiaryIds)) {
            data["beneficiaryIds"] = [];
            for (let item of this.beneficiaryIds)
                data["beneficiaryIds"].push(item);
        }
        data["contentsToRecord"] = this.contentsToRecord;
        data["detarminationAndNotes"] = this.detarminationAndNotes;
        return data;
    }

    clone(): CreateVerbalNoteDto {
        const json = this.toJSON();
        let result = new CreateVerbalNoteDto();
        result.init(json);
        return result;
    }
}

export interface ICreateVerbalNoteDto {
    serviceVerbalId: number;
    title: string | undefined;
    verbalTagIds: number[] | undefined;
    beneficiaryIds: number[] | undefined;
    contentsToRecord: string | undefined;
    detarminationAndNotes: string | undefined;
}

export class CreateVerbalTagDto implements ICreateVerbalTagDto {
    description!: string;

    constructor(data?: ICreateVerbalTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateVerbalTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVerbalTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        return data;
    }

    clone(): CreateVerbalTagDto {
        const json = this.toJSON();
        let result = new CreateVerbalTagDto();
        result.init(json);
        return result;
    }
}

export interface ICreateVerbalTagDto {
    description: string;
}

export class CreateVideoSurveillanceSystemDto implements ICreateVideoSurveillanceSystemDto {
    structureId!: number;
    name!: string;

    constructor(data?: ICreateVideoSurveillanceSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.structureId = _data["structureId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateVideoSurveillanceSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVideoSurveillanceSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["structureId"] = this.structureId;
        data["name"] = this.name;
        return data;
    }

    clone(): CreateVideoSurveillanceSystemDto {
        const json = this.toJSON();
        let result = new CreateVideoSurveillanceSystemDto();
        result.init(json);
        return result;
    }
}

export interface ICreateVideoSurveillanceSystemDto {
    structureId: number;
    name: string;
}

export class CreateVitalSignRecordDto implements ICreateVitalSignRecordDto {
    socialHealthRecordId!: number;
    date!: moment.Moment;

    constructor(data?: ICreateVitalSignRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateVitalSignRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVitalSignRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        return data;
    }

    clone(): CreateVitalSignRecordDto {
        const json = this.toJSON();
        let result = new CreateVitalSignRecordDto();
        result.init(json);
        return result;
    }
}

export interface ICreateVitalSignRecordDto {
    socialHealthRecordId: number;
    date: moment.Moment;
}

export class CreateWeightDetectionEntryDto implements ICreateWeightDetectionEntryDto {
    serviceWeightDetectionId!: number;
    serviceUserId!: number;

    constructor(data?: ICreateWeightDetectionEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceWeightDetectionId = _data["serviceWeightDetectionId"];
            this.serviceUserId = _data["serviceUserId"];
        }
    }

    static fromJS(data: any): CreateWeightDetectionEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWeightDetectionEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceWeightDetectionId"] = this.serviceWeightDetectionId;
        data["serviceUserId"] = this.serviceUserId;
        return data;
    }

    clone(): CreateWeightDetectionEntryDto {
        const json = this.toJSON();
        let result = new CreateWeightDetectionEntryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateWeightDetectionEntryDto {
    serviceWeightDetectionId: number;
    serviceUserId: number;
}

export class CreateWeightDetectionMonthEntryDto implements ICreateWeightDetectionMonthEntryDto {
    weightDetectionEntryId!: number;
    monthId!: number;
    weight!: number | undefined;

    constructor(data?: ICreateWeightDetectionMonthEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weightDetectionEntryId = _data["weightDetectionEntryId"];
            this.monthId = _data["monthId"];
            this.weight = _data["weight"];
        }
    }

    static fromJS(data: any): CreateWeightDetectionMonthEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWeightDetectionMonthEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weightDetectionEntryId"] = this.weightDetectionEntryId;
        data["monthId"] = this.monthId;
        data["weight"] = this.weight;
        return data;
    }

    clone(): CreateWeightDetectionMonthEntryDto {
        const json = this.toJSON();
        let result = new CreateWeightDetectionMonthEntryDto();
        result.init(json);
        return result;
    }
}

export interface ICreateWeightDetectionMonthEntryDto {
    weightDetectionEntryId: number;
    monthId: number;
    weight: number | undefined;
}

export class CustomDataTemplateDto implements ICustomDataTemplateDto {
    id!: number;
    name!: string | undefined;
    content!: string | undefined;

    constructor(data?: ICustomDataTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): CustomDataTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomDataTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["content"] = this.content;
        return data;
    }

    clone(): CustomDataTemplateDto {
        const json = this.toJSON();
        let result = new CustomDataTemplateDto();
        result.init(json);
        return result;
    }
}

export interface ICustomDataTemplateDto {
    id: number;
    name: string | undefined;
    content: string | undefined;
}

export class CustomDataTemplateDtoPagedResultDto implements ICustomDataTemplateDtoPagedResultDto {
    items!: CustomDataTemplateDto[] | undefined;
    totalCount!: number;

    constructor(data?: ICustomDataTemplateDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CustomDataTemplateDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): CustomDataTemplateDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomDataTemplateDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): CustomDataTemplateDtoPagedResultDto {
        const json = this.toJSON();
        let result = new CustomDataTemplateDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ICustomDataTemplateDtoPagedResultDto {
    items: CustomDataTemplateDto[] | undefined;
    totalCount: number;
}

export class DataSetObservationGridDto implements IDataSetObservationGridDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IDataSetObservationGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DataSetObservationGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataSetObservationGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): DataSetObservationGridDto {
        const json = this.toJSON();
        let result = new DataSetObservationGridDto();
        result.init(json);
        return result;
    }
}

export interface IDataSetObservationGridDto {
    id: number;
    name: string | undefined;
}

export class DayTreatmentsDto implements IDayTreatmentsDto {
    day!: number;
    treatmentTypeIds!: number[] | undefined;

    constructor(data?: IDayTreatmentsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"];
            if (Array.isArray(_data["treatmentTypeIds"])) {
                this.treatmentTypeIds = [] as any;
                for (let item of _data["treatmentTypeIds"])
                    this.treatmentTypeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DayTreatmentsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DayTreatmentsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        if (Array.isArray(this.treatmentTypeIds)) {
            data["treatmentTypeIds"] = [];
            for (let item of this.treatmentTypeIds)
                data["treatmentTypeIds"].push(item);
        }
        return data;
    }

    clone(): DayTreatmentsDto {
        const json = this.toJSON();
        let result = new DayTreatmentsDto();
        result.init(json);
        return result;
    }
}

export interface IDayTreatmentsDto {
    day: number;
    treatmentTypeIds: number[] | undefined;
}

export class DiaryRecordDto implements IDiaryRecordDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    diaryType!: DictionaryDto;
    description!: string | undefined;
    creatorUserId!: number;
    creationTime!: moment.Moment;

    constructor(data?: IDiaryRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.diaryType = _data["diaryType"] ? DictionaryDto.fromJS(_data["diaryType"]) : undefined as any;
            this.description = _data["description"];
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): DiaryRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiaryRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["diaryType"] = this.diaryType ? this.diaryType.toJSON() : undefined as any;
        data["description"] = this.description;
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        return data;
    }

    clone(): DiaryRecordDto {
        const json = this.toJSON();
        let result = new DiaryRecordDto();
        result.init(json);
        return result;
    }
}

export interface IDiaryRecordDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    diaryType: DictionaryDto;
    description: string | undefined;
    creatorUserId: number;
    creationTime: moment.Moment;
}

export class DiaryRecordDtoPagedResultDto implements IDiaryRecordDtoPagedResultDto {
    items!: DiaryRecordDto[] | undefined;
    totalCount!: number;

    constructor(data?: IDiaryRecordDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DiaryRecordDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DiaryRecordDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiaryRecordDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DiaryRecordDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DiaryRecordDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDiaryRecordDtoPagedResultDto {
    items: DiaryRecordDto[] | undefined;
    totalCount: number;
}

export class DictionaryDto implements IDictionaryDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;

    constructor(data?: IDictionaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
        }
    }

    static fromJS(data: any): DictionaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DictionaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        return data;
    }

    clone(): DictionaryDto {
        const json = this.toJSON();
        let result = new DictionaryDto();
        result.init(json);
        return result;
    }
}

export interface IDictionaryDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
}

export class DisabilityDto implements IDisabilityDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    percentage!: number;
    releaseDate!: moment.Moment | undefined;
    diagnosis!: string | undefined;
    note!: string | undefined;

    constructor(data?: IDisabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.percentage = _data["percentage"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : undefined as any;
            this.diagnosis = _data["diagnosis"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): DisabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new DisabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["percentage"] = this.percentage;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined as any;
        data["diagnosis"] = this.diagnosis;
        data["note"] = this.note;
        return data;
    }

    clone(): DisabilityDto {
        const json = this.toJSON();
        let result = new DisabilityDto();
        result.init(json);
        return result;
    }
}

export interface IDisabilityDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    percentage: number;
    releaseDate: moment.Moment | undefined;
    diagnosis: string | undefined;
    note: string | undefined;
}

export class DisabilityDtoPagedResultDto implements IDisabilityDtoPagedResultDto {
    items!: DisabilityDto[] | undefined;
    totalCount!: number;

    constructor(data?: IDisabilityDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DisabilityDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DisabilityDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DisabilityDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DisabilityDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DisabilityDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDisabilityDtoPagedResultDto {
    items: DisabilityDto[] | undefined;
    totalCount: number;
}

export class DoctorRecordDto implements IDoctorRecordDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    doctorType!: DictionaryDto;
    specialization!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IDoctorRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.doctorType = _data["doctorType"] ? DictionaryDto.fromJS(_data["doctorType"]) : undefined as any;
            this.specialization = _data["specialization"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): DoctorRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["doctorType"] = this.doctorType ? this.doctorType.toJSON() : undefined as any;
        data["specialization"] = this.specialization;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }

    clone(): DoctorRecordDto {
        const json = this.toJSON();
        let result = new DoctorRecordDto();
        result.init(json);
        return result;
    }
}

export interface IDoctorRecordDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    name: string | undefined;
    surname: string | undefined;
    doctorType: DictionaryDto;
    specialization: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
}

export class DoctorRecordDtoPagedResultDto implements IDoctorRecordDtoPagedResultDto {
    items!: DoctorRecordDto[] | undefined;
    totalCount!: number;

    constructor(data?: IDoctorRecordDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DoctorRecordDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DoctorRecordDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DoctorRecordDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DoctorRecordDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DoctorRecordDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDoctorRecordDtoPagedResultDto {
    items: DoctorRecordDto[] | undefined;
    totalCount: number;
}

export class DrugAdministrationRecordDto implements IDrugAdministrationRecordDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    administrationDateTime!: moment.Moment;
    drug!: string | undefined;
    administrator!: string | undefined;

    constructor(data?: IDrugAdministrationRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.administrationDateTime = _data["administrationDateTime"] ? moment(_data["administrationDateTime"].toString()) : undefined as any;
            this.drug = _data["drug"];
            this.administrator = _data["administrator"];
        }
    }

    static fromJS(data: any): DrugAdministrationRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new DrugAdministrationRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["administrationDateTime"] = this.administrationDateTime ? this.administrationDateTime.toISOString() : undefined as any;
        data["drug"] = this.drug;
        data["administrator"] = this.administrator;
        return data;
    }

    clone(): DrugAdministrationRecordDto {
        const json = this.toJSON();
        let result = new DrugAdministrationRecordDto();
        result.init(json);
        return result;
    }
}

export interface IDrugAdministrationRecordDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    administrationDateTime: moment.Moment;
    drug: string | undefined;
    administrator: string | undefined;
}

export class DrugAdministrationRecordDtoPagedResultDto implements IDrugAdministrationRecordDtoPagedResultDto {
    items!: DrugAdministrationRecordDto[] | undefined;
    totalCount!: number;

    constructor(data?: IDrugAdministrationRecordDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DrugAdministrationRecordDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DrugAdministrationRecordDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DrugAdministrationRecordDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DrugAdministrationRecordDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DrugAdministrationRecordDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDrugAdministrationRecordDtoPagedResultDto {
    items: DrugAdministrationRecordDto[] | undefined;
    totalCount: number;
}

export class DrugDto implements IDrugDto {
    id!: number;
    name!: string | undefined;
    administrationMethod!: string | undefined;

    constructor(data?: IDrugDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.administrationMethod = _data["administrationMethod"];
        }
    }

    static fromJS(data: any): DrugDto {
        data = typeof data === 'object' ? data : {};
        let result = new DrugDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["administrationMethod"] = this.administrationMethod;
        return data;
    }

    clone(): DrugDto {
        const json = this.toJSON();
        let result = new DrugDto();
        result.init(json);
        return result;
    }
}

export interface IDrugDto {
    id: number;
    name: string | undefined;
    administrationMethod: string | undefined;
}

export class DrugDtoPagedResultDto implements IDrugDtoPagedResultDto {
    items!: DrugDto[] | undefined;
    totalCount!: number;

    constructor(data?: IDrugDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DrugDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DrugDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DrugDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DrugDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DrugDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDrugDtoPagedResultDto {
    items: DrugDto[] | undefined;
    totalCount: number;
}

export class DrugStockManagementRecordDto implements IDrugStockManagementRecordDto {
    id!: number;
    drugName!: string | undefined;
    expiryDate!: moment.Moment | undefined;
    loadingDate!: moment.Moment | undefined;
    loadingQuantity!: string | undefined;
    dischargeDate!: moment.Moment | undefined;
    dischargeQuantity!: string | undefined;
    isSecondConfirmed!: boolean;
    secondConfirmingUserId!: number | undefined;
    secondConfirmationDate!: moment.Moment | undefined;
    secondConfirmingUserFullName!: string | undefined;
    isConfirmed!: boolean;
    confirmingUserId!: number | undefined;
    confirmationDate!: moment.Moment | undefined;
    confirmingUserFullName!: string | undefined;

    constructor(data?: IDrugStockManagementRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.drugName = _data["drugName"];
            this.expiryDate = _data["expiryDate"] ? moment(_data["expiryDate"].toString()) : undefined as any;
            this.loadingDate = _data["loadingDate"] ? moment(_data["loadingDate"].toString()) : undefined as any;
            this.loadingQuantity = _data["loadingQuantity"];
            this.dischargeDate = _data["dischargeDate"] ? moment(_data["dischargeDate"].toString()) : undefined as any;
            this.dischargeQuantity = _data["dischargeQuantity"];
            this.isSecondConfirmed = _data["isSecondConfirmed"];
            this.secondConfirmingUserId = _data["secondConfirmingUserId"];
            this.secondConfirmationDate = _data["secondConfirmationDate"] ? moment(_data["secondConfirmationDate"].toString()) : undefined as any;
            this.secondConfirmingUserFullName = _data["secondConfirmingUserFullName"];
            this.isConfirmed = _data["isConfirmed"];
            this.confirmingUserId = _data["confirmingUserId"];
            this.confirmationDate = _data["confirmationDate"] ? moment(_data["confirmationDate"].toString()) : undefined as any;
            this.confirmingUserFullName = _data["confirmingUserFullName"];
        }
    }

    static fromJS(data: any): DrugStockManagementRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new DrugStockManagementRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["drugName"] = this.drugName;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : undefined as any;
        data["loadingDate"] = this.loadingDate ? this.loadingDate.toISOString() : undefined as any;
        data["loadingQuantity"] = this.loadingQuantity;
        data["dischargeDate"] = this.dischargeDate ? this.dischargeDate.toISOString() : undefined as any;
        data["dischargeQuantity"] = this.dischargeQuantity;
        data["isSecondConfirmed"] = this.isSecondConfirmed;
        data["secondConfirmingUserId"] = this.secondConfirmingUserId;
        data["secondConfirmationDate"] = this.secondConfirmationDate ? this.secondConfirmationDate.toISOString() : undefined as any;
        data["secondConfirmingUserFullName"] = this.secondConfirmingUserFullName;
        data["isConfirmed"] = this.isConfirmed;
        data["confirmingUserId"] = this.confirmingUserId;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : undefined as any;
        data["confirmingUserFullName"] = this.confirmingUserFullName;
        return data;
    }

    clone(): DrugStockManagementRecordDto {
        const json = this.toJSON();
        let result = new DrugStockManagementRecordDto();
        result.init(json);
        return result;
    }
}

export interface IDrugStockManagementRecordDto {
    id: number;
    drugName: string | undefined;
    expiryDate: moment.Moment | undefined;
    loadingDate: moment.Moment | undefined;
    loadingQuantity: string | undefined;
    dischargeDate: moment.Moment | undefined;
    dischargeQuantity: string | undefined;
    isSecondConfirmed: boolean;
    secondConfirmingUserId: number | undefined;
    secondConfirmationDate: moment.Moment | undefined;
    secondConfirmingUserFullName: string | undefined;
    isConfirmed: boolean;
    confirmingUserId: number | undefined;
    confirmationDate: moment.Moment | undefined;
    confirmingUserFullName: string | undefined;
}

export class DrugStockManagementRecordDtoPagedResultDto implements IDrugStockManagementRecordDtoPagedResultDto {
    items!: DrugStockManagementRecordDto[] | undefined;
    totalCount!: number;

    constructor(data?: IDrugStockManagementRecordDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DrugStockManagementRecordDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): DrugStockManagementRecordDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new DrugStockManagementRecordDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): DrugStockManagementRecordDtoPagedResultDto {
        const json = this.toJSON();
        let result = new DrugStockManagementRecordDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IDrugStockManagementRecordDtoPagedResultDto {
    items: DrugStockManagementRecordDto[] | undefined;
    totalCount: number;
}

export class EducationalTrainingDto implements IEducationalTrainingDto {
    id!: number;
    educationalDegreeLevel!: DictionaryDto;
    support!: boolean | undefined;
    titleArchievement!: string | undefined;

    constructor(data?: IEducationalTrainingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.educationalDegreeLevel = _data["educationalDegreeLevel"] ? DictionaryDto.fromJS(_data["educationalDegreeLevel"]) : undefined as any;
            this.support = _data["support"];
            this.titleArchievement = _data["titleArchievement"];
        }
    }

    static fromJS(data: any): EducationalTrainingDto {
        data = typeof data === 'object' ? data : {};
        let result = new EducationalTrainingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["educationalDegreeLevel"] = this.educationalDegreeLevel ? this.educationalDegreeLevel.toJSON() : undefined as any;
        data["support"] = this.support;
        data["titleArchievement"] = this.titleArchievement;
        return data;
    }

    clone(): EducationalTrainingDto {
        const json = this.toJSON();
        let result = new EducationalTrainingDto();
        result.init(json);
        return result;
    }
}

export interface IEducationalTrainingDto {
    id: number;
    educationalDegreeLevel: DictionaryDto;
    support: boolean | undefined;
    titleArchievement: string | undefined;
}

export class EducationalTrainingDtoPagedResultDto implements IEducationalTrainingDtoPagedResultDto {
    items!: EducationalTrainingDto[] | undefined;
    totalCount!: number;

    constructor(data?: IEducationalTrainingDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EducationalTrainingDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): EducationalTrainingDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new EducationalTrainingDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): EducationalTrainingDtoPagedResultDto {
        const json = this.toJSON();
        let result = new EducationalTrainingDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IEducationalTrainingDtoPagedResultDto {
    items: EducationalTrainingDto[] | undefined;
    totalCount: number;
}

export class ElectricalSystemBaseDto implements IElectricalSystemBaseDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IElectricalSystemBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ElectricalSystemBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectricalSystemBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): ElectricalSystemBaseDto {
        const json = this.toJSON();
        let result = new ElectricalSystemBaseDto();
        result.init(json);
        return result;
    }
}

export interface IElectricalSystemBaseDto {
    id: number;
    name: string | undefined;
}

export class ElectricalSystemDto implements IElectricalSystemDto {
    id!: number;
    name!: string | undefined;
    project!: boolean;
    projectFile!: FileDto;
    plantConformityDeclaration!: boolean;
    plantConformityDeclarationFile!: FileDto;
    competentBodies!: boolean | undefined;
    grounding!: boolean | undefined;
    competentBody!: DictionaryDto;
    appointedCertifyingBody!: string | undefined;
    lastVerificationDate!: moment.Moment | undefined;
    verificationCadence!: DictionaryDto;
    systemPower!: string | undefined;
    plantBookletPresent!: boolean;
    plantBookletPresentFile!: FileDto;
    appointedCompany!: string | undefined;
    lastCompilationDate!: moment.Moment | undefined;
    compilationCadence!: number;
    notes!: string | undefined;

    constructor(data?: IElectricalSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.project = _data["project"];
            this.projectFile = _data["projectFile"] ? FileDto.fromJS(_data["projectFile"]) : undefined as any;
            this.plantConformityDeclaration = _data["plantConformityDeclaration"];
            this.plantConformityDeclarationFile = _data["plantConformityDeclarationFile"] ? FileDto.fromJS(_data["plantConformityDeclarationFile"]) : undefined as any;
            this.competentBodies = _data["competentBodies"];
            this.grounding = _data["grounding"];
            this.competentBody = _data["competentBody"] ? DictionaryDto.fromJS(_data["competentBody"]) : undefined as any;
            this.appointedCertifyingBody = _data["appointedCertifyingBody"];
            this.lastVerificationDate = _data["lastVerificationDate"] ? moment(_data["lastVerificationDate"].toString()) : undefined as any;
            this.verificationCadence = _data["verificationCadence"] ? DictionaryDto.fromJS(_data["verificationCadence"]) : undefined as any;
            this.systemPower = _data["systemPower"];
            this.plantBookletPresent = _data["plantBookletPresent"];
            this.plantBookletPresentFile = _data["plantBookletPresentFile"] ? FileDto.fromJS(_data["plantBookletPresentFile"]) : undefined as any;
            this.appointedCompany = _data["appointedCompany"];
            this.lastCompilationDate = _data["lastCompilationDate"] ? moment(_data["lastCompilationDate"].toString()) : undefined as any;
            this.compilationCadence = _data["compilationCadence"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): ElectricalSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectricalSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["project"] = this.project;
        data["projectFile"] = this.projectFile ? this.projectFile.toJSON() : undefined as any;
        data["plantConformityDeclaration"] = this.plantConformityDeclaration;
        data["plantConformityDeclarationFile"] = this.plantConformityDeclarationFile ? this.plantConformityDeclarationFile.toJSON() : undefined as any;
        data["competentBodies"] = this.competentBodies;
        data["grounding"] = this.grounding;
        data["competentBody"] = this.competentBody ? this.competentBody.toJSON() : undefined as any;
        data["appointedCertifyingBody"] = this.appointedCertifyingBody;
        data["lastVerificationDate"] = this.lastVerificationDate ? this.lastVerificationDate.toISOString() : undefined as any;
        data["verificationCadence"] = this.verificationCadence ? this.verificationCadence.toJSON() : undefined as any;
        data["systemPower"] = this.systemPower;
        data["plantBookletPresent"] = this.plantBookletPresent;
        data["plantBookletPresentFile"] = this.plantBookletPresentFile ? this.plantBookletPresentFile.toJSON() : undefined as any;
        data["appointedCompany"] = this.appointedCompany;
        data["lastCompilationDate"] = this.lastCompilationDate ? this.lastCompilationDate.toISOString() : undefined as any;
        data["compilationCadence"] = this.compilationCadence;
        data["notes"] = this.notes;
        return data;
    }

    clone(): ElectricalSystemDto {
        const json = this.toJSON();
        let result = new ElectricalSystemDto();
        result.init(json);
        return result;
    }
}

export interface IElectricalSystemDto {
    id: number;
    name: string | undefined;
    project: boolean;
    projectFile: FileDto;
    plantConformityDeclaration: boolean;
    plantConformityDeclarationFile: FileDto;
    competentBodies: boolean | undefined;
    grounding: boolean | undefined;
    competentBody: DictionaryDto;
    appointedCertifyingBody: string | undefined;
    lastVerificationDate: moment.Moment | undefined;
    verificationCadence: DictionaryDto;
    systemPower: string | undefined;
    plantBookletPresent: boolean;
    plantBookletPresentFile: FileDto;
    appointedCompany: string | undefined;
    lastCompilationDate: moment.Moment | undefined;
    compilationCadence: number;
    notes: string | undefined;
}

export class ElectricalSystemDtoPagedResultDto implements IElectricalSystemDtoPagedResultDto {
    items!: ElectricalSystemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IElectricalSystemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ElectricalSystemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ElectricalSystemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectricalSystemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ElectricalSystemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ElectricalSystemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IElectricalSystemDtoPagedResultDto {
    items: ElectricalSystemDto[] | undefined;
    totalCount: number;
}

export class ElevatorSystemBaseDto implements IElevatorSystemBaseDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IElevatorSystemBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ElevatorSystemBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElevatorSystemBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): ElevatorSystemBaseDto {
        const json = this.toJSON();
        let result = new ElevatorSystemBaseDto();
        result.init(json);
        return result;
    }
}

export interface IElevatorSystemBaseDto {
    id: number;
    name: string | undefined;
}

export class ElevatorSystemDto implements IElevatorSystemDto {
    id!: number;
    name!: string | undefined;
    structure!: StructureDto;
    elevatorType!: DictionaryDto;
    serialNumber!: string | undefined;
    brand!: string | undefined;
    testing!: boolean | undefined;
    plantConformityDeclaration!: boolean;
    plantConformityDeclarationFile!: FileDto;
    maintenanceContract!: boolean;
    maintenanceContractFile!: FileDto;
    maintenanceCompany!: string | undefined;
    lastMaintenanceDate!: moment.Moment | undefined;
    telephoneDialer!: boolean;
    phoneNumber!: string | undefined;
    externalBodyVerificationObligation!: boolean;
    companyName!: string | undefined;
    lastVerificationDate!: moment.Moment | undefined;
    verificationFrequency!: number | undefined;
    notes!: string | undefined;

    constructor(data?: IElevatorSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.structure = _data["structure"] ? StructureDto.fromJS(_data["structure"]) : undefined as any;
            this.elevatorType = _data["elevatorType"] ? DictionaryDto.fromJS(_data["elevatorType"]) : undefined as any;
            this.serialNumber = _data["serialNumber"];
            this.brand = _data["brand"];
            this.testing = _data["testing"];
            this.plantConformityDeclaration = _data["plantConformityDeclaration"];
            this.plantConformityDeclarationFile = _data["plantConformityDeclarationFile"] ? FileDto.fromJS(_data["plantConformityDeclarationFile"]) : undefined as any;
            this.maintenanceContract = _data["maintenanceContract"];
            this.maintenanceContractFile = _data["maintenanceContractFile"] ? FileDto.fromJS(_data["maintenanceContractFile"]) : undefined as any;
            this.maintenanceCompany = _data["maintenanceCompany"];
            this.lastMaintenanceDate = _data["lastMaintenanceDate"] ? moment(_data["lastMaintenanceDate"].toString()) : undefined as any;
            this.telephoneDialer = _data["telephoneDialer"];
            this.phoneNumber = _data["phoneNumber"];
            this.externalBodyVerificationObligation = _data["externalBodyVerificationObligation"];
            this.companyName = _data["companyName"];
            this.lastVerificationDate = _data["lastVerificationDate"] ? moment(_data["lastVerificationDate"].toString()) : undefined as any;
            this.verificationFrequency = _data["verificationFrequency"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): ElevatorSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElevatorSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["structure"] = this.structure ? this.structure.toJSON() : undefined as any;
        data["elevatorType"] = this.elevatorType ? this.elevatorType.toJSON() : undefined as any;
        data["serialNumber"] = this.serialNumber;
        data["brand"] = this.brand;
        data["testing"] = this.testing;
        data["plantConformityDeclaration"] = this.plantConformityDeclaration;
        data["plantConformityDeclarationFile"] = this.plantConformityDeclarationFile ? this.plantConformityDeclarationFile.toJSON() : undefined as any;
        data["maintenanceContract"] = this.maintenanceContract;
        data["maintenanceContractFile"] = this.maintenanceContractFile ? this.maintenanceContractFile.toJSON() : undefined as any;
        data["maintenanceCompany"] = this.maintenanceCompany;
        data["lastMaintenanceDate"] = this.lastMaintenanceDate ? this.lastMaintenanceDate.toISOString() : undefined as any;
        data["telephoneDialer"] = this.telephoneDialer;
        data["phoneNumber"] = this.phoneNumber;
        data["externalBodyVerificationObligation"] = this.externalBodyVerificationObligation;
        data["companyName"] = this.companyName;
        data["lastVerificationDate"] = this.lastVerificationDate ? this.lastVerificationDate.toISOString() : undefined as any;
        data["verificationFrequency"] = this.verificationFrequency;
        data["notes"] = this.notes;
        return data;
    }

    clone(): ElevatorSystemDto {
        const json = this.toJSON();
        let result = new ElevatorSystemDto();
        result.init(json);
        return result;
    }
}

export interface IElevatorSystemDto {
    id: number;
    name: string | undefined;
    structure: StructureDto;
    elevatorType: DictionaryDto;
    serialNumber: string | undefined;
    brand: string | undefined;
    testing: boolean | undefined;
    plantConformityDeclaration: boolean;
    plantConformityDeclarationFile: FileDto;
    maintenanceContract: boolean;
    maintenanceContractFile: FileDto;
    maintenanceCompany: string | undefined;
    lastMaintenanceDate: moment.Moment | undefined;
    telephoneDialer: boolean;
    phoneNumber: string | undefined;
    externalBodyVerificationObligation: boolean;
    companyName: string | undefined;
    lastVerificationDate: moment.Moment | undefined;
    verificationFrequency: number | undefined;
    notes: string | undefined;
}

export class ElevatorSystemDtoPagedResultDto implements IElevatorSystemDtoPagedResultDto {
    items!: ElevatorSystemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IElevatorSystemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ElevatorSystemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ElevatorSystemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElevatorSystemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ElevatorSystemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ElevatorSystemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IElevatorSystemDtoPagedResultDto {
    items: ElevatorSystemDto[] | undefined;
    totalCount: number;
}

export class EmploymentPeriodDto implements IEmploymentPeriodDto {
    id!: number;
    startDateTime!: moment.Moment | undefined;
    endDateTime!: moment.Moment | undefined;

    constructor(data?: IEmploymentPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): EmploymentPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined as any;
        return data;
    }

    clone(): EmploymentPeriodDto {
        const json = this.toJSON();
        let result = new EmploymentPeriodDto();
        result.init(json);
        return result;
    }
}

export interface IEmploymentPeriodDto {
    id: number;
    startDateTime: moment.Moment | undefined;
    endDateTime: moment.Moment | undefined;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider!: string;
    providerKey!: string;
    providerAccessCode!: string;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        return data;
    }

    clone(): ExternalAuthenticateModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string;
    providerAccessCode: string;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    waitingForActivation!: boolean;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        return data;
    }

    clone(): ExternalAuthenticateResultModel {
        const json = this.toJSON();
        let result = new ExternalAuthenticateResultModel();
        result.init(json);
        return result;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name!: string | undefined;
    clientId!: string | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        return data;
    }

    clone(): ExternalLoginProviderInfoModel {
        const json = this.toJSON();
        let result = new ExternalLoginProviderInfoModel();
        result.init(json);
        return result;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
}

export class FallReportDto implements IFallReportDto {
    id!: number;
    isConfirmed!: boolean;
    confirmingUserId!: number | undefined;
    confirmationDate!: moment.Moment | undefined;
    confirmingUserFullName!: string | undefined;
    isMale!: boolean | undefined;
    admissionDate!: moment.Moment | undefined;
    floor!: number | undefined;
    roomNumber!: number | undefined;
    date!: moment.Moment;
    personPresent!: DictionaryDto;
    otherPersonPresent!: string | undefined;
    fallMode!: DictionaryDto;
    otherFallMode!: string | undefined;
    fallReason!: DictionaryDto;
    otherFallReason!: string | undefined;
    fallLocation!: DictionaryDto;
    otherFallLocation!: string | undefined;
    userDoingWhenHeFell!: string | undefined;
    footwearType!: DictionaryDto;
    otherFootwearType!: string | undefined;
    bloodPressure!: number | undefined;
    isSuicide!: boolean | undefined;
    isViolence!: boolean | undefined;
    editOperatorFullName!: string | undefined;
    editOperatorDateTime!: moment.Moment | undefined;
    injuryType!: string | undefined;
    injurySite!: string | undefined;
    injuryPrognosis!: string | undefined;
    consciousnessState!: DictionaryDto;
    fallEventOutcome!: DictionaryDto;
    otherFallEventOutcome!: string | undefined;
    editDoctorFullName!: string | undefined;
    editDoctorDateTime!: moment.Moment | undefined;

    constructor(data?: IFallReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isConfirmed = _data["isConfirmed"];
            this.confirmingUserId = _data["confirmingUserId"];
            this.confirmationDate = _data["confirmationDate"] ? moment(_data["confirmationDate"].toString()) : undefined as any;
            this.confirmingUserFullName = _data["confirmingUserFullName"];
            this.isMale = _data["isMale"];
            this.admissionDate = _data["admissionDate"] ? moment(_data["admissionDate"].toString()) : undefined as any;
            this.floor = _data["floor"];
            this.roomNumber = _data["roomNumber"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.personPresent = _data["personPresent"] ? DictionaryDto.fromJS(_data["personPresent"]) : undefined as any;
            this.otherPersonPresent = _data["otherPersonPresent"];
            this.fallMode = _data["fallMode"] ? DictionaryDto.fromJS(_data["fallMode"]) : undefined as any;
            this.otherFallMode = _data["otherFallMode"];
            this.fallReason = _data["fallReason"] ? DictionaryDto.fromJS(_data["fallReason"]) : undefined as any;
            this.otherFallReason = _data["otherFallReason"];
            this.fallLocation = _data["fallLocation"] ? DictionaryDto.fromJS(_data["fallLocation"]) : undefined as any;
            this.otherFallLocation = _data["otherFallLocation"];
            this.userDoingWhenHeFell = _data["userDoingWhenHeFell"];
            this.footwearType = _data["footwearType"] ? DictionaryDto.fromJS(_data["footwearType"]) : undefined as any;
            this.otherFootwearType = _data["otherFootwearType"];
            this.bloodPressure = _data["bloodPressure"];
            this.isSuicide = _data["isSuicide"];
            this.isViolence = _data["isViolence"];
            this.editOperatorFullName = _data["editOperatorFullName"];
            this.editOperatorDateTime = _data["editOperatorDateTime"] ? moment(_data["editOperatorDateTime"].toString()) : undefined as any;
            this.injuryType = _data["injuryType"];
            this.injurySite = _data["injurySite"];
            this.injuryPrognosis = _data["injuryPrognosis"];
            this.consciousnessState = _data["consciousnessState"] ? DictionaryDto.fromJS(_data["consciousnessState"]) : undefined as any;
            this.fallEventOutcome = _data["fallEventOutcome"] ? DictionaryDto.fromJS(_data["fallEventOutcome"]) : undefined as any;
            this.otherFallEventOutcome = _data["otherFallEventOutcome"];
            this.editDoctorFullName = _data["editDoctorFullName"];
            this.editDoctorDateTime = _data["editDoctorDateTime"] ? moment(_data["editDoctorDateTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): FallReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new FallReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isConfirmed"] = this.isConfirmed;
        data["confirmingUserId"] = this.confirmingUserId;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : undefined as any;
        data["confirmingUserFullName"] = this.confirmingUserFullName;
        data["isMale"] = this.isMale;
        data["admissionDate"] = this.admissionDate ? this.admissionDate.toISOString() : undefined as any;
        data["floor"] = this.floor;
        data["roomNumber"] = this.roomNumber;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["personPresent"] = this.personPresent ? this.personPresent.toJSON() : undefined as any;
        data["otherPersonPresent"] = this.otherPersonPresent;
        data["fallMode"] = this.fallMode ? this.fallMode.toJSON() : undefined as any;
        data["otherFallMode"] = this.otherFallMode;
        data["fallReason"] = this.fallReason ? this.fallReason.toJSON() : undefined as any;
        data["otherFallReason"] = this.otherFallReason;
        data["fallLocation"] = this.fallLocation ? this.fallLocation.toJSON() : undefined as any;
        data["otherFallLocation"] = this.otherFallLocation;
        data["userDoingWhenHeFell"] = this.userDoingWhenHeFell;
        data["footwearType"] = this.footwearType ? this.footwearType.toJSON() : undefined as any;
        data["otherFootwearType"] = this.otherFootwearType;
        data["bloodPressure"] = this.bloodPressure;
        data["isSuicide"] = this.isSuicide;
        data["isViolence"] = this.isViolence;
        data["editOperatorFullName"] = this.editOperatorFullName;
        data["editOperatorDateTime"] = this.editOperatorDateTime ? this.editOperatorDateTime.toISOString() : undefined as any;
        data["injuryType"] = this.injuryType;
        data["injurySite"] = this.injurySite;
        data["injuryPrognosis"] = this.injuryPrognosis;
        data["consciousnessState"] = this.consciousnessState ? this.consciousnessState.toJSON() : undefined as any;
        data["fallEventOutcome"] = this.fallEventOutcome ? this.fallEventOutcome.toJSON() : undefined as any;
        data["otherFallEventOutcome"] = this.otherFallEventOutcome;
        data["editDoctorFullName"] = this.editDoctorFullName;
        data["editDoctorDateTime"] = this.editDoctorDateTime ? this.editDoctorDateTime.toISOString() : undefined as any;
        return data;
    }

    clone(): FallReportDto {
        const json = this.toJSON();
        let result = new FallReportDto();
        result.init(json);
        return result;
    }
}

export interface IFallReportDto {
    id: number;
    isConfirmed: boolean;
    confirmingUserId: number | undefined;
    confirmationDate: moment.Moment | undefined;
    confirmingUserFullName: string | undefined;
    isMale: boolean | undefined;
    admissionDate: moment.Moment | undefined;
    floor: number | undefined;
    roomNumber: number | undefined;
    date: moment.Moment;
    personPresent: DictionaryDto;
    otherPersonPresent: string | undefined;
    fallMode: DictionaryDto;
    otherFallMode: string | undefined;
    fallReason: DictionaryDto;
    otherFallReason: string | undefined;
    fallLocation: DictionaryDto;
    otherFallLocation: string | undefined;
    userDoingWhenHeFell: string | undefined;
    footwearType: DictionaryDto;
    otherFootwearType: string | undefined;
    bloodPressure: number | undefined;
    isSuicide: boolean | undefined;
    isViolence: boolean | undefined;
    editOperatorFullName: string | undefined;
    editOperatorDateTime: moment.Moment | undefined;
    injuryType: string | undefined;
    injurySite: string | undefined;
    injuryPrognosis: string | undefined;
    consciousnessState: DictionaryDto;
    fallEventOutcome: DictionaryDto;
    otherFallEventOutcome: string | undefined;
    editDoctorFullName: string | undefined;
    editDoctorDateTime: moment.Moment | undefined;
}

export class FallReportDtoPagedResultDto implements IFallReportDtoPagedResultDto {
    items!: FallReportDto[] | undefined;
    totalCount!: number;

    constructor(data?: IFallReportDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FallReportDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): FallReportDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FallReportDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): FallReportDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FallReportDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFallReportDtoPagedResultDto {
    items: FallReportDto[] | undefined;
    totalCount: number;
}

export class FamilyComponentDto implements IFamilyComponentDto {
    id!: number;
    kinshipDegree!: string | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    birthDate!: moment.Moment | undefined;
    deathDate!: moment.Moment | undefined;
    workActivities!: string | undefined;
    educationDegree!: string | undefined;

    constructor(data?: IFamilyComponentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kinshipDegree = _data["kinshipDegree"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : undefined as any;
            this.deathDate = _data["deathDate"] ? moment(_data["deathDate"].toString()) : undefined as any;
            this.workActivities = _data["workActivities"];
            this.educationDegree = _data["educationDegree"];
        }
    }

    static fromJS(data: any): FamilyComponentDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyComponentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kinshipDegree"] = this.kinshipDegree;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["birthDate"] = this.birthDate ? this.birthDate.format('YYYY-MM-DD') : undefined as any;
        data["deathDate"] = this.deathDate ? this.deathDate.format('YYYY-MM-DD') : undefined as any;
        data["workActivities"] = this.workActivities;
        data["educationDegree"] = this.educationDegree;
        return data;
    }

    clone(): FamilyComponentDto {
        const json = this.toJSON();
        let result = new FamilyComponentDto();
        result.init(json);
        return result;
    }
}

export interface IFamilyComponentDto {
    id: number;
    kinshipDegree: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    birthDate: moment.Moment | undefined;
    deathDate: moment.Moment | undefined;
    workActivities: string | undefined;
    educationDegree: string | undefined;
}

export class FamilyComponentDtoPagedResultDto implements IFamilyComponentDtoPagedResultDto {
    items!: FamilyComponentDto[] | undefined;
    totalCount!: number;

    constructor(data?: IFamilyComponentDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FamilyComponentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): FamilyComponentDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyComponentDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): FamilyComponentDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FamilyComponentDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFamilyComponentDtoPagedResultDto {
    items: FamilyComponentDto[] | undefined;
    totalCount: number;
}

export class FamilyReferenceDto implements IFamilyReferenceDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    phoneNumber!: string | undefined;
    emailAddress!: string | undefined;
    role!: string | undefined;

    constructor(data?: IFamilyReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phoneNumber = _data["phoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): FamilyReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phoneNumber"] = this.phoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["role"] = this.role;
        return data;
    }

    clone(): FamilyReferenceDto {
        const json = this.toJSON();
        let result = new FamilyReferenceDto();
        result.init(json);
        return result;
    }
}

export interface IFamilyReferenceDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    name: string | undefined;
    surname: string | undefined;
    phoneNumber: string | undefined;
    emailAddress: string | undefined;
    role: string | undefined;
}

export class FamilyReferenceDtoPagedResultDto implements IFamilyReferenceDtoPagedResultDto {
    items!: FamilyReferenceDto[] | undefined;
    totalCount!: number;

    constructor(data?: IFamilyReferenceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FamilyReferenceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): FamilyReferenceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FamilyReferenceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): FamilyReferenceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FamilyReferenceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFamilyReferenceDtoPagedResultDto {
    items: FamilyReferenceDto[] | undefined;
    totalCount: number;
}

export class FileDownloadDto implements IFileDownloadDto {
    id!: number;
    fileName!: string | undefined;
    mimeType!: string | undefined;
    size!: number;
    byteArray!: string | undefined;

    constructor(data?: IFileDownloadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fileName = _data["fileName"];
            this.mimeType = _data["mimeType"];
            this.size = _data["size"];
            this.byteArray = _data["byteArray"];
        }
    }

    static fromJS(data: any): FileDownloadDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDownloadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fileName"] = this.fileName;
        data["mimeType"] = this.mimeType;
        data["size"] = this.size;
        data["byteArray"] = this.byteArray;
        return data;
    }

    clone(): FileDownloadDto {
        const json = this.toJSON();
        let result = new FileDownloadDto();
        result.init(json);
        return result;
    }
}

export interface IFileDownloadDto {
    id: number;
    fileName: string | undefined;
    mimeType: string | undefined;
    size: number;
    byteArray: string | undefined;
}

export class FileDto implements IFileDto {
    id!: number;
    mask!: string | undefined;
    name!: string | undefined;
    extension!: string | undefined;
    mimeType!: string | undefined;
    size!: number;
    creationTime!: moment.Moment;
    fileTags!: DictionaryDto[] | undefined;
    expirationDate!: moment.Moment | undefined;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.mask = _data["mask"];
            this.name = _data["name"];
            this.extension = _data["extension"];
            this.mimeType = _data["mimeType"];
            this.size = _data["size"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
            if (Array.isArray(_data["fileTags"])) {
                this.fileTags = [] as any;
                for (let item of _data["fileTags"])
                    this.fileTags!.push(DictionaryDto.fromJS(item));
            }
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["mask"] = this.mask;
        data["name"] = this.name;
        data["extension"] = this.extension;
        data["mimeType"] = this.mimeType;
        data["size"] = this.size;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        if (Array.isArray(this.fileTags)) {
            data["fileTags"] = [];
            for (let item of this.fileTags)
                data["fileTags"].push(item ? item.toJSON() : undefined as any);
        }
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        return data;
    }

    clone(): FileDto {
        const json = this.toJSON();
        let result = new FileDto();
        result.init(json);
        return result;
    }
}

export interface IFileDto {
    id: number;
    mask: string | undefined;
    name: string | undefined;
    extension: string | undefined;
    mimeType: string | undefined;
    size: number;
    creationTime: moment.Moment;
    fileTags: DictionaryDto[] | undefined;
    expirationDate: moment.Moment | undefined;
}

export class FileDtoPagedResultDto implements IFileDtoPagedResultDto {
    items!: FileDto[] | undefined;
    totalCount!: number;

    constructor(data?: IFileDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FileDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): FileDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): FileDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FileDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFileDtoPagedResultDto {
    items: FileDto[] | undefined;
    totalCount: number;
}

export class FileExtendedDto implements IFileExtendedDto {
    byteArray!: string | undefined;
    signedUrl!: string | undefined;

    constructor(data?: IFileExtendedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.byteArray = _data["byteArray"];
            this.signedUrl = _data["signedUrl"];
        }
    }

    static fromJS(data: any): FileExtendedDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileExtendedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["byteArray"] = this.byteArray;
        data["signedUrl"] = this.signedUrl;
        return data;
    }

    clone(): FileExtendedDto {
        const json = this.toJSON();
        let result = new FileExtendedDto();
        result.init(json);
        return result;
    }
}

export interface IFileExtendedDto {
    byteArray: string | undefined;
    signedUrl: string | undefined;
}

export class FileZipDowloadDto implements IFileZipDowloadDto {
    serviceId!: number | undefined;
    userId!: number | undefined;
    activityId!: number | undefined;
    socialHealthRecordId!: number | undefined;

    constructor(data?: IFileZipDowloadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.userId = _data["userId"];
            this.activityId = _data["activityId"];
            this.socialHealthRecordId = _data["socialHealthRecordId"];
        }
    }

    static fromJS(data: any): FileZipDowloadDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileZipDowloadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["userId"] = this.userId;
        data["activityId"] = this.activityId;
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        return data;
    }

    clone(): FileZipDowloadDto {
        const json = this.toJSON();
        let result = new FileZipDowloadDto();
        result.init(json);
        return result;
    }
}

export interface IFileZipDowloadDto {
    serviceId: number | undefined;
    userId: number | undefined;
    activityId: number | undefined;
    socialHealthRecordId: number | undefined;
}

export class FirePreventionSystemBaseDto implements IFirePreventionSystemBaseDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IFirePreventionSystemBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FirePreventionSystemBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FirePreventionSystemBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): FirePreventionSystemBaseDto {
        const json = this.toJSON();
        let result = new FirePreventionSystemBaseDto();
        result.init(json);
        return result;
    }
}

export interface IFirePreventionSystemBaseDto {
    id: number;
    name: string | undefined;
}

export class FirePreventionSystemDto implements IFirePreventionSystemDto {
    id!: number;
    structure!: StructureDto;
    name!: string;
    firePreventionDevices!: DictionaryDto;
    firePreventionExtinguisher!: DictionaryDto;
    fireControlUnitBrand!: string | undefined;
    fireControlUnitModel!: string | undefined;
    quantity!: number | undefined;
    project!: boolean;
    projectFile!: FileDto;
    plantConformityDeclaration!: boolean;
    plantConformityDeclarationFile!: FileDto;
    maintenanceContract!: boolean;
    maintenanceCompany!: string | undefined;
    maintenanceFile!: FileDto;
    lastMaintenanceDate!: moment.Moment | undefined;
    appointedCompany!: string | undefined;
    outsiderResponsible!: boolean;
    record!: boolean;
    notes!: string | undefined;

    constructor(data?: IFirePreventionSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.structure = new StructureDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.structure = _data["structure"] ? StructureDto.fromJS(_data["structure"]) : new StructureDto();
            this.name = _data["name"];
            this.firePreventionDevices = _data["firePreventionDevices"] ? DictionaryDto.fromJS(_data["firePreventionDevices"]) : undefined as any;
            this.firePreventionExtinguisher = _data["firePreventionExtinguisher"] ? DictionaryDto.fromJS(_data["firePreventionExtinguisher"]) : undefined as any;
            this.fireControlUnitBrand = _data["fireControlUnitBrand"];
            this.fireControlUnitModel = _data["fireControlUnitModel"];
            this.quantity = _data["quantity"];
            this.project = _data["project"];
            this.projectFile = _data["projectFile"] ? FileDto.fromJS(_data["projectFile"]) : undefined as any;
            this.plantConformityDeclaration = _data["plantConformityDeclaration"];
            this.plantConformityDeclarationFile = _data["plantConformityDeclarationFile"] ? FileDto.fromJS(_data["plantConformityDeclarationFile"]) : undefined as any;
            this.maintenanceContract = _data["maintenanceContract"];
            this.maintenanceCompany = _data["maintenanceCompany"];
            this.maintenanceFile = _data["maintenanceFile"] ? FileDto.fromJS(_data["maintenanceFile"]) : undefined as any;
            this.lastMaintenanceDate = _data["lastMaintenanceDate"] ? moment(_data["lastMaintenanceDate"].toString()) : undefined as any;
            this.appointedCompany = _data["appointedCompany"];
            this.outsiderResponsible = _data["outsiderResponsible"];
            this.record = _data["record"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): FirePreventionSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FirePreventionSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["structure"] = this.structure ? this.structure.toJSON() : undefined as any;
        data["name"] = this.name;
        data["firePreventionDevices"] = this.firePreventionDevices ? this.firePreventionDevices.toJSON() : undefined as any;
        data["firePreventionExtinguisher"] = this.firePreventionExtinguisher ? this.firePreventionExtinguisher.toJSON() : undefined as any;
        data["fireControlUnitBrand"] = this.fireControlUnitBrand;
        data["fireControlUnitModel"] = this.fireControlUnitModel;
        data["quantity"] = this.quantity;
        data["project"] = this.project;
        data["projectFile"] = this.projectFile ? this.projectFile.toJSON() : undefined as any;
        data["plantConformityDeclaration"] = this.plantConformityDeclaration;
        data["plantConformityDeclarationFile"] = this.plantConformityDeclarationFile ? this.plantConformityDeclarationFile.toJSON() : undefined as any;
        data["maintenanceContract"] = this.maintenanceContract;
        data["maintenanceCompany"] = this.maintenanceCompany;
        data["maintenanceFile"] = this.maintenanceFile ? this.maintenanceFile.toJSON() : undefined as any;
        data["lastMaintenanceDate"] = this.lastMaintenanceDate ? this.lastMaintenanceDate.toISOString() : undefined as any;
        data["appointedCompany"] = this.appointedCompany;
        data["outsiderResponsible"] = this.outsiderResponsible;
        data["record"] = this.record;
        data["notes"] = this.notes;
        return data;
    }

    clone(): FirePreventionSystemDto {
        const json = this.toJSON();
        let result = new FirePreventionSystemDto();
        result.init(json);
        return result;
    }
}

export interface IFirePreventionSystemDto {
    id: number;
    structure: StructureDto;
    name: string;
    firePreventionDevices: DictionaryDto;
    firePreventionExtinguisher: DictionaryDto;
    fireControlUnitBrand: string | undefined;
    fireControlUnitModel: string | undefined;
    quantity: number | undefined;
    project: boolean;
    projectFile: FileDto;
    plantConformityDeclaration: boolean;
    plantConformityDeclarationFile: FileDto;
    maintenanceContract: boolean;
    maintenanceCompany: string | undefined;
    maintenanceFile: FileDto;
    lastMaintenanceDate: moment.Moment | undefined;
    appointedCompany: string | undefined;
    outsiderResponsible: boolean;
    record: boolean;
    notes: string | undefined;
}

export class FirePreventionSystemDtoPagedResultDto implements IFirePreventionSystemDtoPagedResultDto {
    items!: FirePreventionSystemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IFirePreventionSystemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FirePreventionSystemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): FirePreventionSystemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new FirePreventionSystemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): FirePreventionSystemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new FirePreventionSystemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IFirePreventionSystemDtoPagedResultDto {
    items: FirePreventionSystemDto[] | undefined;
    totalCount: number;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        return data;
    }

    clone(): FlatPermissionDto {
        const json = this.toJSON();
        let result = new FlatPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IFlatPermissionDto {
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
}

export class ForceResetPasswordDto implements IForceResetPasswordDto {
    adminPassword!: string;
    userId!: number;
    newPassword!: string;

    constructor(data?: IForceResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.adminPassword = _data["adminPassword"];
            this.userId = _data["userId"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ForceResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForceResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adminPassword"] = this.adminPassword;
        data["userId"] = this.userId;
        data["newPassword"] = this.newPassword;
        return data;
    }

    clone(): ForceResetPasswordDto {
        const json = this.toJSON();
        let result = new ForceResetPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IForceResetPasswordDto {
    adminPassword: string;
    userId: number;
    newPassword: string;
}

export class ForgotPasswordDto implements IForgotPasswordDto {
    emailAddress!: string;

    constructor(data?: IForgotPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): ForgotPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }

    clone(): ForgotPasswordDto {
        const json = this.toJSON();
        let result = new ForgotPasswordDto();
        result.init(json);
        return result;
    }
}

export interface IForgotPasswordDto {
    emailAddress: string;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    application!: ApplicationInfoDto;
    user!: UserLoginInfoDto;
    tenant!: TenantLoginInfoDto;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : undefined as any;
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : undefined as any;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : undefined as any;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : undefined as any;
        return data;
    }

    clone(): GetCurrentLoginInformationsOutput {
        const json = this.toJSON();
        let result = new GetCurrentLoginInformationsOutput();
        result.init(json);
        return result;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    application: ApplicationInfoDto;
    user: UserLoginInfoDto;
    tenant: TenantLoginInfoDto;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role!: RoleEditDto;
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : undefined as any;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }

    clone(): GetRoleForEditOutput {
        const json = this.toJSON();
        let result = new GetRoleForEditOutput();
        result.init(json);
        return result;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class HealthAspectDto implements IHealthAspectDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    motorSkills!: boolean;
    sight!: boolean;
    hearing!: boolean;
    language!: boolean;
    walking!: boolean;
    other!: string | undefined;
    aids!: string | undefined;
    rehabilitationTherapies!: string | undefined;
    drugTherapies!: string | undefined;
    note!: string | undefined;

    constructor(data?: IHealthAspectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.motorSkills = _data["motorSkills"];
            this.sight = _data["sight"];
            this.hearing = _data["hearing"];
            this.language = _data["language"];
            this.walking = _data["walking"];
            this.other = _data["other"];
            this.aids = _data["aids"];
            this.rehabilitationTherapies = _data["rehabilitationTherapies"];
            this.drugTherapies = _data["drugTherapies"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): HealthAspectDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthAspectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["motorSkills"] = this.motorSkills;
        data["sight"] = this.sight;
        data["hearing"] = this.hearing;
        data["language"] = this.language;
        data["walking"] = this.walking;
        data["other"] = this.other;
        data["aids"] = this.aids;
        data["rehabilitationTherapies"] = this.rehabilitationTherapies;
        data["drugTherapies"] = this.drugTherapies;
        data["note"] = this.note;
        return data;
    }

    clone(): HealthAspectDto {
        const json = this.toJSON();
        let result = new HealthAspectDto();
        result.init(json);
        return result;
    }
}

export interface IHealthAspectDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    motorSkills: boolean;
    sight: boolean;
    hearing: boolean;
    language: boolean;
    walking: boolean;
    other: string | undefined;
    aids: string | undefined;
    rehabilitationTherapies: string | undefined;
    drugTherapies: string | undefined;
    note: string | undefined;
}

export class HealthAspectDtoPagedResultDto implements IHealthAspectDtoPagedResultDto {
    items!: HealthAspectDto[] | undefined;
    totalCount!: number;

    constructor(data?: IHealthAspectDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HealthAspectDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): HealthAspectDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthAspectDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): HealthAspectDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HealthAspectDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHealthAspectDtoPagedResultDto {
    items: HealthAspectDto[] | undefined;
    totalCount: number;
}

export class HealthCoordinatorRecordDto implements IHealthCoordinatorRecordDto {
    id!: number;
    date!: moment.Moment;
    diagnosis!: string | undefined;
    advice!: string | undefined;

    constructor(data?: IHealthCoordinatorRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.diagnosis = _data["diagnosis"];
            this.advice = _data["advice"];
        }
    }

    static fromJS(data: any): HealthCoordinatorRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCoordinatorRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["diagnosis"] = this.diagnosis;
        data["advice"] = this.advice;
        return data;
    }

    clone(): HealthCoordinatorRecordDto {
        const json = this.toJSON();
        let result = new HealthCoordinatorRecordDto();
        result.init(json);
        return result;
    }
}

export interface IHealthCoordinatorRecordDto {
    id: number;
    date: moment.Moment;
    diagnosis: string | undefined;
    advice: string | undefined;
}

export class HealthCoordinatorRecordDtoPagedResultDto implements IHealthCoordinatorRecordDtoPagedResultDto {
    items!: HealthCoordinatorRecordDto[] | undefined;
    totalCount!: number;

    constructor(data?: IHealthCoordinatorRecordDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HealthCoordinatorRecordDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): HealthCoordinatorRecordDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCoordinatorRecordDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): HealthCoordinatorRecordDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HealthCoordinatorRecordDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHealthCoordinatorRecordDtoPagedResultDto {
    items: HealthCoordinatorRecordDto[] | undefined;
    totalCount: number;
}

export class HealthSocialWelfareServiceDto implements IHealthSocialWelfareServiceDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    dateOfAcceptance!: moment.Moment | undefined;
    socialWorker!: string | undefined;
    homeAssistant!: string | undefined;
    dayFosterCare!: string | undefined;
    inChargeAt!: string | undefined;
    serviceNPI!: string | undefined;

    constructor(data?: IHealthSocialWelfareServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.dateOfAcceptance = _data["dateOfAcceptance"] ? moment(_data["dateOfAcceptance"].toString()) : undefined as any;
            this.socialWorker = _data["socialWorker"];
            this.homeAssistant = _data["homeAssistant"];
            this.dayFosterCare = _data["dayFosterCare"];
            this.inChargeAt = _data["inChargeAt"];
            this.serviceNPI = _data["serviceNPI"];
        }
    }

    static fromJS(data: any): HealthSocialWelfareServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthSocialWelfareServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["dateOfAcceptance"] = this.dateOfAcceptance ? this.dateOfAcceptance.toISOString() : undefined as any;
        data["socialWorker"] = this.socialWorker;
        data["homeAssistant"] = this.homeAssistant;
        data["dayFosterCare"] = this.dayFosterCare;
        data["inChargeAt"] = this.inChargeAt;
        data["serviceNPI"] = this.serviceNPI;
        return data;
    }

    clone(): HealthSocialWelfareServiceDto {
        const json = this.toJSON();
        let result = new HealthSocialWelfareServiceDto();
        result.init(json);
        return result;
    }
}

export interface IHealthSocialWelfareServiceDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    dateOfAcceptance: moment.Moment | undefined;
    socialWorker: string | undefined;
    homeAssistant: string | undefined;
    dayFosterCare: string | undefined;
    inChargeAt: string | undefined;
    serviceNPI: string | undefined;
}

export class HealthSocialWelfareServiceDtoPagedResultDto implements IHealthSocialWelfareServiceDtoPagedResultDto {
    items!: HealthSocialWelfareServiceDto[] | undefined;
    totalCount!: number;

    constructor(data?: IHealthSocialWelfareServiceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HealthSocialWelfareServiceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): HealthSocialWelfareServiceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HealthSocialWelfareServiceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): HealthSocialWelfareServiceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HealthSocialWelfareServiceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHealthSocialWelfareServiceDtoPagedResultDto {
    items: HealthSocialWelfareServiceDto[] | undefined;
    totalCount: number;
}

export class HeatingSystemBaseDto implements IHeatingSystemBaseDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IHeatingSystemBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): HeatingSystemBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new HeatingSystemBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): HeatingSystemBaseDto {
        const json = this.toJSON();
        let result = new HeatingSystemBaseDto();
        result.init(json);
        return result;
    }
}

export interface IHeatingSystemBaseDto {
    id: number;
    name: string | undefined;
}

export class HeatingSystemDto implements IHeatingSystemDto {
    id!: number;
    name!: string | undefined;
    plantType!: DictionaryDto;
    fuelType!: DictionaryDto;
    fuel!: DictionaryDto;
    plantConformityDeclaration!: boolean;
    plantConformityDeclarationFile!: FileDto;
    plantBookletPresent!: boolean;
    plantBookletPresentFile!: FileDto;
    performanceVerification!: boolean;
    cadenceOfChange!: DictionaryDto;
    lastVerificationDate!: moment.Moment | undefined;
    maintenanceContract!: boolean;
    maintenanceCompany!: string | undefined;
    maintenanceFile!: FileDto;
    lastMaintenanceDate!: moment.Moment | undefined;
    outsiderResponsible!: boolean;
    appointedCompany!: string | undefined;
    cpi!: boolean;
    cpiMonth!: DictionaryDto;
    notes!: string | undefined;

    constructor(data?: IHeatingSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.plantType = _data["plantType"] ? DictionaryDto.fromJS(_data["plantType"]) : undefined as any;
            this.fuelType = _data["fuelType"] ? DictionaryDto.fromJS(_data["fuelType"]) : undefined as any;
            this.fuel = _data["fuel"] ? DictionaryDto.fromJS(_data["fuel"]) : undefined as any;
            this.plantConformityDeclaration = _data["plantConformityDeclaration"];
            this.plantConformityDeclarationFile = _data["plantConformityDeclarationFile"] ? FileDto.fromJS(_data["plantConformityDeclarationFile"]) : undefined as any;
            this.plantBookletPresent = _data["plantBookletPresent"];
            this.plantBookletPresentFile = _data["plantBookletPresentFile"] ? FileDto.fromJS(_data["plantBookletPresentFile"]) : undefined as any;
            this.performanceVerification = _data["performanceVerification"];
            this.cadenceOfChange = _data["cadenceOfChange"] ? DictionaryDto.fromJS(_data["cadenceOfChange"]) : undefined as any;
            this.lastVerificationDate = _data["lastVerificationDate"] ? moment(_data["lastVerificationDate"].toString()) : undefined as any;
            this.maintenanceContract = _data["maintenanceContract"];
            this.maintenanceCompany = _data["maintenanceCompany"];
            this.maintenanceFile = _data["maintenanceFile"] ? FileDto.fromJS(_data["maintenanceFile"]) : undefined as any;
            this.lastMaintenanceDate = _data["lastMaintenanceDate"] ? moment(_data["lastMaintenanceDate"].toString()) : undefined as any;
            this.outsiderResponsible = _data["outsiderResponsible"];
            this.appointedCompany = _data["appointedCompany"];
            this.cpi = _data["cpi"];
            this.cpiMonth = _data["cpiMonth"] ? DictionaryDto.fromJS(_data["cpiMonth"]) : undefined as any;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): HeatingSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new HeatingSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["plantType"] = this.plantType ? this.plantType.toJSON() : undefined as any;
        data["fuelType"] = this.fuelType ? this.fuelType.toJSON() : undefined as any;
        data["fuel"] = this.fuel ? this.fuel.toJSON() : undefined as any;
        data["plantConformityDeclaration"] = this.plantConformityDeclaration;
        data["plantConformityDeclarationFile"] = this.plantConformityDeclarationFile ? this.plantConformityDeclarationFile.toJSON() : undefined as any;
        data["plantBookletPresent"] = this.plantBookletPresent;
        data["plantBookletPresentFile"] = this.plantBookletPresentFile ? this.plantBookletPresentFile.toJSON() : undefined as any;
        data["performanceVerification"] = this.performanceVerification;
        data["cadenceOfChange"] = this.cadenceOfChange ? this.cadenceOfChange.toJSON() : undefined as any;
        data["lastVerificationDate"] = this.lastVerificationDate ? this.lastVerificationDate.toISOString() : undefined as any;
        data["maintenanceContract"] = this.maintenanceContract;
        data["maintenanceCompany"] = this.maintenanceCompany;
        data["maintenanceFile"] = this.maintenanceFile ? this.maintenanceFile.toJSON() : undefined as any;
        data["lastMaintenanceDate"] = this.lastMaintenanceDate ? this.lastMaintenanceDate.toISOString() : undefined as any;
        data["outsiderResponsible"] = this.outsiderResponsible;
        data["appointedCompany"] = this.appointedCompany;
        data["cpi"] = this.cpi;
        data["cpiMonth"] = this.cpiMonth ? this.cpiMonth.toJSON() : undefined as any;
        data["notes"] = this.notes;
        return data;
    }

    clone(): HeatingSystemDto {
        const json = this.toJSON();
        let result = new HeatingSystemDto();
        result.init(json);
        return result;
    }
}

export interface IHeatingSystemDto {
    id: number;
    name: string | undefined;
    plantType: DictionaryDto;
    fuelType: DictionaryDto;
    fuel: DictionaryDto;
    plantConformityDeclaration: boolean;
    plantConformityDeclarationFile: FileDto;
    plantBookletPresent: boolean;
    plantBookletPresentFile: FileDto;
    performanceVerification: boolean;
    cadenceOfChange: DictionaryDto;
    lastVerificationDate: moment.Moment | undefined;
    maintenanceContract: boolean;
    maintenanceCompany: string | undefined;
    maintenanceFile: FileDto;
    lastMaintenanceDate: moment.Moment | undefined;
    outsiderResponsible: boolean;
    appointedCompany: string | undefined;
    cpi: boolean;
    cpiMonth: DictionaryDto;
    notes: string | undefined;
}

export class HeatingSystemDtoPagedResultDto implements IHeatingSystemDtoPagedResultDto {
    items!: HeatingSystemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IHeatingSystemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HeatingSystemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): HeatingSystemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HeatingSystemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): HeatingSystemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HeatingSystemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHeatingSystemDtoPagedResultDto {
    items: HeatingSystemDto[] | undefined;
    totalCount: number;
}

export class HistoricalCaseDto implements IHistoricalCaseDto {
    id!: number;
    scope!: DictionaryDto;
    description!: string | undefined;

    constructor(data?: IHistoricalCaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scope = _data["scope"] ? DictionaryDto.fromJS(_data["scope"]) : undefined as any;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): HistoricalCaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricalCaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scope"] = this.scope ? this.scope.toJSON() : undefined as any;
        data["description"] = this.description;
        return data;
    }

    clone(): HistoricalCaseDto {
        const json = this.toJSON();
        let result = new HistoricalCaseDto();
        result.init(json);
        return result;
    }
}

export interface IHistoricalCaseDto {
    id: number;
    scope: DictionaryDto;
    description: string | undefined;
}

export class HistoricalCaseDtoPagedResultDto implements IHistoricalCaseDtoPagedResultDto {
    items!: HistoricalCaseDto[] | undefined;
    totalCount!: number;

    constructor(data?: IHistoricalCaseDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HistoricalCaseDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): HistoricalCaseDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricalCaseDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): HistoricalCaseDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HistoricalCaseDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHistoricalCaseDtoPagedResultDto {
    items: HistoricalCaseDto[] | undefined;
    totalCount: number;
}

export class HousingSituationDto implements IHousingSituationDto {
    id!: number;
    possession!: boolean | undefined;
    environmentalHygienicCondition!: boolean | undefined;
    locationType!: DictionaryDto;
    relationship!: string | undefined;

    constructor(data?: IHousingSituationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.possession = _data["possession"];
            this.environmentalHygienicCondition = _data["environmentalHygienicCondition"];
            this.locationType = _data["locationType"] ? DictionaryDto.fromJS(_data["locationType"]) : undefined as any;
            this.relationship = _data["relationship"];
        }
    }

    static fromJS(data: any): HousingSituationDto {
        data = typeof data === 'object' ? data : {};
        let result = new HousingSituationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["possession"] = this.possession;
        data["environmentalHygienicCondition"] = this.environmentalHygienicCondition;
        data["locationType"] = this.locationType ? this.locationType.toJSON() : undefined as any;
        data["relationship"] = this.relationship;
        return data;
    }

    clone(): HousingSituationDto {
        const json = this.toJSON();
        let result = new HousingSituationDto();
        result.init(json);
        return result;
    }
}

export interface IHousingSituationDto {
    id: number;
    possession: boolean | undefined;
    environmentalHygienicCondition: boolean | undefined;
    locationType: DictionaryDto;
    relationship: string | undefined;
}

export class HousingSituationDtoPagedResultDto implements IHousingSituationDtoPagedResultDto {
    items!: HousingSituationDto[] | undefined;
    totalCount!: number;

    constructor(data?: IHousingSituationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HousingSituationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): HousingSituationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HousingSituationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): HousingSituationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HousingSituationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHousingSituationDtoPagedResultDto {
    items: HousingSituationDto[] | undefined;
    totalCount: number;
}

export class HydraulicSystemBaseDto implements IHydraulicSystemBaseDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IHydraulicSystemBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): HydraulicSystemBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new HydraulicSystemBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): HydraulicSystemBaseDto {
        const json = this.toJSON();
        let result = new HydraulicSystemBaseDto();
        result.init(json);
        return result;
    }
}

export interface IHydraulicSystemBaseDto {
    id: number;
    name: string | undefined;
}

export class HydraulicSystemDto implements IHydraulicSystemDto {
    id!: number;
    name!: string | undefined;
    project!: boolean;
    projectFile!: FileDto;
    lastLegionellaeCheck!: moment.Moment | undefined;
    lastWaterSafetyCheck!: moment.Moment | undefined;
    notes!: string | undefined;

    constructor(data?: IHydraulicSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.project = _data["project"];
            this.projectFile = _data["projectFile"] ? FileDto.fromJS(_data["projectFile"]) : undefined as any;
            this.lastLegionellaeCheck = _data["lastLegionellaeCheck"] ? moment(_data["lastLegionellaeCheck"].toString()) : undefined as any;
            this.lastWaterSafetyCheck = _data["lastWaterSafetyCheck"] ? moment(_data["lastWaterSafetyCheck"].toString()) : undefined as any;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): HydraulicSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new HydraulicSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["project"] = this.project;
        data["projectFile"] = this.projectFile ? this.projectFile.toJSON() : undefined as any;
        data["lastLegionellaeCheck"] = this.lastLegionellaeCheck ? this.lastLegionellaeCheck.toISOString() : undefined as any;
        data["lastWaterSafetyCheck"] = this.lastWaterSafetyCheck ? this.lastWaterSafetyCheck.toISOString() : undefined as any;
        data["notes"] = this.notes;
        return data;
    }

    clone(): HydraulicSystemDto {
        const json = this.toJSON();
        let result = new HydraulicSystemDto();
        result.init(json);
        return result;
    }
}

export interface IHydraulicSystemDto {
    id: number;
    name: string | undefined;
    project: boolean;
    projectFile: FileDto;
    lastLegionellaeCheck: moment.Moment | undefined;
    lastWaterSafetyCheck: moment.Moment | undefined;
    notes: string | undefined;
}

export class HydraulicSystemDtoPagedResultDto implements IHydraulicSystemDtoPagedResultDto {
    items!: HydraulicSystemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IHydraulicSystemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HydraulicSystemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): HydraulicSystemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new HydraulicSystemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): HydraulicSystemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new HydraulicSystemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IHydraulicSystemDtoPagedResultDto {
    items: HydraulicSystemDto[] | undefined;
    totalCount: number;
}

export class IdentityError implements IIdentityError {
    code!: string | undefined;
    description!: string | undefined;

    constructor(data?: IIdentityError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): IdentityError {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }

    clone(): IdentityError {
        const json = this.toJSON();
        let result = new IdentityError();
        result.init(json);
        return result;
    }
}

export interface IIdentityError {
    code: string | undefined;
    description: string | undefined;
}

export class IdentityResult implements IIdentityResult {
    readonly succeeded!: boolean;
    readonly errors!: IdentityError[] | undefined;

    constructor(data?: IIdentityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                (this as any).errors = [] as any;
                for (let item of _data["errors"])
                    (this as any).errors!.push(IdentityError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IdentityResult {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): IdentityResult {
        const json = this.toJSON();
        let result = new IdentityResult();
        result.init(json);
        return result;
    }
}

export interface IIdentityResult {
    succeeded: boolean;
    errors: IdentityError[] | undefined;
}

export class IncomeAllowanceDto implements IIncomeAllowanceDto {
    id!: number;
    disabilityRate!: number;
    placeableWork!: boolean | undefined;
    protectedCategories!: boolean | undefined;
    inailDisability!: boolean | undefined;
    disabilityType!: DictionaryDto;
    practicesInProgress!: boolean | undefined;
    allowanceAccompanying!: boolean | undefined;
    note!: string | undefined;

    constructor(data?: IIncomeAllowanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.disabilityRate = _data["disabilityRate"];
            this.placeableWork = _data["placeableWork"];
            this.protectedCategories = _data["protectedCategories"];
            this.inailDisability = _data["inailDisability"];
            this.disabilityType = _data["disabilityType"] ? DictionaryDto.fromJS(_data["disabilityType"]) : undefined as any;
            this.practicesInProgress = _data["practicesInProgress"];
            this.allowanceAccompanying = _data["allowanceAccompanying"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): IncomeAllowanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeAllowanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["disabilityRate"] = this.disabilityRate;
        data["placeableWork"] = this.placeableWork;
        data["protectedCategories"] = this.protectedCategories;
        data["inailDisability"] = this.inailDisability;
        data["disabilityType"] = this.disabilityType ? this.disabilityType.toJSON() : undefined as any;
        data["practicesInProgress"] = this.practicesInProgress;
        data["allowanceAccompanying"] = this.allowanceAccompanying;
        data["note"] = this.note;
        return data;
    }

    clone(): IncomeAllowanceDto {
        const json = this.toJSON();
        let result = new IncomeAllowanceDto();
        result.init(json);
        return result;
    }
}

export interface IIncomeAllowanceDto {
    id: number;
    disabilityRate: number;
    placeableWork: boolean | undefined;
    protectedCategories: boolean | undefined;
    inailDisability: boolean | undefined;
    disabilityType: DictionaryDto;
    practicesInProgress: boolean | undefined;
    allowanceAccompanying: boolean | undefined;
    note: string | undefined;
}

export class IncomeAllowanceDtoPagedResultDto implements IIncomeAllowanceDtoPagedResultDto {
    items!: IncomeAllowanceDto[] | undefined;
    totalCount!: number;

    constructor(data?: IIncomeAllowanceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IncomeAllowanceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): IncomeAllowanceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeAllowanceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): IncomeAllowanceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new IncomeAllowanceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IIncomeAllowanceDtoPagedResultDto {
    items: IncomeAllowanceDto[] | undefined;
    totalCount: number;
}

export class InformationAccreditationDto implements IInformationAccreditationDto {
    id!: number;
    insertionDate!: moment.Moment | undefined;
    mmg!: string | undefined;
    dss!: string | undefined;
    municipalSocialService!: MunicipalityDto;
    neurologicalDisorders!: string | undefined;
    psychiatricDisorders!: string | undefined;
    arterialHypertension!: boolean | undefined;
    diabetesMellitus!: boolean | undefined;
    osteoporosis!: boolean | undefined;
    sphincterIncontinence!: string | undefined;
    allergies!: string | undefined;
    foodIntolerances!: string | undefined;
    sensoryMotorDisorders!: string | undefined;

    constructor(data?: IInformationAccreditationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.insertionDate = _data["insertionDate"] ? moment(_data["insertionDate"].toString()) : undefined as any;
            this.mmg = _data["mmg"];
            this.dss = _data["dss"];
            this.municipalSocialService = _data["municipalSocialService"] ? MunicipalityDto.fromJS(_data["municipalSocialService"]) : undefined as any;
            this.neurologicalDisorders = _data["neurologicalDisorders"];
            this.psychiatricDisorders = _data["psychiatricDisorders"];
            this.arterialHypertension = _data["arterialHypertension"];
            this.diabetesMellitus = _data["diabetesMellitus"];
            this.osteoporosis = _data["osteoporosis"];
            this.sphincterIncontinence = _data["sphincterIncontinence"];
            this.allergies = _data["allergies"];
            this.foodIntolerances = _data["foodIntolerances"];
            this.sensoryMotorDisorders = _data["sensoryMotorDisorders"];
        }
    }

    static fromJS(data: any): InformationAccreditationDto {
        data = typeof data === 'object' ? data : {};
        let result = new InformationAccreditationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["insertionDate"] = this.insertionDate ? this.insertionDate.toISOString() : undefined as any;
        data["mmg"] = this.mmg;
        data["dss"] = this.dss;
        data["municipalSocialService"] = this.municipalSocialService ? this.municipalSocialService.toJSON() : undefined as any;
        data["neurologicalDisorders"] = this.neurologicalDisorders;
        data["psychiatricDisorders"] = this.psychiatricDisorders;
        data["arterialHypertension"] = this.arterialHypertension;
        data["diabetesMellitus"] = this.diabetesMellitus;
        data["osteoporosis"] = this.osteoporosis;
        data["sphincterIncontinence"] = this.sphincterIncontinence;
        data["allergies"] = this.allergies;
        data["foodIntolerances"] = this.foodIntolerances;
        data["sensoryMotorDisorders"] = this.sensoryMotorDisorders;
        return data;
    }

    clone(): InformationAccreditationDto {
        const json = this.toJSON();
        let result = new InformationAccreditationDto();
        result.init(json);
        return result;
    }
}

export interface IInformationAccreditationDto {
    id: number;
    insertionDate: moment.Moment | undefined;
    mmg: string | undefined;
    dss: string | undefined;
    municipalSocialService: MunicipalityDto;
    neurologicalDisorders: string | undefined;
    psychiatricDisorders: string | undefined;
    arterialHypertension: boolean | undefined;
    diabetesMellitus: boolean | undefined;
    osteoporosis: boolean | undefined;
    sphincterIncontinence: string | undefined;
    allergies: string | undefined;
    foodIntolerances: string | undefined;
    sensoryMotorDisorders: string | undefined;
}

export class InformationAccreditationDtoPagedResultDto implements IInformationAccreditationDtoPagedResultDto {
    items!: InformationAccreditationDto[] | undefined;
    totalCount!: number;

    constructor(data?: IInformationAccreditationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InformationAccreditationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InformationAccreditationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InformationAccreditationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InformationAccreditationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InformationAccreditationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInformationAccreditationDtoPagedResultDto {
    items: InformationAccreditationDto[] | undefined;
    totalCount: number;
}

export class InputCardRecordDto implements IInputCardRecordDto {
    id!: number;
    schoolWorks!: SchoolWorkDto[] | undefined;
    autonomy!: AutonomyDto;
    healthSocialWelfareService!: HealthSocialWelfareServiceDto;
    personalDataFamilyMembers!: PersonalDataFamilyMemberDto[] | undefined;
    personalData!: PersonalDataDto;
    familyReferences!: FamilyReferenceDto[] | undefined;
    socialAssistanceReferences!: SocialAssistanceReferenceDto[] | undefined;
    otherReferences!: OtherReferenceDto[] | undefined;
    disabilities!: DisabilityDto[] | undefined;
    healthAspect!: HealthAspectDto;
    administrativeLegalArea!: AdministrativeLegalAreaDto;
    umvDs!: UMVDDto[] | undefined;
    occupations!: OccupationDto[] | undefined;

    constructor(data?: IInputCardRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["schoolWorks"])) {
                this.schoolWorks = [] as any;
                for (let item of _data["schoolWorks"])
                    this.schoolWorks!.push(SchoolWorkDto.fromJS(item));
            }
            this.autonomy = _data["autonomy"] ? AutonomyDto.fromJS(_data["autonomy"]) : undefined as any;
            this.healthSocialWelfareService = _data["healthSocialWelfareService"] ? HealthSocialWelfareServiceDto.fromJS(_data["healthSocialWelfareService"]) : undefined as any;
            if (Array.isArray(_data["personalDataFamilyMembers"])) {
                this.personalDataFamilyMembers = [] as any;
                for (let item of _data["personalDataFamilyMembers"])
                    this.personalDataFamilyMembers!.push(PersonalDataFamilyMemberDto.fromJS(item));
            }
            this.personalData = _data["personalData"] ? PersonalDataDto.fromJS(_data["personalData"]) : undefined as any;
            if (Array.isArray(_data["familyReferences"])) {
                this.familyReferences = [] as any;
                for (let item of _data["familyReferences"])
                    this.familyReferences!.push(FamilyReferenceDto.fromJS(item));
            }
            if (Array.isArray(_data["socialAssistanceReferences"])) {
                this.socialAssistanceReferences = [] as any;
                for (let item of _data["socialAssistanceReferences"])
                    this.socialAssistanceReferences!.push(SocialAssistanceReferenceDto.fromJS(item));
            }
            if (Array.isArray(_data["otherReferences"])) {
                this.otherReferences = [] as any;
                for (let item of _data["otherReferences"])
                    this.otherReferences!.push(OtherReferenceDto.fromJS(item));
            }
            if (Array.isArray(_data["disabilities"])) {
                this.disabilities = [] as any;
                for (let item of _data["disabilities"])
                    this.disabilities!.push(DisabilityDto.fromJS(item));
            }
            this.healthAspect = _data["healthAspect"] ? HealthAspectDto.fromJS(_data["healthAspect"]) : undefined as any;
            this.administrativeLegalArea = _data["administrativeLegalArea"] ? AdministrativeLegalAreaDto.fromJS(_data["administrativeLegalArea"]) : undefined as any;
            if (Array.isArray(_data["umvDs"])) {
                this.umvDs = [] as any;
                for (let item of _data["umvDs"])
                    this.umvDs!.push(UMVDDto.fromJS(item));
            }
            if (Array.isArray(_data["occupations"])) {
                this.occupations = [] as any;
                for (let item of _data["occupations"])
                    this.occupations!.push(OccupationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InputCardRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputCardRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.schoolWorks)) {
            data["schoolWorks"] = [];
            for (let item of this.schoolWorks)
                data["schoolWorks"].push(item ? item.toJSON() : undefined as any);
        }
        data["autonomy"] = this.autonomy ? this.autonomy.toJSON() : undefined as any;
        data["healthSocialWelfareService"] = this.healthSocialWelfareService ? this.healthSocialWelfareService.toJSON() : undefined as any;
        if (Array.isArray(this.personalDataFamilyMembers)) {
            data["personalDataFamilyMembers"] = [];
            for (let item of this.personalDataFamilyMembers)
                data["personalDataFamilyMembers"].push(item ? item.toJSON() : undefined as any);
        }
        data["personalData"] = this.personalData ? this.personalData.toJSON() : undefined as any;
        if (Array.isArray(this.familyReferences)) {
            data["familyReferences"] = [];
            for (let item of this.familyReferences)
                data["familyReferences"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.socialAssistanceReferences)) {
            data["socialAssistanceReferences"] = [];
            for (let item of this.socialAssistanceReferences)
                data["socialAssistanceReferences"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.otherReferences)) {
            data["otherReferences"] = [];
            for (let item of this.otherReferences)
                data["otherReferences"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.disabilities)) {
            data["disabilities"] = [];
            for (let item of this.disabilities)
                data["disabilities"].push(item ? item.toJSON() : undefined as any);
        }
        data["healthAspect"] = this.healthAspect ? this.healthAspect.toJSON() : undefined as any;
        data["administrativeLegalArea"] = this.administrativeLegalArea ? this.administrativeLegalArea.toJSON() : undefined as any;
        if (Array.isArray(this.umvDs)) {
            data["umvDs"] = [];
            for (let item of this.umvDs)
                data["umvDs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.occupations)) {
            data["occupations"] = [];
            for (let item of this.occupations)
                data["occupations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): InputCardRecordDto {
        const json = this.toJSON();
        let result = new InputCardRecordDto();
        result.init(json);
        return result;
    }
}

export interface IInputCardRecordDto {
    id: number;
    schoolWorks: SchoolWorkDto[] | undefined;
    autonomy: AutonomyDto;
    healthSocialWelfareService: HealthSocialWelfareServiceDto;
    personalDataFamilyMembers: PersonalDataFamilyMemberDto[] | undefined;
    personalData: PersonalDataDto;
    familyReferences: FamilyReferenceDto[] | undefined;
    socialAssistanceReferences: SocialAssistanceReferenceDto[] | undefined;
    otherReferences: OtherReferenceDto[] | undefined;
    disabilities: DisabilityDto[] | undefined;
    healthAspect: HealthAspectDto;
    administrativeLegalArea: AdministrativeLegalAreaDto;
    umvDs: UMVDDto[] | undefined;
    occupations: OccupationDto[] | undefined;
}

export class InputCardRecordDtoPagedResultDto implements IInputCardRecordDtoPagedResultDto {
    items!: InputCardRecordDto[] | undefined;
    totalCount!: number;

    constructor(data?: IInputCardRecordDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InputCardRecordDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InputCardRecordDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputCardRecordDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InputCardRecordDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InputCardRecordDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInputCardRecordDtoPagedResultDto {
    items: InputCardRecordDto[] | undefined;
    totalCount: number;
}

export class IntegratedRehabilitationPlanRecordDto implements IIntegratedRehabilitationPlanRecordDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    startingSituation!: string | undefined;
    observationGridId!: number;
    observationGridDate!: moment.Moment | undefined;
    objectives!: ObjectiveDto[] | undefined;
    description!: string | undefined;
    protocolNumber!: string | undefined;
    isFinalReport!: boolean;
    creationTime!: moment.Moment;

    constructor(data?: IIntegratedRehabilitationPlanRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.startingSituation = _data["startingSituation"];
            this.observationGridId = _data["observationGridId"];
            this.observationGridDate = _data["observationGridDate"] ? moment(_data["observationGridDate"].toString()) : undefined as any;
            if (Array.isArray(_data["objectives"])) {
                this.objectives = [] as any;
                for (let item of _data["objectives"])
                    this.objectives!.push(ObjectiveDto.fromJS(item));
            }
            this.description = _data["description"];
            this.protocolNumber = _data["protocolNumber"];
            this.isFinalReport = _data["isFinalReport"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): IntegratedRehabilitationPlanRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegratedRehabilitationPlanRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["startingSituation"] = this.startingSituation;
        data["observationGridId"] = this.observationGridId;
        data["observationGridDate"] = this.observationGridDate ? this.observationGridDate.toISOString() : undefined as any;
        if (Array.isArray(this.objectives)) {
            data["objectives"] = [];
            for (let item of this.objectives)
                data["objectives"].push(item ? item.toJSON() : undefined as any);
        }
        data["description"] = this.description;
        data["protocolNumber"] = this.protocolNumber;
        data["isFinalReport"] = this.isFinalReport;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        return data;
    }

    clone(): IntegratedRehabilitationPlanRecordDto {
        const json = this.toJSON();
        let result = new IntegratedRehabilitationPlanRecordDto();
        result.init(json);
        return result;
    }
}

export interface IIntegratedRehabilitationPlanRecordDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    startingSituation: string | undefined;
    observationGridId: number;
    observationGridDate: moment.Moment | undefined;
    objectives: ObjectiveDto[] | undefined;
    description: string | undefined;
    protocolNumber: string | undefined;
    isFinalReport: boolean;
    creationTime: moment.Moment;
}

export class IntegratedRehabilitationPlanRecordDtoPagedResultDto implements IIntegratedRehabilitationPlanRecordDtoPagedResultDto {
    items!: IntegratedRehabilitationPlanRecordDto[] | undefined;
    totalCount!: number;

    constructor(data?: IIntegratedRehabilitationPlanRecordDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IntegratedRehabilitationPlanRecordDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): IntegratedRehabilitationPlanRecordDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegratedRehabilitationPlanRecordDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): IntegratedRehabilitationPlanRecordDtoPagedResultDto {
        const json = this.toJSON();
        let result = new IntegratedRehabilitationPlanRecordDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IIntegratedRehabilitationPlanRecordDtoPagedResultDto {
    items: IntegratedRehabilitationPlanRecordDto[] | undefined;
    totalCount: number;
}

export class InterviewParticipantsRecordDto implements IInterviewParticipantsRecordDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    equipe!: ServiceUserDto[] | undefined;
    relatives!: RelativeDto[] | undefined;

    constructor(data?: IInterviewParticipantsRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            if (Array.isArray(_data["equipe"])) {
                this.equipe = [] as any;
                for (let item of _data["equipe"])
                    this.equipe!.push(ServiceUserDto.fromJS(item));
            }
            if (Array.isArray(_data["relatives"])) {
                this.relatives = [] as any;
                for (let item of _data["relatives"])
                    this.relatives!.push(RelativeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InterviewParticipantsRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new InterviewParticipantsRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        if (Array.isArray(this.equipe)) {
            data["equipe"] = [];
            for (let item of this.equipe)
                data["equipe"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.relatives)) {
            data["relatives"] = [];
            for (let item of this.relatives)
                data["relatives"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): InterviewParticipantsRecordDto {
        const json = this.toJSON();
        let result = new InterviewParticipantsRecordDto();
        result.init(json);
        return result;
    }
}

export interface IInterviewParticipantsRecordDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    equipe: ServiceUserDto[] | undefined;
    relatives: RelativeDto[] | undefined;
}

export class InterviewParticipantsRecordDtoPagedResultDto implements IInterviewParticipantsRecordDtoPagedResultDto {
    items!: InterviewParticipantsRecordDto[] | undefined;
    totalCount!: number;

    constructor(data?: IInterviewParticipantsRecordDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InterviewParticipantsRecordDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): InterviewParticipantsRecordDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new InterviewParticipantsRecordDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): InterviewParticipantsRecordDtoPagedResultDto {
        const json = this.toJSON();
        let result = new InterviewParticipantsRecordDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IInterviewParticipantsRecordDtoPagedResultDto {
    items: InterviewParticipantsRecordDto[] | undefined;
    totalCount: number;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyUrl!: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyUrl = _data["tenancyUrl"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyUrl"] = this.tenancyUrl;
        return data;
    }

    clone(): IsTenantAvailableInput {
        const json = this.toJSON();
        let result = new IsTenantAvailableInput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableInput {
    tenancyUrl: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state!: TenantAvailabilityState;
    cookiesPolicyUrl!: string | undefined;
    privacyPolicyUrl!: string | undefined;
    termsOfServiceUrl!: string | undefined;
    tenantId!: number | undefined;
    tenancyName!: string | undefined;
    siteId!: string | undefined;
    cookiePolityId!: string | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.cookiesPolicyUrl = _data["cookiesPolicyUrl"];
            this.privacyPolicyUrl = _data["privacyPolicyUrl"];
            this.termsOfServiceUrl = _data["termsOfServiceUrl"];
            this.tenantId = _data["tenantId"];
            this.tenancyName = _data["tenancyName"];
            this.siteId = _data["siteId"];
            this.cookiePolityId = _data["cookiePolityId"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["cookiesPolicyUrl"] = this.cookiesPolicyUrl;
        data["privacyPolicyUrl"] = this.privacyPolicyUrl;
        data["termsOfServiceUrl"] = this.termsOfServiceUrl;
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["siteId"] = this.siteId;
        data["cookiePolityId"] = this.cookiePolityId;
        return data;
    }

    clone(): IsTenantAvailableOutput {
        const json = this.toJSON();
        let result = new IsTenantAvailableOutput();
        result.init(json);
        return result;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    cookiesPolicyUrl: string | undefined;
    privacyPolicyUrl: string | undefined;
    termsOfServiceUrl: string | undefined;
    tenantId: number | undefined;
    tenancyName: string | undefined;
    siteId: string | undefined;
    cookiePolityId: string | undefined;
}

export class LifelineSystemBaseDto implements ILifelineSystemBaseDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: ILifelineSystemBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LifelineSystemBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new LifelineSystemBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): LifelineSystemBaseDto {
        const json = this.toJSON();
        let result = new LifelineSystemBaseDto();
        result.init(json);
        return result;
    }
}

export interface ILifelineSystemBaseDto {
    id: number;
    name: string | undefined;
}

export class LifelineSystemDto implements ILifelineSystemDto {
    id!: number;
    name!: string | undefined;
    project!: boolean;
    projectFile!: FileDto;
    lastVerificationDate!: moment.Moment | undefined;
    verificationCadence!: DictionaryDto;
    maintenanceContract!: boolean;
    maintenanceCompany!: string | undefined;
    maintenanceFile!: FileDto;
    lastMaintenanceDate!: moment.Moment | undefined;
    appointedCompany!: string | undefined;
    outsiderResponsible!: boolean;
    notes!: string | undefined;

    constructor(data?: ILifelineSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.project = _data["project"];
            this.projectFile = _data["projectFile"] ? FileDto.fromJS(_data["projectFile"]) : undefined as any;
            this.lastVerificationDate = _data["lastVerificationDate"] ? moment(_data["lastVerificationDate"].toString()) : undefined as any;
            this.verificationCadence = _data["verificationCadence"] ? DictionaryDto.fromJS(_data["verificationCadence"]) : undefined as any;
            this.maintenanceContract = _data["maintenanceContract"];
            this.maintenanceCompany = _data["maintenanceCompany"];
            this.maintenanceFile = _data["maintenanceFile"] ? FileDto.fromJS(_data["maintenanceFile"]) : undefined as any;
            this.lastMaintenanceDate = _data["lastMaintenanceDate"] ? moment(_data["lastMaintenanceDate"].toString()) : undefined as any;
            this.appointedCompany = _data["appointedCompany"];
            this.outsiderResponsible = _data["outsiderResponsible"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): LifelineSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LifelineSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["project"] = this.project;
        data["projectFile"] = this.projectFile ? this.projectFile.toJSON() : undefined as any;
        data["lastVerificationDate"] = this.lastVerificationDate ? this.lastVerificationDate.toISOString() : undefined as any;
        data["verificationCadence"] = this.verificationCadence ? this.verificationCadence.toJSON() : undefined as any;
        data["maintenanceContract"] = this.maintenanceContract;
        data["maintenanceCompany"] = this.maintenanceCompany;
        data["maintenanceFile"] = this.maintenanceFile ? this.maintenanceFile.toJSON() : undefined as any;
        data["lastMaintenanceDate"] = this.lastMaintenanceDate ? this.lastMaintenanceDate.toISOString() : undefined as any;
        data["appointedCompany"] = this.appointedCompany;
        data["outsiderResponsible"] = this.outsiderResponsible;
        data["notes"] = this.notes;
        return data;
    }

    clone(): LifelineSystemDto {
        const json = this.toJSON();
        let result = new LifelineSystemDto();
        result.init(json);
        return result;
    }
}

export interface ILifelineSystemDto {
    id: number;
    name: string | undefined;
    project: boolean;
    projectFile: FileDto;
    lastVerificationDate: moment.Moment | undefined;
    verificationCadence: DictionaryDto;
    maintenanceContract: boolean;
    maintenanceCompany: string | undefined;
    maintenanceFile: FileDto;
    lastMaintenanceDate: moment.Moment | undefined;
    appointedCompany: string | undefined;
    outsiderResponsible: boolean;
    notes: string | undefined;
}

export class LifelineSystemDtoPagedResultDto implements ILifelineSystemDtoPagedResultDto {
    items!: LifelineSystemDto[] | undefined;
    totalCount!: number;

    constructor(data?: ILifelineSystemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LifelineSystemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): LifelineSystemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LifelineSystemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): LifelineSystemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new LifelineSystemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ILifelineSystemDtoPagedResultDto {
    items: LifelineSystemDto[] | undefined;
    totalCount: number;
}

export class LinkedServiceDiaryDto implements ILinkedServiceDiaryDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    serviceId!: number;
    serviceName!: string | undefined;

    constructor(data?: ILinkedServiceDiaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.serviceId = _data["serviceId"];
            this.serviceName = _data["serviceName"];
        }
    }

    static fromJS(data: any): LinkedServiceDiaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedServiceDiaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["serviceId"] = this.serviceId;
        data["serviceName"] = this.serviceName;
        return data;
    }

    clone(): LinkedServiceDiaryDto {
        const json = this.toJSON();
        let result = new LinkedServiceDiaryDto();
        result.init(json);
        return result;
    }
}

export interface ILinkedServiceDiaryDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    serviceId: number;
    serviceName: string | undefined;
}

export class LinkedServiceDiaryDtoPagedResultDto implements ILinkedServiceDiaryDtoPagedResultDto {
    items!: LinkedServiceDiaryDto[] | undefined;
    totalCount!: number;

    constructor(data?: ILinkedServiceDiaryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LinkedServiceDiaryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): LinkedServiceDiaryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedServiceDiaryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): LinkedServiceDiaryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new LinkedServiceDiaryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ILinkedServiceDiaryDtoPagedResultDto {
    items: LinkedServiceDiaryDto[] | undefined;
    totalCount: number;
}

export class MaintenanceEventDto implements IMaintenanceEventDto {
    id!: number;
    eventType!: DictionaryDto;
    date!: moment.Moment;
    provider!: string | undefined;
    amount!: number | undefined;
    note!: string | undefined;

    constructor(data?: IMaintenanceEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventType = _data["eventType"] ? DictionaryDto.fromJS(_data["eventType"]) : undefined as any;
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.provider = _data["provider"];
            this.amount = _data["amount"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): MaintenanceEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventType"] = this.eventType ? this.eventType.toJSON() : undefined as any;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["provider"] = this.provider;
        data["amount"] = this.amount;
        data["note"] = this.note;
        return data;
    }

    clone(): MaintenanceEventDto {
        const json = this.toJSON();
        let result = new MaintenanceEventDto();
        result.init(json);
        return result;
    }
}

export interface IMaintenanceEventDto {
    id: number;
    eventType: DictionaryDto;
    date: moment.Moment;
    provider: string | undefined;
    amount: number | undefined;
    note: string | undefined;
}

export class MaintenanceEventDtoPagedResultDto implements IMaintenanceEventDtoPagedResultDto {
    items!: MaintenanceEventDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMaintenanceEventDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MaintenanceEventDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MaintenanceEventDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceEventDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MaintenanceEventDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MaintenanceEventDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMaintenanceEventDtoPagedResultDto {
    items: MaintenanceEventDto[] | undefined;
    totalCount: number;
}

export class MonitoringRestraintConfirmationSignatureDto implements IMonitoringRestraintConfirmationSignatureDto {
    id!: number;
    monitoringRestraintRecord!: MonitoringRestraintRecordDto;
    signatureType!: DictionaryDto;
    isConfirmed!: boolean;
    confirmingUserId!: number | undefined;
    confirmationDate!: moment.Moment | undefined;
    confirmingUserFullName!: string | undefined;

    constructor(data?: IMonitoringRestraintConfirmationSignatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.monitoringRestraintRecord = _data["monitoringRestraintRecord"] ? MonitoringRestraintRecordDto.fromJS(_data["monitoringRestraintRecord"]) : undefined as any;
            this.signatureType = _data["signatureType"] ? DictionaryDto.fromJS(_data["signatureType"]) : undefined as any;
            this.isConfirmed = _data["isConfirmed"];
            this.confirmingUserId = _data["confirmingUserId"];
            this.confirmationDate = _data["confirmationDate"] ? moment(_data["confirmationDate"].toString()) : undefined as any;
            this.confirmingUserFullName = _data["confirmingUserFullName"];
        }
    }

    static fromJS(data: any): MonitoringRestraintConfirmationSignatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonitoringRestraintConfirmationSignatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["monitoringRestraintRecord"] = this.monitoringRestraintRecord ? this.monitoringRestraintRecord.toJSON() : undefined as any;
        data["signatureType"] = this.signatureType ? this.signatureType.toJSON() : undefined as any;
        data["isConfirmed"] = this.isConfirmed;
        data["confirmingUserId"] = this.confirmingUserId;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : undefined as any;
        data["confirmingUserFullName"] = this.confirmingUserFullName;
        return data;
    }

    clone(): MonitoringRestraintConfirmationSignatureDto {
        const json = this.toJSON();
        let result = new MonitoringRestraintConfirmationSignatureDto();
        result.init(json);
        return result;
    }
}

export interface IMonitoringRestraintConfirmationSignatureDto {
    id: number;
    monitoringRestraintRecord: MonitoringRestraintRecordDto;
    signatureType: DictionaryDto;
    isConfirmed: boolean;
    confirmingUserId: number | undefined;
    confirmationDate: moment.Moment | undefined;
    confirmingUserFullName: string | undefined;
}

export class MonitoringRestraintRecordDto implements IMonitoringRestraintRecordDto {
    id!: number;
    socialHealthRecordId!: number;
    date!: moment.Moment;
    startRestraint!: moment.Moment | undefined;
    mmse!: string | undefined;
    disorderNonCognitives!: DictionaryDto[] | undefined;
    conleyScale!: string | undefined;
    prescribedTypes!: DictionaryDto[] | undefined;
    bedriddenGuest!: string | undefined;
    sideRails!: string | undefined;
    prescribedTypeOther!: string | undefined;
    wheelchairUsers!: DictionaryDto[] | undefined;
    wheelchairUserOther!: string | undefined;
    bodySegments!: DictionaryDto[] | undefined;
    bodySegmentOther!: string | undefined;
    psychosocialSphereSyndromes!: DictionaryDto[] | undefined;
    nursingSphereSyndromes!: DictionaryDto[] | undefined;
    physiotherapySphereSyndromes!: DictionaryDto[] | undefined;
    notes!: string | undefined;
    signatures!: MonitoringRestraintConfirmationSignatureDto[] | undefined;

    constructor(data?: IMonitoringRestraintRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.startRestraint = _data["startRestraint"] ? moment(_data["startRestraint"].toString()) : undefined as any;
            this.mmse = _data["mmse"];
            if (Array.isArray(_data["disorderNonCognitives"])) {
                this.disorderNonCognitives = [] as any;
                for (let item of _data["disorderNonCognitives"])
                    this.disorderNonCognitives!.push(DictionaryDto.fromJS(item));
            }
            this.conleyScale = _data["conleyScale"];
            if (Array.isArray(_data["prescribedTypes"])) {
                this.prescribedTypes = [] as any;
                for (let item of _data["prescribedTypes"])
                    this.prescribedTypes!.push(DictionaryDto.fromJS(item));
            }
            this.bedriddenGuest = _data["bedriddenGuest"];
            this.sideRails = _data["sideRails"];
            this.prescribedTypeOther = _data["prescribedTypeOther"];
            if (Array.isArray(_data["wheelchairUsers"])) {
                this.wheelchairUsers = [] as any;
                for (let item of _data["wheelchairUsers"])
                    this.wheelchairUsers!.push(DictionaryDto.fromJS(item));
            }
            this.wheelchairUserOther = _data["wheelchairUserOther"];
            if (Array.isArray(_data["bodySegments"])) {
                this.bodySegments = [] as any;
                for (let item of _data["bodySegments"])
                    this.bodySegments!.push(DictionaryDto.fromJS(item));
            }
            this.bodySegmentOther = _data["bodySegmentOther"];
            if (Array.isArray(_data["psychosocialSphereSyndromes"])) {
                this.psychosocialSphereSyndromes = [] as any;
                for (let item of _data["psychosocialSphereSyndromes"])
                    this.psychosocialSphereSyndromes!.push(DictionaryDto.fromJS(item));
            }
            if (Array.isArray(_data["nursingSphereSyndromes"])) {
                this.nursingSphereSyndromes = [] as any;
                for (let item of _data["nursingSphereSyndromes"])
                    this.nursingSphereSyndromes!.push(DictionaryDto.fromJS(item));
            }
            if (Array.isArray(_data["physiotherapySphereSyndromes"])) {
                this.physiotherapySphereSyndromes = [] as any;
                for (let item of _data["physiotherapySphereSyndromes"])
                    this.physiotherapySphereSyndromes!.push(DictionaryDto.fromJS(item));
            }
            this.notes = _data["notes"];
            if (Array.isArray(_data["signatures"])) {
                this.signatures = [] as any;
                for (let item of _data["signatures"])
                    this.signatures!.push(MonitoringRestraintConfirmationSignatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MonitoringRestraintRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonitoringRestraintRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["startRestraint"] = this.startRestraint ? this.startRestraint.toISOString() : undefined as any;
        data["mmse"] = this.mmse;
        if (Array.isArray(this.disorderNonCognitives)) {
            data["disorderNonCognitives"] = [];
            for (let item of this.disorderNonCognitives)
                data["disorderNonCognitives"].push(item ? item.toJSON() : undefined as any);
        }
        data["conleyScale"] = this.conleyScale;
        if (Array.isArray(this.prescribedTypes)) {
            data["prescribedTypes"] = [];
            for (let item of this.prescribedTypes)
                data["prescribedTypes"].push(item ? item.toJSON() : undefined as any);
        }
        data["bedriddenGuest"] = this.bedriddenGuest;
        data["sideRails"] = this.sideRails;
        data["prescribedTypeOther"] = this.prescribedTypeOther;
        if (Array.isArray(this.wheelchairUsers)) {
            data["wheelchairUsers"] = [];
            for (let item of this.wheelchairUsers)
                data["wheelchairUsers"].push(item ? item.toJSON() : undefined as any);
        }
        data["wheelchairUserOther"] = this.wheelchairUserOther;
        if (Array.isArray(this.bodySegments)) {
            data["bodySegments"] = [];
            for (let item of this.bodySegments)
                data["bodySegments"].push(item ? item.toJSON() : undefined as any);
        }
        data["bodySegmentOther"] = this.bodySegmentOther;
        if (Array.isArray(this.psychosocialSphereSyndromes)) {
            data["psychosocialSphereSyndromes"] = [];
            for (let item of this.psychosocialSphereSyndromes)
                data["psychosocialSphereSyndromes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.nursingSphereSyndromes)) {
            data["nursingSphereSyndromes"] = [];
            for (let item of this.nursingSphereSyndromes)
                data["nursingSphereSyndromes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.physiotherapySphereSyndromes)) {
            data["physiotherapySphereSyndromes"] = [];
            for (let item of this.physiotherapySphereSyndromes)
                data["physiotherapySphereSyndromes"].push(item ? item.toJSON() : undefined as any);
        }
        data["notes"] = this.notes;
        if (Array.isArray(this.signatures)) {
            data["signatures"] = [];
            for (let item of this.signatures)
                data["signatures"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): MonitoringRestraintRecordDto {
        const json = this.toJSON();
        let result = new MonitoringRestraintRecordDto();
        result.init(json);
        return result;
    }
}

export interface IMonitoringRestraintRecordDto {
    id: number;
    socialHealthRecordId: number;
    date: moment.Moment;
    startRestraint: moment.Moment | undefined;
    mmse: string | undefined;
    disorderNonCognitives: DictionaryDto[] | undefined;
    conleyScale: string | undefined;
    prescribedTypes: DictionaryDto[] | undefined;
    bedriddenGuest: string | undefined;
    sideRails: string | undefined;
    prescribedTypeOther: string | undefined;
    wheelchairUsers: DictionaryDto[] | undefined;
    wheelchairUserOther: string | undefined;
    bodySegments: DictionaryDto[] | undefined;
    bodySegmentOther: string | undefined;
    psychosocialSphereSyndromes: DictionaryDto[] | undefined;
    nursingSphereSyndromes: DictionaryDto[] | undefined;
    physiotherapySphereSyndromes: DictionaryDto[] | undefined;
    notes: string | undefined;
    signatures: MonitoringRestraintConfirmationSignatureDto[] | undefined;
}

export class MonitoringRestraintRecordItemDto implements IMonitoringRestraintRecordItemDto {
    id!: number;
    date!: moment.Moment;
    socialHealthRecordId!: number;
    signatures!: MonitoringRestraintConfirmationSignatureDto[] | undefined;

    constructor(data?: IMonitoringRestraintRecordItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            if (Array.isArray(_data["signatures"])) {
                this.signatures = [] as any;
                for (let item of _data["signatures"])
                    this.signatures!.push(MonitoringRestraintConfirmationSignatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MonitoringRestraintRecordItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonitoringRestraintRecordItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        if (Array.isArray(this.signatures)) {
            data["signatures"] = [];
            for (let item of this.signatures)
                data["signatures"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): MonitoringRestraintRecordItemDto {
        const json = this.toJSON();
        let result = new MonitoringRestraintRecordItemDto();
        result.init(json);
        return result;
    }
}

export interface IMonitoringRestraintRecordItemDto {
    id: number;
    date: moment.Moment;
    socialHealthRecordId: number;
    signatures: MonitoringRestraintConfirmationSignatureDto[] | undefined;
}

export class MonitoringRestraintRecordItemDtoPagedResultDto implements IMonitoringRestraintRecordItemDtoPagedResultDto {
    items!: MonitoringRestraintRecordItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMonitoringRestraintRecordItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MonitoringRestraintRecordItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MonitoringRestraintRecordItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonitoringRestraintRecordItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MonitoringRestraintRecordItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MonitoringRestraintRecordItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMonitoringRestraintRecordItemDtoPagedResultDto {
    items: MonitoringRestraintRecordItemDto[] | undefined;
    totalCount: number;
}

export class MonthlyRehabilitationProgramNoteDto implements IMonthlyRehabilitationProgramNoteDto {
    id!: number;
    motivation!: string | undefined;
    isConfirmed!: boolean;
    confirmingUserId!: number | undefined;
    confirmationDate!: moment.Moment | undefined;
    confirmingUserFullName!: string | undefined;

    constructor(data?: IMonthlyRehabilitationProgramNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.motivation = _data["motivation"];
            this.isConfirmed = _data["isConfirmed"];
            this.confirmingUserId = _data["confirmingUserId"];
            this.confirmationDate = _data["confirmationDate"] ? moment(_data["confirmationDate"].toString()) : undefined as any;
            this.confirmingUserFullName = _data["confirmingUserFullName"];
        }
    }

    static fromJS(data: any): MonthlyRehabilitationProgramNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyRehabilitationProgramNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["motivation"] = this.motivation;
        data["isConfirmed"] = this.isConfirmed;
        data["confirmingUserId"] = this.confirmingUserId;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : undefined as any;
        data["confirmingUserFullName"] = this.confirmingUserFullName;
        return data;
    }

    clone(): MonthlyRehabilitationProgramNoteDto {
        const json = this.toJSON();
        let result = new MonthlyRehabilitationProgramNoteDto();
        result.init(json);
        return result;
    }
}

export interface IMonthlyRehabilitationProgramNoteDto {
    id: number;
    motivation: string | undefined;
    isConfirmed: boolean;
    confirmingUserId: number | undefined;
    confirmationDate: moment.Moment | undefined;
    confirmingUserFullName: string | undefined;
}

export class MonthlyRehabilitationProgramNoteDtoPagedResultDto implements IMonthlyRehabilitationProgramNoteDtoPagedResultDto {
    items!: MonthlyRehabilitationProgramNoteDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMonthlyRehabilitationProgramNoteDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MonthlyRehabilitationProgramNoteDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MonthlyRehabilitationProgramNoteDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyRehabilitationProgramNoteDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MonthlyRehabilitationProgramNoteDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MonthlyRehabilitationProgramNoteDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMonthlyRehabilitationProgramNoteDtoPagedResultDto {
    items: MonthlyRehabilitationProgramNoteDto[] | undefined;
    totalCount: number;
}

export class MonthlyRehabilitationProgramRecordDto implements IMonthlyRehabilitationProgramRecordDto {
    id!: number;
    socialHealthRecordId!: number;
    month!: string | undefined;
    year!: number;
    treatments!: MonthlyRehabilitationProgramTreatmentDto[] | undefined;
    notes!: MonthlyRehabilitationProgramNoteDto[] | undefined;
    collaborationDegree!: DictionaryDto;

    constructor(data?: IMonthlyRehabilitationProgramRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.month = _data["month"];
            this.year = _data["year"];
            if (Array.isArray(_data["treatments"])) {
                this.treatments = [] as any;
                for (let item of _data["treatments"])
                    this.treatments!.push(MonthlyRehabilitationProgramTreatmentDto.fromJS(item));
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [] as any;
                for (let item of _data["notes"])
                    this.notes!.push(MonthlyRehabilitationProgramNoteDto.fromJS(item));
            }
            this.collaborationDegree = _data["collaborationDegree"] ? DictionaryDto.fromJS(_data["collaborationDegree"]) : undefined as any;
        }
    }

    static fromJS(data: any): MonthlyRehabilitationProgramRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyRehabilitationProgramRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["month"] = this.month;
        data["year"] = this.year;
        if (Array.isArray(this.treatments)) {
            data["treatments"] = [];
            for (let item of this.treatments)
                data["treatments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            for (let item of this.notes)
                data["notes"].push(item ? item.toJSON() : undefined as any);
        }
        data["collaborationDegree"] = this.collaborationDegree ? this.collaborationDegree.toJSON() : undefined as any;
        return data;
    }

    clone(): MonthlyRehabilitationProgramRecordDto {
        const json = this.toJSON();
        let result = new MonthlyRehabilitationProgramRecordDto();
        result.init(json);
        return result;
    }
}

export interface IMonthlyRehabilitationProgramRecordDto {
    id: number;
    socialHealthRecordId: number;
    month: string | undefined;
    year: number;
    treatments: MonthlyRehabilitationProgramTreatmentDto[] | undefined;
    notes: MonthlyRehabilitationProgramNoteDto[] | undefined;
    collaborationDegree: DictionaryDto;
}

export class MonthlyRehabilitationProgramRecordItemDto implements IMonthlyRehabilitationProgramRecordItemDto {
    id!: number;
    socialHealthRecordId!: number;
    month!: string | undefined;
    year!: number;

    constructor(data?: IMonthlyRehabilitationProgramRecordItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.month = _data["month"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): MonthlyRehabilitationProgramRecordItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyRehabilitationProgramRecordItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["month"] = this.month;
        data["year"] = this.year;
        return data;
    }

    clone(): MonthlyRehabilitationProgramRecordItemDto {
        const json = this.toJSON();
        let result = new MonthlyRehabilitationProgramRecordItemDto();
        result.init(json);
        return result;
    }
}

export interface IMonthlyRehabilitationProgramRecordItemDto {
    id: number;
    socialHealthRecordId: number;
    month: string | undefined;
    year: number;
}

export class MonthlyRehabilitationProgramRecordItemDtoPagedResultDto implements IMonthlyRehabilitationProgramRecordItemDtoPagedResultDto {
    items!: MonthlyRehabilitationProgramRecordItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMonthlyRehabilitationProgramRecordItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MonthlyRehabilitationProgramRecordItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MonthlyRehabilitationProgramRecordItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyRehabilitationProgramRecordItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MonthlyRehabilitationProgramRecordItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MonthlyRehabilitationProgramRecordItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMonthlyRehabilitationProgramRecordItemDtoPagedResultDto {
    items: MonthlyRehabilitationProgramRecordItemDto[] | undefined;
    totalCount: number;
}

export class MonthlyRehabilitationProgramTreatmentDto implements IMonthlyRehabilitationProgramTreatmentDto {
    id!: number;
    treatmentTypes!: DictionaryDto[] | undefined;
    day!: number;

    constructor(data?: IMonthlyRehabilitationProgramTreatmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["treatmentTypes"])) {
                this.treatmentTypes = [] as any;
                for (let item of _data["treatmentTypes"])
                    this.treatmentTypes!.push(DictionaryDto.fromJS(item));
            }
            this.day = _data["day"];
        }
    }

    static fromJS(data: any): MonthlyRehabilitationProgramTreatmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyRehabilitationProgramTreatmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.treatmentTypes)) {
            data["treatmentTypes"] = [];
            for (let item of this.treatmentTypes)
                data["treatmentTypes"].push(item ? item.toJSON() : undefined as any);
        }
        data["day"] = this.day;
        return data;
    }

    clone(): MonthlyRehabilitationProgramTreatmentDto {
        const json = this.toJSON();
        let result = new MonthlyRehabilitationProgramTreatmentDto();
        result.init(json);
        return result;
    }
}

export interface IMonthlyRehabilitationProgramTreatmentDto {
    id: number;
    treatmentTypes: DictionaryDto[] | undefined;
    day: number;
}

export class MonthlyRehabilitationProgramTreatmentDtoPagedResultDto implements IMonthlyRehabilitationProgramTreatmentDtoPagedResultDto {
    items!: MonthlyRehabilitationProgramTreatmentDto[] | undefined;
    totalCount!: number;

    constructor(data?: IMonthlyRehabilitationProgramTreatmentDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MonthlyRehabilitationProgramTreatmentDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): MonthlyRehabilitationProgramTreatmentDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyRehabilitationProgramTreatmentDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): MonthlyRehabilitationProgramTreatmentDtoPagedResultDto {
        const json = this.toJSON();
        let result = new MonthlyRehabilitationProgramTreatmentDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IMonthlyRehabilitationProgramTreatmentDtoPagedResultDto {
    items: MonthlyRehabilitationProgramTreatmentDto[] | undefined;
    totalCount: number;
}

export class MunicipalityDto implements IMunicipalityDto {
    id!: number;
    name!: string | undefined;
    isChiefTown!: boolean;
    province!: ProvinceDto;

    constructor(data?: IMunicipalityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isChiefTown = _data["isChiefTown"];
            this.province = _data["province"] ? ProvinceDto.fromJS(_data["province"]) : undefined as any;
        }
    }

    static fromJS(data: any): MunicipalityDto {
        data = typeof data === 'object' ? data : {};
        let result = new MunicipalityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isChiefTown"] = this.isChiefTown;
        data["province"] = this.province ? this.province.toJSON() : undefined as any;
        return data;
    }

    clone(): MunicipalityDto {
        const json = this.toJSON();
        let result = new MunicipalityDto();
        result.init(json);
        return result;
    }
}

export interface IMunicipalityDto {
    id: number;
    name: string | undefined;
    isChiefTown: boolean;
    province: ProvinceDto;
}

export class ObjectiveDto implements IObjectiveDto {
    id!: number;
    description!: string | undefined;
    scopeObservationGrid!: ScopeObservationGridDto;
    objectiveTime!: DictionaryDto;
    strategy!: string | undefined;
    results!: ObjectiveResultDto[] | undefined;

    constructor(data?: IObjectiveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.scopeObservationGrid = _data["scopeObservationGrid"] ? ScopeObservationGridDto.fromJS(_data["scopeObservationGrid"]) : undefined as any;
            this.objectiveTime = _data["objectiveTime"] ? DictionaryDto.fromJS(_data["objectiveTime"]) : undefined as any;
            this.strategy = _data["strategy"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ObjectiveResultDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ObjectiveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectiveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["scopeObservationGrid"] = this.scopeObservationGrid ? this.scopeObservationGrid.toJSON() : undefined as any;
        data["objectiveTime"] = this.objectiveTime ? this.objectiveTime.toJSON() : undefined as any;
        data["strategy"] = this.strategy;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ObjectiveDto {
        const json = this.toJSON();
        let result = new ObjectiveDto();
        result.init(json);
        return result;
    }
}

export interface IObjectiveDto {
    id: number;
    description: string | undefined;
    scopeObservationGrid: ScopeObservationGridDto;
    objectiveTime: DictionaryDto;
    strategy: string | undefined;
    results: ObjectiveResultDto[] | undefined;
}

export class ObjectiveDtoPagedResultDto implements IObjectiveDtoPagedResultDto {
    items!: ObjectiveDto[] | undefined;
    totalCount!: number;

    constructor(data?: IObjectiveDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ObjectiveDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ObjectiveDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectiveDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ObjectiveDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ObjectiveDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IObjectiveDtoPagedResultDto {
    items: ObjectiveDto[] | undefined;
    totalCount: number;
}

export class ObjectiveResultDto implements IObjectiveResultDto {
    id!: number;
    outcome!: DictionaryDto;
    dateTime!: moment.Moment | undefined;
    description!: string | undefined;

    constructor(data?: IObjectiveResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.outcome = _data["outcome"] ? DictionaryDto.fromJS(_data["outcome"]) : undefined as any;
            this.dateTime = _data["dateTime"] ? moment(_data["dateTime"].toString()) : undefined as any;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ObjectiveResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectiveResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["outcome"] = this.outcome ? this.outcome.toJSON() : undefined as any;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : undefined as any;
        data["description"] = this.description;
        return data;
    }

    clone(): ObjectiveResultDto {
        const json = this.toJSON();
        let result = new ObjectiveResultDto();
        result.init(json);
        return result;
    }
}

export interface IObjectiveResultDto {
    id: number;
    outcome: DictionaryDto;
    dateTime: moment.Moment | undefined;
    description: string | undefined;
}

export class ObjectiveResultDtoPagedResultDto implements IObjectiveResultDtoPagedResultDto {
    items!: ObjectiveResultDto[] | undefined;
    totalCount!: number;

    constructor(data?: IObjectiveResultDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ObjectiveResultDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ObjectiveResultDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectiveResultDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ObjectiveResultDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ObjectiveResultDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IObjectiveResultDtoPagedResultDto {
    items: ObjectiveResultDto[] | undefined;
    totalCount: number;
}

export class ObjectiveResultGetAllInput implements IObjectiveResultGetAllInput {

    constructor(data?: IObjectiveResultGetAllInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ObjectiveResultGetAllInput {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectiveResultGetAllInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ObjectiveResultGetAllInput {
        const json = this.toJSON();
        let result = new ObjectiveResultGetAllInput();
        result.init(json);
        return result;
    }
}

export interface IObjectiveResultGetAllInput {
}

export class ObjectivesRehabilitationBarthelDto implements IObjectivesRehabilitationBarthelDto {
    id!: number;
    dateEntry!: moment.Moment | undefined;
    totalEntry!: number | undefined;
    dateCurrent!: moment.Moment | undefined;
    totalCurrent!: number | undefined;
    dateNext!: moment.Moment | undefined;
    totalNext!: number | undefined;

    constructor(data?: IObjectivesRehabilitationBarthelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateEntry = _data["dateEntry"] ? moment(_data["dateEntry"].toString()) : undefined as any;
            this.totalEntry = _data["totalEntry"];
            this.dateCurrent = _data["dateCurrent"] ? moment(_data["dateCurrent"].toString()) : undefined as any;
            this.totalCurrent = _data["totalCurrent"];
            this.dateNext = _data["dateNext"] ? moment(_data["dateNext"].toString()) : undefined as any;
            this.totalNext = _data["totalNext"];
        }
    }

    static fromJS(data: any): ObjectivesRehabilitationBarthelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectivesRehabilitationBarthelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateEntry"] = this.dateEntry ? this.dateEntry.toISOString() : undefined as any;
        data["totalEntry"] = this.totalEntry;
        data["dateCurrent"] = this.dateCurrent ? this.dateCurrent.toISOString() : undefined as any;
        data["totalCurrent"] = this.totalCurrent;
        data["dateNext"] = this.dateNext ? this.dateNext.toISOString() : undefined as any;
        data["totalNext"] = this.totalNext;
        return data;
    }

    clone(): ObjectivesRehabilitationBarthelDto {
        const json = this.toJSON();
        let result = new ObjectivesRehabilitationBarthelDto();
        result.init(json);
        return result;
    }
}

export interface IObjectivesRehabilitationBarthelDto {
    id: number;
    dateEntry: moment.Moment | undefined;
    totalEntry: number | undefined;
    dateCurrent: moment.Moment | undefined;
    totalCurrent: number | undefined;
    dateNext: moment.Moment | undefined;
    totalNext: number | undefined;
}

export class ObjectivesRehabilitationRecordDto implements IObjectivesRehabilitationRecordDto {
    id!: number;
    socialHealthRecordId!: number;
    date!: moment.Moment;
    shortTermObjectives!: DictionaryDto[] | undefined;
    shortTermOther!: string | undefined;
    shortTermResult!: DictionaryDto;
    longTermObjectives!: DictionaryDto[] | undefined;
    longTermOther!: string | undefined;
    treatmentPrograms!: DictionaryDto[] | undefined;
    treatmentProgramOther!: string | undefined;
    weeklyFrequency!: DictionaryDto;
    weeklyFrequencyOther!: string | undefined;
    tinetti!: ObjectivesRehabilitationTinettiDto;
    barthel!: ObjectivesRehabilitationBarthelDto;
    isSecondConfirmed!: boolean;
    secondConfirmingUserId!: number | undefined;
    secondConfirmationDate!: moment.Moment | undefined;
    secondConfirmingUserFullName!: string | undefined;
    isConfirmed!: boolean;
    confirmingUserId!: number | undefined;
    confirmationDate!: moment.Moment | undefined;
    confirmingUserFullName!: string | undefined;

    constructor(data?: IObjectivesRehabilitationRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            if (Array.isArray(_data["shortTermObjectives"])) {
                this.shortTermObjectives = [] as any;
                for (let item of _data["shortTermObjectives"])
                    this.shortTermObjectives!.push(DictionaryDto.fromJS(item));
            }
            this.shortTermOther = _data["shortTermOther"];
            this.shortTermResult = _data["shortTermResult"] ? DictionaryDto.fromJS(_data["shortTermResult"]) : undefined as any;
            if (Array.isArray(_data["longTermObjectives"])) {
                this.longTermObjectives = [] as any;
                for (let item of _data["longTermObjectives"])
                    this.longTermObjectives!.push(DictionaryDto.fromJS(item));
            }
            this.longTermOther = _data["longTermOther"];
            if (Array.isArray(_data["treatmentPrograms"])) {
                this.treatmentPrograms = [] as any;
                for (let item of _data["treatmentPrograms"])
                    this.treatmentPrograms!.push(DictionaryDto.fromJS(item));
            }
            this.treatmentProgramOther = _data["treatmentProgramOther"];
            this.weeklyFrequency = _data["weeklyFrequency"] ? DictionaryDto.fromJS(_data["weeklyFrequency"]) : undefined as any;
            this.weeklyFrequencyOther = _data["weeklyFrequencyOther"];
            this.tinetti = _data["tinetti"] ? ObjectivesRehabilitationTinettiDto.fromJS(_data["tinetti"]) : undefined as any;
            this.barthel = _data["barthel"] ? ObjectivesRehabilitationBarthelDto.fromJS(_data["barthel"]) : undefined as any;
            this.isSecondConfirmed = _data["isSecondConfirmed"];
            this.secondConfirmingUserId = _data["secondConfirmingUserId"];
            this.secondConfirmationDate = _data["secondConfirmationDate"] ? moment(_data["secondConfirmationDate"].toString()) : undefined as any;
            this.secondConfirmingUserFullName = _data["secondConfirmingUserFullName"];
            this.isConfirmed = _data["isConfirmed"];
            this.confirmingUserId = _data["confirmingUserId"];
            this.confirmationDate = _data["confirmationDate"] ? moment(_data["confirmationDate"].toString()) : undefined as any;
            this.confirmingUserFullName = _data["confirmingUserFullName"];
        }
    }

    static fromJS(data: any): ObjectivesRehabilitationRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectivesRehabilitationRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        if (Array.isArray(this.shortTermObjectives)) {
            data["shortTermObjectives"] = [];
            for (let item of this.shortTermObjectives)
                data["shortTermObjectives"].push(item ? item.toJSON() : undefined as any);
        }
        data["shortTermOther"] = this.shortTermOther;
        data["shortTermResult"] = this.shortTermResult ? this.shortTermResult.toJSON() : undefined as any;
        if (Array.isArray(this.longTermObjectives)) {
            data["longTermObjectives"] = [];
            for (let item of this.longTermObjectives)
                data["longTermObjectives"].push(item ? item.toJSON() : undefined as any);
        }
        data["longTermOther"] = this.longTermOther;
        if (Array.isArray(this.treatmentPrograms)) {
            data["treatmentPrograms"] = [];
            for (let item of this.treatmentPrograms)
                data["treatmentPrograms"].push(item ? item.toJSON() : undefined as any);
        }
        data["treatmentProgramOther"] = this.treatmentProgramOther;
        data["weeklyFrequency"] = this.weeklyFrequency ? this.weeklyFrequency.toJSON() : undefined as any;
        data["weeklyFrequencyOther"] = this.weeklyFrequencyOther;
        data["tinetti"] = this.tinetti ? this.tinetti.toJSON() : undefined as any;
        data["barthel"] = this.barthel ? this.barthel.toJSON() : undefined as any;
        data["isSecondConfirmed"] = this.isSecondConfirmed;
        data["secondConfirmingUserId"] = this.secondConfirmingUserId;
        data["secondConfirmationDate"] = this.secondConfirmationDate ? this.secondConfirmationDate.toISOString() : undefined as any;
        data["secondConfirmingUserFullName"] = this.secondConfirmingUserFullName;
        data["isConfirmed"] = this.isConfirmed;
        data["confirmingUserId"] = this.confirmingUserId;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : undefined as any;
        data["confirmingUserFullName"] = this.confirmingUserFullName;
        return data;
    }

    clone(): ObjectivesRehabilitationRecordDto {
        const json = this.toJSON();
        let result = new ObjectivesRehabilitationRecordDto();
        result.init(json);
        return result;
    }
}

export interface IObjectivesRehabilitationRecordDto {
    id: number;
    socialHealthRecordId: number;
    date: moment.Moment;
    shortTermObjectives: DictionaryDto[] | undefined;
    shortTermOther: string | undefined;
    shortTermResult: DictionaryDto;
    longTermObjectives: DictionaryDto[] | undefined;
    longTermOther: string | undefined;
    treatmentPrograms: DictionaryDto[] | undefined;
    treatmentProgramOther: string | undefined;
    weeklyFrequency: DictionaryDto;
    weeklyFrequencyOther: string | undefined;
    tinetti: ObjectivesRehabilitationTinettiDto;
    barthel: ObjectivesRehabilitationBarthelDto;
    isSecondConfirmed: boolean;
    secondConfirmingUserId: number | undefined;
    secondConfirmationDate: moment.Moment | undefined;
    secondConfirmingUserFullName: string | undefined;
    isConfirmed: boolean;
    confirmingUserId: number | undefined;
    confirmationDate: moment.Moment | undefined;
    confirmingUserFullName: string | undefined;
}

export class ObjectivesRehabilitationRecordItemDto implements IObjectivesRehabilitationRecordItemDto {
    id!: number;
    date!: moment.Moment;
    isSecondConfirmed!: boolean;
    secondConfirmingUserId!: number | undefined;
    secondConfirmationDate!: moment.Moment | undefined;
    secondConfirmingUserFullName!: string | undefined;
    isConfirmed!: boolean;
    confirmingUserId!: number | undefined;
    confirmationDate!: moment.Moment | undefined;
    confirmingUserFullName!: string | undefined;

    constructor(data?: IObjectivesRehabilitationRecordItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.isSecondConfirmed = _data["isSecondConfirmed"];
            this.secondConfirmingUserId = _data["secondConfirmingUserId"];
            this.secondConfirmationDate = _data["secondConfirmationDate"] ? moment(_data["secondConfirmationDate"].toString()) : undefined as any;
            this.secondConfirmingUserFullName = _data["secondConfirmingUserFullName"];
            this.isConfirmed = _data["isConfirmed"];
            this.confirmingUserId = _data["confirmingUserId"];
            this.confirmationDate = _data["confirmationDate"] ? moment(_data["confirmationDate"].toString()) : undefined as any;
            this.confirmingUserFullName = _data["confirmingUserFullName"];
        }
    }

    static fromJS(data: any): ObjectivesRehabilitationRecordItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectivesRehabilitationRecordItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["isSecondConfirmed"] = this.isSecondConfirmed;
        data["secondConfirmingUserId"] = this.secondConfirmingUserId;
        data["secondConfirmationDate"] = this.secondConfirmationDate ? this.secondConfirmationDate.toISOString() : undefined as any;
        data["secondConfirmingUserFullName"] = this.secondConfirmingUserFullName;
        data["isConfirmed"] = this.isConfirmed;
        data["confirmingUserId"] = this.confirmingUserId;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : undefined as any;
        data["confirmingUserFullName"] = this.confirmingUserFullName;
        return data;
    }

    clone(): ObjectivesRehabilitationRecordItemDto {
        const json = this.toJSON();
        let result = new ObjectivesRehabilitationRecordItemDto();
        result.init(json);
        return result;
    }
}

export interface IObjectivesRehabilitationRecordItemDto {
    id: number;
    date: moment.Moment;
    isSecondConfirmed: boolean;
    secondConfirmingUserId: number | undefined;
    secondConfirmationDate: moment.Moment | undefined;
    secondConfirmingUserFullName: string | undefined;
    isConfirmed: boolean;
    confirmingUserId: number | undefined;
    confirmationDate: moment.Moment | undefined;
    confirmingUserFullName: string | undefined;
}

export class ObjectivesRehabilitationRecordItemDtoPagedResultDto implements IObjectivesRehabilitationRecordItemDtoPagedResultDto {
    items!: ObjectivesRehabilitationRecordItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IObjectivesRehabilitationRecordItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ObjectivesRehabilitationRecordItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ObjectivesRehabilitationRecordItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectivesRehabilitationRecordItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ObjectivesRehabilitationRecordItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ObjectivesRehabilitationRecordItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IObjectivesRehabilitationRecordItemDtoPagedResultDto {
    items: ObjectivesRehabilitationRecordItemDto[] | undefined;
    totalCount: number;
}

export class ObjectivesRehabilitationTinettiDto implements IObjectivesRehabilitationTinettiDto {
    id!: number;
    dateEntry!: moment.Moment | undefined;
    balanceEntry!: number | undefined;
    gaitEntry!: number | undefined;
    totalEntry!: number | undefined;
    dateCurrent!: moment.Moment | undefined;
    balanceCurrent!: number | undefined;
    gaitCurrent!: number | undefined;
    totalCurrent!: number | undefined;
    dateNext!: moment.Moment | undefined;
    balanceNext!: number | undefined;
    gaitNext!: number | undefined;
    totalNext!: number | undefined;

    constructor(data?: IObjectivesRehabilitationTinettiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateEntry = _data["dateEntry"] ? moment(_data["dateEntry"].toString()) : undefined as any;
            this.balanceEntry = _data["balanceEntry"];
            this.gaitEntry = _data["gaitEntry"];
            this.totalEntry = _data["totalEntry"];
            this.dateCurrent = _data["dateCurrent"] ? moment(_data["dateCurrent"].toString()) : undefined as any;
            this.balanceCurrent = _data["balanceCurrent"];
            this.gaitCurrent = _data["gaitCurrent"];
            this.totalCurrent = _data["totalCurrent"];
            this.dateNext = _data["dateNext"] ? moment(_data["dateNext"].toString()) : undefined as any;
            this.balanceNext = _data["balanceNext"];
            this.gaitNext = _data["gaitNext"];
            this.totalNext = _data["totalNext"];
        }
    }

    static fromJS(data: any): ObjectivesRehabilitationTinettiDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectivesRehabilitationTinettiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateEntry"] = this.dateEntry ? this.dateEntry.toISOString() : undefined as any;
        data["balanceEntry"] = this.balanceEntry;
        data["gaitEntry"] = this.gaitEntry;
        data["totalEntry"] = this.totalEntry;
        data["dateCurrent"] = this.dateCurrent ? this.dateCurrent.toISOString() : undefined as any;
        data["balanceCurrent"] = this.balanceCurrent;
        data["gaitCurrent"] = this.gaitCurrent;
        data["totalCurrent"] = this.totalCurrent;
        data["dateNext"] = this.dateNext ? this.dateNext.toISOString() : undefined as any;
        data["balanceNext"] = this.balanceNext;
        data["gaitNext"] = this.gaitNext;
        data["totalNext"] = this.totalNext;
        return data;
    }

    clone(): ObjectivesRehabilitationTinettiDto {
        const json = this.toJSON();
        let result = new ObjectivesRehabilitationTinettiDto();
        result.init(json);
        return result;
    }
}

export interface IObjectivesRehabilitationTinettiDto {
    id: number;
    dateEntry: moment.Moment | undefined;
    balanceEntry: number | undefined;
    gaitEntry: number | undefined;
    totalEntry: number | undefined;
    dateCurrent: moment.Moment | undefined;
    balanceCurrent: number | undefined;
    gaitCurrent: number | undefined;
    totalCurrent: number | undefined;
    dateNext: moment.Moment | undefined;
    balanceNext: number | undefined;
    gaitNext: number | undefined;
    totalNext: number | undefined;
}

export class ObservationGridCategoryHistoryDto implements IObservationGridCategoryHistoryDto {
    id!: number;
    date!: moment.Moment | undefined;
    observationGridResponses!: ResponseObservationGridDto[] | undefined;

    constructor(data?: IObservationGridCategoryHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            if (Array.isArray(_data["observationGridResponses"])) {
                this.observationGridResponses = [] as any;
                for (let item of _data["observationGridResponses"])
                    this.observationGridResponses!.push(ResponseObservationGridDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ObservationGridCategoryHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationGridCategoryHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        if (Array.isArray(this.observationGridResponses)) {
            data["observationGridResponses"] = [];
            for (let item of this.observationGridResponses)
                data["observationGridResponses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ObservationGridCategoryHistoryDto {
        const json = this.toJSON();
        let result = new ObservationGridCategoryHistoryDto();
        result.init(json);
        return result;
    }
}

export interface IObservationGridCategoryHistoryDto {
    id: number;
    date: moment.Moment | undefined;
    observationGridResponses: ResponseObservationGridDto[] | undefined;
}

export class ObservationGridDto implements IObservationGridDto {
    id!: number;
    socialHealthRecord!: SocialHealthRecordDto;
    date!: moment.Moment | undefined;
    responsesObservationGrid!: ResponseObservationGridDto[] | undefined;
    observationGridScopes!: ObservationGridScopesDto[] | undefined;
    isConfirmed!: boolean;
    confirmingUserId!: number | undefined;
    confirmingUserFullName!: string | undefined;
    confirmationDate!: moment.Moment | undefined;

    constructor(data?: IObservationGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.socialHealthRecord = _data["socialHealthRecord"] ? SocialHealthRecordDto.fromJS(_data["socialHealthRecord"]) : undefined as any;
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            if (Array.isArray(_data["responsesObservationGrid"])) {
                this.responsesObservationGrid = [] as any;
                for (let item of _data["responsesObservationGrid"])
                    this.responsesObservationGrid!.push(ResponseObservationGridDto.fromJS(item));
            }
            if (Array.isArray(_data["observationGridScopes"])) {
                this.observationGridScopes = [] as any;
                for (let item of _data["observationGridScopes"])
                    this.observationGridScopes!.push(ObservationGridScopesDto.fromJS(item));
            }
            this.isConfirmed = _data["isConfirmed"];
            this.confirmingUserId = _data["confirmingUserId"];
            this.confirmingUserFullName = _data["confirmingUserFullName"];
            this.confirmationDate = _data["confirmationDate"] ? moment(_data["confirmationDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ObservationGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["socialHealthRecord"] = this.socialHealthRecord ? this.socialHealthRecord.toJSON() : undefined as any;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        if (Array.isArray(this.responsesObservationGrid)) {
            data["responsesObservationGrid"] = [];
            for (let item of this.responsesObservationGrid)
                data["responsesObservationGrid"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.observationGridScopes)) {
            data["observationGridScopes"] = [];
            for (let item of this.observationGridScopes)
                data["observationGridScopes"].push(item ? item.toJSON() : undefined as any);
        }
        data["isConfirmed"] = this.isConfirmed;
        data["confirmingUserId"] = this.confirmingUserId;
        data["confirmingUserFullName"] = this.confirmingUserFullName;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : undefined as any;
        return data;
    }

    clone(): ObservationGridDto {
        const json = this.toJSON();
        let result = new ObservationGridDto();
        result.init(json);
        return result;
    }
}

export interface IObservationGridDto {
    id: number;
    socialHealthRecord: SocialHealthRecordDto;
    date: moment.Moment | undefined;
    responsesObservationGrid: ResponseObservationGridDto[] | undefined;
    observationGridScopes: ObservationGridScopesDto[] | undefined;
    isConfirmed: boolean;
    confirmingUserId: number | undefined;
    confirmingUserFullName: string | undefined;
    confirmationDate: moment.Moment | undefined;
}

export class ObservationGridItemDto implements IObservationGridItemDto {
    id!: number;
    socialHealthRecord!: SocialHealthRecordDto;
    date!: moment.Moment | undefined;
    isConfirmed!: boolean;
    confirmingUserId!: number | undefined;
    confirmingUserFullName!: string | undefined;
    confirmationDate!: moment.Moment | undefined;

    constructor(data?: IObservationGridItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.socialHealthRecord = _data["socialHealthRecord"] ? SocialHealthRecordDto.fromJS(_data["socialHealthRecord"]) : undefined as any;
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.isConfirmed = _data["isConfirmed"];
            this.confirmingUserId = _data["confirmingUserId"];
            this.confirmingUserFullName = _data["confirmingUserFullName"];
            this.confirmationDate = _data["confirmationDate"] ? moment(_data["confirmationDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ObservationGridItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationGridItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["socialHealthRecord"] = this.socialHealthRecord ? this.socialHealthRecord.toJSON() : undefined as any;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["isConfirmed"] = this.isConfirmed;
        data["confirmingUserId"] = this.confirmingUserId;
        data["confirmingUserFullName"] = this.confirmingUserFullName;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : undefined as any;
        return data;
    }

    clone(): ObservationGridItemDto {
        const json = this.toJSON();
        let result = new ObservationGridItemDto();
        result.init(json);
        return result;
    }
}

export interface IObservationGridItemDto {
    id: number;
    socialHealthRecord: SocialHealthRecordDto;
    date: moment.Moment | undefined;
    isConfirmed: boolean;
    confirmingUserId: number | undefined;
    confirmingUserFullName: string | undefined;
    confirmationDate: moment.Moment | undefined;
}

export class ObservationGridItemDtoPagedResultDto implements IObservationGridItemDtoPagedResultDto {
    items!: ObservationGridItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IObservationGridItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ObservationGridItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ObservationGridItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationGridItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ObservationGridItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ObservationGridItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IObservationGridItemDtoPagedResultDto {
    items: ObservationGridItemDto[] | undefined;
    totalCount: number;
}

export class ObservationGridScopesDto implements IObservationGridScopesDto {
    id!: number;
    scopeObservationGrid!: ScopeObservationGridDto;

    constructor(data?: IObservationGridScopesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scopeObservationGrid = _data["scopeObservationGrid"] ? ScopeObservationGridDto.fromJS(_data["scopeObservationGrid"]) : undefined as any;
        }
    }

    static fromJS(data: any): ObservationGridScopesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationGridScopesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scopeObservationGrid"] = this.scopeObservationGrid ? this.scopeObservationGrid.toJSON() : undefined as any;
        return data;
    }

    clone(): ObservationGridScopesDto {
        const json = this.toJSON();
        let result = new ObservationGridScopesDto();
        result.init(json);
        return result;
    }
}

export interface IObservationGridScopesDto {
    id: number;
    scopeObservationGrid: ScopeObservationGridDto;
}

export class ObservationGridSectionOperatorPermissionDto implements IObservationGridSectionOperatorPermissionDto {
    id!: number;
    serviceUser!: ServiceUserDto;
    sectionObservationGrid!: SectionObservationGridDto;

    constructor(data?: IObservationGridSectionOperatorPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceUser = _data["serviceUser"] ? ServiceUserDto.fromJS(_data["serviceUser"]) : undefined as any;
            this.sectionObservationGrid = _data["sectionObservationGrid"] ? SectionObservationGridDto.fromJS(_data["sectionObservationGrid"]) : undefined as any;
        }
    }

    static fromJS(data: any): ObservationGridSectionOperatorPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationGridSectionOperatorPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceUser"] = this.serviceUser ? this.serviceUser.toJSON() : undefined as any;
        data["sectionObservationGrid"] = this.sectionObservationGrid ? this.sectionObservationGrid.toJSON() : undefined as any;
        return data;
    }

    clone(): ObservationGridSectionOperatorPermissionDto {
        const json = this.toJSON();
        let result = new ObservationGridSectionOperatorPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IObservationGridSectionOperatorPermissionDto {
    id: number;
    serviceUser: ServiceUserDto;
    sectionObservationGrid: SectionObservationGridDto;
}

export class ObservationGridSectionOperatorPermissionDtoPagedResultDto implements IObservationGridSectionOperatorPermissionDtoPagedResultDto {
    items!: ObservationGridSectionOperatorPermissionDto[] | undefined;
    totalCount!: number;

    constructor(data?: IObservationGridSectionOperatorPermissionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ObservationGridSectionOperatorPermissionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ObservationGridSectionOperatorPermissionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ObservationGridSectionOperatorPermissionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ObservationGridSectionOperatorPermissionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ObservationGridSectionOperatorPermissionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IObservationGridSectionOperatorPermissionDtoPagedResultDto {
    items: ObservationGridSectionOperatorPermissionDto[] | undefined;
    totalCount: number;
}

export class OccupationDto implements IOccupationDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    activityType!: string | undefined;
    location!: string | undefined;
    activityPeriod!: string | undefined;
    time!: string | undefined;
    note!: string | undefined;

    constructor(data?: IOccupationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.activityType = _data["activityType"];
            this.location = _data["location"];
            this.activityPeriod = _data["activityPeriod"];
            this.time = _data["time"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): OccupationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OccupationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["activityType"] = this.activityType;
        data["location"] = this.location;
        data["activityPeriod"] = this.activityPeriod;
        data["time"] = this.time;
        data["note"] = this.note;
        return data;
    }

    clone(): OccupationDto {
        const json = this.toJSON();
        let result = new OccupationDto();
        result.init(json);
        return result;
    }
}

export interface IOccupationDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    activityType: string | undefined;
    location: string | undefined;
    activityPeriod: string | undefined;
    time: string | undefined;
    note: string | undefined;
}

export class OccupationDtoPagedResultDto implements IOccupationDtoPagedResultDto {
    items!: OccupationDto[] | undefined;
    totalCount!: number;

    constructor(data?: IOccupationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OccupationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OccupationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OccupationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OccupationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OccupationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOccupationDtoPagedResultDto {
    items: OccupationDto[] | undefined;
    totalCount: number;
}

export class OperatorPermissionDto implements IOperatorPermissionDto {
    serviceUserId!: number;
    recordId!: number;

    constructor(data?: IOperatorPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceUserId = _data["serviceUserId"];
            this.recordId = _data["recordId"];
        }
    }

    static fromJS(data: any): OperatorPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new OperatorPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceUserId"] = this.serviceUserId;
        data["recordId"] = this.recordId;
        return data;
    }

    clone(): OperatorPermissionDto {
        const json = this.toJSON();
        let result = new OperatorPermissionDto();
        result.init(json);
        return result;
    }
}

export interface IOperatorPermissionDto {
    serviceUserId: number;
    recordId: number;
}

export class OrganizationDto implements IOrganizationDto {
    id!: number;
    name!: string | undefined;
    services!: ServiceItemDto[] | undefined;

    constructor(data?: IOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ServiceItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): OrganizationDto {
        const json = this.toJSON();
        let result = new OrganizationDto();
        result.init(json);
        return result;
    }
}

export interface IOrganizationDto {
    id: number;
    name: string | undefined;
    services: ServiceItemDto[] | undefined;
}

export class OrganizationDtoPagedResultDto implements IOrganizationDtoPagedResultDto {
    items!: OrganizationDto[] | undefined;
    totalCount!: number;

    constructor(data?: IOrganizationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OrganizationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OrganizationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OrganizationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOrganizationDtoPagedResultDto {
    items: OrganizationDto[] | undefined;
    totalCount: number;
}

export class OrganizationGetAllInput implements IOrganizationGetAllInput {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    keyword!: string | undefined;

    constructor(data?: IOrganizationGetAllInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.keyword = _data["keyword"];
        }
    }

    static fromJS(data: any): OrganizationGetAllInput {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationGetAllInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["keyword"] = this.keyword;
        return data;
    }

    clone(): OrganizationGetAllInput {
        const json = this.toJSON();
        let result = new OrganizationGetAllInput();
        result.init(json);
        return result;
    }
}

export interface IOrganizationGetAllInput {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    keyword: string | undefined;
}

export class OtherReferenceDto implements IOtherReferenceDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    phoneNumber!: string | undefined;
    otherPhoneNumber!: string | undefined;
    emailAddress!: string | undefined;
    role!: string | undefined;
    address!: AddressDto;
    note!: string | undefined;
    isActive!: boolean;

    constructor(data?: IOtherReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phoneNumber = _data["phoneNumber"];
            this.otherPhoneNumber = _data["otherPhoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.role = _data["role"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : undefined as any;
            this.note = _data["note"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): OtherReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new OtherReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phoneNumber"] = this.phoneNumber;
        data["otherPhoneNumber"] = this.otherPhoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["role"] = this.role;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["note"] = this.note;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): OtherReferenceDto {
        const json = this.toJSON();
        let result = new OtherReferenceDto();
        result.init(json);
        return result;
    }
}

export interface IOtherReferenceDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    name: string | undefined;
    surname: string | undefined;
    phoneNumber: string | undefined;
    otherPhoneNumber: string | undefined;
    emailAddress: string | undefined;
    role: string | undefined;
    address: AddressDto;
    note: string | undefined;
    isActive: boolean;
}

export class OtherReferenceDtoPagedResultDto implements IOtherReferenceDtoPagedResultDto {
    items!: OtherReferenceDto[] | undefined;
    totalCount!: number;

    constructor(data?: IOtherReferenceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OtherReferenceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): OtherReferenceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new OtherReferenceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): OtherReferenceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new OtherReferenceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IOtherReferenceDtoPagedResultDto {
    items: OtherReferenceDto[] | undefined;
    totalCount: number;
}

export class Patient118RecordDto implements IPatient118RecordDto {
    id!: number;
    isConfirmed!: boolean;
    confirmingUserId!: number | undefined;
    confirmationDate!: moment.Moment | undefined;
    confirmingUserFullName!: string | undefined;
    date!: moment.Moment;
    residence!: string | undefined;
    healthCardNumber!: string | undefined;
    caregiverName!: string | undefined;
    caregiverSurname!: string | undefined;
    caregiverNumber!: string | undefined;
    diagnosis!: string | undefined;
    therapy!: string | undefined;
    note!: string | undefined;

    constructor(data?: IPatient118RecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isConfirmed = _data["isConfirmed"];
            this.confirmingUserId = _data["confirmingUserId"];
            this.confirmationDate = _data["confirmationDate"] ? moment(_data["confirmationDate"].toString()) : undefined as any;
            this.confirmingUserFullName = _data["confirmingUserFullName"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.residence = _data["residence"];
            this.healthCardNumber = _data["healthCardNumber"];
            this.caregiverName = _data["caregiverName"];
            this.caregiverSurname = _data["caregiverSurname"];
            this.caregiverNumber = _data["caregiverNumber"];
            this.diagnosis = _data["diagnosis"];
            this.therapy = _data["therapy"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): Patient118RecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new Patient118RecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isConfirmed"] = this.isConfirmed;
        data["confirmingUserId"] = this.confirmingUserId;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : undefined as any;
        data["confirmingUserFullName"] = this.confirmingUserFullName;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["residence"] = this.residence;
        data["healthCardNumber"] = this.healthCardNumber;
        data["caregiverName"] = this.caregiverName;
        data["caregiverSurname"] = this.caregiverSurname;
        data["caregiverNumber"] = this.caregiverNumber;
        data["diagnosis"] = this.diagnosis;
        data["therapy"] = this.therapy;
        data["note"] = this.note;
        return data;
    }

    clone(): Patient118RecordDto {
        const json = this.toJSON();
        let result = new Patient118RecordDto();
        result.init(json);
        return result;
    }
}

export interface IPatient118RecordDto {
    id: number;
    isConfirmed: boolean;
    confirmingUserId: number | undefined;
    confirmationDate: moment.Moment | undefined;
    confirmingUserFullName: string | undefined;
    date: moment.Moment;
    residence: string | undefined;
    healthCardNumber: string | undefined;
    caregiverName: string | undefined;
    caregiverSurname: string | undefined;
    caregiverNumber: string | undefined;
    diagnosis: string | undefined;
    therapy: string | undefined;
    note: string | undefined;
}

export class Patient118RecordDtoPagedResultDto implements IPatient118RecordDtoPagedResultDto {
    items!: Patient118RecordDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPatient118RecordDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Patient118RecordDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): Patient118RecordDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new Patient118RecordDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): Patient118RecordDtoPagedResultDto {
        const json = this.toJSON();
        let result = new Patient118RecordDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPatient118RecordDtoPagedResultDto {
    items: Patient118RecordDto[] | undefined;
    totalCount: number;
}

export class PermissionDto implements IPermissionDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    parent!: PermissionDto;

    constructor(data?: IPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.parent = _data["parent"] ? PermissionDto.fromJS(_data["parent"]) : undefined as any;
        }
    }

    static fromJS(data: any): PermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        return data;
    }

    clone(): PermissionDto {
        const json = this.toJSON();
        let result = new PermissionDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    parent: PermissionDto;
}

export class PermissionDtoListResultDto implements IPermissionDtoListResultDto {
    items!: PermissionDto[] | undefined;

    constructor(data?: IPermissionDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PermissionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PermissionDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): PermissionDtoListResultDto {
        const json = this.toJSON();
        let result = new PermissionDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IPermissionDtoListResultDto {
    items: PermissionDto[] | undefined;
}

export class PersonalAutonomyDto implements IPersonalAutonomyDto {
    id!: number;
    walkingMode!: DictionaryDto;
    walkingDescription!: string | undefined;
    eatingMode!: DictionaryDto;
    eatingDescription!: string | undefined;
    personalHygieneMode!: DictionaryDto;
    personalHygieneDescription!: string | undefined;
    note!: string | undefined;

    constructor(data?: IPersonalAutonomyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.walkingMode = _data["walkingMode"] ? DictionaryDto.fromJS(_data["walkingMode"]) : undefined as any;
            this.walkingDescription = _data["walkingDescription"];
            this.eatingMode = _data["eatingMode"] ? DictionaryDto.fromJS(_data["eatingMode"]) : undefined as any;
            this.eatingDescription = _data["eatingDescription"];
            this.personalHygieneMode = _data["personalHygieneMode"] ? DictionaryDto.fromJS(_data["personalHygieneMode"]) : undefined as any;
            this.personalHygieneDescription = _data["personalHygieneDescription"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): PersonalAutonomyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalAutonomyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["walkingMode"] = this.walkingMode ? this.walkingMode.toJSON() : undefined as any;
        data["walkingDescription"] = this.walkingDescription;
        data["eatingMode"] = this.eatingMode ? this.eatingMode.toJSON() : undefined as any;
        data["eatingDescription"] = this.eatingDescription;
        data["personalHygieneMode"] = this.personalHygieneMode ? this.personalHygieneMode.toJSON() : undefined as any;
        data["personalHygieneDescription"] = this.personalHygieneDescription;
        data["note"] = this.note;
        return data;
    }

    clone(): PersonalAutonomyDto {
        const json = this.toJSON();
        let result = new PersonalAutonomyDto();
        result.init(json);
        return result;
    }
}

export interface IPersonalAutonomyDto {
    id: number;
    walkingMode: DictionaryDto;
    walkingDescription: string | undefined;
    eatingMode: DictionaryDto;
    eatingDescription: string | undefined;
    personalHygieneMode: DictionaryDto;
    personalHygieneDescription: string | undefined;
    note: string | undefined;
}

export class PersonalAutonomyDtoPagedResultDto implements IPersonalAutonomyDtoPagedResultDto {
    items!: PersonalAutonomyDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPersonalAutonomyDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PersonalAutonomyDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PersonalAutonomyDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalAutonomyDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PersonalAutonomyDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PersonalAutonomyDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPersonalAutonomyDtoPagedResultDto {
    items: PersonalAutonomyDto[] | undefined;
    totalCount: number;
}

export class PersonalDataDto implements IPersonalDataDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    residenceAddresses!: AddressDto[] | undefined;
    domicileAddresses!: AddressDto[] | undefined;
    constituency!: string | undefined;
    district!: string | undefined;
    phoneNumbers!: string[] | undefined;

    constructor(data?: IPersonalDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            if (Array.isArray(_data["residenceAddresses"])) {
                this.residenceAddresses = [] as any;
                for (let item of _data["residenceAddresses"])
                    this.residenceAddresses!.push(AddressDto.fromJS(item));
            }
            if (Array.isArray(_data["domicileAddresses"])) {
                this.domicileAddresses = [] as any;
                for (let item of _data["domicileAddresses"])
                    this.domicileAddresses!.push(AddressDto.fromJS(item));
            }
            this.constituency = _data["constituency"];
            this.district = _data["district"];
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(item);
            }
        }
    }

    static fromJS(data: any): PersonalDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        if (Array.isArray(this.residenceAddresses)) {
            data["residenceAddresses"] = [];
            for (let item of this.residenceAddresses)
                data["residenceAddresses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.domicileAddresses)) {
            data["domicileAddresses"] = [];
            for (let item of this.domicileAddresses)
                data["domicileAddresses"].push(item ? item.toJSON() : undefined as any);
        }
        data["constituency"] = this.constituency;
        data["district"] = this.district;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item);
        }
        return data;
    }

    clone(): PersonalDataDto {
        const json = this.toJSON();
        let result = new PersonalDataDto();
        result.init(json);
        return result;
    }
}

export interface IPersonalDataDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    residenceAddresses: AddressDto[] | undefined;
    domicileAddresses: AddressDto[] | undefined;
    constituency: string | undefined;
    district: string | undefined;
    phoneNumbers: string[] | undefined;
}

export class PersonalDataDtoPagedResultDto implements IPersonalDataDtoPagedResultDto {
    items!: PersonalDataDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPersonalDataDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PersonalDataDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PersonalDataDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalDataDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PersonalDataDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PersonalDataDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPersonalDataDtoPagedResultDto {
    items: PersonalDataDto[] | undefined;
    totalCount: number;
}

export class PersonalDataFamilyMemberDto implements IPersonalDataFamilyMemberDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    kinshipDegree!: DictionaryDto;
    name!: string | undefined;
    surname!: string | undefined;
    birthDate!: moment.Moment | undefined;
    cohabitation!: boolean | undefined;
    note!: string | undefined;
    profession!: string | undefined;

    constructor(data?: IPersonalDataFamilyMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.kinshipDegree = _data["kinshipDegree"] ? DictionaryDto.fromJS(_data["kinshipDegree"]) : undefined as any;
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : undefined as any;
            this.cohabitation = _data["cohabitation"];
            this.note = _data["note"];
            this.profession = _data["profession"];
        }
    }

    static fromJS(data: any): PersonalDataFamilyMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalDataFamilyMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["kinshipDegree"] = this.kinshipDegree ? this.kinshipDegree.toJSON() : undefined as any;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined as any;
        data["cohabitation"] = this.cohabitation;
        data["note"] = this.note;
        data["profession"] = this.profession;
        return data;
    }

    clone(): PersonalDataFamilyMemberDto {
        const json = this.toJSON();
        let result = new PersonalDataFamilyMemberDto();
        result.init(json);
        return result;
    }
}

export interface IPersonalDataFamilyMemberDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    kinshipDegree: DictionaryDto;
    name: string | undefined;
    surname: string | undefined;
    birthDate: moment.Moment | undefined;
    cohabitation: boolean | undefined;
    note: string | undefined;
    profession: string | undefined;
}

export class PersonalDataFamilyMemberDtoPagedResultDto implements IPersonalDataFamilyMemberDtoPagedResultDto {
    items!: PersonalDataFamilyMemberDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPersonalDataFamilyMemberDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PersonalDataFamilyMemberDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PersonalDataFamilyMemberDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalDataFamilyMemberDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PersonalDataFamilyMemberDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PersonalDataFamilyMemberDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPersonalDataFamilyMemberDtoPagedResultDto {
    items: PersonalDataFamilyMemberDto[] | undefined;
    totalCount: number;
}

export class PhotovoltaicSystemBaseDto implements IPhotovoltaicSystemBaseDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IPhotovoltaicSystemBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PhotovoltaicSystemBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhotovoltaicSystemBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): PhotovoltaicSystemBaseDto {
        const json = this.toJSON();
        let result = new PhotovoltaicSystemBaseDto();
        result.init(json);
        return result;
    }
}

export interface IPhotovoltaicSystemBaseDto {
    id: number;
    name: string | undefined;
}

export class PhotovoltaicSystemDto implements IPhotovoltaicSystemDto {
    id!: number;
    name!: string | undefined;
    plantConformityDeclaration!: boolean;
    plantConformityDeclarationFile!: FileDto;
    project!: boolean;
    projectFile!: FileDto;
    reportInailOrCiva!: boolean;
    notes!: string | undefined;

    constructor(data?: IPhotovoltaicSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.plantConformityDeclaration = _data["plantConformityDeclaration"];
            this.plantConformityDeclarationFile = _data["plantConformityDeclarationFile"] ? FileDto.fromJS(_data["plantConformityDeclarationFile"]) : undefined as any;
            this.project = _data["project"];
            this.projectFile = _data["projectFile"] ? FileDto.fromJS(_data["projectFile"]) : undefined as any;
            this.reportInailOrCiva = _data["reportInailOrCiva"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): PhotovoltaicSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhotovoltaicSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["plantConformityDeclaration"] = this.plantConformityDeclaration;
        data["plantConformityDeclarationFile"] = this.plantConformityDeclarationFile ? this.plantConformityDeclarationFile.toJSON() : undefined as any;
        data["project"] = this.project;
        data["projectFile"] = this.projectFile ? this.projectFile.toJSON() : undefined as any;
        data["reportInailOrCiva"] = this.reportInailOrCiva;
        data["notes"] = this.notes;
        return data;
    }

    clone(): PhotovoltaicSystemDto {
        const json = this.toJSON();
        let result = new PhotovoltaicSystemDto();
        result.init(json);
        return result;
    }
}

export interface IPhotovoltaicSystemDto {
    id: number;
    name: string | undefined;
    plantConformityDeclaration: boolean;
    plantConformityDeclarationFile: FileDto;
    project: boolean;
    projectFile: FileDto;
    reportInailOrCiva: boolean;
    notes: string | undefined;
}

export class PhotovoltaicSystemDtoPagedResultDto implements IPhotovoltaicSystemDtoPagedResultDto {
    items!: PhotovoltaicSystemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IPhotovoltaicSystemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PhotovoltaicSystemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): PhotovoltaicSystemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PhotovoltaicSystemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): PhotovoltaicSystemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new PhotovoltaicSystemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IPhotovoltaicSystemDtoPagedResultDto {
    items: PhotovoltaicSystemDto[] | undefined;
    totalCount: number;
}

export class ProtectionMeasureDto implements IProtectionMeasureDto {
    id!: number;
    provisionType!: DictionaryDto;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    note!: string | undefined;

    constructor(data?: IProtectionMeasureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.provisionType = _data["provisionType"] ? DictionaryDto.fromJS(_data["provisionType"]) : undefined as any;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ProtectionMeasureDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProtectionMeasureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["provisionType"] = this.provisionType ? this.provisionType.toJSON() : undefined as any;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.format('YYYY-MM-DD') : undefined as any;
        data["note"] = this.note;
        return data;
    }

    clone(): ProtectionMeasureDto {
        const json = this.toJSON();
        let result = new ProtectionMeasureDto();
        result.init(json);
        return result;
    }
}

export interface IProtectionMeasureDto {
    id: number;
    provisionType: DictionaryDto;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    note: string | undefined;
}

export class ProtectionMeasureDtoPagedResultDto implements IProtectionMeasureDtoPagedResultDto {
    items!: ProtectionMeasureDto[] | undefined;
    totalCount!: number;

    constructor(data?: IProtectionMeasureDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProtectionMeasureDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ProtectionMeasureDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProtectionMeasureDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ProtectionMeasureDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ProtectionMeasureDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IProtectionMeasureDtoPagedResultDto {
    items: ProtectionMeasureDto[] | undefined;
    totalCount: number;
}

export class ProvinceDto implements IProvinceDto {
    id!: number;
    name!: string | undefined;
    abbreviation!: string | undefined;
    region!: RegionDto;

    constructor(data?: IProvinceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.abbreviation = _data["abbreviation"];
            this.region = _data["region"] ? RegionDto.fromJS(_data["region"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProvinceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProvinceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["abbreviation"] = this.abbreviation;
        data["region"] = this.region ? this.region.toJSON() : undefined as any;
        return data;
    }

    clone(): ProvinceDto {
        const json = this.toJSON();
        let result = new ProvinceDto();
        result.init(json);
        return result;
    }
}

export interface IProvinceDto {
    id: number;
    name: string | undefined;
    abbreviation: string | undefined;
    region: RegionDto;
}

export class ReconciliationCaseDto implements IReconciliationCaseDto {
    isBaseRecognition!: boolean;
    isModifiedRecognition!: boolean;
    isNewPrescriptionRecognition!: boolean;

    constructor(data?: IReconciliationCaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isBaseRecognition = _data["isBaseRecognition"];
            this.isModifiedRecognition = _data["isModifiedRecognition"];
            this.isNewPrescriptionRecognition = _data["isNewPrescriptionRecognition"];
        }
    }

    static fromJS(data: any): ReconciliationCaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReconciliationCaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isBaseRecognition"] = this.isBaseRecognition;
        data["isModifiedRecognition"] = this.isModifiedRecognition;
        data["isNewPrescriptionRecognition"] = this.isNewPrescriptionRecognition;
        return data;
    }

    clone(): ReconciliationCaseDto {
        const json = this.toJSON();
        let result = new ReconciliationCaseDto();
        result.init(json);
        return result;
    }
}

export interface IReconciliationCaseDto {
    isBaseRecognition: boolean;
    isModifiedRecognition: boolean;
    isNewPrescriptionRecognition: boolean;
}

export class ReconciliationPharmacologicalRecordDto implements IReconciliationPharmacologicalRecordDto {
    id!: number;
    date!: moment.Moment;
    socialHealthRecordId!: number;
    room!: string | undefined;
    bed!: string | undefined;
    reconciliationPharmacologicalSomministrationRecognitions!: ReconciliationPharmacologicalSomministrationRecognitionDto[] | undefined;
    observation!: string | undefined;
    allergyOrIntolerance!: string | undefined;
    reconciliationInformation!: DictionaryDto[] | undefined;
    reconciliationInformationOther!: string | undefined;
    signatures!: ConfirmationSignatureDto[] | undefined;

    constructor(data?: IReconciliationPharmacologicalRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.room = _data["room"];
            this.bed = _data["bed"];
            if (Array.isArray(_data["reconciliationPharmacologicalSomministrationRecognitions"])) {
                this.reconciliationPharmacologicalSomministrationRecognitions = [] as any;
                for (let item of _data["reconciliationPharmacologicalSomministrationRecognitions"])
                    this.reconciliationPharmacologicalSomministrationRecognitions!.push(ReconciliationPharmacologicalSomministrationRecognitionDto.fromJS(item));
            }
            this.observation = _data["observation"];
            this.allergyOrIntolerance = _data["allergyOrIntolerance"];
            if (Array.isArray(_data["reconciliationInformation"])) {
                this.reconciliationInformation = [] as any;
                for (let item of _data["reconciliationInformation"])
                    this.reconciliationInformation!.push(DictionaryDto.fromJS(item));
            }
            this.reconciliationInformationOther = _data["reconciliationInformationOther"];
            if (Array.isArray(_data["signatures"])) {
                this.signatures = [] as any;
                for (let item of _data["signatures"])
                    this.signatures!.push(ConfirmationSignatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReconciliationPharmacologicalRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReconciliationPharmacologicalRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["room"] = this.room;
        data["bed"] = this.bed;
        if (Array.isArray(this.reconciliationPharmacologicalSomministrationRecognitions)) {
            data["reconciliationPharmacologicalSomministrationRecognitions"] = [];
            for (let item of this.reconciliationPharmacologicalSomministrationRecognitions)
                data["reconciliationPharmacologicalSomministrationRecognitions"].push(item ? item.toJSON() : undefined as any);
        }
        data["observation"] = this.observation;
        data["allergyOrIntolerance"] = this.allergyOrIntolerance;
        if (Array.isArray(this.reconciliationInformation)) {
            data["reconciliationInformation"] = [];
            for (let item of this.reconciliationInformation)
                data["reconciliationInformation"].push(item ? item.toJSON() : undefined as any);
        }
        data["reconciliationInformationOther"] = this.reconciliationInformationOther;
        if (Array.isArray(this.signatures)) {
            data["signatures"] = [];
            for (let item of this.signatures)
                data["signatures"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ReconciliationPharmacologicalRecordDto {
        const json = this.toJSON();
        let result = new ReconciliationPharmacologicalRecordDto();
        result.init(json);
        return result;
    }
}

export interface IReconciliationPharmacologicalRecordDto {
    id: number;
    date: moment.Moment;
    socialHealthRecordId: number;
    room: string | undefined;
    bed: string | undefined;
    reconciliationPharmacologicalSomministrationRecognitions: ReconciliationPharmacologicalSomministrationRecognitionDto[] | undefined;
    observation: string | undefined;
    allergyOrIntolerance: string | undefined;
    reconciliationInformation: DictionaryDto[] | undefined;
    reconciliationInformationOther: string | undefined;
    signatures: ConfirmationSignatureDto[] | undefined;
}

export class ReconciliationPharmacologicalRecordItemDto implements IReconciliationPharmacologicalRecordItemDto {
    id!: number;
    date!: moment.Moment;
    socialHealthRecordId!: number;
    room!: string | undefined;
    bed!: string | undefined;
    signatures!: ConfirmationSignatureDto[] | undefined;

    constructor(data?: IReconciliationPharmacologicalRecordItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.room = _data["room"];
            this.bed = _data["bed"];
            if (Array.isArray(_data["signatures"])) {
                this.signatures = [] as any;
                for (let item of _data["signatures"])
                    this.signatures!.push(ConfirmationSignatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReconciliationPharmacologicalRecordItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReconciliationPharmacologicalRecordItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["room"] = this.room;
        data["bed"] = this.bed;
        if (Array.isArray(this.signatures)) {
            data["signatures"] = [];
            for (let item of this.signatures)
                data["signatures"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ReconciliationPharmacologicalRecordItemDto {
        const json = this.toJSON();
        let result = new ReconciliationPharmacologicalRecordItemDto();
        result.init(json);
        return result;
    }
}

export interface IReconciliationPharmacologicalRecordItemDto {
    id: number;
    date: moment.Moment;
    socialHealthRecordId: number;
    room: string | undefined;
    bed: string | undefined;
    signatures: ConfirmationSignatureDto[] | undefined;
}

export class ReconciliationPharmacologicalRecordItemDtoPagedResultDto implements IReconciliationPharmacologicalRecordItemDtoPagedResultDto {
    items!: ReconciliationPharmacologicalRecordItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IReconciliationPharmacologicalRecordItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReconciliationPharmacologicalRecordItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ReconciliationPharmacologicalRecordItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReconciliationPharmacologicalRecordItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ReconciliationPharmacologicalRecordItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ReconciliationPharmacologicalRecordItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IReconciliationPharmacologicalRecordItemDtoPagedResultDto {
    items: ReconciliationPharmacologicalRecordItemDto[] | undefined;
    totalCount: number;
}

export class ReconciliationPharmacologicalSomministrationRecognitionDto implements IReconciliationPharmacologicalSomministrationRecognitionDto {
    id!: number;
    drugName!: string | undefined;
    formAndDosage!: string | undefined;
    somministrationMethod!: DictionaryDto;
    somministrationMethodOther!: string | undefined;
    dosageDaily!: string | undefined;
    startDate!: moment.Moment | undefined;
    duration!: string | undefined;
    dateTimeLastDose!: moment.Moment | undefined;
    modifiedReconciliationPharmacologicalSomministrationRecognitions!: ReconciliationPharmacologicalSomministrationRecognitionDto[] | undefined;
    reconciliationPharmacologicalSomministrationReconciliation!: ReconciliationPharmacologicalSomministrationReconciliationDto;
    isNewPrescription!: boolean | undefined;
    isConfirmed!: boolean;
    confirmingUserId!: number | undefined;
    confirmationDate!: moment.Moment | undefined;
    confirmingUserFullName!: string | undefined;

    constructor(data?: IReconciliationPharmacologicalSomministrationRecognitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.drugName = _data["drugName"];
            this.formAndDosage = _data["formAndDosage"];
            this.somministrationMethod = _data["somministrationMethod"] ? DictionaryDto.fromJS(_data["somministrationMethod"]) : undefined as any;
            this.somministrationMethodOther = _data["somministrationMethodOther"];
            this.dosageDaily = _data["dosageDaily"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.duration = _data["duration"];
            this.dateTimeLastDose = _data["dateTimeLastDose"] ? moment(_data["dateTimeLastDose"].toString()) : undefined as any;
            if (Array.isArray(_data["modifiedReconciliationPharmacologicalSomministrationRecognitions"])) {
                this.modifiedReconciliationPharmacologicalSomministrationRecognitions = [] as any;
                for (let item of _data["modifiedReconciliationPharmacologicalSomministrationRecognitions"])
                    this.modifiedReconciliationPharmacologicalSomministrationRecognitions!.push(ReconciliationPharmacologicalSomministrationRecognitionDto.fromJS(item));
            }
            this.reconciliationPharmacologicalSomministrationReconciliation = _data["reconciliationPharmacologicalSomministrationReconciliation"] ? ReconciliationPharmacologicalSomministrationReconciliationDto.fromJS(_data["reconciliationPharmacologicalSomministrationReconciliation"]) : undefined as any;
            this.isNewPrescription = _data["isNewPrescription"];
            this.isConfirmed = _data["isConfirmed"];
            this.confirmingUserId = _data["confirmingUserId"];
            this.confirmationDate = _data["confirmationDate"] ? moment(_data["confirmationDate"].toString()) : undefined as any;
            this.confirmingUserFullName = _data["confirmingUserFullName"];
        }
    }

    static fromJS(data: any): ReconciliationPharmacologicalSomministrationRecognitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReconciliationPharmacologicalSomministrationRecognitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["drugName"] = this.drugName;
        data["formAndDosage"] = this.formAndDosage;
        data["somministrationMethod"] = this.somministrationMethod ? this.somministrationMethod.toJSON() : undefined as any;
        data["somministrationMethodOther"] = this.somministrationMethodOther;
        data["dosageDaily"] = this.dosageDaily;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["duration"] = this.duration;
        data["dateTimeLastDose"] = this.dateTimeLastDose ? this.dateTimeLastDose.toISOString() : undefined as any;
        if (Array.isArray(this.modifiedReconciliationPharmacologicalSomministrationRecognitions)) {
            data["modifiedReconciliationPharmacologicalSomministrationRecognitions"] = [];
            for (let item of this.modifiedReconciliationPharmacologicalSomministrationRecognitions)
                data["modifiedReconciliationPharmacologicalSomministrationRecognitions"].push(item ? item.toJSON() : undefined as any);
        }
        data["reconciliationPharmacologicalSomministrationReconciliation"] = this.reconciliationPharmacologicalSomministrationReconciliation ? this.reconciliationPharmacologicalSomministrationReconciliation.toJSON() : undefined as any;
        data["isNewPrescription"] = this.isNewPrescription;
        data["isConfirmed"] = this.isConfirmed;
        data["confirmingUserId"] = this.confirmingUserId;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : undefined as any;
        data["confirmingUserFullName"] = this.confirmingUserFullName;
        return data;
    }

    clone(): ReconciliationPharmacologicalSomministrationRecognitionDto {
        const json = this.toJSON();
        let result = new ReconciliationPharmacologicalSomministrationRecognitionDto();
        result.init(json);
        return result;
    }
}

export interface IReconciliationPharmacologicalSomministrationRecognitionDto {
    id: number;
    drugName: string | undefined;
    formAndDosage: string | undefined;
    somministrationMethod: DictionaryDto;
    somministrationMethodOther: string | undefined;
    dosageDaily: string | undefined;
    startDate: moment.Moment | undefined;
    duration: string | undefined;
    dateTimeLastDose: moment.Moment | undefined;
    modifiedReconciliationPharmacologicalSomministrationRecognitions: ReconciliationPharmacologicalSomministrationRecognitionDto[] | undefined;
    reconciliationPharmacologicalSomministrationReconciliation: ReconciliationPharmacologicalSomministrationReconciliationDto;
    isNewPrescription: boolean | undefined;
    isConfirmed: boolean;
    confirmingUserId: number | undefined;
    confirmationDate: moment.Moment | undefined;
    confirmingUserFullName: string | undefined;
}

export class ReconciliationPharmacologicalSomministrationRecognitionDtoPagedResultDto implements IReconciliationPharmacologicalSomministrationRecognitionDtoPagedResultDto {
    items!: ReconciliationPharmacologicalSomministrationRecognitionDto[] | undefined;
    totalCount!: number;

    constructor(data?: IReconciliationPharmacologicalSomministrationRecognitionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReconciliationPharmacologicalSomministrationRecognitionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ReconciliationPharmacologicalSomministrationRecognitionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReconciliationPharmacologicalSomministrationRecognitionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ReconciliationPharmacologicalSomministrationRecognitionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ReconciliationPharmacologicalSomministrationRecognitionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IReconciliationPharmacologicalSomministrationRecognitionDtoPagedResultDto {
    items: ReconciliationPharmacologicalSomministrationRecognitionDto[] | undefined;
    totalCount: number;
}

export class ReconciliationPharmacologicalSomministrationReconciliationDto implements IReconciliationPharmacologicalSomministrationReconciliationDto {
    id!: number;
    isBaseRecognition!: boolean;
    isModifiedRecognition!: boolean;
    isNewPrescriptionRecognition!: boolean;
    continue!: boolean | undefined;
    interrupt!: boolean | undefined;
    modify!: boolean | undefined;
    getStarted!: boolean | undefined;
    motivation!: string | undefined;
    isConfirmed!: boolean;
    confirmingUserId!: number | undefined;
    confirmationDate!: moment.Moment | undefined;
    confirmingUserFullName!: string | undefined;

    constructor(data?: IReconciliationPharmacologicalSomministrationReconciliationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isBaseRecognition = _data["isBaseRecognition"];
            this.isModifiedRecognition = _data["isModifiedRecognition"];
            this.isNewPrescriptionRecognition = _data["isNewPrescriptionRecognition"];
            this.continue = _data["continue"];
            this.interrupt = _data["interrupt"];
            this.modify = _data["modify"];
            this.getStarted = _data["getStarted"];
            this.motivation = _data["motivation"];
            this.isConfirmed = _data["isConfirmed"];
            this.confirmingUserId = _data["confirmingUserId"];
            this.confirmationDate = _data["confirmationDate"] ? moment(_data["confirmationDate"].toString()) : undefined as any;
            this.confirmingUserFullName = _data["confirmingUserFullName"];
        }
    }

    static fromJS(data: any): ReconciliationPharmacologicalSomministrationReconciliationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReconciliationPharmacologicalSomministrationReconciliationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isBaseRecognition"] = this.isBaseRecognition;
        data["isModifiedRecognition"] = this.isModifiedRecognition;
        data["isNewPrescriptionRecognition"] = this.isNewPrescriptionRecognition;
        data["continue"] = this.continue;
        data["interrupt"] = this.interrupt;
        data["modify"] = this.modify;
        data["getStarted"] = this.getStarted;
        data["motivation"] = this.motivation;
        data["isConfirmed"] = this.isConfirmed;
        data["confirmingUserId"] = this.confirmingUserId;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : undefined as any;
        data["confirmingUserFullName"] = this.confirmingUserFullName;
        return data;
    }

    clone(): ReconciliationPharmacologicalSomministrationReconciliationDto {
        const json = this.toJSON();
        let result = new ReconciliationPharmacologicalSomministrationReconciliationDto();
        result.init(json);
        return result;
    }
}

export interface IReconciliationPharmacologicalSomministrationReconciliationDto {
    id: number;
    isBaseRecognition: boolean;
    isModifiedRecognition: boolean;
    isNewPrescriptionRecognition: boolean;
    continue: boolean | undefined;
    interrupt: boolean | undefined;
    modify: boolean | undefined;
    getStarted: boolean | undefined;
    motivation: string | undefined;
    isConfirmed: boolean;
    confirmingUserId: number | undefined;
    confirmationDate: moment.Moment | undefined;
    confirmingUserFullName: string | undefined;
}

export class ReconciliationPharmacologicalSomministrationReconciliationDtoPagedResultDto implements IReconciliationPharmacologicalSomministrationReconciliationDtoPagedResultDto {
    items!: ReconciliationPharmacologicalSomministrationReconciliationDto[] | undefined;
    totalCount!: number;

    constructor(data?: IReconciliationPharmacologicalSomministrationReconciliationDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ReconciliationPharmacologicalSomministrationReconciliationDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ReconciliationPharmacologicalSomministrationReconciliationDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReconciliationPharmacologicalSomministrationReconciliationDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ReconciliationPharmacologicalSomministrationReconciliationDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ReconciliationPharmacologicalSomministrationReconciliationDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IReconciliationPharmacologicalSomministrationReconciliationDtoPagedResultDto {
    items: ReconciliationPharmacologicalSomministrationReconciliationDto[] | undefined;
    totalCount: number;
}

export class RecordDto implements IRecordDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;

    constructor(data?: IRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): RecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }

    clone(): RecordDto {
        const json = this.toJSON();
        let result = new RecordDto();
        result.init(json);
        return result;
    }
}

export interface IRecordDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
}

export class RecordDtoPagedResultDto implements IRecordDtoPagedResultDto {
    items!: RecordDto[] | undefined;
    totalCount!: number;

    constructor(data?: IRecordDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RecordDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RecordDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecordDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RecordDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RecordDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRecordDtoPagedResultDto {
    items: RecordDto[] | undefined;
    totalCount: number;
}

export class RegionDto implements IRegionDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): RegionDto {
        const json = this.toJSON();
        let result = new RegionDto();
        result.init(json);
        return result;
    }
}

export interface IRegionDto {
    id: number;
    name: string | undefined;
}

export class RegisterInput implements IRegisterInput {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string | undefined;
    password!: string;
    captchaResponse!: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }

    clone(): RegisterInput {
        const json = this.toJSON();
        let result = new RegisterInput();
        result.init(json);
        return result;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string | undefined;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin!: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }

    clone(): RegisterOutput {
        const json = this.toJSON();
        let result = new RegisterOutput();
        result.init(json);
        return result;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class RehabilitationRecordDto implements IRehabilitationRecordDto {
    id!: number;
    date!: moment.Moment;
    diagnosis!: string | undefined;
    generalCondition!: DictionaryDto;
    mentalState!: DictionaryDto;
    activity!: DictionaryDto;
    mobility!: DictionaryDto;
    presenceSores!: DictionaryDto;
    note!: string | undefined;
    treatments!: DictionaryDto[] | undefined;
    isSecondConfirmed!: boolean;
    secondConfirmingUserId!: number | undefined;
    secondConfirmationDate!: moment.Moment | undefined;
    secondConfirmingUserFullName!: string | undefined;
    isConfirmed!: boolean;
    confirmingUserId!: number | undefined;
    confirmationDate!: moment.Moment | undefined;
    confirmingUserFullName!: string | undefined;

    constructor(data?: IRehabilitationRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.diagnosis = _data["diagnosis"];
            this.generalCondition = _data["generalCondition"] ? DictionaryDto.fromJS(_data["generalCondition"]) : undefined as any;
            this.mentalState = _data["mentalState"] ? DictionaryDto.fromJS(_data["mentalState"]) : undefined as any;
            this.activity = _data["activity"] ? DictionaryDto.fromJS(_data["activity"]) : undefined as any;
            this.mobility = _data["mobility"] ? DictionaryDto.fromJS(_data["mobility"]) : undefined as any;
            this.presenceSores = _data["presenceSores"] ? DictionaryDto.fromJS(_data["presenceSores"]) : undefined as any;
            this.note = _data["note"];
            if (Array.isArray(_data["treatments"])) {
                this.treatments = [] as any;
                for (let item of _data["treatments"])
                    this.treatments!.push(DictionaryDto.fromJS(item));
            }
            this.isSecondConfirmed = _data["isSecondConfirmed"];
            this.secondConfirmingUserId = _data["secondConfirmingUserId"];
            this.secondConfirmationDate = _data["secondConfirmationDate"] ? moment(_data["secondConfirmationDate"].toString()) : undefined as any;
            this.secondConfirmingUserFullName = _data["secondConfirmingUserFullName"];
            this.isConfirmed = _data["isConfirmed"];
            this.confirmingUserId = _data["confirmingUserId"];
            this.confirmationDate = _data["confirmationDate"] ? moment(_data["confirmationDate"].toString()) : undefined as any;
            this.confirmingUserFullName = _data["confirmingUserFullName"];
        }
    }

    static fromJS(data: any): RehabilitationRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new RehabilitationRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["diagnosis"] = this.diagnosis;
        data["generalCondition"] = this.generalCondition ? this.generalCondition.toJSON() : undefined as any;
        data["mentalState"] = this.mentalState ? this.mentalState.toJSON() : undefined as any;
        data["activity"] = this.activity ? this.activity.toJSON() : undefined as any;
        data["mobility"] = this.mobility ? this.mobility.toJSON() : undefined as any;
        data["presenceSores"] = this.presenceSores ? this.presenceSores.toJSON() : undefined as any;
        data["note"] = this.note;
        if (Array.isArray(this.treatments)) {
            data["treatments"] = [];
            for (let item of this.treatments)
                data["treatments"].push(item ? item.toJSON() : undefined as any);
        }
        data["isSecondConfirmed"] = this.isSecondConfirmed;
        data["secondConfirmingUserId"] = this.secondConfirmingUserId;
        data["secondConfirmationDate"] = this.secondConfirmationDate ? this.secondConfirmationDate.toISOString() : undefined as any;
        data["secondConfirmingUserFullName"] = this.secondConfirmingUserFullName;
        data["isConfirmed"] = this.isConfirmed;
        data["confirmingUserId"] = this.confirmingUserId;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : undefined as any;
        data["confirmingUserFullName"] = this.confirmingUserFullName;
        return data;
    }

    clone(): RehabilitationRecordDto {
        const json = this.toJSON();
        let result = new RehabilitationRecordDto();
        result.init(json);
        return result;
    }
}

export interface IRehabilitationRecordDto {
    id: number;
    date: moment.Moment;
    diagnosis: string | undefined;
    generalCondition: DictionaryDto;
    mentalState: DictionaryDto;
    activity: DictionaryDto;
    mobility: DictionaryDto;
    presenceSores: DictionaryDto;
    note: string | undefined;
    treatments: DictionaryDto[] | undefined;
    isSecondConfirmed: boolean;
    secondConfirmingUserId: number | undefined;
    secondConfirmationDate: moment.Moment | undefined;
    secondConfirmingUserFullName: string | undefined;
    isConfirmed: boolean;
    confirmingUserId: number | undefined;
    confirmationDate: moment.Moment | undefined;
    confirmingUserFullName: string | undefined;
}

export class RehabilitationRecordDtoPagedResultDto implements IRehabilitationRecordDtoPagedResultDto {
    items!: RehabilitationRecordDto[] | undefined;
    totalCount!: number;

    constructor(data?: IRehabilitationRecordDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RehabilitationRecordDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RehabilitationRecordDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RehabilitationRecordDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RehabilitationRecordDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RehabilitationRecordDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRehabilitationRecordDtoPagedResultDto {
    items: RehabilitationRecordDto[] | undefined;
    totalCount: number;
}

export class RelativeDto implements IRelativeDto {
    id!: number;
    kinshipDegree!: DictionaryDto;
    nominative!: string | undefined;

    constructor(data?: IRelativeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kinshipDegree = _data["kinshipDegree"] ? DictionaryDto.fromJS(_data["kinshipDegree"]) : undefined as any;
            this.nominative = _data["nominative"];
        }
    }

    static fromJS(data: any): RelativeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelativeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kinshipDegree"] = this.kinshipDegree ? this.kinshipDegree.toJSON() : undefined as any;
        data["nominative"] = this.nominative;
        return data;
    }

    clone(): RelativeDto {
        const json = this.toJSON();
        let result = new RelativeDto();
        result.init(json);
        return result;
    }
}

export interface IRelativeDto {
    id: number;
    kinshipDegree: DictionaryDto;
    nominative: string | undefined;
}

export class RelativeDtoPagedResultDto implements IRelativeDtoPagedResultDto {
    items!: RelativeDto[] | undefined;
    totalCount!: number;

    constructor(data?: IRelativeDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RelativeDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RelativeDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelativeDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RelativeDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RelativeDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRelativeDtoPagedResultDto {
    items: RelativeDto[] | undefined;
    totalCount: number;
}

export class RescheduleMyActivityInput implements IRescheduleMyActivityInput {
    id!: number;
    occurrenceStart!: moment.Moment | undefined;
    newStart!: moment.Moment;
    newEnd!: moment.Moment;

    constructor(data?: IRescheduleMyActivityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.occurrenceStart = _data["occurrenceStart"] ? moment(_data["occurrenceStart"].toString()) : undefined as any;
            this.newStart = _data["newStart"] ? moment(_data["newStart"].toString()) : undefined as any;
            this.newEnd = _data["newEnd"] ? moment(_data["newEnd"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RescheduleMyActivityInput {
        data = typeof data === 'object' ? data : {};
        let result = new RescheduleMyActivityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["occurrenceStart"] = this.occurrenceStart ? this.occurrenceStart.toISOString() : undefined as any;
        data["newStart"] = this.newStart ? this.newStart.toISOString() : undefined as any;
        data["newEnd"] = this.newEnd ? this.newEnd.toISOString() : undefined as any;
        return data;
    }

    clone(): RescheduleMyActivityInput {
        const json = this.toJSON();
        let result = new RescheduleMyActivityInput();
        result.init(json);
        return result;
    }
}

export interface IRescheduleMyActivityInput {
    id: number;
    occurrenceStart: moment.Moment | undefined;
    newStart: moment.Moment;
    newEnd: moment.Moment;
}

export class ResetPasswordResultDto implements IResetPasswordResultDto {
    result!: IdentityResult;
    userId!: number;
    isUserActive!: boolean;

    constructor(data?: IResetPasswordResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? IdentityResult.fromJS(_data["result"]) : undefined as any;
            this.userId = _data["userId"];
            this.isUserActive = _data["isUserActive"];
        }
    }

    static fromJS(data: any): ResetPasswordResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        data["userId"] = this.userId;
        data["isUserActive"] = this.isUserActive;
        return data;
    }

    clone(): ResetPasswordResultDto {
        const json = this.toJSON();
        let result = new ResetPasswordResultDto();
        result.init(json);
        return result;
    }
}

export interface IResetPasswordResultDto {
    result: IdentityResult;
    userId: number;
    isUserActive: boolean;
}

export class ResponseObservationGridDto implements IResponseObservationGridDto {
    id!: number;
    responseType!: DictionaryDto;
    description!: string | undefined;
    scopeObservationGrid!: ScopeObservationGridDto;
    measurementScale!: DictionaryDto;

    constructor(data?: IResponseObservationGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.responseType = _data["responseType"] ? DictionaryDto.fromJS(_data["responseType"]) : undefined as any;
            this.description = _data["description"];
            this.scopeObservationGrid = _data["scopeObservationGrid"] ? ScopeObservationGridDto.fromJS(_data["scopeObservationGrid"]) : undefined as any;
            this.measurementScale = _data["measurementScale"] ? DictionaryDto.fromJS(_data["measurementScale"]) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseObservationGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseObservationGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["responseType"] = this.responseType ? this.responseType.toJSON() : undefined as any;
        data["description"] = this.description;
        data["scopeObservationGrid"] = this.scopeObservationGrid ? this.scopeObservationGrid.toJSON() : undefined as any;
        data["measurementScale"] = this.measurementScale ? this.measurementScale.toJSON() : undefined as any;
        return data;
    }

    clone(): ResponseObservationGridDto {
        const json = this.toJSON();
        let result = new ResponseObservationGridDto();
        result.init(json);
        return result;
    }
}

export interface IResponseObservationGridDto {
    id: number;
    responseType: DictionaryDto;
    description: string | undefined;
    scopeObservationGrid: ScopeObservationGridDto;
    measurementScale: DictionaryDto;
}

export class ResponseObservationGridItemDto implements IResponseObservationGridItemDto {
    id!: number;
    responseType!: DictionaryDto;
    description!: string | undefined;
    scopeObservationGrid!: ScopeObservationGridDto;
    measurementScale!: DictionaryDto;
    observationGridDate!: moment.Moment | undefined;

    constructor(data?: IResponseObservationGridItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.responseType = _data["responseType"] ? DictionaryDto.fromJS(_data["responseType"]) : undefined as any;
            this.description = _data["description"];
            this.scopeObservationGrid = _data["scopeObservationGrid"] ? ScopeObservationGridDto.fromJS(_data["scopeObservationGrid"]) : undefined as any;
            this.measurementScale = _data["measurementScale"] ? DictionaryDto.fromJS(_data["measurementScale"]) : undefined as any;
            this.observationGridDate = _data["observationGridDate"] ? moment(_data["observationGridDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ResponseObservationGridItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseObservationGridItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["responseType"] = this.responseType ? this.responseType.toJSON() : undefined as any;
        data["description"] = this.description;
        data["scopeObservationGrid"] = this.scopeObservationGrid ? this.scopeObservationGrid.toJSON() : undefined as any;
        data["measurementScale"] = this.measurementScale ? this.measurementScale.toJSON() : undefined as any;
        data["observationGridDate"] = this.observationGridDate ? this.observationGridDate.toISOString() : undefined as any;
        return data;
    }

    clone(): ResponseObservationGridItemDto {
        const json = this.toJSON();
        let result = new ResponseObservationGridItemDto();
        result.init(json);
        return result;
    }
}

export interface IResponseObservationGridItemDto {
    id: number;
    responseType: DictionaryDto;
    description: string | undefined;
    scopeObservationGrid: ScopeObservationGridDto;
    measurementScale: DictionaryDto;
    observationGridDate: moment.Moment | undefined;
}

export class ResponseObservationGridItemDtoPagedResultDto implements IResponseObservationGridItemDtoPagedResultDto {
    items!: ResponseObservationGridItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IResponseObservationGridItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ResponseObservationGridItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ResponseObservationGridItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseObservationGridItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ResponseObservationGridItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ResponseObservationGridItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IResponseObservationGridItemDtoPagedResultDto {
    items: ResponseObservationGridItemDto[] | undefined;
    totalCount: number;
}

export class RoleDto implements IRoleDto {
    id!: number;
    name!: string;
    displayName!: string;
    normalizedName!: string | undefined;
    description!: string | undefined;
    grantedPermissions!: string[] | undefined;
    isStatic!: boolean;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.normalizedName = _data["normalizedName"];
            this.description = _data["description"];
            if (Array.isArray(_data["grantedPermissions"])) {
                this.grantedPermissions = [] as any;
                for (let item of _data["grantedPermissions"])
                    this.grantedPermissions!.push(item);
            }
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        if (Array.isArray(this.grantedPermissions)) {
            data["grantedPermissions"] = [];
            for (let item of this.grantedPermissions)
                data["grantedPermissions"].push(item);
        }
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): RoleDto {
        const json = this.toJSON();
        let result = new RoleDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDto {
    id: number;
    name: string;
    displayName: string;
    normalizedName: string | undefined;
    description: string | undefined;
    grantedPermissions: string[] | undefined;
    isStatic: boolean;
}

export class RoleDtoPagedResultDto implements IRoleDtoPagedResultDto {
    items!: RoleDto[] | undefined;
    totalCount!: number;

    constructor(data?: IRoleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RoleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RoleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleDtoPagedResultDto {
    items: RoleDto[] | undefined;
    totalCount: number;
}

export class RoleEditDto implements IRoleEditDto {
    id!: number;
    name!: string;
    displayName!: string;
    description!: string | undefined;
    isStatic!: boolean;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isStatic = _data["isStatic"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        return data;
    }

    clone(): RoleEditDto {
        const json = this.toJSON();
        let result = new RoleEditDto();
        result.init(json);
        return result;
    }
}

export interface IRoleEditDto {
    id: number;
    name: string;
    displayName: string;
    description: string | undefined;
    isStatic: boolean;
}

export class RoleListDto implements IRoleListDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    isStatic!: boolean;
    isDefault!: boolean;
    creationTime!: moment.Moment;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined as any;
        return data;
    }

    clone(): RoleListDto {
        const json = this.toJSON();
        let result = new RoleListDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    creationTime: moment.Moment;
}

export class RoleListDtoListResultDto implements IRoleListDtoListResultDto {
    items!: RoleListDto[] | undefined;

    constructor(data?: IRoleListDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoleListDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): RoleListDtoListResultDto {
        const json = this.toJSON();
        let result = new RoleListDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoleListDtoListResultDto {
    items: RoleListDto[] | undefined;
}

export class RoomDto implements IRoomDto {
    id!: number;
    name!: string | undefined;
    availableBeds!: number;
    structure!: StructureDto;

    constructor(data?: IRoomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.availableBeds = _data["availableBeds"];
            this.structure = _data["structure"] ? StructureDto.fromJS(_data["structure"]) : undefined as any;
        }
    }

    static fromJS(data: any): RoomDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["availableBeds"] = this.availableBeds;
        data["structure"] = this.structure ? this.structure.toJSON() : undefined as any;
        return data;
    }

    clone(): RoomDto {
        const json = this.toJSON();
        let result = new RoomDto();
        result.init(json);
        return result;
    }
}

export interface IRoomDto {
    id: number;
    name: string | undefined;
    availableBeds: number;
    structure: StructureDto;
}

export class RoomDtoPagedResultDto implements IRoomDtoPagedResultDto {
    items!: RoomDto[] | undefined;
    totalCount!: number;

    constructor(data?: IRoomDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoomDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): RoomDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): RoomDtoPagedResultDto {
        const json = this.toJSON();
        let result = new RoomDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IRoomDtoPagedResultDto {
    items: RoomDto[] | undefined;
    totalCount: number;
}

export class RoomOccupancyDto implements IRoomOccupancyDto {
    roomId!: number;
    name!: string | undefined;
    availableBeds!: number;
    occupiedBeds!: number;

    constructor(data?: IRoomOccupancyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roomId = _data["roomId"];
            this.name = _data["name"];
            this.availableBeds = _data["availableBeds"];
            this.occupiedBeds = _data["occupiedBeds"];
        }
    }

    static fromJS(data: any): RoomOccupancyDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomOccupancyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roomId"] = this.roomId;
        data["name"] = this.name;
        data["availableBeds"] = this.availableBeds;
        data["occupiedBeds"] = this.occupiedBeds;
        return data;
    }

    clone(): RoomOccupancyDto {
        const json = this.toJSON();
        let result = new RoomOccupancyDto();
        result.init(json);
        return result;
    }
}

export interface IRoomOccupancyDto {
    roomId: number;
    name: string | undefined;
    availableBeds: number;
    occupiedBeds: number;
}

export class SchoolWorkDto implements ISchoolWorkDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    levelFieldOfStudy!: string | undefined;
    institution!: string | undefined;
    completionYear!: string | undefined;

    constructor(data?: ISchoolWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.levelFieldOfStudy = _data["levelFieldOfStudy"];
            this.institution = _data["institution"];
            this.completionYear = _data["completionYear"];
        }
    }

    static fromJS(data: any): SchoolWorkDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["levelFieldOfStudy"] = this.levelFieldOfStudy;
        data["institution"] = this.institution;
        data["completionYear"] = this.completionYear;
        return data;
    }

    clone(): SchoolWorkDto {
        const json = this.toJSON();
        let result = new SchoolWorkDto();
        result.init(json);
        return result;
    }
}

export interface ISchoolWorkDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    levelFieldOfStudy: string | undefined;
    institution: string | undefined;
    completionYear: string | undefined;
}

export class SchoolWorkDtoPagedResultDto implements ISchoolWorkDtoPagedResultDto {
    items!: SchoolWorkDto[] | undefined;
    totalCount!: number;

    constructor(data?: ISchoolWorkDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SchoolWorkDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SchoolWorkDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SchoolWorkDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SchoolWorkDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SchoolWorkDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISchoolWorkDtoPagedResultDto {
    items: SchoolWorkDto[] | undefined;
    totalCount: number;
}

export class ScopeObservationGridDto implements IScopeObservationGridDto {
    id!: number;
    description!: string | undefined;
    categoryObservationGrid!: CategoryObservationGridDto;

    constructor(data?: IScopeObservationGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.categoryObservationGrid = _data["categoryObservationGrid"] ? CategoryObservationGridDto.fromJS(_data["categoryObservationGrid"]) : undefined as any;
        }
    }

    static fromJS(data: any): ScopeObservationGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScopeObservationGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["categoryObservationGrid"] = this.categoryObservationGrid ? this.categoryObservationGrid.toJSON() : undefined as any;
        return data;
    }

    clone(): ScopeObservationGridDto {
        const json = this.toJSON();
        let result = new ScopeObservationGridDto();
        result.init(json);
        return result;
    }
}

export interface IScopeObservationGridDto {
    id: number;
    description: string | undefined;
    categoryObservationGrid: CategoryObservationGridDto;
}

export class ScopeObservationGridDtoPagedResultDto implements IScopeObservationGridDtoPagedResultDto {
    items!: ScopeObservationGridDto[] | undefined;
    totalCount!: number;

    constructor(data?: IScopeObservationGridDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScopeObservationGridDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ScopeObservationGridDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScopeObservationGridDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ScopeObservationGridDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ScopeObservationGridDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IScopeObservationGridDtoPagedResultDto {
    items: ScopeObservationGridDto[] | undefined;
    totalCount: number;
}

export class SectionObservationGridDto implements ISectionObservationGridDto {
    id!: number;
    name!: string | undefined;
    dataSetObservationGrid!: DataSetObservationGridDto;

    constructor(data?: ISectionObservationGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dataSetObservationGrid = _data["dataSetObservationGrid"] ? DataSetObservationGridDto.fromJS(_data["dataSetObservationGrid"]) : undefined as any;
        }
    }

    static fromJS(data: any): SectionObservationGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new SectionObservationGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dataSetObservationGrid"] = this.dataSetObservationGrid ? this.dataSetObservationGrid.toJSON() : undefined as any;
        return data;
    }

    clone(): SectionObservationGridDto {
        const json = this.toJSON();
        let result = new SectionObservationGridDto();
        result.init(json);
        return result;
    }
}

export interface ISectionObservationGridDto {
    id: number;
    name: string | undefined;
    dataSetObservationGrid: DataSetObservationGridDto;
}

export class SectionObservationGridDtoPagedResultDto implements ISectionObservationGridDtoPagedResultDto {
    items!: SectionObservationGridDto[] | undefined;
    totalCount!: number;

    constructor(data?: ISectionObservationGridDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SectionObservationGridDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SectionObservationGridDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SectionObservationGridDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SectionObservationGridDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SectionObservationGridDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISectionObservationGridDtoPagedResultDto {
    items: SectionObservationGridDto[] | undefined;
    totalCount: number;
}

export class SectionOperatorPermissionDto implements ISectionOperatorPermissionDto {
    serviceUserId!: number;
    sectionObservationGridId!: number;

    constructor(data?: ISectionOperatorPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceUserId = _data["serviceUserId"];
            this.sectionObservationGridId = _data["sectionObservationGridId"];
        }
    }

    static fromJS(data: any): SectionOperatorPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SectionOperatorPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceUserId"] = this.serviceUserId;
        data["sectionObservationGridId"] = this.sectionObservationGridId;
        return data;
    }

    clone(): SectionOperatorPermissionDto {
        const json = this.toJSON();
        let result = new SectionOperatorPermissionDto();
        result.init(json);
        return result;
    }
}

export interface ISectionOperatorPermissionDto {
    serviceUserId: number;
    sectionObservationGridId: number;
}

export class ServiceAttendanceRegisterDto implements IServiceAttendanceRegisterDto {
    id!: number;
    serviceUser!: ServiceUserDto;
    date!: moment.Moment;
    isPresent!: boolean | undefined;
    employmentPeriods!: EmploymentPeriodDto[] | undefined;
    totalMinutesPresent!: number | undefined;

    constructor(data?: IServiceAttendanceRegisterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceUser = _data["serviceUser"] ? ServiceUserDto.fromJS(_data["serviceUser"]) : undefined as any;
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.isPresent = _data["isPresent"];
            if (Array.isArray(_data["employmentPeriods"])) {
                this.employmentPeriods = [] as any;
                for (let item of _data["employmentPeriods"])
                    this.employmentPeriods!.push(EmploymentPeriodDto.fromJS(item));
            }
            this.totalMinutesPresent = _data["totalMinutesPresent"];
        }
    }

    static fromJS(data: any): ServiceAttendanceRegisterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceAttendanceRegisterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceUser"] = this.serviceUser ? this.serviceUser.toJSON() : undefined as any;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined as any;
        data["isPresent"] = this.isPresent;
        if (Array.isArray(this.employmentPeriods)) {
            data["employmentPeriods"] = [];
            for (let item of this.employmentPeriods)
                data["employmentPeriods"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalMinutesPresent"] = this.totalMinutesPresent;
        return data;
    }

    clone(): ServiceAttendanceRegisterDto {
        const json = this.toJSON();
        let result = new ServiceAttendanceRegisterDto();
        result.init(json);
        return result;
    }
}

export interface IServiceAttendanceRegisterDto {
    id: number;
    serviceUser: ServiceUserDto;
    date: moment.Moment;
    isPresent: boolean | undefined;
    employmentPeriods: EmploymentPeriodDto[] | undefined;
    totalMinutesPresent: number | undefined;
}

export class ServiceAttendanceRegisterDtoPagedResultDto implements IServiceAttendanceRegisterDtoPagedResultDto {
    items!: ServiceAttendanceRegisterDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceAttendanceRegisterDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceAttendanceRegisterDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceAttendanceRegisterDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceAttendanceRegisterDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceAttendanceRegisterDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceAttendanceRegisterDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceAttendanceRegisterDtoPagedResultDto {
    items: ServiceAttendanceRegisterDto[] | undefined;
    totalCount: number;
}

export class ServiceAttendanceRegisterDtoServiceAttendanceRegisterPagedResultDto implements IServiceAttendanceRegisterDtoServiceAttendanceRegisterPagedResultDto {
    items!: ServiceAttendanceRegisterDto[] | undefined;
    totalCount!: number;
    totalMinutesPresent!: number;
    totalAttendance!: number;
    totalAbsences!: number;

    constructor(data?: IServiceAttendanceRegisterDtoServiceAttendanceRegisterPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceAttendanceRegisterDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
            this.totalMinutesPresent = _data["totalMinutesPresent"];
            this.totalAttendance = _data["totalAttendance"];
            this.totalAbsences = _data["totalAbsences"];
        }
    }

    static fromJS(data: any): ServiceAttendanceRegisterDtoServiceAttendanceRegisterPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceAttendanceRegisterDtoServiceAttendanceRegisterPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        data["totalMinutesPresent"] = this.totalMinutesPresent;
        data["totalAttendance"] = this.totalAttendance;
        data["totalAbsences"] = this.totalAbsences;
        return data;
    }

    clone(): ServiceAttendanceRegisterDtoServiceAttendanceRegisterPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceAttendanceRegisterDtoServiceAttendanceRegisterPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceAttendanceRegisterDtoServiceAttendanceRegisterPagedResultDto {
    items: ServiceAttendanceRegisterDto[] | undefined;
    totalCount: number;
    totalMinutesPresent: number;
    totalAttendance: number;
    totalAbsences: number;
}

export class ServiceAttendanceRegisterGetAllInput implements IServiceAttendanceRegisterGetAllInput {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    serviceUserIds!: number[] | undefined;
    date!: moment.Moment | undefined;
    startRangeDate!: moment.Moment | undefined;
    endRangeDate!: moment.Moment | undefined;
    serviceId!: number | undefined;

    constructor(data?: IServiceAttendanceRegisterGetAllInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            if (Array.isArray(_data["serviceUserIds"])) {
                this.serviceUserIds = [] as any;
                for (let item of _data["serviceUserIds"])
                    this.serviceUserIds!.push(item);
            }
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.startRangeDate = _data["startRangeDate"] ? moment(_data["startRangeDate"].toString()) : undefined as any;
            this.endRangeDate = _data["endRangeDate"] ? moment(_data["endRangeDate"].toString()) : undefined as any;
            this.serviceId = _data["serviceId"];
        }
    }

    static fromJS(data: any): ServiceAttendanceRegisterGetAllInput {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceAttendanceRegisterGetAllInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        if (Array.isArray(this.serviceUserIds)) {
            data["serviceUserIds"] = [];
            for (let item of this.serviceUserIds)
                data["serviceUserIds"].push(item);
        }
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined as any;
        data["startRangeDate"] = this.startRangeDate ? this.startRangeDate.toISOString() : undefined as any;
        data["endRangeDate"] = this.endRangeDate ? this.endRangeDate.toISOString() : undefined as any;
        data["serviceId"] = this.serviceId;
        return data;
    }

    clone(): ServiceAttendanceRegisterGetAllInput {
        const json = this.toJSON();
        let result = new ServiceAttendanceRegisterGetAllInput();
        result.init(json);
        return result;
    }
}

export interface IServiceAttendanceRegisterGetAllInput {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    serviceUserIds: number[] | undefined;
    date: moment.Moment | undefined;
    startRangeDate: moment.Moment | undefined;
    endRangeDate: moment.Moment | undefined;
    serviceId: number | undefined;
}

export class ServiceCheckRefrigeratorTemperatureDetailDto implements IServiceCheckRefrigeratorTemperatureDetailDto {
    id!: number;
    day!: number;
    temperature!: number | undefined;
    isConfirmed!: boolean;
    confirmingUserId!: number | undefined;
    confirmationDate!: moment.Moment | undefined;
    confirmingUserFullName!: string | undefined;

    constructor(data?: IServiceCheckRefrigeratorTemperatureDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.day = _data["day"];
            this.temperature = _data["temperature"];
            this.isConfirmed = _data["isConfirmed"];
            this.confirmingUserId = _data["confirmingUserId"];
            this.confirmationDate = _data["confirmationDate"] ? moment(_data["confirmationDate"].toString()) : undefined as any;
            this.confirmingUserFullName = _data["confirmingUserFullName"];
        }
    }

    static fromJS(data: any): ServiceCheckRefrigeratorTemperatureDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCheckRefrigeratorTemperatureDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["day"] = this.day;
        data["temperature"] = this.temperature;
        data["isConfirmed"] = this.isConfirmed;
        data["confirmingUserId"] = this.confirmingUserId;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : undefined as any;
        data["confirmingUserFullName"] = this.confirmingUserFullName;
        return data;
    }

    clone(): ServiceCheckRefrigeratorTemperatureDetailDto {
        const json = this.toJSON();
        let result = new ServiceCheckRefrigeratorTemperatureDetailDto();
        result.init(json);
        return result;
    }
}

export interface IServiceCheckRefrigeratorTemperatureDetailDto {
    id: number;
    day: number;
    temperature: number | undefined;
    isConfirmed: boolean;
    confirmingUserId: number | undefined;
    confirmationDate: moment.Moment | undefined;
    confirmingUserFullName: string | undefined;
}

export class ServiceCheckRefrigeratorTemperatureDetailDtoPagedResultDto implements IServiceCheckRefrigeratorTemperatureDetailDtoPagedResultDto {
    items!: ServiceCheckRefrigeratorTemperatureDetailDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceCheckRefrigeratorTemperatureDetailDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceCheckRefrigeratorTemperatureDetailDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceCheckRefrigeratorTemperatureDetailDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCheckRefrigeratorTemperatureDetailDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceCheckRefrigeratorTemperatureDetailDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceCheckRefrigeratorTemperatureDetailDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceCheckRefrigeratorTemperatureDetailDtoPagedResultDto {
    items: ServiceCheckRefrigeratorTemperatureDetailDto[] | undefined;
    totalCount: number;
}

export class ServiceCheckRefrigeratorTemperatureDto implements IServiceCheckRefrigeratorTemperatureDto {
    id!: number;
    serviceId!: number;
    month!: number;
    year!: number;
    serviceCheckRefrigeratorTemperatureDetails!: ServiceCheckRefrigeratorTemperatureDetailDto[] | undefined;

    constructor(data?: IServiceCheckRefrigeratorTemperatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.month = _data["month"];
            this.year = _data["year"];
            if (Array.isArray(_data["serviceCheckRefrigeratorTemperatureDetails"])) {
                this.serviceCheckRefrigeratorTemperatureDetails = [] as any;
                for (let item of _data["serviceCheckRefrigeratorTemperatureDetails"])
                    this.serviceCheckRefrigeratorTemperatureDetails!.push(ServiceCheckRefrigeratorTemperatureDetailDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceCheckRefrigeratorTemperatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCheckRefrigeratorTemperatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["month"] = this.month;
        data["year"] = this.year;
        if (Array.isArray(this.serviceCheckRefrigeratorTemperatureDetails)) {
            data["serviceCheckRefrigeratorTemperatureDetails"] = [];
            for (let item of this.serviceCheckRefrigeratorTemperatureDetails)
                data["serviceCheckRefrigeratorTemperatureDetails"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ServiceCheckRefrigeratorTemperatureDto {
        const json = this.toJSON();
        let result = new ServiceCheckRefrigeratorTemperatureDto();
        result.init(json);
        return result;
    }
}

export interface IServiceCheckRefrigeratorTemperatureDto {
    id: number;
    serviceId: number;
    month: number;
    year: number;
    serviceCheckRefrigeratorTemperatureDetails: ServiceCheckRefrigeratorTemperatureDetailDto[] | undefined;
}

export class ServiceCheckRefrigeratorTemperatureItemDto implements IServiceCheckRefrigeratorTemperatureItemDto {
    id!: number;
    serviceId!: number;
    year!: number;
    month!: number;

    constructor(data?: IServiceCheckRefrigeratorTemperatureItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceId = _data["serviceId"];
            this.year = _data["year"];
            this.month = _data["month"];
        }
    }

    static fromJS(data: any): ServiceCheckRefrigeratorTemperatureItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCheckRefrigeratorTemperatureItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceId"] = this.serviceId;
        data["year"] = this.year;
        data["month"] = this.month;
        return data;
    }

    clone(): ServiceCheckRefrigeratorTemperatureItemDto {
        const json = this.toJSON();
        let result = new ServiceCheckRefrigeratorTemperatureItemDto();
        result.init(json);
        return result;
    }
}

export interface IServiceCheckRefrigeratorTemperatureItemDto {
    id: number;
    serviceId: number;
    year: number;
    month: number;
}

export class ServiceCheckRefrigeratorTemperatureItemDtoPagedResultDto implements IServiceCheckRefrigeratorTemperatureItemDtoPagedResultDto {
    items!: ServiceCheckRefrigeratorTemperatureItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceCheckRefrigeratorTemperatureItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceCheckRefrigeratorTemperatureItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceCheckRefrigeratorTemperatureItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceCheckRefrigeratorTemperatureItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceCheckRefrigeratorTemperatureItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceCheckRefrigeratorTemperatureItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceCheckRefrigeratorTemperatureItemDtoPagedResultDto {
    items: ServiceCheckRefrigeratorTemperatureItemDto[] | undefined;
    totalCount: number;
}

export class ServiceDataCollectionDto implements IServiceDataCollectionDto {
    id!: number;
    date!: moment.Moment;
    laboratory!: DictionaryDto;
    serviceUser!: ServiceUserDto;
    objectives!: ServiceDataCollectionObjectiveDto[] | undefined;
    totalR!: number;
    totalNR!: number;
    totalP!: number;

    constructor(data?: IServiceDataCollectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.laboratory = _data["laboratory"] ? DictionaryDto.fromJS(_data["laboratory"]) : undefined as any;
            this.serviceUser = _data["serviceUser"] ? ServiceUserDto.fromJS(_data["serviceUser"]) : undefined as any;
            if (Array.isArray(_data["objectives"])) {
                this.objectives = [] as any;
                for (let item of _data["objectives"])
                    this.objectives!.push(ServiceDataCollectionObjectiveDto.fromJS(item));
            }
            this.totalR = _data["totalR"];
            this.totalNR = _data["totalNR"];
            this.totalP = _data["totalP"];
        }
    }

    static fromJS(data: any): ServiceDataCollectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDataCollectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["laboratory"] = this.laboratory ? this.laboratory.toJSON() : undefined as any;
        data["serviceUser"] = this.serviceUser ? this.serviceUser.toJSON() : undefined as any;
        if (Array.isArray(this.objectives)) {
            data["objectives"] = [];
            for (let item of this.objectives)
                data["objectives"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalR"] = this.totalR;
        data["totalNR"] = this.totalNR;
        data["totalP"] = this.totalP;
        return data;
    }

    clone(): ServiceDataCollectionDto {
        const json = this.toJSON();
        let result = new ServiceDataCollectionDto();
        result.init(json);
        return result;
    }
}

export interface IServiceDataCollectionDto {
    id: number;
    date: moment.Moment;
    laboratory: DictionaryDto;
    serviceUser: ServiceUserDto;
    objectives: ServiceDataCollectionObjectiveDto[] | undefined;
    totalR: number;
    totalNR: number;
    totalP: number;
}

export class ServiceDataCollectionItemDto implements IServiceDataCollectionItemDto {
    id!: number;
    date!: moment.Moment;
    laboratory!: DictionaryDto;
    serviceUser!: ServiceUserDto;

    constructor(data?: IServiceDataCollectionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.laboratory = _data["laboratory"] ? DictionaryDto.fromJS(_data["laboratory"]) : undefined as any;
            this.serviceUser = _data["serviceUser"] ? ServiceUserDto.fromJS(_data["serviceUser"]) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceDataCollectionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDataCollectionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["laboratory"] = this.laboratory ? this.laboratory.toJSON() : undefined as any;
        data["serviceUser"] = this.serviceUser ? this.serviceUser.toJSON() : undefined as any;
        return data;
    }

    clone(): ServiceDataCollectionItemDto {
        const json = this.toJSON();
        let result = new ServiceDataCollectionItemDto();
        result.init(json);
        return result;
    }
}

export interface IServiceDataCollectionItemDto {
    id: number;
    date: moment.Moment;
    laboratory: DictionaryDto;
    serviceUser: ServiceUserDto;
}

export class ServiceDataCollectionItemDtoPagedResultDto implements IServiceDataCollectionItemDtoPagedResultDto {
    items!: ServiceDataCollectionItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceDataCollectionItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceDataCollectionItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceDataCollectionItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDataCollectionItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceDataCollectionItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceDataCollectionItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceDataCollectionItemDtoPagedResultDto {
    items: ServiceDataCollectionItemDto[] | undefined;
    totalCount: number;
}

export class ServiceDataCollectionObjectiveDto implements IServiceDataCollectionObjectiveDto {
    id!: number;
    objective!: DictionaryDto;
    serviceDataCollectionResult!: DictionaryDto;

    constructor(data?: IServiceDataCollectionObjectiveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.objective = _data["objective"] ? DictionaryDto.fromJS(_data["objective"]) : undefined as any;
            this.serviceDataCollectionResult = _data["serviceDataCollectionResult"] ? DictionaryDto.fromJS(_data["serviceDataCollectionResult"]) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceDataCollectionObjectiveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDataCollectionObjectiveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["objective"] = this.objective ? this.objective.toJSON() : undefined as any;
        data["serviceDataCollectionResult"] = this.serviceDataCollectionResult ? this.serviceDataCollectionResult.toJSON() : undefined as any;
        return data;
    }

    clone(): ServiceDataCollectionObjectiveDto {
        const json = this.toJSON();
        let result = new ServiceDataCollectionObjectiveDto();
        result.init(json);
        return result;
    }
}

export interface IServiceDataCollectionObjectiveDto {
    id: number;
    objective: DictionaryDto;
    serviceDataCollectionResult: DictionaryDto;
}

export class ServiceDataCollectionObjectiveDtoPagedResultDto implements IServiceDataCollectionObjectiveDtoPagedResultDto {
    items!: ServiceDataCollectionObjectiveDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceDataCollectionObjectiveDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceDataCollectionObjectiveDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceDataCollectionObjectiveDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDataCollectionObjectiveDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceDataCollectionObjectiveDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceDataCollectionObjectiveDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceDataCollectionObjectiveDtoPagedResultDto {
    items: ServiceDataCollectionObjectiveDto[] | undefined;
    totalCount: number;
}

export class ServiceDto implements IServiceDto {
    id!: number;
    cloudFolderUrl!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    managerName!: string | undefined;
    managerPhoneNumber!: string | undefined;
    template!: ServiceTemplateDto;
    serviceSectors!: DictionaryDto[] | undefined;
    totalSeats!: number | undefined;
    address!: AddressDto;
    landline!: string | undefined;

    constructor(data?: IServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cloudFolderUrl = _data["cloudFolderUrl"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.managerName = _data["managerName"];
            this.managerPhoneNumber = _data["managerPhoneNumber"];
            this.template = _data["template"] ? ServiceTemplateDto.fromJS(_data["template"]) : undefined as any;
            if (Array.isArray(_data["serviceSectors"])) {
                this.serviceSectors = [] as any;
                for (let item of _data["serviceSectors"])
                    this.serviceSectors!.push(DictionaryDto.fromJS(item));
            }
            this.totalSeats = _data["totalSeats"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : undefined as any;
            this.landline = _data["landline"];
        }
    }

    static fromJS(data: any): ServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cloudFolderUrl"] = this.cloudFolderUrl;
        data["name"] = this.name;
        data["description"] = this.description;
        data["managerName"] = this.managerName;
        data["managerPhoneNumber"] = this.managerPhoneNumber;
        data["template"] = this.template ? this.template.toJSON() : undefined as any;
        if (Array.isArray(this.serviceSectors)) {
            data["serviceSectors"] = [];
            for (let item of this.serviceSectors)
                data["serviceSectors"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalSeats"] = this.totalSeats;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["landline"] = this.landline;
        return data;
    }

    clone(): ServiceDto {
        const json = this.toJSON();
        let result = new ServiceDto();
        result.init(json);
        return result;
    }
}

export interface IServiceDto {
    id: number;
    cloudFolderUrl: string | undefined;
    name: string | undefined;
    description: string | undefined;
    managerName: string | undefined;
    managerPhoneNumber: string | undefined;
    template: ServiceTemplateDto;
    serviceSectors: DictionaryDto[] | undefined;
    totalSeats: number | undefined;
    address: AddressDto;
    landline: string | undefined;
}

export class ServiceFileTagDto implements IServiceFileTagDto {
    id!: number;
    service!: ServiceDto;
    fileTag!: DictionaryDto;

    constructor(data?: IServiceFileTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.service = _data["service"] ? ServiceDto.fromJS(_data["service"]) : undefined as any;
            this.fileTag = _data["fileTag"] ? DictionaryDto.fromJS(_data["fileTag"]) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceFileTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceFileTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["service"] = this.service ? this.service.toJSON() : undefined as any;
        data["fileTag"] = this.fileTag ? this.fileTag.toJSON() : undefined as any;
        return data;
    }

    clone(): ServiceFileTagDto {
        const json = this.toJSON();
        let result = new ServiceFileTagDto();
        result.init(json);
        return result;
    }
}

export interface IServiceFileTagDto {
    id: number;
    service: ServiceDto;
    fileTag: DictionaryDto;
}

export class ServiceFileTagDtoPagedResultDto implements IServiceFileTagDtoPagedResultDto {
    items!: ServiceFileTagDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceFileTagDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceFileTagDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceFileTagDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceFileTagDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceFileTagDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceFileTagDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceFileTagDtoPagedResultDto {
    items: ServiceFileTagDto[] | undefined;
    totalCount: number;
}

export class ServiceGetAllInput implements IServiceGetAllInput {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    isPaginated!: boolean;
    keyword!: string | undefined;
    operatorIds!: number[] | undefined;
    beneficiaryIds!: number[] | undefined;
    organizationIds!: number[] | undefined;
    qualificationIds!: number[] | undefined;
    structureIds!: number[] | undefined;
    userIds!: number[] | undefined;
    serviceSectorIds!: number[] | undefined;

    constructor(data?: IServiceGetAllInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.isPaginated = _data["isPaginated"];
            this.keyword = _data["keyword"];
            if (Array.isArray(_data["operatorIds"])) {
                this.operatorIds = [] as any;
                for (let item of _data["operatorIds"])
                    this.operatorIds!.push(item);
            }
            if (Array.isArray(_data["beneficiaryIds"])) {
                this.beneficiaryIds = [] as any;
                for (let item of _data["beneficiaryIds"])
                    this.beneficiaryIds!.push(item);
            }
            if (Array.isArray(_data["organizationIds"])) {
                this.organizationIds = [] as any;
                for (let item of _data["organizationIds"])
                    this.organizationIds!.push(item);
            }
            if (Array.isArray(_data["qualificationIds"])) {
                this.qualificationIds = [] as any;
                for (let item of _data["qualificationIds"])
                    this.qualificationIds!.push(item);
            }
            if (Array.isArray(_data["structureIds"])) {
                this.structureIds = [] as any;
                for (let item of _data["structureIds"])
                    this.structureIds!.push(item);
            }
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            if (Array.isArray(_data["serviceSectorIds"])) {
                this.serviceSectorIds = [] as any;
                for (let item of _data["serviceSectorIds"])
                    this.serviceSectorIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ServiceGetAllInput {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceGetAllInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["isPaginated"] = this.isPaginated;
        data["keyword"] = this.keyword;
        if (Array.isArray(this.operatorIds)) {
            data["operatorIds"] = [];
            for (let item of this.operatorIds)
                data["operatorIds"].push(item);
        }
        if (Array.isArray(this.beneficiaryIds)) {
            data["beneficiaryIds"] = [];
            for (let item of this.beneficiaryIds)
                data["beneficiaryIds"].push(item);
        }
        if (Array.isArray(this.organizationIds)) {
            data["organizationIds"] = [];
            for (let item of this.organizationIds)
                data["organizationIds"].push(item);
        }
        if (Array.isArray(this.qualificationIds)) {
            data["qualificationIds"] = [];
            for (let item of this.qualificationIds)
                data["qualificationIds"].push(item);
        }
        if (Array.isArray(this.structureIds)) {
            data["structureIds"] = [];
            for (let item of this.structureIds)
                data["structureIds"].push(item);
        }
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        if (Array.isArray(this.serviceSectorIds)) {
            data["serviceSectorIds"] = [];
            for (let item of this.serviceSectorIds)
                data["serviceSectorIds"].push(item);
        }
        return data;
    }

    clone(): ServiceGetAllInput {
        const json = this.toJSON();
        let result = new ServiceGetAllInput();
        result.init(json);
        return result;
    }
}

export interface IServiceGetAllInput {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    isPaginated: boolean;
    keyword: string | undefined;
    operatorIds: number[] | undefined;
    beneficiaryIds: number[] | undefined;
    organizationIds: number[] | undefined;
    qualificationIds: number[] | undefined;
    structureIds: number[] | undefined;
    userIds: number[] | undefined;
    serviceSectorIds: number[] | undefined;
}

export class ServiceItemDto implements IServiceItemDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;
    serviceSectors!: DictionaryDto[] | undefined;
    totalSeats!: number | undefined;

    constructor(data?: IServiceItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["serviceSectors"])) {
                this.serviceSectors = [] as any;
                for (let item of _data["serviceSectors"])
                    this.serviceSectors!.push(DictionaryDto.fromJS(item));
            }
            this.totalSeats = _data["totalSeats"];
        }
    }

    static fromJS(data: any): ServiceItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.serviceSectors)) {
            data["serviceSectors"] = [];
            for (let item of this.serviceSectors)
                data["serviceSectors"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalSeats"] = this.totalSeats;
        return data;
    }

    clone(): ServiceItemDto {
        const json = this.toJSON();
        let result = new ServiceItemDto();
        result.init(json);
        return result;
    }
}

export interface IServiceItemDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    serviceSectors: DictionaryDto[] | undefined;
    totalSeats: number | undefined;
}

export class ServiceItemDtoPagedResultDto implements IServiceItemDtoPagedResultDto {
    items!: ServiceItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceItemDtoPagedResultDto {
    items: ServiceItemDto[] | undefined;
    totalCount: number;
}

export class ServiceLogDto implements IServiceLogDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    serviceUsers!: ServiceUserDto[] | undefined;
    service!: ServiceDto;
    hasDifferentReferenceDate!: boolean;
    referenceDate!: moment.Moment | undefined;
    title!: string | undefined;
    description!: string | undefined;
    isRead!: boolean;
    creatorUserId!: number | undefined;
    creatorUserFullName!: string | undefined;
    tags!: TagDto[] | undefined;
    tenantId!: number | undefined;
    serviceLogServiceTasks!: ServiceLogServiceTaskDto[] | undefined;

    constructor(data?: IServiceLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            if (Array.isArray(_data["serviceUsers"])) {
                this.serviceUsers = [] as any;
                for (let item of _data["serviceUsers"])
                    this.serviceUsers!.push(ServiceUserDto.fromJS(item));
            }
            this.service = _data["service"] ? ServiceDto.fromJS(_data["service"]) : undefined as any;
            this.hasDifferentReferenceDate = _data["hasDifferentReferenceDate"];
            this.referenceDate = _data["referenceDate"] ? moment(_data["referenceDate"].toString()) : undefined as any;
            this.title = _data["title"];
            this.description = _data["description"];
            this.isRead = _data["isRead"];
            this.creatorUserId = _data["creatorUserId"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagDto.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["serviceLogServiceTasks"])) {
                this.serviceLogServiceTasks = [] as any;
                for (let item of _data["serviceLogServiceTasks"])
                    this.serviceLogServiceTasks!.push(ServiceLogServiceTaskDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        if (Array.isArray(this.serviceUsers)) {
            data["serviceUsers"] = [];
            for (let item of this.serviceUsers)
                data["serviceUsers"].push(item ? item.toJSON() : undefined as any);
        }
        data["service"] = this.service ? this.service.toJSON() : undefined as any;
        data["hasDifferentReferenceDate"] = this.hasDifferentReferenceDate;
        data["referenceDate"] = this.referenceDate ? this.referenceDate.toISOString() : undefined as any;
        data["title"] = this.title;
        data["description"] = this.description;
        data["isRead"] = this.isRead;
        data["creatorUserId"] = this.creatorUserId;
        data["creatorUserFullName"] = this.creatorUserFullName;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.serviceLogServiceTasks)) {
            data["serviceLogServiceTasks"] = [];
            for (let item of this.serviceLogServiceTasks)
                data["serviceLogServiceTasks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ServiceLogDto {
        const json = this.toJSON();
        let result = new ServiceLogDto();
        result.init(json);
        return result;
    }
}

export interface IServiceLogDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    serviceUsers: ServiceUserDto[] | undefined;
    service: ServiceDto;
    hasDifferentReferenceDate: boolean;
    referenceDate: moment.Moment | undefined;
    title: string | undefined;
    description: string | undefined;
    isRead: boolean;
    creatorUserId: number | undefined;
    creatorUserFullName: string | undefined;
    tags: TagDto[] | undefined;
    tenantId: number | undefined;
    serviceLogServiceTasks: ServiceLogServiceTaskDto[] | undefined;
}

export class ServiceLogDtoPagedResultDto implements IServiceLogDtoPagedResultDto {
    items!: ServiceLogDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceLogDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceLogDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceLogDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceLogDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceLogDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceLogDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceLogDtoPagedResultDto {
    items: ServiceLogDto[] | undefined;
    totalCount: number;
}

export class ServiceLogGetAllInput implements IServiceLogGetAllInput {
    maxResultCount!: number;
    skipCount!: number;
    sorting!: string | undefined;
    isPaginated!: boolean;
    keyword!: string | undefined;
    serviceId!: number | undefined;
    userId!: number | undefined;
    tagIds!: number[] | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    isRead!: boolean | undefined;
    includeLinkedDiaries!: boolean;

    constructor(data?: IServiceLogGetAllInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.sorting = _data["sorting"];
            this.isPaginated = _data["isPaginated"];
            this.keyword = _data["keyword"];
            this.serviceId = _data["serviceId"];
            this.userId = _data["userId"];
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
            this.isRead = _data["isRead"];
            this.includeLinkedDiaries = _data["includeLinkedDiaries"];
        }
    }

    static fromJS(data: any): ServiceLogGetAllInput {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceLogGetAllInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["sorting"] = this.sorting;
        data["isPaginated"] = this.isPaginated;
        data["keyword"] = this.keyword;
        data["serviceId"] = this.serviceId;
        data["userId"] = this.userId;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["isRead"] = this.isRead;
        data["includeLinkedDiaries"] = this.includeLinkedDiaries;
        return data;
    }

    clone(): ServiceLogGetAllInput {
        const json = this.toJSON();
        let result = new ServiceLogGetAllInput();
        result.init(json);
        return result;
    }
}

export interface IServiceLogGetAllInput {
    maxResultCount: number;
    skipCount: number;
    sorting: string | undefined;
    isPaginated: boolean;
    keyword: string | undefined;
    serviceId: number | undefined;
    userId: number | undefined;
    tagIds: number[] | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    isRead: boolean | undefined;
    includeLinkedDiaries: boolean;
}

export class ServiceLogServiceTaskDto implements IServiceLogServiceTaskDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    serviceTask!: ServiceTaskDto;
    isCompleted!: boolean;

    constructor(data?: IServiceLogServiceTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.serviceTask = _data["serviceTask"] ? ServiceTaskDto.fromJS(_data["serviceTask"]) : undefined as any;
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): ServiceLogServiceTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceLogServiceTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["serviceTask"] = this.serviceTask ? this.serviceTask.toJSON() : undefined as any;
        data["isCompleted"] = this.isCompleted;
        return data;
    }

    clone(): ServiceLogServiceTaskDto {
        const json = this.toJSON();
        let result = new ServiceLogServiceTaskDto();
        result.init(json);
        return result;
    }
}

export interface IServiceLogServiceTaskDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    serviceTask: ServiceTaskDto;
    isCompleted: boolean;
}

export class ServiceLogServiceTaskDtoPagedResultDto implements IServiceLogServiceTaskDtoPagedResultDto {
    items!: ServiceLogServiceTaskDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceLogServiceTaskDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceLogServiceTaskDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceLogServiceTaskDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceLogServiceTaskDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceLogServiceTaskDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceLogServiceTaskDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceLogServiceTaskDtoPagedResultDto {
    items: ServiceLogServiceTaskDto[] | undefined;
    totalCount: number;
}

export class ServiceModRUDDto implements IServiceModRUDDto {
    id!: number;
    serviceUserDto!: ServiceUserBasicDto;
    municipalityResidence!: string | undefined;
    frequency!: string | undefined;
    hour!: string | undefined;
    weeklyAccess!: string | undefined;
    authorization!: string | undefined;
    voucher!: boolean | undefined;
    expiryVoucher!: moment.Moment | undefined;
    transport!: boolean | undefined;
    canteen!: boolean | undefined;
    entryDate!: moment.Moment | undefined;
    expiryPAI!: moment.Moment | undefined;
    familyContact!: string | undefined;

    constructor(data?: IServiceModRUDDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceUserDto = _data["serviceUserDto"] ? ServiceUserBasicDto.fromJS(_data["serviceUserDto"]) : undefined as any;
            this.municipalityResidence = _data["municipalityResidence"];
            this.frequency = _data["frequency"];
            this.hour = _data["hour"];
            this.weeklyAccess = _data["weeklyAccess"];
            this.authorization = _data["authorization"];
            this.voucher = _data["voucher"];
            this.expiryVoucher = _data["expiryVoucher"] ? moment(_data["expiryVoucher"].toString()) : undefined as any;
            this.transport = _data["transport"];
            this.canteen = _data["canteen"];
            this.entryDate = _data["entryDate"] ? moment(_data["entryDate"].toString()) : undefined as any;
            this.expiryPAI = _data["expiryPAI"] ? moment(_data["expiryPAI"].toString()) : undefined as any;
            this.familyContact = _data["familyContact"];
        }
    }

    static fromJS(data: any): ServiceModRUDDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceModRUDDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceUserDto"] = this.serviceUserDto ? this.serviceUserDto.toJSON() : undefined as any;
        data["municipalityResidence"] = this.municipalityResidence;
        data["frequency"] = this.frequency;
        data["hour"] = this.hour;
        data["weeklyAccess"] = this.weeklyAccess;
        data["authorization"] = this.authorization;
        data["voucher"] = this.voucher;
        data["expiryVoucher"] = this.expiryVoucher ? this.expiryVoucher.toISOString() : undefined as any;
        data["transport"] = this.transport;
        data["canteen"] = this.canteen;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : undefined as any;
        data["expiryPAI"] = this.expiryPAI ? this.expiryPAI.toISOString() : undefined as any;
        data["familyContact"] = this.familyContact;
        return data;
    }

    clone(): ServiceModRUDDto {
        const json = this.toJSON();
        let result = new ServiceModRUDDto();
        result.init(json);
        return result;
    }
}

export interface IServiceModRUDDto {
    id: number;
    serviceUserDto: ServiceUserBasicDto;
    municipalityResidence: string | undefined;
    frequency: string | undefined;
    hour: string | undefined;
    weeklyAccess: string | undefined;
    authorization: string | undefined;
    voucher: boolean | undefined;
    expiryVoucher: moment.Moment | undefined;
    transport: boolean | undefined;
    canteen: boolean | undefined;
    entryDate: moment.Moment | undefined;
    expiryPAI: moment.Moment | undefined;
    familyContact: string | undefined;
}

export class ServiceModRUDItemDto implements IServiceModRUDItemDto {
    id!: number;
    serviceUserDto!: ServiceUserBasicDto;

    constructor(data?: IServiceModRUDItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceUserDto = _data["serviceUserDto"] ? ServiceUserBasicDto.fromJS(_data["serviceUserDto"]) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceModRUDItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceModRUDItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceUserDto"] = this.serviceUserDto ? this.serviceUserDto.toJSON() : undefined as any;
        return data;
    }

    clone(): ServiceModRUDItemDto {
        const json = this.toJSON();
        let result = new ServiceModRUDItemDto();
        result.init(json);
        return result;
    }
}

export interface IServiceModRUDItemDto {
    id: number;
    serviceUserDto: ServiceUserBasicDto;
}

export class ServiceModRUDItemDtoPagedResultDto implements IServiceModRUDItemDtoPagedResultDto {
    items!: ServiceModRUDItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceModRUDItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceModRUDItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceModRUDItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceModRUDItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceModRUDItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceModRUDItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceModRUDItemDtoPagedResultDto {
    items: ServiceModRUDItemDto[] | undefined;
    totalCount: number;
}

export class ServicePlaceDto implements IServicePlaceDto {
    id!: number;
    service!: ServiceItemDto;
    place!: DictionaryDto;

    constructor(data?: IServicePlaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.service = _data["service"] ? ServiceItemDto.fromJS(_data["service"]) : undefined as any;
            this.place = _data["place"] ? DictionaryDto.fromJS(_data["place"]) : undefined as any;
        }
    }

    static fromJS(data: any): ServicePlaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServicePlaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["service"] = this.service ? this.service.toJSON() : undefined as any;
        data["place"] = this.place ? this.place.toJSON() : undefined as any;
        return data;
    }

    clone(): ServicePlaceDto {
        const json = this.toJSON();
        let result = new ServicePlaceDto();
        result.init(json);
        return result;
    }
}

export interface IServicePlaceDto {
    id: number;
    service: ServiceItemDto;
    place: DictionaryDto;
}

export class ServicePlaceDtoPagedResultDto implements IServicePlaceDtoPagedResultDto {
    items!: ServicePlaceDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServicePlaceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServicePlaceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServicePlaceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServicePlaceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServicePlaceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServicePlaceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServicePlaceDtoPagedResultDto {
    items: ServicePlaceDto[] | undefined;
    totalCount: number;
}

export class ServiceReportDto implements IServiceReportDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    serviceId!: number | undefined;
    beneficiary!: ServiceUserDto;
    operator!: ServiceUserDto;
    objectives!: ServiceReportObjectiveDto[] | undefined;
    school!: string | undefined;
    schoolAddress!: AddressDto;
    protocolNumber!: string | undefined;
    place!: string | undefined;
    date!: moment.Moment | undefined;
    subject!: string | undefined;
    projectReferent!: string | undefined;
    serviceManager!: string | undefined;
    schoolYear!: string | undefined;
    projectStartDate!: moment.Moment | undefined;
    weeklyHours!: string | undefined;
    projectLocation!: string | undefined;
    supportTeachers!: string | undefined;
    interventionsDescription!: string | undefined;
    issues!: string | undefined;
    nextYearObjectives!: string | undefined;
    isConfirmed!: boolean;
    confirmingUserId!: number | undefined;
    confirmingUserFullName!: string | undefined;
    confirmationDate!: moment.Moment | undefined;

    constructor(data?: IServiceReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.serviceId = _data["serviceId"];
            this.beneficiary = _data["beneficiary"] ? ServiceUserDto.fromJS(_data["beneficiary"]) : undefined as any;
            this.operator = _data["operator"] ? ServiceUserDto.fromJS(_data["operator"]) : undefined as any;
            if (Array.isArray(_data["objectives"])) {
                this.objectives = [] as any;
                for (let item of _data["objectives"])
                    this.objectives!.push(ServiceReportObjectiveDto.fromJS(item));
            }
            this.school = _data["school"];
            this.schoolAddress = _data["schoolAddress"] ? AddressDto.fromJS(_data["schoolAddress"]) : undefined as any;
            this.protocolNumber = _data["protocolNumber"];
            this.place = _data["place"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.subject = _data["subject"];
            this.projectReferent = _data["projectReferent"];
            this.serviceManager = _data["serviceManager"];
            this.schoolYear = _data["schoolYear"];
            this.projectStartDate = _data["projectStartDate"] ? moment(_data["projectStartDate"].toString()) : undefined as any;
            this.weeklyHours = _data["weeklyHours"];
            this.projectLocation = _data["projectLocation"];
            this.supportTeachers = _data["supportTeachers"];
            this.interventionsDescription = _data["interventionsDescription"];
            this.issues = _data["issues"];
            this.nextYearObjectives = _data["nextYearObjectives"];
            this.isConfirmed = _data["isConfirmed"];
            this.confirmingUserId = _data["confirmingUserId"];
            this.confirmingUserFullName = _data["confirmingUserFullName"];
            this.confirmationDate = _data["confirmationDate"] ? moment(_data["confirmationDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["serviceId"] = this.serviceId;
        data["beneficiary"] = this.beneficiary ? this.beneficiary.toJSON() : undefined as any;
        data["operator"] = this.operator ? this.operator.toJSON() : undefined as any;
        if (Array.isArray(this.objectives)) {
            data["objectives"] = [];
            for (let item of this.objectives)
                data["objectives"].push(item ? item.toJSON() : undefined as any);
        }
        data["school"] = this.school;
        data["schoolAddress"] = this.schoolAddress ? this.schoolAddress.toJSON() : undefined as any;
        data["protocolNumber"] = this.protocolNumber;
        data["place"] = this.place;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["subject"] = this.subject;
        data["projectReferent"] = this.projectReferent;
        data["serviceManager"] = this.serviceManager;
        data["schoolYear"] = this.schoolYear;
        data["projectStartDate"] = this.projectStartDate ? this.projectStartDate.toISOString() : undefined as any;
        data["weeklyHours"] = this.weeklyHours;
        data["projectLocation"] = this.projectLocation;
        data["supportTeachers"] = this.supportTeachers;
        data["interventionsDescription"] = this.interventionsDescription;
        data["issues"] = this.issues;
        data["nextYearObjectives"] = this.nextYearObjectives;
        data["isConfirmed"] = this.isConfirmed;
        data["confirmingUserId"] = this.confirmingUserId;
        data["confirmingUserFullName"] = this.confirmingUserFullName;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : undefined as any;
        return data;
    }

    clone(): ServiceReportDto {
        const json = this.toJSON();
        let result = new ServiceReportDto();
        result.init(json);
        return result;
    }
}

export interface IServiceReportDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    serviceId: number | undefined;
    beneficiary: ServiceUserDto;
    operator: ServiceUserDto;
    objectives: ServiceReportObjectiveDto[] | undefined;
    school: string | undefined;
    schoolAddress: AddressDto;
    protocolNumber: string | undefined;
    place: string | undefined;
    date: moment.Moment | undefined;
    subject: string | undefined;
    projectReferent: string | undefined;
    serviceManager: string | undefined;
    schoolYear: string | undefined;
    projectStartDate: moment.Moment | undefined;
    weeklyHours: string | undefined;
    projectLocation: string | undefined;
    supportTeachers: string | undefined;
    interventionsDescription: string | undefined;
    issues: string | undefined;
    nextYearObjectives: string | undefined;
    isConfirmed: boolean;
    confirmingUserId: number | undefined;
    confirmingUserFullName: string | undefined;
    confirmationDate: moment.Moment | undefined;
}

export class ServiceReportDtoPagedResultDto implements IServiceReportDtoPagedResultDto {
    items!: ServiceReportDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceReportDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceReportDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceReportDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceReportDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceReportDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceReportDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceReportDtoPagedResultDto {
    items: ServiceReportDto[] | undefined;
    totalCount: number;
}

export class ServiceReportObjectiveDto implements IServiceReportObjectiveDto {
    id!: number;
    description!: string | undefined;
    outcome!: ServiceReportObjectiveOutcome;

    constructor(data?: IServiceReportObjectiveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.outcome = _data["outcome"];
        }
    }

    static fromJS(data: any): ServiceReportObjectiveDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceReportObjectiveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["outcome"] = this.outcome;
        return data;
    }

    clone(): ServiceReportObjectiveDto {
        const json = this.toJSON();
        let result = new ServiceReportObjectiveDto();
        result.init(json);
        return result;
    }
}

export interface IServiceReportObjectiveDto {
    id: number;
    description: string | undefined;
    outcome: ServiceReportObjectiveOutcome;
}

export class ServiceReportObjectiveInputDto implements IServiceReportObjectiveInputDto {
    description!: string | undefined;
    outcome!: ServiceReportObjectiveOutcome;

    constructor(data?: IServiceReportObjectiveInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.outcome = _data["outcome"];
        }
    }

    static fromJS(data: any): ServiceReportObjectiveInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceReportObjectiveInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["outcome"] = this.outcome;
        return data;
    }

    clone(): ServiceReportObjectiveInputDto {
        const json = this.toJSON();
        let result = new ServiceReportObjectiveInputDto();
        result.init(json);
        return result;
    }
}

export interface IServiceReportObjectiveInputDto {
    description: string | undefined;
    outcome: ServiceReportObjectiveOutcome;
}

export enum ServiceReportObjectiveOutcome {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class ServiceSemiAnnualHealthDocumentationReviewDto implements IServiceSemiAnnualHealthDocumentationReviewDto {
    id!: number;
    isConfirmed!: boolean;
    confirmingUserId!: number | undefined;
    confirmationDate!: moment.Moment | undefined;
    confirmingUserFullName!: string | undefined;
    date!: moment.Moment | undefined;
    annotation!: string | undefined;

    constructor(data?: IServiceSemiAnnualHealthDocumentationReviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isConfirmed = _data["isConfirmed"];
            this.confirmingUserId = _data["confirmingUserId"];
            this.confirmationDate = _data["confirmationDate"] ? moment(_data["confirmationDate"].toString()) : undefined as any;
            this.confirmingUserFullName = _data["confirmingUserFullName"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.annotation = _data["annotation"];
        }
    }

    static fromJS(data: any): ServiceSemiAnnualHealthDocumentationReviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceSemiAnnualHealthDocumentationReviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isConfirmed"] = this.isConfirmed;
        data["confirmingUserId"] = this.confirmingUserId;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : undefined as any;
        data["confirmingUserFullName"] = this.confirmingUserFullName;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["annotation"] = this.annotation;
        return data;
    }

    clone(): ServiceSemiAnnualHealthDocumentationReviewDto {
        const json = this.toJSON();
        let result = new ServiceSemiAnnualHealthDocumentationReviewDto();
        result.init(json);
        return result;
    }
}

export interface IServiceSemiAnnualHealthDocumentationReviewDto {
    id: number;
    isConfirmed: boolean;
    confirmingUserId: number | undefined;
    confirmationDate: moment.Moment | undefined;
    confirmingUserFullName: string | undefined;
    date: moment.Moment | undefined;
    annotation: string | undefined;
}

export class ServiceSemiAnnualHealthDocumentationReviewDtoPagedResultDto implements IServiceSemiAnnualHealthDocumentationReviewDtoPagedResultDto {
    items!: ServiceSemiAnnualHealthDocumentationReviewDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceSemiAnnualHealthDocumentationReviewDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceSemiAnnualHealthDocumentationReviewDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceSemiAnnualHealthDocumentationReviewDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceSemiAnnualHealthDocumentationReviewDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceSemiAnnualHealthDocumentationReviewDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceSemiAnnualHealthDocumentationReviewDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceSemiAnnualHealthDocumentationReviewDtoPagedResultDto {
    items: ServiceSemiAnnualHealthDocumentationReviewDto[] | undefined;
    totalCount: number;
}

export class ServiceStructureDto implements IServiceStructureDto {
    id!: number;
    service!: ServiceDto;
    structure!: StructureDto;
    airTreatmentSystem!: AirTreatmentSystemBaseDto;
    electricalSystem!: ElectricalSystemBaseDto;
    elevatorSystem!: ElevatorSystemBaseDto;
    heatingSystem!: HeatingSystemBaseDto;
    hydraulicSystem!: HydraulicSystemBaseDto;
    firePreventionSystem!: FirePreventionSystemBaseDto;
    photovoltaicSystem!: PhotovoltaicSystemBaseDto;
    lifelineSystem!: LifelineSystemBaseDto;
    antiTheftSystem!: AntiTheftSystemBaseDto;
    videoSurveillanceSystem!: VideoSurveillanceSystemBaseDto;

    constructor(data?: IServiceStructureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.service = _data["service"] ? ServiceDto.fromJS(_data["service"]) : undefined as any;
            this.structure = _data["structure"] ? StructureDto.fromJS(_data["structure"]) : undefined as any;
            this.airTreatmentSystem = _data["airTreatmentSystem"] ? AirTreatmentSystemBaseDto.fromJS(_data["airTreatmentSystem"]) : undefined as any;
            this.electricalSystem = _data["electricalSystem"] ? ElectricalSystemBaseDto.fromJS(_data["electricalSystem"]) : undefined as any;
            this.elevatorSystem = _data["elevatorSystem"] ? ElevatorSystemBaseDto.fromJS(_data["elevatorSystem"]) : undefined as any;
            this.heatingSystem = _data["heatingSystem"] ? HeatingSystemBaseDto.fromJS(_data["heatingSystem"]) : undefined as any;
            this.hydraulicSystem = _data["hydraulicSystem"] ? HydraulicSystemBaseDto.fromJS(_data["hydraulicSystem"]) : undefined as any;
            this.firePreventionSystem = _data["firePreventionSystem"] ? FirePreventionSystemBaseDto.fromJS(_data["firePreventionSystem"]) : undefined as any;
            this.photovoltaicSystem = _data["photovoltaicSystem"] ? PhotovoltaicSystemBaseDto.fromJS(_data["photovoltaicSystem"]) : undefined as any;
            this.lifelineSystem = _data["lifelineSystem"] ? LifelineSystemBaseDto.fromJS(_data["lifelineSystem"]) : undefined as any;
            this.antiTheftSystem = _data["antiTheftSystem"] ? AntiTheftSystemBaseDto.fromJS(_data["antiTheftSystem"]) : undefined as any;
            this.videoSurveillanceSystem = _data["videoSurveillanceSystem"] ? VideoSurveillanceSystemBaseDto.fromJS(_data["videoSurveillanceSystem"]) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceStructureDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceStructureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["service"] = this.service ? this.service.toJSON() : undefined as any;
        data["structure"] = this.structure ? this.structure.toJSON() : undefined as any;
        data["airTreatmentSystem"] = this.airTreatmentSystem ? this.airTreatmentSystem.toJSON() : undefined as any;
        data["electricalSystem"] = this.electricalSystem ? this.electricalSystem.toJSON() : undefined as any;
        data["elevatorSystem"] = this.elevatorSystem ? this.elevatorSystem.toJSON() : undefined as any;
        data["heatingSystem"] = this.heatingSystem ? this.heatingSystem.toJSON() : undefined as any;
        data["hydraulicSystem"] = this.hydraulicSystem ? this.hydraulicSystem.toJSON() : undefined as any;
        data["firePreventionSystem"] = this.firePreventionSystem ? this.firePreventionSystem.toJSON() : undefined as any;
        data["photovoltaicSystem"] = this.photovoltaicSystem ? this.photovoltaicSystem.toJSON() : undefined as any;
        data["lifelineSystem"] = this.lifelineSystem ? this.lifelineSystem.toJSON() : undefined as any;
        data["antiTheftSystem"] = this.antiTheftSystem ? this.antiTheftSystem.toJSON() : undefined as any;
        data["videoSurveillanceSystem"] = this.videoSurveillanceSystem ? this.videoSurveillanceSystem.toJSON() : undefined as any;
        return data;
    }

    clone(): ServiceStructureDto {
        const json = this.toJSON();
        let result = new ServiceStructureDto();
        result.init(json);
        return result;
    }
}

export interface IServiceStructureDto {
    id: number;
    service: ServiceDto;
    structure: StructureDto;
    airTreatmentSystem: AirTreatmentSystemBaseDto;
    electricalSystem: ElectricalSystemBaseDto;
    elevatorSystem: ElevatorSystemBaseDto;
    heatingSystem: HeatingSystemBaseDto;
    hydraulicSystem: HydraulicSystemBaseDto;
    firePreventionSystem: FirePreventionSystemBaseDto;
    photovoltaicSystem: PhotovoltaicSystemBaseDto;
    lifelineSystem: LifelineSystemBaseDto;
    antiTheftSystem: AntiTheftSystemBaseDto;
    videoSurveillanceSystem: VideoSurveillanceSystemBaseDto;
}

export class ServiceStructureDtoPagedResultDto implements IServiceStructureDtoPagedResultDto {
    items!: ServiceStructureDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceStructureDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceStructureDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceStructureDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceStructureDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceStructureDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceStructureDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceStructureDtoPagedResultDto {
    items: ServiceStructureDto[] | undefined;
    totalCount: number;
}

export class ServiceSubTagDto implements IServiceSubTagDto {
    id!: number;
    subTag!: DictionaryDto;
    service!: ServiceItemDto;

    constructor(data?: IServiceSubTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subTag = _data["subTag"] ? DictionaryDto.fromJS(_data["subTag"]) : undefined as any;
            this.service = _data["service"] ? ServiceItemDto.fromJS(_data["service"]) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceSubTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceSubTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subTag"] = this.subTag ? this.subTag.toJSON() : undefined as any;
        data["service"] = this.service ? this.service.toJSON() : undefined as any;
        return data;
    }

    clone(): ServiceSubTagDto {
        const json = this.toJSON();
        let result = new ServiceSubTagDto();
        result.init(json);
        return result;
    }
}

export interface IServiceSubTagDto {
    id: number;
    subTag: DictionaryDto;
    service: ServiceItemDto;
}

export class ServiceSubTagDtoPagedResultDto implements IServiceSubTagDtoPagedResultDto {
    items!: ServiceSubTagDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceSubTagDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceSubTagDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceSubTagDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceSubTagDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceSubTagDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceSubTagDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceSubTagDtoPagedResultDto {
    items: ServiceSubTagDto[] | undefined;
    totalCount: number;
}

export class ServiceTagDto implements IServiceTagDto {
    id!: number;
    tag!: TagDto;
    service!: ServiceItemDto;

    constructor(data?: IServiceTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tag = _data["tag"] ? TagDto.fromJS(_data["tag"]) : undefined as any;
            this.service = _data["service"] ? ServiceItemDto.fromJS(_data["service"]) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tag"] = this.tag ? this.tag.toJSON() : undefined as any;
        data["service"] = this.service ? this.service.toJSON() : undefined as any;
        return data;
    }

    clone(): ServiceTagDto {
        const json = this.toJSON();
        let result = new ServiceTagDto();
        result.init(json);
        return result;
    }
}

export interface IServiceTagDto {
    id: number;
    tag: TagDto;
    service: ServiceItemDto;
}

export class ServiceTagDtoPagedResultDto implements IServiceTagDtoPagedResultDto {
    items!: ServiceTagDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceTagDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceTagDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceTagDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTagDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceTagDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceTagDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceTagDtoPagedResultDto {
    items: ServiceTagDto[] | undefined;
    totalCount: number;
}

export class ServiceTaskDto implements IServiceTaskDto {
    id!: number;
    service!: ServiceItemDto;
    task!: DictionaryDto;

    constructor(data?: IServiceTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.service = _data["service"] ? ServiceItemDto.fromJS(_data["service"]) : undefined as any;
            this.task = _data["task"] ? DictionaryDto.fromJS(_data["task"]) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["service"] = this.service ? this.service.toJSON() : undefined as any;
        data["task"] = this.task ? this.task.toJSON() : undefined as any;
        return data;
    }

    clone(): ServiceTaskDto {
        const json = this.toJSON();
        let result = new ServiceTaskDto();
        result.init(json);
        return result;
    }
}

export interface IServiceTaskDto {
    id: number;
    service: ServiceItemDto;
    task: DictionaryDto;
}

export class ServiceTaskDtoPagedResultDto implements IServiceTaskDtoPagedResultDto {
    items!: ServiceTaskDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceTaskDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceTaskDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceTaskDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTaskDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceTaskDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceTaskDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceTaskDtoPagedResultDto {
    items: ServiceTaskDto[] | undefined;
    totalCount: number;
}

export class ServiceTemplateDto implements IServiceTemplateDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    isHidden!: boolean;
    name!: string | undefined;
    description!: string | undefined;
    widgets!: ServiceWidgetDto[] | undefined;
    isDeletable!: boolean;

    constructor(data?: IServiceTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.isHidden = _data["isHidden"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["widgets"])
                    this.widgets!.push(ServiceWidgetDto.fromJS(item));
            }
            this.isDeletable = _data["isDeletable"];
        }
    }

    static fromJS(data: any): ServiceTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["isHidden"] = this.isHidden;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDeletable"] = this.isDeletable;
        return data;
    }

    clone(): ServiceTemplateDto {
        const json = this.toJSON();
        let result = new ServiceTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IServiceTemplateDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    isHidden: boolean;
    name: string | undefined;
    description: string | undefined;
    widgets: ServiceWidgetDto[] | undefined;
    isDeletable: boolean;
}

export class ServiceTemplateDtoPagedResultDto implements IServiceTemplateDtoPagedResultDto {
    items!: ServiceTemplateDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceTemplateDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceTemplateDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceTemplateDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceTemplateDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceTemplateDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceTemplateDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceTemplateDtoPagedResultDto {
    items: ServiceTemplateDto[] | undefined;
    totalCount: number;
}

export class ServiceUserAvailabilityDto implements IServiceUserAvailabilityDto {
    id!: number;
    serviceUser!: ServiceUserDto;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;

    constructor(data?: IServiceUserAvailabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceUser = _data["serviceUser"] ? ServiceUserDto.fromJS(_data["serviceUser"]) : undefined as any;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceUserAvailabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceUserAvailabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceUser"] = this.serviceUser ? this.serviceUser.toJSON() : undefined as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        return data;
    }

    clone(): ServiceUserAvailabilityDto {
        const json = this.toJSON();
        let result = new ServiceUserAvailabilityDto();
        result.init(json);
        return result;
    }
}

export interface IServiceUserAvailabilityDto {
    id: number;
    serviceUser: ServiceUserDto;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
}

export class ServiceUserAvailabilityDtoPagedResultDto implements IServiceUserAvailabilityDtoPagedResultDto {
    items!: ServiceUserAvailabilityDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceUserAvailabilityDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceUserAvailabilityDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceUserAvailabilityDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceUserAvailabilityDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceUserAvailabilityDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceUserAvailabilityDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceUserAvailabilityDtoPagedResultDto {
    items: ServiceUserAvailabilityDto[] | undefined;
    totalCount: number;
}

export class ServiceUserBasicDto implements IServiceUserBasicDto {
    id!: number;
    user!: BaseUserDto;

    constructor(data?: IServiceUserBasicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? BaseUserDto.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceUserBasicDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceUserBasicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }

    clone(): ServiceUserBasicDto {
        const json = this.toJSON();
        let result = new ServiceUserBasicDto();
        result.init(json);
        return result;
    }
}

export interface IServiceUserBasicDto {
    id: number;
    user: BaseUserDto;
}

export class ServiceUserDto implements IServiceUserDto {
    id!: number;
    cloudFolderUrl!: string | undefined;
    user!: UserDto;
    service!: ServiceDto;
    isOperator!: boolean;
    qualification!: DictionaryDto;
    archivalTime!: moment.Moment | undefined;
    readonly isArchivedAtTenant!: boolean;
    readonly isArchived!: boolean;

    constructor(data?: IServiceUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cloudFolderUrl = _data["cloudFolderUrl"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            this.service = _data["service"] ? ServiceDto.fromJS(_data["service"]) : undefined as any;
            this.isOperator = _data["isOperator"];
            this.qualification = _data["qualification"] ? DictionaryDto.fromJS(_data["qualification"]) : undefined as any;
            this.archivalTime = _data["archivalTime"] ? moment(_data["archivalTime"].toString()) : undefined as any;
            (this as any).isArchivedAtTenant = _data["isArchivedAtTenant"];
            (this as any).isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): ServiceUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cloudFolderUrl"] = this.cloudFolderUrl;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["service"] = this.service ? this.service.toJSON() : undefined as any;
        data["isOperator"] = this.isOperator;
        data["qualification"] = this.qualification ? this.qualification.toJSON() : undefined as any;
        data["archivalTime"] = this.archivalTime ? this.archivalTime.toISOString() : undefined as any;
        data["isArchivedAtTenant"] = this.isArchivedAtTenant;
        data["isArchived"] = this.isArchived;
        return data;
    }

    clone(): ServiceUserDto {
        const json = this.toJSON();
        let result = new ServiceUserDto();
        result.init(json);
        return result;
    }
}

export interface IServiceUserDto {
    id: number;
    cloudFolderUrl: string | undefined;
    user: UserDto;
    service: ServiceDto;
    isOperator: boolean;
    qualification: DictionaryDto;
    archivalTime: moment.Moment | undefined;
    isArchivedAtTenant: boolean;
    isArchived: boolean;
}

export class ServiceUserDtoPagedResultDto implements IServiceUserDtoPagedResultDto {
    items!: ServiceUserDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceUserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceUserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceUserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceUserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceUserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceUserDtoPagedResultDto {
    items: ServiceUserDto[] | undefined;
    totalCount: number;
}

export class ServiceUserSocialHealthRecordTemplateDto implements IServiceUserSocialHealthRecordTemplateDto {
    serviceUserId!: number;
    socialHealthRecordId!: number;
    socialHealthRecordTemplate!: SocialHealtRecordTemplateDto;

    constructor(data?: IServiceUserSocialHealthRecordTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceUserId = _data["serviceUserId"];
            this.socialHealthRecordId = _data["socialHealthRecordId"];
            this.socialHealthRecordTemplate = _data["socialHealthRecordTemplate"] ? SocialHealtRecordTemplateDto.fromJS(_data["socialHealthRecordTemplate"]) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceUserSocialHealthRecordTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceUserSocialHealthRecordTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceUserId"] = this.serviceUserId;
        data["socialHealthRecordId"] = this.socialHealthRecordId;
        data["socialHealthRecordTemplate"] = this.socialHealthRecordTemplate ? this.socialHealthRecordTemplate.toJSON() : undefined as any;
        return data;
    }

    clone(): ServiceUserSocialHealthRecordTemplateDto {
        const json = this.toJSON();
        let result = new ServiceUserSocialHealthRecordTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IServiceUserSocialHealthRecordTemplateDto {
    serviceUserId: number;
    socialHealthRecordId: number;
    socialHealthRecordTemplate: SocialHealtRecordTemplateDto;
}

export class ServiceUserStructureDto implements IServiceUserStructureDto {
    id!: number;
    serviceUserId!: number;
    userId!: number;
    userName!: string | undefined;
    userSurname!: string | undefined;
    serviceId!: number;
    serviceName!: string | undefined;
    structureId!: number;
    structureName!: string | undefined;
    roomId!: number | undefined;
    roomName!: string | undefined;
    startDate!: moment.Moment;
    endDate!: moment.Moment | undefined;
    serviceUserCreationTime!: moment.Moment;
    previousStructureName!: string | undefined;
    nextStructureName!: string | undefined;

    constructor(data?: IServiceUserStructureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceUserId = _data["serviceUserId"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userSurname = _data["userSurname"];
            this.serviceId = _data["serviceId"];
            this.serviceName = _data["serviceName"];
            this.structureId = _data["structureId"];
            this.structureName = _data["structureName"];
            this.roomId = _data["roomId"];
            this.roomName = _data["roomName"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
            this.serviceUserCreationTime = _data["serviceUserCreationTime"] ? moment(_data["serviceUserCreationTime"].toString()) : undefined as any;
            this.previousStructureName = _data["previousStructureName"];
            this.nextStructureName = _data["nextStructureName"];
        }
    }

    static fromJS(data: any): ServiceUserStructureDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceUserStructureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceUserId"] = this.serviceUserId;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userSurname"] = this.userSurname;
        data["serviceId"] = this.serviceId;
        data["serviceName"] = this.serviceName;
        data["structureId"] = this.structureId;
        data["structureName"] = this.structureName;
        data["roomId"] = this.roomId;
        data["roomName"] = this.roomName;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.format('YYYY-MM-DD') : undefined as any;
        data["serviceUserCreationTime"] = this.serviceUserCreationTime ? this.serviceUserCreationTime.toISOString() : undefined as any;
        data["previousStructureName"] = this.previousStructureName;
        data["nextStructureName"] = this.nextStructureName;
        return data;
    }

    clone(): ServiceUserStructureDto {
        const json = this.toJSON();
        let result = new ServiceUserStructureDto();
        result.init(json);
        return result;
    }
}

export interface IServiceUserStructureDto {
    id: number;
    serviceUserId: number;
    userId: number;
    userName: string | undefined;
    userSurname: string | undefined;
    serviceId: number;
    serviceName: string | undefined;
    structureId: number;
    structureName: string | undefined;
    roomId: number | undefined;
    roomName: string | undefined;
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
    serviceUserCreationTime: moment.Moment;
    previousStructureName: string | undefined;
    nextStructureName: string | undefined;
}

export class ServiceUserStructureDtoListResultDto implements IServiceUserStructureDtoListResultDto {
    items!: ServiceUserStructureDto[] | undefined;

    constructor(data?: IServiceUserStructureDtoListResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceUserStructureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceUserStructureDtoListResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceUserStructureDtoListResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ServiceUserStructureDtoListResultDto {
        const json = this.toJSON();
        let result = new ServiceUserStructureDtoListResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceUserStructureDtoListResultDto {
    items: ServiceUserStructureDto[] | undefined;
}

export class ServiceVerbalDto implements IServiceVerbalDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    operators!: ServiceUserDto[] | undefined;
    service!: ServiceDto;
    date!: moment.Moment | undefined;
    externalPeople!: string | undefined;
    dayOrder!: string | undefined;
    isConfirmed!: boolean;
    confirmingUserId!: number | undefined;
    confirmingUserFullName!: string | undefined;
    confirmationDate!: moment.Moment | undefined;

    constructor(data?: IServiceVerbalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            if (Array.isArray(_data["operators"])) {
                this.operators = [] as any;
                for (let item of _data["operators"])
                    this.operators!.push(ServiceUserDto.fromJS(item));
            }
            this.service = _data["service"] ? ServiceDto.fromJS(_data["service"]) : undefined as any;
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.externalPeople = _data["externalPeople"];
            this.dayOrder = _data["dayOrder"];
            this.isConfirmed = _data["isConfirmed"];
            this.confirmingUserId = _data["confirmingUserId"];
            this.confirmingUserFullName = _data["confirmingUserFullName"];
            this.confirmationDate = _data["confirmationDate"] ? moment(_data["confirmationDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceVerbalDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceVerbalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        if (Array.isArray(this.operators)) {
            data["operators"] = [];
            for (let item of this.operators)
                data["operators"].push(item ? item.toJSON() : undefined as any);
        }
        data["service"] = this.service ? this.service.toJSON() : undefined as any;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["externalPeople"] = this.externalPeople;
        data["dayOrder"] = this.dayOrder;
        data["isConfirmed"] = this.isConfirmed;
        data["confirmingUserId"] = this.confirmingUserId;
        data["confirmingUserFullName"] = this.confirmingUserFullName;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : undefined as any;
        return data;
    }

    clone(): ServiceVerbalDto {
        const json = this.toJSON();
        let result = new ServiceVerbalDto();
        result.init(json);
        return result;
    }
}

export interface IServiceVerbalDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    operators: ServiceUserDto[] | undefined;
    service: ServiceDto;
    date: moment.Moment | undefined;
    externalPeople: string | undefined;
    dayOrder: string | undefined;
    isConfirmed: boolean;
    confirmingUserId: number | undefined;
    confirmingUserFullName: string | undefined;
    confirmationDate: moment.Moment | undefined;
}

export class ServiceVerbalDtoPagedResultDto implements IServiceVerbalDtoPagedResultDto {
    items!: ServiceVerbalDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceVerbalDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceVerbalDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceVerbalDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceVerbalDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceVerbalDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceVerbalDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceVerbalDtoPagedResultDto {
    items: ServiceVerbalDto[] | undefined;
    totalCount: number;
}

export class ServiceVerbalTagDto implements IServiceVerbalTagDto {
    id!: number;
    verbalTag!: DictionaryDto;
    service!: ServiceItemDto;

    constructor(data?: IServiceVerbalTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.verbalTag = _data["verbalTag"] ? DictionaryDto.fromJS(_data["verbalTag"]) : undefined as any;
            this.service = _data["service"] ? ServiceItemDto.fromJS(_data["service"]) : undefined as any;
        }
    }

    static fromJS(data: any): ServiceVerbalTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceVerbalTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["verbalTag"] = this.verbalTag ? this.verbalTag.toJSON() : undefined as any;
        data["service"] = this.service ? this.service.toJSON() : undefined as any;
        return data;
    }

    clone(): ServiceVerbalTagDto {
        const json = this.toJSON();
        let result = new ServiceVerbalTagDto();
        result.init(json);
        return result;
    }
}

export interface IServiceVerbalTagDto {
    id: number;
    verbalTag: DictionaryDto;
    service: ServiceItemDto;
}

export class ServiceVerbalTagDtoPagedResultDto implements IServiceVerbalTagDtoPagedResultDto {
    items!: ServiceVerbalTagDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceVerbalTagDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceVerbalTagDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceVerbalTagDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceVerbalTagDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceVerbalTagDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceVerbalTagDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceVerbalTagDtoPagedResultDto {
    items: ServiceVerbalTagDto[] | undefined;
    totalCount: number;
}

export class ServiceWeeklyScheduleDto implements IServiceWeeklyScheduleDto {
    id!: number;
    serviceUser!: ServiceUserDto;
    dayOfWeek!: DictionaryDto;
    employmentPeriods!: EmploymentPeriodDto[] | undefined;

    constructor(data?: IServiceWeeklyScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceUser = _data["serviceUser"] ? ServiceUserDto.fromJS(_data["serviceUser"]) : undefined as any;
            this.dayOfWeek = _data["dayOfWeek"] ? DictionaryDto.fromJS(_data["dayOfWeek"]) : undefined as any;
            if (Array.isArray(_data["employmentPeriods"])) {
                this.employmentPeriods = [] as any;
                for (let item of _data["employmentPeriods"])
                    this.employmentPeriods!.push(EmploymentPeriodDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceWeeklyScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceWeeklyScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceUser"] = this.serviceUser ? this.serviceUser.toJSON() : undefined as any;
        data["dayOfWeek"] = this.dayOfWeek ? this.dayOfWeek.toJSON() : undefined as any;
        if (Array.isArray(this.employmentPeriods)) {
            data["employmentPeriods"] = [];
            for (let item of this.employmentPeriods)
                data["employmentPeriods"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ServiceWeeklyScheduleDto {
        const json = this.toJSON();
        let result = new ServiceWeeklyScheduleDto();
        result.init(json);
        return result;
    }
}

export interface IServiceWeeklyScheduleDto {
    id: number;
    serviceUser: ServiceUserDto;
    dayOfWeek: DictionaryDto;
    employmentPeriods: EmploymentPeriodDto[] | undefined;
}

export class ServiceWeeklyScheduleDtoPagedResultDto implements IServiceWeeklyScheduleDtoPagedResultDto {
    items!: ServiceWeeklyScheduleDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceWeeklyScheduleDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceWeeklyScheduleDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceWeeklyScheduleDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceWeeklyScheduleDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceWeeklyScheduleDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceWeeklyScheduleDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceWeeklyScheduleDtoPagedResultDto {
    items: ServiceWeeklyScheduleDto[] | undefined;
    totalCount: number;
}

export class ServiceWeightDetectionDto implements IServiceWeightDetectionDto {
    id!: number;
    structure!: string | undefined;
    year!: number;
    entries!: WeightDetectionEntryDto[] | undefined;

    constructor(data?: IServiceWeightDetectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.structure = _data["structure"];
            this.year = _data["year"];
            if (Array.isArray(_data["entries"])) {
                this.entries = [] as any;
                for (let item of _data["entries"])
                    this.entries!.push(WeightDetectionEntryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceWeightDetectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceWeightDetectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["structure"] = this.structure;
        data["year"] = this.year;
        if (Array.isArray(this.entries)) {
            data["entries"] = [];
            for (let item of this.entries)
                data["entries"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): ServiceWeightDetectionDto {
        const json = this.toJSON();
        let result = new ServiceWeightDetectionDto();
        result.init(json);
        return result;
    }
}

export interface IServiceWeightDetectionDto {
    id: number;
    structure: string | undefined;
    year: number;
    entries: WeightDetectionEntryDto[] | undefined;
}

export class ServiceWeightDetectionItemDto implements IServiceWeightDetectionItemDto {
    id!: number;
    structure!: string | undefined;
    year!: number;

    constructor(data?: IServiceWeightDetectionItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.structure = _data["structure"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): ServiceWeightDetectionItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceWeightDetectionItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["structure"] = this.structure;
        data["year"] = this.year;
        return data;
    }

    clone(): ServiceWeightDetectionItemDto {
        const json = this.toJSON();
        let result = new ServiceWeightDetectionItemDto();
        result.init(json);
        return result;
    }
}

export interface IServiceWeightDetectionItemDto {
    id: number;
    structure: string | undefined;
    year: number;
}

export class ServiceWeightDetectionItemDtoPagedResultDto implements IServiceWeightDetectionItemDtoPagedResultDto {
    items!: ServiceWeightDetectionItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceWeightDetectionItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceWeightDetectionItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceWeightDetectionItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceWeightDetectionItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceWeightDetectionItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceWeightDetectionItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceWeightDetectionItemDtoPagedResultDto {
    items: ServiceWeightDetectionItemDto[] | undefined;
    totalCount: number;
}

export class ServiceWidgetDto implements IServiceWidgetDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;

    constructor(data?: IServiceWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ServiceWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }

    clone(): ServiceWidgetDto {
        const json = this.toJSON();
        let result = new ServiceWidgetDto();
        result.init(json);
        return result;
    }
}

export interface IServiceWidgetDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
}

export class ServiceWidgetDtoPagedResultDto implements IServiceWidgetDtoPagedResultDto {
    items!: ServiceWidgetDto[] | undefined;
    totalCount!: number;

    constructor(data?: IServiceWidgetDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceWidgetDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): ServiceWidgetDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceWidgetDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): ServiceWidgetDtoPagedResultDto {
        const json = this.toJSON();
        let result = new ServiceWidgetDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IServiceWidgetDtoPagedResultDto {
    items: ServiceWidgetDto[] | undefined;
    totalCount: number;
}

export class SetCloudFolderUrlInput implements ISetCloudFolderUrlInput {
    id!: number;
    url!: string | undefined;

    constructor(data?: ISetCloudFolderUrlInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): SetCloudFolderUrlInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetCloudFolderUrlInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["url"] = this.url;
        return data;
    }

    clone(): SetCloudFolderUrlInput {
        const json = this.toJSON();
        let result = new SetCloudFolderUrlInput();
        result.init(json);
        return result;
    }
}

export interface ISetCloudFolderUrlInput {
    id: number;
    url: string | undefined;
}

export class SetLinkedServiceDiariesDto implements ISetLinkedServiceDiariesDto {
    userId!: number;
    viewingServiceId!: number;
    serviceIds!: number[] | undefined;

    constructor(data?: ISetLinkedServiceDiariesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.viewingServiceId = _data["viewingServiceId"];
            if (Array.isArray(_data["serviceIds"])) {
                this.serviceIds = [] as any;
                for (let item of _data["serviceIds"])
                    this.serviceIds!.push(item);
            }
        }
    }

    static fromJS(data: any): SetLinkedServiceDiariesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetLinkedServiceDiariesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["viewingServiceId"] = this.viewingServiceId;
        if (Array.isArray(this.serviceIds)) {
            data["serviceIds"] = [];
            for (let item of this.serviceIds)
                data["serviceIds"].push(item);
        }
        return data;
    }

    clone(): SetLinkedServiceDiariesDto {
        const json = this.toJSON();
        let result = new SetLinkedServiceDiariesDto();
        result.init(json);
        return result;
    }
}

export interface ISetLinkedServiceDiariesDto {
    userId: number;
    viewingServiceId: number;
    serviceIds: number[] | undefined;
}

export class SetServiceLogReadStateDto implements ISetServiceLogReadStateDto {
    serviceLogId!: number;
    isRead!: boolean;

    constructor(data?: ISetServiceLogReadStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceLogId = _data["serviceLogId"];
            this.isRead = _data["isRead"];
        }
    }

    static fromJS(data: any): SetServiceLogReadStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SetServiceLogReadStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceLogId"] = this.serviceLogId;
        data["isRead"] = this.isRead;
        return data;
    }

    clone(): SetServiceLogReadStateDto {
        const json = this.toJSON();
        let result = new SetServiceLogReadStateDto();
        result.init(json);
        return result;
    }
}

export interface ISetServiceLogReadStateDto {
    serviceLogId: number;
    isRead: boolean;
}

export class SocialAssistanceReferenceDto implements ISocialAssistanceReferenceDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    phoneNumber!: string | undefined;
    otherPhoneNumber!: string | undefined;
    emailAddress!: string | undefined;
    role!: string | undefined;
    address!: AddressDto;
    note!: string | undefined;

    constructor(data?: ISocialAssistanceReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phoneNumber = _data["phoneNumber"];
            this.otherPhoneNumber = _data["otherPhoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.role = _data["role"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : undefined as any;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): SocialAssistanceReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialAssistanceReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phoneNumber"] = this.phoneNumber;
        data["otherPhoneNumber"] = this.otherPhoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["role"] = this.role;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["note"] = this.note;
        return data;
    }

    clone(): SocialAssistanceReferenceDto {
        const json = this.toJSON();
        let result = new SocialAssistanceReferenceDto();
        result.init(json);
        return result;
    }
}

export interface ISocialAssistanceReferenceDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    name: string | undefined;
    surname: string | undefined;
    phoneNumber: string | undefined;
    otherPhoneNumber: string | undefined;
    emailAddress: string | undefined;
    role: string | undefined;
    address: AddressDto;
    note: string | undefined;
}

export class SocialAssistanceReferenceDtoPagedResultDto implements ISocialAssistanceReferenceDtoPagedResultDto {
    items!: SocialAssistanceReferenceDto[] | undefined;
    totalCount!: number;

    constructor(data?: ISocialAssistanceReferenceDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SocialAssistanceReferenceDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SocialAssistanceReferenceDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialAssistanceReferenceDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SocialAssistanceReferenceDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SocialAssistanceReferenceDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISocialAssistanceReferenceDtoPagedResultDto {
    items: SocialAssistanceReferenceDto[] | undefined;
    totalCount: number;
}

export class SocialHealthRecordDto implements ISocialHealthRecordDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    date!: moment.Moment;
    code!: string | undefined;
    dischargeDate!: moment.Moment | undefined;
    dischargeDiagnosis!: string | undefined;
    user!: UserDto;
    socialHealthRecordTemplate!: SocialHealtRecordTemplateDto;
    customDataContent!: string | undefined;

    constructor(data?: ISocialHealthRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.code = _data["code"];
            this.dischargeDate = _data["dischargeDate"] ? moment(_data["dischargeDate"].toString()) : undefined as any;
            this.dischargeDiagnosis = _data["dischargeDiagnosis"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            this.socialHealthRecordTemplate = _data["socialHealthRecordTemplate"] ? SocialHealtRecordTemplateDto.fromJS(_data["socialHealthRecordTemplate"]) : undefined as any;
            this.customDataContent = _data["customDataContent"];
        }
    }

    static fromJS(data: any): SocialHealthRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialHealthRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["code"] = this.code;
        data["dischargeDate"] = this.dischargeDate ? this.dischargeDate.format('YYYY-MM-DD') : undefined as any;
        data["dischargeDiagnosis"] = this.dischargeDiagnosis;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["socialHealthRecordTemplate"] = this.socialHealthRecordTemplate ? this.socialHealthRecordTemplate.toJSON() : undefined as any;
        data["customDataContent"] = this.customDataContent;
        return data;
    }

    clone(): SocialHealthRecordDto {
        const json = this.toJSON();
        let result = new SocialHealthRecordDto();
        result.init(json);
        return result;
    }
}

export interface ISocialHealthRecordDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    date: moment.Moment;
    code: string | undefined;
    dischargeDate: moment.Moment | undefined;
    dischargeDiagnosis: string | undefined;
    user: UserDto;
    socialHealthRecordTemplate: SocialHealtRecordTemplateDto;
    customDataContent: string | undefined;
}

export class SocialHealthRecordDtoPagedResultDto implements ISocialHealthRecordDtoPagedResultDto {
    items!: SocialHealthRecordDto[] | undefined;
    totalCount!: number;

    constructor(data?: ISocialHealthRecordDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SocialHealthRecordDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SocialHealthRecordDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialHealthRecordDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SocialHealthRecordDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SocialHealthRecordDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISocialHealthRecordDtoPagedResultDto {
    items: SocialHealthRecordDto[] | undefined;
    totalCount: number;
}

export class SocialHealthRecordExtensionDateDto implements ISocialHealthRecordExtensionDateDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    date!: moment.Moment;
    reason!: string | undefined;

    constructor(data?: ISocialHealthRecordExtensionDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): SocialHealthRecordExtensionDateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialHealthRecordExtensionDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined as any;
        data["reason"] = this.reason;
        return data;
    }

    clone(): SocialHealthRecordExtensionDateDto {
        const json = this.toJSON();
        let result = new SocialHealthRecordExtensionDateDto();
        result.init(json);
        return result;
    }
}

export interface ISocialHealthRecordExtensionDateDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    date: moment.Moment;
    reason: string | undefined;
}

export class SocialHealthRecordExtensionDateDtoPagedResultDto implements ISocialHealthRecordExtensionDateDtoPagedResultDto {
    items!: SocialHealthRecordExtensionDateDto[] | undefined;
    totalCount!: number;

    constructor(data?: ISocialHealthRecordExtensionDateDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SocialHealthRecordExtensionDateDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SocialHealthRecordExtensionDateDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialHealthRecordExtensionDateDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SocialHealthRecordExtensionDateDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SocialHealthRecordExtensionDateDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISocialHealthRecordExtensionDateDtoPagedResultDto {
    items: SocialHealthRecordExtensionDateDto[] | undefined;
    totalCount: number;
}

export class SocialHealthRecordOperatorPermissionDto implements ISocialHealthRecordOperatorPermissionDto {
    id!: number;
    operator!: ServiceUserDto;
    record!: RecordDto;

    constructor(data?: ISocialHealthRecordOperatorPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.operator = _data["operator"] ? ServiceUserDto.fromJS(_data["operator"]) : undefined as any;
            this.record = _data["record"] ? RecordDto.fromJS(_data["record"]) : undefined as any;
        }
    }

    static fromJS(data: any): SocialHealthRecordOperatorPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialHealthRecordOperatorPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["operator"] = this.operator ? this.operator.toJSON() : undefined as any;
        data["record"] = this.record ? this.record.toJSON() : undefined as any;
        return data;
    }

    clone(): SocialHealthRecordOperatorPermissionDto {
        const json = this.toJSON();
        let result = new SocialHealthRecordOperatorPermissionDto();
        result.init(json);
        return result;
    }
}

export interface ISocialHealthRecordOperatorPermissionDto {
    id: number;
    operator: ServiceUserDto;
    record: RecordDto;
}

export class SocialHealthRecordOperatorPermissionDtoPagedResultDto implements ISocialHealthRecordOperatorPermissionDtoPagedResultDto {
    items!: SocialHealthRecordOperatorPermissionDto[] | undefined;
    totalCount!: number;

    constructor(data?: ISocialHealthRecordOperatorPermissionDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SocialHealthRecordOperatorPermissionDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SocialHealthRecordOperatorPermissionDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialHealthRecordOperatorPermissionDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SocialHealthRecordOperatorPermissionDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SocialHealthRecordOperatorPermissionDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISocialHealthRecordOperatorPermissionDtoPagedResultDto {
    items: SocialHealthRecordOperatorPermissionDto[] | undefined;
    totalCount: number;
}

export class SocialHealtRecordTemplateDto implements ISocialHealtRecordTemplateDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    isHidden!: boolean;
    name!: string | undefined;
    description!: string | undefined;
    widgets!: RecordDto[] | undefined;
    isDeletable!: boolean;

    constructor(data?: ISocialHealtRecordTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.isHidden = _data["isHidden"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["widgets"])
                    this.widgets!.push(RecordDto.fromJS(item));
            }
            this.isDeletable = _data["isDeletable"];
        }
    }

    static fromJS(data: any): SocialHealtRecordTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialHealtRecordTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["isHidden"] = this.isHidden;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDeletable"] = this.isDeletable;
        return data;
    }

    clone(): SocialHealtRecordTemplateDto {
        const json = this.toJSON();
        let result = new SocialHealtRecordTemplateDto();
        result.init(json);
        return result;
    }
}

export interface ISocialHealtRecordTemplateDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    isHidden: boolean;
    name: string | undefined;
    description: string | undefined;
    widgets: RecordDto[] | undefined;
    isDeletable: boolean;
}

export class SocialHealtRecordTemplateDtoPagedResultDto implements ISocialHealtRecordTemplateDtoPagedResultDto {
    items!: SocialHealtRecordTemplateDto[] | undefined;
    totalCount!: number;

    constructor(data?: ISocialHealtRecordTemplateDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SocialHealtRecordTemplateDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SocialHealtRecordTemplateDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialHealtRecordTemplateDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SocialHealtRecordTemplateDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SocialHealtRecordTemplateDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISocialHealtRecordTemplateDtoPagedResultDto {
    items: SocialHealtRecordTemplateDto[] | undefined;
    totalCount: number;
}

export class SocialInvestigationRecordDto implements ISocialInvestigationRecordDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    socialHealthRecord!: SocialHealthRecordDto;
    briefUserHistory!: string | undefined;
    familyComponents!: FamilyComponentDto[] | undefined;
    familySituation!: DictionaryDto;
    familyNote!: string | undefined;
    familyMedicalHistory!: string | undefined;
    familyDynamics!: string | undefined;
    incomeAllowances!: IncomeAllowanceDto[] | undefined;
    protectionMeasure!: ProtectionMeasureDto;
    housingSituation!: HousingSituationDto;
    eductionalTraining!: EducationalTrainingDto;
    freeTimeAutonomies!: string | undefined;
    characteristicsOrProblems!: string | undefined;

    constructor(data?: ISocialInvestigationRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.socialHealthRecord = _data["socialHealthRecord"] ? SocialHealthRecordDto.fromJS(_data["socialHealthRecord"]) : undefined as any;
            this.briefUserHistory = _data["briefUserHistory"];
            if (Array.isArray(_data["familyComponents"])) {
                this.familyComponents = [] as any;
                for (let item of _data["familyComponents"])
                    this.familyComponents!.push(FamilyComponentDto.fromJS(item));
            }
            this.familySituation = _data["familySituation"] ? DictionaryDto.fromJS(_data["familySituation"]) : undefined as any;
            this.familyNote = _data["familyNote"];
            this.familyMedicalHistory = _data["familyMedicalHistory"];
            this.familyDynamics = _data["familyDynamics"];
            if (Array.isArray(_data["incomeAllowances"])) {
                this.incomeAllowances = [] as any;
                for (let item of _data["incomeAllowances"])
                    this.incomeAllowances!.push(IncomeAllowanceDto.fromJS(item));
            }
            this.protectionMeasure = _data["protectionMeasure"] ? ProtectionMeasureDto.fromJS(_data["protectionMeasure"]) : undefined as any;
            this.housingSituation = _data["housingSituation"] ? HousingSituationDto.fromJS(_data["housingSituation"]) : undefined as any;
            this.eductionalTraining = _data["eductionalTraining"] ? EducationalTrainingDto.fromJS(_data["eductionalTraining"]) : undefined as any;
            this.freeTimeAutonomies = _data["freeTimeAutonomies"];
            this.characteristicsOrProblems = _data["characteristicsOrProblems"];
        }
    }

    static fromJS(data: any): SocialInvestigationRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialInvestigationRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["socialHealthRecord"] = this.socialHealthRecord ? this.socialHealthRecord.toJSON() : undefined as any;
        data["briefUserHistory"] = this.briefUserHistory;
        if (Array.isArray(this.familyComponents)) {
            data["familyComponents"] = [];
            for (let item of this.familyComponents)
                data["familyComponents"].push(item ? item.toJSON() : undefined as any);
        }
        data["familySituation"] = this.familySituation ? this.familySituation.toJSON() : undefined as any;
        data["familyNote"] = this.familyNote;
        data["familyMedicalHistory"] = this.familyMedicalHistory;
        data["familyDynamics"] = this.familyDynamics;
        if (Array.isArray(this.incomeAllowances)) {
            data["incomeAllowances"] = [];
            for (let item of this.incomeAllowances)
                data["incomeAllowances"].push(item ? item.toJSON() : undefined as any);
        }
        data["protectionMeasure"] = this.protectionMeasure ? this.protectionMeasure.toJSON() : undefined as any;
        data["housingSituation"] = this.housingSituation ? this.housingSituation.toJSON() : undefined as any;
        data["eductionalTraining"] = this.eductionalTraining ? this.eductionalTraining.toJSON() : undefined as any;
        data["freeTimeAutonomies"] = this.freeTimeAutonomies;
        data["characteristicsOrProblems"] = this.characteristicsOrProblems;
        return data;
    }

    clone(): SocialInvestigationRecordDto {
        const json = this.toJSON();
        let result = new SocialInvestigationRecordDto();
        result.init(json);
        return result;
    }
}

export interface ISocialInvestigationRecordDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    socialHealthRecord: SocialHealthRecordDto;
    briefUserHistory: string | undefined;
    familyComponents: FamilyComponentDto[] | undefined;
    familySituation: DictionaryDto;
    familyNote: string | undefined;
    familyMedicalHistory: string | undefined;
    familyDynamics: string | undefined;
    incomeAllowances: IncomeAllowanceDto[] | undefined;
    protectionMeasure: ProtectionMeasureDto;
    housingSituation: HousingSituationDto;
    eductionalTraining: EducationalTrainingDto;
    freeTimeAutonomies: string | undefined;
    characteristicsOrProblems: string | undefined;
}

export class SocialInvestigationRecordDtoPagedResultDto implements ISocialInvestigationRecordDtoPagedResultDto {
    items!: SocialInvestigationRecordDto[] | undefined;
    totalCount!: number;

    constructor(data?: ISocialInvestigationRecordDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SocialInvestigationRecordDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SocialInvestigationRecordDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SocialInvestigationRecordDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SocialInvestigationRecordDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SocialInvestigationRecordDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISocialInvestigationRecordDtoPagedResultDto {
    items: SocialInvestigationRecordDto[] | undefined;
    totalCount: number;
}

export class SpecialistAssessmentRecordDto implements ISpecialistAssessmentRecordDto {
    id!: number;
    date!: moment.Moment;
    diagnosis!: string | undefined;
    advice!: string | undefined;

    constructor(data?: ISpecialistAssessmentRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.diagnosis = _data["diagnosis"];
            this.advice = _data["advice"];
        }
    }

    static fromJS(data: any): SpecialistAssessmentRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialistAssessmentRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["diagnosis"] = this.diagnosis;
        data["advice"] = this.advice;
        return data;
    }

    clone(): SpecialistAssessmentRecordDto {
        const json = this.toJSON();
        let result = new SpecialistAssessmentRecordDto();
        result.init(json);
        return result;
    }
}

export interface ISpecialistAssessmentRecordDto {
    id: number;
    date: moment.Moment;
    diagnosis: string | undefined;
    advice: string | undefined;
}

export class SpecialistAssessmentRecordDtoPagedResultDto implements ISpecialistAssessmentRecordDtoPagedResultDto {
    items!: SpecialistAssessmentRecordDto[] | undefined;
    totalCount!: number;

    constructor(data?: ISpecialistAssessmentRecordDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SpecialistAssessmentRecordDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SpecialistAssessmentRecordDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialistAssessmentRecordDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SpecialistAssessmentRecordDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SpecialistAssessmentRecordDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISpecialistAssessmentRecordDtoPagedResultDto {
    items: SpecialistAssessmentRecordDto[] | undefined;
    totalCount: number;
}

export class SpontaneousReportingEventDto implements ISpontaneousReportingEventDto {
    id!: number;
    isConfirmed!: boolean;
    confirmingUserId!: number | undefined;
    confirmingUserFullName!: string | undefined;
    confirmationDate!: moment.Moment | undefined;
    structure!: string | undefined;
    operationalUnit!: string | undefined;
    equipe!: ServiceUserDto;
    title!: DictionaryDto;
    otherTitle!: string | undefined;
    hospitalizationNumber!: string | undefined;
    performanceType!: DictionaryDto;
    otherPerformanceType!: string | undefined;
    procedureDelay!: DictionaryDto;
    inappropriateType!: DictionaryDto;
    missedProcedureType!: DictionaryDto;
    otherEventType!: DictionaryDto;
    otherOtherEventType!: string | undefined;
    dateTime!: moment.Moment;
    place!: string | undefined;
    isWeekday!: boolean | undefined;
    description!: string | undefined;
    patientFactors!: DictionaryDto[] | undefined;
    staffFactors!: DictionaryDto[] | undefined;
    systemFactors!: DictionaryDto[] | undefined;
    otherSystemFactor!: string | undefined;
    outcomeReductionFactors!: DictionaryDto[] | undefined;
    otherOutcomeReductionFactor!: string | undefined;
    additionalInvestigations!: DictionaryDto[] | undefined;
    otherAdditionalInvestigation!: string | undefined;
    isDocumented!: boolean | undefined;
    isPatientInformed!: boolean | undefined;
    preventedOrAvoidedEvent!: string | undefined;
    eventSeverityLevel!: DictionaryDto;

    constructor(data?: ISpontaneousReportingEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isConfirmed = _data["isConfirmed"];
            this.confirmingUserId = _data["confirmingUserId"];
            this.confirmingUserFullName = _data["confirmingUserFullName"];
            this.confirmationDate = _data["confirmationDate"] ? moment(_data["confirmationDate"].toString()) : undefined as any;
            this.structure = _data["structure"];
            this.operationalUnit = _data["operationalUnit"];
            this.equipe = _data["equipe"] ? ServiceUserDto.fromJS(_data["equipe"]) : undefined as any;
            this.title = _data["title"] ? DictionaryDto.fromJS(_data["title"]) : undefined as any;
            this.otherTitle = _data["otherTitle"];
            this.hospitalizationNumber = _data["hospitalizationNumber"];
            this.performanceType = _data["performanceType"] ? DictionaryDto.fromJS(_data["performanceType"]) : undefined as any;
            this.otherPerformanceType = _data["otherPerformanceType"];
            this.procedureDelay = _data["procedureDelay"] ? DictionaryDto.fromJS(_data["procedureDelay"]) : undefined as any;
            this.inappropriateType = _data["inappropriateType"] ? DictionaryDto.fromJS(_data["inappropriateType"]) : undefined as any;
            this.missedProcedureType = _data["missedProcedureType"] ? DictionaryDto.fromJS(_data["missedProcedureType"]) : undefined as any;
            this.otherEventType = _data["otherEventType"] ? DictionaryDto.fromJS(_data["otherEventType"]) : undefined as any;
            this.otherOtherEventType = _data["otherOtherEventType"];
            this.dateTime = _data["dateTime"] ? moment(_data["dateTime"].toString()) : undefined as any;
            this.place = _data["place"];
            this.isWeekday = _data["isWeekday"];
            this.description = _data["description"];
            if (Array.isArray(_data["patientFactors"])) {
                this.patientFactors = [] as any;
                for (let item of _data["patientFactors"])
                    this.patientFactors!.push(DictionaryDto.fromJS(item));
            }
            if (Array.isArray(_data["staffFactors"])) {
                this.staffFactors = [] as any;
                for (let item of _data["staffFactors"])
                    this.staffFactors!.push(DictionaryDto.fromJS(item));
            }
            if (Array.isArray(_data["systemFactors"])) {
                this.systemFactors = [] as any;
                for (let item of _data["systemFactors"])
                    this.systemFactors!.push(DictionaryDto.fromJS(item));
            }
            this.otherSystemFactor = _data["otherSystemFactor"];
            if (Array.isArray(_data["outcomeReductionFactors"])) {
                this.outcomeReductionFactors = [] as any;
                for (let item of _data["outcomeReductionFactors"])
                    this.outcomeReductionFactors!.push(DictionaryDto.fromJS(item));
            }
            this.otherOutcomeReductionFactor = _data["otherOutcomeReductionFactor"];
            if (Array.isArray(_data["additionalInvestigations"])) {
                this.additionalInvestigations = [] as any;
                for (let item of _data["additionalInvestigations"])
                    this.additionalInvestigations!.push(DictionaryDto.fromJS(item));
            }
            this.otherAdditionalInvestigation = _data["otherAdditionalInvestigation"];
            this.isDocumented = _data["isDocumented"];
            this.isPatientInformed = _data["isPatientInformed"];
            this.preventedOrAvoidedEvent = _data["preventedOrAvoidedEvent"];
            this.eventSeverityLevel = _data["eventSeverityLevel"] ? DictionaryDto.fromJS(_data["eventSeverityLevel"]) : undefined as any;
        }
    }

    static fromJS(data: any): SpontaneousReportingEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpontaneousReportingEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isConfirmed"] = this.isConfirmed;
        data["confirmingUserId"] = this.confirmingUserId;
        data["confirmingUserFullName"] = this.confirmingUserFullName;
        data["confirmationDate"] = this.confirmationDate ? this.confirmationDate.toISOString() : undefined as any;
        data["structure"] = this.structure;
        data["operationalUnit"] = this.operationalUnit;
        data["equipe"] = this.equipe ? this.equipe.toJSON() : undefined as any;
        data["title"] = this.title ? this.title.toJSON() : undefined as any;
        data["otherTitle"] = this.otherTitle;
        data["hospitalizationNumber"] = this.hospitalizationNumber;
        data["performanceType"] = this.performanceType ? this.performanceType.toJSON() : undefined as any;
        data["otherPerformanceType"] = this.otherPerformanceType;
        data["procedureDelay"] = this.procedureDelay ? this.procedureDelay.toJSON() : undefined as any;
        data["inappropriateType"] = this.inappropriateType ? this.inappropriateType.toJSON() : undefined as any;
        data["missedProcedureType"] = this.missedProcedureType ? this.missedProcedureType.toJSON() : undefined as any;
        data["otherEventType"] = this.otherEventType ? this.otherEventType.toJSON() : undefined as any;
        data["otherOtherEventType"] = this.otherOtherEventType;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : undefined as any;
        data["place"] = this.place;
        data["isWeekday"] = this.isWeekday;
        data["description"] = this.description;
        if (Array.isArray(this.patientFactors)) {
            data["patientFactors"] = [];
            for (let item of this.patientFactors)
                data["patientFactors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.staffFactors)) {
            data["staffFactors"] = [];
            for (let item of this.staffFactors)
                data["staffFactors"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.systemFactors)) {
            data["systemFactors"] = [];
            for (let item of this.systemFactors)
                data["systemFactors"].push(item ? item.toJSON() : undefined as any);
        }
        data["otherSystemFactor"] = this.otherSystemFactor;
        if (Array.isArray(this.outcomeReductionFactors)) {
            data["outcomeReductionFactors"] = [];
            for (let item of this.outcomeReductionFactors)
                data["outcomeReductionFactors"].push(item ? item.toJSON() : undefined as any);
        }
        data["otherOutcomeReductionFactor"] = this.otherOutcomeReductionFactor;
        if (Array.isArray(this.additionalInvestigations)) {
            data["additionalInvestigations"] = [];
            for (let item of this.additionalInvestigations)
                data["additionalInvestigations"].push(item ? item.toJSON() : undefined as any);
        }
        data["otherAdditionalInvestigation"] = this.otherAdditionalInvestigation;
        data["isDocumented"] = this.isDocumented;
        data["isPatientInformed"] = this.isPatientInformed;
        data["preventedOrAvoidedEvent"] = this.preventedOrAvoidedEvent;
        data["eventSeverityLevel"] = this.eventSeverityLevel ? this.eventSeverityLevel.toJSON() : undefined as any;
        return data;
    }

    clone(): SpontaneousReportingEventDto {
        const json = this.toJSON();
        let result = new SpontaneousReportingEventDto();
        result.init(json);
        return result;
    }
}

export interface ISpontaneousReportingEventDto {
    id: number;
    isConfirmed: boolean;
    confirmingUserId: number | undefined;
    confirmingUserFullName: string | undefined;
    confirmationDate: moment.Moment | undefined;
    structure: string | undefined;
    operationalUnit: string | undefined;
    equipe: ServiceUserDto;
    title: DictionaryDto;
    otherTitle: string | undefined;
    hospitalizationNumber: string | undefined;
    performanceType: DictionaryDto;
    otherPerformanceType: string | undefined;
    procedureDelay: DictionaryDto;
    inappropriateType: DictionaryDto;
    missedProcedureType: DictionaryDto;
    otherEventType: DictionaryDto;
    otherOtherEventType: string | undefined;
    dateTime: moment.Moment;
    place: string | undefined;
    isWeekday: boolean | undefined;
    description: string | undefined;
    patientFactors: DictionaryDto[] | undefined;
    staffFactors: DictionaryDto[] | undefined;
    systemFactors: DictionaryDto[] | undefined;
    otherSystemFactor: string | undefined;
    outcomeReductionFactors: DictionaryDto[] | undefined;
    otherOutcomeReductionFactor: string | undefined;
    additionalInvestigations: DictionaryDto[] | undefined;
    otherAdditionalInvestigation: string | undefined;
    isDocumented: boolean | undefined;
    isPatientInformed: boolean | undefined;
    preventedOrAvoidedEvent: string | undefined;
    eventSeverityLevel: DictionaryDto;
}

export class SpontaneousReportingEventItemDto implements ISpontaneousReportingEventItemDto {
    id!: number;
    isConfirmed!: boolean;
    confirmingUserFullName!: string | undefined;
    dateTime!: moment.Moment;
    place!: string | undefined;

    constructor(data?: ISpontaneousReportingEventItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isConfirmed = _data["isConfirmed"];
            this.confirmingUserFullName = _data["confirmingUserFullName"];
            this.dateTime = _data["dateTime"] ? moment(_data["dateTime"].toString()) : undefined as any;
            this.place = _data["place"];
        }
    }

    static fromJS(data: any): SpontaneousReportingEventItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpontaneousReportingEventItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isConfirmed"] = this.isConfirmed;
        data["confirmingUserFullName"] = this.confirmingUserFullName;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : undefined as any;
        data["place"] = this.place;
        return data;
    }

    clone(): SpontaneousReportingEventItemDto {
        const json = this.toJSON();
        let result = new SpontaneousReportingEventItemDto();
        result.init(json);
        return result;
    }
}

export interface ISpontaneousReportingEventItemDto {
    id: number;
    isConfirmed: boolean;
    confirmingUserFullName: string | undefined;
    dateTime: moment.Moment;
    place: string | undefined;
}

export class SpontaneousReportingEventItemDtoPagedResultDto implements ISpontaneousReportingEventItemDtoPagedResultDto {
    items!: SpontaneousReportingEventItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: ISpontaneousReportingEventItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SpontaneousReportingEventItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): SpontaneousReportingEventItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new SpontaneousReportingEventItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): SpontaneousReportingEventItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new SpontaneousReportingEventItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ISpontaneousReportingEventItemDtoPagedResultDto {
    items: SpontaneousReportingEventItemDto[] | undefined;
    totalCount: number;
}

export class StructureDetailDto implements IStructureDetailDto {
    id!: number;
    cadastralData!: string | undefined;
    structureOwnershipType!: DictionaryDto;
    releaseDate!: moment.Moment | undefined;
    leaseExpirationDate!: moment.Moment | undefined;
    contractRent!: boolean;
    contractRentFile!: FileDto;
    deed!: boolean;
    deedFile!: FileDto;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    extensionDate!: moment.Moment | undefined;
    contractConcession!: boolean;
    contractConcessionFile!: FileDto;
    lastBuildingPermitDate!: moment.Moment | undefined;
    lastOccupancyCertificateDate!: moment.Moment | undefined;
    undergroundLocalAuthorizations!: boolean;
    undergroundLocalAuthorizationsFile!: FileDto;
    floorPlan!: boolean;
    floorPlanFile!: FileDto;
    surfaceArea!: number | undefined;
    cpi!: boolean;
    cpiFile!: FileDto;
    cpiType!: DictionaryDto;

    constructor(data?: IStructureDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cadastralData = _data["cadastralData"];
            this.structureOwnershipType = _data["structureOwnershipType"] ? DictionaryDto.fromJS(_data["structureOwnershipType"]) : undefined as any;
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : undefined as any;
            this.leaseExpirationDate = _data["leaseExpirationDate"] ? moment(_data["leaseExpirationDate"].toString()) : undefined as any;
            this.contractRent = _data["contractRent"];
            this.contractRentFile = _data["contractRentFile"] ? FileDto.fromJS(_data["contractRentFile"]) : undefined as any;
            this.deed = _data["deed"];
            this.deedFile = _data["deedFile"] ? FileDto.fromJS(_data["deedFile"]) : undefined as any;
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
            this.extensionDate = _data["extensionDate"] ? moment(_data["extensionDate"].toString()) : undefined as any;
            this.contractConcession = _data["contractConcession"];
            this.contractConcessionFile = _data["contractConcessionFile"] ? FileDto.fromJS(_data["contractConcessionFile"]) : undefined as any;
            this.lastBuildingPermitDate = _data["lastBuildingPermitDate"] ? moment(_data["lastBuildingPermitDate"].toString()) : undefined as any;
            this.lastOccupancyCertificateDate = _data["lastOccupancyCertificateDate"] ? moment(_data["lastOccupancyCertificateDate"].toString()) : undefined as any;
            this.undergroundLocalAuthorizations = _data["undergroundLocalAuthorizations"];
            this.undergroundLocalAuthorizationsFile = _data["undergroundLocalAuthorizationsFile"] ? FileDto.fromJS(_data["undergroundLocalAuthorizationsFile"]) : undefined as any;
            this.floorPlan = _data["floorPlan"];
            this.floorPlanFile = _data["floorPlanFile"] ? FileDto.fromJS(_data["floorPlanFile"]) : undefined as any;
            this.surfaceArea = _data["surfaceArea"];
            this.cpi = _data["cpi"];
            this.cpiFile = _data["cpiFile"] ? FileDto.fromJS(_data["cpiFile"]) : undefined as any;
            this.cpiType = _data["cpiType"] ? DictionaryDto.fromJS(_data["cpiType"]) : undefined as any;
        }
    }

    static fromJS(data: any): StructureDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new StructureDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cadastralData"] = this.cadastralData;
        data["structureOwnershipType"] = this.structureOwnershipType ? this.structureOwnershipType.toJSON() : undefined as any;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined as any;
        data["leaseExpirationDate"] = this.leaseExpirationDate ? this.leaseExpirationDate.toISOString() : undefined as any;
        data["contractRent"] = this.contractRent;
        data["contractRentFile"] = this.contractRentFile ? this.contractRentFile.toJSON() : undefined as any;
        data["deed"] = this.deed;
        data["deedFile"] = this.deedFile ? this.deedFile.toJSON() : undefined as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["extensionDate"] = this.extensionDate ? this.extensionDate.toISOString() : undefined as any;
        data["contractConcession"] = this.contractConcession;
        data["contractConcessionFile"] = this.contractConcessionFile ? this.contractConcessionFile.toJSON() : undefined as any;
        data["lastBuildingPermitDate"] = this.lastBuildingPermitDate ? this.lastBuildingPermitDate.toISOString() : undefined as any;
        data["lastOccupancyCertificateDate"] = this.lastOccupancyCertificateDate ? this.lastOccupancyCertificateDate.toISOString() : undefined as any;
        data["undergroundLocalAuthorizations"] = this.undergroundLocalAuthorizations;
        data["undergroundLocalAuthorizationsFile"] = this.undergroundLocalAuthorizationsFile ? this.undergroundLocalAuthorizationsFile.toJSON() : undefined as any;
        data["floorPlan"] = this.floorPlan;
        data["floorPlanFile"] = this.floorPlanFile ? this.floorPlanFile.toJSON() : undefined as any;
        data["surfaceArea"] = this.surfaceArea;
        data["cpi"] = this.cpi;
        data["cpiFile"] = this.cpiFile ? this.cpiFile.toJSON() : undefined as any;
        data["cpiType"] = this.cpiType ? this.cpiType.toJSON() : undefined as any;
        return data;
    }

    clone(): StructureDetailDto {
        const json = this.toJSON();
        let result = new StructureDetailDto();
        result.init(json);
        return result;
    }
}

export interface IStructureDetailDto {
    id: number;
    cadastralData: string | undefined;
    structureOwnershipType: DictionaryDto;
    releaseDate: moment.Moment | undefined;
    leaseExpirationDate: moment.Moment | undefined;
    contractRent: boolean;
    contractRentFile: FileDto;
    deed: boolean;
    deedFile: FileDto;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    extensionDate: moment.Moment | undefined;
    contractConcession: boolean;
    contractConcessionFile: FileDto;
    lastBuildingPermitDate: moment.Moment | undefined;
    lastOccupancyCertificateDate: moment.Moment | undefined;
    undergroundLocalAuthorizations: boolean;
    undergroundLocalAuthorizationsFile: FileDto;
    floorPlan: boolean;
    floorPlanFile: FileDto;
    surfaceArea: number | undefined;
    cpi: boolean;
    cpiFile: FileDto;
    cpiType: DictionaryDto;
}

export class StructureDetailDtoPagedResultDto implements IStructureDetailDtoPagedResultDto {
    items!: StructureDetailDto[] | undefined;
    totalCount!: number;

    constructor(data?: IStructureDetailDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StructureDetailDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): StructureDetailDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StructureDetailDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): StructureDetailDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StructureDetailDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStructureDetailDtoPagedResultDto {
    items: StructureDetailDto[] | undefined;
    totalCount: number;
}

export class StructureDto implements IStructureDto {
    id!: number;
    name!: string | undefined;
    address!: AddressDto;
    status!: boolean | undefined;
    template!: StructureTemplateDto;

    constructor(data?: IStructureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : undefined as any;
            this.status = _data["status"];
            this.template = _data["template"] ? StructureTemplateDto.fromJS(_data["template"]) : undefined as any;
        }
    }

    static fromJS(data: any): StructureDto {
        data = typeof data === 'object' ? data : {};
        let result = new StructureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["status"] = this.status;
        data["template"] = this.template ? this.template.toJSON() : undefined as any;
        return data;
    }

    clone(): StructureDto {
        const json = this.toJSON();
        let result = new StructureDto();
        result.init(json);
        return result;
    }
}

export interface IStructureDto {
    id: number;
    name: string | undefined;
    address: AddressDto;
    status: boolean | undefined;
    template: StructureTemplateDto;
}

export class StructureDtoPagedResultDto implements IStructureDtoPagedResultDto {
    items!: StructureDto[] | undefined;
    totalCount!: number;

    constructor(data?: IStructureDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StructureDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): StructureDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StructureDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): StructureDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StructureDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStructureDtoPagedResultDto {
    items: StructureDto[] | undefined;
    totalCount: number;
}

export class StructureRegistryDataDto implements IStructureRegistryDataDto {
    id!: number;
    nui!: string | undefined;
    floor!: string | undefined;
    hasElevator!: boolean | undefined;
    householdHead!: string | undefined;
    contractStartDate!: moment.Moment | undefined;
    contractEndDate!: moment.Moment | undefined;
    projectType!: string | undefined;
    projectTotalPlaces!: number | undefined;
    projectExpirationDate!: moment.Moment | undefined;
    ownerName!: string | undefined;
    ownerPhoneNumber!: string | undefined;
    ownerEmailAddress!: string | undefined;
    utilitiesPayment!: string | undefined;
    heatingType!: string | undefined;
    heatingOrdinaryCleaning!: string | undefined;
    heatingCost!: number | undefined;
    heatingBrand!: string | undefined;
    notes!: string | undefined;
    structure!: StructureDto;

    constructor(data?: IStructureRegistryDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nui = _data["nui"];
            this.floor = _data["floor"];
            this.hasElevator = _data["hasElevator"];
            this.householdHead = _data["householdHead"];
            this.contractStartDate = _data["contractStartDate"] ? moment(_data["contractStartDate"].toString()) : undefined as any;
            this.contractEndDate = _data["contractEndDate"] ? moment(_data["contractEndDate"].toString()) : undefined as any;
            this.projectType = _data["projectType"];
            this.projectTotalPlaces = _data["projectTotalPlaces"];
            this.projectExpirationDate = _data["projectExpirationDate"] ? moment(_data["projectExpirationDate"].toString()) : undefined as any;
            this.ownerName = _data["ownerName"];
            this.ownerPhoneNumber = _data["ownerPhoneNumber"];
            this.ownerEmailAddress = _data["ownerEmailAddress"];
            this.utilitiesPayment = _data["utilitiesPayment"];
            this.heatingType = _data["heatingType"];
            this.heatingOrdinaryCleaning = _data["heatingOrdinaryCleaning"];
            this.heatingCost = _data["heatingCost"];
            this.heatingBrand = _data["heatingBrand"];
            this.notes = _data["notes"];
            this.structure = _data["structure"] ? StructureDto.fromJS(_data["structure"]) : undefined as any;
        }
    }

    static fromJS(data: any): StructureRegistryDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new StructureRegistryDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nui"] = this.nui;
        data["floor"] = this.floor;
        data["hasElevator"] = this.hasElevator;
        data["householdHead"] = this.householdHead;
        data["contractStartDate"] = this.contractStartDate ? this.contractStartDate.toISOString() : undefined as any;
        data["contractEndDate"] = this.contractEndDate ? this.contractEndDate.toISOString() : undefined as any;
        data["projectType"] = this.projectType;
        data["projectTotalPlaces"] = this.projectTotalPlaces;
        data["projectExpirationDate"] = this.projectExpirationDate ? this.projectExpirationDate.toISOString() : undefined as any;
        data["ownerName"] = this.ownerName;
        data["ownerPhoneNumber"] = this.ownerPhoneNumber;
        data["ownerEmailAddress"] = this.ownerEmailAddress;
        data["utilitiesPayment"] = this.utilitiesPayment;
        data["heatingType"] = this.heatingType;
        data["heatingOrdinaryCleaning"] = this.heatingOrdinaryCleaning;
        data["heatingCost"] = this.heatingCost;
        data["heatingBrand"] = this.heatingBrand;
        data["notes"] = this.notes;
        data["structure"] = this.structure ? this.structure.toJSON() : undefined as any;
        return data;
    }

    clone(): StructureRegistryDataDto {
        const json = this.toJSON();
        let result = new StructureRegistryDataDto();
        result.init(json);
        return result;
    }
}

export interface IStructureRegistryDataDto {
    id: number;
    nui: string | undefined;
    floor: string | undefined;
    hasElevator: boolean | undefined;
    householdHead: string | undefined;
    contractStartDate: moment.Moment | undefined;
    contractEndDate: moment.Moment | undefined;
    projectType: string | undefined;
    projectTotalPlaces: number | undefined;
    projectExpirationDate: moment.Moment | undefined;
    ownerName: string | undefined;
    ownerPhoneNumber: string | undefined;
    ownerEmailAddress: string | undefined;
    utilitiesPayment: string | undefined;
    heatingType: string | undefined;
    heatingOrdinaryCleaning: string | undefined;
    heatingCost: number | undefined;
    heatingBrand: string | undefined;
    notes: string | undefined;
    structure: StructureDto;
}

export class StructureRegistryDataDtoPagedResultDto implements IStructureRegistryDataDtoPagedResultDto {
    items!: StructureRegistryDataDto[] | undefined;
    totalCount!: number;

    constructor(data?: IStructureRegistryDataDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StructureRegistryDataDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): StructureRegistryDataDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StructureRegistryDataDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): StructureRegistryDataDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StructureRegistryDataDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStructureRegistryDataDtoPagedResultDto {
    items: StructureRegistryDataDto[] | undefined;
    totalCount: number;
}

export class StructureTemplateDto implements IStructureTemplateDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    isHidden!: boolean;
    name!: string | undefined;
    description!: string | undefined;
    widgets!: StructureWidgetDto[] | undefined;
    isDeletable!: boolean;

    constructor(data?: IStructureTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.isHidden = _data["isHidden"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["widgets"])
                    this.widgets!.push(StructureWidgetDto.fromJS(item));
            }
            this.isDeletable = _data["isDeletable"];
        }
    }

    static fromJS(data: any): StructureTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new StructureTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["isHidden"] = this.isHidden;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item ? item.toJSON() : undefined as any);
        }
        data["isDeletable"] = this.isDeletable;
        return data;
    }

    clone(): StructureTemplateDto {
        const json = this.toJSON();
        let result = new StructureTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IStructureTemplateDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    isHidden: boolean;
    name: string | undefined;
    description: string | undefined;
    widgets: StructureWidgetDto[] | undefined;
    isDeletable: boolean;
}

export class StructureTemplateDtoPagedResultDto implements IStructureTemplateDtoPagedResultDto {
    items!: StructureTemplateDto[] | undefined;
    totalCount!: number;

    constructor(data?: IStructureTemplateDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StructureTemplateDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): StructureTemplateDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StructureTemplateDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): StructureTemplateDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StructureTemplateDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStructureTemplateDtoPagedResultDto {
    items: StructureTemplateDto[] | undefined;
    totalCount: number;
}

export class StructureWidgetDto implements IStructureWidgetDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;

    constructor(data?: IStructureWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): StructureWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new StructureWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }

    clone(): StructureWidgetDto {
        const json = this.toJSON();
        let result = new StructureWidgetDto();
        result.init(json);
        return result;
    }
}

export interface IStructureWidgetDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
}

export class StructureWidgetDtoPagedResultDto implements IStructureWidgetDtoPagedResultDto {
    items!: StructureWidgetDto[] | undefined;
    totalCount!: number;

    constructor(data?: IStructureWidgetDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StructureWidgetDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): StructureWidgetDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new StructureWidgetDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): StructureWidgetDtoPagedResultDto {
        const json = this.toJSON();
        let result = new StructureWidgetDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IStructureWidgetDtoPagedResultDto {
    items: StructureWidgetDto[] | undefined;
    totalCount: number;
}

export class TagDto implements ITagDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;
    subTags!: DictionaryDto[] | undefined;

    constructor(data?: ITagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
            if (Array.isArray(_data["subTags"])) {
                this.subTags = [] as any;
                for (let item of _data["subTags"])
                    this.subTags!.push(DictionaryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        if (Array.isArray(this.subTags)) {
            data["subTags"] = [];
            for (let item of this.subTags)
                data["subTags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TagDto {
        const json = this.toJSON();
        let result = new TagDto();
        result.init(json);
        return result;
    }
}

export interface ITagDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
    subTags: DictionaryDto[] | undefined;
}

export enum TenantAvailabilityState {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}

export class TenantDto implements ITenantDto {
    id!: number;
    tenancyName!: string;
    name!: string;
    isActive!: boolean;

    constructor(data?: ITenantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TenantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): TenantDto {
        const json = this.toJSON();
        let result = new TenantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDto {
    id: number;
    tenancyName: string;
    name: string;
    isActive: boolean;
}

export class TenantDtoPagedResultDto implements ITenantDtoPagedResultDto {
    items!: TenantDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITenantDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TenantDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TenantDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TenantDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDtoPagedResultDto {
    items: TenantDto[] | undefined;
    totalCount: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    id!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        return data;
    }

    clone(): TenantLoginInfoDto {
        const json = this.toJSON();
        let result = new TenantLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface ITenantLoginInfoDto {
    id: number;
    tenancyName: string | undefined;
    name: string | undefined;
}

export class TinettiAnswerDto implements ITinettiAnswerDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;
    tinettiQuestion!: TinettiQuestionDto;
    value!: number;

    constructor(data?: ITinettiAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
            this.tinettiQuestion = _data["tinettiQuestion"] ? TinettiQuestionDto.fromJS(_data["tinettiQuestion"]) : undefined as any;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TinettiAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new TinettiAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        data["tinettiQuestion"] = this.tinettiQuestion ? this.tinettiQuestion.toJSON() : undefined as any;
        data["value"] = this.value;
        return data;
    }

    clone(): TinettiAnswerDto {
        const json = this.toJSON();
        let result = new TinettiAnswerDto();
        result.init(json);
        return result;
    }
}

export interface ITinettiAnswerDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
    tinettiQuestion: TinettiQuestionDto;
    value: number;
}

export class TinettiPerformanceRecordAnswerDto implements ITinettiPerformanceRecordAnswerDto {
    id!: number;
    tinettiStaircaseRecordId!: number;
    allAnswers!: TinettiAnswerDto[] | undefined;

    constructor(data?: ITinettiPerformanceRecordAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tinettiStaircaseRecordId = _data["tinettiStaircaseRecordId"];
            if (Array.isArray(_data["allAnswers"])) {
                this.allAnswers = [] as any;
                for (let item of _data["allAnswers"])
                    this.allAnswers!.push(TinettiAnswerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TinettiPerformanceRecordAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new TinettiPerformanceRecordAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tinettiStaircaseRecordId"] = this.tinettiStaircaseRecordId;
        if (Array.isArray(this.allAnswers)) {
            data["allAnswers"] = [];
            for (let item of this.allAnswers)
                data["allAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): TinettiPerformanceRecordAnswerDto {
        const json = this.toJSON();
        let result = new TinettiPerformanceRecordAnswerDto();
        result.init(json);
        return result;
    }
}

export interface ITinettiPerformanceRecordAnswerDto {
    id: number;
    tinettiStaircaseRecordId: number;
    allAnswers: TinettiAnswerDto[] | undefined;
}

export class TinettiPerformanceRecordAnswerDtoPagedResultDto implements ITinettiPerformanceRecordAnswerDtoPagedResultDto {
    items!: TinettiPerformanceRecordAnswerDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITinettiPerformanceRecordAnswerDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TinettiPerformanceRecordAnswerDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TinettiPerformanceRecordAnswerDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TinettiPerformanceRecordAnswerDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TinettiPerformanceRecordAnswerDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TinettiPerformanceRecordAnswerDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITinettiPerformanceRecordAnswerDtoPagedResultDto {
    items: TinettiPerformanceRecordAnswerDto[] | undefined;
    totalCount: number;
}

export class TinettiPerformanceRecordAnswerGetAllInput implements ITinettiPerformanceRecordAnswerGetAllInput {

    constructor(data?: ITinettiPerformanceRecordAnswerGetAllInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): TinettiPerformanceRecordAnswerGetAllInput {
        data = typeof data === 'object' ? data : {};
        let result = new TinettiPerformanceRecordAnswerGetAllInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): TinettiPerformanceRecordAnswerGetAllInput {
        const json = this.toJSON();
        let result = new TinettiPerformanceRecordAnswerGetAllInput();
        result.init(json);
        return result;
    }
}

export interface ITinettiPerformanceRecordAnswerGetAllInput {
}

export class TinettiPerformanceRecordDto implements ITinettiPerformanceRecordDto {
    id!: number;
    date!: moment.Moment;
    tinettiAnswers!: TinettiAnswerDto[] | undefined;
    isCompiled!: boolean;
    balanceScore!: number | undefined;
    gaitScore!: number | undefined;
    totalScore!: number | undefined;
    hasPreviously!: boolean;
    hasFollowing!: boolean;

    constructor(data?: ITinettiPerformanceRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            if (Array.isArray(_data["tinettiAnswers"])) {
                this.tinettiAnswers = [] as any;
                for (let item of _data["tinettiAnswers"])
                    this.tinettiAnswers!.push(TinettiAnswerDto.fromJS(item));
            }
            this.isCompiled = _data["isCompiled"];
            this.balanceScore = _data["balanceScore"];
            this.gaitScore = _data["gaitScore"];
            this.totalScore = _data["totalScore"];
            this.hasPreviously = _data["hasPreviously"];
            this.hasFollowing = _data["hasFollowing"];
        }
    }

    static fromJS(data: any): TinettiPerformanceRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new TinettiPerformanceRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        if (Array.isArray(this.tinettiAnswers)) {
            data["tinettiAnswers"] = [];
            for (let item of this.tinettiAnswers)
                data["tinettiAnswers"].push(item ? item.toJSON() : undefined as any);
        }
        data["isCompiled"] = this.isCompiled;
        data["balanceScore"] = this.balanceScore;
        data["gaitScore"] = this.gaitScore;
        data["totalScore"] = this.totalScore;
        data["hasPreviously"] = this.hasPreviously;
        data["hasFollowing"] = this.hasFollowing;
        return data;
    }

    clone(): TinettiPerformanceRecordDto {
        const json = this.toJSON();
        let result = new TinettiPerformanceRecordDto();
        result.init(json);
        return result;
    }
}

export interface ITinettiPerformanceRecordDto {
    id: number;
    date: moment.Moment;
    tinettiAnswers: TinettiAnswerDto[] | undefined;
    isCompiled: boolean;
    balanceScore: number | undefined;
    gaitScore: number | undefined;
    totalScore: number | undefined;
    hasPreviously: boolean;
    hasFollowing: boolean;
}

export class TinettiPerformanceRecordItemDto implements ITinettiPerformanceRecordItemDto {
    id!: number;
    date!: moment.Moment | undefined;
    isCompiled!: boolean;
    balanceScore!: number | undefined;
    gaitScore!: number | undefined;
    totalScore!: number | undefined;

    constructor(data?: ITinettiPerformanceRecordItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.isCompiled = _data["isCompiled"];
            this.balanceScore = _data["balanceScore"];
            this.gaitScore = _data["gaitScore"];
            this.totalScore = _data["totalScore"];
        }
    }

    static fromJS(data: any): TinettiPerformanceRecordItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new TinettiPerformanceRecordItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["isCompiled"] = this.isCompiled;
        data["balanceScore"] = this.balanceScore;
        data["gaitScore"] = this.gaitScore;
        data["totalScore"] = this.totalScore;
        return data;
    }

    clone(): TinettiPerformanceRecordItemDto {
        const json = this.toJSON();
        let result = new TinettiPerformanceRecordItemDto();
        result.init(json);
        return result;
    }
}

export interface ITinettiPerformanceRecordItemDto {
    id: number;
    date: moment.Moment | undefined;
    isCompiled: boolean;
    balanceScore: number | undefined;
    gaitScore: number | undefined;
    totalScore: number | undefined;
}

export class TinettiPerformanceRecordItemDtoPagedResultDto implements ITinettiPerformanceRecordItemDtoPagedResultDto {
    items!: TinettiPerformanceRecordItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: ITinettiPerformanceRecordItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TinettiPerformanceRecordItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): TinettiPerformanceRecordItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new TinettiPerformanceRecordItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): TinettiPerformanceRecordItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new TinettiPerformanceRecordItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface ITinettiPerformanceRecordItemDtoPagedResultDto {
    items: TinettiPerformanceRecordItemDto[] | undefined;
    totalCount: number;
}

export class TinettiQuestionDto implements ITinettiQuestionDto {
    id!: number;
    description!: string | undefined;
    staticCode!: string | undefined;
    tinettiType!: DictionaryDto;
    isMultipleChoice!: boolean;

    constructor(data?: ITinettiQuestionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.staticCode = _data["staticCode"];
            this.tinettiType = _data["tinettiType"] ? DictionaryDto.fromJS(_data["tinettiType"]) : undefined as any;
            this.isMultipleChoice = _data["isMultipleChoice"];
        }
    }

    static fromJS(data: any): TinettiQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TinettiQuestionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["staticCode"] = this.staticCode;
        data["tinettiType"] = this.tinettiType ? this.tinettiType.toJSON() : undefined as any;
        data["isMultipleChoice"] = this.isMultipleChoice;
        return data;
    }

    clone(): TinettiQuestionDto {
        const json = this.toJSON();
        let result = new TinettiQuestionDto();
        result.init(json);
        return result;
    }
}

export interface ITinettiQuestionDto {
    id: number;
    description: string | undefined;
    staticCode: string | undefined;
    tinettiType: DictionaryDto;
    isMultipleChoice: boolean;
}

export class UMVDDto implements IUMVDDto {
    id!: number;
    lastModifierUserId!: number | undefined;
    lastModifierUserFullName!: string | undefined;
    lastModificationTime!: moment.Moment | undefined;
    releaseDate!: moment.Moment | undefined;
    intensity!: string | undefined;
    possibleExpirationDate!: moment.Moment | undefined;
    frequency!: string | undefined;

    constructor(data?: IUMVDDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined as any;
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : undefined as any;
            this.intensity = _data["intensity"];
            this.possibleExpirationDate = _data["possibleExpirationDate"] ? moment(_data["possibleExpirationDate"].toString()) : undefined as any;
            this.frequency = _data["frequency"];
        }
    }

    static fromJS(data: any): UMVDDto {
        data = typeof data === 'object' ? data : {};
        let result = new UMVDDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined as any;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined as any;
        data["intensity"] = this.intensity;
        data["possibleExpirationDate"] = this.possibleExpirationDate ? this.possibleExpirationDate.toISOString() : undefined as any;
        data["frequency"] = this.frequency;
        return data;
    }

    clone(): UMVDDto {
        const json = this.toJSON();
        let result = new UMVDDto();
        result.init(json);
        return result;
    }
}

export interface IUMVDDto {
    id: number;
    lastModifierUserId: number | undefined;
    lastModifierUserFullName: string | undefined;
    lastModificationTime: moment.Moment | undefined;
    releaseDate: moment.Moment | undefined;
    intensity: string | undefined;
    possibleExpirationDate: moment.Moment | undefined;
    frequency: string | undefined;
}

export class UMVDDtoPagedResultDto implements IUMVDDtoPagedResultDto {
    items!: UMVDDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUMVDDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UMVDDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UMVDDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UMVDDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UMVDDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UMVDDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUMVDDtoPagedResultDto {
    items: UMVDDto[] | undefined;
    totalCount: number;
}

export class UnassignServiceUserStructureInput implements IUnassignServiceUserStructureInput {
    serviceUserIds!: number[] | undefined;
    endDate!: moment.Moment;

    constructor(data?: IUnassignServiceUserStructureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["serviceUserIds"])) {
                this.serviceUserIds = [] as any;
                for (let item of _data["serviceUserIds"])
                    this.serviceUserIds!.push(item);
            }
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UnassignServiceUserStructureInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnassignServiceUserStructureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.serviceUserIds)) {
            data["serviceUserIds"] = [];
            for (let item of this.serviceUserIds)
                data["serviceUserIds"].push(item);
        }
        data["endDate"] = this.endDate ? this.endDate.format('YYYY-MM-DD') : undefined as any;
        return data;
    }

    clone(): UnassignServiceUserStructureInput {
        const json = this.toJSON();
        let result = new UnassignServiceUserStructureInput();
        result.init(json);
        return result;
    }
}

export interface IUnassignServiceUserStructureInput {
    serviceUserIds: number[] | undefined;
    endDate: moment.Moment;
}

export class UpdateActivityDto implements IUpdateActivityDto {
    id!: number;
    name!: string;
    description!: string | undefined;
    startDateTime!: moment.Moment;
    endDateTime!: moment.Moment;
    badgeInDateTime!: moment.Moment | undefined;
    badgeOutDateTime!: moment.Moment | undefined;
    note!: string | undefined;
    actualActivityMinutes!: number;
    isAbsent!: boolean | undefined;
    reasonAbsence!: string | undefined;
    recurrenceRule!: string | undefined;
    recurrenceException!: string | undefined;
    plannedActivityMinutes!: number;
    fileIds!: number[] | undefined;
    placeIds!: number[] | undefined;
    serviceOperatorIds!: number[] | undefined;
    serviceBeneficiaryIds!: number[] | undefined;
    qualificationId!: number | undefined;
    statusId!: number | undefined;
    cancellationReason!: string | undefined;

    constructor(data?: IUpdateActivityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.startDateTime = _data["startDateTime"] ? moment(_data["startDateTime"].toString()) : undefined as any;
            this.endDateTime = _data["endDateTime"] ? moment(_data["endDateTime"].toString()) : undefined as any;
            this.badgeInDateTime = _data["badgeInDateTime"] ? moment(_data["badgeInDateTime"].toString()) : undefined as any;
            this.badgeOutDateTime = _data["badgeOutDateTime"] ? moment(_data["badgeOutDateTime"].toString()) : undefined as any;
            this.note = _data["note"];
            this.actualActivityMinutes = _data["actualActivityMinutes"];
            this.isAbsent = _data["isAbsent"];
            this.reasonAbsence = _data["reasonAbsence"];
            this.recurrenceRule = _data["recurrenceRule"];
            this.recurrenceException = _data["recurrenceException"];
            this.plannedActivityMinutes = _data["plannedActivityMinutes"];
            if (Array.isArray(_data["fileIds"])) {
                this.fileIds = [] as any;
                for (let item of _data["fileIds"])
                    this.fileIds!.push(item);
            }
            if (Array.isArray(_data["placeIds"])) {
                this.placeIds = [] as any;
                for (let item of _data["placeIds"])
                    this.placeIds!.push(item);
            }
            if (Array.isArray(_data["serviceOperatorIds"])) {
                this.serviceOperatorIds = [] as any;
                for (let item of _data["serviceOperatorIds"])
                    this.serviceOperatorIds!.push(item);
            }
            if (Array.isArray(_data["serviceBeneficiaryIds"])) {
                this.serviceBeneficiaryIds = [] as any;
                for (let item of _data["serviceBeneficiaryIds"])
                    this.serviceBeneficiaryIds!.push(item);
            }
            this.qualificationId = _data["qualificationId"];
            this.statusId = _data["statusId"];
            this.cancellationReason = _data["cancellationReason"];
        }
    }

    static fromJS(data: any): UpdateActivityDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActivityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : undefined as any;
        data["endDateTime"] = this.endDateTime ? this.endDateTime.toISOString() : undefined as any;
        data["badgeInDateTime"] = this.badgeInDateTime ? this.badgeInDateTime.toISOString() : undefined as any;
        data["badgeOutDateTime"] = this.badgeOutDateTime ? this.badgeOutDateTime.toISOString() : undefined as any;
        data["note"] = this.note;
        data["actualActivityMinutes"] = this.actualActivityMinutes;
        data["isAbsent"] = this.isAbsent;
        data["reasonAbsence"] = this.reasonAbsence;
        data["recurrenceRule"] = this.recurrenceRule;
        data["recurrenceException"] = this.recurrenceException;
        data["plannedActivityMinutes"] = this.plannedActivityMinutes;
        if (Array.isArray(this.fileIds)) {
            data["fileIds"] = [];
            for (let item of this.fileIds)
                data["fileIds"].push(item);
        }
        if (Array.isArray(this.placeIds)) {
            data["placeIds"] = [];
            for (let item of this.placeIds)
                data["placeIds"].push(item);
        }
        if (Array.isArray(this.serviceOperatorIds)) {
            data["serviceOperatorIds"] = [];
            for (let item of this.serviceOperatorIds)
                data["serviceOperatorIds"].push(item);
        }
        if (Array.isArray(this.serviceBeneficiaryIds)) {
            data["serviceBeneficiaryIds"] = [];
            for (let item of this.serviceBeneficiaryIds)
                data["serviceBeneficiaryIds"].push(item);
        }
        data["qualificationId"] = this.qualificationId;
        data["statusId"] = this.statusId;
        data["cancellationReason"] = this.cancellationReason;
        return data;
    }

    clone(): UpdateActivityDto {
        const json = this.toJSON();
        let result = new UpdateActivityDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateActivityDto {
    id: number;
    name: string;
    description: string | undefined;
    startDateTime: moment.Moment;
    endDateTime: moment.Moment;
    badgeInDateTime: moment.Moment | undefined;
    badgeOutDateTime: moment.Moment | undefined;
    note: string | undefined;
    actualActivityMinutes: number;
    isAbsent: boolean | undefined;
    reasonAbsence: string | undefined;
    recurrenceRule: string | undefined;
    recurrenceException: string | undefined;
    plannedActivityMinutes: number;
    fileIds: number[] | undefined;
    placeIds: number[] | undefined;
    serviceOperatorIds: number[] | undefined;
    serviceBeneficiaryIds: number[] | undefined;
    qualificationId: number | undefined;
    statusId: number | undefined;
    cancellationReason: string | undefined;
}

export class UpdateActivityUserDto implements IUpdateActivityUserDto {
    id!: number;

    constructor(data?: IUpdateActivityUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateActivityUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateActivityUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateActivityUserDto {
        const json = this.toJSON();
        let result = new UpdateActivityUserDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateActivityUserDto {
    id: number;
}

export class UpdateAdministrativeLegalAreaDto implements IUpdateAdministrativeLegalAreaDto {
    id!: number;
    supportAdministrator!: boolean;
    supportAdministratorName!: string | undefined;
    supportAdministratorDate!: moment.Moment | undefined;
    guardian!: boolean;
    guardianName!: string | undefined;
    guardianDate!: moment.Moment | undefined;
    pension!: boolean;
    accompaniment!: boolean;
    freeTransport!: boolean;
    freeTransportWithAccompaniment!: boolean;
    registrationForTargetedPlacement!: boolean;
    presenceOfFunctionalDiagnosis!: boolean;
    note!: string | undefined;

    constructor(data?: IUpdateAdministrativeLegalAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.supportAdministrator = _data["supportAdministrator"];
            this.supportAdministratorName = _data["supportAdministratorName"];
            this.supportAdministratorDate = _data["supportAdministratorDate"] ? moment(_data["supportAdministratorDate"].toString()) : undefined as any;
            this.guardian = _data["guardian"];
            this.guardianName = _data["guardianName"];
            this.guardianDate = _data["guardianDate"] ? moment(_data["guardianDate"].toString()) : undefined as any;
            this.pension = _data["pension"];
            this.accompaniment = _data["accompaniment"];
            this.freeTransport = _data["freeTransport"];
            this.freeTransportWithAccompaniment = _data["freeTransportWithAccompaniment"];
            this.registrationForTargetedPlacement = _data["registrationForTargetedPlacement"];
            this.presenceOfFunctionalDiagnosis = _data["presenceOfFunctionalDiagnosis"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateAdministrativeLegalAreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAdministrativeLegalAreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["supportAdministrator"] = this.supportAdministrator;
        data["supportAdministratorName"] = this.supportAdministratorName;
        data["supportAdministratorDate"] = this.supportAdministratorDate ? this.supportAdministratorDate.toISOString() : undefined as any;
        data["guardian"] = this.guardian;
        data["guardianName"] = this.guardianName;
        data["guardianDate"] = this.guardianDate ? this.guardianDate.toISOString() : undefined as any;
        data["pension"] = this.pension;
        data["accompaniment"] = this.accompaniment;
        data["freeTransport"] = this.freeTransport;
        data["freeTransportWithAccompaniment"] = this.freeTransportWithAccompaniment;
        data["registrationForTargetedPlacement"] = this.registrationForTargetedPlacement;
        data["presenceOfFunctionalDiagnosis"] = this.presenceOfFunctionalDiagnosis;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateAdministrativeLegalAreaDto {
        const json = this.toJSON();
        let result = new UpdateAdministrativeLegalAreaDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAdministrativeLegalAreaDto {
    id: number;
    supportAdministrator: boolean;
    supportAdministratorName: string | undefined;
    supportAdministratorDate: moment.Moment | undefined;
    guardian: boolean;
    guardianName: string | undefined;
    guardianDate: moment.Moment | undefined;
    pension: boolean;
    accompaniment: boolean;
    freeTransport: boolean;
    freeTransportWithAccompaniment: boolean;
    registrationForTargetedPlacement: boolean;
    presenceOfFunctionalDiagnosis: boolean;
    note: string | undefined;
}

export class UpdateAdmissionRecordDto implements IUpdateAdmissionRecordDto {
    id!: number;
    admissionDate!: moment.Moment;
    admissionTypeId!: number | undefined;
    admissionDiagnosis!: string | undefined;
    travel!: boolean | undefined;
    diningFacility!: boolean | undefined;
    reconciliationVoucherRequest!: boolean;
    startDateVoucher!: moment.Moment | undefined;
    endDateVoucher!: moment.Moment | undefined;
    disability!: string | undefined;
    accompanimentAllowance!: boolean;
    admissionDiagnosisUVMReport!: string | undefined;
    dailyAttendanceResidentialFacility!: boolean | undefined;
    dayOfWeekIds!: number[] | undefined;
    admissionResidentialAuthorization!: UpdateAdmissionResidentialAuthorizationDto;
    pharmacologicalTherapy!: CreateDrugDto[] | undefined;
    historicalCases!: CreateHistoricalCaseDto[] | undefined;
    foodAllergies!: string | undefined;
    otherDietaryHabits!: string | undefined;
    personalAutonomy!: UpdatePersonalAutonomyDto;
    remotePathologicalAnamnesis!: string | undefined;
    proximalPathologicalAnamnesis!: string | undefined;
    orthosesProsthesesAndAids!: string | undefined;

    constructor(data?: IUpdateAdmissionRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.admissionDate = _data["admissionDate"] ? moment(_data["admissionDate"].toString()) : undefined as any;
            this.admissionTypeId = _data["admissionTypeId"];
            this.admissionDiagnosis = _data["admissionDiagnosis"];
            this.travel = _data["travel"];
            this.diningFacility = _data["diningFacility"];
            this.reconciliationVoucherRequest = _data["reconciliationVoucherRequest"];
            this.startDateVoucher = _data["startDateVoucher"] ? moment(_data["startDateVoucher"].toString()) : undefined as any;
            this.endDateVoucher = _data["endDateVoucher"] ? moment(_data["endDateVoucher"].toString()) : undefined as any;
            this.disability = _data["disability"];
            this.accompanimentAllowance = _data["accompanimentAllowance"];
            this.admissionDiagnosisUVMReport = _data["admissionDiagnosisUVMReport"];
            this.dailyAttendanceResidentialFacility = _data["dailyAttendanceResidentialFacility"];
            if (Array.isArray(_data["dayOfWeekIds"])) {
                this.dayOfWeekIds = [] as any;
                for (let item of _data["dayOfWeekIds"])
                    this.dayOfWeekIds!.push(item);
            }
            this.admissionResidentialAuthorization = _data["admissionResidentialAuthorization"] ? UpdateAdmissionResidentialAuthorizationDto.fromJS(_data["admissionResidentialAuthorization"]) : undefined as any;
            if (Array.isArray(_data["pharmacologicalTherapy"])) {
                this.pharmacologicalTherapy = [] as any;
                for (let item of _data["pharmacologicalTherapy"])
                    this.pharmacologicalTherapy!.push(CreateDrugDto.fromJS(item));
            }
            if (Array.isArray(_data["historicalCases"])) {
                this.historicalCases = [] as any;
                for (let item of _data["historicalCases"])
                    this.historicalCases!.push(CreateHistoricalCaseDto.fromJS(item));
            }
            this.foodAllergies = _data["foodAllergies"];
            this.otherDietaryHabits = _data["otherDietaryHabits"];
            this.personalAutonomy = _data["personalAutonomy"] ? UpdatePersonalAutonomyDto.fromJS(_data["personalAutonomy"]) : undefined as any;
            this.remotePathologicalAnamnesis = _data["remotePathologicalAnamnesis"];
            this.proximalPathologicalAnamnesis = _data["proximalPathologicalAnamnesis"];
            this.orthosesProsthesesAndAids = _data["orthosesProsthesesAndAids"];
        }
    }

    static fromJS(data: any): UpdateAdmissionRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAdmissionRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["admissionDate"] = this.admissionDate ? this.admissionDate.format('YYYY-MM-DD') : undefined as any;
        data["admissionTypeId"] = this.admissionTypeId;
        data["admissionDiagnosis"] = this.admissionDiagnosis;
        data["travel"] = this.travel;
        data["diningFacility"] = this.diningFacility;
        data["reconciliationVoucherRequest"] = this.reconciliationVoucherRequest;
        data["startDateVoucher"] = this.startDateVoucher ? this.startDateVoucher.format('YYYY-MM-DD') : undefined as any;
        data["endDateVoucher"] = this.endDateVoucher ? this.endDateVoucher.format('YYYY-MM-DD') : undefined as any;
        data["disability"] = this.disability;
        data["accompanimentAllowance"] = this.accompanimentAllowance;
        data["admissionDiagnosisUVMReport"] = this.admissionDiagnosisUVMReport;
        data["dailyAttendanceResidentialFacility"] = this.dailyAttendanceResidentialFacility;
        if (Array.isArray(this.dayOfWeekIds)) {
            data["dayOfWeekIds"] = [];
            for (let item of this.dayOfWeekIds)
                data["dayOfWeekIds"].push(item);
        }
        data["admissionResidentialAuthorization"] = this.admissionResidentialAuthorization ? this.admissionResidentialAuthorization.toJSON() : undefined as any;
        if (Array.isArray(this.pharmacologicalTherapy)) {
            data["pharmacologicalTherapy"] = [];
            for (let item of this.pharmacologicalTherapy)
                data["pharmacologicalTherapy"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.historicalCases)) {
            data["historicalCases"] = [];
            for (let item of this.historicalCases)
                data["historicalCases"].push(item ? item.toJSON() : undefined as any);
        }
        data["foodAllergies"] = this.foodAllergies;
        data["otherDietaryHabits"] = this.otherDietaryHabits;
        data["personalAutonomy"] = this.personalAutonomy ? this.personalAutonomy.toJSON() : undefined as any;
        data["remotePathologicalAnamnesis"] = this.remotePathologicalAnamnesis;
        data["proximalPathologicalAnamnesis"] = this.proximalPathologicalAnamnesis;
        data["orthosesProsthesesAndAids"] = this.orthosesProsthesesAndAids;
        return data;
    }

    clone(): UpdateAdmissionRecordDto {
        const json = this.toJSON();
        let result = new UpdateAdmissionRecordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAdmissionRecordDto {
    id: number;
    admissionDate: moment.Moment;
    admissionTypeId: number | undefined;
    admissionDiagnosis: string | undefined;
    travel: boolean | undefined;
    diningFacility: boolean | undefined;
    reconciliationVoucherRequest: boolean;
    startDateVoucher: moment.Moment | undefined;
    endDateVoucher: moment.Moment | undefined;
    disability: string | undefined;
    accompanimentAllowance: boolean;
    admissionDiagnosisUVMReport: string | undefined;
    dailyAttendanceResidentialFacility: boolean | undefined;
    dayOfWeekIds: number[] | undefined;
    admissionResidentialAuthorization: UpdateAdmissionResidentialAuthorizationDto;
    pharmacologicalTherapy: CreateDrugDto[] | undefined;
    historicalCases: CreateHistoricalCaseDto[] | undefined;
    foodAllergies: string | undefined;
    otherDietaryHabits: string | undefined;
    personalAutonomy: UpdatePersonalAutonomyDto;
    remotePathologicalAnamnesis: string | undefined;
    proximalPathologicalAnamnesis: string | undefined;
    orthosesProsthesesAndAids: string | undefined;
}

export class UpdateAdmissionResidentialAuthorizationDto implements IUpdateAdmissionResidentialAuthorizationDto {
    id!: number;
    date!: moment.Moment | undefined;
    protocol!: string | undefined;
    expirationDate!: moment.Moment | undefined;
    attendanceStartDate!: moment.Moment | undefined;

    constructor(data?: IUpdateAdmissionResidentialAuthorizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.protocol = _data["protocol"];
            this.expirationDate = _data["expirationDate"] ? moment(_data["expirationDate"].toString()) : undefined as any;
            this.attendanceStartDate = _data["attendanceStartDate"] ? moment(_data["attendanceStartDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateAdmissionResidentialAuthorizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAdmissionResidentialAuthorizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined as any;
        data["protocol"] = this.protocol;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.format('YYYY-MM-DD') : undefined as any;
        data["attendanceStartDate"] = this.attendanceStartDate ? this.attendanceStartDate.format('YYYY-MM-DD') : undefined as any;
        return data;
    }

    clone(): UpdateAdmissionResidentialAuthorizationDto {
        const json = this.toJSON();
        let result = new UpdateAdmissionResidentialAuthorizationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAdmissionResidentialAuthorizationDto {
    id: number;
    date: moment.Moment | undefined;
    protocol: string | undefined;
    expirationDate: moment.Moment | undefined;
    attendanceStartDate: moment.Moment | undefined;
}

export class UpdateAirTreatmentSystemDto implements IUpdateAirTreatmentSystemDto {
    id!: number;
    name!: string;
    airTreatmentPlantTypeId!: number | undefined;
    ton!: string | undefined;
    equivalentCarbonDioxide!: string | undefined;
    leaksControlId!: number | undefined;
    numberOfUnits!: number | undefined;
    project!: boolean;
    plantBookletPresent!: boolean;
    plantBookletPresentFileId!: number | undefined;
    plantConformityDeclaration!: boolean;
    plantConformityDeclarationFileId!: number | undefined;
    maintenanceContract!: boolean;
    maintenanceContractFileId!: number | undefined;
    maintenanceCompany!: string | undefined;
    lastMaintenanceDate!: moment.Moment | undefined;
    notes!: string | undefined;

    constructor(data?: IUpdateAirTreatmentSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.airTreatmentPlantTypeId = _data["airTreatmentPlantTypeId"];
            this.ton = _data["ton"];
            this.equivalentCarbonDioxide = _data["equivalentCarbonDioxide"];
            this.leaksControlId = _data["leaksControlId"];
            this.numberOfUnits = _data["numberOfUnits"];
            this.project = _data["project"];
            this.plantBookletPresent = _data["plantBookletPresent"];
            this.plantBookletPresentFileId = _data["plantBookletPresentFileId"];
            this.plantConformityDeclaration = _data["plantConformityDeclaration"];
            this.plantConformityDeclarationFileId = _data["plantConformityDeclarationFileId"];
            this.maintenanceContract = _data["maintenanceContract"];
            this.maintenanceContractFileId = _data["maintenanceContractFileId"];
            this.maintenanceCompany = _data["maintenanceCompany"];
            this.lastMaintenanceDate = _data["lastMaintenanceDate"] ? moment(_data["lastMaintenanceDate"].toString()) : undefined as any;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateAirTreatmentSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAirTreatmentSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["airTreatmentPlantTypeId"] = this.airTreatmentPlantTypeId;
        data["ton"] = this.ton;
        data["equivalentCarbonDioxide"] = this.equivalentCarbonDioxide;
        data["leaksControlId"] = this.leaksControlId;
        data["numberOfUnits"] = this.numberOfUnits;
        data["project"] = this.project;
        data["plantBookletPresent"] = this.plantBookletPresent;
        data["plantBookletPresentFileId"] = this.plantBookletPresentFileId;
        data["plantConformityDeclaration"] = this.plantConformityDeclaration;
        data["plantConformityDeclarationFileId"] = this.plantConformityDeclarationFileId;
        data["maintenanceContract"] = this.maintenanceContract;
        data["maintenanceContractFileId"] = this.maintenanceContractFileId;
        data["maintenanceCompany"] = this.maintenanceCompany;
        data["lastMaintenanceDate"] = this.lastMaintenanceDate ? this.lastMaintenanceDate.toISOString() : undefined as any;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpdateAirTreatmentSystemDto {
        const json = this.toJSON();
        let result = new UpdateAirTreatmentSystemDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAirTreatmentSystemDto {
    id: number;
    name: string;
    airTreatmentPlantTypeId: number | undefined;
    ton: string | undefined;
    equivalentCarbonDioxide: string | undefined;
    leaksControlId: number | undefined;
    numberOfUnits: number | undefined;
    project: boolean;
    plantBookletPresent: boolean;
    plantBookletPresentFileId: number | undefined;
    plantConformityDeclaration: boolean;
    plantConformityDeclarationFileId: number | undefined;
    maintenanceContract: boolean;
    maintenanceContractFileId: number | undefined;
    maintenanceCompany: string | undefined;
    lastMaintenanceDate: moment.Moment | undefined;
    notes: string | undefined;
}

export class UpdateAlertDto implements IUpdateAlertDto {
    id!: number;
    date!: moment.Moment;
    title!: string | undefined;
    description!: string | undefined;
    contextLink!: string | undefined;
    emailNotification!: boolean;
    userIds!: number[] | undefined;

    constructor(data?: IUpdateAlertDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.title = _data["title"];
            this.description = _data["description"];
            this.contextLink = _data["contextLink"];
            this.emailNotification = _data["emailNotification"];
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateAlertDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAlertDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["title"] = this.title;
        data["description"] = this.description;
        data["contextLink"] = this.contextLink;
        data["emailNotification"] = this.emailNotification;
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        return data;
    }

    clone(): UpdateAlertDto {
        const json = this.toJSON();
        let result = new UpdateAlertDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAlertDto {
    id: number;
    date: moment.Moment;
    title: string | undefined;
    description: string | undefined;
    contextLink: string | undefined;
    emailNotification: boolean;
    userIds: number[] | undefined;
}

export class UpdateAntiTheftSystemDto implements IUpdateAntiTheftSystemDto {
    id!: number;
    name!: string | undefined;
    brand!: string | undefined;
    model!: string | undefined;
    telephoneDialer!: boolean;
    telephoneNumber!: string | undefined;
    project!: boolean;
    projectFileId!: number | undefined;
    maintenanceContract!: boolean;
    maintenanceContractFileId!: number | undefined;
    maintenanceCompany!: string | undefined;
    lastMaintenanceDate!: moment.Moment | undefined;
    outsiderResponsible!: boolean;
    externalVigilance!: boolean;
    vigilanceContractFileId!: number | undefined;
    vigilanceCompany!: string | undefined;
    notes!: string | undefined;

    constructor(data?: IUpdateAntiTheftSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.brand = _data["brand"];
            this.model = _data["model"];
            this.telephoneDialer = _data["telephoneDialer"];
            this.telephoneNumber = _data["telephoneNumber"];
            this.project = _data["project"];
            this.projectFileId = _data["projectFileId"];
            this.maintenanceContract = _data["maintenanceContract"];
            this.maintenanceContractFileId = _data["maintenanceContractFileId"];
            this.maintenanceCompany = _data["maintenanceCompany"];
            this.lastMaintenanceDate = _data["lastMaintenanceDate"] ? moment(_data["lastMaintenanceDate"].toString()) : undefined as any;
            this.outsiderResponsible = _data["outsiderResponsible"];
            this.externalVigilance = _data["externalVigilance"];
            this.vigilanceContractFileId = _data["vigilanceContractFileId"];
            this.vigilanceCompany = _data["vigilanceCompany"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateAntiTheftSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAntiTheftSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["brand"] = this.brand;
        data["model"] = this.model;
        data["telephoneDialer"] = this.telephoneDialer;
        data["telephoneNumber"] = this.telephoneNumber;
        data["project"] = this.project;
        data["projectFileId"] = this.projectFileId;
        data["maintenanceContract"] = this.maintenanceContract;
        data["maintenanceContractFileId"] = this.maintenanceContractFileId;
        data["maintenanceCompany"] = this.maintenanceCompany;
        data["lastMaintenanceDate"] = this.lastMaintenanceDate ? this.lastMaintenanceDate.toISOString() : undefined as any;
        data["outsiderResponsible"] = this.outsiderResponsible;
        data["externalVigilance"] = this.externalVigilance;
        data["vigilanceContractFileId"] = this.vigilanceContractFileId;
        data["vigilanceCompany"] = this.vigilanceCompany;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpdateAntiTheftSystemDto {
        const json = this.toJSON();
        let result = new UpdateAntiTheftSystemDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAntiTheftSystemDto {
    id: number;
    name: string | undefined;
    brand: string | undefined;
    model: string | undefined;
    telephoneDialer: boolean;
    telephoneNumber: string | undefined;
    project: boolean;
    projectFileId: number | undefined;
    maintenanceContract: boolean;
    maintenanceContractFileId: number | undefined;
    maintenanceCompany: string | undefined;
    lastMaintenanceDate: moment.Moment | undefined;
    outsiderResponsible: boolean;
    externalVigilance: boolean;
    vigilanceContractFileId: number | undefined;
    vigilanceCompany: string | undefined;
    notes: string | undefined;
}

export class UpdateAssetDto implements IUpdateAssetDto {
    id!: number;
    name!: string;
    assetTypeId!: number;
    description!: string | undefined;
    iccid!: string | undefined;
    phoneNumber!: string | undefined;
    pin!: string | undefined;
    puk!: string | undefined;
    note!: string | undefined;

    constructor(data?: IUpdateAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.assetTypeId = _data["assetTypeId"];
            this.description = _data["description"];
            this.iccid = _data["iccid"];
            this.phoneNumber = _data["phoneNumber"];
            this.pin = _data["pin"];
            this.puk = _data["puk"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["assetTypeId"] = this.assetTypeId;
        data["description"] = this.description;
        data["iccid"] = this.iccid;
        data["phoneNumber"] = this.phoneNumber;
        data["pin"] = this.pin;
        data["puk"] = this.puk;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateAssetDto {
        const json = this.toJSON();
        let result = new UpdateAssetDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAssetDto {
    id: number;
    name: string;
    assetTypeId: number;
    description: string | undefined;
    iccid: string | undefined;
    phoneNumber: string | undefined;
    pin: string | undefined;
    puk: string | undefined;
    note: string | undefined;
}

export class UpdateAssetServiceUserDto implements IUpdateAssetServiceUserDto {
    id!: number;
    userId!: number;
    assignmentDate!: moment.Moment;
    withdrawalDate!: moment.Moment | undefined;

    constructor(data?: IUpdateAssetServiceUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.assignmentDate = _data["assignmentDate"] ? moment(_data["assignmentDate"].toString()) : undefined as any;
            this.withdrawalDate = _data["withdrawalDate"] ? moment(_data["withdrawalDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateAssetServiceUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssetServiceUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["assignmentDate"] = this.assignmentDate ? this.assignmentDate.toISOString() : undefined as any;
        data["withdrawalDate"] = this.withdrawalDate ? this.withdrawalDate.toISOString() : undefined as any;
        return data;
    }

    clone(): UpdateAssetServiceUserDto {
        const json = this.toJSON();
        let result = new UpdateAssetServiceUserDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAssetServiceUserDto {
    id: number;
    userId: number;
    assignmentDate: moment.Moment;
    withdrawalDate: moment.Moment | undefined;
}

export class UpdateAutonomyDto implements IUpdateAutonomyDto {
    id!: number;
    eatAlone!: string | undefined;
    sleepAloneInRoom!: string | undefined;
    canCalculate!: string | undefined;
    canReadTime!: string | undefined;
    orientedInTime!: string | undefined;
    orientedInSpace!: string | undefined;
    usesPublicTransport!: string | undefined;
    dailyRoutine!: string | undefined;
    goesOutAlone!: string | undefined;
    staysHomeAlone!: string | undefined;
    weekendActivities!: string | undefined;
    hasFriends!: string | undefined;
    sleptAwayWithoutCloseRelatives!: string | undefined;
    hobbiesAndInterests!: string | undefined;
    difficultBehaviors!: string | undefined;
    sexualActivity!: string | undefined;
    personalHygiene!: string | undefined;
    takeCareYourSelf!: string | undefined;
    thingsInOrder!: string | undefined;
    assignmentsAtHome!: string | undefined;
    canWrite!: string | undefined;
    canRead!: string | undefined;
    knowPersonalDetail!: string | undefined;
    hasMoneyRegularly!: string | undefined;
    purchasesYourselfHome!: string | undefined;
    hasHouseKeys!: string | undefined;
    hasPhone!: string | undefined;
    crossRoadAlone!: string | undefined;
    other!: string | undefined;

    constructor(data?: IUpdateAutonomyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eatAlone = _data["eatAlone"];
            this.sleepAloneInRoom = _data["sleepAloneInRoom"];
            this.canCalculate = _data["canCalculate"];
            this.canReadTime = _data["canReadTime"];
            this.orientedInTime = _data["orientedInTime"];
            this.orientedInSpace = _data["orientedInSpace"];
            this.usesPublicTransport = _data["usesPublicTransport"];
            this.dailyRoutine = _data["dailyRoutine"];
            this.goesOutAlone = _data["goesOutAlone"];
            this.staysHomeAlone = _data["staysHomeAlone"];
            this.weekendActivities = _data["weekendActivities"];
            this.hasFriends = _data["hasFriends"];
            this.sleptAwayWithoutCloseRelatives = _data["sleptAwayWithoutCloseRelatives"];
            this.hobbiesAndInterests = _data["hobbiesAndInterests"];
            this.difficultBehaviors = _data["difficultBehaviors"];
            this.sexualActivity = _data["sexualActivity"];
            this.personalHygiene = _data["personalHygiene"];
            this.takeCareYourSelf = _data["takeCareYourSelf"];
            this.thingsInOrder = _data["thingsInOrder"];
            this.assignmentsAtHome = _data["assignmentsAtHome"];
            this.canWrite = _data["canWrite"];
            this.canRead = _data["canRead"];
            this.knowPersonalDetail = _data["knowPersonalDetail"];
            this.hasMoneyRegularly = _data["hasMoneyRegularly"];
            this.purchasesYourselfHome = _data["purchasesYourselfHome"];
            this.hasHouseKeys = _data["hasHouseKeys"];
            this.hasPhone = _data["hasPhone"];
            this.crossRoadAlone = _data["crossRoadAlone"];
            this.other = _data["other"];
        }
    }

    static fromJS(data: any): UpdateAutonomyDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAutonomyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eatAlone"] = this.eatAlone;
        data["sleepAloneInRoom"] = this.sleepAloneInRoom;
        data["canCalculate"] = this.canCalculate;
        data["canReadTime"] = this.canReadTime;
        data["orientedInTime"] = this.orientedInTime;
        data["orientedInSpace"] = this.orientedInSpace;
        data["usesPublicTransport"] = this.usesPublicTransport;
        data["dailyRoutine"] = this.dailyRoutine;
        data["goesOutAlone"] = this.goesOutAlone;
        data["staysHomeAlone"] = this.staysHomeAlone;
        data["weekendActivities"] = this.weekendActivities;
        data["hasFriends"] = this.hasFriends;
        data["sleptAwayWithoutCloseRelatives"] = this.sleptAwayWithoutCloseRelatives;
        data["hobbiesAndInterests"] = this.hobbiesAndInterests;
        data["difficultBehaviors"] = this.difficultBehaviors;
        data["sexualActivity"] = this.sexualActivity;
        data["personalHygiene"] = this.personalHygiene;
        data["takeCareYourSelf"] = this.takeCareYourSelf;
        data["thingsInOrder"] = this.thingsInOrder;
        data["assignmentsAtHome"] = this.assignmentsAtHome;
        data["canWrite"] = this.canWrite;
        data["canRead"] = this.canRead;
        data["knowPersonalDetail"] = this.knowPersonalDetail;
        data["hasMoneyRegularly"] = this.hasMoneyRegularly;
        data["purchasesYourselfHome"] = this.purchasesYourselfHome;
        data["hasHouseKeys"] = this.hasHouseKeys;
        data["hasPhone"] = this.hasPhone;
        data["crossRoadAlone"] = this.crossRoadAlone;
        data["other"] = this.other;
        return data;
    }

    clone(): UpdateAutonomyDto {
        const json = this.toJSON();
        let result = new UpdateAutonomyDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateAutonomyDto {
    id: number;
    eatAlone: string | undefined;
    sleepAloneInRoom: string | undefined;
    canCalculate: string | undefined;
    canReadTime: string | undefined;
    orientedInTime: string | undefined;
    orientedInSpace: string | undefined;
    usesPublicTransport: string | undefined;
    dailyRoutine: string | undefined;
    goesOutAlone: string | undefined;
    staysHomeAlone: string | undefined;
    weekendActivities: string | undefined;
    hasFriends: string | undefined;
    sleptAwayWithoutCloseRelatives: string | undefined;
    hobbiesAndInterests: string | undefined;
    difficultBehaviors: string | undefined;
    sexualActivity: string | undefined;
    personalHygiene: string | undefined;
    takeCareYourSelf: string | undefined;
    thingsInOrder: string | undefined;
    assignmentsAtHome: string | undefined;
    canWrite: string | undefined;
    canRead: string | undefined;
    knowPersonalDetail: string | undefined;
    hasMoneyRegularly: string | undefined;
    purchasesYourselfHome: string | undefined;
    hasHouseKeys: string | undefined;
    hasPhone: string | undefined;
    crossRoadAlone: string | undefined;
    other: string | undefined;
}

export class UpdateBarthelIndexDto implements IUpdateBarthelIndexDto {
    id!: number;
    date!: moment.Moment;

    constructor(data?: IUpdateBarthelIndexDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateBarthelIndexDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBarthelIndexDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        return data;
    }

    clone(): UpdateBarthelIndexDto {
        const json = this.toJSON();
        let result = new UpdateBarthelIndexDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateBarthelIndexDto {
    id: number;
    date: moment.Moment;
}

export class UpdateCaregiverRecordDto implements IUpdateCaregiverRecordDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    caregiverTypeId!: number | undefined;

    constructor(data?: IUpdateCaregiverRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.caregiverTypeId = _data["caregiverTypeId"];
        }
    }

    static fromJS(data: any): UpdateCaregiverRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCaregiverRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["caregiverTypeId"] = this.caregiverTypeId;
        return data;
    }

    clone(): UpdateCaregiverRecordDto {
        const json = this.toJSON();
        let result = new UpdateCaregiverRecordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCaregiverRecordDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    caregiverTypeId: number | undefined;
}

export class UpdateCategoryObservationGridDto implements IUpdateCategoryObservationGridDto {
    id!: number;
    name!: string | undefined;
    sectionObservationGridId!: number | undefined;

    constructor(data?: IUpdateCategoryObservationGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sectionObservationGridId = _data["sectionObservationGridId"];
        }
    }

    static fromJS(data: any): UpdateCategoryObservationGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCategoryObservationGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sectionObservationGridId"] = this.sectionObservationGridId;
        return data;
    }

    clone(): UpdateCategoryObservationGridDto {
        const json = this.toJSON();
        let result = new UpdateCategoryObservationGridDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCategoryObservationGridDto {
    id: number;
    name: string | undefined;
    sectionObservationGridId: number | undefined;
}

export class UpdateCheckDrugExpirationDto implements IUpdateCheckDrugExpirationDto {
    id!: number;
    month!: number;
    note!: string | undefined;

    constructor(data?: IUpdateCheckDrugExpirationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.month = _data["month"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateCheckDrugExpirationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCheckDrugExpirationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["month"] = this.month;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateCheckDrugExpirationDto {
        const json = this.toJSON();
        let result = new UpdateCheckDrugExpirationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCheckDrugExpirationDto {
    id: number;
    month: number;
    note: string | undefined;
}

export class UpdateConleyScaleDto implements IUpdateConleyScaleDto {
    id!: number;
    isMale!: boolean | undefined;
    admissionDate!: moment.Moment;
    detectionDate!: moment.Moment;
    conleyQuestion1!: number;
    conleyQuestion2!: number;
    conleyQuestion3!: number;
    conleyQuestion4!: number;
    conleyQuestion5!: number;
    conleyQuestion6!: number;

    constructor(data?: IUpdateConleyScaleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isMale = _data["isMale"];
            this.admissionDate = _data["admissionDate"] ? moment(_data["admissionDate"].toString()) : undefined as any;
            this.detectionDate = _data["detectionDate"] ? moment(_data["detectionDate"].toString()) : undefined as any;
            this.conleyQuestion1 = _data["conleyQuestion1"];
            this.conleyQuestion2 = _data["conleyQuestion2"];
            this.conleyQuestion3 = _data["conleyQuestion3"];
            this.conleyQuestion4 = _data["conleyQuestion4"];
            this.conleyQuestion5 = _data["conleyQuestion5"];
            this.conleyQuestion6 = _data["conleyQuestion6"];
        }
    }

    static fromJS(data: any): UpdateConleyScaleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConleyScaleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isMale"] = this.isMale;
        data["admissionDate"] = this.admissionDate ? this.admissionDate.toISOString() : undefined as any;
        data["detectionDate"] = this.detectionDate ? this.detectionDate.toISOString() : undefined as any;
        data["conleyQuestion1"] = this.conleyQuestion1;
        data["conleyQuestion2"] = this.conleyQuestion2;
        data["conleyQuestion3"] = this.conleyQuestion3;
        data["conleyQuestion4"] = this.conleyQuestion4;
        data["conleyQuestion5"] = this.conleyQuestion5;
        data["conleyQuestion6"] = this.conleyQuestion6;
        return data;
    }

    clone(): UpdateConleyScaleDto {
        const json = this.toJSON();
        let result = new UpdateConleyScaleDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateConleyScaleDto {
    id: number;
    isMale: boolean | undefined;
    admissionDate: moment.Moment;
    detectionDate: moment.Moment;
    conleyQuestion1: number;
    conleyQuestion2: number;
    conleyQuestion3: number;
    conleyQuestion4: number;
    conleyQuestion5: number;
    conleyQuestion6: number;
}

export class UpdateCustomDataTemplateDto implements IUpdateCustomDataTemplateDto {
    id!: number;
    name!: string | undefined;
    content!: string | undefined;

    constructor(data?: IUpdateCustomDataTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): UpdateCustomDataTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomDataTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["content"] = this.content;
        return data;
    }

    clone(): UpdateCustomDataTemplateDto {
        const json = this.toJSON();
        let result = new UpdateCustomDataTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateCustomDataTemplateDto {
    id: number;
    name: string | undefined;
    content: string | undefined;
}

export class UpdateDiaryRecordDto implements IUpdateDiaryRecordDto {
    id!: number;
    diaryTypeId!: number | undefined;
    description!: string | undefined;

    constructor(data?: IUpdateDiaryRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.diaryTypeId = _data["diaryTypeId"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateDiaryRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDiaryRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["diaryTypeId"] = this.diaryTypeId;
        data["description"] = this.description;
        return data;
    }

    clone(): UpdateDiaryRecordDto {
        const json = this.toJSON();
        let result = new UpdateDiaryRecordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateDiaryRecordDto {
    id: number;
    diaryTypeId: number | undefined;
    description: string | undefined;
}

export class UpdateDisabilityDto implements IUpdateDisabilityDto {
    id!: number;
    percentage!: number;
    releaseDate!: moment.Moment | undefined;
    diagnosis!: string | undefined;
    note!: string | undefined;

    constructor(data?: IUpdateDisabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.percentage = _data["percentage"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : undefined as any;
            this.diagnosis = _data["diagnosis"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateDisabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDisabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["percentage"] = this.percentage;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined as any;
        data["diagnosis"] = this.diagnosis;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateDisabilityDto {
        const json = this.toJSON();
        let result = new UpdateDisabilityDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateDisabilityDto {
    id: number;
    percentage: number;
    releaseDate: moment.Moment | undefined;
    diagnosis: string | undefined;
    note: string | undefined;
}

export class UpdateDoctorRecordDto implements IUpdateDoctorRecordDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    doctorTypeId!: number | undefined;
    specialization!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IUpdateDoctorRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.doctorTypeId = _data["doctorTypeId"];
            this.specialization = _data["specialization"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): UpdateDoctorRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDoctorRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["doctorTypeId"] = this.doctorTypeId;
        data["specialization"] = this.specialization;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }

    clone(): UpdateDoctorRecordDto {
        const json = this.toJSON();
        let result = new UpdateDoctorRecordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateDoctorRecordDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    doctorTypeId: number | undefined;
    specialization: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
}

export class UpdateDrugAdministrationRecordDto implements IUpdateDrugAdministrationRecordDto {
    id!: number;
    administrationDateTime!: moment.Moment;
    drug!: string | undefined;
    administrator!: string | undefined;

    constructor(data?: IUpdateDrugAdministrationRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.administrationDateTime = _data["administrationDateTime"] ? moment(_data["administrationDateTime"].toString()) : undefined as any;
            this.drug = _data["drug"];
            this.administrator = _data["administrator"];
        }
    }

    static fromJS(data: any): UpdateDrugAdministrationRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDrugAdministrationRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["administrationDateTime"] = this.administrationDateTime ? this.administrationDateTime.toISOString() : undefined as any;
        data["drug"] = this.drug;
        data["administrator"] = this.administrator;
        return data;
    }

    clone(): UpdateDrugAdministrationRecordDto {
        const json = this.toJSON();
        let result = new UpdateDrugAdministrationRecordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateDrugAdministrationRecordDto {
    id: number;
    administrationDateTime: moment.Moment;
    drug: string | undefined;
    administrator: string | undefined;
}

export class UpdateDrugDto implements IUpdateDrugDto {
    id!: number;
    name!: string | undefined;
    administrationMethod!: string | undefined;

    constructor(data?: IUpdateDrugDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.administrationMethod = _data["administrationMethod"];
        }
    }

    static fromJS(data: any): UpdateDrugDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDrugDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["administrationMethod"] = this.administrationMethod;
        return data;
    }

    clone(): UpdateDrugDto {
        const json = this.toJSON();
        let result = new UpdateDrugDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateDrugDto {
    id: number;
    name: string | undefined;
    administrationMethod: string | undefined;
}

export class UpdateDrugStockManagementRecord implements IUpdateDrugStockManagementRecord {
    id!: number;
    drugName!: string | undefined;
    expiryDate!: moment.Moment | undefined;
    loadingDate!: moment.Moment | undefined;
    loadingQuantity!: string | undefined;
    dischargeDate!: moment.Moment | undefined;
    dischargeQuantity!: string | undefined;

    constructor(data?: IUpdateDrugStockManagementRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.drugName = _data["drugName"];
            this.expiryDate = _data["expiryDate"] ? moment(_data["expiryDate"].toString()) : undefined as any;
            this.loadingDate = _data["loadingDate"] ? moment(_data["loadingDate"].toString()) : undefined as any;
            this.loadingQuantity = _data["loadingQuantity"];
            this.dischargeDate = _data["dischargeDate"] ? moment(_data["dischargeDate"].toString()) : undefined as any;
            this.dischargeQuantity = _data["dischargeQuantity"];
        }
    }

    static fromJS(data: any): UpdateDrugStockManagementRecord {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDrugStockManagementRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["drugName"] = this.drugName;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : undefined as any;
        data["loadingDate"] = this.loadingDate ? this.loadingDate.toISOString() : undefined as any;
        data["loadingQuantity"] = this.loadingQuantity;
        data["dischargeDate"] = this.dischargeDate ? this.dischargeDate.toISOString() : undefined as any;
        data["dischargeQuantity"] = this.dischargeQuantity;
        return data;
    }

    clone(): UpdateDrugStockManagementRecord {
        const json = this.toJSON();
        let result = new UpdateDrugStockManagementRecord();
        result.init(json);
        return result;
    }
}

export interface IUpdateDrugStockManagementRecord {
    id: number;
    drugName: string | undefined;
    expiryDate: moment.Moment | undefined;
    loadingDate: moment.Moment | undefined;
    loadingQuantity: string | undefined;
    dischargeDate: moment.Moment | undefined;
    dischargeQuantity: string | undefined;
}

export class UpdateEducationalTrainingDto implements IUpdateEducationalTrainingDto {
    id!: number;
    educationalDegreeLevelId!: number | undefined;
    support!: boolean | undefined;
    titleArchievement!: string | undefined;

    constructor(data?: IUpdateEducationalTrainingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.educationalDegreeLevelId = _data["educationalDegreeLevelId"];
            this.support = _data["support"];
            this.titleArchievement = _data["titleArchievement"];
        }
    }

    static fromJS(data: any): UpdateEducationalTrainingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEducationalTrainingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["educationalDegreeLevelId"] = this.educationalDegreeLevelId;
        data["support"] = this.support;
        data["titleArchievement"] = this.titleArchievement;
        return data;
    }

    clone(): UpdateEducationalTrainingDto {
        const json = this.toJSON();
        let result = new UpdateEducationalTrainingDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateEducationalTrainingDto {
    id: number;
    educationalDegreeLevelId: number | undefined;
    support: boolean | undefined;
    titleArchievement: string | undefined;
}

export class UpdateElectricalSystemDto implements IUpdateElectricalSystemDto {
    id!: number;
    name!: string | undefined;
    project!: boolean;
    projectFileId!: number | undefined;
    plantConformityDeclaration!: boolean;
    plantConformityDeclarationFileId!: number | undefined;
    competentBodies!: boolean | undefined;
    grounding!: boolean | undefined;
    competentBodyId!: number | undefined;
    appointedCertifyingBody!: string | undefined;
    lastVerificationDate!: moment.Moment | undefined;
    verificationCadenceId!: number | undefined;
    systemPower!: string | undefined;
    plantBookletPresent!: boolean;
    plantBookletPresentFileId!: number | undefined;
    appointedCompany!: string | undefined;
    lastCompilationDate!: moment.Moment | undefined;
    compilationCadence!: number;
    notes!: string | undefined;

    constructor(data?: IUpdateElectricalSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.project = _data["project"];
            this.projectFileId = _data["projectFileId"];
            this.plantConformityDeclaration = _data["plantConformityDeclaration"];
            this.plantConformityDeclarationFileId = _data["plantConformityDeclarationFileId"];
            this.competentBodies = _data["competentBodies"];
            this.grounding = _data["grounding"];
            this.competentBodyId = _data["competentBodyId"];
            this.appointedCertifyingBody = _data["appointedCertifyingBody"];
            this.lastVerificationDate = _data["lastVerificationDate"] ? moment(_data["lastVerificationDate"].toString()) : undefined as any;
            this.verificationCadenceId = _data["verificationCadenceId"];
            this.systemPower = _data["systemPower"];
            this.plantBookletPresent = _data["plantBookletPresent"];
            this.plantBookletPresentFileId = _data["plantBookletPresentFileId"];
            this.appointedCompany = _data["appointedCompany"];
            this.lastCompilationDate = _data["lastCompilationDate"] ? moment(_data["lastCompilationDate"].toString()) : undefined as any;
            this.compilationCadence = _data["compilationCadence"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateElectricalSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateElectricalSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["project"] = this.project;
        data["projectFileId"] = this.projectFileId;
        data["plantConformityDeclaration"] = this.plantConformityDeclaration;
        data["plantConformityDeclarationFileId"] = this.plantConformityDeclarationFileId;
        data["competentBodies"] = this.competentBodies;
        data["grounding"] = this.grounding;
        data["competentBodyId"] = this.competentBodyId;
        data["appointedCertifyingBody"] = this.appointedCertifyingBody;
        data["lastVerificationDate"] = this.lastVerificationDate ? this.lastVerificationDate.toISOString() : undefined as any;
        data["verificationCadenceId"] = this.verificationCadenceId;
        data["systemPower"] = this.systemPower;
        data["plantBookletPresent"] = this.plantBookletPresent;
        data["plantBookletPresentFileId"] = this.plantBookletPresentFileId;
        data["appointedCompany"] = this.appointedCompany;
        data["lastCompilationDate"] = this.lastCompilationDate ? this.lastCompilationDate.toISOString() : undefined as any;
        data["compilationCadence"] = this.compilationCadence;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpdateElectricalSystemDto {
        const json = this.toJSON();
        let result = new UpdateElectricalSystemDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateElectricalSystemDto {
    id: number;
    name: string | undefined;
    project: boolean;
    projectFileId: number | undefined;
    plantConformityDeclaration: boolean;
    plantConformityDeclarationFileId: number | undefined;
    competentBodies: boolean | undefined;
    grounding: boolean | undefined;
    competentBodyId: number | undefined;
    appointedCertifyingBody: string | undefined;
    lastVerificationDate: moment.Moment | undefined;
    verificationCadenceId: number | undefined;
    systemPower: string | undefined;
    plantBookletPresent: boolean;
    plantBookletPresentFileId: number | undefined;
    appointedCompany: string | undefined;
    lastCompilationDate: moment.Moment | undefined;
    compilationCadence: number;
    notes: string | undefined;
}

export class UpdateElevatorSystemDto implements IUpdateElevatorSystemDto {
    id!: number;
    name!: string;
    elevatorTypeId!: number | undefined;
    serialNumber!: string | undefined;
    brand!: string | undefined;
    testing!: boolean | undefined;
    plantConformityDeclaration!: boolean;
    plantConformityDeclarationFileId!: number | undefined;
    maintenanceContract!: boolean;
    maintenanceContractFileId!: number | undefined;
    maintenanceCompany!: string | undefined;
    lastMaintenanceDate!: moment.Moment | undefined;
    telephoneDialer!: boolean;
    phoneNumber!: string | undefined;
    externalBodyVerificationObligation!: boolean;
    companyName!: string | undefined;
    lastVerificationDate!: moment.Moment | undefined;
    verificationFrequency!: number | undefined;
    notes!: string | undefined;

    constructor(data?: IUpdateElevatorSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.elevatorTypeId = _data["elevatorTypeId"];
            this.serialNumber = _data["serialNumber"];
            this.brand = _data["brand"];
            this.testing = _data["testing"];
            this.plantConformityDeclaration = _data["plantConformityDeclaration"];
            this.plantConformityDeclarationFileId = _data["plantConformityDeclarationFileId"];
            this.maintenanceContract = _data["maintenanceContract"];
            this.maintenanceContractFileId = _data["maintenanceContractFileId"];
            this.maintenanceCompany = _data["maintenanceCompany"];
            this.lastMaintenanceDate = _data["lastMaintenanceDate"] ? moment(_data["lastMaintenanceDate"].toString()) : undefined as any;
            this.telephoneDialer = _data["telephoneDialer"];
            this.phoneNumber = _data["phoneNumber"];
            this.externalBodyVerificationObligation = _data["externalBodyVerificationObligation"];
            this.companyName = _data["companyName"];
            this.lastVerificationDate = _data["lastVerificationDate"] ? moment(_data["lastVerificationDate"].toString()) : undefined as any;
            this.verificationFrequency = _data["verificationFrequency"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateElevatorSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateElevatorSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["elevatorTypeId"] = this.elevatorTypeId;
        data["serialNumber"] = this.serialNumber;
        data["brand"] = this.brand;
        data["testing"] = this.testing;
        data["plantConformityDeclaration"] = this.plantConformityDeclaration;
        data["plantConformityDeclarationFileId"] = this.plantConformityDeclarationFileId;
        data["maintenanceContract"] = this.maintenanceContract;
        data["maintenanceContractFileId"] = this.maintenanceContractFileId;
        data["maintenanceCompany"] = this.maintenanceCompany;
        data["lastMaintenanceDate"] = this.lastMaintenanceDate ? this.lastMaintenanceDate.toISOString() : undefined as any;
        data["telephoneDialer"] = this.telephoneDialer;
        data["phoneNumber"] = this.phoneNumber;
        data["externalBodyVerificationObligation"] = this.externalBodyVerificationObligation;
        data["companyName"] = this.companyName;
        data["lastVerificationDate"] = this.lastVerificationDate ? this.lastVerificationDate.toISOString() : undefined as any;
        data["verificationFrequency"] = this.verificationFrequency;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpdateElevatorSystemDto {
        const json = this.toJSON();
        let result = new UpdateElevatorSystemDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateElevatorSystemDto {
    id: number;
    name: string;
    elevatorTypeId: number | undefined;
    serialNumber: string | undefined;
    brand: string | undefined;
    testing: boolean | undefined;
    plantConformityDeclaration: boolean;
    plantConformityDeclarationFileId: number | undefined;
    maintenanceContract: boolean;
    maintenanceContractFileId: number | undefined;
    maintenanceCompany: string | undefined;
    lastMaintenanceDate: moment.Moment | undefined;
    telephoneDialer: boolean;
    phoneNumber: string | undefined;
    externalBodyVerificationObligation: boolean;
    companyName: string | undefined;
    lastVerificationDate: moment.Moment | undefined;
    verificationFrequency: number | undefined;
    notes: string | undefined;
}

export class UpdateFallReportDto implements IUpdateFallReportDto {
    id!: number;
    isMale!: boolean | undefined;
    admissionDate!: moment.Moment | undefined;
    floor!: number | undefined;
    roomNumber!: number | undefined;

    constructor(data?: IUpdateFallReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isMale = _data["isMale"];
            this.admissionDate = _data["admissionDate"] ? moment(_data["admissionDate"].toString()) : undefined as any;
            this.floor = _data["floor"];
            this.roomNumber = _data["roomNumber"];
        }
    }

    static fromJS(data: any): UpdateFallReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFallReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isMale"] = this.isMale;
        data["admissionDate"] = this.admissionDate ? this.admissionDate.toISOString() : undefined as any;
        data["floor"] = this.floor;
        data["roomNumber"] = this.roomNumber;
        return data;
    }

    clone(): UpdateFallReportDto {
        const json = this.toJSON();
        let result = new UpdateFallReportDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateFallReportDto {
    id: number;
    isMale: boolean | undefined;
    admissionDate: moment.Moment | undefined;
    floor: number | undefined;
    roomNumber: number | undefined;
}

export class UpdateFallReportForDoctorDto implements IUpdateFallReportForDoctorDto {
    id!: number;
    injuryType!: string | undefined;
    injurySite!: string | undefined;
    injuryPrognosis!: string | undefined;
    consciousnessStateId!: number | undefined;
    fallEventOutcomeId!: number | undefined;
    otherFallEventOutcome!: string | undefined;

    constructor(data?: IUpdateFallReportForDoctorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.injuryType = _data["injuryType"];
            this.injurySite = _data["injurySite"];
            this.injuryPrognosis = _data["injuryPrognosis"];
            this.consciousnessStateId = _data["consciousnessStateId"];
            this.fallEventOutcomeId = _data["fallEventOutcomeId"];
            this.otherFallEventOutcome = _data["otherFallEventOutcome"];
        }
    }

    static fromJS(data: any): UpdateFallReportForDoctorDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFallReportForDoctorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["injuryType"] = this.injuryType;
        data["injurySite"] = this.injurySite;
        data["injuryPrognosis"] = this.injuryPrognosis;
        data["consciousnessStateId"] = this.consciousnessStateId;
        data["fallEventOutcomeId"] = this.fallEventOutcomeId;
        data["otherFallEventOutcome"] = this.otherFallEventOutcome;
        return data;
    }

    clone(): UpdateFallReportForDoctorDto {
        const json = this.toJSON();
        let result = new UpdateFallReportForDoctorDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateFallReportForDoctorDto {
    id: number;
    injuryType: string | undefined;
    injurySite: string | undefined;
    injuryPrognosis: string | undefined;
    consciousnessStateId: number | undefined;
    fallEventOutcomeId: number | undefined;
    otherFallEventOutcome: string | undefined;
}

export class UpdateFallReportForOperatorDto implements IUpdateFallReportForOperatorDto {
    id!: number;
    date!: moment.Moment;
    personPresentId!: number | undefined;
    otherPersonPresent!: string | undefined;
    fallModeId!: number | undefined;
    otherFallMode!: string | undefined;
    fallReasonId!: number | undefined;
    otherFallReason!: string | undefined;
    fallLocationId!: number | undefined;
    otherFallLocation!: string | undefined;
    userDoingWhenHeFell!: string | undefined;
    footwearTypeId!: number | undefined;
    otherFootwearType!: string | undefined;
    bloodPressure!: number | undefined;
    isSuicide!: boolean | undefined;
    isViolence!: boolean | undefined;

    constructor(data?: IUpdateFallReportForOperatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.personPresentId = _data["personPresentId"];
            this.otherPersonPresent = _data["otherPersonPresent"];
            this.fallModeId = _data["fallModeId"];
            this.otherFallMode = _data["otherFallMode"];
            this.fallReasonId = _data["fallReasonId"];
            this.otherFallReason = _data["otherFallReason"];
            this.fallLocationId = _data["fallLocationId"];
            this.otherFallLocation = _data["otherFallLocation"];
            this.userDoingWhenHeFell = _data["userDoingWhenHeFell"];
            this.footwearTypeId = _data["footwearTypeId"];
            this.otherFootwearType = _data["otherFootwearType"];
            this.bloodPressure = _data["bloodPressure"];
            this.isSuicide = _data["isSuicide"];
            this.isViolence = _data["isViolence"];
        }
    }

    static fromJS(data: any): UpdateFallReportForOperatorDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFallReportForOperatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["personPresentId"] = this.personPresentId;
        data["otherPersonPresent"] = this.otherPersonPresent;
        data["fallModeId"] = this.fallModeId;
        data["otherFallMode"] = this.otherFallMode;
        data["fallReasonId"] = this.fallReasonId;
        data["otherFallReason"] = this.otherFallReason;
        data["fallLocationId"] = this.fallLocationId;
        data["otherFallLocation"] = this.otherFallLocation;
        data["userDoingWhenHeFell"] = this.userDoingWhenHeFell;
        data["footwearTypeId"] = this.footwearTypeId;
        data["otherFootwearType"] = this.otherFootwearType;
        data["bloodPressure"] = this.bloodPressure;
        data["isSuicide"] = this.isSuicide;
        data["isViolence"] = this.isViolence;
        return data;
    }

    clone(): UpdateFallReportForOperatorDto {
        const json = this.toJSON();
        let result = new UpdateFallReportForOperatorDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateFallReportForOperatorDto {
    id: number;
    date: moment.Moment;
    personPresentId: number | undefined;
    otherPersonPresent: string | undefined;
    fallModeId: number | undefined;
    otherFallMode: string | undefined;
    fallReasonId: number | undefined;
    otherFallReason: string | undefined;
    fallLocationId: number | undefined;
    otherFallLocation: string | undefined;
    userDoingWhenHeFell: string | undefined;
    footwearTypeId: number | undefined;
    otherFootwearType: string | undefined;
    bloodPressure: number | undefined;
    isSuicide: boolean | undefined;
    isViolence: boolean | undefined;
}

export class UpdateFamilyComponentDto implements IUpdateFamilyComponentDto {
    id!: number;
    kinshipDegree!: string | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    birthDate!: moment.Moment | undefined;
    deathDate!: moment.Moment | undefined;
    workActivities!: string | undefined;
    educationDegree!: string | undefined;

    constructor(data?: IUpdateFamilyComponentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kinshipDegree = _data["kinshipDegree"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : undefined as any;
            this.deathDate = _data["deathDate"] ? moment(_data["deathDate"].toString()) : undefined as any;
            this.workActivities = _data["workActivities"];
            this.educationDegree = _data["educationDegree"];
        }
    }

    static fromJS(data: any): UpdateFamilyComponentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFamilyComponentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kinshipDegree"] = this.kinshipDegree;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["birthDate"] = this.birthDate ? this.birthDate.format('YYYY-MM-DD') : undefined as any;
        data["deathDate"] = this.deathDate ? this.deathDate.format('YYYY-MM-DD') : undefined as any;
        data["workActivities"] = this.workActivities;
        data["educationDegree"] = this.educationDegree;
        return data;
    }

    clone(): UpdateFamilyComponentDto {
        const json = this.toJSON();
        let result = new UpdateFamilyComponentDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateFamilyComponentDto {
    id: number;
    kinshipDegree: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    birthDate: moment.Moment | undefined;
    deathDate: moment.Moment | undefined;
    workActivities: string | undefined;
    educationDegree: string | undefined;
}

export class UpdateFamilyReferenceDto implements IUpdateFamilyReferenceDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    phoneNumber!: string | undefined;
    emailAddress!: string | undefined;
    role!: string | undefined;

    constructor(data?: IUpdateFamilyReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phoneNumber = _data["phoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.role = _data["role"];
        }
    }

    static fromJS(data: any): UpdateFamilyReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFamilyReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phoneNumber"] = this.phoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["role"] = this.role;
        return data;
    }

    clone(): UpdateFamilyReferenceDto {
        const json = this.toJSON();
        let result = new UpdateFamilyReferenceDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateFamilyReferenceDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    phoneNumber: string | undefined;
    emailAddress: string | undefined;
    role: string | undefined;
}

export class UpdateFirePreventionSystemDto implements IUpdateFirePreventionSystemDto {
    id!: number;
    name!: string | undefined;
    firePreventionDevicesId!: number | undefined;
    firePreventionExtinguisherId!: number | undefined;
    quantity!: number | undefined;
    fireControlUnitBrand!: string | undefined;
    fireControlUnitModel!: string | undefined;
    project!: boolean;
    projectFileId!: number | undefined;
    plantConformityDeclaration!: boolean;
    plantConformityDeclarationFileId!: number | undefined;
    maintenanceContract!: boolean;
    maintenanceCompany!: string | undefined;
    maintenanceFileId!: number | undefined;
    lastMaintenanceDate!: moment.Moment | undefined;
    appointedCompany!: string | undefined;
    outsiderResponsible!: boolean;
    record!: boolean;
    notes!: string | undefined;

    constructor(data?: IUpdateFirePreventionSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.firePreventionDevicesId = _data["firePreventionDevicesId"];
            this.firePreventionExtinguisherId = _data["firePreventionExtinguisherId"];
            this.quantity = _data["quantity"];
            this.fireControlUnitBrand = _data["fireControlUnitBrand"];
            this.fireControlUnitModel = _data["fireControlUnitModel"];
            this.project = _data["project"];
            this.projectFileId = _data["projectFileId"];
            this.plantConformityDeclaration = _data["plantConformityDeclaration"];
            this.plantConformityDeclarationFileId = _data["plantConformityDeclarationFileId"];
            this.maintenanceContract = _data["maintenanceContract"];
            this.maintenanceCompany = _data["maintenanceCompany"];
            this.maintenanceFileId = _data["maintenanceFileId"];
            this.lastMaintenanceDate = _data["lastMaintenanceDate"] ? moment(_data["lastMaintenanceDate"].toString()) : undefined as any;
            this.appointedCompany = _data["appointedCompany"];
            this.outsiderResponsible = _data["outsiderResponsible"];
            this.record = _data["record"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateFirePreventionSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFirePreventionSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["firePreventionDevicesId"] = this.firePreventionDevicesId;
        data["firePreventionExtinguisherId"] = this.firePreventionExtinguisherId;
        data["quantity"] = this.quantity;
        data["fireControlUnitBrand"] = this.fireControlUnitBrand;
        data["fireControlUnitModel"] = this.fireControlUnitModel;
        data["project"] = this.project;
        data["projectFileId"] = this.projectFileId;
        data["plantConformityDeclaration"] = this.plantConformityDeclaration;
        data["plantConformityDeclarationFileId"] = this.plantConformityDeclarationFileId;
        data["maintenanceContract"] = this.maintenanceContract;
        data["maintenanceCompany"] = this.maintenanceCompany;
        data["maintenanceFileId"] = this.maintenanceFileId;
        data["lastMaintenanceDate"] = this.lastMaintenanceDate ? this.lastMaintenanceDate.toISOString() : undefined as any;
        data["appointedCompany"] = this.appointedCompany;
        data["outsiderResponsible"] = this.outsiderResponsible;
        data["record"] = this.record;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpdateFirePreventionSystemDto {
        const json = this.toJSON();
        let result = new UpdateFirePreventionSystemDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateFirePreventionSystemDto {
    id: number;
    name: string | undefined;
    firePreventionDevicesId: number | undefined;
    firePreventionExtinguisherId: number | undefined;
    quantity: number | undefined;
    fireControlUnitBrand: string | undefined;
    fireControlUnitModel: string | undefined;
    project: boolean;
    projectFileId: number | undefined;
    plantConformityDeclaration: boolean;
    plantConformityDeclarationFileId: number | undefined;
    maintenanceContract: boolean;
    maintenanceCompany: string | undefined;
    maintenanceFileId: number | undefined;
    lastMaintenanceDate: moment.Moment | undefined;
    appointedCompany: string | undefined;
    outsiderResponsible: boolean;
    record: boolean;
    notes: string | undefined;
}

export class UpdateHealthAspectDto implements IUpdateHealthAspectDto {
    id!: number;
    motorSkills!: boolean;
    sight!: boolean;
    hearing!: boolean;
    language!: boolean;
    walking!: boolean;
    other!: string | undefined;
    aids!: string | undefined;
    rehabilitationTherapies!: string | undefined;
    drugTherapies!: string | undefined;
    note!: string | undefined;

    constructor(data?: IUpdateHealthAspectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.motorSkills = _data["motorSkills"];
            this.sight = _data["sight"];
            this.hearing = _data["hearing"];
            this.language = _data["language"];
            this.walking = _data["walking"];
            this.other = _data["other"];
            this.aids = _data["aids"];
            this.rehabilitationTherapies = _data["rehabilitationTherapies"];
            this.drugTherapies = _data["drugTherapies"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateHealthAspectDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHealthAspectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["motorSkills"] = this.motorSkills;
        data["sight"] = this.sight;
        data["hearing"] = this.hearing;
        data["language"] = this.language;
        data["walking"] = this.walking;
        data["other"] = this.other;
        data["aids"] = this.aids;
        data["rehabilitationTherapies"] = this.rehabilitationTherapies;
        data["drugTherapies"] = this.drugTherapies;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateHealthAspectDto {
        const json = this.toJSON();
        let result = new UpdateHealthAspectDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateHealthAspectDto {
    id: number;
    motorSkills: boolean;
    sight: boolean;
    hearing: boolean;
    language: boolean;
    walking: boolean;
    other: string | undefined;
    aids: string | undefined;
    rehabilitationTherapies: string | undefined;
    drugTherapies: string | undefined;
    note: string | undefined;
}

export class UpdateHealthCoordinatorRecordDto implements IUpdateHealthCoordinatorRecordDto {
    id!: number;
    date!: moment.Moment;
    diagnosis!: string | undefined;
    advice!: string | undefined;

    constructor(data?: IUpdateHealthCoordinatorRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.diagnosis = _data["diagnosis"];
            this.advice = _data["advice"];
        }
    }

    static fromJS(data: any): UpdateHealthCoordinatorRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHealthCoordinatorRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["diagnosis"] = this.diagnosis;
        data["advice"] = this.advice;
        return data;
    }

    clone(): UpdateHealthCoordinatorRecordDto {
        const json = this.toJSON();
        let result = new UpdateHealthCoordinatorRecordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateHealthCoordinatorRecordDto {
    id: number;
    date: moment.Moment;
    diagnosis: string | undefined;
    advice: string | undefined;
}

export class UpdateHealthSocialWelfareServiceDto implements IUpdateHealthSocialWelfareServiceDto {
    id!: number;
    dateOfAcceptance!: moment.Moment | undefined;
    socialWorker!: string | undefined;
    homeAssistant!: string | undefined;
    dayFosterCare!: string | undefined;
    inChargeAt!: string | undefined;
    serviceNPI!: string | undefined;

    constructor(data?: IUpdateHealthSocialWelfareServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateOfAcceptance = _data["dateOfAcceptance"] ? moment(_data["dateOfAcceptance"].toString()) : undefined as any;
            this.socialWorker = _data["socialWorker"];
            this.homeAssistant = _data["homeAssistant"];
            this.dayFosterCare = _data["dayFosterCare"];
            this.inChargeAt = _data["inChargeAt"];
            this.serviceNPI = _data["serviceNPI"];
        }
    }

    static fromJS(data: any): UpdateHealthSocialWelfareServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHealthSocialWelfareServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateOfAcceptance"] = this.dateOfAcceptance ? this.dateOfAcceptance.toISOString() : undefined as any;
        data["socialWorker"] = this.socialWorker;
        data["homeAssistant"] = this.homeAssistant;
        data["dayFosterCare"] = this.dayFosterCare;
        data["inChargeAt"] = this.inChargeAt;
        data["serviceNPI"] = this.serviceNPI;
        return data;
    }

    clone(): UpdateHealthSocialWelfareServiceDto {
        const json = this.toJSON();
        let result = new UpdateHealthSocialWelfareServiceDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateHealthSocialWelfareServiceDto {
    id: number;
    dateOfAcceptance: moment.Moment | undefined;
    socialWorker: string | undefined;
    homeAssistant: string | undefined;
    dayFosterCare: string | undefined;
    inChargeAt: string | undefined;
    serviceNPI: string | undefined;
}

export class UpdateHeatingSystemDto implements IUpdateHeatingSystemDto {
    id!: number;
    name!: string;
    plantType!: number | undefined;
    fuelType!: number | undefined;
    fuel!: number | undefined;
    plantConformityDeclaration!: boolean;
    plantConformityDeclarationFile!: number | undefined;
    plantBookletPresent!: boolean;
    plantBookletPresentFile!: number | undefined;
    performanceVerification!: boolean;
    cadenceOfChange!: number | undefined;
    lastVerificationDate!: moment.Moment | undefined;
    maintenanceContract!: boolean;
    maintenanceCompany!: string | undefined;
    maintenanceFile!: number | undefined;
    lastMaintenanceDate!: moment.Moment | undefined;
    outsiderResponsible!: boolean;
    appointedCompany!: string | undefined;
    cpi!: boolean;
    cpiMonth!: number | undefined;
    notes!: string | undefined;

    constructor(data?: IUpdateHeatingSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.plantType = _data["plantType"];
            this.fuelType = _data["fuelType"];
            this.fuel = _data["fuel"];
            this.plantConformityDeclaration = _data["plantConformityDeclaration"];
            this.plantConformityDeclarationFile = _data["plantConformityDeclarationFile"];
            this.plantBookletPresent = _data["plantBookletPresent"];
            this.plantBookletPresentFile = _data["plantBookletPresentFile"];
            this.performanceVerification = _data["performanceVerification"];
            this.cadenceOfChange = _data["cadenceOfChange"];
            this.lastVerificationDate = _data["lastVerificationDate"] ? moment(_data["lastVerificationDate"].toString()) : undefined as any;
            this.maintenanceContract = _data["maintenanceContract"];
            this.maintenanceCompany = _data["maintenanceCompany"];
            this.maintenanceFile = _data["maintenanceFile"];
            this.lastMaintenanceDate = _data["lastMaintenanceDate"] ? moment(_data["lastMaintenanceDate"].toString()) : undefined as any;
            this.outsiderResponsible = _data["outsiderResponsible"];
            this.appointedCompany = _data["appointedCompany"];
            this.cpi = _data["cpi"];
            this.cpiMonth = _data["cpiMonth"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateHeatingSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHeatingSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["plantType"] = this.plantType;
        data["fuelType"] = this.fuelType;
        data["fuel"] = this.fuel;
        data["plantConformityDeclaration"] = this.plantConformityDeclaration;
        data["plantConformityDeclarationFile"] = this.plantConformityDeclarationFile;
        data["plantBookletPresent"] = this.plantBookletPresent;
        data["plantBookletPresentFile"] = this.plantBookletPresentFile;
        data["performanceVerification"] = this.performanceVerification;
        data["cadenceOfChange"] = this.cadenceOfChange;
        data["lastVerificationDate"] = this.lastVerificationDate ? this.lastVerificationDate.toISOString() : undefined as any;
        data["maintenanceContract"] = this.maintenanceContract;
        data["maintenanceCompany"] = this.maintenanceCompany;
        data["maintenanceFile"] = this.maintenanceFile;
        data["lastMaintenanceDate"] = this.lastMaintenanceDate ? this.lastMaintenanceDate.toISOString() : undefined as any;
        data["outsiderResponsible"] = this.outsiderResponsible;
        data["appointedCompany"] = this.appointedCompany;
        data["cpi"] = this.cpi;
        data["cpiMonth"] = this.cpiMonth;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpdateHeatingSystemDto {
        const json = this.toJSON();
        let result = new UpdateHeatingSystemDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateHeatingSystemDto {
    id: number;
    name: string;
    plantType: number | undefined;
    fuelType: number | undefined;
    fuel: number | undefined;
    plantConformityDeclaration: boolean;
    plantConformityDeclarationFile: number | undefined;
    plantBookletPresent: boolean;
    plantBookletPresentFile: number | undefined;
    performanceVerification: boolean;
    cadenceOfChange: number | undefined;
    lastVerificationDate: moment.Moment | undefined;
    maintenanceContract: boolean;
    maintenanceCompany: string | undefined;
    maintenanceFile: number | undefined;
    lastMaintenanceDate: moment.Moment | undefined;
    outsiderResponsible: boolean;
    appointedCompany: string | undefined;
    cpi: boolean;
    cpiMonth: number | undefined;
    notes: string | undefined;
}

export class UpdateHistoricalCaseDto implements IUpdateHistoricalCaseDto {
    id!: number;
    historicalCaseScopeId!: number | undefined;
    description!: string | undefined;

    constructor(data?: IUpdateHistoricalCaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.historicalCaseScopeId = _data["historicalCaseScopeId"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateHistoricalCaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHistoricalCaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["historicalCaseScopeId"] = this.historicalCaseScopeId;
        data["description"] = this.description;
        return data;
    }

    clone(): UpdateHistoricalCaseDto {
        const json = this.toJSON();
        let result = new UpdateHistoricalCaseDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateHistoricalCaseDto {
    id: number;
    historicalCaseScopeId: number | undefined;
    description: string | undefined;
}

export class UpdateHousingSituationDto implements IUpdateHousingSituationDto {
    id!: number;
    possession!: boolean | undefined;
    environmentalHygienicCondition!: boolean | undefined;
    locationTypeId!: number | undefined;
    relationship!: string | undefined;

    constructor(data?: IUpdateHousingSituationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.possession = _data["possession"];
            this.environmentalHygienicCondition = _data["environmentalHygienicCondition"];
            this.locationTypeId = _data["locationTypeId"];
            this.relationship = _data["relationship"];
        }
    }

    static fromJS(data: any): UpdateHousingSituationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHousingSituationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["possession"] = this.possession;
        data["environmentalHygienicCondition"] = this.environmentalHygienicCondition;
        data["locationTypeId"] = this.locationTypeId;
        data["relationship"] = this.relationship;
        return data;
    }

    clone(): UpdateHousingSituationDto {
        const json = this.toJSON();
        let result = new UpdateHousingSituationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateHousingSituationDto {
    id: number;
    possession: boolean | undefined;
    environmentalHygienicCondition: boolean | undefined;
    locationTypeId: number | undefined;
    relationship: string | undefined;
}

export class UpdateHydraulicSystemDto implements IUpdateHydraulicSystemDto {
    id!: number;
    name!: string;
    project!: boolean;
    projectFileId!: number | undefined;
    lastLegionellaeCheck!: moment.Moment | undefined;
    lastWaterSafetyCheck!: moment.Moment | undefined;
    notes!: string | undefined;

    constructor(data?: IUpdateHydraulicSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.project = _data["project"];
            this.projectFileId = _data["projectFileId"];
            this.lastLegionellaeCheck = _data["lastLegionellaeCheck"] ? moment(_data["lastLegionellaeCheck"].toString()) : undefined as any;
            this.lastWaterSafetyCheck = _data["lastWaterSafetyCheck"] ? moment(_data["lastWaterSafetyCheck"].toString()) : undefined as any;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateHydraulicSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHydraulicSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["project"] = this.project;
        data["projectFileId"] = this.projectFileId;
        data["lastLegionellaeCheck"] = this.lastLegionellaeCheck ? this.lastLegionellaeCheck.toISOString() : undefined as any;
        data["lastWaterSafetyCheck"] = this.lastWaterSafetyCheck ? this.lastWaterSafetyCheck.toISOString() : undefined as any;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpdateHydraulicSystemDto {
        const json = this.toJSON();
        let result = new UpdateHydraulicSystemDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateHydraulicSystemDto {
    id: number;
    name: string;
    project: boolean;
    projectFileId: number | undefined;
    lastLegionellaeCheck: moment.Moment | undefined;
    lastWaterSafetyCheck: moment.Moment | undefined;
    notes: string | undefined;
}

export class UpdateIncomeAllowanceDto implements IUpdateIncomeAllowanceDto {
    id!: number;
    disabilityRate!: number;
    placeableWork!: boolean | undefined;
    protectedCategories!: boolean | undefined;
    inailDisability!: boolean | undefined;
    disabilityTypeId!: number | undefined;
    practicesInProgress!: boolean | undefined;
    allowanceAccompanying!: boolean | undefined;
    note!: string | undefined;

    constructor(data?: IUpdateIncomeAllowanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.disabilityRate = _data["disabilityRate"];
            this.placeableWork = _data["placeableWork"];
            this.protectedCategories = _data["protectedCategories"];
            this.inailDisability = _data["inailDisability"];
            this.disabilityTypeId = _data["disabilityTypeId"];
            this.practicesInProgress = _data["practicesInProgress"];
            this.allowanceAccompanying = _data["allowanceAccompanying"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateIncomeAllowanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIncomeAllowanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["disabilityRate"] = this.disabilityRate;
        data["placeableWork"] = this.placeableWork;
        data["protectedCategories"] = this.protectedCategories;
        data["inailDisability"] = this.inailDisability;
        data["disabilityTypeId"] = this.disabilityTypeId;
        data["practicesInProgress"] = this.practicesInProgress;
        data["allowanceAccompanying"] = this.allowanceAccompanying;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateIncomeAllowanceDto {
        const json = this.toJSON();
        let result = new UpdateIncomeAllowanceDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateIncomeAllowanceDto {
    id: number;
    disabilityRate: number;
    placeableWork: boolean | undefined;
    protectedCategories: boolean | undefined;
    inailDisability: boolean | undefined;
    disabilityTypeId: number | undefined;
    practicesInProgress: boolean | undefined;
    allowanceAccompanying: boolean | undefined;
    note: string | undefined;
}

export class UpdateInformationAccreditationDto implements IUpdateInformationAccreditationDto {
    id!: number;
    insertionDate!: moment.Moment | undefined;
    mmg!: string | undefined;
    dss!: string | undefined;
    municipalSocialServiceId!: number | undefined;
    neurologicalDisorders!: string | undefined;
    psychiatricDisorders!: string | undefined;
    arterialHypertension!: boolean | undefined;
    diabetesMellitus!: boolean | undefined;
    osteoporosis!: boolean | undefined;
    sphincterIncontinence!: string | undefined;
    allergies!: string | undefined;
    foodIntolerances!: string | undefined;
    sensoryMotorDisorders!: string | undefined;

    constructor(data?: IUpdateInformationAccreditationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.insertionDate = _data["insertionDate"] ? moment(_data["insertionDate"].toString()) : undefined as any;
            this.mmg = _data["mmg"];
            this.dss = _data["dss"];
            this.municipalSocialServiceId = _data["municipalSocialServiceId"];
            this.neurologicalDisorders = _data["neurologicalDisorders"];
            this.psychiatricDisorders = _data["psychiatricDisorders"];
            this.arterialHypertension = _data["arterialHypertension"];
            this.diabetesMellitus = _data["diabetesMellitus"];
            this.osteoporosis = _data["osteoporosis"];
            this.sphincterIncontinence = _data["sphincterIncontinence"];
            this.allergies = _data["allergies"];
            this.foodIntolerances = _data["foodIntolerances"];
            this.sensoryMotorDisorders = _data["sensoryMotorDisorders"];
        }
    }

    static fromJS(data: any): UpdateInformationAccreditationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInformationAccreditationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["insertionDate"] = this.insertionDate ? this.insertionDate.toISOString() : undefined as any;
        data["mmg"] = this.mmg;
        data["dss"] = this.dss;
        data["municipalSocialServiceId"] = this.municipalSocialServiceId;
        data["neurologicalDisorders"] = this.neurologicalDisorders;
        data["psychiatricDisorders"] = this.psychiatricDisorders;
        data["arterialHypertension"] = this.arterialHypertension;
        data["diabetesMellitus"] = this.diabetesMellitus;
        data["osteoporosis"] = this.osteoporosis;
        data["sphincterIncontinence"] = this.sphincterIncontinence;
        data["allergies"] = this.allergies;
        data["foodIntolerances"] = this.foodIntolerances;
        data["sensoryMotorDisorders"] = this.sensoryMotorDisorders;
        return data;
    }

    clone(): UpdateInformationAccreditationDto {
        const json = this.toJSON();
        let result = new UpdateInformationAccreditationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateInformationAccreditationDto {
    id: number;
    insertionDate: moment.Moment | undefined;
    mmg: string | undefined;
    dss: string | undefined;
    municipalSocialServiceId: number | undefined;
    neurologicalDisorders: string | undefined;
    psychiatricDisorders: string | undefined;
    arterialHypertension: boolean | undefined;
    diabetesMellitus: boolean | undefined;
    osteoporosis: boolean | undefined;
    sphincterIncontinence: string | undefined;
    allergies: string | undefined;
    foodIntolerances: string | undefined;
    sensoryMotorDisorders: string | undefined;
}

export class UpdateIntegratedRehabilitationPlanRecordDto implements IUpdateIntegratedRehabilitationPlanRecordDto {
    id!: number;
    startingSituation!: string | undefined;
    description!: string | undefined;
    protocolNumber!: string | undefined;
    isFinalReport!: boolean;

    constructor(data?: IUpdateIntegratedRehabilitationPlanRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startingSituation = _data["startingSituation"];
            this.description = _data["description"];
            this.protocolNumber = _data["protocolNumber"];
            this.isFinalReport = _data["isFinalReport"];
        }
    }

    static fromJS(data: any): UpdateIntegratedRehabilitationPlanRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIntegratedRehabilitationPlanRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startingSituation"] = this.startingSituation;
        data["description"] = this.description;
        data["protocolNumber"] = this.protocolNumber;
        data["isFinalReport"] = this.isFinalReport;
        return data;
    }

    clone(): UpdateIntegratedRehabilitationPlanRecordDto {
        const json = this.toJSON();
        let result = new UpdateIntegratedRehabilitationPlanRecordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateIntegratedRehabilitationPlanRecordDto {
    id: number;
    startingSituation: string | undefined;
    description: string | undefined;
    protocolNumber: string | undefined;
    isFinalReport: boolean;
}

export class UpdateInterviewParticipantsRecordDto implements IUpdateInterviewParticipantsRecordDto {
    id!: number;
    serviceUserIds!: number[] | undefined;
    relatives!: UpdateRelativeDto[] | undefined;

    constructor(data?: IUpdateInterviewParticipantsRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["serviceUserIds"])) {
                this.serviceUserIds = [] as any;
                for (let item of _data["serviceUserIds"])
                    this.serviceUserIds!.push(item);
            }
            if (Array.isArray(_data["relatives"])) {
                this.relatives = [] as any;
                for (let item of _data["relatives"])
                    this.relatives!.push(UpdateRelativeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateInterviewParticipantsRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInterviewParticipantsRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.serviceUserIds)) {
            data["serviceUserIds"] = [];
            for (let item of this.serviceUserIds)
                data["serviceUserIds"].push(item);
        }
        if (Array.isArray(this.relatives)) {
            data["relatives"] = [];
            for (let item of this.relatives)
                data["relatives"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UpdateInterviewParticipantsRecordDto {
        const json = this.toJSON();
        let result = new UpdateInterviewParticipantsRecordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateInterviewParticipantsRecordDto {
    id: number;
    serviceUserIds: number[] | undefined;
    relatives: UpdateRelativeDto[] | undefined;
}

export class UpdateLifelineSystemDto implements IUpdateLifelineSystemDto {
    id!: number;
    name!: string;
    project!: boolean;
    projectFileId!: number | undefined;
    lastVerificationDate!: moment.Moment | undefined;
    verificationCadenceId!: number | undefined;
    maintenanceContract!: boolean;
    maintenanceCompany!: string | undefined;
    maintenanceFile!: number | undefined;
    lastMaintenanceDate!: moment.Moment | undefined;
    outsiderResponsible!: boolean;
    appointedCompany!: string | undefined;
    notes!: string | undefined;

    constructor(data?: IUpdateLifelineSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.project = _data["project"];
            this.projectFileId = _data["projectFileId"];
            this.lastVerificationDate = _data["lastVerificationDate"] ? moment(_data["lastVerificationDate"].toString()) : undefined as any;
            this.verificationCadenceId = _data["verificationCadenceId"];
            this.maintenanceContract = _data["maintenanceContract"];
            this.maintenanceCompany = _data["maintenanceCompany"];
            this.maintenanceFile = _data["maintenanceFile"];
            this.lastMaintenanceDate = _data["lastMaintenanceDate"] ? moment(_data["lastMaintenanceDate"].toString()) : undefined as any;
            this.outsiderResponsible = _data["outsiderResponsible"];
            this.appointedCompany = _data["appointedCompany"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateLifelineSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLifelineSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["project"] = this.project;
        data["projectFileId"] = this.projectFileId;
        data["lastVerificationDate"] = this.lastVerificationDate ? this.lastVerificationDate.toISOString() : undefined as any;
        data["verificationCadenceId"] = this.verificationCadenceId;
        data["maintenanceContract"] = this.maintenanceContract;
        data["maintenanceCompany"] = this.maintenanceCompany;
        data["maintenanceFile"] = this.maintenanceFile;
        data["lastMaintenanceDate"] = this.lastMaintenanceDate ? this.lastMaintenanceDate.toISOString() : undefined as any;
        data["outsiderResponsible"] = this.outsiderResponsible;
        data["appointedCompany"] = this.appointedCompany;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpdateLifelineSystemDto {
        const json = this.toJSON();
        let result = new UpdateLifelineSystemDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateLifelineSystemDto {
    id: number;
    name: string;
    project: boolean;
    projectFileId: number | undefined;
    lastVerificationDate: moment.Moment | undefined;
    verificationCadenceId: number | undefined;
    maintenanceContract: boolean;
    maintenanceCompany: string | undefined;
    maintenanceFile: number | undefined;
    lastMaintenanceDate: moment.Moment | undefined;
    outsiderResponsible: boolean;
    appointedCompany: string | undefined;
    notes: string | undefined;
}

export class UpdateMaintenanceEventDto implements IUpdateMaintenanceEventDto {
    id!: number;
    eventTypeId!: number | undefined;
    date!: moment.Moment;
    provider!: string | undefined;
    amount!: number | undefined;
    note!: string | undefined;

    constructor(data?: IUpdateMaintenanceEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventTypeId = _data["eventTypeId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.provider = _data["provider"];
            this.amount = _data["amount"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateMaintenanceEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMaintenanceEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventTypeId"] = this.eventTypeId;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["provider"] = this.provider;
        data["amount"] = this.amount;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateMaintenanceEventDto {
        const json = this.toJSON();
        let result = new UpdateMaintenanceEventDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateMaintenanceEventDto {
    id: number;
    eventTypeId: number | undefined;
    date: moment.Moment;
    provider: string | undefined;
    amount: number | undefined;
    note: string | undefined;
}

export class UpdateMonitoringRestraintRecordDto implements IUpdateMonitoringRestraintRecordDto {
    id!: number;
    date!: moment.Moment;
    startRestraint!: moment.Moment | undefined;
    mmse!: string | undefined;
    disorderNonCognitiveIds!: number[] | undefined;
    conleyScale!: string | undefined;
    prescribedTypeIds!: number[] | undefined;
    bedriddenGuest!: string | undefined;
    sideRails!: string | undefined;
    prescribedTypeOther!: string | undefined;
    wheelchairUserIds!: number[] | undefined;
    wheelchairUserOther!: string | undefined;
    bodySegmentIds!: number[] | undefined;
    bodySegmentOther!: string | undefined;
    psychosocialSphereSyndromeIds!: number[] | undefined;
    nursingSphereSyndromeIds!: number[] | undefined;
    physiotherapySphereSyndromeIds!: number[] | undefined;
    notes!: string | undefined;

    constructor(data?: IUpdateMonitoringRestraintRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.startRestraint = _data["startRestraint"] ? moment(_data["startRestraint"].toString()) : undefined as any;
            this.mmse = _data["mmse"];
            if (Array.isArray(_data["disorderNonCognitiveIds"])) {
                this.disorderNonCognitiveIds = [] as any;
                for (let item of _data["disorderNonCognitiveIds"])
                    this.disorderNonCognitiveIds!.push(item);
            }
            this.conleyScale = _data["conleyScale"];
            if (Array.isArray(_data["prescribedTypeIds"])) {
                this.prescribedTypeIds = [] as any;
                for (let item of _data["prescribedTypeIds"])
                    this.prescribedTypeIds!.push(item);
            }
            this.bedriddenGuest = _data["bedriddenGuest"];
            this.sideRails = _data["sideRails"];
            this.prescribedTypeOther = _data["prescribedTypeOther"];
            if (Array.isArray(_data["wheelchairUserIds"])) {
                this.wheelchairUserIds = [] as any;
                for (let item of _data["wheelchairUserIds"])
                    this.wheelchairUserIds!.push(item);
            }
            this.wheelchairUserOther = _data["wheelchairUserOther"];
            if (Array.isArray(_data["bodySegmentIds"])) {
                this.bodySegmentIds = [] as any;
                for (let item of _data["bodySegmentIds"])
                    this.bodySegmentIds!.push(item);
            }
            this.bodySegmentOther = _data["bodySegmentOther"];
            if (Array.isArray(_data["psychosocialSphereSyndromeIds"])) {
                this.psychosocialSphereSyndromeIds = [] as any;
                for (let item of _data["psychosocialSphereSyndromeIds"])
                    this.psychosocialSphereSyndromeIds!.push(item);
            }
            if (Array.isArray(_data["nursingSphereSyndromeIds"])) {
                this.nursingSphereSyndromeIds = [] as any;
                for (let item of _data["nursingSphereSyndromeIds"])
                    this.nursingSphereSyndromeIds!.push(item);
            }
            if (Array.isArray(_data["physiotherapySphereSyndromeIds"])) {
                this.physiotherapySphereSyndromeIds = [] as any;
                for (let item of _data["physiotherapySphereSyndromeIds"])
                    this.physiotherapySphereSyndromeIds!.push(item);
            }
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateMonitoringRestraintRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMonitoringRestraintRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["startRestraint"] = this.startRestraint ? this.startRestraint.toISOString() : undefined as any;
        data["mmse"] = this.mmse;
        if (Array.isArray(this.disorderNonCognitiveIds)) {
            data["disorderNonCognitiveIds"] = [];
            for (let item of this.disorderNonCognitiveIds)
                data["disorderNonCognitiveIds"].push(item);
        }
        data["conleyScale"] = this.conleyScale;
        if (Array.isArray(this.prescribedTypeIds)) {
            data["prescribedTypeIds"] = [];
            for (let item of this.prescribedTypeIds)
                data["prescribedTypeIds"].push(item);
        }
        data["bedriddenGuest"] = this.bedriddenGuest;
        data["sideRails"] = this.sideRails;
        data["prescribedTypeOther"] = this.prescribedTypeOther;
        if (Array.isArray(this.wheelchairUserIds)) {
            data["wheelchairUserIds"] = [];
            for (let item of this.wheelchairUserIds)
                data["wheelchairUserIds"].push(item);
        }
        data["wheelchairUserOther"] = this.wheelchairUserOther;
        if (Array.isArray(this.bodySegmentIds)) {
            data["bodySegmentIds"] = [];
            for (let item of this.bodySegmentIds)
                data["bodySegmentIds"].push(item);
        }
        data["bodySegmentOther"] = this.bodySegmentOther;
        if (Array.isArray(this.psychosocialSphereSyndromeIds)) {
            data["psychosocialSphereSyndromeIds"] = [];
            for (let item of this.psychosocialSphereSyndromeIds)
                data["psychosocialSphereSyndromeIds"].push(item);
        }
        if (Array.isArray(this.nursingSphereSyndromeIds)) {
            data["nursingSphereSyndromeIds"] = [];
            for (let item of this.nursingSphereSyndromeIds)
                data["nursingSphereSyndromeIds"].push(item);
        }
        if (Array.isArray(this.physiotherapySphereSyndromeIds)) {
            data["physiotherapySphereSyndromeIds"] = [];
            for (let item of this.physiotherapySphereSyndromeIds)
                data["physiotherapySphereSyndromeIds"].push(item);
        }
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpdateMonitoringRestraintRecordDto {
        const json = this.toJSON();
        let result = new UpdateMonitoringRestraintRecordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateMonitoringRestraintRecordDto {
    id: number;
    date: moment.Moment;
    startRestraint: moment.Moment | undefined;
    mmse: string | undefined;
    disorderNonCognitiveIds: number[] | undefined;
    conleyScale: string | undefined;
    prescribedTypeIds: number[] | undefined;
    bedriddenGuest: string | undefined;
    sideRails: string | undefined;
    prescribedTypeOther: string | undefined;
    wheelchairUserIds: number[] | undefined;
    wheelchairUserOther: string | undefined;
    bodySegmentIds: number[] | undefined;
    bodySegmentOther: string | undefined;
    psychosocialSphereSyndromeIds: number[] | undefined;
    nursingSphereSyndromeIds: number[] | undefined;
    physiotherapySphereSyndromeIds: number[] | undefined;
    notes: string | undefined;
}

export class UpdateMonthlyRehabilitationProgramNoteDto implements IUpdateMonthlyRehabilitationProgramNoteDto {
    id!: number;
    motivation!: string | undefined;

    constructor(data?: IUpdateMonthlyRehabilitationProgramNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.motivation = _data["motivation"];
        }
    }

    static fromJS(data: any): UpdateMonthlyRehabilitationProgramNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMonthlyRehabilitationProgramNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["motivation"] = this.motivation;
        return data;
    }

    clone(): UpdateMonthlyRehabilitationProgramNoteDto {
        const json = this.toJSON();
        let result = new UpdateMonthlyRehabilitationProgramNoteDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateMonthlyRehabilitationProgramNoteDto {
    id: number;
    motivation: string | undefined;
}

export class UpdateMonthlyRehabilitationProgramRecordDto implements IUpdateMonthlyRehabilitationProgramRecordDto {
    id!: number;
    collaborationDegreeId!: number | undefined;

    constructor(data?: IUpdateMonthlyRehabilitationProgramRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.collaborationDegreeId = _data["collaborationDegreeId"];
        }
    }

    static fromJS(data: any): UpdateMonthlyRehabilitationProgramRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMonthlyRehabilitationProgramRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["collaborationDegreeId"] = this.collaborationDegreeId;
        return data;
    }

    clone(): UpdateMonthlyRehabilitationProgramRecordDto {
        const json = this.toJSON();
        let result = new UpdateMonthlyRehabilitationProgramRecordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateMonthlyRehabilitationProgramRecordDto {
    id: number;
    collaborationDegreeId: number | undefined;
}

export class UpdateMonthlyRehabilitationProgramTreatmentDto implements IUpdateMonthlyRehabilitationProgramTreatmentDto {
    id!: number;
    day!: number;
    treatmentTypeIds!: number[] | undefined;

    constructor(data?: IUpdateMonthlyRehabilitationProgramTreatmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.day = _data["day"];
            if (Array.isArray(_data["treatmentTypeIds"])) {
                this.treatmentTypeIds = [] as any;
                for (let item of _data["treatmentTypeIds"])
                    this.treatmentTypeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateMonthlyRehabilitationProgramTreatmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateMonthlyRehabilitationProgramTreatmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["day"] = this.day;
        if (Array.isArray(this.treatmentTypeIds)) {
            data["treatmentTypeIds"] = [];
            for (let item of this.treatmentTypeIds)
                data["treatmentTypeIds"].push(item);
        }
        return data;
    }

    clone(): UpdateMonthlyRehabilitationProgramTreatmentDto {
        const json = this.toJSON();
        let result = new UpdateMonthlyRehabilitationProgramTreatmentDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateMonthlyRehabilitationProgramTreatmentDto {
    id: number;
    day: number;
    treatmentTypeIds: number[] | undefined;
}

export class UpdateObjectiveDto implements IUpdateObjectiveDto {
    id!: number;
    integratedRehabilitationPlanRecordId!: number;
    scopeObservationGridId!: number;
    description!: string | undefined;
    objectiveTimeId!: number | undefined;
    strategy!: string | undefined;
    result!: CreateObjectiveResultDto;

    constructor(data?: IUpdateObjectiveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.integratedRehabilitationPlanRecordId = _data["integratedRehabilitationPlanRecordId"];
            this.scopeObservationGridId = _data["scopeObservationGridId"];
            this.description = _data["description"];
            this.objectiveTimeId = _data["objectiveTimeId"];
            this.strategy = _data["strategy"];
            this.result = _data["result"] ? CreateObjectiveResultDto.fromJS(_data["result"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateObjectiveDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateObjectiveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["integratedRehabilitationPlanRecordId"] = this.integratedRehabilitationPlanRecordId;
        data["scopeObservationGridId"] = this.scopeObservationGridId;
        data["description"] = this.description;
        data["objectiveTimeId"] = this.objectiveTimeId;
        data["strategy"] = this.strategy;
        data["result"] = this.result ? this.result.toJSON() : undefined as any;
        return data;
    }

    clone(): UpdateObjectiveDto {
        const json = this.toJSON();
        let result = new UpdateObjectiveDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateObjectiveDto {
    id: number;
    integratedRehabilitationPlanRecordId: number;
    scopeObservationGridId: number;
    description: string | undefined;
    objectiveTimeId: number | undefined;
    strategy: string | undefined;
    result: CreateObjectiveResultDto;
}

export class UpdateObjectiveResultDto implements IUpdateObjectiveResultDto {
    id!: number;
    objectiveId!: number | undefined;
    outcomeId!: number | undefined;
    dateTime!: moment.Moment | undefined;
    description!: string | undefined;

    constructor(data?: IUpdateObjectiveResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.objectiveId = _data["objectiveId"];
            this.outcomeId = _data["outcomeId"];
            this.dateTime = _data["dateTime"] ? moment(_data["dateTime"].toString()) : undefined as any;
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateObjectiveResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateObjectiveResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["objectiveId"] = this.objectiveId;
        data["outcomeId"] = this.outcomeId;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : undefined as any;
        data["description"] = this.description;
        return data;
    }

    clone(): UpdateObjectiveResultDto {
        const json = this.toJSON();
        let result = new UpdateObjectiveResultDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateObjectiveResultDto {
    id: number;
    objectiveId: number | undefined;
    outcomeId: number | undefined;
    dateTime: moment.Moment | undefined;
    description: string | undefined;
}

export class UpdateObjectivesRehabilitationRecordDto implements IUpdateObjectivesRehabilitationRecordDto {
    id!: number;
    date!: moment.Moment;
    shortTermObjectiveIds!: number[] | undefined;
    shortTermOther!: string | undefined;
    shortTermResultId!: number | undefined;
    longTermObjectiveIds!: number[] | undefined;
    longTermOther!: string | undefined;
    treatmentProgramIds!: number[] | undefined;
    treatmentProgramOther!: string | undefined;
    weeklyFrequencyId!: number | undefined;
    weeklyFrequencyOther!: string | undefined;
    tinetti!: CreateOrUpdateObjectivesRehabilitationTinettiDto;
    barthel!: CreateOrUpdateObjectivesRehabilitationBarthelDto;

    constructor(data?: IUpdateObjectivesRehabilitationRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            if (Array.isArray(_data["shortTermObjectiveIds"])) {
                this.shortTermObjectiveIds = [] as any;
                for (let item of _data["shortTermObjectiveIds"])
                    this.shortTermObjectiveIds!.push(item);
            }
            this.shortTermOther = _data["shortTermOther"];
            this.shortTermResultId = _data["shortTermResultId"];
            if (Array.isArray(_data["longTermObjectiveIds"])) {
                this.longTermObjectiveIds = [] as any;
                for (let item of _data["longTermObjectiveIds"])
                    this.longTermObjectiveIds!.push(item);
            }
            this.longTermOther = _data["longTermOther"];
            if (Array.isArray(_data["treatmentProgramIds"])) {
                this.treatmentProgramIds = [] as any;
                for (let item of _data["treatmentProgramIds"])
                    this.treatmentProgramIds!.push(item);
            }
            this.treatmentProgramOther = _data["treatmentProgramOther"];
            this.weeklyFrequencyId = _data["weeklyFrequencyId"];
            this.weeklyFrequencyOther = _data["weeklyFrequencyOther"];
            this.tinetti = _data["tinetti"] ? CreateOrUpdateObjectivesRehabilitationTinettiDto.fromJS(_data["tinetti"]) : undefined as any;
            this.barthel = _data["barthel"] ? CreateOrUpdateObjectivesRehabilitationBarthelDto.fromJS(_data["barthel"]) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateObjectivesRehabilitationRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateObjectivesRehabilitationRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        if (Array.isArray(this.shortTermObjectiveIds)) {
            data["shortTermObjectiveIds"] = [];
            for (let item of this.shortTermObjectiveIds)
                data["shortTermObjectiveIds"].push(item);
        }
        data["shortTermOther"] = this.shortTermOther;
        data["shortTermResultId"] = this.shortTermResultId;
        if (Array.isArray(this.longTermObjectiveIds)) {
            data["longTermObjectiveIds"] = [];
            for (let item of this.longTermObjectiveIds)
                data["longTermObjectiveIds"].push(item);
        }
        data["longTermOther"] = this.longTermOther;
        if (Array.isArray(this.treatmentProgramIds)) {
            data["treatmentProgramIds"] = [];
            for (let item of this.treatmentProgramIds)
                data["treatmentProgramIds"].push(item);
        }
        data["treatmentProgramOther"] = this.treatmentProgramOther;
        data["weeklyFrequencyId"] = this.weeklyFrequencyId;
        data["weeklyFrequencyOther"] = this.weeklyFrequencyOther;
        data["tinetti"] = this.tinetti ? this.tinetti.toJSON() : undefined as any;
        data["barthel"] = this.barthel ? this.barthel.toJSON() : undefined as any;
        return data;
    }

    clone(): UpdateObjectivesRehabilitationRecordDto {
        const json = this.toJSON();
        let result = new UpdateObjectivesRehabilitationRecordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateObjectivesRehabilitationRecordDto {
    id: number;
    date: moment.Moment;
    shortTermObjectiveIds: number[] | undefined;
    shortTermOther: string | undefined;
    shortTermResultId: number | undefined;
    longTermObjectiveIds: number[] | undefined;
    longTermOther: string | undefined;
    treatmentProgramIds: number[] | undefined;
    treatmentProgramOther: string | undefined;
    weeklyFrequencyId: number | undefined;
    weeklyFrequencyOther: string | undefined;
    tinetti: CreateOrUpdateObjectivesRehabilitationTinettiDto;
    barthel: CreateOrUpdateObjectivesRehabilitationBarthelDto;
}

export class UpdateObservationGrid implements IUpdateObservationGrid {
    id!: number;
    scopeObservationGridIds!: number[] | undefined;
    date!: moment.Moment | undefined;

    constructor(data?: IUpdateObservationGrid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["scopeObservationGridIds"])) {
                this.scopeObservationGridIds = [] as any;
                for (let item of _data["scopeObservationGridIds"])
                    this.scopeObservationGridIds!.push(item);
            }
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateObservationGrid {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateObservationGrid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.scopeObservationGridIds)) {
            data["scopeObservationGridIds"] = [];
            for (let item of this.scopeObservationGridIds)
                data["scopeObservationGridIds"].push(item);
        }
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        return data;
    }

    clone(): UpdateObservationGrid {
        const json = this.toJSON();
        let result = new UpdateObservationGrid();
        result.init(json);
        return result;
    }
}

export interface IUpdateObservationGrid {
    id: number;
    scopeObservationGridIds: number[] | undefined;
    date: moment.Moment | undefined;
}

export class UpdateOccupationDto implements IUpdateOccupationDto {
    id!: number;
    activityType!: string | undefined;
    location!: string | undefined;
    activityPeriod!: string | undefined;
    time!: string | undefined;
    note!: string | undefined;

    constructor(data?: IUpdateOccupationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.activityType = _data["activityType"];
            this.location = _data["location"];
            this.activityPeriod = _data["activityPeriod"];
            this.time = _data["time"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateOccupationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOccupationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["activityType"] = this.activityType;
        data["location"] = this.location;
        data["activityPeriod"] = this.activityPeriod;
        data["time"] = this.time;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateOccupationDto {
        const json = this.toJSON();
        let result = new UpdateOccupationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateOccupationDto {
    id: number;
    activityType: string | undefined;
    location: string | undefined;
    activityPeriod: string | undefined;
    time: string | undefined;
    note: string | undefined;
}

export class UpdateOrganizationDto implements IUpdateOrganizationDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IUpdateOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UpdateOrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): UpdateOrganizationDto {
        const json = this.toJSON();
        let result = new UpdateOrganizationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateOrganizationDto {
    id: number;
    name: string | undefined;
}

export class UpdateOtherReferenceDto implements IUpdateOtherReferenceDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    phoneNumber!: string | undefined;
    otherPhoneNumber!: string | undefined;
    emailAddress!: string | undefined;
    role!: string | undefined;
    address!: CreateAddressDto;
    note!: string | undefined;
    isActive!: boolean;

    constructor(data?: IUpdateOtherReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phoneNumber = _data["phoneNumber"];
            this.otherPhoneNumber = _data["otherPhoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.role = _data["role"];
            this.address = _data["address"] ? CreateAddressDto.fromJS(_data["address"]) : undefined as any;
            this.note = _data["note"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): UpdateOtherReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOtherReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phoneNumber"] = this.phoneNumber;
        data["otherPhoneNumber"] = this.otherPhoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["role"] = this.role;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["note"] = this.note;
        data["isActive"] = this.isActive;
        return data;
    }

    clone(): UpdateOtherReferenceDto {
        const json = this.toJSON();
        let result = new UpdateOtherReferenceDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateOtherReferenceDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    phoneNumber: string | undefined;
    otherPhoneNumber: string | undefined;
    emailAddress: string | undefined;
    role: string | undefined;
    address: CreateAddressDto;
    note: string | undefined;
    isActive: boolean;
}

export class UpdatePatient118RecordDto implements IUpdatePatient118RecordDto {
    id!: number;
    date!: moment.Moment;
    residence!: string | undefined;
    healthCardNumber!: string | undefined;
    caregiverName!: string | undefined;
    caregiverSurname!: string | undefined;
    caregiverNumber!: string | undefined;
    diagnosis!: string | undefined;
    therapy!: string | undefined;
    note!: string | undefined;

    constructor(data?: IUpdatePatient118RecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.residence = _data["residence"];
            this.healthCardNumber = _data["healthCardNumber"];
            this.caregiverName = _data["caregiverName"];
            this.caregiverSurname = _data["caregiverSurname"];
            this.caregiverNumber = _data["caregiverNumber"];
            this.diagnosis = _data["diagnosis"];
            this.therapy = _data["therapy"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdatePatient118RecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePatient118RecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["residence"] = this.residence;
        data["healthCardNumber"] = this.healthCardNumber;
        data["caregiverName"] = this.caregiverName;
        data["caregiverSurname"] = this.caregiverSurname;
        data["caregiverNumber"] = this.caregiverNumber;
        data["diagnosis"] = this.diagnosis;
        data["therapy"] = this.therapy;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdatePatient118RecordDto {
        const json = this.toJSON();
        let result = new UpdatePatient118RecordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePatient118RecordDto {
    id: number;
    date: moment.Moment;
    residence: string | undefined;
    healthCardNumber: string | undefined;
    caregiverName: string | undefined;
    caregiverSurname: string | undefined;
    caregiverNumber: string | undefined;
    diagnosis: string | undefined;
    therapy: string | undefined;
    note: string | undefined;
}

export class UpdatePersonalAutonomyDto implements IUpdatePersonalAutonomyDto {
    id!: number;
    walkingModeId!: number | undefined;
    walkingDescription!: string | undefined;
    eatingModeId!: number | undefined;
    eatingDescription!: string | undefined;
    personalHygieneModeId!: number | undefined;
    personalHygieneDescription!: string | undefined;
    note!: string | undefined;

    constructor(data?: IUpdatePersonalAutonomyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.walkingModeId = _data["walkingModeId"];
            this.walkingDescription = _data["walkingDescription"];
            this.eatingModeId = _data["eatingModeId"];
            this.eatingDescription = _data["eatingDescription"];
            this.personalHygieneModeId = _data["personalHygieneModeId"];
            this.personalHygieneDescription = _data["personalHygieneDescription"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdatePersonalAutonomyDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonalAutonomyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["walkingModeId"] = this.walkingModeId;
        data["walkingDescription"] = this.walkingDescription;
        data["eatingModeId"] = this.eatingModeId;
        data["eatingDescription"] = this.eatingDescription;
        data["personalHygieneModeId"] = this.personalHygieneModeId;
        data["personalHygieneDescription"] = this.personalHygieneDescription;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdatePersonalAutonomyDto {
        const json = this.toJSON();
        let result = new UpdatePersonalAutonomyDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePersonalAutonomyDto {
    id: number;
    walkingModeId: number | undefined;
    walkingDescription: string | undefined;
    eatingModeId: number | undefined;
    eatingDescription: string | undefined;
    personalHygieneModeId: number | undefined;
    personalHygieneDescription: string | undefined;
    note: string | undefined;
}

export class UpdatePersonalDataDto implements IUpdatePersonalDataDto {
    id!: number;
    residenceAddresses!: CreateAddressDto[] | undefined;
    domicileAddresses!: CreateAddressDto[] | undefined;
    constituency!: string | undefined;
    district!: string | undefined;
    phoneNumbers!: string[] | undefined;

    constructor(data?: IUpdatePersonalDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["residenceAddresses"])) {
                this.residenceAddresses = [] as any;
                for (let item of _data["residenceAddresses"])
                    this.residenceAddresses!.push(CreateAddressDto.fromJS(item));
            }
            if (Array.isArray(_data["domicileAddresses"])) {
                this.domicileAddresses = [] as any;
                for (let item of _data["domicileAddresses"])
                    this.domicileAddresses!.push(CreateAddressDto.fromJS(item));
            }
            this.constituency = _data["constituency"];
            this.district = _data["district"];
            if (Array.isArray(_data["phoneNumbers"])) {
                this.phoneNumbers = [] as any;
                for (let item of _data["phoneNumbers"])
                    this.phoneNumbers!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdatePersonalDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonalDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.residenceAddresses)) {
            data["residenceAddresses"] = [];
            for (let item of this.residenceAddresses)
                data["residenceAddresses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.domicileAddresses)) {
            data["domicileAddresses"] = [];
            for (let item of this.domicileAddresses)
                data["domicileAddresses"].push(item ? item.toJSON() : undefined as any);
        }
        data["constituency"] = this.constituency;
        data["district"] = this.district;
        if (Array.isArray(this.phoneNumbers)) {
            data["phoneNumbers"] = [];
            for (let item of this.phoneNumbers)
                data["phoneNumbers"].push(item);
        }
        return data;
    }

    clone(): UpdatePersonalDataDto {
        const json = this.toJSON();
        let result = new UpdatePersonalDataDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePersonalDataDto {
    id: number;
    residenceAddresses: CreateAddressDto[] | undefined;
    domicileAddresses: CreateAddressDto[] | undefined;
    constituency: string | undefined;
    district: string | undefined;
    phoneNumbers: string[] | undefined;
}

export class UpdatePersonalDataFamilyMemberDto implements IUpdatePersonalDataFamilyMemberDto {
    id!: number;
    kinshipDegreeId!: number | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    birthDate!: moment.Moment | undefined;
    cohabitation!: boolean | undefined;
    note!: string | undefined;
    profession!: string | undefined;

    constructor(data?: IUpdatePersonalDataFamilyMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kinshipDegreeId = _data["kinshipDegreeId"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : undefined as any;
            this.cohabitation = _data["cohabitation"];
            this.note = _data["note"];
            this.profession = _data["profession"];
        }
    }

    static fromJS(data: any): UpdatePersonalDataFamilyMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonalDataFamilyMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kinshipDegreeId"] = this.kinshipDegreeId;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined as any;
        data["cohabitation"] = this.cohabitation;
        data["note"] = this.note;
        data["profession"] = this.profession;
        return data;
    }

    clone(): UpdatePersonalDataFamilyMemberDto {
        const json = this.toJSON();
        let result = new UpdatePersonalDataFamilyMemberDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePersonalDataFamilyMemberDto {
    id: number;
    kinshipDegreeId: number | undefined;
    name: string | undefined;
    surname: string | undefined;
    birthDate: moment.Moment | undefined;
    cohabitation: boolean | undefined;
    note: string | undefined;
    profession: string | undefined;
}

export class UpdatePhotovoltaicSystemDto implements IUpdatePhotovoltaicSystemDto {
    id!: number;
    name!: string;
    project!: boolean;
    projectFileId!: number | undefined;
    plantConformityDeclaration!: boolean;
    plantConformityDeclarationFileId!: number | undefined;
    reportInailOrCiva!: boolean;
    notes!: string | undefined;

    constructor(data?: IUpdatePhotovoltaicSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.project = _data["project"];
            this.projectFileId = _data["projectFileId"];
            this.plantConformityDeclaration = _data["plantConformityDeclaration"];
            this.plantConformityDeclarationFileId = _data["plantConformityDeclarationFileId"];
            this.reportInailOrCiva = _data["reportInailOrCiva"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdatePhotovoltaicSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePhotovoltaicSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["project"] = this.project;
        data["projectFileId"] = this.projectFileId;
        data["plantConformityDeclaration"] = this.plantConformityDeclaration;
        data["plantConformityDeclarationFileId"] = this.plantConformityDeclarationFileId;
        data["reportInailOrCiva"] = this.reportInailOrCiva;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpdatePhotovoltaicSystemDto {
        const json = this.toJSON();
        let result = new UpdatePhotovoltaicSystemDto();
        result.init(json);
        return result;
    }
}

export interface IUpdatePhotovoltaicSystemDto {
    id: number;
    name: string;
    project: boolean;
    projectFileId: number | undefined;
    plantConformityDeclaration: boolean;
    plantConformityDeclarationFileId: number | undefined;
    reportInailOrCiva: boolean;
    notes: string | undefined;
}

export class UpdateProtectionMeasureDto implements IUpdateProtectionMeasureDto {
    id!: number;
    provisionTypeId!: number | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    note!: string | undefined;

    constructor(data?: IUpdateProtectionMeasureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.provisionTypeId = _data["provisionTypeId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateProtectionMeasureDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProtectionMeasureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["provisionTypeId"] = this.provisionTypeId;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.format('YYYY-MM-DD') : undefined as any;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateProtectionMeasureDto {
        const json = this.toJSON();
        let result = new UpdateProtectionMeasureDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateProtectionMeasureDto {
    id: number;
    provisionTypeId: number | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    note: string | undefined;
}

export class UpdateReconciliationPharmacologicalRecordDto implements IUpdateReconciliationPharmacologicalRecordDto {
    id!: number;
    date!: moment.Moment;
    room!: string | undefined;
    bed!: string | undefined;
    observation!: string | undefined;
    allergyOrIntolerance!: string | undefined;
    reconciliationInformationIds!: number[] | undefined;
    reconciliationInformationOther!: string | undefined;

    constructor(data?: IUpdateReconciliationPharmacologicalRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.room = _data["room"];
            this.bed = _data["bed"];
            this.observation = _data["observation"];
            this.allergyOrIntolerance = _data["allergyOrIntolerance"];
            if (Array.isArray(_data["reconciliationInformationIds"])) {
                this.reconciliationInformationIds = [] as any;
                for (let item of _data["reconciliationInformationIds"])
                    this.reconciliationInformationIds!.push(item);
            }
            this.reconciliationInformationOther = _data["reconciliationInformationOther"];
        }
    }

    static fromJS(data: any): UpdateReconciliationPharmacologicalRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReconciliationPharmacologicalRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["room"] = this.room;
        data["bed"] = this.bed;
        data["observation"] = this.observation;
        data["allergyOrIntolerance"] = this.allergyOrIntolerance;
        if (Array.isArray(this.reconciliationInformationIds)) {
            data["reconciliationInformationIds"] = [];
            for (let item of this.reconciliationInformationIds)
                data["reconciliationInformationIds"].push(item);
        }
        data["reconciliationInformationOther"] = this.reconciliationInformationOther;
        return data;
    }

    clone(): UpdateReconciliationPharmacologicalRecordDto {
        const json = this.toJSON();
        let result = new UpdateReconciliationPharmacologicalRecordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateReconciliationPharmacologicalRecordDto {
    id: number;
    date: moment.Moment;
    room: string | undefined;
    bed: string | undefined;
    observation: string | undefined;
    allergyOrIntolerance: string | undefined;
    reconciliationInformationIds: number[] | undefined;
    reconciliationInformationOther: string | undefined;
}

export class UpdateReconciliationPharmacologicalSomministrationRecognitionDto implements IUpdateReconciliationPharmacologicalSomministrationRecognitionDto {
    id!: number;
    drugName!: string | undefined;
    formAndDosage!: string | undefined;
    somministrationMethodId!: number | undefined;
    somministrationMethodOther!: string | undefined;
    dosageDaily!: string | undefined;
    startDate!: moment.Moment | undefined;
    duration!: string | undefined;
    dateTimeLastDose!: moment.Moment | undefined;
    isNewPrescription!: boolean | undefined;

    constructor(data?: IUpdateReconciliationPharmacologicalSomministrationRecognitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.drugName = _data["drugName"];
            this.formAndDosage = _data["formAndDosage"];
            this.somministrationMethodId = _data["somministrationMethodId"];
            this.somministrationMethodOther = _data["somministrationMethodOther"];
            this.dosageDaily = _data["dosageDaily"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.duration = _data["duration"];
            this.dateTimeLastDose = _data["dateTimeLastDose"] ? moment(_data["dateTimeLastDose"].toString()) : undefined as any;
            this.isNewPrescription = _data["isNewPrescription"];
        }
    }

    static fromJS(data: any): UpdateReconciliationPharmacologicalSomministrationRecognitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReconciliationPharmacologicalSomministrationRecognitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["drugName"] = this.drugName;
        data["formAndDosage"] = this.formAndDosage;
        data["somministrationMethodId"] = this.somministrationMethodId;
        data["somministrationMethodOther"] = this.somministrationMethodOther;
        data["dosageDaily"] = this.dosageDaily;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["duration"] = this.duration;
        data["dateTimeLastDose"] = this.dateTimeLastDose ? this.dateTimeLastDose.toISOString() : undefined as any;
        data["isNewPrescription"] = this.isNewPrescription;
        return data;
    }

    clone(): UpdateReconciliationPharmacologicalSomministrationRecognitionDto {
        const json = this.toJSON();
        let result = new UpdateReconciliationPharmacologicalSomministrationRecognitionDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateReconciliationPharmacologicalSomministrationRecognitionDto {
    id: number;
    drugName: string | undefined;
    formAndDosage: string | undefined;
    somministrationMethodId: number | undefined;
    somministrationMethodOther: string | undefined;
    dosageDaily: string | undefined;
    startDate: moment.Moment | undefined;
    duration: string | undefined;
    dateTimeLastDose: moment.Moment | undefined;
    isNewPrescription: boolean | undefined;
}

export class UpdateReconciliationPharmacologicalSomministrationReconciliationDto implements IUpdateReconciliationPharmacologicalSomministrationReconciliationDto {
    id!: number;
    continue!: boolean | undefined;
    interrupt!: boolean | undefined;
    modify!: boolean | undefined;
    getStarted!: boolean | undefined;
    motivation!: string | undefined;

    constructor(data?: IUpdateReconciliationPharmacologicalSomministrationReconciliationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.continue = _data["continue"];
            this.interrupt = _data["interrupt"];
            this.modify = _data["modify"];
            this.getStarted = _data["getStarted"];
            this.motivation = _data["motivation"];
        }
    }

    static fromJS(data: any): UpdateReconciliationPharmacologicalSomministrationReconciliationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateReconciliationPharmacologicalSomministrationReconciliationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["continue"] = this.continue;
        data["interrupt"] = this.interrupt;
        data["modify"] = this.modify;
        data["getStarted"] = this.getStarted;
        data["motivation"] = this.motivation;
        return data;
    }

    clone(): UpdateReconciliationPharmacologicalSomministrationReconciliationDto {
        const json = this.toJSON();
        let result = new UpdateReconciliationPharmacologicalSomministrationReconciliationDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateReconciliationPharmacologicalSomministrationReconciliationDto {
    id: number;
    continue: boolean | undefined;
    interrupt: boolean | undefined;
    modify: boolean | undefined;
    getStarted: boolean | undefined;
    motivation: string | undefined;
}

export class UpdateRecordDto implements IUpdateRecordDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;

    constructor(data?: IUpdateRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }

    clone(): UpdateRecordDto {
        const json = this.toJSON();
        let result = new UpdateRecordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateRecordDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
}

export class UpdateRehabilitationRecordDto implements IUpdateRehabilitationRecordDto {
    id!: number;
    date!: moment.Moment;
    diagnosis!: string | undefined;
    generalConditionId!: number | undefined;
    mentalStateId!: number | undefined;
    activityId!: number | undefined;
    mobilityId!: number | undefined;
    presenceSoresId!: number | undefined;
    note!: string | undefined;
    treatmentIds!: number[] | undefined;

    constructor(data?: IUpdateRehabilitationRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.diagnosis = _data["diagnosis"];
            this.generalConditionId = _data["generalConditionId"];
            this.mentalStateId = _data["mentalStateId"];
            this.activityId = _data["activityId"];
            this.mobilityId = _data["mobilityId"];
            this.presenceSoresId = _data["presenceSoresId"];
            this.note = _data["note"];
            if (Array.isArray(_data["treatmentIds"])) {
                this.treatmentIds = [] as any;
                for (let item of _data["treatmentIds"])
                    this.treatmentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateRehabilitationRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRehabilitationRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["diagnosis"] = this.diagnosis;
        data["generalConditionId"] = this.generalConditionId;
        data["mentalStateId"] = this.mentalStateId;
        data["activityId"] = this.activityId;
        data["mobilityId"] = this.mobilityId;
        data["presenceSoresId"] = this.presenceSoresId;
        data["note"] = this.note;
        if (Array.isArray(this.treatmentIds)) {
            data["treatmentIds"] = [];
            for (let item of this.treatmentIds)
                data["treatmentIds"].push(item);
        }
        return data;
    }

    clone(): UpdateRehabilitationRecordDto {
        const json = this.toJSON();
        let result = new UpdateRehabilitationRecordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateRehabilitationRecordDto {
    id: number;
    date: moment.Moment;
    diagnosis: string | undefined;
    generalConditionId: number | undefined;
    mentalStateId: number | undefined;
    activityId: number | undefined;
    mobilityId: number | undefined;
    presenceSoresId: number | undefined;
    note: string | undefined;
    treatmentIds: number[] | undefined;
}

export class UpdateRelativeDto implements IUpdateRelativeDto {
    id!: number;
    kinshipDegreeId!: number | undefined;
    nominative!: string | undefined;

    constructor(data?: IUpdateRelativeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kinshipDegreeId = _data["kinshipDegreeId"];
            this.nominative = _data["nominative"];
        }
    }

    static fromJS(data: any): UpdateRelativeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRelativeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kinshipDegreeId"] = this.kinshipDegreeId;
        data["nominative"] = this.nominative;
        return data;
    }

    clone(): UpdateRelativeDto {
        const json = this.toJSON();
        let result = new UpdateRelativeDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateRelativeDto {
    id: number;
    kinshipDegreeId: number | undefined;
    nominative: string | undefined;
}

export class UpdateResponseObservationGridDto implements IUpdateResponseObservationGridDto {
    id!: number;
    responseTypeId!: number | undefined;
    description!: string | undefined;
    measurementScaleId!: number | undefined;

    constructor(data?: IUpdateResponseObservationGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.responseTypeId = _data["responseTypeId"];
            this.description = _data["description"];
            this.measurementScaleId = _data["measurementScaleId"];
        }
    }

    static fromJS(data: any): UpdateResponseObservationGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateResponseObservationGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["responseTypeId"] = this.responseTypeId;
        data["description"] = this.description;
        data["measurementScaleId"] = this.measurementScaleId;
        return data;
    }

    clone(): UpdateResponseObservationGridDto {
        const json = this.toJSON();
        let result = new UpdateResponseObservationGridDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateResponseObservationGridDto {
    id: number;
    responseTypeId: number | undefined;
    description: string | undefined;
    measurementScaleId: number | undefined;
}

export class UpdateRoomDto implements IUpdateRoomDto {
    id!: number;
    name!: string;
    availableBeds!: number;

    constructor(data?: IUpdateRoomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.availableBeds = _data["availableBeds"];
        }
    }

    static fromJS(data: any): UpdateRoomDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["availableBeds"] = this.availableBeds;
        return data;
    }

    clone(): UpdateRoomDto {
        const json = this.toJSON();
        let result = new UpdateRoomDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateRoomDto {
    id: number;
    name: string;
    availableBeds: number;
}

export class UpdateSchoolWorkDto implements IUpdateSchoolWorkDto {
    id!: number;
    levelFieldOfStudy!: string | undefined;
    institution!: string | undefined;
    completionYear!: string | undefined;

    constructor(data?: IUpdateSchoolWorkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.levelFieldOfStudy = _data["levelFieldOfStudy"];
            this.institution = _data["institution"];
            this.completionYear = _data["completionYear"];
        }
    }

    static fromJS(data: any): UpdateSchoolWorkDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSchoolWorkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["levelFieldOfStudy"] = this.levelFieldOfStudy;
        data["institution"] = this.institution;
        data["completionYear"] = this.completionYear;
        return data;
    }

    clone(): UpdateSchoolWorkDto {
        const json = this.toJSON();
        let result = new UpdateSchoolWorkDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSchoolWorkDto {
    id: number;
    levelFieldOfStudy: string | undefined;
    institution: string | undefined;
    completionYear: string | undefined;
}

export class UpdateScopeObservationGridDto implements IUpdateScopeObservationGridDto {
    id!: number;
    description!: string | undefined;
    categoryObservationGridId!: number | undefined;

    constructor(data?: IUpdateScopeObservationGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.categoryObservationGridId = _data["categoryObservationGridId"];
        }
    }

    static fromJS(data: any): UpdateScopeObservationGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScopeObservationGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["categoryObservationGridId"] = this.categoryObservationGridId;
        return data;
    }

    clone(): UpdateScopeObservationGridDto {
        const json = this.toJSON();
        let result = new UpdateScopeObservationGridDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateScopeObservationGridDto {
    id: number;
    description: string | undefined;
    categoryObservationGridId: number | undefined;
}

export class UpdateSectionObservationGridDto implements IUpdateSectionObservationGridDto {
    id!: number;
    name!: string | undefined;
    dataSetObservationGridId!: number | undefined;

    constructor(data?: IUpdateSectionObservationGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dataSetObservationGridId = _data["dataSetObservationGridId"];
        }
    }

    static fromJS(data: any): UpdateSectionObservationGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSectionObservationGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dataSetObservationGridId"] = this.dataSetObservationGridId;
        return data;
    }

    clone(): UpdateSectionObservationGridDto {
        const json = this.toJSON();
        let result = new UpdateSectionObservationGridDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSectionObservationGridDto {
    id: number;
    name: string | undefined;
    dataSetObservationGridId: number | undefined;
}

export class UpdateServiceAttendanceRegisterDto implements IUpdateServiceAttendanceRegisterDto {
    id!: number;
    isPresent!: boolean | undefined;
    employmentPeriods!: CreateEmploymentPeriodDto[] | undefined;

    constructor(data?: IUpdateServiceAttendanceRegisterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isPresent = _data["isPresent"];
            if (Array.isArray(_data["employmentPeriods"])) {
                this.employmentPeriods = [] as any;
                for (let item of _data["employmentPeriods"])
                    this.employmentPeriods!.push(CreateEmploymentPeriodDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateServiceAttendanceRegisterDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceAttendanceRegisterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isPresent"] = this.isPresent;
        if (Array.isArray(this.employmentPeriods)) {
            data["employmentPeriods"] = [];
            for (let item of this.employmentPeriods)
                data["employmentPeriods"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UpdateServiceAttendanceRegisterDto {
        const json = this.toJSON();
        let result = new UpdateServiceAttendanceRegisterDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceAttendanceRegisterDto {
    id: number;
    isPresent: boolean | undefined;
    employmentPeriods: CreateEmploymentPeriodDto[] | undefined;
}

export class UpdateServiceCheckRefrigeratorTemperatureDetailDto implements IUpdateServiceCheckRefrigeratorTemperatureDetailDto {
    id!: number;
    day!: number;
    temperature!: number | undefined;

    constructor(data?: IUpdateServiceCheckRefrigeratorTemperatureDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.day = _data["day"];
            this.temperature = _data["temperature"];
        }
    }

    static fromJS(data: any): UpdateServiceCheckRefrigeratorTemperatureDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceCheckRefrigeratorTemperatureDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["day"] = this.day;
        data["temperature"] = this.temperature;
        return data;
    }

    clone(): UpdateServiceCheckRefrigeratorTemperatureDetailDto {
        const json = this.toJSON();
        let result = new UpdateServiceCheckRefrigeratorTemperatureDetailDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceCheckRefrigeratorTemperatureDetailDto {
    id: number;
    day: number;
    temperature: number | undefined;
}

export class UpdateServiceCheckRefrigeratorTemperatureDto implements IUpdateServiceCheckRefrigeratorTemperatureDto {
    id!: number;
    month!: number;
    year!: number;

    constructor(data?: IUpdateServiceCheckRefrigeratorTemperatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.month = _data["month"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): UpdateServiceCheckRefrigeratorTemperatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceCheckRefrigeratorTemperatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["month"] = this.month;
        data["year"] = this.year;
        return data;
    }

    clone(): UpdateServiceCheckRefrigeratorTemperatureDto {
        const json = this.toJSON();
        let result = new UpdateServiceCheckRefrigeratorTemperatureDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceCheckRefrigeratorTemperatureDto {
    id: number;
    month: number;
    year: number;
}

export class UpdateServiceDataCollectionDto implements IUpdateServiceDataCollectionDto {
    id!: number;
    date!: moment.Moment;
    laboratoryId!: number;
    objectiveIds!: number[] | undefined;

    constructor(data?: IUpdateServiceDataCollectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.laboratoryId = _data["laboratoryId"];
            if (Array.isArray(_data["objectiveIds"])) {
                this.objectiveIds = [] as any;
                for (let item of _data["objectiveIds"])
                    this.objectiveIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateServiceDataCollectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceDataCollectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["laboratoryId"] = this.laboratoryId;
        if (Array.isArray(this.objectiveIds)) {
            data["objectiveIds"] = [];
            for (let item of this.objectiveIds)
                data["objectiveIds"].push(item);
        }
        return data;
    }

    clone(): UpdateServiceDataCollectionDto {
        const json = this.toJSON();
        let result = new UpdateServiceDataCollectionDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceDataCollectionDto {
    id: number;
    date: moment.Moment;
    laboratoryId: number;
    objectiveIds: number[] | undefined;
}

export class UpdateServiceDataCollectionObjectiveDto implements IUpdateServiceDataCollectionObjectiveDto {
    id!: number;
    serviceDataCollectionResultId!: number | undefined;

    constructor(data?: IUpdateServiceDataCollectionObjectiveDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceDataCollectionResultId = _data["serviceDataCollectionResultId"];
        }
    }

    static fromJS(data: any): UpdateServiceDataCollectionObjectiveDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceDataCollectionObjectiveDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceDataCollectionResultId"] = this.serviceDataCollectionResultId;
        return data;
    }

    clone(): UpdateServiceDataCollectionObjectiveDto {
        const json = this.toJSON();
        let result = new UpdateServiceDataCollectionObjectiveDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceDataCollectionObjectiveDto {
    id: number;
    serviceDataCollectionResultId: number | undefined;
}

export class UpdateServiceDto implements IUpdateServiceDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;
    managerName!: string | undefined;
    managerPhoneNumber!: string | undefined;
    sectorIds!: number[] | undefined;
    totalSeats!: number | undefined;
    address!: CreateAddressDto;
    landline!: string | undefined;

    constructor(data?: IUpdateServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.managerName = _data["managerName"];
            this.managerPhoneNumber = _data["managerPhoneNumber"];
            if (Array.isArray(_data["sectorIds"])) {
                this.sectorIds = [] as any;
                for (let item of _data["sectorIds"])
                    this.sectorIds!.push(item);
            }
            this.totalSeats = _data["totalSeats"];
            this.address = _data["address"] ? CreateAddressDto.fromJS(_data["address"]) : undefined as any;
            this.landline = _data["landline"];
        }
    }

    static fromJS(data: any): UpdateServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["managerName"] = this.managerName;
        data["managerPhoneNumber"] = this.managerPhoneNumber;
        if (Array.isArray(this.sectorIds)) {
            data["sectorIds"] = [];
            for (let item of this.sectorIds)
                data["sectorIds"].push(item);
        }
        data["totalSeats"] = this.totalSeats;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["landline"] = this.landline;
        return data;
    }

    clone(): UpdateServiceDto {
        const json = this.toJSON();
        let result = new UpdateServiceDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    managerName: string | undefined;
    managerPhoneNumber: string | undefined;
    sectorIds: number[] | undefined;
    totalSeats: number | undefined;
    address: CreateAddressDto;
    landline: string | undefined;
}

export class UpdateServiceLogDto implements IUpdateServiceLogDto {
    id!: number;
    serviceUserIds!: number[] | undefined;
    serviceId!: number | undefined;
    title!: string | undefined;
    description!: string | undefined;
    hasDifferentReferenceDate!: boolean;
    referenceDate!: moment.Moment | undefined;
    tagIds!: number[] | undefined;
    subTagIds!: number[] | undefined;

    constructor(data?: IUpdateServiceLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["serviceUserIds"])) {
                this.serviceUserIds = [] as any;
                for (let item of _data["serviceUserIds"])
                    this.serviceUserIds!.push(item);
            }
            this.serviceId = _data["serviceId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.hasDifferentReferenceDate = _data["hasDifferentReferenceDate"];
            this.referenceDate = _data["referenceDate"] ? moment(_data["referenceDate"].toString()) : undefined as any;
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            if (Array.isArray(_data["subTagIds"])) {
                this.subTagIds = [] as any;
                for (let item of _data["subTagIds"])
                    this.subTagIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateServiceLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.serviceUserIds)) {
            data["serviceUserIds"] = [];
            for (let item of this.serviceUserIds)
                data["serviceUserIds"].push(item);
        }
        data["serviceId"] = this.serviceId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["hasDifferentReferenceDate"] = this.hasDifferentReferenceDate;
        data["referenceDate"] = this.referenceDate ? this.referenceDate.toISOString() : undefined as any;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        if (Array.isArray(this.subTagIds)) {
            data["subTagIds"] = [];
            for (let item of this.subTagIds)
                data["subTagIds"].push(item);
        }
        return data;
    }

    clone(): UpdateServiceLogDto {
        const json = this.toJSON();
        let result = new UpdateServiceLogDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceLogDto {
    id: number;
    serviceUserIds: number[] | undefined;
    serviceId: number | undefined;
    title: string | undefined;
    description: string | undefined;
    hasDifferentReferenceDate: boolean;
    referenceDate: moment.Moment | undefined;
    tagIds: number[] | undefined;
    subTagIds: number[] | undefined;
}

export class UpdateServiceLogServiceTaskDto implements IUpdateServiceLogServiceTaskDto {
    id!: number;
    isCompleted!: boolean;

    constructor(data?: IUpdateServiceLogServiceTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isCompleted = _data["isCompleted"];
        }
    }

    static fromJS(data: any): UpdateServiceLogServiceTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceLogServiceTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isCompleted"] = this.isCompleted;
        return data;
    }

    clone(): UpdateServiceLogServiceTaskDto {
        const json = this.toJSON();
        let result = new UpdateServiceLogServiceTaskDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceLogServiceTaskDto {
    id: number;
    isCompleted: boolean;
}

export class UpdateServiceModRUDDto implements IUpdateServiceModRUDDto {
    id!: number;
    municipalityResidence!: string | undefined;
    frequency!: string | undefined;
    hour!: string | undefined;
    weeklyAccess!: string | undefined;
    authorization!: string | undefined;
    voucher!: boolean | undefined;
    expiryVoucher!: moment.Moment | undefined;
    transport!: boolean | undefined;
    canteen!: boolean | undefined;
    entryDate!: moment.Moment | undefined;
    expiryPAI!: moment.Moment | undefined;
    familyContact!: string | undefined;

    constructor(data?: IUpdateServiceModRUDDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.municipalityResidence = _data["municipalityResidence"];
            this.frequency = _data["frequency"];
            this.hour = _data["hour"];
            this.weeklyAccess = _data["weeklyAccess"];
            this.authorization = _data["authorization"];
            this.voucher = _data["voucher"];
            this.expiryVoucher = _data["expiryVoucher"] ? moment(_data["expiryVoucher"].toString()) : undefined as any;
            this.transport = _data["transport"];
            this.canteen = _data["canteen"];
            this.entryDate = _data["entryDate"] ? moment(_data["entryDate"].toString()) : undefined as any;
            this.expiryPAI = _data["expiryPAI"] ? moment(_data["expiryPAI"].toString()) : undefined as any;
            this.familyContact = _data["familyContact"];
        }
    }

    static fromJS(data: any): UpdateServiceModRUDDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceModRUDDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["municipalityResidence"] = this.municipalityResidence;
        data["frequency"] = this.frequency;
        data["hour"] = this.hour;
        data["weeklyAccess"] = this.weeklyAccess;
        data["authorization"] = this.authorization;
        data["voucher"] = this.voucher;
        data["expiryVoucher"] = this.expiryVoucher ? this.expiryVoucher.toISOString() : undefined as any;
        data["transport"] = this.transport;
        data["canteen"] = this.canteen;
        data["entryDate"] = this.entryDate ? this.entryDate.toISOString() : undefined as any;
        data["expiryPAI"] = this.expiryPAI ? this.expiryPAI.toISOString() : undefined as any;
        data["familyContact"] = this.familyContact;
        return data;
    }

    clone(): UpdateServiceModRUDDto {
        const json = this.toJSON();
        let result = new UpdateServiceModRUDDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceModRUDDto {
    id: number;
    municipalityResidence: string | undefined;
    frequency: string | undefined;
    hour: string | undefined;
    weeklyAccess: string | undefined;
    authorization: string | undefined;
    voucher: boolean | undefined;
    expiryVoucher: moment.Moment | undefined;
    transport: boolean | undefined;
    canteen: boolean | undefined;
    entryDate: moment.Moment | undefined;
    expiryPAI: moment.Moment | undefined;
    familyContact: string | undefined;
}

export class UpdateServiceReportDto implements IUpdateServiceReportDto {
    serviceId!: number;
    beneficiaryId!: number;
    operatorId!: number;
    objectives!: ServiceReportObjectiveInputDto[] | undefined;
    school!: string | undefined;
    schoolAddress!: CreateAddressDto;
    protocolNumber!: string | undefined;
    place!: string | undefined;
    date!: moment.Moment | undefined;
    subject!: string | undefined;
    projectReferent!: string | undefined;
    serviceManager!: string | undefined;
    schoolYear!: string | undefined;
    projectStartDate!: moment.Moment | undefined;
    weeklyHours!: string | undefined;
    projectLocation!: string | undefined;
    supportTeachers!: string | undefined;
    interventionsDescription!: string | undefined;
    issues!: string | undefined;
    nextYearObjectives!: string | undefined;
    id!: number;

    constructor(data?: IUpdateServiceReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceId = _data["serviceId"];
            this.beneficiaryId = _data["beneficiaryId"];
            this.operatorId = _data["operatorId"];
            if (Array.isArray(_data["objectives"])) {
                this.objectives = [] as any;
                for (let item of _data["objectives"])
                    this.objectives!.push(ServiceReportObjectiveInputDto.fromJS(item));
            }
            this.school = _data["school"];
            this.schoolAddress = _data["schoolAddress"] ? CreateAddressDto.fromJS(_data["schoolAddress"]) : undefined as any;
            this.protocolNumber = _data["protocolNumber"];
            this.place = _data["place"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.subject = _data["subject"];
            this.projectReferent = _data["projectReferent"];
            this.serviceManager = _data["serviceManager"];
            this.schoolYear = _data["schoolYear"];
            this.projectStartDate = _data["projectStartDate"] ? moment(_data["projectStartDate"].toString()) : undefined as any;
            this.weeklyHours = _data["weeklyHours"];
            this.projectLocation = _data["projectLocation"];
            this.supportTeachers = _data["supportTeachers"];
            this.interventionsDescription = _data["interventionsDescription"];
            this.issues = _data["issues"];
            this.nextYearObjectives = _data["nextYearObjectives"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateServiceReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceId"] = this.serviceId;
        data["beneficiaryId"] = this.beneficiaryId;
        data["operatorId"] = this.operatorId;
        if (Array.isArray(this.objectives)) {
            data["objectives"] = [];
            for (let item of this.objectives)
                data["objectives"].push(item ? item.toJSON() : undefined as any);
        }
        data["school"] = this.school;
        data["schoolAddress"] = this.schoolAddress ? this.schoolAddress.toJSON() : undefined as any;
        data["protocolNumber"] = this.protocolNumber;
        data["place"] = this.place;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["subject"] = this.subject;
        data["projectReferent"] = this.projectReferent;
        data["serviceManager"] = this.serviceManager;
        data["schoolYear"] = this.schoolYear;
        data["projectStartDate"] = this.projectStartDate ? this.projectStartDate.toISOString() : undefined as any;
        data["weeklyHours"] = this.weeklyHours;
        data["projectLocation"] = this.projectLocation;
        data["supportTeachers"] = this.supportTeachers;
        data["interventionsDescription"] = this.interventionsDescription;
        data["issues"] = this.issues;
        data["nextYearObjectives"] = this.nextYearObjectives;
        data["id"] = this.id;
        return data;
    }

    clone(): UpdateServiceReportDto {
        const json = this.toJSON();
        let result = new UpdateServiceReportDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceReportDto {
    serviceId: number;
    beneficiaryId: number;
    operatorId: number;
    objectives: ServiceReportObjectiveInputDto[] | undefined;
    school: string | undefined;
    schoolAddress: CreateAddressDto;
    protocolNumber: string | undefined;
    place: string | undefined;
    date: moment.Moment | undefined;
    subject: string | undefined;
    projectReferent: string | undefined;
    serviceManager: string | undefined;
    schoolYear: string | undefined;
    projectStartDate: moment.Moment | undefined;
    weeklyHours: string | undefined;
    projectLocation: string | undefined;
    supportTeachers: string | undefined;
    interventionsDescription: string | undefined;
    issues: string | undefined;
    nextYearObjectives: string | undefined;
    id: number;
}

export class UpdateServiceSemiAnnualHealthDocumentationReviewDto implements IUpdateServiceSemiAnnualHealthDocumentationReviewDto {
    id!: number;
    date!: moment.Moment | undefined;
    annotation!: string | undefined;

    constructor(data?: IUpdateServiceSemiAnnualHealthDocumentationReviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.annotation = _data["annotation"];
        }
    }

    static fromJS(data: any): UpdateServiceSemiAnnualHealthDocumentationReviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceSemiAnnualHealthDocumentationReviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["annotation"] = this.annotation;
        return data;
    }

    clone(): UpdateServiceSemiAnnualHealthDocumentationReviewDto {
        const json = this.toJSON();
        let result = new UpdateServiceSemiAnnualHealthDocumentationReviewDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceSemiAnnualHealthDocumentationReviewDto {
    id: number;
    date: moment.Moment | undefined;
    annotation: string | undefined;
}

export class UpdateServiceTemplateDto implements IUpdateServiceTemplateDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;
    widgetIds!: number[] | undefined;

    constructor(data?: IUpdateServiceTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["widgetIds"])) {
                this.widgetIds = [] as any;
                for (let item of _data["widgetIds"])
                    this.widgetIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateServiceTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.widgetIds)) {
            data["widgetIds"] = [];
            for (let item of this.widgetIds)
                data["widgetIds"].push(item);
        }
        return data;
    }

    clone(): UpdateServiceTemplateDto {
        const json = this.toJSON();
        let result = new UpdateServiceTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceTemplateDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    widgetIds: number[] | undefined;
}

export class UpdateServiceUserAvailabilityDto implements IUpdateServiceUserAvailabilityDto {
    id!: number;
    startDate!: moment.Moment;
    endDate!: moment.Moment | undefined;

    constructor(data?: IUpdateServiceUserAvailabilityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateServiceUserAvailabilityDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceUserAvailabilityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        return data;
    }

    clone(): UpdateServiceUserAvailabilityDto {
        const json = this.toJSON();
        let result = new UpdateServiceUserAvailabilityDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceUserAvailabilityDto {
    id: number;
    startDate: moment.Moment;
    endDate: moment.Moment | undefined;
}

export class UpdateServiceUserDto implements IUpdateServiceUserDto {
    id!: number;
    isOperator!: boolean;
    qualificationId!: number | undefined;

    constructor(data?: IUpdateServiceUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isOperator = _data["isOperator"];
            this.qualificationId = _data["qualificationId"];
        }
    }

    static fromJS(data: any): UpdateServiceUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isOperator"] = this.isOperator;
        data["qualificationId"] = this.qualificationId;
        return data;
    }

    clone(): UpdateServiceUserDto {
        const json = this.toJSON();
        let result = new UpdateServiceUserDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceUserDto {
    id: number;
    isOperator: boolean;
    qualificationId: number | undefined;
}

export class UpdateServiceVerbalDto implements IUpdateServiceVerbalDto {
    id!: number;
    serviceUserIds!: number[] | undefined;
    serviceId!: number | undefined;
    externalPeople!: string | undefined;
    date!: moment.Moment | undefined;
    isConfirmed!: boolean;
    dayOrder!: string | undefined;

    constructor(data?: IUpdateServiceVerbalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["serviceUserIds"])) {
                this.serviceUserIds = [] as any;
                for (let item of _data["serviceUserIds"])
                    this.serviceUserIds!.push(item);
            }
            this.serviceId = _data["serviceId"];
            this.externalPeople = _data["externalPeople"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.isConfirmed = _data["isConfirmed"];
            this.dayOrder = _data["dayOrder"];
        }
    }

    static fromJS(data: any): UpdateServiceVerbalDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceVerbalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.serviceUserIds)) {
            data["serviceUserIds"] = [];
            for (let item of this.serviceUserIds)
                data["serviceUserIds"].push(item);
        }
        data["serviceId"] = this.serviceId;
        data["externalPeople"] = this.externalPeople;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["isConfirmed"] = this.isConfirmed;
        data["dayOrder"] = this.dayOrder;
        return data;
    }

    clone(): UpdateServiceVerbalDto {
        const json = this.toJSON();
        let result = new UpdateServiceVerbalDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceVerbalDto {
    id: number;
    serviceUserIds: number[] | undefined;
    serviceId: number | undefined;
    externalPeople: string | undefined;
    date: moment.Moment | undefined;
    isConfirmed: boolean;
    dayOrder: string | undefined;
}

export class UpdateServiceWeeklyScheduleDto implements IUpdateServiceWeeklyScheduleDto {
    id!: number;
    dayOfWeekId!: number;
    employmentPeriods!: CreateEmploymentPeriodDto[] | undefined;

    constructor(data?: IUpdateServiceWeeklyScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dayOfWeekId = _data["dayOfWeekId"];
            if (Array.isArray(_data["employmentPeriods"])) {
                this.employmentPeriods = [] as any;
                for (let item of _data["employmentPeriods"])
                    this.employmentPeriods!.push(CreateEmploymentPeriodDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateServiceWeeklyScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceWeeklyScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dayOfWeekId"] = this.dayOfWeekId;
        if (Array.isArray(this.employmentPeriods)) {
            data["employmentPeriods"] = [];
            for (let item of this.employmentPeriods)
                data["employmentPeriods"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): UpdateServiceWeeklyScheduleDto {
        const json = this.toJSON();
        let result = new UpdateServiceWeeklyScheduleDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceWeeklyScheduleDto {
    id: number;
    dayOfWeekId: number;
    employmentPeriods: CreateEmploymentPeriodDto[] | undefined;
}

export class UpdateServiceWeightDetectionDto implements IUpdateServiceWeightDetectionDto {
    id!: number;
    structure!: string | undefined;
    year!: number;

    constructor(data?: IUpdateServiceWeightDetectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.structure = _data["structure"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): UpdateServiceWeightDetectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceWeightDetectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["structure"] = this.structure;
        data["year"] = this.year;
        return data;
    }

    clone(): UpdateServiceWeightDetectionDto {
        const json = this.toJSON();
        let result = new UpdateServiceWeightDetectionDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceWeightDetectionDto {
    id: number;
    structure: string | undefined;
    year: number;
}

export class UpdateServiceWidgetDto implements IUpdateServiceWidgetDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;

    constructor(data?: IUpdateServiceWidgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateServiceWidgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceWidgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }

    clone(): UpdateServiceWidgetDto {
        const json = this.toJSON();
        let result = new UpdateServiceWidgetDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateServiceWidgetDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
}

export class UpdateSocialAssistanceReferenceDto implements IUpdateSocialAssistanceReferenceDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    phoneNumber!: string | undefined;
    otherPhoneNumber!: string | undefined;
    emailAddress!: string | undefined;
    role!: string | undefined;
    address!: CreateAddressDto;
    note!: string | undefined;

    constructor(data?: IUpdateSocialAssistanceReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phoneNumber = _data["phoneNumber"];
            this.otherPhoneNumber = _data["otherPhoneNumber"];
            this.emailAddress = _data["emailAddress"];
            this.role = _data["role"];
            this.address = _data["address"] ? CreateAddressDto.fromJS(_data["address"]) : undefined as any;
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateSocialAssistanceReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSocialAssistanceReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phoneNumber"] = this.phoneNumber;
        data["otherPhoneNumber"] = this.otherPhoneNumber;
        data["emailAddress"] = this.emailAddress;
        data["role"] = this.role;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateSocialAssistanceReferenceDto {
        const json = this.toJSON();
        let result = new UpdateSocialAssistanceReferenceDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSocialAssistanceReferenceDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    phoneNumber: string | undefined;
    otherPhoneNumber: string | undefined;
    emailAddress: string | undefined;
    role: string | undefined;
    address: CreateAddressDto;
    note: string | undefined;
}

export class UpdateSocialHealthRecordDto implements IUpdateSocialHealthRecordDto {
    id!: number;
    date!: moment.Moment;
    code!: string | undefined;
    dischargeDate!: moment.Moment | undefined;
    dischargeDiagnosis!: string | undefined;
    customDataContent!: string | undefined;

    constructor(data?: IUpdateSocialHealthRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.code = _data["code"];
            this.dischargeDate = _data["dischargeDate"] ? moment(_data["dischargeDate"].toString()) : undefined as any;
            this.dischargeDiagnosis = _data["dischargeDiagnosis"];
            this.customDataContent = _data["customDataContent"];
        }
    }

    static fromJS(data: any): UpdateSocialHealthRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSocialHealthRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["code"] = this.code;
        data["dischargeDate"] = this.dischargeDate ? this.dischargeDate.format('YYYY-MM-DD') : undefined as any;
        data["dischargeDiagnosis"] = this.dischargeDiagnosis;
        data["customDataContent"] = this.customDataContent;
        return data;
    }

    clone(): UpdateSocialHealthRecordDto {
        const json = this.toJSON();
        let result = new UpdateSocialHealthRecordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSocialHealthRecordDto {
    id: number;
    date: moment.Moment;
    code: string | undefined;
    dischargeDate: moment.Moment | undefined;
    dischargeDiagnosis: string | undefined;
    customDataContent: string | undefined;
}

export class UpdateSocialHealthRecordExtensionDateDto implements IUpdateSocialHealthRecordExtensionDateDto {
    id!: number;
    date!: moment.Moment;
    reason!: string | undefined;

    constructor(data?: IUpdateSocialHealthRecordExtensionDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): UpdateSocialHealthRecordExtensionDateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSocialHealthRecordExtensionDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.format('YYYY-MM-DD') : undefined as any;
        data["reason"] = this.reason;
        return data;
    }

    clone(): UpdateSocialHealthRecordExtensionDateDto {
        const json = this.toJSON();
        let result = new UpdateSocialHealthRecordExtensionDateDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSocialHealthRecordExtensionDateDto {
    id: number;
    date: moment.Moment;
    reason: string | undefined;
}

export class UpdateSocialHealtRecordTemplateDto implements IUpdateSocialHealtRecordTemplateDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;
    widgetIds!: number[] | undefined;

    constructor(data?: IUpdateSocialHealtRecordTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["widgetIds"])) {
                this.widgetIds = [] as any;
                for (let item of _data["widgetIds"])
                    this.widgetIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateSocialHealtRecordTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSocialHealtRecordTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.widgetIds)) {
            data["widgetIds"] = [];
            for (let item of this.widgetIds)
                data["widgetIds"].push(item);
        }
        return data;
    }

    clone(): UpdateSocialHealtRecordTemplateDto {
        const json = this.toJSON();
        let result = new UpdateSocialHealtRecordTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSocialHealtRecordTemplateDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    widgetIds: number[] | undefined;
}

export class UpdateSocialInvestigationRecordDto implements IUpdateSocialInvestigationRecordDto {
    id!: number;
    briefUserHistory!: string | undefined;
    familyComponents!: CreateFamilyComponentDto[] | undefined;
    familySituationId!: number | undefined;
    familyNote!: string | undefined;
    familyMedicalHistory!: string | undefined;
    familyDynamics!: string | undefined;
    incomeAllowances!: CreateIncomeAllowanceDto[] | undefined;
    protectionMeasure!: CreateProtectionMeasureDto;
    housingSituation!: CreateHousingSituationDto;
    eductionalTraining!: CreateEducationalTrainingDto;
    freeTimeAutonomies!: string | undefined;
    characteristicsOrProblems!: string | undefined;

    constructor(data?: IUpdateSocialInvestigationRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.briefUserHistory = _data["briefUserHistory"];
            if (Array.isArray(_data["familyComponents"])) {
                this.familyComponents = [] as any;
                for (let item of _data["familyComponents"])
                    this.familyComponents!.push(CreateFamilyComponentDto.fromJS(item));
            }
            this.familySituationId = _data["familySituationId"];
            this.familyNote = _data["familyNote"];
            this.familyMedicalHistory = _data["familyMedicalHistory"];
            this.familyDynamics = _data["familyDynamics"];
            if (Array.isArray(_data["incomeAllowances"])) {
                this.incomeAllowances = [] as any;
                for (let item of _data["incomeAllowances"])
                    this.incomeAllowances!.push(CreateIncomeAllowanceDto.fromJS(item));
            }
            this.protectionMeasure = _data["protectionMeasure"] ? CreateProtectionMeasureDto.fromJS(_data["protectionMeasure"]) : undefined as any;
            this.housingSituation = _data["housingSituation"] ? CreateHousingSituationDto.fromJS(_data["housingSituation"]) : undefined as any;
            this.eductionalTraining = _data["eductionalTraining"] ? CreateEducationalTrainingDto.fromJS(_data["eductionalTraining"]) : undefined as any;
            this.freeTimeAutonomies = _data["freeTimeAutonomies"];
            this.characteristicsOrProblems = _data["characteristicsOrProblems"];
        }
    }

    static fromJS(data: any): UpdateSocialInvestigationRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSocialInvestigationRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["briefUserHistory"] = this.briefUserHistory;
        if (Array.isArray(this.familyComponents)) {
            data["familyComponents"] = [];
            for (let item of this.familyComponents)
                data["familyComponents"].push(item ? item.toJSON() : undefined as any);
        }
        data["familySituationId"] = this.familySituationId;
        data["familyNote"] = this.familyNote;
        data["familyMedicalHistory"] = this.familyMedicalHistory;
        data["familyDynamics"] = this.familyDynamics;
        if (Array.isArray(this.incomeAllowances)) {
            data["incomeAllowances"] = [];
            for (let item of this.incomeAllowances)
                data["incomeAllowances"].push(item ? item.toJSON() : undefined as any);
        }
        data["protectionMeasure"] = this.protectionMeasure ? this.protectionMeasure.toJSON() : undefined as any;
        data["housingSituation"] = this.housingSituation ? this.housingSituation.toJSON() : undefined as any;
        data["eductionalTraining"] = this.eductionalTraining ? this.eductionalTraining.toJSON() : undefined as any;
        data["freeTimeAutonomies"] = this.freeTimeAutonomies;
        data["characteristicsOrProblems"] = this.characteristicsOrProblems;
        return data;
    }

    clone(): UpdateSocialInvestigationRecordDto {
        const json = this.toJSON();
        let result = new UpdateSocialInvestigationRecordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSocialInvestigationRecordDto {
    id: number;
    briefUserHistory: string | undefined;
    familyComponents: CreateFamilyComponentDto[] | undefined;
    familySituationId: number | undefined;
    familyNote: string | undefined;
    familyMedicalHistory: string | undefined;
    familyDynamics: string | undefined;
    incomeAllowances: CreateIncomeAllowanceDto[] | undefined;
    protectionMeasure: CreateProtectionMeasureDto;
    housingSituation: CreateHousingSituationDto;
    eductionalTraining: CreateEducationalTrainingDto;
    freeTimeAutonomies: string | undefined;
    characteristicsOrProblems: string | undefined;
}

export class UpdateSpecialistAssessmentRecordDto implements IUpdateSpecialistAssessmentRecordDto {
    id!: number;
    date!: moment.Moment;
    diagnosis!: string | undefined;
    advice!: string | undefined;

    constructor(data?: IUpdateSpecialistAssessmentRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.diagnosis = _data["diagnosis"];
            this.advice = _data["advice"];
        }
    }

    static fromJS(data: any): UpdateSpecialistAssessmentRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSpecialistAssessmentRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["diagnosis"] = this.diagnosis;
        data["advice"] = this.advice;
        return data;
    }

    clone(): UpdateSpecialistAssessmentRecordDto {
        const json = this.toJSON();
        let result = new UpdateSpecialistAssessmentRecordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSpecialistAssessmentRecordDto {
    id: number;
    date: moment.Moment;
    diagnosis: string | undefined;
    advice: string | undefined;
}

export class UpdateSpontaneousReportingEventDto implements IUpdateSpontaneousReportingEventDto {
    id!: number;
    structure!: string | undefined;
    operationalUnit!: string | undefined;
    equipeId!: number | undefined;
    titleId!: number | undefined;
    otherTitle!: string | undefined;
    hospitalizationNumber!: string | undefined;
    performanceTypeId!: number | undefined;
    otherPerformanceType!: string | undefined;
    procedureDelayId!: number | undefined;
    inappropriateTypeId!: number | undefined;
    missedProcedureTypeId!: number | undefined;
    otherEventTypeId!: number | undefined;
    otherOtherEventType!: string | undefined;
    dateTime!: moment.Moment;
    place!: string;
    isWeekday!: boolean | undefined;
    description!: string | undefined;
    patientFactorIds!: number[] | undefined;
    staffFactorsìIds!: number[] | undefined;
    systemFactorIds!: number[] | undefined;
    otherSystemFactor!: string | undefined;
    outcomeReductionFactorIds!: number[] | undefined;
    otherOutcomeReductionFactor!: string | undefined;
    additionalInvestigationIds!: number[] | undefined;
    otherAdditionalInvestigation!: string | undefined;
    isDocumented!: boolean | undefined;
    isPatientInformed!: boolean | undefined;
    preventedOrAvoidedEvent!: string | undefined;
    eventSeverityLevelId!: number | undefined;

    constructor(data?: IUpdateSpontaneousReportingEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.structure = _data["structure"];
            this.operationalUnit = _data["operationalUnit"];
            this.equipeId = _data["equipeId"];
            this.titleId = _data["titleId"];
            this.otherTitle = _data["otherTitle"];
            this.hospitalizationNumber = _data["hospitalizationNumber"];
            this.performanceTypeId = _data["performanceTypeId"];
            this.otherPerformanceType = _data["otherPerformanceType"];
            this.procedureDelayId = _data["procedureDelayId"];
            this.inappropriateTypeId = _data["inappropriateTypeId"];
            this.missedProcedureTypeId = _data["missedProcedureTypeId"];
            this.otherEventTypeId = _data["otherEventTypeId"];
            this.otherOtherEventType = _data["otherOtherEventType"];
            this.dateTime = _data["dateTime"] ? moment(_data["dateTime"].toString()) : undefined as any;
            this.place = _data["place"];
            this.isWeekday = _data["isWeekday"];
            this.description = _data["description"];
            if (Array.isArray(_data["patientFactorIds"])) {
                this.patientFactorIds = [] as any;
                for (let item of _data["patientFactorIds"])
                    this.patientFactorIds!.push(item);
            }
            if (Array.isArray(_data["staffFactorsìIds"])) {
                this.staffFactorsìIds = [] as any;
                for (let item of _data["staffFactorsìIds"])
                    this.staffFactorsìIds!.push(item);
            }
            if (Array.isArray(_data["systemFactorIds"])) {
                this.systemFactorIds = [] as any;
                for (let item of _data["systemFactorIds"])
                    this.systemFactorIds!.push(item);
            }
            this.otherSystemFactor = _data["otherSystemFactor"];
            if (Array.isArray(_data["outcomeReductionFactorIds"])) {
                this.outcomeReductionFactorIds = [] as any;
                for (let item of _data["outcomeReductionFactorIds"])
                    this.outcomeReductionFactorIds!.push(item);
            }
            this.otherOutcomeReductionFactor = _data["otherOutcomeReductionFactor"];
            if (Array.isArray(_data["additionalInvestigationIds"])) {
                this.additionalInvestigationIds = [] as any;
                for (let item of _data["additionalInvestigationIds"])
                    this.additionalInvestigationIds!.push(item);
            }
            this.otherAdditionalInvestigation = _data["otherAdditionalInvestigation"];
            this.isDocumented = _data["isDocumented"];
            this.isPatientInformed = _data["isPatientInformed"];
            this.preventedOrAvoidedEvent = _data["preventedOrAvoidedEvent"];
            this.eventSeverityLevelId = _data["eventSeverityLevelId"];
        }
    }

    static fromJS(data: any): UpdateSpontaneousReportingEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSpontaneousReportingEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["structure"] = this.structure;
        data["operationalUnit"] = this.operationalUnit;
        data["equipeId"] = this.equipeId;
        data["titleId"] = this.titleId;
        data["otherTitle"] = this.otherTitle;
        data["hospitalizationNumber"] = this.hospitalizationNumber;
        data["performanceTypeId"] = this.performanceTypeId;
        data["otherPerformanceType"] = this.otherPerformanceType;
        data["procedureDelayId"] = this.procedureDelayId;
        data["inappropriateTypeId"] = this.inappropriateTypeId;
        data["missedProcedureTypeId"] = this.missedProcedureTypeId;
        data["otherEventTypeId"] = this.otherEventTypeId;
        data["otherOtherEventType"] = this.otherOtherEventType;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : undefined as any;
        data["place"] = this.place;
        data["isWeekday"] = this.isWeekday;
        data["description"] = this.description;
        if (Array.isArray(this.patientFactorIds)) {
            data["patientFactorIds"] = [];
            for (let item of this.patientFactorIds)
                data["patientFactorIds"].push(item);
        }
        if (Array.isArray(this.staffFactorsìIds)) {
            data["staffFactorsìIds"] = [];
            for (let item of this.staffFactorsìIds)
                data["staffFactorsìIds"].push(item);
        }
        if (Array.isArray(this.systemFactorIds)) {
            data["systemFactorIds"] = [];
            for (let item of this.systemFactorIds)
                data["systemFactorIds"].push(item);
        }
        data["otherSystemFactor"] = this.otherSystemFactor;
        if (Array.isArray(this.outcomeReductionFactorIds)) {
            data["outcomeReductionFactorIds"] = [];
            for (let item of this.outcomeReductionFactorIds)
                data["outcomeReductionFactorIds"].push(item);
        }
        data["otherOutcomeReductionFactor"] = this.otherOutcomeReductionFactor;
        if (Array.isArray(this.additionalInvestigationIds)) {
            data["additionalInvestigationIds"] = [];
            for (let item of this.additionalInvestigationIds)
                data["additionalInvestigationIds"].push(item);
        }
        data["otherAdditionalInvestigation"] = this.otherAdditionalInvestigation;
        data["isDocumented"] = this.isDocumented;
        data["isPatientInformed"] = this.isPatientInformed;
        data["preventedOrAvoidedEvent"] = this.preventedOrAvoidedEvent;
        data["eventSeverityLevelId"] = this.eventSeverityLevelId;
        return data;
    }

    clone(): UpdateSpontaneousReportingEventDto {
        const json = this.toJSON();
        let result = new UpdateSpontaneousReportingEventDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateSpontaneousReportingEventDto {
    id: number;
    structure: string | undefined;
    operationalUnit: string | undefined;
    equipeId: number | undefined;
    titleId: number | undefined;
    otherTitle: string | undefined;
    hospitalizationNumber: string | undefined;
    performanceTypeId: number | undefined;
    otherPerformanceType: string | undefined;
    procedureDelayId: number | undefined;
    inappropriateTypeId: number | undefined;
    missedProcedureTypeId: number | undefined;
    otherEventTypeId: number | undefined;
    otherOtherEventType: string | undefined;
    dateTime: moment.Moment;
    place: string;
    isWeekday: boolean | undefined;
    description: string | undefined;
    patientFactorIds: number[] | undefined;
    staffFactorsìIds: number[] | undefined;
    systemFactorIds: number[] | undefined;
    otherSystemFactor: string | undefined;
    outcomeReductionFactorIds: number[] | undefined;
    otherOutcomeReductionFactor: string | undefined;
    additionalInvestigationIds: number[] | undefined;
    otherAdditionalInvestigation: string | undefined;
    isDocumented: boolean | undefined;
    isPatientInformed: boolean | undefined;
    preventedOrAvoidedEvent: string | undefined;
    eventSeverityLevelId: number | undefined;
}

export class UpdateStructureDetailDto implements IUpdateStructureDetailDto {
    id!: number;
    cadastralData!: string | undefined;
    structureOwnershipTypeId!: number | undefined;
    releaseDate!: moment.Moment | undefined;
    leaseExpirationDate!: moment.Moment | undefined;
    contractRent!: boolean;
    contractRentFileId!: number | undefined;
    deed!: boolean;
    deedFileId!: number | undefined;
    startDate!: moment.Moment | undefined;
    endDate!: moment.Moment | undefined;
    extensionDate!: moment.Moment | undefined;
    contractConcession!: boolean;
    contractConcessionFileId!: number | undefined;
    lastBuildingPermitDate!: moment.Moment | undefined;
    lastOccupancyCertificateDate!: moment.Moment | undefined;
    undergroundLocalAuthorizations!: boolean;
    undergroundLocalAuthorizationsFileId!: number | undefined;
    floorPlan!: boolean;
    floorPlanFileId!: number | undefined;
    surfaceArea!: number | undefined;
    cpi!: boolean;
    cpiFileId!: number | undefined;
    cpiTypeId!: number | undefined;

    constructor(data?: IUpdateStructureDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.cadastralData = _data["cadastralData"];
            this.structureOwnershipTypeId = _data["structureOwnershipTypeId"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : undefined as any;
            this.leaseExpirationDate = _data["leaseExpirationDate"] ? moment(_data["leaseExpirationDate"].toString()) : undefined as any;
            this.contractRent = _data["contractRent"];
            this.contractRentFileId = _data["contractRentFileId"];
            this.deed = _data["deed"];
            this.deedFileId = _data["deedFileId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
            this.extensionDate = _data["extensionDate"] ? moment(_data["extensionDate"].toString()) : undefined as any;
            this.contractConcession = _data["contractConcession"];
            this.contractConcessionFileId = _data["contractConcessionFileId"];
            this.lastBuildingPermitDate = _data["lastBuildingPermitDate"] ? moment(_data["lastBuildingPermitDate"].toString()) : undefined as any;
            this.lastOccupancyCertificateDate = _data["lastOccupancyCertificateDate"] ? moment(_data["lastOccupancyCertificateDate"].toString()) : undefined as any;
            this.undergroundLocalAuthorizations = _data["undergroundLocalAuthorizations"];
            this.undergroundLocalAuthorizationsFileId = _data["undergroundLocalAuthorizationsFileId"];
            this.floorPlan = _data["floorPlan"];
            this.floorPlanFileId = _data["floorPlanFileId"];
            this.surfaceArea = _data["surfaceArea"];
            this.cpi = _data["cpi"];
            this.cpiFileId = _data["cpiFileId"];
            this.cpiTypeId = _data["cpiTypeId"];
        }
    }

    static fromJS(data: any): UpdateStructureDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStructureDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["cadastralData"] = this.cadastralData;
        data["structureOwnershipTypeId"] = this.structureOwnershipTypeId;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined as any;
        data["leaseExpirationDate"] = this.leaseExpirationDate ? this.leaseExpirationDate.toISOString() : undefined as any;
        data["contractRent"] = this.contractRent;
        data["contractRentFileId"] = this.contractRentFileId;
        data["deed"] = this.deed;
        data["deedFileId"] = this.deedFileId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["extensionDate"] = this.extensionDate ? this.extensionDate.toISOString() : undefined as any;
        data["contractConcession"] = this.contractConcession;
        data["contractConcessionFileId"] = this.contractConcessionFileId;
        data["lastBuildingPermitDate"] = this.lastBuildingPermitDate ? this.lastBuildingPermitDate.toISOString() : undefined as any;
        data["lastOccupancyCertificateDate"] = this.lastOccupancyCertificateDate ? this.lastOccupancyCertificateDate.toISOString() : undefined as any;
        data["undergroundLocalAuthorizations"] = this.undergroundLocalAuthorizations;
        data["undergroundLocalAuthorizationsFileId"] = this.undergroundLocalAuthorizationsFileId;
        data["floorPlan"] = this.floorPlan;
        data["floorPlanFileId"] = this.floorPlanFileId;
        data["surfaceArea"] = this.surfaceArea;
        data["cpi"] = this.cpi;
        data["cpiFileId"] = this.cpiFileId;
        data["cpiTypeId"] = this.cpiTypeId;
        return data;
    }

    clone(): UpdateStructureDetailDto {
        const json = this.toJSON();
        let result = new UpdateStructureDetailDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateStructureDetailDto {
    id: number;
    cadastralData: string | undefined;
    structureOwnershipTypeId: number | undefined;
    releaseDate: moment.Moment | undefined;
    leaseExpirationDate: moment.Moment | undefined;
    contractRent: boolean;
    contractRentFileId: number | undefined;
    deed: boolean;
    deedFileId: number | undefined;
    startDate: moment.Moment | undefined;
    endDate: moment.Moment | undefined;
    extensionDate: moment.Moment | undefined;
    contractConcession: boolean;
    contractConcessionFileId: number | undefined;
    lastBuildingPermitDate: moment.Moment | undefined;
    lastOccupancyCertificateDate: moment.Moment | undefined;
    undergroundLocalAuthorizations: boolean;
    undergroundLocalAuthorizationsFileId: number | undefined;
    floorPlan: boolean;
    floorPlanFileId: number | undefined;
    surfaceArea: number | undefined;
    cpi: boolean;
    cpiFileId: number | undefined;
    cpiTypeId: number | undefined;
}

export class UpdateStructureDto implements IUpdateStructureDto {
    id!: number;
    name!: string;
    address!: CreateAddressDto;
    status!: boolean | undefined;

    constructor(data?: IUpdateStructureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.address = new CreateAddressDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"] ? CreateAddressDto.fromJS(_data["address"]) : new CreateAddressDto();
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UpdateStructureDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStructureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : undefined as any;
        data["status"] = this.status;
        return data;
    }

    clone(): UpdateStructureDto {
        const json = this.toJSON();
        let result = new UpdateStructureDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateStructureDto {
    id: number;
    name: string;
    address: CreateAddressDto;
    status: boolean | undefined;
}

export class UpdateStructureRegistryDataDto implements IUpdateStructureRegistryDataDto {
    id!: number;
    nui!: string | undefined;
    floor!: string | undefined;
    hasElevator!: boolean | undefined;
    householdHead!: string | undefined;
    contractStartDate!: moment.Moment | undefined;
    contractEndDate!: moment.Moment | undefined;
    projectType!: string | undefined;
    projectTotalPlaces!: number | undefined;
    projectExpirationDate!: moment.Moment | undefined;
    ownerName!: string | undefined;
    ownerPhoneNumber!: string | undefined;
    ownerEmailAddress!: string | undefined;
    utilitiesPayment!: string | undefined;
    heatingType!: string | undefined;
    heatingOrdinaryCleaning!: string | undefined;
    heatingCost!: number | undefined;
    heatingBrand!: string | undefined;
    notes!: string | undefined;

    constructor(data?: IUpdateStructureRegistryDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nui = _data["nui"];
            this.floor = _data["floor"];
            this.hasElevator = _data["hasElevator"];
            this.householdHead = _data["householdHead"];
            this.contractStartDate = _data["contractStartDate"] ? moment(_data["contractStartDate"].toString()) : undefined as any;
            this.contractEndDate = _data["contractEndDate"] ? moment(_data["contractEndDate"].toString()) : undefined as any;
            this.projectType = _data["projectType"];
            this.projectTotalPlaces = _data["projectTotalPlaces"];
            this.projectExpirationDate = _data["projectExpirationDate"] ? moment(_data["projectExpirationDate"].toString()) : undefined as any;
            this.ownerName = _data["ownerName"];
            this.ownerPhoneNumber = _data["ownerPhoneNumber"];
            this.ownerEmailAddress = _data["ownerEmailAddress"];
            this.utilitiesPayment = _data["utilitiesPayment"];
            this.heatingType = _data["heatingType"];
            this.heatingOrdinaryCleaning = _data["heatingOrdinaryCleaning"];
            this.heatingCost = _data["heatingCost"];
            this.heatingBrand = _data["heatingBrand"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateStructureRegistryDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStructureRegistryDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nui"] = this.nui;
        data["floor"] = this.floor;
        data["hasElevator"] = this.hasElevator;
        data["householdHead"] = this.householdHead;
        data["contractStartDate"] = this.contractStartDate ? this.contractStartDate.toISOString() : undefined as any;
        data["contractEndDate"] = this.contractEndDate ? this.contractEndDate.toISOString() : undefined as any;
        data["projectType"] = this.projectType;
        data["projectTotalPlaces"] = this.projectTotalPlaces;
        data["projectExpirationDate"] = this.projectExpirationDate ? this.projectExpirationDate.toISOString() : undefined as any;
        data["ownerName"] = this.ownerName;
        data["ownerPhoneNumber"] = this.ownerPhoneNumber;
        data["ownerEmailAddress"] = this.ownerEmailAddress;
        data["utilitiesPayment"] = this.utilitiesPayment;
        data["heatingType"] = this.heatingType;
        data["heatingOrdinaryCleaning"] = this.heatingOrdinaryCleaning;
        data["heatingCost"] = this.heatingCost;
        data["heatingBrand"] = this.heatingBrand;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpdateStructureRegistryDataDto {
        const json = this.toJSON();
        let result = new UpdateStructureRegistryDataDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateStructureRegistryDataDto {
    id: number;
    nui: string | undefined;
    floor: string | undefined;
    hasElevator: boolean | undefined;
    householdHead: string | undefined;
    contractStartDate: moment.Moment | undefined;
    contractEndDate: moment.Moment | undefined;
    projectType: string | undefined;
    projectTotalPlaces: number | undefined;
    projectExpirationDate: moment.Moment | undefined;
    ownerName: string | undefined;
    ownerPhoneNumber: string | undefined;
    ownerEmailAddress: string | undefined;
    utilitiesPayment: string | undefined;
    heatingType: string | undefined;
    heatingOrdinaryCleaning: string | undefined;
    heatingCost: number | undefined;
    heatingBrand: string | undefined;
    notes: string | undefined;
}

export class UpdateStructureTemplateDto implements IUpdateStructureTemplateDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;
    widgetIds!: number[] | undefined;

    constructor(data?: IUpdateStructureTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["widgetIds"])) {
                this.widgetIds = [] as any;
                for (let item of _data["widgetIds"])
                    this.widgetIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateStructureTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStructureTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.widgetIds)) {
            data["widgetIds"] = [];
            for (let item of this.widgetIds)
                data["widgetIds"].push(item);
        }
        return data;
    }

    clone(): UpdateStructureTemplateDto {
        const json = this.toJSON();
        let result = new UpdateStructureTemplateDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateStructureTemplateDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    widgetIds: number[] | undefined;
}

export class UpdateTinettiPerformanceRecordDto implements IUpdateTinettiPerformanceRecordDto {
    id!: number;
    date!: moment.Moment;

    constructor(data?: IUpdateTinettiPerformanceRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateTinettiPerformanceRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTinettiPerformanceRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        return data;
    }

    clone(): UpdateTinettiPerformanceRecordDto {
        const json = this.toJSON();
        let result = new UpdateTinettiPerformanceRecordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateTinettiPerformanceRecordDto {
    id: number;
    date: moment.Moment;
}

export class UpdateUMVDDto implements IUpdateUMVDDto {
    id!: number;
    releaseDate!: moment.Moment | undefined;
    intensity!: string | undefined;
    possibleExpirationDate!: moment.Moment | undefined;
    frequency!: string | undefined;

    constructor(data?: IUpdateUMVDDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.releaseDate = _data["releaseDate"] ? moment(_data["releaseDate"].toString()) : undefined as any;
            this.intensity = _data["intensity"];
            this.possibleExpirationDate = _data["possibleExpirationDate"] ? moment(_data["possibleExpirationDate"].toString()) : undefined as any;
            this.frequency = _data["frequency"];
        }
    }

    static fromJS(data: any): UpdateUMVDDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUMVDDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined as any;
        data["intensity"] = this.intensity;
        data["possibleExpirationDate"] = this.possibleExpirationDate ? this.possibleExpirationDate.toISOString() : undefined as any;
        data["frequency"] = this.frequency;
        return data;
    }

    clone(): UpdateUMVDDto {
        const json = this.toJSON();
        let result = new UpdateUMVDDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUMVDDto {
    id: number;
    releaseDate: moment.Moment | undefined;
    intensity: string | undefined;
    possibleExpirationDate: moment.Moment | undefined;
    frequency: string | undefined;
}

export class UpdateUserDto implements IUpdateUserDto {
    id!: number;
    name!: string;
    surname!: string;
    fiscalCode!: string | undefined;
    birthDate!: moment.Moment;
    birthPlaceId!: number | undefined;
    isMale!: boolean | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    isActive!: boolean;
    roleNames!: string[] | undefined;
    customDataContent!: string | undefined;

    constructor(data?: IUpdateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.fiscalCode = _data["fiscalCode"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : undefined as any;
            this.birthPlaceId = _data["birthPlaceId"];
            this.isMale = _data["isMale"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            this.customDataContent = _data["customDataContent"];
        }
    }

    static fromJS(data: any): UpdateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fiscalCode"] = this.fiscalCode;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined as any;
        data["birthPlaceId"] = this.birthPlaceId;
        data["isMale"] = this.isMale;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        data["customDataContent"] = this.customDataContent;
        return data;
    }

    clone(): UpdateUserDto {
        const json = this.toJSON();
        let result = new UpdateUserDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserDto {
    id: number;
    name: string;
    surname: string;
    fiscalCode: string | undefined;
    birthDate: moment.Moment;
    birthPlaceId: number | undefined;
    isMale: boolean | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    isActive: boolean;
    roleNames: string[] | undefined;
    customDataContent: string | undefined;
}

export class UpdateVehicleAdditionalDataDto implements IUpdateVehicleAdditionalDataDto {
    id!: number;
    keys!: string | undefined;
    multiCard!: boolean | undefined;
    pin!: string | undefined;
    cardNumber!: string | undefined;
    insurance!: string | undefined;
    insuranceExpirationDate!: moment.Moment | undefined;
    vehicleKm!: number | undefined;
    lastRevisionDate!: moment.Moment | undefined;
    revisionExpiration!: number | undefined;

    constructor(data?: IUpdateVehicleAdditionalDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.keys = _data["keys"];
            this.multiCard = _data["multiCard"];
            this.pin = _data["pin"];
            this.cardNumber = _data["cardNumber"];
            this.insurance = _data["insurance"];
            this.insuranceExpirationDate = _data["insuranceExpirationDate"] ? moment(_data["insuranceExpirationDate"].toString()) : undefined as any;
            this.vehicleKm = _data["vehicleKm"];
            this.lastRevisionDate = _data["lastRevisionDate"] ? moment(_data["lastRevisionDate"].toString()) : undefined as any;
            this.revisionExpiration = _data["revisionExpiration"];
        }
    }

    static fromJS(data: any): UpdateVehicleAdditionalDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVehicleAdditionalDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["keys"] = this.keys;
        data["multiCard"] = this.multiCard;
        data["pin"] = this.pin;
        data["cardNumber"] = this.cardNumber;
        data["insurance"] = this.insurance;
        data["insuranceExpirationDate"] = this.insuranceExpirationDate ? this.insuranceExpirationDate.toISOString() : undefined as any;
        data["vehicleKm"] = this.vehicleKm;
        data["lastRevisionDate"] = this.lastRevisionDate ? this.lastRevisionDate.toISOString() : undefined as any;
        data["revisionExpiration"] = this.revisionExpiration;
        return data;
    }

    clone(): UpdateVehicleAdditionalDataDto {
        const json = this.toJSON();
        let result = new UpdateVehicleAdditionalDataDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateVehicleAdditionalDataDto {
    id: number;
    keys: string | undefined;
    multiCard: boolean | undefined;
    pin: string | undefined;
    cardNumber: string | undefined;
    insurance: string | undefined;
    insuranceExpirationDate: moment.Moment | undefined;
    vehicleKm: number | undefined;
    lastRevisionDate: moment.Moment | undefined;
    revisionExpiration: number | undefined;
}

export class UpdateVehicleDto implements IUpdateVehicleDto {
    id!: number;
    plate!: string | undefined;
    vehicleTypeId!: number;
    make!: string | undefined;
    model!: string | undefined;
    registrationDate!: moment.Moment | undefined;
    ownerShipId!: number | undefined;
    rentalStartDate!: moment.Moment | undefined;
    rentalEndDate!: moment.Moment | undefined;
    kmforYear!: number | undefined;
    contractId!: number | undefined;
    equipped!: boolean | undefined;
    seats!: number | undefined;
    wheelchairSpaces!: number | undefined;
    classicCode!: string | undefined;
    engineCategory!: string | undefined;
    notes!: string | undefined;
    energySourceId!: number | undefined;
    rentalCompanyIds!: number[] | undefined;

    constructor(data?: IUpdateVehicleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.plate = _data["plate"];
            this.vehicleTypeId = _data["vehicleTypeId"];
            this.make = _data["make"];
            this.model = _data["model"];
            this.registrationDate = _data["registrationDate"] ? moment(_data["registrationDate"].toString()) : undefined as any;
            this.ownerShipId = _data["ownerShipId"];
            this.rentalStartDate = _data["rentalStartDate"] ? moment(_data["rentalStartDate"].toString()) : undefined as any;
            this.rentalEndDate = _data["rentalEndDate"] ? moment(_data["rentalEndDate"].toString()) : undefined as any;
            this.kmforYear = _data["kmforYear"];
            this.contractId = _data["contractId"];
            this.equipped = _data["equipped"];
            this.seats = _data["seats"];
            this.wheelchairSpaces = _data["wheelchairSpaces"];
            this.classicCode = _data["classicCode"];
            this.engineCategory = _data["engineCategory"];
            this.notes = _data["notes"];
            this.energySourceId = _data["energySourceId"];
            if (Array.isArray(_data["rentalCompanyIds"])) {
                this.rentalCompanyIds = [] as any;
                for (let item of _data["rentalCompanyIds"])
                    this.rentalCompanyIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateVehicleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVehicleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plate"] = this.plate;
        data["vehicleTypeId"] = this.vehicleTypeId;
        data["make"] = this.make;
        data["model"] = this.model;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : undefined as any;
        data["ownerShipId"] = this.ownerShipId;
        data["rentalStartDate"] = this.rentalStartDate ? this.rentalStartDate.toISOString() : undefined as any;
        data["rentalEndDate"] = this.rentalEndDate ? this.rentalEndDate.toISOString() : undefined as any;
        data["kmforYear"] = this.kmforYear;
        data["contractId"] = this.contractId;
        data["equipped"] = this.equipped;
        data["seats"] = this.seats;
        data["wheelchairSpaces"] = this.wheelchairSpaces;
        data["classicCode"] = this.classicCode;
        data["engineCategory"] = this.engineCategory;
        data["notes"] = this.notes;
        data["energySourceId"] = this.energySourceId;
        if (Array.isArray(this.rentalCompanyIds)) {
            data["rentalCompanyIds"] = [];
            for (let item of this.rentalCompanyIds)
                data["rentalCompanyIds"].push(item);
        }
        return data;
    }

    clone(): UpdateVehicleDto {
        const json = this.toJSON();
        let result = new UpdateVehicleDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateVehicleDto {
    id: number;
    plate: string | undefined;
    vehicleTypeId: number;
    make: string | undefined;
    model: string | undefined;
    registrationDate: moment.Moment | undefined;
    ownerShipId: number | undefined;
    rentalStartDate: moment.Moment | undefined;
    rentalEndDate: moment.Moment | undefined;
    kmforYear: number | undefined;
    contractId: number | undefined;
    equipped: boolean | undefined;
    seats: number | undefined;
    wheelchairSpaces: number | undefined;
    classicCode: string | undefined;
    engineCategory: string | undefined;
    notes: string | undefined;
    energySourceId: number | undefined;
    rentalCompanyIds: number[] | undefined;
}

export class UpdateVehicleServiceUserDto implements IUpdateVehicleServiceUserDto {
    id!: number;
    vehicleId!: number;
    serviceId!: number;
    userId!: number | undefined;
    assignmentDate!: moment.Moment;
    withdrawalDate!: moment.Moment | undefined;

    constructor(data?: IUpdateVehicleServiceUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vehicleId = _data["vehicleId"];
            this.serviceId = _data["serviceId"];
            this.userId = _data["userId"];
            this.assignmentDate = _data["assignmentDate"] ? moment(_data["assignmentDate"].toString()) : undefined as any;
            this.withdrawalDate = _data["withdrawalDate"] ? moment(_data["withdrawalDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): UpdateVehicleServiceUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVehicleServiceUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vehicleId"] = this.vehicleId;
        data["serviceId"] = this.serviceId;
        data["userId"] = this.userId;
        data["assignmentDate"] = this.assignmentDate ? this.assignmentDate.toISOString() : undefined as any;
        data["withdrawalDate"] = this.withdrawalDate ? this.withdrawalDate.toISOString() : undefined as any;
        return data;
    }

    clone(): UpdateVehicleServiceUserDto {
        const json = this.toJSON();
        let result = new UpdateVehicleServiceUserDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateVehicleServiceUserDto {
    id: number;
    vehicleId: number;
    serviceId: number;
    userId: number | undefined;
    assignmentDate: moment.Moment;
    withdrawalDate: moment.Moment | undefined;
}

export class UpdateVerbalNoteDto implements IUpdateVerbalNoteDto {
    id!: number;
    title!: string | undefined;
    verbalTagIds!: number[] | undefined;
    beneficiaryIds!: number[] | undefined;
    contentsToRecord!: string | undefined;
    detarminationAndNotes!: string | undefined;

    constructor(data?: IUpdateVerbalNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            if (Array.isArray(_data["verbalTagIds"])) {
                this.verbalTagIds = [] as any;
                for (let item of _data["verbalTagIds"])
                    this.verbalTagIds!.push(item);
            }
            if (Array.isArray(_data["beneficiaryIds"])) {
                this.beneficiaryIds = [] as any;
                for (let item of _data["beneficiaryIds"])
                    this.beneficiaryIds!.push(item);
            }
            this.contentsToRecord = _data["contentsToRecord"];
            this.detarminationAndNotes = _data["detarminationAndNotes"];
        }
    }

    static fromJS(data: any): UpdateVerbalNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVerbalNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        if (Array.isArray(this.verbalTagIds)) {
            data["verbalTagIds"] = [];
            for (let item of this.verbalTagIds)
                data["verbalTagIds"].push(item);
        }
        if (Array.isArray(this.beneficiaryIds)) {
            data["beneficiaryIds"] = [];
            for (let item of this.beneficiaryIds)
                data["beneficiaryIds"].push(item);
        }
        data["contentsToRecord"] = this.contentsToRecord;
        data["detarminationAndNotes"] = this.detarminationAndNotes;
        return data;
    }

    clone(): UpdateVerbalNoteDto {
        const json = this.toJSON();
        let result = new UpdateVerbalNoteDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateVerbalNoteDto {
    id: number;
    title: string | undefined;
    verbalTagIds: number[] | undefined;
    beneficiaryIds: number[] | undefined;
    contentsToRecord: string | undefined;
    detarminationAndNotes: string | undefined;
}

export class UpdateVideoSurveillanceSystemDto implements IUpdateVideoSurveillanceSystemDto {
    id!: number;
    name!: string | undefined;
    numberOfCameras!: number | undefined;
    numberOfMonitors!: number | undefined;
    maintenanceContract!: boolean;
    maintenanceContractFileId!: number | undefined;
    maintenanceCompany!: string | undefined;
    lastMaintenanceDate!: moment.Moment | undefined;
    outsiderResponsible!: boolean;
    externalVigilance!: boolean;
    vigilanceContractFileId!: number | undefined;
    vigilanceCompany!: string | undefined;
    operationalAuthorizationId!: number | undefined;
    notes!: string | undefined;

    constructor(data?: IUpdateVideoSurveillanceSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.numberOfCameras = _data["numberOfCameras"];
            this.numberOfMonitors = _data["numberOfMonitors"];
            this.maintenanceContract = _data["maintenanceContract"];
            this.maintenanceContractFileId = _data["maintenanceContractFileId"];
            this.maintenanceCompany = _data["maintenanceCompany"];
            this.lastMaintenanceDate = _data["lastMaintenanceDate"] ? moment(_data["lastMaintenanceDate"].toString()) : undefined as any;
            this.outsiderResponsible = _data["outsiderResponsible"];
            this.externalVigilance = _data["externalVigilance"];
            this.vigilanceContractFileId = _data["vigilanceContractFileId"];
            this.vigilanceCompany = _data["vigilanceCompany"];
            this.operationalAuthorizationId = _data["operationalAuthorizationId"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): UpdateVideoSurveillanceSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVideoSurveillanceSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["numberOfCameras"] = this.numberOfCameras;
        data["numberOfMonitors"] = this.numberOfMonitors;
        data["maintenanceContract"] = this.maintenanceContract;
        data["maintenanceContractFileId"] = this.maintenanceContractFileId;
        data["maintenanceCompany"] = this.maintenanceCompany;
        data["lastMaintenanceDate"] = this.lastMaintenanceDate ? this.lastMaintenanceDate.toISOString() : undefined as any;
        data["outsiderResponsible"] = this.outsiderResponsible;
        data["externalVigilance"] = this.externalVigilance;
        data["vigilanceContractFileId"] = this.vigilanceContractFileId;
        data["vigilanceCompany"] = this.vigilanceCompany;
        data["operationalAuthorizationId"] = this.operationalAuthorizationId;
        data["notes"] = this.notes;
        return data;
    }

    clone(): UpdateVideoSurveillanceSystemDto {
        const json = this.toJSON();
        let result = new UpdateVideoSurveillanceSystemDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateVideoSurveillanceSystemDto {
    id: number;
    name: string | undefined;
    numberOfCameras: number | undefined;
    numberOfMonitors: number | undefined;
    maintenanceContract: boolean;
    maintenanceContractFileId: number | undefined;
    maintenanceCompany: string | undefined;
    lastMaintenanceDate: moment.Moment | undefined;
    outsiderResponsible: boolean;
    externalVigilance: boolean;
    vigilanceContractFileId: number | undefined;
    vigilanceCompany: string | undefined;
    operationalAuthorizationId: number | undefined;
    notes: string | undefined;
}

export class UpdateVitalSignRecordDto implements IUpdateVitalSignRecordDto {
    id!: number;
    firstPA!: number | undefined;
    secondPA!: number | undefined;
    firstFC!: number | undefined;
    secondFC!: number | undefined;
    firstSpO2!: number | undefined;
    secondSpO2!: number | undefined;
    note!: string | undefined;

    constructor(data?: IUpdateVitalSignRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstPA = _data["firstPA"];
            this.secondPA = _data["secondPA"];
            this.firstFC = _data["firstFC"];
            this.secondFC = _data["secondFC"];
            this.firstSpO2 = _data["firstSpO2"];
            this.secondSpO2 = _data["secondSpO2"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): UpdateVitalSignRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateVitalSignRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstPA"] = this.firstPA;
        data["secondPA"] = this.secondPA;
        data["firstFC"] = this.firstFC;
        data["secondFC"] = this.secondFC;
        data["firstSpO2"] = this.firstSpO2;
        data["secondSpO2"] = this.secondSpO2;
        data["note"] = this.note;
        return data;
    }

    clone(): UpdateVitalSignRecordDto {
        const json = this.toJSON();
        let result = new UpdateVitalSignRecordDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateVitalSignRecordDto {
    id: number;
    firstPA: number | undefined;
    secondPA: number | undefined;
    firstFC: number | undefined;
    secondFC: number | undefined;
    firstSpO2: number | undefined;
    secondSpO2: number | undefined;
    note: string | undefined;
}

export class UpdateWeightDetectionEntryDto implements IUpdateWeightDetectionEntryDto {
    id!: number;
    serviceUserId!: number;

    constructor(data?: IUpdateWeightDetectionEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceUserId = _data["serviceUserId"];
        }
    }

    static fromJS(data: any): UpdateWeightDetectionEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWeightDetectionEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceUserId"] = this.serviceUserId;
        return data;
    }

    clone(): UpdateWeightDetectionEntryDto {
        const json = this.toJSON();
        let result = new UpdateWeightDetectionEntryDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateWeightDetectionEntryDto {
    id: number;
    serviceUserId: number;
}

export class UpdateWeightDetectionMonthEntryDto implements IUpdateWeightDetectionMonthEntryDto {
    id!: number;
    monthId!: number;
    weight!: number | undefined;

    constructor(data?: IUpdateWeightDetectionMonthEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.monthId = _data["monthId"];
            this.weight = _data["weight"];
        }
    }

    static fromJS(data: any): UpdateWeightDetectionMonthEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWeightDetectionMonthEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["monthId"] = this.monthId;
        data["weight"] = this.weight;
        return data;
    }

    clone(): UpdateWeightDetectionMonthEntryDto {
        const json = this.toJSON();
        let result = new UpdateWeightDetectionMonthEntryDto();
        result.init(json);
        return result;
    }
}

export interface IUpdateWeightDetectionMonthEntryDto {
    id: number;
    monthId: number;
    weight: number | undefined;
}

export class UserDto implements IUserDto {
    id!: number;
    userGuid!: string | undefined;
    name!: string | undefined;
    surname!: string | undefined;
    phoneNumber!: string | undefined;
    fiscalCode!: string | undefined;
    birthDate!: moment.Moment;
    birthPlace!: MunicipalityDto;
    isMale!: boolean | undefined;
    emailAddress!: string | undefined;
    roleNames!: string[] | undefined;
    roleDisplayNames!: string[] | undefined;
    isActive!: boolean;
    isDeleted!: boolean;
    archivalTime!: moment.Moment | undefined;
    readonly isArchived!: boolean;
    lastLoginTime!: moment.Moment | undefined;
    isEmailConfirmed!: boolean;
    fullName!: string | undefined;
    accessFailedCount!: number;
    lockoutEndDateUtc!: moment.Moment | undefined;
    customDataContent!: string | undefined;
    serviceNames!: string[] | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userGuid = _data["userGuid"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.phoneNumber = _data["phoneNumber"];
            this.fiscalCode = _data["fiscalCode"];
            this.birthDate = _data["birthDate"] ? moment(_data["birthDate"].toString()) : undefined as any;
            this.birthPlace = _data["birthPlace"] ? MunicipalityDto.fromJS(_data["birthPlace"]) : undefined as any;
            this.isMale = _data["isMale"];
            this.emailAddress = _data["emailAddress"];
            if (Array.isArray(_data["roleNames"])) {
                this.roleNames = [] as any;
                for (let item of _data["roleNames"])
                    this.roleNames!.push(item);
            }
            if (Array.isArray(_data["roleDisplayNames"])) {
                this.roleDisplayNames = [] as any;
                for (let item of _data["roleDisplayNames"])
                    this.roleDisplayNames!.push(item);
            }
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.archivalTime = _data["archivalTime"] ? moment(_data["archivalTime"].toString()) : undefined as any;
            (this as any).isArchived = _data["isArchived"];
            this.lastLoginTime = _data["lastLoginTime"] ? moment(_data["lastLoginTime"].toString()) : undefined as any;
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            this.fullName = _data["fullName"];
            this.accessFailedCount = _data["accessFailedCount"];
            this.lockoutEndDateUtc = _data["lockoutEndDateUtc"] ? moment(_data["lockoutEndDateUtc"].toString()) : undefined as any;
            this.customDataContent = _data["customDataContent"];
            if (Array.isArray(_data["serviceNames"])) {
                this.serviceNames = [] as any;
                for (let item of _data["serviceNames"])
                    this.serviceNames!.push(item);
            }
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userGuid"] = this.userGuid;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phoneNumber"] = this.phoneNumber;
        data["fiscalCode"] = this.fiscalCode;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : undefined as any;
        data["birthPlace"] = this.birthPlace ? this.birthPlace.toJSON() : undefined as any;
        data["isMale"] = this.isMale;
        data["emailAddress"] = this.emailAddress;
        if (Array.isArray(this.roleNames)) {
            data["roleNames"] = [];
            for (let item of this.roleNames)
                data["roleNames"].push(item);
        }
        if (Array.isArray(this.roleDisplayNames)) {
            data["roleDisplayNames"] = [];
            for (let item of this.roleDisplayNames)
                data["roleDisplayNames"].push(item);
        }
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["archivalTime"] = this.archivalTime ? this.archivalTime.toISOString() : undefined as any;
        data["isArchived"] = this.isArchived;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : undefined as any;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["fullName"] = this.fullName;
        data["accessFailedCount"] = this.accessFailedCount;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : undefined as any;
        data["customDataContent"] = this.customDataContent;
        if (Array.isArray(this.serviceNames)) {
            data["serviceNames"] = [];
            for (let item of this.serviceNames)
                data["serviceNames"].push(item);
        }
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id: number;
    userGuid: string | undefined;
    name: string | undefined;
    surname: string | undefined;
    phoneNumber: string | undefined;
    fiscalCode: string | undefined;
    birthDate: moment.Moment;
    birthPlace: MunicipalityDto;
    isMale: boolean | undefined;
    emailAddress: string | undefined;
    roleNames: string[] | undefined;
    roleDisplayNames: string[] | undefined;
    isActive: boolean;
    isDeleted: boolean;
    archivalTime: moment.Moment | undefined;
    isArchived: boolean;
    lastLoginTime: moment.Moment | undefined;
    isEmailConfirmed: boolean;
    fullName: string | undefined;
    accessFailedCount: number;
    lockoutEndDateUtc: moment.Moment | undefined;
    customDataContent: string | undefined;
    serviceNames: string[] | undefined;
}

export class UserDtoPagedResultDto implements IUserDtoPagedResultDto {
    items!: UserDto[] | undefined;
    totalCount!: number;

    constructor(data?: IUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): UserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): UserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new UserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IUserDtoPagedResultDto {
    items: UserDto[] | undefined;
    totalCount: number;
}

export class UserGuidDto implements IUserGuidDto {
    id!: number;
    userGuid!: string | undefined;

    constructor(data?: IUserGuidDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userGuid = _data["userGuid"];
        }
    }

    static fromJS(data: any): UserGuidDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGuidDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userGuid"] = this.userGuid;
        return data;
    }

    clone(): UserGuidDto {
        const json = this.toJSON();
        let result = new UserGuidDto();
        result.init(json);
        return result;
    }
}

export interface IUserGuidDto {
    id: number;
    userGuid: string | undefined;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    id!: number;
    name!: string | undefined;
    surname!: string | undefined;
    fullName!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.fullName = _data["fullName"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        return data;
    }

    clone(): UserLoginInfoDto {
        const json = this.toJSON();
        let result = new UserLoginInfoDto();
        result.init(json);
        return result;
    }
}

export interface IUserLoginInfoDto {
    id: number;
    name: string | undefined;
    surname: string | undefined;
    fullName: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
}

export class VehicleAdditionalDataDto implements IVehicleAdditionalDataDto {
    id!: number;
    keys!: string | undefined;
    multiCard!: boolean | undefined;
    pin!: string | undefined;
    cardNumber!: string | undefined;
    insurance!: string | undefined;
    insuranceExpirationDate!: moment.Moment | undefined;
    vehicleKm!: number | undefined;
    lastRevisionDate!: moment.Moment | undefined;
    revisionExpiration!: number | undefined;

    constructor(data?: IVehicleAdditionalDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.keys = _data["keys"];
            this.multiCard = _data["multiCard"];
            this.pin = _data["pin"];
            this.cardNumber = _data["cardNumber"];
            this.insurance = _data["insurance"];
            this.insuranceExpirationDate = _data["insuranceExpirationDate"] ? moment(_data["insuranceExpirationDate"].toString()) : undefined as any;
            this.vehicleKm = _data["vehicleKm"];
            this.lastRevisionDate = _data["lastRevisionDate"] ? moment(_data["lastRevisionDate"].toString()) : undefined as any;
            this.revisionExpiration = _data["revisionExpiration"];
        }
    }

    static fromJS(data: any): VehicleAdditionalDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleAdditionalDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["keys"] = this.keys;
        data["multiCard"] = this.multiCard;
        data["pin"] = this.pin;
        data["cardNumber"] = this.cardNumber;
        data["insurance"] = this.insurance;
        data["insuranceExpirationDate"] = this.insuranceExpirationDate ? this.insuranceExpirationDate.toISOString() : undefined as any;
        data["vehicleKm"] = this.vehicleKm;
        data["lastRevisionDate"] = this.lastRevisionDate ? this.lastRevisionDate.toISOString() : undefined as any;
        data["revisionExpiration"] = this.revisionExpiration;
        return data;
    }

    clone(): VehicleAdditionalDataDto {
        const json = this.toJSON();
        let result = new VehicleAdditionalDataDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleAdditionalDataDto {
    id: number;
    keys: string | undefined;
    multiCard: boolean | undefined;
    pin: string | undefined;
    cardNumber: string | undefined;
    insurance: string | undefined;
    insuranceExpirationDate: moment.Moment | undefined;
    vehicleKm: number | undefined;
    lastRevisionDate: moment.Moment | undefined;
    revisionExpiration: number | undefined;
}

export class VehicleAdditionalDataDtoPagedResultDto implements IVehicleAdditionalDataDtoPagedResultDto {
    items!: VehicleAdditionalDataDto[] | undefined;
    totalCount!: number;

    constructor(data?: IVehicleAdditionalDataDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VehicleAdditionalDataDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): VehicleAdditionalDataDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleAdditionalDataDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): VehicleAdditionalDataDtoPagedResultDto {
        const json = this.toJSON();
        let result = new VehicleAdditionalDataDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleAdditionalDataDtoPagedResultDto {
    items: VehicleAdditionalDataDto[] | undefined;
    totalCount: number;
}

export class VehicleDto implements IVehicleDto {
    id!: number;
    plate!: string | undefined;
    vehicleType!: DictionaryDto;
    make!: string | undefined;
    model!: string | undefined;
    registrationDate!: moment.Moment | undefined;
    ownerShip!: DictionaryDto;
    rentalStartDate!: moment.Moment | undefined;
    rentalEndDate!: moment.Moment | undefined;
    kmforYear!: number | undefined;
    contract!: FileDto;
    equipped!: boolean | undefined;
    seats!: number | undefined;
    wheelchairSpaces!: number | undefined;
    classicCode!: string | undefined;
    engineCategory!: string | undefined;
    notes!: string | undefined;
    energySource!: DictionaryDto;
    rentalCompanies!: DictionaryDto[] | undefined;

    constructor(data?: IVehicleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.plate = _data["plate"];
            this.vehicleType = _data["vehicleType"] ? DictionaryDto.fromJS(_data["vehicleType"]) : undefined as any;
            this.make = _data["make"];
            this.model = _data["model"];
            this.registrationDate = _data["registrationDate"] ? moment(_data["registrationDate"].toString()) : undefined as any;
            this.ownerShip = _data["ownerShip"] ? DictionaryDto.fromJS(_data["ownerShip"]) : undefined as any;
            this.rentalStartDate = _data["rentalStartDate"] ? moment(_data["rentalStartDate"].toString()) : undefined as any;
            this.rentalEndDate = _data["rentalEndDate"] ? moment(_data["rentalEndDate"].toString()) : undefined as any;
            this.kmforYear = _data["kmforYear"];
            this.contract = _data["contract"] ? FileDto.fromJS(_data["contract"]) : undefined as any;
            this.equipped = _data["equipped"];
            this.seats = _data["seats"];
            this.wheelchairSpaces = _data["wheelchairSpaces"];
            this.classicCode = _data["classicCode"];
            this.engineCategory = _data["engineCategory"];
            this.notes = _data["notes"];
            this.energySource = _data["energySource"] ? DictionaryDto.fromJS(_data["energySource"]) : undefined as any;
            if (Array.isArray(_data["rentalCompanies"])) {
                this.rentalCompanies = [] as any;
                for (let item of _data["rentalCompanies"])
                    this.rentalCompanies!.push(DictionaryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VehicleDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plate"] = this.plate;
        data["vehicleType"] = this.vehicleType ? this.vehicleType.toJSON() : undefined as any;
        data["make"] = this.make;
        data["model"] = this.model;
        data["registrationDate"] = this.registrationDate ? this.registrationDate.toISOString() : undefined as any;
        data["ownerShip"] = this.ownerShip ? this.ownerShip.toJSON() : undefined as any;
        data["rentalStartDate"] = this.rentalStartDate ? this.rentalStartDate.toISOString() : undefined as any;
        data["rentalEndDate"] = this.rentalEndDate ? this.rentalEndDate.toISOString() : undefined as any;
        data["kmforYear"] = this.kmforYear;
        data["contract"] = this.contract ? this.contract.toJSON() : undefined as any;
        data["equipped"] = this.equipped;
        data["seats"] = this.seats;
        data["wheelchairSpaces"] = this.wheelchairSpaces;
        data["classicCode"] = this.classicCode;
        data["engineCategory"] = this.engineCategory;
        data["notes"] = this.notes;
        data["energySource"] = this.energySource ? this.energySource.toJSON() : undefined as any;
        if (Array.isArray(this.rentalCompanies)) {
            data["rentalCompanies"] = [];
            for (let item of this.rentalCompanies)
                data["rentalCompanies"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): VehicleDto {
        const json = this.toJSON();
        let result = new VehicleDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleDto {
    id: number;
    plate: string | undefined;
    vehicleType: DictionaryDto;
    make: string | undefined;
    model: string | undefined;
    registrationDate: moment.Moment | undefined;
    ownerShip: DictionaryDto;
    rentalStartDate: moment.Moment | undefined;
    rentalEndDate: moment.Moment | undefined;
    kmforYear: number | undefined;
    contract: FileDto;
    equipped: boolean | undefined;
    seats: number | undefined;
    wheelchairSpaces: number | undefined;
    classicCode: string | undefined;
    engineCategory: string | undefined;
    notes: string | undefined;
    energySource: DictionaryDto;
    rentalCompanies: DictionaryDto[] | undefined;
}

export class VehicleItemDto implements IVehicleItemDto {
    id!: number;
    plate!: string | undefined;
    vehicleType!: DictionaryDto;
    model!: string | undefined;
    make!: string | undefined;

    constructor(data?: IVehicleItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.plate = _data["plate"];
            this.vehicleType = _data["vehicleType"] ? DictionaryDto.fromJS(_data["vehicleType"]) : undefined as any;
            this.model = _data["model"];
            this.make = _data["make"];
        }
    }

    static fromJS(data: any): VehicleItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plate"] = this.plate;
        data["vehicleType"] = this.vehicleType ? this.vehicleType.toJSON() : undefined as any;
        data["model"] = this.model;
        data["make"] = this.make;
        return data;
    }

    clone(): VehicleItemDto {
        const json = this.toJSON();
        let result = new VehicleItemDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleItemDto {
    id: number;
    plate: string | undefined;
    vehicleType: DictionaryDto;
    model: string | undefined;
    make: string | undefined;
}

export class VehicleItemDtoPagedResultDto implements IVehicleItemDtoPagedResultDto {
    items!: VehicleItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IVehicleItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VehicleItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): VehicleItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): VehicleItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new VehicleItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleItemDtoPagedResultDto {
    items: VehicleItemDto[] | undefined;
    totalCount: number;
}

export class VehicleServiceUserDto implements IVehicleServiceUserDto {
    id!: number;
    user!: BaseUserDto;
    vehicle!: VehicleItemDto;
    service!: ServiceItemDto;
    assignmentDate!: moment.Moment;
    withdrawalDate!: moment.Moment | undefined;

    constructor(data?: IVehicleServiceUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"] ? BaseUserDto.fromJS(_data["user"]) : undefined as any;
            this.vehicle = _data["vehicle"] ? VehicleItemDto.fromJS(_data["vehicle"]) : undefined as any;
            this.service = _data["service"] ? ServiceItemDto.fromJS(_data["service"]) : undefined as any;
            this.assignmentDate = _data["assignmentDate"] ? moment(_data["assignmentDate"].toString()) : undefined as any;
            this.withdrawalDate = _data["withdrawalDate"] ? moment(_data["withdrawalDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): VehicleServiceUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleServiceUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : undefined as any;
        data["service"] = this.service ? this.service.toJSON() : undefined as any;
        data["assignmentDate"] = this.assignmentDate ? this.assignmentDate.toISOString() : undefined as any;
        data["withdrawalDate"] = this.withdrawalDate ? this.withdrawalDate.toISOString() : undefined as any;
        return data;
    }

    clone(): VehicleServiceUserDto {
        const json = this.toJSON();
        let result = new VehicleServiceUserDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleServiceUserDto {
    id: number;
    user: BaseUserDto;
    vehicle: VehicleItemDto;
    service: ServiceItemDto;
    assignmentDate: moment.Moment;
    withdrawalDate: moment.Moment | undefined;
}

export class VehicleServiceUserDtoPagedResultDto implements IVehicleServiceUserDtoPagedResultDto {
    items!: VehicleServiceUserDto[] | undefined;
    totalCount!: number;

    constructor(data?: IVehicleServiceUserDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VehicleServiceUserDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): VehicleServiceUserDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleServiceUserDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): VehicleServiceUserDtoPagedResultDto {
        const json = this.toJSON();
        let result = new VehicleServiceUserDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVehicleServiceUserDtoPagedResultDto {
    items: VehicleServiceUserDto[] | undefined;
    totalCount: number;
}

export class VerbalNoteDto implements IVerbalNoteDto {
    id!: number;
    serviceVerbal!: ServiceVerbalDto;
    title!: string | undefined;
    verbalTags!: DictionaryDto[] | undefined;
    lastModifierUserFullName!: string | undefined;
    creatorUserFullName!: string | undefined;
    beneficiaries!: ServiceUserDto[] | undefined;
    contentsToRecord!: string | undefined;
    detarminationAndNotes!: string | undefined;

    constructor(data?: IVerbalNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceVerbal = _data["serviceVerbal"] ? ServiceVerbalDto.fromJS(_data["serviceVerbal"]) : undefined as any;
            this.title = _data["title"];
            if (Array.isArray(_data["verbalTags"])) {
                this.verbalTags = [] as any;
                for (let item of _data["verbalTags"])
                    this.verbalTags!.push(DictionaryDto.fromJS(item));
            }
            this.lastModifierUserFullName = _data["lastModifierUserFullName"];
            this.creatorUserFullName = _data["creatorUserFullName"];
            if (Array.isArray(_data["beneficiaries"])) {
                this.beneficiaries = [] as any;
                for (let item of _data["beneficiaries"])
                    this.beneficiaries!.push(ServiceUserDto.fromJS(item));
            }
            this.contentsToRecord = _data["contentsToRecord"];
            this.detarminationAndNotes = _data["detarminationAndNotes"];
        }
    }

    static fromJS(data: any): VerbalNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerbalNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceVerbal"] = this.serviceVerbal ? this.serviceVerbal.toJSON() : undefined as any;
        data["title"] = this.title;
        if (Array.isArray(this.verbalTags)) {
            data["verbalTags"] = [];
            for (let item of this.verbalTags)
                data["verbalTags"].push(item ? item.toJSON() : undefined as any);
        }
        data["lastModifierUserFullName"] = this.lastModifierUserFullName;
        data["creatorUserFullName"] = this.creatorUserFullName;
        if (Array.isArray(this.beneficiaries)) {
            data["beneficiaries"] = [];
            for (let item of this.beneficiaries)
                data["beneficiaries"].push(item ? item.toJSON() : undefined as any);
        }
        data["contentsToRecord"] = this.contentsToRecord;
        data["detarminationAndNotes"] = this.detarminationAndNotes;
        return data;
    }

    clone(): VerbalNoteDto {
        const json = this.toJSON();
        let result = new VerbalNoteDto();
        result.init(json);
        return result;
    }
}

export interface IVerbalNoteDto {
    id: number;
    serviceVerbal: ServiceVerbalDto;
    title: string | undefined;
    verbalTags: DictionaryDto[] | undefined;
    lastModifierUserFullName: string | undefined;
    creatorUserFullName: string | undefined;
    beneficiaries: ServiceUserDto[] | undefined;
    contentsToRecord: string | undefined;
    detarminationAndNotes: string | undefined;
}

export class VerbalNoteDtoPagedResultDto implements IVerbalNoteDtoPagedResultDto {
    items!: VerbalNoteDto[] | undefined;
    totalCount!: number;

    constructor(data?: IVerbalNoteDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VerbalNoteDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): VerbalNoteDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerbalNoteDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): VerbalNoteDtoPagedResultDto {
        const json = this.toJSON();
        let result = new VerbalNoteDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVerbalNoteDtoPagedResultDto {
    items: VerbalNoteDto[] | undefined;
    totalCount: number;
}

export class VideoSurveillanceSystemBaseDto implements IVideoSurveillanceSystemBaseDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IVideoSurveillanceSystemBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): VideoSurveillanceSystemBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoSurveillanceSystemBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): VideoSurveillanceSystemBaseDto {
        const json = this.toJSON();
        let result = new VideoSurveillanceSystemBaseDto();
        result.init(json);
        return result;
    }
}

export interface IVideoSurveillanceSystemBaseDto {
    id: number;
    name: string | undefined;
}

export class VideoSurveillanceSystemDto implements IVideoSurveillanceSystemDto {
    id!: number;
    name!: string | undefined;
    numberOfCameras!: number | undefined;
    numberOfMonitors!: number | undefined;
    maintenanceContract!: boolean;
    maintenanceContractFile!: FileDto;
    maintenanceCompany!: string | undefined;
    lastMaintenanceDate!: moment.Moment | undefined;
    outsiderResponsible!: boolean;
    externalVigilance!: boolean;
    vigilanceContractFile!: FileDto;
    vigilanceCompany!: string | undefined;
    operationalAuthorization!: DictionaryDto;
    notes!: string | undefined;

    constructor(data?: IVideoSurveillanceSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.numberOfCameras = _data["numberOfCameras"];
            this.numberOfMonitors = _data["numberOfMonitors"];
            this.maintenanceContract = _data["maintenanceContract"];
            this.maintenanceContractFile = _data["maintenanceContractFile"] ? FileDto.fromJS(_data["maintenanceContractFile"]) : undefined as any;
            this.maintenanceCompany = _data["maintenanceCompany"];
            this.lastMaintenanceDate = _data["lastMaintenanceDate"] ? moment(_data["lastMaintenanceDate"].toString()) : undefined as any;
            this.outsiderResponsible = _data["outsiderResponsible"];
            this.externalVigilance = _data["externalVigilance"];
            this.vigilanceContractFile = _data["vigilanceContractFile"] ? FileDto.fromJS(_data["vigilanceContractFile"]) : undefined as any;
            this.vigilanceCompany = _data["vigilanceCompany"];
            this.operationalAuthorization = _data["operationalAuthorization"] ? DictionaryDto.fromJS(_data["operationalAuthorization"]) : undefined as any;
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): VideoSurveillanceSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoSurveillanceSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["numberOfCameras"] = this.numberOfCameras;
        data["numberOfMonitors"] = this.numberOfMonitors;
        data["maintenanceContract"] = this.maintenanceContract;
        data["maintenanceContractFile"] = this.maintenanceContractFile ? this.maintenanceContractFile.toJSON() : undefined as any;
        data["maintenanceCompany"] = this.maintenanceCompany;
        data["lastMaintenanceDate"] = this.lastMaintenanceDate ? this.lastMaintenanceDate.toISOString() : undefined as any;
        data["outsiderResponsible"] = this.outsiderResponsible;
        data["externalVigilance"] = this.externalVigilance;
        data["vigilanceContractFile"] = this.vigilanceContractFile ? this.vigilanceContractFile.toJSON() : undefined as any;
        data["vigilanceCompany"] = this.vigilanceCompany;
        data["operationalAuthorization"] = this.operationalAuthorization ? this.operationalAuthorization.toJSON() : undefined as any;
        data["notes"] = this.notes;
        return data;
    }

    clone(): VideoSurveillanceSystemDto {
        const json = this.toJSON();
        let result = new VideoSurveillanceSystemDto();
        result.init(json);
        return result;
    }
}

export interface IVideoSurveillanceSystemDto {
    id: number;
    name: string | undefined;
    numberOfCameras: number | undefined;
    numberOfMonitors: number | undefined;
    maintenanceContract: boolean;
    maintenanceContractFile: FileDto;
    maintenanceCompany: string | undefined;
    lastMaintenanceDate: moment.Moment | undefined;
    outsiderResponsible: boolean;
    externalVigilance: boolean;
    vigilanceContractFile: FileDto;
    vigilanceCompany: string | undefined;
    operationalAuthorization: DictionaryDto;
    notes: string | undefined;
}

export class VideoSurveillanceSystemDtoPagedResultDto implements IVideoSurveillanceSystemDtoPagedResultDto {
    items!: VideoSurveillanceSystemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IVideoSurveillanceSystemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VideoSurveillanceSystemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): VideoSurveillanceSystemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VideoSurveillanceSystemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): VideoSurveillanceSystemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new VideoSurveillanceSystemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVideoSurveillanceSystemDtoPagedResultDto {
    items: VideoSurveillanceSystemDto[] | undefined;
    totalCount: number;
}

export class VitalSignRecordDto implements IVitalSignRecordDto {
    id!: number;
    date!: moment.Moment;
    bodyTemperatureHourVitalSigns!: BodyTemperatureHourVitalSignDto[] | undefined;
    firstPA!: number | undefined;
    secondPA!: number | undefined;
    firstFC!: number | undefined;
    secondFC!: number | undefined;
    firstSpO2!: number | undefined;
    secondSpO2!: number | undefined;
    note!: string | undefined;

    constructor(data?: IVitalSignRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            if (Array.isArray(_data["bodyTemperatureHourVitalSigns"])) {
                this.bodyTemperatureHourVitalSigns = [] as any;
                for (let item of _data["bodyTemperatureHourVitalSigns"])
                    this.bodyTemperatureHourVitalSigns!.push(BodyTemperatureHourVitalSignDto.fromJS(item));
            }
            this.firstPA = _data["firstPA"];
            this.secondPA = _data["secondPA"];
            this.firstFC = _data["firstFC"];
            this.secondFC = _data["secondFC"];
            this.firstSpO2 = _data["firstSpO2"];
            this.secondSpO2 = _data["secondSpO2"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): VitalSignRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new VitalSignRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        if (Array.isArray(this.bodyTemperatureHourVitalSigns)) {
            data["bodyTemperatureHourVitalSigns"] = [];
            for (let item of this.bodyTemperatureHourVitalSigns)
                data["bodyTemperatureHourVitalSigns"].push(item ? item.toJSON() : undefined as any);
        }
        data["firstPA"] = this.firstPA;
        data["secondPA"] = this.secondPA;
        data["firstFC"] = this.firstFC;
        data["secondFC"] = this.secondFC;
        data["firstSpO2"] = this.firstSpO2;
        data["secondSpO2"] = this.secondSpO2;
        data["note"] = this.note;
        return data;
    }

    clone(): VitalSignRecordDto {
        const json = this.toJSON();
        let result = new VitalSignRecordDto();
        result.init(json);
        return result;
    }
}

export interface IVitalSignRecordDto {
    id: number;
    date: moment.Moment;
    bodyTemperatureHourVitalSigns: BodyTemperatureHourVitalSignDto[] | undefined;
    firstPA: number | undefined;
    secondPA: number | undefined;
    firstFC: number | undefined;
    secondFC: number | undefined;
    firstSpO2: number | undefined;
    secondSpO2: number | undefined;
    note: string | undefined;
}

export class VitalSignRecordItemDto implements IVitalSignRecordItemDto {
    id!: number;
    date!: moment.Moment;

    constructor(data?: IVitalSignRecordItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): VitalSignRecordItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new VitalSignRecordItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        return data;
    }

    clone(): VitalSignRecordItemDto {
        const json = this.toJSON();
        let result = new VitalSignRecordItemDto();
        result.init(json);
        return result;
    }
}

export interface IVitalSignRecordItemDto {
    id: number;
    date: moment.Moment;
}

export class VitalSignRecordItemDtoPagedResultDto implements IVitalSignRecordItemDtoPagedResultDto {
    items!: VitalSignRecordItemDto[] | undefined;
    totalCount!: number;

    constructor(data?: IVitalSignRecordItemDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(VitalSignRecordItemDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): VitalSignRecordItemDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new VitalSignRecordItemDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): VitalSignRecordItemDtoPagedResultDto {
        const json = this.toJSON();
        let result = new VitalSignRecordItemDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IVitalSignRecordItemDtoPagedResultDto {
    items: VitalSignRecordItemDto[] | undefined;
    totalCount: number;
}

export class WeightDetectionEntryDto implements IWeightDetectionEntryDto {
    id!: number;
    serviceUser!: ServiceUserBasicDto;
    monthEntries!: WeightDetectionMonthEntryDto[] | undefined;

    constructor(data?: IWeightDetectionEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceUser = _data["serviceUser"] ? ServiceUserBasicDto.fromJS(_data["serviceUser"]) : undefined as any;
            if (Array.isArray(_data["monthEntries"])) {
                this.monthEntries = [] as any;
                for (let item of _data["monthEntries"])
                    this.monthEntries!.push(WeightDetectionMonthEntryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WeightDetectionEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeightDetectionEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceUser"] = this.serviceUser ? this.serviceUser.toJSON() : undefined as any;
        if (Array.isArray(this.monthEntries)) {
            data["monthEntries"] = [];
            for (let item of this.monthEntries)
                data["monthEntries"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }

    clone(): WeightDetectionEntryDto {
        const json = this.toJSON();
        let result = new WeightDetectionEntryDto();
        result.init(json);
        return result;
    }
}

export interface IWeightDetectionEntryDto {
    id: number;
    serviceUser: ServiceUserBasicDto;
    monthEntries: WeightDetectionMonthEntryDto[] | undefined;
}

export class WeightDetectionEntryDtoPagedResultDto implements IWeightDetectionEntryDtoPagedResultDto {
    items!: WeightDetectionEntryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IWeightDetectionEntryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WeightDetectionEntryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): WeightDetectionEntryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeightDetectionEntryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): WeightDetectionEntryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WeightDetectionEntryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWeightDetectionEntryDtoPagedResultDto {
    items: WeightDetectionEntryDto[] | undefined;
    totalCount: number;
}

export class WeightDetectionMonthEntryDto implements IWeightDetectionMonthEntryDto {
    id!: number;
    month!: DictionaryDto;
    weight!: number | undefined;

    constructor(data?: IWeightDetectionMonthEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.month = _data["month"] ? DictionaryDto.fromJS(_data["month"]) : undefined as any;
            this.weight = _data["weight"];
        }
    }

    static fromJS(data: any): WeightDetectionMonthEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeightDetectionMonthEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["month"] = this.month ? this.month.toJSON() : undefined as any;
        data["weight"] = this.weight;
        return data;
    }

    clone(): WeightDetectionMonthEntryDto {
        const json = this.toJSON();
        let result = new WeightDetectionMonthEntryDto();
        result.init(json);
        return result;
    }
}

export interface IWeightDetectionMonthEntryDto {
    id: number;
    month: DictionaryDto;
    weight: number | undefined;
}

export class WeightDetectionMonthEntryDtoPagedResultDto implements IWeightDetectionMonthEntryDtoPagedResultDto {
    items!: WeightDetectionMonthEntryDto[] | undefined;
    totalCount!: number;

    constructor(data?: IWeightDetectionMonthEntryDtoPagedResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WeightDetectionMonthEntryDto.fromJS(item));
            }
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): WeightDetectionMonthEntryDtoPagedResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeightDetectionMonthEntryDtoPagedResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : undefined as any);
        }
        data["totalCount"] = this.totalCount;
        return data;
    }

    clone(): WeightDetectionMonthEntryDtoPagedResultDto {
        const json = this.toJSON();
        let result = new WeightDetectionMonthEntryDtoPagedResultDto();
        result.init(json);
        return result;
    }
}

export interface IWeightDetectionMonthEntryDtoPagedResultDto {
    items: WeightDetectionMonthEntryDto[] | undefined;
    totalCount: number;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}